"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chains = void 0;
exports.chains = {
    1: {
        name: 'Ethereum Mainnet',
        chain: 'ETH',
        icon: 'ethereum',
        rpc: [
            'https://mainnet.infura.io/v3/${INFURA_API_KEY}',
            'wss://mainnet.infura.io/ws/v3/${INFURA_API_KEY}',
            'https://api.mycryptoapi.com/eth',
            'https://cloudflare-eth.com',
            'https://ethereum-rpc.publicnode.com',
            'wss://ethereum-rpc.publicnode.com',
            'https://mainnet.gateway.tenderly.co',
            'wss://mainnet.gateway.tenderly.co',
            'https://rpc.blocknative.com/boost',
            'https://rpc.flashbots.net',
            'https://rpc.flashbots.net/fast',
            'https://rpc.mevblocker.io',
            'https://rpc.mevblocker.io/fast',
            'https://rpc.mevblocker.io/noreverts',
            'https://rpc.mevblocker.io/fullprivacy',
            'https://eth.drpc.org',
            'wss://eth.drpc.org',
            'https://api.securerpc.com/v1'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://ethereum.org',
        shortName: 'eth',
        chainId: 1,
        networkId: 1,
        slip44: 60,
        ens: { registry: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e' },
        explorers: [
            {
                name: 'etherscan',
                url: 'https://etherscan.io',
                standard: 'EIP3091'
            },
            {
                name: 'blockscout',
                url: 'https://eth.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            },
            {
                name: 'dexguru',
                url: 'https://ethereum.dex.guru',
                icon: 'dexguru',
                standard: 'EIP3091'
            },
            {
                name: 'Routescan',
                url: 'https://ethereum.routescan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt'
    },
    2: {
        name: 'Expanse Network',
        chain: 'EXP',
        rpc: ['https://node.expanse.tech'],
        faucets: [],
        nativeCurrency: {
            name: 'Expanse Network Ether',
            symbol: 'EXP',
            decimals: 18
        },
        infoURL: 'https://expanse.tech',
        shortName: 'exp',
        chainId: 2,
        networkId: 1,
        slip44: 40
    },
    3: {
        name: 'Ropsten',
        title: 'Ethereum Testnet Ropsten',
        chain: 'ETH',
        rpc: [
            'https://ropsten.infura.io/v3/${INFURA_API_KEY}',
            'wss://ropsten.infura.io/ws/v3/${INFURA_API_KEY}'
        ],
        faucets: [
            'http://fauceth.komputing.org?chain=3&address=${ADDRESS}',
            'https://faucet.ropsten.be?${ADDRESS}'
        ],
        nativeCurrency: { name: 'Ropsten Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://github.com/ethereum/ropsten',
        shortName: 'rop',
        chainId: 3,
        networkId: 3,
        slip44: 1,
        ens: { registry: '0x112234455c3a32fd11230c42e7bccd4a84e02010' },
        explorers: [
            {
                name: 'etherscan',
                url: 'https://ropsten.etherscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    4: {
        name: 'Rinkeby',
        title: 'Ethereum Testnet Rinkeby',
        chain: 'ETH',
        rpc: [
            'https://rinkeby.infura.io/v3/${INFURA_API_KEY}',
            'wss://rinkeby.infura.io/ws/v3/${INFURA_API_KEY}'
        ],
        faucets: [
            'http://fauceth.komputing.org?chain=4&address=${ADDRESS}',
            'https://faucet.rinkeby.io'
        ],
        nativeCurrency: { name: 'Rinkeby Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.rinkeby.io',
        shortName: 'rin',
        chainId: 4,
        networkId: 4,
        slip44: 1,
        ens: { registry: '0xe7410170f87102df0055eb195163a03b7f2bff4a' },
        explorers: [
            {
                name: 'etherscan-rinkeby',
                url: 'https://rinkeby.etherscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    5: {
        name: 'Goerli',
        title: 'Ethereum Testnet Goerli',
        chain: 'ETH',
        rpc: [
            'https://goerli.infura.io/v3/${INFURA_API_KEY}',
            'wss://goerli.infura.io/v3/${INFURA_API_KEY}',
            'https://rpc.goerli.mudit.blog/',
            'https://ethereum-goerli-rpc.publicnode.com',
            'wss://ethereum-goerli-rpc.publicnode.com',
            'https://goerli.gateway.tenderly.co',
            'wss://goerli.gateway.tenderly.co'
        ],
        faucets: [
            'http://fauceth.komputing.org?chain=5&address=${ADDRESS}',
            'https://goerli-faucet.slock.it?address=${ADDRESS}',
            'https://faucet.goerli.mudit.blog'
        ],
        nativeCurrency: { name: 'Goerli Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://goerli.net/#about',
        shortName: 'gor',
        chainId: 5,
        networkId: 5,
        slip44: 1,
        ens: { registry: '0x112234455c3a32fd11230c42e7bccd4a84e02010' },
        explorers: [
            {
                name: 'etherscan-goerli',
                url: 'https://goerli.etherscan.io',
                standard: 'EIP3091'
            },
            {
                name: 'blockscout-goerli',
                url: 'https://eth-goerli.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    6: {
        name: 'Kotti Testnet',
        title: 'Ethereum Classic Kotti Testnet',
        status: 'deprecated',
        chain: 'ETC',
        icon: 'ethereumclassictestnet',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Kotti Ether', symbol: 'KOT', decimals: 18 },
        infoURL: 'https://ethereumclassic.org/development/testnets',
        shortName: 'kot',
        chainId: 6,
        networkId: 6,
        slip44: 1,
        iconURL: 'https://ipfs.io/ipfs/QmawMDPsaj3kBTZErCYQ3tshv5RrMAN3smWNs72m943Fyj'
    },
    7: {
        name: 'ThaiChain',
        chain: 'TCH',
        rpc: ['https://rpc.dome.cloud', 'https://rpc.thaichain.org'],
        faucets: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'ThaiChain Ether', symbol: 'TCH', decimals: 18 },
        infoURL: 'https://thaichain.io',
        shortName: 'tch',
        chainId: 7,
        networkId: 7,
        icon: 'tch',
        explorers: [
            {
                name: 'Thaichain Explorer',
                url: 'https://exp.thaichain.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPvXht4fY5AigcLbC9ZqycN11K3iqjRTMGynfTtM9gYX5'
    },
    8: {
        name: 'Ubiq',
        chain: 'UBQ',
        rpc: ['https://rpc.octano.dev', 'https://pyrus2.ubiqscan.io'],
        faucets: [],
        nativeCurrency: { name: 'Ubiq Ether', symbol: 'UBQ', decimals: 18 },
        infoURL: 'https://ubiqsmart.com',
        shortName: 'ubq',
        chainId: 8,
        networkId: 8,
        slip44: 108,
        explorers: [
            {
                name: 'ubiqscan',
                url: 'https://ubiqscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    9: {
        name: 'Ubiq Network Testnet',
        chain: 'UBQ',
        rpc: [],
        faucets: [],
        nativeCurrency: {
            name: 'Ubiq Testnet Ether',
            symbol: 'TUBQ',
            decimals: 18
        },
        infoURL: 'https://ethersocial.org',
        shortName: 'tubq',
        chainId: 9,
        networkId: 2,
        slip44: 1
    },
    10: {
        name: 'OP Mainnet',
        chain: 'ETH',
        rpc: [
            'https://mainnet.optimism.io',
            'https://optimism-rpc.publicnode.com',
            'wss://optimism-rpc.publicnode.com',
            'https://optimism.gateway.tenderly.co',
            'wss://optimism.gateway.tenderly.co',
            'https://optimism.drpc.org',
            'wss://optimism.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://optimism.io',
        shortName: 'oeth',
        chainId: 10,
        networkId: 10,
        explorers: [
            {
                name: 'etherscan',
                url: 'https://optimistic.etherscan.io',
                standard: 'EIP3091'
            },
            {
                name: 'blockscout',
                url: 'https://optimism.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            },
            {
                name: 'dexguru',
                url: 'https://optimism.dex.guru',
                icon: 'dexguru',
                standard: 'EIP3091'
            },
            {
                name: 'Routescan',
                url: 'https://mainnet.superscan.network',
                standard: 'EIP3091'
            }
        ]
    },
    11: {
        name: 'Metadium Mainnet',
        chain: 'META',
        rpc: ['https://api.metadium.com/prod'],
        faucets: [],
        nativeCurrency: {
            name: 'Metadium Mainnet Ether',
            symbol: 'META',
            decimals: 18
        },
        infoURL: 'https://metadium.com',
        shortName: 'meta',
        chainId: 11,
        networkId: 11,
        slip44: 916
    },
    12: {
        name: 'Metadium Testnet',
        chain: 'META',
        rpc: ['https://api.metadium.com/dev'],
        faucets: [],
        nativeCurrency: {
            name: 'Metadium Testnet Ether',
            symbol: 'KAL',
            decimals: 18
        },
        infoURL: 'https://metadium.com',
        shortName: 'kal',
        chainId: 12,
        networkId: 12,
        slip44: 1
    },
    13: {
        name: 'Diode Testnet Staging',
        chain: 'DIODE',
        rpc: ['https://staging.diode.io:8443/', 'wss://staging.diode.io:8443/ws'],
        faucets: [],
        nativeCurrency: { name: 'Staging Diodes', symbol: 'sDIODE', decimals: 18 },
        infoURL: 'https://diode.io/staging',
        shortName: 'dstg',
        chainId: 13,
        networkId: 13,
        slip44: 1
    },
    14: {
        name: 'Flare Mainnet',
        chain: 'FLR',
        icon: 'flare',
        rpc: [
            'https://flare-api.flare.network/ext/C/rpc',
            'https://flare.rpc.thirdweb.com',
            'https://flare-bundler.etherspot.io',
            'https://rpc.ankr.com/flare',
            'https://01-gravelines-003-01.rpc.tatum.io/ext/bc/C/rpc',
            'https://01-vinthill-003-02.rpc.tatum.io/ext/bc/C/rpc',
            'https://rpc.au.cc/flare',
            'https://flare.enosys.global/ext/C/rpc',
            'https://flare.solidifi.app/ext/C/rpc'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Flare', symbol: 'FLR', decimals: 18 },
        infoURL: 'https://flare.network',
        shortName: 'flr',
        chainId: 14,
        networkId: 14,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://flare-explorer.flare.network',
                standard: 'EIP3091'
            },
            {
                name: 'Routescan',
                url: 'https://mainnet.flarescan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbT52cCx4h1rcz6nXGfUPFdRyw1VfFMU8kKpY7YCtvUjs'
    },
    15: {
        icon: 'diode',
        name: 'Diode Prenet',
        chain: 'DIODE',
        rpc: ['https://prenet.diode.io:8443/', 'wss://prenet.diode.io:8443/ws'],
        faucets: [],
        nativeCurrency: { name: 'Diodes', symbol: 'DIODE', decimals: 18 },
        infoURL: 'https://diode.io/prenet',
        shortName: 'diode',
        chainId: 15,
        networkId: 15,
        iconURL: 'https://ipfs.io/ipfs/bafkreigsppluw555hxzp43uc7xv6rjodspdij3sqqg2owcdrpilpbqeymm'
    },
    16: {
        name: 'Songbird Testnet Coston',
        chain: 'SGB',
        icon: 'coston',
        rpc: [
            'https://coston-api.flare.network/ext/C/rpc',
            'https://songbird-testnet-coston.rpc.thirdweb.com',
            'https://01-gravelines-004-01.rpc.tatum.io/ext/bc/C/rpc',
            'https://02-chicago-004-02.rpc.tatum.io/ext/bc/C/rpc',
            'https://02-tokyo-004-03.rpc.tatum.io/ext/bc/C/rpc',
            'https://coston.enosys.global/ext/C/rpc'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://faucet.flare.network'],
        nativeCurrency: { name: 'Coston Flare', symbol: 'CFLR', decimals: 18 },
        infoURL: 'https://flare.network',
        shortName: 'cflr',
        chainId: 16,
        networkId: 16,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://coston-explorer.flare.network',
                standard: 'EIP3091'
            },
            {
                name: 'Routescan',
                url: 'https://coston.testnet.flarescan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmV5PVhxaT3ePRHYsH3aryEHin2c49W18xW3Xg4o171iYE'
    },
    17: {
        name: 'ThaiChain 2.0 ThaiFi',
        chain: 'TCH',
        rpc: ['https://rpc.thaifi.com'],
        faucets: [],
        nativeCurrency: { name: 'Thaifi Ether', symbol: 'TFI', decimals: 18 },
        infoURL: 'https://exp.thaifi.com',
        shortName: 'tfi',
        chainId: 17,
        networkId: 17
    },
    18: {
        name: 'ThunderCore Testnet',
        chain: 'TST',
        rpc: [
            'https://testnet-rpc.thundercore.com',
            'https://thundercore-testnet.drpc.org',
            'wss://thundercore-testnet.drpc.org'
        ],
        faucets: ['https://faucet-testnet.thundercore.com'],
        nativeCurrency: {
            name: 'ThunderCore Testnet Token',
            symbol: 'TST',
            decimals: 18
        },
        infoURL: 'https://thundercore.com',
        shortName: 'TST',
        chainId: 18,
        networkId: 18,
        slip44: 1,
        explorers: [
            {
                name: 'thundercore-blockscout-testnet',
                url: 'https://explorer-testnet.thundercore.com',
                standard: 'EIP3091'
            }
        ]
    },
    19: {
        name: 'Songbird Canary-Network',
        chain: 'SGB',
        icon: 'songbird',
        rpc: [
            'https://songbird-api.flare.network/ext/C/rpc',
            'https://01-gravelines-006-01.rpc.tatum.io/ext/bc/C/rpc',
            'https://01-vinthill-006-02.rpc.tatum.io/ext/bc/C/rpc',
            'https://02-tokyo-006-03.rpc.tatum.io/ext/bc/C/rpc',
            'https://rpc.au.cc/songbird',
            'https://songbird.enosys.global/ext/C/rpc',
            'https://songbird.solidifi.app/ext/C/rpc'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Songbird', symbol: 'SGB', decimals: 18 },
        infoURL: 'https://flare.network',
        shortName: 'sgb',
        chainId: 19,
        networkId: 19,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://songbird-explorer.flare.network',
                standard: 'EIP3091'
            },
            {
                name: 'Routescan',
                url: 'https://songbird.flarescan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdpaH9pEFDXB4tUPxcqAHfB3Sfx3BQufz6EAzBWhHH6Ka'
    },
    20: {
        name: 'Elastos Smart Chain',
        chain: 'ETH',
        rpc: ['https://api.elastos.io/eth'],
        faucets: [],
        nativeCurrency: { name: 'Elastos', symbol: 'ELA', decimals: 18 },
        infoURL: 'https://www.elastos.org/',
        shortName: 'esc',
        chainId: 20,
        networkId: 20,
        explorers: [
            {
                name: 'elastos esc explorer',
                url: 'https://esc.elastos.io',
                standard: 'EIP3091'
            }
        ]
    },
    21: {
        name: 'Elastos Smart Chain Testnet',
        chain: 'ETH',
        rpc: ['https://api-testnet.elastos.io/eth'],
        faucets: ['https://esc-faucet.elastos.io/'],
        nativeCurrency: { name: 'Elastos', symbol: 'tELA', decimals: 18 },
        infoURL: 'https://www.elastos.org/',
        shortName: 'esct',
        chainId: 21,
        networkId: 21,
        explorers: [
            {
                name: 'elastos esc explorer',
                url: 'https://esc-testnet.elastos.io',
                standard: 'EIP3091'
            }
        ]
    },
    22: {
        name: 'ELA-DID-Sidechain Mainnet',
        chain: 'ETH',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Elastos', symbol: 'ELA', decimals: 18 },
        infoURL: 'https://www.elastos.org/',
        shortName: 'eladid',
        chainId: 22,
        networkId: 22
    },
    23: {
        name: 'ELA-DID-Sidechain Testnet',
        chain: 'ETH',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Elastos', symbol: 'tELA', decimals: 18 },
        infoURL: 'https://elaeth.io/',
        shortName: 'eladidt',
        chainId: 23,
        networkId: 23,
        slip44: 1
    },
    24: {
        name: 'KardiaChain Mainnet',
        chain: 'KAI',
        icon: 'kardiachain',
        rpc: ['https://rpc.kardiachain.io'],
        faucets: [],
        nativeCurrency: { name: 'KardiaChain', symbol: 'KAI', decimals: 18 },
        infoURL: 'https://kardiachain.io',
        shortName: 'kardiachain',
        chainId: 24,
        networkId: 0,
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/QmXoHaZXJevc59GuzEgBhwRSH6kio1agMRvL8bD93pARRV'
    },
    25: {
        name: 'Cronos Mainnet',
        chain: 'CRO',
        rpc: [
            'https://evm.cronos.org',
            'https://cronos-evm-rpc.publicnode.com',
            'wss://cronos-evm-rpc.publicnode.com',
            'https://cronos.drpc.org',
            'wss://cronos.drpc.org'
        ],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Cronos', symbol: 'CRO', decimals: 18 },
        infoURL: 'https://cronos.org/',
        shortName: 'cro',
        chainId: 25,
        networkId: 25,
        explorers: [
            {
                name: 'Cronos Explorer',
                url: 'https://explorer.cronos.org',
                standard: 'none'
            }
        ]
    },
    26: {
        name: 'Genesis L1 testnet',
        chain: 'genesis',
        rpc: ['https://testrpc.genesisl1.org'],
        faucets: [],
        nativeCurrency: { name: 'L1 testcoin', symbol: 'L1test', decimals: 18 },
        infoURL: 'https://www.genesisl1.com',
        shortName: 'L1test',
        chainId: 26,
        networkId: 26,
        slip44: 1,
        explorers: [
            {
                name: 'Genesis L1 testnet explorer',
                url: 'https://testnet.genesisl1.org',
                standard: 'none'
            }
        ]
    },
    27: {
        name: 'ShibaChain',
        chain: 'SHIB',
        rpc: ['https://rpc.shibchain.org'],
        faucets: [],
        nativeCurrency: { name: 'SHIBA INU COIN', symbol: 'SHIB', decimals: 18 },
        infoURL: 'https://shibchain.org',
        shortName: 'shib',
        chainId: 27,
        networkId: 27,
        explorers: [
            {
                name: 'Shiba Explorer',
                url: 'https://exp.shibchain.org',
                standard: 'none'
            }
        ]
    },
    28: {
        name: 'Boba Network Rinkeby Testnet',
        chain: 'ETH',
        status: 'deprecated',
        rpc: ['https://rinkeby.boba.network/'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://boba.network',
        shortName: 'BobaRinkeby',
        chainId: 28,
        networkId: 28,
        slip44: 1,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://blockexplorer.rinkeby.boba.network',
                standard: 'none'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-4',
            bridges: [{ url: 'https://gateway.rinkeby.boba.network' }]
        }
    },
    29: {
        name: 'Genesis L1',
        chain: 'genesis',
        rpc: ['https://rpc.genesisl1.org'],
        faucets: [],
        nativeCurrency: { name: 'L1 coin', symbol: 'L1', decimals: 18 },
        infoURL: 'https://www.genesisl1.com',
        shortName: 'L1',
        chainId: 29,
        networkId: 29,
        explorers: [
            {
                name: 'Genesis L1 blockchain explorer',
                url: 'https://explorer.genesisl1.org',
                standard: 'none'
            }
        ]
    },
    30: {
        name: 'Rootstock Mainnet',
        chain: 'Rootstock',
        rpc: ['https://public-node.rsk.co', 'https://mycrypto.rsk.co'],
        faucets: [],
        icon: 'rootstock',
        nativeCurrency: { name: 'Smart Bitcoin', symbol: 'RBTC', decimals: 18 },
        infoURL: 'https://rootstock.io',
        shortName: 'rsk',
        chainId: 30,
        networkId: 30,
        slip44: 137,
        explorers: [
            {
                name: 'Rootstock Explorer',
                url: 'https://explorer.rsk.co',
                standard: 'EIP3091'
            },
            {
                name: 'blockscout',
                url: 'https://rootstock.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigidzbf22dnpmmlfxv6u7oifq6ln33j4n57ox4ipiproalufrheym'
    },
    31: {
        name: 'Rootstock Testnet',
        chain: 'Rootstock',
        rpc: [
            'https://public-node.testnet.rsk.co',
            'https://mycrypto.testnet.rsk.co'
        ],
        faucets: ['https://faucet.rsk.co/'],
        icon: 'rootstock',
        nativeCurrency: {
            name: 'Testnet Smart Bitcoin',
            symbol: 'tRBTC',
            decimals: 18
        },
        infoURL: 'https://rootstock.io',
        shortName: 'trsk',
        chainId: 31,
        networkId: 31,
        slip44: 1,
        explorers: [
            {
                name: 'RSK Testnet Explorer',
                url: 'https://explorer.testnet.rsk.co',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigidzbf22dnpmmlfxv6u7oifq6ln33j4n57ox4ipiproalufrheym'
    },
    32: {
        name: 'GoodData Testnet',
        chain: 'GooD',
        rpc: ['https://test2.goodata.io'],
        faucets: [],
        nativeCurrency: {
            name: 'GoodData Testnet Ether',
            symbol: 'GooD',
            decimals: 18
        },
        infoURL: 'https://www.goodata.org',
        shortName: 'GooDT',
        chainId: 32,
        networkId: 32,
        slip44: 1
    },
    33: {
        name: 'GoodData Mainnet',
        chain: 'GooD',
        rpc: ['https://rpc.goodata.io'],
        faucets: [],
        nativeCurrency: {
            name: 'GoodData Mainnet Ether',
            symbol: 'GooD',
            decimals: 18
        },
        infoURL: 'https://www.goodata.org',
        shortName: 'GooD',
        chainId: 33,
        networkId: 33
    },
    34: {
        name: 'SecureChain Mainnet',
        chain: 'SCAI',
        icon: 'scaiIcon',
        rpc: ['https://mainnet-rpc.scai.network'],
        faucets: [],
        nativeCurrency: { name: 'SecureChain', symbol: 'SCAI', decimals: 18 },
        infoURL: 'https://securechain.ai',
        shortName: 'scai',
        chainId: 34,
        networkId: 34,
        redFlags: ['reusedChainId'],
        explorers: [
            {
                name: 'SecureChain Mainnet',
                url: 'https://explorer.securechain.ai',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme2Z8VFYjhHGfLQPBnfseNpEdRfmTDy7VXqrdH4AHETJf'
    },
    35: {
        name: 'TBWG Chain',
        chain: 'TBWG',
        rpc: ['https://rpc.tbwg.io'],
        faucets: [],
        nativeCurrency: { name: 'TBWG Ether', symbol: 'TBG', decimals: 18 },
        infoURL: 'https://tbwg.io',
        shortName: 'tbwg',
        chainId: 35,
        networkId: 35
    },
    36: {
        name: 'Dxchain Mainnet',
        chain: 'Dxchain',
        icon: 'dx',
        rpc: ['https://mainnet.dxchain.com'],
        faucets: [],
        nativeCurrency: { name: 'Dxchain', symbol: 'DX', decimals: 18 },
        infoURL: 'https://www.dxchain.com/',
        shortName: 'dx',
        chainId: 36,
        networkId: 36,
        explorers: [
            { name: 'dxscan', url: 'https://dxscan.io', standard: 'EIP3091' }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYBup5bWoBfkaHntbcgW8Ji7ncad7f53deJ4Q55z4PNQs'
    },
    37: {
        name: 'Xpla Mainnet',
        chain: 'XPLA',
        rpc: ['https://dimension-evm-rpc.xpla.dev'],
        faucets: [],
        nativeCurrency: { name: 'XPLA', symbol: 'XPLA', decimals: 18 },
        infoURL: 'https://xpla.io',
        shortName: 'xpla',
        chainId: 37,
        networkId: 37,
        icon: 'xpla',
        explorers: [
            {
                name: 'XPLA Explorer',
                url: 'https://explorer.xpla.io/mainnet',
                standard: 'EIP3091'
            }
        ],
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/Qmf4GoxfpeA5VGqu7KP5eyv1WKaCpNDbvMxq1MjQBwFWxq'
    },
    38: {
        name: 'Valorbit',
        chain: 'VAL',
        rpc: ['https://rpc.valorbit.com/v2'],
        faucets: [],
        nativeCurrency: { name: 'Valorbit', symbol: 'VAL', decimals: 18 },
        infoURL: 'https://valorbit.com',
        shortName: 'val',
        chainId: 38,
        networkId: 38,
        slip44: 538
    },
    39: {
        name: 'U2U Solaris Mainnet',
        chain: 'u2u',
        rpc: ['https://rpc-mainnet.u2u.xyz'],
        faucets: [],
        nativeCurrency: { name: 'U2U Network', symbol: 'U2U', decimals: 18 },
        infoURL: 'https://u2u.xyz',
        shortName: 'u2u',
        chainId: 39,
        networkId: 39,
        icon: 'u2u',
        explorers: [
            {
                icon: 'u2u',
                name: 'U2U Explorer',
                url: 'https://u2uscan.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcW64RgqQVHnNbVFyfaMNKt7dJvFqEbfEHZmeyeK8dpEa'
    },
    40: {
        name: 'Telos EVM Mainnet',
        chain: 'TLOS',
        rpc: [
            'https://rpc.telos.net',
            'https://telos.drpc.org',
            'wss://telos.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Telos', symbol: 'TLOS', decimals: 18 },
        infoURL: 'https://telos.net',
        shortName: 'TelosEVM',
        chainId: 40,
        networkId: 40,
        explorers: [
            {
                name: 'teloscan',
                url: 'https://teloscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    41: {
        name: 'Telos EVM Testnet',
        chain: 'TLOS',
        rpc: [
            'https://rpc.testnet.telos.net',
            'https://telos-testnet.drpc.org',
            'wss://telos-testnet.drpc.org'
        ],
        faucets: ['https://app.telos.net/testnet/developers'],
        nativeCurrency: { name: 'Telos', symbol: 'TLOS', decimals: 18 },
        infoURL: 'https://telos.net',
        shortName: 'TelosEVMTestnet',
        chainId: 41,
        networkId: 41,
        slip44: 1,
        explorers: [
            {
                name: 'teloscan',
                url: 'https://testnet.teloscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    42: {
        name: 'LUKSO Mainnet',
        chain: 'LUKSO',
        icon: 'lukso',
        rpc: [
            'https://rpc.mainnet.lukso.network',
            'wss://ws-rpc.mainnet.lukso.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'LUKSO', symbol: 'LYX', decimals: 18 },
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.execution.mainnet.lukso.network',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://lukso.network',
        shortName: 'lukso',
        chainId: 42,
        networkId: 42,
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/Qmeg9sFF5tAGi6MCx7YjtVHW6a23zqvHRK1xwzSdp9iE7z'
    },
    43: {
        name: 'Darwinia Pangolin Testnet',
        chain: 'pangolin',
        rpc: ['https://pangolin-rpc.darwinia.network'],
        faucets: [
            'https://docs.darwinia.network/pangolin-testnet-1e9ac8b09e874e8abd6a7f18c096ca6a'
        ],
        nativeCurrency: {
            name: 'Pangolin Network Native Token',
            symbol: 'PRING',
            decimals: 18
        },
        infoURL: 'https://darwinia.network/',
        shortName: 'pangolin',
        chainId: 43,
        networkId: 43,
        slip44: 1,
        explorers: [
            {
                name: 'subscan',
                url: 'https://pangolin.subscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    44: {
        name: 'Crab Network',
        chain: 'crab',
        rpc: ['https://crab-rpc.darwinia.network', 'https://crab-rpc.dcdao.box'],
        faucets: [],
        nativeCurrency: {
            name: 'Crab Network Native Token',
            symbol: 'CRAB',
            decimals: 18
        },
        infoURL: 'https://crab.network/',
        shortName: 'crab',
        chainId: 44,
        networkId: 44,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://crab-scan.darwinia.network',
                standard: 'EIP3091'
            }
        ]
    },
    45: {
        name: 'Darwinia Pangoro Testnet',
        chain: 'pangoro',
        rpc: ['https://pangoro-rpc.darwinia.network'],
        faucets: [
            'https://docs.darwinia.network/pangoro-testnet-70cfec5dc9ca42759959ba3803edaec2'
        ],
        nativeCurrency: {
            name: 'Pangoro Network Native Token',
            symbol: 'ORING',
            decimals: 18
        },
        infoURL: 'https://darwinia.network/',
        shortName: 'pangoro',
        chainId: 45,
        networkId: 45,
        slip44: 1,
        explorers: [
            {
                name: 'subscan',
                url: 'https://pangoro.subscan.io',
                standard: 'none'
            }
        ]
    },
    46: {
        name: 'Darwinia Network',
        chain: 'darwinia',
        rpc: [
            'https://rpc.darwinia.network',
            'https://darwinia-rpc.dcdao.box',
            'https://darwinia-rpc.dwellir.com',
            'https://darwinia.rpc.subquery.network/public'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'Darwinia Network Native Token',
            symbol: 'RING',
            decimals: 18
        },
        infoURL: 'https://darwinia.network',
        shortName: 'darwinia',
        chainId: 46,
        networkId: 46,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.darwinia.network',
                standard: 'EIP3091'
            }
        ]
    },
    47: {
        name: 'Acria IntelliChain',
        chain: 'AIC',
        rpc: ['https://aic.acria.ai'],
        faucets: [],
        nativeCurrency: { name: 'ACRIA', symbol: 'ACRIA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://acria.ai',
        shortName: 'aic',
        chainId: 47,
        networkId: 47,
        explorers: [
            {
                name: 'Acria IntelliChain-Explorer',
                url: 'https://explorer.acria.ai',
                standard: 'EIP3091'
            }
        ]
    },
    48: {
        name: 'Ennothem Mainnet Proterozoic',
        chain: 'ETMP',
        rpc: ['https://rpc.etm.network'],
        faucets: [],
        nativeCurrency: { name: 'Ennothem', symbol: 'ETMP', decimals: 18 },
        infoURL: 'https://etm.network',
        shortName: 'etmp',
        chainId: 48,
        networkId: 48,
        icon: 'etmp',
        explorers: [
            {
                name: 'etmpscan',
                url: 'https://etmscan.network',
                icon: 'etmp',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmT7DTqT1V2y42pRpt3sj9ifijfmbtkHN7D2vTfAUAS622'
    },
    49: {
        name: 'Ennothem Testnet Pioneer',
        chain: 'ETMP',
        rpc: ['https://rpc.pioneer.etm.network'],
        faucets: [],
        nativeCurrency: { name: 'Ennothem', symbol: 'ETMP', decimals: 18 },
        infoURL: 'https://etm.network',
        shortName: 'etmpTest',
        chainId: 49,
        networkId: 49,
        slip44: 1,
        icon: 'etmp',
        explorers: [
            {
                name: 'etmp',
                url: 'https://pioneer.etmscan.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmT7DTqT1V2y42pRpt3sj9ifijfmbtkHN7D2vTfAUAS622'
    },
    50: {
        name: 'XDC Network',
        chain: 'XDC',
        rpc: [
            'https://erpc.xinfin.network',
            'https://rpc.xinfin.network',
            'https://rpc1.xinfin.network',
            'https://rpc.xdcrpc.com',
            'https://erpc.xdcrpc.com',
            'https://rpc.ankr.com/xdc',
            'https://rpc.xdc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'XinFin', symbol: 'XDC', decimals: 18 },
        infoURL: 'https://xinfin.org',
        shortName: 'xdc',
        chainId: 50,
        networkId: 50,
        icon: 'xdc',
        explorers: [
            {
                name: 'xdcscan',
                url: 'https://xdcscan.com',
                icon: 'blocksscan',
                standard: 'EIP3091'
            },
            {
                name: 'openscan',
                url: 'https://xdcscan.io',
                icon: 'blocksscan',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeRq7pabiJE2n1xU3Y5Mb4TZSX9kQ74x7a3P2Z4PqcMRX'
    },
    51: {
        name: 'XDC Apothem Network',
        chain: 'XDC',
        rpc: [
            'https://rpc.apothem.network',
            'https://erpc.apothem.network',
            'https://apothem.xdcrpc.com'
        ],
        faucets: [
            'https://faucet.apothem.network',
            'https://faucet.blocksscan.io',
            'https://apothem.xdcscan.io/faucet'
        ],
        nativeCurrency: { name: 'XinFin', symbol: 'TXDC', decimals: 18 },
        infoURL: 'https://xinfin.org',
        shortName: 'txdc',
        chainId: 51,
        networkId: 51,
        icon: 'xdc',
        explorers: [
            {
                name: 'xdcscan',
                url: 'https://testnet.xdcscan.com',
                icon: 'blocksscan',
                standard: 'EIP3091'
            },
            {
                name: 'openscan',
                url: 'https://apothem.xdcscan.io',
                icon: 'blocksscan',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeRq7pabiJE2n1xU3Y5Mb4TZSX9kQ74x7a3P2Z4PqcMRX'
    },
    52: {
        name: 'CoinEx Smart Chain Mainnet',
        chain: 'CSC',
        rpc: ['https://rpc.coinex.net'],
        faucets: [],
        nativeCurrency: {
            name: 'CoinEx Chain Native Token',
            symbol: 'cet',
            decimals: 18
        },
        infoURL: 'https://www.coinex.org/',
        shortName: 'cet',
        chainId: 52,
        networkId: 52,
        explorers: [
            {
                name: 'coinexscan',
                url: 'https://www.coinex.net',
                standard: 'none'
            }
        ]
    },
    53: {
        name: 'CoinEx Smart Chain Testnet',
        chain: 'CSC',
        rpc: ['https://testnet-rpc.coinex.net/'],
        faucets: [],
        nativeCurrency: {
            name: 'CoinEx Chain Test Native Token',
            symbol: 'cett',
            decimals: 18
        },
        infoURL: 'https://www.coinex.org/',
        shortName: 'tcet',
        chainId: 53,
        networkId: 53,
        slip44: 1,
        explorers: [
            {
                name: 'coinexscan',
                url: 'https://testnet.coinex.net',
                standard: 'none'
            }
        ]
    },
    54: {
        name: 'Openpiece Mainnet',
        chain: 'OPENPIECE',
        icon: 'openpiece',
        rpc: ['https://mainnet.openpiece.io'],
        faucets: [],
        nativeCurrency: { name: 'Belly', symbol: 'BELLY', decimals: 18 },
        infoURL: 'https://cryptopiece.online',
        shortName: 'OP',
        chainId: 54,
        networkId: 54,
        explorers: [
            {
                name: 'Belly Scan',
                url: 'https://bellyscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVTahJkdSH3HPYsJMK2GmqfWZjLyxE7cXy1aHEnHU3vp2'
    },
    55: {
        name: 'Zyx Mainnet',
        chain: 'ZYX',
        rpc: [
            'https://rpc-1.zyx.network/',
            'https://rpc-2.zyx.network/',
            'https://rpc-3.zyx.network/',
            'https://rpc-4.zyx.network/',
            'https://rpc-5.zyx.network/',
            'https://rpc-6.zyx.network/'
        ],
        faucets: [],
        nativeCurrency: { name: 'Zyx', symbol: 'ZYX', decimals: 18 },
        infoURL: 'https://zyx.network/',
        shortName: 'ZYX',
        chainId: 55,
        networkId: 55,
        explorers: [
            { name: 'zyxscan', url: 'https://zyxscan.com', standard: 'none' }
        ]
    },
    56: {
        name: 'BNB Smart Chain Mainnet',
        chain: 'BSC',
        rpc: [
            'https://bsc-dataseed1.bnbchain.org',
            'https://bsc-dataseed2.bnbchain.org',
            'https://bsc-dataseed3.bnbchain.org',
            'https://bsc-dataseed4.bnbchain.org',
            'https://bsc-dataseed1.defibit.io',
            'https://bsc-dataseed2.defibit.io',
            'https://bsc-dataseed3.defibit.io',
            'https://bsc-dataseed4.defibit.io',
            'https://bsc-dataseed1.ninicoin.io',
            'https://bsc-dataseed2.ninicoin.io',
            'https://bsc-dataseed3.ninicoin.io',
            'https://bsc-dataseed4.ninicoin.io',
            'https://bsc-rpc.publicnode.com',
            'wss://bsc-rpc.publicnode.com',
            'wss://bsc-ws-node.nariox.org'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'BNB Chain Native Token',
            symbol: 'BNB',
            decimals: 18
        },
        infoURL: 'https://www.bnbchain.org/en',
        shortName: 'bnb',
        chainId: 56,
        networkId: 56,
        slip44: 714,
        explorers: [
            {
                name: 'bscscan',
                url: 'https://bscscan.com',
                standard: 'EIP3091'
            },
            {
                name: 'dexguru',
                url: 'https://bnb.dex.guru',
                icon: 'dexguru',
                standard: 'EIP3091'
            }
        ]
    },
    57: {
        name: 'Syscoin Mainnet',
        chain: 'SYS',
        rpc: [
            'https://rpc.syscoin.org',
            'https://rpc.ankr.com/syscoin/${ANKR_API_KEY}',
            'https://syscoin.public-rpc.com',
            'wss://rpc.syscoin.org/wss',
            'https://syscoin-evm.publicnode.com',
            'wss://syscoin-evm.publicnode.com'
        ],
        faucets: ['https://faucet.syscoin.org'],
        nativeCurrency: { name: 'Syscoin', symbol: 'SYS', decimals: 18 },
        infoURL: 'https://www.syscoin.org',
        shortName: 'sys',
        chainId: 57,
        networkId: 57,
        explorers: [
            {
                name: 'Syscoin Block Explorer',
                url: 'https://explorer.syscoin.org',
                standard: 'EIP3091'
            }
        ]
    },
    58: {
        name: 'Ontology Mainnet',
        chain: 'Ontology',
        icon: 'ontology',
        rpc: [
            'http://dappnode1.ont.io:20339',
            'http://dappnode2.ont.io:20339',
            'http://dappnode3.ont.io:20339',
            'http://dappnode4.ont.io:20339',
            'https://dappnode1.ont.io:10339',
            'https://dappnode2.ont.io:10339',
            'https://dappnode3.ont.io:10339',
            'https://dappnode4.ont.io:10339'
        ],
        faucets: [],
        nativeCurrency: { name: 'ONG', symbol: 'ONG', decimals: 18 },
        infoURL: 'https://ont.io/',
        shortName: 'OntologyMainnet',
        chainId: 58,
        networkId: 58,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer.ont.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigmvn6spvbiirtutowpq6jmetevbxoof5plzixjoerbeswy4htfb4'
    },
    59: {
        name: 'EOS EVM Legacy',
        chain: 'EOS',
        rpc: ['https://api.eosargentina.io'],
        faucets: [],
        nativeCurrency: { name: 'EOS', symbol: 'EOS', decimals: 18 },
        infoURL: 'https://eosargentina.io',
        shortName: 'eos-legacy',
        chainId: 59,
        networkId: 59,
        explorers: [],
        status: 'deprecated'
    },
    60: {
        name: 'GoChain',
        chain: 'GO',
        rpc: ['https://rpc.gochain.io'],
        faucets: [],
        nativeCurrency: { name: 'GoChain Ether', symbol: 'GO', decimals: 18 },
        infoURL: 'https://gochain.io',
        shortName: 'go',
        chainId: 60,
        networkId: 60,
        slip44: 6060,
        explorers: [
            {
                name: 'GoChain Explorer',
                url: 'https://explorer.gochain.io',
                standard: 'EIP3091'
            }
        ]
    },
    61: {
        name: 'Ethereum Classic',
        title: 'Ethereum Classic Mainnet',
        status: 'active',
        chain: 'ETC',
        icon: 'ethereumclassic',
        rpc: [
            'https://etc.rivet.link',
            'https://besu-at.etc-network.info',
            'https://geth-at.etc-network.info',
            'https://etc.etcdesktop.com',
            'https://etc.mytokenpocket.vip'
        ],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETC', decimals: 18 },
        infoURL: 'https://ethereumclassic.org',
        shortName: 'etc',
        chainId: 61,
        networkId: 1,
        slip44: 61,
        explorers: [
            {
                name: 'blockscout-ethereum-classic',
                url: 'https://etc.blockscout.com',
                standard: 'EIP3091'
            },
            {
                name: 'etcnetworkinfo-blockscout-ethereum-classic',
                url: 'https://explorer-blockscout.etc-network.info',
                standard: 'none'
            },
            {
                name: 'etcnetworkinfo-alethio-ethereum-classic',
                url: 'https://explorer-alethio.etc-network.info',
                standard: 'none'
            },
            {
                name: 'etcnetworkinfo-expedition-ethereum-classic',
                url: 'https://explorer-expedition.etc-network.info',
                standard: 'none'
            },
            {
                name: 'hebeblock-ethereum-classic',
                url: 'https://etcerscan.com',
                standard: 'EIP3091'
            },
            {
                name: 'oklink-ethereum-classic',
                url: 'https://www.oklink.com/etc',
                standard: 'EIP3091'
            },
            {
                name: 'tokenview-ethereum-classic',
                url: 'https://etc.tokenview.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme7PT7gidTzRuf3T2JdxQ64JeZPgFH7yNBB8mYoMPbpTe'
    },
    62: {
        name: 'Morden Testnet',
        title: 'Ethereum Classic Morden Testnet',
        status: 'deprecated',
        chain: 'ETC',
        icon: 'ethereumclassictestnet',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Morden Ether', symbol: 'TETC', decimals: 18 },
        infoURL: 'https://ethereumclassic.org/development/testnets',
        shortName: 'tetc',
        chainId: 62,
        networkId: 2,
        slip44: 1,
        iconURL: 'https://ipfs.io/ipfs/QmawMDPsaj3kBTZErCYQ3tshv5RrMAN3smWNs72m943Fyj'
    },
    63: {
        name: 'Mordor Testnet',
        title: 'Ethereum Classic Mordor Testnet',
        status: 'active',
        chain: 'ETC',
        icon: 'ethereumclassictestnet',
        rpc: [
            'https://rpc.mordor.etccooperative.org',
            'https://geth-mordor.etc-network.info'
        ],
        features: [{ name: 'EIP155' }],
        faucets: [
            'https://easy.hebeswap.com/#/faucet',
            'https://faucet.mordortest.net'
        ],
        nativeCurrency: { name: 'Mordor Ether', symbol: 'METC', decimals: 18 },
        infoURL: 'https://ethereumclassic.org/development/testnets',
        shortName: 'metc',
        chainId: 63,
        networkId: 7,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout-mordor',
                url: 'https://etc-mordor.blockscout.com',
                standard: 'EIP3091'
            },
            {
                name: 'etcnetworkinfo-expedition-mordor',
                url: 'https://explorer-expedition.etc-network.info/?network=Ethereum+Classic+at+etc-network.info+GETH+Mordor',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmawMDPsaj3kBTZErCYQ3tshv5RrMAN3smWNs72m943Fyj'
    },
    64: {
        name: 'Ellaism',
        chain: 'ELLA',
        rpc: ['https://jsonrpc.ellaism.org'],
        faucets: [],
        nativeCurrency: { name: 'Ellaism Ether', symbol: 'ELLA', decimals: 18 },
        infoURL: 'https://ellaism.org',
        shortName: 'ellaism',
        chainId: 64,
        networkId: 64,
        slip44: 163
    },
    65: {
        name: 'OKExChain Testnet',
        chain: 'okexchain',
        rpc: ['https://exchaintestrpc.okex.org'],
        faucets: ['https://www.okex.com/drawdex'],
        nativeCurrency: {
            name: 'OKExChain Global Utility Token in testnet',
            symbol: 'OKT',
            decimals: 18
        },
        infoURL: 'https://www.okex.com/okexchain',
        shortName: 'tokt',
        chainId: 65,
        networkId: 65,
        slip44: 1,
        explorers: [
            {
                name: 'OKLink',
                url: 'https://www.oklink.com/okexchain-test',
                standard: 'EIP3091'
            }
        ]
    },
    66: {
        name: 'OKXChain Mainnet',
        chain: 'okxchain',
        rpc: [
            'https://exchainrpc.okex.org',
            'https://okc-mainnet.gateway.pokt.network/v1/lb/6275309bea1b320039c893ff'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'OKXChain Global Utility Token',
            symbol: 'OKT',
            decimals: 18
        },
        infoURL: 'https://www.okex.com/okc',
        shortName: 'okt',
        chainId: 66,
        networkId: 66,
        explorers: [
            {
                name: 'OKLink',
                url: 'https://www.oklink.com/en/okc',
                standard: 'EIP3091'
            }
        ]
    },
    67: {
        name: 'DBChain Testnet',
        chain: 'DBM',
        rpc: ['http://test-rpc.dbmbp.com'],
        faucets: [],
        nativeCurrency: { name: 'DBChain Testnet', symbol: 'DBM', decimals: 18 },
        infoURL: 'http://test.dbmbp.com',
        shortName: 'dbm',
        chainId: 67,
        networkId: 67,
        slip44: 1
    },
    68: {
        name: 'SoterOne Mainnet',
        chain: 'SOTER',
        rpc: ['https://rpc.soter.one'],
        faucets: [],
        nativeCurrency: {
            name: 'SoterOne Mainnet Ether',
            symbol: 'SOTER',
            decimals: 18
        },
        infoURL: 'https://www.soterone.com',
        shortName: 'SO1',
        chainId: 68,
        networkId: 68
    },
    69: {
        name: 'Optimism Kovan',
        title: 'Optimism Testnet Kovan',
        chain: 'ETH',
        rpc: ['https://kovan.optimism.io/'],
        faucets: ['http://fauceth.komputing.org?chain=69&address=${ADDRESS}'],
        nativeCurrency: { name: 'Kovan Ether', symbol: 'ETH', decimals: 18 },
        explorers: [
            {
                name: 'etherscan',
                url: 'https://kovan-optimistic.etherscan.io',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://optimism.io',
        shortName: 'okov',
        chainId: 69,
        networkId: 69,
        slip44: 1
    },
    70: {
        name: 'Hoo Smart Chain',
        chain: 'HSC',
        rpc: [
            'https://http-mainnet.hoosmartchain.com',
            'https://http-mainnet2.hoosmartchain.com',
            'wss://ws-mainnet.hoosmartchain.com',
            'wss://ws-mainnet2.hoosmartchain.com'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'Hoo Smart Chain Native Token',
            symbol: 'HOO',
            decimals: 18
        },
        infoURL: 'https://www.hoosmartchain.com',
        shortName: 'hsc',
        chainId: 70,
        networkId: 70,
        slip44: 1170,
        explorers: [
            {
                name: 'hooscan',
                url: 'https://www.hooscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    71: {
        name: 'Conflux eSpace (Testnet)',
        chain: 'Conflux',
        rpc: ['https://evmtestnet.confluxrpc.com'],
        faucets: ['https://faucet.confluxnetwork.org'],
        nativeCurrency: { name: 'CFX', symbol: 'CFX', decimals: 18 },
        infoURL: 'https://confluxnetwork.org',
        shortName: 'cfxtest',
        chainId: 71,
        networkId: 71,
        icon: 'conflux',
        explorers: [
            {
                name: 'Conflux Scan',
                url: 'https://evmtestnet.confluxscan.net',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifj7n24u2dslfijfihwqvpdeigt5aj3k3sxv6s35lv75sxsfr3ojy'
    },
    72: {
        name: 'DxChain Testnet',
        chain: 'DxChain',
        rpc: ['https://testnet-http.dxchain.com'],
        faucets: ['https://faucet.dxscan.io'],
        nativeCurrency: { name: 'DxChain Testnet', symbol: 'DX', decimals: 18 },
        infoURL: 'https://testnet.dxscan.io/',
        shortName: 'dxc',
        chainId: 72,
        networkId: 72,
        slip44: 1
    },
    73: {
        name: 'FNCY',
        chain: 'FNCY',
        rpc: ['https://fncy-seed1.fncy.world'],
        faucets: ['https://faucet-testnet.fncy.world'],
        nativeCurrency: { name: 'FNCY', symbol: 'FNCY', decimals: 18 },
        infoURL: 'https://fncyscan.fncy.world',
        shortName: 'FNCY',
        chainId: 73,
        networkId: 73,
        icon: 'fncy',
        explorers: [
            {
                name: 'fncy scan',
                url: 'https://fncyscan.fncy.world',
                icon: 'fncy',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfXCh6UnaEHn3Evz7RFJ3p2ggJBRm9hunDHegeoquGuhD'
    },
    74: {
        name: 'IDChain Mainnet',
        chain: 'IDChain',
        rpc: ['https://idchain.one/rpc/', 'wss://idchain.one/ws/'],
        faucets: [],
        nativeCurrency: { name: 'EIDI', symbol: 'EIDI', decimals: 18 },
        infoURL: 'https://idchain.one/begin/',
        shortName: 'idchain',
        chainId: 74,
        networkId: 74,
        icon: 'idchain',
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer.idchain.one',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZVwsY6HPXScKqZCA9SWNrr4jrQAHkPhVhMWi6Fj1DsrJ'
    },
    75: {
        name: 'Decimal Smart Chain Mainnet',
        chain: 'DSC',
        rpc: [
            'https://node.decimalchain.com/web3/',
            'https://node1-mainnet.decimalchain.com/web3/',
            'https://node2-mainnet.decimalchain.com/web3/',
            'https://node3-mainnet.decimalchain.com/web3/',
            'https://node4-mainnet.decimalchain.com/web3/'
        ],
        faucets: [],
        nativeCurrency: { name: 'Decimal', symbol: 'DEL', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://decimalchain.com',
        shortName: 'DSC',
        chainId: 75,
        networkId: 75,
        icon: 'dsc',
        explorers: [
            {
                name: 'DSC Explorer Mainnet',
                url: 'https://explorer.decimalchain.com',
                icon: 'dsc',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSgzwKnJJjys3Uq2aVVdwJ3NffLj3CXMVCph9uByTBegc'
    },
    76: {
        name: 'Mix',
        chain: 'MIX',
        rpc: ['https://rpc2.mix-blockchain.org:8647'],
        faucets: [],
        nativeCurrency: { name: 'Mix Ether', symbol: 'MIX', decimals: 18 },
        infoURL: 'https://mix-blockchain.org',
        shortName: 'mix',
        chainId: 76,
        networkId: 76,
        slip44: 76
    },
    77: {
        name: 'POA Network Sokol',
        chain: 'POA',
        rpc: [
            'https://sokol.poa.network',
            'wss://sokol.poa.network/wss',
            'ws://sokol.poa.network:8546'
        ],
        faucets: [],
        nativeCurrency: { name: 'POA Sokol Ether', symbol: 'SPOA', decimals: 18 },
        infoURL: 'https://poa.network',
        shortName: 'spoa',
        chainId: 77,
        networkId: 77,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.com/poa/sokol',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    78: {
        name: 'PrimusChain mainnet',
        chain: 'PC',
        rpc: ['https://ethnode.primusmoney.com/mainnet'],
        faucets: [],
        nativeCurrency: { name: 'Primus Ether', symbol: 'PETH', decimals: 18 },
        infoURL: 'https://primusmoney.com',
        shortName: 'primuschain',
        chainId: 78,
        networkId: 78
    },
    79: {
        name: 'Zenith Mainnet',
        chain: 'Zenith',
        rpc: [
            'https://dataserver-us-1.zenithchain.co/',
            'https://dataserver-asia-3.zenithchain.co/',
            'https://dataserver-asia-4.zenithchain.co/',
            'https://dataserver-asia-2.zenithchain.co/',
            'https://dataserver-asia-5.zenithchain.co/',
            'https://dataserver-asia-6.zenithchain.co/',
            'https://dataserver-asia-7.zenithchain.co/'
        ],
        faucets: [],
        nativeCurrency: { name: 'ZENITH', symbol: 'ZENITH', decimals: 18 },
        infoURL: 'https://www.zenithchain.co/',
        chainId: 79,
        networkId: 79,
        shortName: 'zenith',
        explorers: [
            {
                name: 'zenith scan',
                url: 'https://scan.zenithchain.co',
                standard: 'EIP3091'
            }
        ]
    },
    80: {
        name: 'GeneChain',
        chain: 'GeneChain',
        rpc: ['https://rpc.genechain.io'],
        faucets: [],
        nativeCurrency: { name: 'RNA', symbol: 'RNA', decimals: 18 },
        infoURL: 'https://scan.genechain.io/',
        shortName: 'GeneChain',
        chainId: 80,
        networkId: 80,
        explorers: [
            {
                name: 'GeneChain Scan',
                url: 'https://scan.genechain.io',
                standard: 'EIP3091'
            }
        ]
    },
    81: {
        name: 'Japan Open Chain Mainnet',
        chain: 'JOC',
        rpc: [
            'https://rpc-1.japanopenchain.org:8545',
            'https://rpc-2.japanopenchain.org:8545',
            'https://rpc-3.japanopenchain.org'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'Japan Open Chain Token',
            symbol: 'JOC',
            decimals: 18
        },
        infoURL: 'https://www.japanopenchain.org/',
        shortName: 'joc',
        chainId: 81,
        networkId: 81,
        icon: 'joc',
        explorers: [
            {
                name: 'Block Explorer',
                url: 'https://explorer.japanopenchain.org',
                standard: 'EIP3091',
                icon: 'joc'
            }
        ],
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/bafkreigkeot6kwnehcrmhppzd5yqaifttmmvyznv3qjo7agh2figylfyvu'
    },
    82: {
        name: 'Meter Mainnet',
        chain: 'METER',
        rpc: ['https://rpc.meter.io'],
        faucets: ['https://faucet.meter.io'],
        nativeCurrency: { name: 'Meter', symbol: 'MTR', decimals: 18 },
        infoURL: 'https://www.meter.io',
        shortName: 'Meter',
        chainId: 82,
        networkId: 82,
        explorers: [
            {
                name: 'Meter Mainnet Scan',
                url: 'https://scan.meter.io',
                standard: 'EIP3091'
            }
        ]
    },
    83: {
        name: 'Meter Testnet',
        chain: 'METER Testnet',
        rpc: ['https://rpctest.meter.io'],
        faucets: ['https://faucet-warringstakes.meter.io'],
        nativeCurrency: { name: 'Meter', symbol: 'MTR', decimals: 18 },
        infoURL: 'https://www.meter.io',
        shortName: 'MeterTest',
        chainId: 83,
        networkId: 83,
        slip44: 1,
        explorers: [
            {
                name: 'Meter Testnet Scan',
                url: 'https://scan-warringstakes.meter.io',
                standard: 'EIP3091'
            }
        ]
    },
    84: {
        name: 'Linqto Devnet',
        chain: 'LNQ',
        rpc: ['https://linqto-dev.com'],
        faucets: [],
        nativeCurrency: { name: 'XRP', symbol: 'XRP', decimals: 18 },
        infoURL: 'https://linqto.com',
        shortName: 'linqto-devnet',
        chainId: 84,
        networkId: 84,
        explorers: [
            {
                name: 'Linqto Devnet Explorer',
                url: 'https://explorer.linqto-dev.com',
                standard: 'EIP3091'
            }
        ]
    },
    85: {
        name: 'GateChain Testnet',
        chainId: 85,
        shortName: 'gttest',
        chain: 'GTTEST',
        networkId: 85,
        slip44: 1,
        nativeCurrency: { name: 'GateToken', symbol: 'GT', decimals: 18 },
        rpc: ['https://testnet.gatenode.cc'],
        faucets: ['https://www.gatescan.org/testnet/faucet'],
        explorers: [
            {
                name: 'GateScan',
                url: 'https://www.gatescan.org/testnet',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://www.gatechain.io'
    },
    86: {
        name: 'GateChain Mainnet',
        chainId: 86,
        shortName: 'gt',
        chain: 'GT',
        networkId: 86,
        nativeCurrency: { name: 'GateToken', symbol: 'GT', decimals: 18 },
        rpc: ['https://evm.gatenode.cc'],
        faucets: ['https://www.gatescan.org/faucet'],
        explorers: [
            {
                name: 'GateScan',
                url: 'https://www.gatescan.org',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://www.gatechain.io'
    },
    87: {
        name: 'Nova Network',
        chain: 'NNW',
        icon: 'novanetwork',
        rpc: [
            'https://connect.novanetwork.io',
            'https://0x57.redjackstudio.com',
            'https://rpc.novanetwork.io:9070'
        ],
        faucets: [],
        nativeCurrency: { name: 'Supernova', symbol: 'SNT', decimals: 18 },
        infoURL: 'https://novanetwork.io',
        shortName: 'nnw',
        chainId: 87,
        networkId: 87,
        explorers: [
            {
                name: 'novanetwork',
                url: 'https://explorer.novanetwork.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTTamJ55YGQwMboq4aqf3JjTEy5WDtjo4GBRQ5VdsWA6U'
    },
    88: {
        name: 'Viction',
        chain: 'Viction',
        rpc: ['https://rpc.viction.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Viction', symbol: 'VIC', decimals: 18 },
        infoURL: 'https://viction.xyz',
        shortName: 'vic',
        chainId: 88,
        networkId: 88,
        slip44: 889
    },
    89: {
        name: 'Viction Testnet',
        chain: 'Viction',
        rpc: ['https://rpc-testnet.viction.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Viction', symbol: 'VIC', decimals: 18 },
        infoURL: 'https://viction.xyz',
        shortName: 'vict',
        chainId: 89,
        networkId: 89,
        slip44: 1
    },
    90: {
        name: 'Garizon Stage0',
        chain: 'GAR',
        icon: 'garizon',
        rpc: ['https://s0.garizon.net/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Garizon', symbol: 'GAR', decimals: 18 },
        infoURL: 'https://garizon.com',
        shortName: 'gar-s0',
        chainId: 90,
        networkId: 90,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer.garizon.com',
                icon: 'garizon',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc'
    },
    91: {
        name: 'Garizon Stage1',
        chain: 'GAR',
        icon: 'garizon',
        rpc: ['https://s1.garizon.net/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Garizon', symbol: 'GAR', decimals: 18 },
        infoURL: 'https://garizon.com',
        shortName: 'gar-s1',
        chainId: 91,
        networkId: 91,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer.garizon.com',
                icon: 'garizon',
                standard: 'EIP3091'
            }
        ],
        parent: { chain: 'eip155-90', type: 'shard' },
        iconURL: 'https://ipfs.io/ipfs/QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc'
    },
    92: {
        name: 'Garizon Stage2',
        chain: 'GAR',
        icon: 'garizon',
        rpc: ['https://s2.garizon.net/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Garizon', symbol: 'GAR', decimals: 18 },
        infoURL: 'https://garizon.com',
        shortName: 'gar-s2',
        chainId: 92,
        networkId: 92,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer.garizon.com',
                icon: 'garizon',
                standard: 'EIP3091'
            }
        ],
        parent: { chain: 'eip155-90', type: 'shard' },
        iconURL: 'https://ipfs.io/ipfs/QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc'
    },
    93: {
        name: 'Garizon Stage3',
        chain: 'GAR',
        icon: 'garizon',
        rpc: ['https://s3.garizon.net/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Garizon', symbol: 'GAR', decimals: 18 },
        infoURL: 'https://garizon.com',
        shortName: 'gar-s3',
        chainId: 93,
        networkId: 93,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer.garizon.com',
                icon: 'garizon',
                standard: 'EIP3091'
            }
        ],
        parent: { chain: 'eip155-90', type: 'shard' },
        iconURL: 'https://ipfs.io/ipfs/QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc'
    },
    94: {
        name: 'SwissDLT',
        chain: 'SDLT',
        rpc: ['https://rpc.swissdlt.ch'],
        faucets: [],
        nativeCurrency: { name: 'BCTS', symbol: 'BCTS', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://bcts.ch',
        shortName: 'sdlt',
        chainId: 94,
        networkId: 94,
        icon: 'bcts',
        explorers: [
            {
                name: 'SwissDLT Explorer',
                url: 'https://explorer.swissdlt.ch',
                icon: 'bcts',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreig7x5z4j6vh2r3pugmjnob3tmlksaekhqcgsorqzvs55o6v7ehqd4'
    },
    95: {
        name: 'CamDL Mainnet',
        chain: 'CADL',
        rpc: ['https://rpc1.camdl.gov.kh/'],
        faucets: ['https://faucet.camdl.gov.kh/'],
        nativeCurrency: { name: 'CADL', symbol: 'CADL', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://camdl.gov.kh/',
        shortName: 'camdl',
        chainId: 95,
        networkId: 95,
        redFlags: ['reusedChainId'],
        icon: 'camdl',
        explorers: [
            {
                name: 'CamDL Block Explorer',
                url: 'https://explorer.camdl.gov.kh',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmW5Fpb2Ywnfqcj4ibvpbKvPv5Mo5eseWdYZnnUvLkj2Hp'
    },
    96: {
        name: 'KUB Mainnet',
        chain: 'KUB',
        rpc: ['https://rpc.bitkubchain.io', 'wss://wss.bitkubchain.io'],
        faucets: [],
        nativeCurrency: { name: 'KUB Coin', symbol: 'KUB', decimals: 18 },
        infoURL: 'https://www.kubchain.com/',
        shortName: 'kub',
        chainId: 96,
        networkId: 96,
        icon: 'kub',
        explorers: [
            {
                name: 'KUB Mainnet Explorer',
                url: 'https://kubscan.com',
                standard: 'none',
                icon: 'kub'
            }
        ],
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/bafkreigwng335wvow35ypah7hpq3m3xga3idods2wqs3cfcncoyzu7vxli'
    },
    97: {
        name: 'BNB Smart Chain Testnet',
        chain: 'BSC',
        rpc: [
            'https://data-seed-prebsc-1-s1.bnbchain.org:8545',
            'https://data-seed-prebsc-2-s1.bnbchain.org:8545',
            'https://data-seed-prebsc-1-s2.bnbchain.org:8545',
            'https://data-seed-prebsc-2-s2.bnbchain.org:8545',
            'https://data-seed-prebsc-1-s3.bnbchain.org:8545',
            'https://data-seed-prebsc-2-s3.bnbchain.org:8545',
            'https://bsc-testnet-rpc.publicnode.com',
            'wss://bsc-testnet-rpc.publicnode.com'
        ],
        faucets: ['https://testnet.bnbchain.org/faucet-smart'],
        nativeCurrency: {
            name: 'BNB Chain Native Token',
            symbol: 'tBNB',
            decimals: 18
        },
        infoURL: 'https://www.bnbchain.org/en',
        shortName: 'bnbt',
        chainId: 97,
        networkId: 97,
        slip44: 1,
        explorers: [
            {
                name: 'bscscan-testnet',
                url: 'https://testnet.bscscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    98: {
        name: 'Six Protocol',
        chain: 'SIXNET',
        icon: 'six',
        rpc: ['https://sixnet-rpc-evm.sixprotocol.net'],
        faucets: [],
        nativeCurrency: { name: 'SIX evm token', symbol: 'SIX', decimals: 18 },
        infoURL: 'https://six.network/',
        shortName: 'six',
        chainId: 98,
        networkId: 98,
        explorers: [
            {
                name: 'SIX Scan',
                url: 'https://sixscan.io/sixnet',
                standard: 'none',
                icon: 'six'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmP93z696v8Hetu13peY2oEHDXq8Bj5CqaDRwpVkpnM15A'
    },
    99: {
        name: 'POA Network Core',
        chain: 'POA',
        rpc: ['https://core.poa.network'],
        faucets: [],
        nativeCurrency: {
            name: 'POA Network Core Ether',
            symbol: 'POA',
            decimals: 18
        },
        infoURL: 'https://poa.network',
        shortName: 'poa',
        chainId: 99,
        networkId: 99,
        slip44: 178,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.com/poa/core',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    100: {
        name: 'Gnosis',
        chain: 'GNO',
        icon: 'gnosis',
        rpc: [
            'https://rpc.gnosischain.com',
            'https://rpc.gnosis.gateway.fm',
            'https://rpc.ankr.com/gnosis',
            'https://gnosischain-rpc.gateway.pokt.network',
            'https://gnosis-mainnet.public.blastapi.io',
            'https://gnosis.api.onfinality.io/public',
            'https://gnosis.blockpi.network/v1/rpc/public',
            'https://web3endpoints.com/gnosischain-mainnet',
            'https://gnosis.oat.farm',
            'wss://rpc.gnosischain.com/wss',
            'https://gnosis-rpc.publicnode.com',
            'wss://gnosis-rpc.publicnode.com'
        ],
        faucets: [
            'https://gnosisfaucet.com',
            'https://stakely.io/faucet/gnosis-chain-xdai',
            'https://faucet.prussia.dev/xdai'
        ],
        nativeCurrency: { name: 'xDAI', symbol: 'XDAI', decimals: 18 },
        infoURL: 'https://docs.gnosischain.com',
        shortName: 'gno',
        chainId: 100,
        networkId: 100,
        slip44: 700,
        explorers: [
            {
                name: 'gnosisscan',
                url: 'https://gnosisscan.io',
                standard: 'EIP3091'
            },
            {
                name: 'blockscout',
                url: 'https://gnosis.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            },
            {
                name: 'dexguru',
                url: 'https://gnosis.dex.guru',
                icon: 'dexguru',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeidk4swpgdyqmpz6shd5onvpaujvwiwthrhypufnwr6xh3dausz2dm'
    },
    101: {
        name: 'EtherInc',
        chain: 'ETI',
        rpc: ['https://api.einc.io/jsonrpc/mainnet'],
        faucets: [],
        nativeCurrency: { name: 'EtherInc Ether', symbol: 'ETI', decimals: 18 },
        infoURL: 'https://einc.io',
        shortName: 'eti',
        chainId: 101,
        networkId: 1,
        slip44: 464
    },
    102: {
        name: 'Web3Games Testnet',
        chain: 'Web3Games',
        icon: 'web3games',
        rpc: [
            'https://testnet-rpc-0.web3games.org/evm',
            'https://testnet-rpc-1.web3games.org/evm',
            'https://testnet-rpc-2.web3games.org/evm'
        ],
        faucets: [],
        nativeCurrency: { name: 'Web3Games', symbol: 'W3G', decimals: 18 },
        infoURL: 'https://web3games.org/',
        shortName: 'tw3g',
        chainId: 102,
        networkId: 102,
        slip44: 1,
        iconURL: 'https://ipfs.io/ipfs/QmUc57w3UTHiWapNW9oQb1dP57ymtdemTTbpvGkjVHBRCo'
    },
    103: {
        name: 'WorldLand Mainnet',
        chain: 'Worldland',
        icon: 'worldland',
        rpc: [
            'https://seoul.worldland.foundation',
            'https://seoul2.worldland.foundation'
        ],
        faucets: [],
        nativeCurrency: { name: 'Worldland', symbol: 'WLC', decimals: 18 },
        infoURL: 'https://worldland.foundation',
        shortName: 'WLC',
        chainId: 103,
        networkId: 103,
        explorers: [
            {
                name: 'Worldland Explorer',
                url: 'https://scan.worldland.foundation',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYZNTfK3byhgLsTjXP8vPubVHRz2CWsBrTJxZrQmKq6JZ'
    },
    104: {
        name: 'Kaiba Lightning Chain Testnet',
        chain: 'tKLC',
        rpc: ['https://klc.live/'],
        faucets: [],
        nativeCurrency: {
            name: 'Kaiba Testnet Token',
            symbol: 'tKAIBA',
            decimals: 18
        },
        infoURL: 'https://kaibadefi.com',
        shortName: 'tklc',
        chainId: 104,
        networkId: 104,
        slip44: 1,
        icon: 'kaiba',
        explorers: [
            {
                name: 'kaibascan',
                url: 'https://kaibascan.io',
                icon: 'kaibascan',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeihbsw3ky7yf6llpww6fabo4dicotcgwjpefscoxrppstjx25dvtea'
    },
    105: {
        name: 'Web3Games Devnet',
        chain: 'Web3Games',
        icon: 'web3games',
        rpc: ['https://devnet.web3games.org/evm'],
        faucets: [],
        nativeCurrency: { name: 'Web3Games', symbol: 'W3G', decimals: 18 },
        infoURL: 'https://web3games.org/',
        shortName: 'dw3g',
        chainId: 105,
        networkId: 105,
        explorers: [
            {
                name: 'Web3Games Explorer',
                url: 'https://explorer-devnet.web3games.org',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUc57w3UTHiWapNW9oQb1dP57ymtdemTTbpvGkjVHBRCo'
    },
    106: {
        name: 'Velas EVM Mainnet',
        chain: 'Velas',
        icon: 'velas',
        rpc: [
            'https://evmexplorer.velas.com/rpc',
            'https://explorer.velas.com/rpc'
        ],
        faucets: [],
        nativeCurrency: { name: 'Velas', symbol: 'VLX', decimals: 18 },
        infoURL: 'https://velas.com',
        shortName: 'vlx',
        chainId: 106,
        networkId: 106,
        explorers: [
            {
                name: 'Velas Explorer',
                url: 'https://evmexplorer.velas.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNXiCXJxEeBd7ZYGYjPSMTSdbDd2nfodLC677gUfk9ku5'
    },
    107: {
        name: 'Nebula Testnet',
        chain: 'NTN',
        icon: 'nebulatestnet',
        rpc: ['https://testnet.rpc.novanetwork.io'],
        faucets: ['https://faucet.novanetwork.io'],
        nativeCurrency: { name: 'Nebula X', symbol: 'NBX', decimals: 18 },
        infoURL: 'https://novanetwork.io',
        shortName: 'ntn',
        chainId: 107,
        networkId: 107,
        slip44: 1,
        explorers: [
            {
                name: 'nebulatestnet',
                url: 'https://explorer.novanetwork.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeFaJtQqTKKuXQR7ysS53bLFPasFBcZw445cvYJ2HGeTo'
    },
    108: {
        name: 'ThunderCore Mainnet',
        chain: 'TT',
        rpc: [
            'https://mainnet-rpc.thundercore.com',
            'https://mainnet-rpc.thundertoken.net',
            'https://mainnet-rpc.thundercore.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'ThunderCore Token', symbol: 'TT', decimals: 18 },
        infoURL: 'https://thundercore.com',
        shortName: 'TT',
        chainId: 108,
        networkId: 108,
        slip44: 1001,
        explorers: [
            {
                name: 'thundercore-viewblock',
                url: 'https://viewblock.io/thundercore',
                standard: 'EIP3091'
            }
        ]
    },
    109: {
        name: 'Shibarium',
        chain: 'Shibarium',
        icon: 'shibarium',
        rpc: [
            'https://www.shibrpc.com',
            'https://rpc.shibrpc.com',
            'https://shib.nownodes.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'BONE Shibarium', symbol: 'BONE', decimals: 18 },
        infoURL: 'https://shibariumecosystem.com',
        shortName: 'shibariumecosystem',
        chainId: 109,
        networkId: 109,
        explorers: [
            {
                name: 'shibariumscan',
                url: 'https://www.shibariumscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmd6rSbfpVjQQZXothmiwGqKo7zovnB9gkeoYcunDt7ZTb'
    },
    110: {
        name: 'Proton Testnet',
        chain: 'XPR',
        rpc: ['https://protontestnet.greymass.com/'],
        faucets: [],
        nativeCurrency: { name: 'Proton', symbol: 'XPR', decimals: 4 },
        infoURL: 'https://protonchain.com',
        shortName: 'xpr',
        chainId: 110,
        networkId: 110,
        slip44: 1
    },
    111: {
        name: 'EtherLite Chain',
        chain: 'ETL',
        rpc: ['https://rpc.etherlite.org'],
        faucets: ['https://etherlite.org/faucets'],
        nativeCurrency: { name: 'EtherLite', symbol: 'ETL', decimals: 18 },
        infoURL: 'https://etherlite.org',
        shortName: 'ETL',
        chainId: 111,
        networkId: 111,
        icon: 'etherlite',
        iconURL: 'https://ipfs.io/ipfs/QmbNAai1KnBnw4SPQKgrf6vBddifPCQTg2PePry1bmmZYy'
    },
    112: {
        name: 'Coinbit Mainnet',
        chain: 'Coinbit',
        rpc: ['https://coinbit-rpc-mainnet.chain.sbcrypto.app'],
        faucets: [],
        nativeCurrency: { name: 'Gas IDR', symbol: 'GIDR', decimals: 18 },
        infoURL: 'https://crypto.stockbit.com/',
        shortName: 'coinbit',
        chainId: 112,
        networkId: 112,
        icon: 'coinbit',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://coinbit-explorer.chain.sbcrypto.app',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdaQRUbAXJGfHeJ8jaB8WVh8CCmHExq8VjvAfXpLWWQEo'
    },
    113: {
        name: 'Dehvo',
        chain: 'Dehvo',
        rpc: [
            'https://connect.dehvo.com',
            'https://rpc.dehvo.com',
            'https://rpc1.dehvo.com',
            'https://rpc2.dehvo.com'
        ],
        faucets: ['https://buy.dehvo.com'],
        nativeCurrency: { name: 'Dehvo', symbol: 'Deh', decimals: 18 },
        infoURL: 'https://dehvo.com',
        shortName: 'deh',
        chainId: 113,
        networkId: 113,
        slip44: 714,
        explorers: [
            {
                name: 'Dehvo Explorer',
                url: 'https://explorer.dehvo.com',
                standard: 'EIP3091'
            }
        ]
    },
    114: {
        name: 'Flare Testnet Coston2',
        chain: 'FLR',
        icon: 'coston2',
        rpc: [
            'https://coston2-api.flare.network/ext/C/rpc',
            'https://flare-testnet-coston2.rpc.thirdweb.com',
            'https://flaretestnet-bundler.etherspot.io',
            'https://01-gravelines-005-01.rpc.tatum.io/ext/bc/C/rpc',
            'https://02-chicago-005-02.rpc.tatum.io/ext/bc/C/rpc',
            'https://02-tokyo-005-03.rpc.tatum.io/ext/bc/C/rpc',
            'https://coston2.enosys.global/ext/C/rpc'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://faucet.flare.network'],
        nativeCurrency: { name: 'Coston2 Flare', symbol: 'C2FLR', decimals: 18 },
        infoURL: 'https://flare.network',
        shortName: 'c2flr',
        chainId: 114,
        networkId: 114,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://coston2-explorer.flare.network',
                standard: 'EIP3091'
            },
            {
                name: 'Routescan',
                url: 'https://coston2.testnet.flarescan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSmXY36oXCLmTp1u3Z2MSrBstBFVFyQv3aGKLKf1hxB6u'
    },
    115: {
        name: 'DeBank Testnet(Deprecated)',
        chain: 'DeBank',
        rpc: [],
        faucets: [],
        icon: 'debank',
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        status: 'deprecated',
        infoURL: 'https://debank.com',
        shortName: 'debank-testnet',
        chainId: 115,
        networkId: 115,
        slip44: 1,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmW9pBps8WHRRWmyXhjLZrjZJUe8F48hUu7z98bu2RVsjN'
    },
    116: {
        name: 'DeBank Mainnet',
        chain: 'DeBank',
        rpc: [],
        faucets: [],
        icon: 'debank',
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        status: 'deprecated',
        infoURL: 'https://debank.com',
        shortName: 'debank-mainnet',
        chainId: 116,
        networkId: 116,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmW9pBps8WHRRWmyXhjLZrjZJUe8F48hUu7z98bu2RVsjN'
    },
    117: {
        name: 'Uptick Mainnet',
        chain: 'Uptick',
        rpc: ['https://json-rpc.uptick.network'],
        faucets: [],
        nativeCurrency: { name: 'Uptick', symbol: 'UPTICK', decimals: 18 },
        infoURL: 'https://www.uptick.network',
        shortName: 'auptick',
        chainId: 117,
        networkId: 117,
        icon: 'uptick',
        explorers: [
            {
                name: 'Uptick Explorer',
                url: 'https://evm-explorer.uptick.network',
                icon: 'uptick',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRGJ6PqYHDTWuUQ6xfnK8S82NzRXiMjTnSGat9qtLuaLP'
    },
    118: {
        name: 'Arcology Testnet',
        chain: 'Arcology',
        icon: 'acolicon',
        rpc: ['https://testnet.arcology.network/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Arcology Coin', symbol: 'Acol', decimals: 18 },
        infoURL: 'https://arcology.network/',
        shortName: 'arcology',
        chainId: 118,
        networkId: 118,
        slip44: 1,
        explorers: [
            {
                name: 'arcology',
                url: 'https://testnet.arcology.network/explorer',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRD7itMvaZutfBjyA7V9xkMGDtsZiJSagPwd3ijqka8kE'
    },
    119: {
        name: 'ENULS Mainnet',
        chain: 'ENULS',
        rpc: ['https://evmapi.nuls.io', 'https://evmapi2.nuls.io'],
        faucets: [],
        nativeCurrency: { name: 'NULS', symbol: 'NULS', decimals: 18 },
        infoURL: 'https://nuls.io',
        shortName: 'enuls',
        chainId: 119,
        networkId: 119,
        icon: 'enuls',
        explorers: [
            {
                name: 'enulsscan',
                url: 'https://evmscan.nuls.io',
                icon: 'enuls',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYz8LK5WkUN8UwqKfWUjnyLuYqQZWihT7J766YXft4TSy'
    },
    120: {
        name: 'ENULS Testnet',
        chain: 'ENULS',
        rpc: ['https://beta.evmapi.nuls.io', 'https://beta.evmapi2.nuls.io'],
        faucets: ['http://faucet.nuls.io'],
        nativeCurrency: { name: 'NULS', symbol: 'NULS', decimals: 18 },
        infoURL: 'https://nuls.io',
        shortName: 'enulst',
        chainId: 120,
        networkId: 120,
        slip44: 1,
        icon: 'enuls',
        explorers: [
            {
                name: 'enulsscan',
                url: 'https://beta.evmscan.nuls.io',
                icon: 'enuls',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYz8LK5WkUN8UwqKfWUjnyLuYqQZWihT7J766YXft4TSy'
    },
    121: {
        name: 'Realchain Mainnet',
        chain: 'REAL',
        rpc: [
            'https://rcl-dataseed1.rclsidechain.com',
            'https://rcl-dataseed2.rclsidechain.com',
            'https://rcl-dataseed3.rclsidechain.com',
            'https://rcl-dataseed4.rclsidechain.com',
            'wss://rcl-dataseed1.rclsidechain.com/v1/',
            'wss://rcl-dataseed2.rclsidechain.com/v1/',
            'wss://rcl-dataseed3.rclsidechain.com/v1/',
            'wss://rcl-dataseed4.rclsidechain.com/v1/'
        ],
        faucets: [],
        nativeCurrency: { name: 'Realchain', symbol: 'REAL', decimals: 18 },
        infoURL: 'https://www.rclsidechain.com/',
        shortName: 'REAL',
        chainId: 121,
        networkId: 121,
        slip44: 714,
        explorers: [
            {
                name: 'realscan',
                url: 'https://rclscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    122: {
        name: 'Fuse Mainnet',
        chain: 'FUSE',
        rpc: [
            'https://rpc.fuse.io',
            'https://fuse.drpc.org',
            'wss://fuse.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Fuse', symbol: 'FUSE', decimals: 18 },
        infoURL: 'https://fuse.io/',
        shortName: 'fuse',
        chainId: 122,
        networkId: 122,
        icon: 'fuse',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.fuse.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmR3gooSiRfCuryT2y7Q37a3DqmdCKvV6vYp1fVpJW3VWz'
    },
    123: {
        name: 'Fuse Sparknet',
        chain: 'fuse',
        rpc: ['https://rpc.fusespark.io'],
        faucets: ['https://get.fusespark.io'],
        nativeCurrency: { name: 'Spark', symbol: 'SPARK', decimals: 18 },
        infoURL: 'https://docs.fuse.io/general/fuse-network-blockchain/fuse-testnet',
        shortName: 'spark',
        chainId: 123,
        networkId: 123
    },
    124: {
        name: 'Decentralized Web Mainnet',
        shortName: 'dwu',
        chain: 'DWU',
        chainId: 124,
        networkId: 124,
        rpc: ['https://decentralized-web.tech/dw_rpc.php'],
        faucets: [],
        infoURL: 'https://decentralized-web.tech/dw_chain.php',
        nativeCurrency: {
            name: 'Decentralized Web Utility',
            symbol: 'DWU',
            decimals: 18
        }
    },
    125: {
        name: 'OYchain Testnet',
        chain: 'OYchain',
        rpc: ['https://rpc.testnet.oychain.io'],
        faucets: ['https://faucet.oychain.io'],
        nativeCurrency: { name: 'OYchain Token', symbol: 'OY', decimals: 18 },
        infoURL: 'https://www.oychain.io',
        shortName: 'OYchainTestnet',
        chainId: 125,
        networkId: 125,
        slip44: 1,
        explorers: [
            {
                name: 'OYchain Testnet Explorer',
                url: 'https://explorer.testnet.oychain.io',
                standard: 'none'
            }
        ]
    },
    126: {
        name: 'OYchain Mainnet',
        chain: 'OYchain',
        icon: 'oychain',
        rpc: ['https://rpc.mainnet.oychain.io'],
        faucets: [],
        nativeCurrency: { name: 'OYchain Token', symbol: 'OY', decimals: 18 },
        infoURL: 'https://www.oychain.io',
        shortName: 'OYchainMainnet',
        chainId: 126,
        networkId: 126,
        slip44: 126,
        explorers: [
            {
                name: 'OYchain Mainnet Explorer',
                url: 'https://explorer.oychain.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXW5T2MaGHznXUmQEXoyJjcdmX7dhLbj5fnqvZZKqeKzA'
    },
    127: {
        name: 'Factory 127 Mainnet',
        chain: 'FETH',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Factory 127 Token', symbol: 'FETH', decimals: 18 },
        infoURL: 'https://www.factory127.com',
        shortName: 'feth',
        chainId: 127,
        networkId: 127,
        slip44: 127
    },
    128: {
        name: 'Huobi ECO Chain Mainnet',
        chain: 'Heco',
        rpc: [
            'https://http-mainnet.hecochain.com',
            'wss://ws-mainnet.hecochain.com'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'Huobi ECO Chain Native Token',
            symbol: 'HT',
            decimals: 18
        },
        infoURL: 'https://www.hecochain.com',
        shortName: 'heco',
        chainId: 128,
        networkId: 128,
        slip44: 1010,
        explorers: [
            {
                name: 'hecoinfo',
                url: 'https://hecoinfo.com',
                standard: 'EIP3091'
            }
        ]
    },
    129: {
        name: 'Innovator Chain',
        chain: 'INNOVATOR',
        rpc: ['https://rpc.innovatorchain.com'],
        faucets: [],
        nativeCurrency: { name: 'INOV8', symbol: 'INOV8', decimals: 18 },
        features: [],
        infoURL: 'https://innovatorchain.com',
        shortName: 'Innovator',
        chainId: 129,
        networkId: 129,
        icon: 'innovator',
        explorers: [
            {
                name: 'Innovator Explorer',
                url: 'https://evm.innovatorchain.com',
                icon: 'blockscout',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVJBGeFYZXMQqicNdzctMfvPN5CrtRrfZBTw3CEpkCBsS'
    },
    130: {
        name: 'Unichain',
        chain: 'ETH',
        rpc: [
            'https://mainnet.unichain.org',
            'https://unichain-rpc.publicnode.com',
            'wss://unichain-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://unichain.org',
        shortName: 'unichain',
        chainId: 130,
        networkId: 130,
        icon: 'unichain',
        explorers: [
            {
                name: 'Unichain Mainnet Explorer',
                url: 'https://uniscan.xyz',
                standard: 'EIP3091'
            },
            {
                name: 'Unichain Mainnet Explorer',
                url: 'https://unichain.blockscout.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWtu564n5T9KhhzKGMEcNWXXume5RzyUu7bARUX6ppHpW'
    },
    131: {
        name: 'Engram Testnet',
        chain: 'tGRAM',
        icon: 'engram',
        rpc: [
            'https://tokioswift.engram.tech',
            'https://tokio-archive.engram.tech'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: {
            name: 'Engram Tokio Testnet',
            symbol: 'tGRAM',
            decimals: 18
        },
        infoURL: 'https://engramnet.io',
        shortName: 'tgram',
        chainId: 131,
        networkId: 131,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://tokioscan-v2.engram.tech',
                icon: 'engram',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidn7dolavrzgqxthydb6rt5iwuzm6cvkxqirzh2szarjspsdp4kyu'
    },
    132: {
        name: 'Namefi Chain Mainnet',
        chain: 'NFIC',
        rpc: ['https://rpc.chain.namefi.io'],
        faucets: [],
        nativeCurrency: { name: 'Namefi Coin', symbol: 'NFIC', decimals: 18 },
        infoURL: 'https://namefi.io/',
        shortName: 'nfic',
        chainId: 132,
        networkId: 132
    },
    133: {
        name: 'HashKey Chain Testnet',
        title: 'HashKey Chain Testnet',
        chain: 'HashKey Chain Testnet',
        rpc: ['https://hashkeychain-testnet.alt.technology'],
        faucets: [],
        nativeCurrency: { name: 'HashKey EcoPoints', symbol: 'HSK', decimals: 18 },
        infoURL: 'https://hashkey.cloud',
        shortName: 'HSKT',
        chainId: 133,
        networkId: 133,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://hashkeychain-testnet-explorer.alt.technology',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111' }
    },
    134: {
        name: 'iExec Sidechain',
        chain: 'Bellecour',
        icon: 'rlc',
        rpc: ['https://bellecour.iex.ec'],
        faucets: [],
        nativeCurrency: { name: 'xRLC', symbol: 'xRLC', decimals: 18 },
        infoURL: 'https://iex.ec',
        shortName: 'rlc',
        chainId: 134,
        networkId: 134,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.bellecour.iex.ec',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUYKpVmZL4aS3TEZLG5wbrRJ6exxLiwm1rejfGYYNicfb'
    },
    135: {
        name: 'Alyx Chain Testnet',
        chain: 'Alyx Chain Testnet',
        rpc: ['https://testnet-rpc.alyxchain.com'],
        faucets: ['https://faucet.alyxchain.com'],
        nativeCurrency: {
            name: 'Alyx Testnet Native Token',
            symbol: 'ALYX',
            decimals: 18
        },
        infoURL: 'https://www.alyxchain.com',
        shortName: 'AlyxTestnet',
        chainId: 135,
        networkId: 135,
        slip44: 1,
        explorers: [
            {
                name: 'alyx testnet scan',
                url: 'https://testnet.alyxscan.com',
                standard: 'EIP3091'
            }
        ],
        icon: 'alyx',
        iconURL: 'https://ipfs.io/ipfs/bafkreifd43fcvh77mdcwjrpzpnlhthounc6b4u645kukqpqhduaveatf6i'
    },
    136: {
        name: 'Deamchain Mainnet',
        chain: 'Deamchain',
        icon: 'deam',
        rpc: ['https://mainnet.deamchain.com'],
        faucets: [],
        nativeCurrency: {
            name: 'Deamchain Native Token',
            symbol: 'DEAM',
            decimals: 18
        },
        infoURL: 'https://deamchain.com',
        shortName: 'deam',
        chainId: 136,
        networkId: 136,
        explorers: [
            {
                name: 'Deamchain Block Explorer',
                url: 'https://scan.deamchain.com',
                standard: 'EIP3091',
                icon: 'deam'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXvHWmjfXKdZMSz7x82NR4SjEqigKdJELVHbnzUPkj17F'
    },
    137: {
        name: 'Polygon Mainnet',
        chain: 'Polygon',
        icon: 'polygon',
        rpc: [
            'https://polygon-rpc.com/',
            'https://rpc-mainnet.matic.network',
            'https://matic-mainnet.chainstacklabs.com',
            'https://rpc-mainnet.maticvigil.com',
            'https://rpc-mainnet.matic.quiknode.pro',
            'https://matic-mainnet-full-rpc.bwarelabs.com',
            'https://polygon-bor-rpc.publicnode.com',
            'wss://polygon-bor-rpc.publicnode.com',
            'https://polygon.gateway.tenderly.co',
            'wss://polygon.gateway.tenderly.co',
            'https://polygon.drpc.org',
            'wss://polygon.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'POL', symbol: 'POL', decimals: 18 },
        infoURL: 'https://polygon.technology/',
        shortName: 'pol',
        chainId: 137,
        networkId: 137,
        slip44: 966,
        explorers: [
            {
                name: 'polygonscan',
                url: 'https://polygonscan.com',
                standard: 'EIP3091'
            },
            {
                name: 'dexguru',
                url: 'https://polygon.dex.guru',
                icon: 'dexguru',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRNqgazYuxUa5WdddFPftTWiP3KwzBMgV9Z19QWnLMETc'
    },
    138: {
        name: 'Defi Oracle Meta Mainnet',
        chain: 'dfiometa',
        icon: 'defioraclemeta',
        rpc: ['https://rpc.defi-oracle.io', 'wss://wss.defi-oracle.io'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://info.defi-oracle.io/',
        shortName: 'dfio-meta-main',
        chainId: 138,
        networkId: 1,
        slip44: 60,
        ens: { registry: '0x57f1887a8BF19b14fC0dF6Fd9B2acc9Af147eA85' },
        explorers: [
            {
                name: 'Blockscout Explorer',
                url: 'https://blockscout.defi-oracle.io',
                standard: 'none'
            },
            {
                name: 'Quorum Explorer',
                url: 'https://explorer.defi-oracle.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYrMRnjQJcNkYq9AvZ2FQ9kzYj9szzP4YDmyNA1ybd8xE'
    },
    139: {
        name: 'WoopChain Mainnet',
        chain: 'WOOP',
        icon: 'woopchain',
        rpc: ['https://rpc.woop.ai/rpc'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'WoopCoin', symbol: 'WOOC', decimals: 18 },
        infoURL: 'https://wikiwoop.com',
        shortName: 'woop',
        chainId: 139,
        networkId: 139,
        explorers: [
            {
                name: 'wikiwoop',
                url: 'https://explorer.wikiwoop.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qma7LpnkGjAN1dwL6VTXUYqzySNxjLg4br7J8UE4yZWYec'
    },
    140: {
        name: 'Eternal Mainnet',
        chain: 'ETE',
        icon: 'eternal',
        rpc: [
            'https://mainnet.eternalcoin.io/v1',
            'ws://mainnet.eternalcoin.io/v1/ws'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Eternal', symbol: 'ETE', decimals: 18 },
        infoURL: 'https://eternalcoin.io',
        shortName: 'ETE',
        chainId: 140,
        networkId: 140,
        iconURL: 'https://ipfs.io/ipfs/bafybeibexfskndvhn5xtrcmpjoifp2ufnzgwiwbfrjcxat55alergskkve'
    },
    141: {
        name: 'Openpiece Testnet',
        chain: 'OPENPIECE',
        icon: 'openpiece',
        rpc: ['https://testnet.openpiece.io'],
        faucets: [],
        nativeCurrency: { name: 'Belly', symbol: 'BELLY', decimals: 18 },
        infoURL: 'https://cryptopiece.online',
        shortName: 'OPtest',
        chainId: 141,
        networkId: 141,
        slip44: 1,
        explorers: [
            {
                name: 'Belly Scan',
                url: 'https://testnet.bellyscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVTahJkdSH3HPYsJMK2GmqfWZjLyxE7cXy1aHEnHU3vp2'
    },
    142: {
        name: 'DAX CHAIN',
        chain: 'DAX',
        rpc: ['https://rpc.prodax.io'],
        faucets: [],
        nativeCurrency: { name: 'Prodax', symbol: 'DAX', decimals: 18 },
        infoURL: 'https://prodax.io/',
        shortName: 'dax',
        chainId: 142,
        networkId: 142
    },
    143: {
        name: 'Monad Mainnet',
        chain: 'MON',
        icon: 'monad',
        rpc: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'MON Token', symbol: 'MON', decimals: 18 },
        infoURL: 'https://monad.xyz',
        shortName: 'mon',
        chainId: 143,
        networkId: 143,
        slip44: 1,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/bafkreia4vjioitvcrm5umefahnp4wttswooykroarjo5itdvohvk6epiya'
    },
    144: {
        name: 'PHI Network v2',
        chain: 'PHI',
        rpc: ['https://connect.phi.network'],
        faucets: [],
        nativeCurrency: { name: 'PHI', symbol: 'Φ', decimals: 18 },
        infoURL: 'https://phi.network',
        shortName: 'PHI',
        chainId: 144,
        networkId: 144,
        icon: 'phi',
        explorers: [
            {
                name: 'Phiscan',
                url: 'https://phiscan.com',
                icon: 'phi',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreid6pm3mic7izp3a6zlfwhhe7etd276bjfsq2xash6a4s2vmcdf65a'
    },
    145: {
        name: 'SoraAI Testnet',
        chain: 'SETH',
        icon: 'ethereum',
        rpc: ['https://rpc-testnet.soraai.bot'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'SoraETH', symbol: 'SETH', decimals: 18 },
        infoURL: 'https://soraai.bot',
        shortName: 'SETH',
        chainId: 145,
        networkId: 145,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.soraai.bot',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.soraai.bot' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt'
    },
    146: {
        name: 'Sonic Mainnet',
        chain: 'sonic',
        rpc: [
            'https://rpc.soniclabs.com',
            'https://sonic-rpc.publicnode.com',
            'wss://sonic-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Sonic', symbol: 'S', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://soniclabs.com',
        shortName: 'sonic',
        chainId: 146,
        networkId: 146,
        icon: 'sonic',
        explorers: [
            {
                name: 'sonic',
                url: 'https://explorer.soniclabs.com',
                icon: 'sonic',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbFqQ87T3HwjF6KejNYYYMcUtc7t64FDbfkpgWchFgMpC'
    },
    147: {
        name: 'Flag Mainnet',
        chain: 'Flag',
        icon: 'flag',
        rpc: ['https://mainnet-rpc.flagscan.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Flag', symbol: 'FLAG', decimals: 18 },
        infoURL: 'https://flagscan.xyz',
        shortName: 'FLAG',
        chainId: 147,
        networkId: 147,
        explorers: [
            {
                name: 'Flag Mainnet Explorer',
                url: 'https://flagscan.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeibcrxeavdxpwwmj4mc6hhp232nkrfbpvfpngcqux2v5rmoshycj3u'
    },
    148: {
        name: 'ShimmerEVM',
        title: 'ShimmerEVM',
        chain: 'ShimmerEVM',
        rpc: ['https://json-rpc.evm.shimmer.network'],
        faucets: [],
        nativeCurrency: { name: 'SMR', symbol: 'SMR', decimals: 18 },
        infoURL: 'https://shimmer.network',
        shortName: 'shimmerevm',
        chainId: 148,
        networkId: 148,
        icon: 'shimmerevm',
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer.evm.shimmer.network',
                icon: 'shimmerevm',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibky2sy6qhi6arktayvologkrgu5kudpgdxfkx4uosbvmstz7v4di'
    },
    150: {
        name: 'Six Protocol Testnet',
        chain: 'FIVENET',
        icon: 'six',
        rpc: ['https://rpc-evm.fivenet.sixprotocol.net'],
        faucets: ['https://faucet.sixprotocol.net'],
        nativeCurrency: {
            name: 'SIX testnet evm token',
            symbol: 'tSIX',
            decimals: 18
        },
        infoURL: 'https://six.network/',
        shortName: 'sixt',
        chainId: 150,
        networkId: 150,
        explorers: [
            {
                name: 'SIX Scan fivenet',
                url: 'https://sixscan.io/fivenet',
                standard: 'none',
                icon: 'six'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmP93z696v8Hetu13peY2oEHDXq8Bj5CqaDRwpVkpnM15A'
    },
    151: {
        name: 'Redbelly Network Mainnet',
        shortName: 'rbn',
        chain: 'RBN',
        chainId: 151,
        networkId: 151,
        slip44: 824,
        icon: 'redbelly',
        rpc: ['https://governors.mainnet.redbelly.network'],
        faucets: [],
        infoURL: 'https://redbelly.network',
        nativeCurrency: {
            name: 'Redbelly Network Coin',
            symbol: 'RBNT',
            decimals: 18
        },
        status: 'active',
        explorers: [
            {
                name: 'Routescan',
                url: 'https://redbelly.routescan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbU86AmMYhDTwDzJWLtrLAURqepXinJbVhXUJq5BaWqCp'
    },
    152: {
        name: 'Redbelly Network Devnet',
        shortName: 'rbn-devnet',
        chain: 'RBN',
        chainId: 152,
        networkId: 152,
        rpc: [],
        faucets: [],
        infoURL: 'https://redbelly.network',
        nativeCurrency: {
            name: 'Redbelly Network Coin',
            symbol: 'RBNT',
            decimals: 18
        },
        status: 'incubating'
    },
    153: {
        name: 'Redbelly Network Testnet',
        shortName: 'rbn-testnet',
        chain: 'RBN',
        chainId: 153,
        networkId: 153,
        icon: 'redbelly',
        slip44: 1,
        rpc: ['https://governors.testnet.redbelly.network'],
        faucets: [],
        infoURL: 'https://redbelly.network',
        nativeCurrency: {
            name: 'Redbelly Network Coin',
            symbol: 'RBNT',
            decimals: 18
        },
        explorers: [
            {
                name: 'Routescan',
                url: 'https://redbelly.testnet.routescan.io',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmbU86AmMYhDTwDzJWLtrLAURqepXinJbVhXUJq5BaWqCp'
    },
    154: {
        name: 'Redbelly Network TGE',
        shortName: 'rbn-tge',
        chain: 'RBN',
        chainId: 154,
        networkId: 154,
        rpc: [],
        faucets: [],
        infoURL: 'https://redbelly.network',
        nativeCurrency: {
            name: 'Redbelly Network Coin',
            symbol: 'RBNT',
            decimals: 18
        }
    },
    155: {
        name: 'Tenet Testnet',
        title: 'Tenet Testnet',
        chain: 'TENET',
        icon: 'tenet',
        rpc: ['https://rpc.testnet.tenet.org'],
        faucets: ['https://faucet.testnet.tenet.org'],
        nativeCurrency: { name: 'TENET', symbol: 'TENET', decimals: 18 },
        infoURL: 'https://tenet.org/',
        shortName: 'tenet-testnet',
        chainId: 155,
        networkId: 155,
        slip44: 1,
        explorers: [
            {
                name: 'TenetScan Testnet',
                url: 'https://testnet.tenetscan.io',
                icon: 'tenet',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmc1gqjWTzNo4pyFSGtQuCu7kRSZZBUVybtTjHn2nNEEPA'
    },
    156: {
        name: 'OEBlock Testnet',
        chain: 'OEBt',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        rpc: ['https://testnet-rpc.oeblock.com'],
        faucets: [],
        nativeCurrency: { name: 'OEBlock', symbol: 'OEB', decimals: 18 },
        infoURL: 'https://www.oeblock.com/',
        shortName: 'obe',
        chainId: 156,
        networkId: 156,
        slip44: 1,
        icon: 'oescan',
        explorers: [
            {
                name: 'OEScan explorer',
                url: 'https://testnet.oescan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdoQUfYqtkWMfjtoPv2KWDY4MxDDSsyWgwXtCx6jfkezz'
    },
    157: {
        name: 'Puppynet',
        chain: 'Puppynet',
        icon: 'shibarium',
        rpc: ['https://puppynet.shibrpc.com'],
        faucets: ['https://shibarium.shib.io/faucet'],
        nativeCurrency: { name: 'BONE', symbol: 'BONE', decimals: 18 },
        infoURL: 'https://shibariumecosystem.com',
        shortName: 'puppynet',
        chainId: 157,
        networkId: 157,
        explorers: [
            {
                name: 'puppyscan',
                url: 'https://puppyscan.shib.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmd6rSbfpVjQQZXothmiwGqKo7zovnB9gkeoYcunDt7ZTb'
    },
    158: {
        name: 'Roburna Mainnet',
        chain: 'RBA',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        rpc: ['https://dataseed.roburna.com'],
        faucets: [],
        nativeCurrency: { name: 'Roburna', symbol: 'RBA', decimals: 18 },
        infoURL: 'https://www.roburna.com/',
        shortName: 'rba',
        chainId: 158,
        networkId: 158,
        icon: 'roburna',
        explorers: [
            {
                name: 'Rbascan Explorer',
                url: 'https://rbascan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTk1uhB9nvnvXifvwEPGFcdgsXRt4EXNjovUGyUmfFRcB'
    },
    159: {
        name: 'Roburna Testnet',
        chain: 'RBAT',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        rpc: ['https://preseed-testnet-1.roburna.com'],
        faucets: [],
        nativeCurrency: { name: 'Roburna', symbol: 'RBAT', decimals: 18 },
        infoURL: 'https://www.roburna.com/',
        shortName: 'rbat',
        chainId: 159,
        networkId: 159,
        icon: 'roburna',
        explorers: [
            {
                name: 'Rbascan Testnet Explorer',
                url: 'https://testnet.rbascan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTk1uhB9nvnvXifvwEPGFcdgsXRt4EXNjovUGyUmfFRcB'
    },
    160: {
        name: 'Armonia Eva Chain Mainnet',
        chain: 'Eva',
        rpc: ['https://evascan.io/api/eth-rpc/'],
        faucets: [],
        nativeCurrency: {
            name: 'Armonia Multichain Native Token',
            symbol: 'AMAX',
            decimals: 18
        },
        infoURL: 'https://amax.network',
        shortName: 'eva',
        chainId: 160,
        networkId: 160,
        status: 'incubating'
    },
    161: {
        name: 'Armonia Eva Chain Testnet',
        chain: 'Wall-e',
        rpc: ['https://testnet.evascan.io/api/eth-rpc/'],
        faucets: [],
        nativeCurrency: {
            name: 'Armonia Multichain Native Token',
            symbol: 'AMAX',
            decimals: 18
        },
        infoURL: 'https://amax.network',
        shortName: 'wall-e',
        chainId: 161,
        networkId: 161,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout - evascan',
                url: 'https://testnet.evascan.io',
                standard: 'EIP3091'
            }
        ]
    },
    162: {
        name: 'Lightstreams Testnet',
        chain: 'PHT',
        rpc: ['https://node.sirius.lightstreams.io'],
        faucets: ['https://discuss.lightstreams.network/t/request-test-tokens'],
        nativeCurrency: { name: 'Lightstreams PHT', symbol: 'PHT', decimals: 18 },
        infoURL: 'https://explorer.sirius.lightstreams.io',
        shortName: 'tpht',
        chainId: 162,
        networkId: 162,
        slip44: 1
    },
    163: {
        name: 'Lightstreams Mainnet',
        chain: 'PHT',
        rpc: ['https://node.mainnet.lightstreams.io'],
        faucets: [],
        nativeCurrency: { name: 'Lightstreams PHT', symbol: 'PHT', decimals: 18 },
        infoURL: 'https://explorer.lightstreams.io',
        shortName: 'pht',
        chainId: 163,
        networkId: 163
    },
    164: {
        name: 'Omni Omega Testnet',
        chain: 'Omni',
        status: 'active',
        rpc: ['https://omega.omni.network', 'wss://wss.omega.omni.network'],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: { name: 'Omni', symbol: 'OMNI', decimals: 18 },
        infoURL: 'https://docs.omni.network',
        shortName: 'omni_omega',
        chainId: 164,
        networkId: 164,
        slip44: 1,
        icon: 'omni',
        explorers: [
            {
                name: 'Omni EVM and cross-chain Explorer',
                url: 'https://omega.omniscan.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdCMVucuZJpMqSn3xSWCU3io5ftRAwtzAqTd8QXLQEaos'
    },
    165: {
        name: 'Omni Testnet (Deprecated)',
        chain: 'Omni',
        rpc: [],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: { name: 'Omni', symbol: 'OMNI', decimals: 18 },
        infoURL: 'https://docs.omni.network/',
        shortName: 'omni_testnet_deprecated',
        chainId: 165,
        networkId: 165,
        slip44: 1,
        explorers: [],
        status: 'deprecated'
    },
    166: {
        name: 'Omni',
        chain: 'Omni',
        status: 'active',
        rpc: ['https://mainnet.omni.network', 'wss://wss.mainnet.omni.network'],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: { name: 'Omni', symbol: 'OMNI', decimals: 18 },
        infoURL: 'https://docs.omni.network',
        shortName: 'omni',
        chainId: 166,
        networkId: 166,
        slip44: 1,
        icon: 'omni',
        explorers: [
            {
                name: 'Omni EVM and cross-chain Explorer',
                url: 'https://omniscan.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdCMVucuZJpMqSn3xSWCU3io5ftRAwtzAqTd8QXLQEaos'
    },
    167: {
        name: 'Atoshi Testnet',
        chain: 'ATOSHI',
        icon: 'atoshi',
        rpc: ['https://node.atoshi.io/'],
        faucets: [],
        nativeCurrency: { name: 'ATOSHI', symbol: 'ATOS', decimals: 18 },
        infoURL: 'https://atoshi.org',
        shortName: 'atoshi',
        chainId: 167,
        networkId: 167,
        slip44: 1,
        explorers: [
            {
                name: 'atoshiscan',
                url: 'https://scan.atoverse.info',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfFK6B4MFLrpSS46aLf7hjpt28poHFeTGEKEuH248Tbyj'
    },
    168: {
        name: 'AIOZ Network',
        chain: 'AIOZ',
        icon: 'aioz',
        rpc: ['https://eth-dataseed.aioz.network'],
        faucets: [],
        nativeCurrency: { name: 'AIOZ', symbol: 'AIOZ', decimals: 18 },
        infoURL: 'https://aioz.network',
        shortName: 'aioz',
        chainId: 168,
        networkId: 168,
        slip44: 60,
        explorers: [
            {
                name: 'AIOZ Network Explorer',
                url: 'https://explorer.aioz.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRAGPFhvQiXgoJkui7WHajpKctGFrJNhHqzYdwcWt5V3Z'
    },
    169: {
        name: 'Manta Pacific Mainnet',
        chain: 'Manta Pacific',
        rpc: [
            'https://pacific-rpc.manta.network/http',
            'https://manta-pacific.drpc.org',
            'wss://manta-pacific.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://pacific-info.manta.network',
        shortName: 'manta',
        chainId: 169,
        networkId: 169,
        icon: 'manta',
        explorers: [
            {
                name: 'manta-pacific Explorer',
                url: 'https://pacific-explorer.manta.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTckcVTViRZ3NqT36MTt8AvgBSmudrbgU3pi8AaNtthoV'
    },
    170: {
        name: 'HOO Smart Chain Testnet',
        chain: 'ETH',
        rpc: ['https://http-testnet.hoosmartchain.com'],
        faucets: ['https://faucet-testnet.hscscan.com/'],
        nativeCurrency: { name: 'HOO', symbol: 'HOO', decimals: 18 },
        infoURL: 'https://www.hoosmartchain.com',
        shortName: 'hoosmartchain',
        chainId: 170,
        networkId: 170,
        slip44: 1
    },
    171: {
        name: 'CO2e Chain',
        chain: 'CO2E',
        rpc: ['https://rpc.co2e.cc', 'https://rpc.co2ledger.xyz'],
        faucets: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'CO2e Token', symbol: 'CO2E', decimals: 18 },
        infoURL: 'https://co2e.cc',
        shortName: 'CO2e',
        chainId: 171,
        networkId: 171,
        icon: 'co2e',
        explorers: [
            {
                name: 'CO2e Explorer',
                url: 'https://exp.co2e.cc',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmdcs7BTuVPjMxfQjfcWdzVeRiXwhzRtRj637pyGRbT9ff'
    },
    172: {
        name: 'Latam-Blockchain Resil Testnet',
        chain: 'Resil',
        rpc: ['https://rpc.latam-blockchain.com', 'wss://ws.latam-blockchain.com'],
        faucets: ['https://faucet.latam-blockchain.com'],
        nativeCurrency: {
            name: 'Latam-Blockchain Resil Test Native Token',
            symbol: 'usd',
            decimals: 18
        },
        infoURL: 'https://latam-blockchain.com',
        shortName: 'resil',
        chainId: 172,
        networkId: 172,
        slip44: 1
    },
    175: {
        name: 'OTC',
        chain: 'OTC',
        faucets: [],
        icon: 'otc',
        rpc: ['https://rpc.otc.run', 'wss://rpc.otc.run'],
        nativeCurrency: { name: 'OTC', symbol: 'OTC', decimals: 18 },
        infoURL: 'https://otc.network',
        shortName: 'OTC',
        chainId: 175,
        networkId: 175,
        slip44: 511,
        iconURL: 'https://ipfs.io/ipfs/QmfC9nTyEUPTXeqhDTpAcqHtLphHFyvZYj2tyoWiMu46H1'
    },
    176: {
        name: 'DC Mainnet',
        chain: 'dcchain',
        icon: 'dcchain',
        rpc: ['https://rpc.dcnetio.cloud', 'wss://ws.dcnetio.cloud'],
        faucets: [],
        nativeCurrency: { name: 'DC Native Token', symbol: 'DCT', decimals: 18 },
        infoURL: 'https://www.dcnetio.cloud',
        shortName: 'dcchain',
        chainId: 176,
        networkId: 176,
        explorers: [
            {
                name: 'dcscan',
                url: 'https://exp.dcnetio.cloud',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQsNtUoaKUHWaxFMBuCQwkX9WmKHz7iNotcZTFkWo7Qgt'
    },
    177: {
        name: 'HashKey Chain',
        title: 'HashKey Chain',
        chain: 'HashKey Chain',
        rpc: ['https://mainnet.hsk.xyz'],
        faucets: [],
        nativeCurrency: { name: 'HashKey EcoPoints', symbol: 'HSK', decimals: 18 },
        infoURL: 'https://hsk.xyz',
        shortName: 'hsk',
        chainId: 177,
        networkId: 177,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://hashkey.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            },
            {
                name: 'blockscout',
                url: 'https://explorer.hsk.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-1' }
    },
    178: {
        name: 'ABEY Testnet',
        chain: 'ABEY',
        rpc: ['https://testrpc.abeychain.com'],
        features: [{ name: 'EIP155' }],
        faucets: ['https://testnet-faucet.abeychain.com'],
        nativeCurrency: { name: 'ABEY', symbol: 'tABEY', decimals: 18 },
        infoURL: 'https://abey.com',
        shortName: 'abeyt',
        chainId: 178,
        networkId: 178,
        explorers: [
            {
                name: 'abeyscan-testnet',
                url: 'https://testnet.abeyscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    179: {
        name: 'ABEY Mainnet',
        chain: 'ABEY',
        rpc: ['https://rpc.abeychain.com'],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: { name: 'ABEY', symbol: 'ABEY', decimals: 18 },
        infoURL: 'https://abey.com',
        shortName: 'abey',
        chainId: 179,
        networkId: 179,
        explorers: [
            {
                name: 'abeyscan',
                url: 'https://abeyscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    180: {
        name: 'AME Chain Mainnet',
        chain: 'AME',
        rpc: ['https://node1.amechain.io/'],
        faucets: [],
        nativeCurrency: { name: 'AME', symbol: 'AME', decimals: 18 },
        infoURL: 'https://amechain.io/',
        shortName: 'ame',
        chainId: 180,
        networkId: 180,
        explorers: [
            {
                name: 'AME Scan',
                url: 'https://amescan.io',
                standard: 'EIP3091'
            }
        ]
    },
    181: {
        name: 'Waterfall Network',
        chain: 'Waterfall Network',
        rpc: ['https://rpc.waterfall.network/'],
        faucets: [],
        nativeCurrency: { name: 'WATER', symbol: 'WATER', decimals: 18 },
        features: [{ name: 'EIP1559' }],
        infoURL: 'https://waterfall.network',
        shortName: 'water',
        chainId: 181,
        networkId: 181,
        icon: 'waterfall-main',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmSDJPBKh9cLVL8UZ5KYwdwPyhD8bRWNb33jjt48wtu5Uc'
    },
    182: {
        name: 'IOST Mainnet',
        chain: 'iost',
        rpc: ['https://l2-mainnet.iost.io', 'wss://l2-mainnet.iost.io'],
        faucets: [],
        nativeCurrency: {
            name: 'BNB Chain Native Token',
            symbol: 'BNB',
            decimals: 18
        },
        infoURL: 'https://iost.io',
        shortName: 'iost',
        chainId: 182,
        networkId: 182,
        icon: 'bnbchain',
        slip44: 714,
        explorers: [
            {
                name: 'IOSTscan',
                url: 'https://l2-scan.iost.io',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-56',
            bridges: [{ url: 'https://l2-bridge.iost.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafybeib75gwytvblyvjpfminitr3i6mpat3a624udfsqsl5nysf5vuuvie'
    },
    183: {
        name: 'Ethernity',
        chain: 'Ethernity',
        rpc: ['https://mainnet.ethernitychain.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        icon: 'ethernity',
        infoURL: 'https://www.ethernity.io',
        shortName: 'ethernity-mainnet',
        chainId: 183,
        networkId: 183,
        explorers: [
            {
                name: 'Ethernity Explorer',
                url: 'https://ernscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihditrs2v6atsj2lzq2auchqiujg2d7lc2owot6tvj7rxe6ikgnv4'
    },
    184: {
        name: 'Dojima Testnet',
        chain: 'Dojima',
        rpc: ['https://rpc-test-d11k.dojima.network'],
        faucets: [],
        nativeCurrency: { name: 'Dojima', symbol: 'DOJ', decimals: 18 },
        icon: 'dojima',
        infoURL: 'https://www.dojima.network/',
        shortName: 'dojtestnet',
        chainId: 184,
        networkId: 184,
        explorers: [
            {
                name: 'Dojima Testnet Explorer',
                url: 'https://explorer-test.dojima.network',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmarhJVEb6jVNfW1GP2rcvAfto6DFdr7RSauZQxjd3iFam'
    },
    185: {
        name: 'Mint Mainnet',
        chain: 'ETH',
        rpc: [
            'https://rpc.mintchain.io',
            'https://global.rpc.mintchain.io',
            'https://asia.rpc.mintchain.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.mintchain.io',
        shortName: 'mint',
        chainId: 185,
        networkId: 185,
        icon: 'mint',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.mintchain.io',
                icon: 'mint',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVfsiKWkiYzxoq1j2Ri3yLYGvgHJBPybVEPsgyw5kqsMN'
    },
    186: {
        name: 'Seele Mainnet',
        chain: 'Seele',
        rpc: ['https://rpc.seelen.pro/'],
        faucets: [],
        nativeCurrency: { name: 'Seele', symbol: 'Seele', decimals: 18 },
        infoURL: 'https://seelen.pro/',
        shortName: 'Seele',
        chainId: 186,
        networkId: 186,
        explorers: [
            {
                name: 'seeleview',
                url: 'https://seeleview.net',
                standard: 'none'
            }
        ]
    },
    187: {
        name: 'Dojima',
        chain: 'Dojima',
        rpc: ['https://rpc-d11k.dojima.network'],
        faucets: [],
        nativeCurrency: { name: 'Dojima', symbol: 'DOJ', decimals: 18 },
        icon: 'dojima',
        infoURL: 'https://www.dojima.network/',
        shortName: 'dojima',
        chainId: 187,
        networkId: 187,
        explorers: [
            {
                name: 'Dojima Explorer',
                url: 'https://explorer.dojima.network',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmarhJVEb6jVNfW1GP2rcvAfto6DFdr7RSauZQxjd3iFam'
    },
    188: {
        name: 'BMC Mainnet',
        chain: 'BMC',
        rpc: ['https://mainnet.bmcchain.com/'],
        faucets: [],
        nativeCurrency: { name: 'BTM', symbol: 'BTM', decimals: 18 },
        infoURL: 'https://bmc.bytom.io/',
        shortName: 'BMC',
        chainId: 188,
        networkId: 188,
        explorers: [
            {
                name: 'Blockmeta',
                url: 'https://bmc.blockmeta.com',
                standard: 'none'
            }
        ]
    },
    189: {
        name: 'BMC Testnet',
        chain: 'BMC',
        rpc: ['https://testnet.bmcchain.com'],
        faucets: [],
        nativeCurrency: { name: 'BTM', symbol: 'BTM', decimals: 18 },
        infoURL: 'https://bmc.bytom.io/',
        shortName: 'BMCT',
        chainId: 189,
        networkId: 189,
        slip44: 1,
        explorers: [
            {
                name: 'Blockmeta',
                url: 'https://bmctestnet.blockmeta.com',
                standard: 'none'
            }
        ]
    },
    190: {
        name: 'CMDAO BBQ Chain',
        chain: 'Underchain 1',
        rpc: ['https://bbqchain-rpc.commudao.xyz'],
        faucets: [],
        nativeCurrency: { name: 'CommuDAO', symbol: 'CMD', decimals: 18 },
        infoURL: 'https://commudao.xyz',
        shortName: 'cmdao-bbq-chain',
        chainId: 190,
        networkId: 190,
        explorers: [
            {
                name: 'bbqchain-explorer',
                url: 'https://bbqchain-exp.commudao.xyz',
                standard: 'EIP3091'
            }
        ]
    },
    191: {
        name: 'FileFileGo',
        chain: 'FFG',
        icon: 'ffgIcon',
        rpc: ['https://rpc.filefilego.com/rpc'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'FFG', symbol: 'FFG', decimals: 18 },
        infoURL: 'https://filefilego.com',
        shortName: 'ffg',
        chainId: 191,
        networkId: 191,
        iconURL: 'https://ipfs.io/ipfs/bafkreihsas2rwakc7lllmtb4pcgwutlel2woibmqmhd4aiin342zgtpmwy'
    },
    193: {
        name: 'Crypto Emergency',
        chain: 'CEM',
        rpc: ['https://cemchain.com'],
        faucets: [],
        nativeCurrency: { name: 'Crypto Emergency', symbol: 'CEM', decimals: 18 },
        infoURL: 'https://cemblockchain.com/',
        shortName: 'cem',
        chainId: 193,
        networkId: 193,
        explorers: [
            {
                name: 'cemscan',
                url: 'https://cemscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    194: {
        name: 'firachain',
        chain: 'FIR',
        icon: 'firachainIcon',
        rpc: ['https://rpc.firachain.com'],
        faucets: [],
        nativeCurrency: { name: 'firachain', symbol: 'FIR', decimals: 18 },
        infoURL: 'https://firachain.com',
        shortName: 'FIR',
        chainId: 194,
        networkId: 194,
        status: 'active',
        explorers: [
            {
                name: 'FiraChain Explorer',
                url: 'https://block.firachain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifpbnvzcnl3badp6uig64fxxnf5tquw2ujyxqa5r2r36wuwd3yo5m'
    },
    195: {
        name: 'X Layer Testnet',
        chain: 'X Layer',
        rpc: ['https://testrpc.xlayer.tech', 'https://xlayertestrpc.okx.com'],
        faucets: ['https://www.okx.com/xlayer/faucet'],
        nativeCurrency: {
            name: 'X Layer Global Utility Token in testnet',
            symbol: 'OKB',
            decimals: 18
        },
        features: [],
        infoURL: 'https://www.okx.com/xlayer',
        shortName: 'tokb',
        chainId: 195,
        networkId: 195,
        slip44: 1,
        icon: 'xlayerTestnet',
        explorers: [
            {
                name: 'OKLink',
                url: 'https://www.oklink.com/xlayer-test',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmSLkiAAr6VtJ6jEqEzz3QdZtVEHzR6Az7E4XD8qXwjuio'
    },
    196: {
        name: 'X Layer Mainnet',
        chain: 'X Layer',
        rpc: ['https://rpc.xlayer.tech', 'https://xlayerrpc.okx.com'],
        faucets: [],
        nativeCurrency: {
            name: 'X Layer Global Utility Token',
            symbol: 'OKB',
            decimals: 18
        },
        features: [],
        infoURL: 'https://www.okx.com/xlayer',
        shortName: 'okb',
        chainId: 196,
        networkId: 196,
        icon: 'xlayer',
        explorers: [
            {
                name: 'OKLink',
                url: 'https://www.oklink.com/xlayer',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmSLkiAAr6VtJ6jEqEzz3QdZtVEHzR6Az7E4XD8qXwjuio'
    },
    197: {
        name: 'Neutrinos TestNet',
        chain: 'NEUTR',
        rpc: ['https://testnet-rpc.neutrinoschain.com'],
        faucets: ['https://neutrinoschain.com/faucet'],
        nativeCurrency: { name: 'Neutrinos', symbol: 'NEUTR', decimals: 18 },
        infoURL: 'https://docs.neutrinoschain.com',
        shortName: 'NEUTR',
        chainId: 197,
        networkId: 197,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet.neutrinoschain.com',
                standard: 'EIP3091'
            }
        ]
    },
    198: {
        name: 'Bitchain Mainnet',
        chain: 'Bit',
        rpc: ['https://rpc.bitchain.biz/'],
        faucets: [],
        nativeCurrency: { name: 'Bitcoin', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://www.bitchain.biz/',
        shortName: 'bit',
        chainId: 198,
        networkId: 198,
        explorers: [
            {
                name: 'Bitchain Scan',
                url: 'https://explorer.bitchain.biz',
                standard: 'EIP3091'
            }
        ]
    },
    199: {
        name: 'BitTorrent Chain Mainnet',
        chain: 'BTTC',
        icon: 'bttc',
        rpc: [
            'https://rpc.bt.io',
            'https://bittorrent.drpc.org',
            'wss://bittorrent.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'BitTorrent', symbol: 'BTT', decimals: 18 },
        infoURL: 'https://bt.io',
        shortName: 'BTT',
        chainId: 199,
        networkId: 199,
        explorers: [
            {
                name: 'BitTorrent Chain Explorer',
                url: 'https://bttcscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW7DmMmWVH4xTWf573AkaUD87tsWZyAxwjyvYx8vU6bjK'
    },
    200: {
        name: 'Arbitrum on xDai',
        chain: 'AOX',
        rpc: ['https://arbitrum.xdaichain.com/'],
        faucets: [],
        nativeCurrency: { name: 'xDAI', symbol: 'xDAI', decimals: 18 },
        infoURL: 'https://xdaichain.com',
        shortName: 'aox',
        chainId: 200,
        networkId: 200,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.com/xdai/arbitrum',
                standard: 'EIP3091'
            }
        ],
        parent: { chain: 'eip155-100', type: 'L2' }
    },
    201: {
        name: 'MOAC testnet',
        chain: 'MOAC',
        rpc: ['https://gateway.moac.io/testnet'],
        faucets: [],
        nativeCurrency: { name: 'MOAC', symbol: 'mc', decimals: 18 },
        infoURL: 'https://moac.io',
        shortName: 'moactest',
        chainId: 201,
        networkId: 201,
        slip44: 1,
        explorers: [
            {
                name: 'moac testnet explorer',
                url: 'https://testnet.moac.io',
                standard: 'none'
            }
        ]
    },
    202: {
        name: 'Edgeless Testnet',
        chain: 'EdgelessTestnet',
        rpc: ['https://testnet.rpc.edgeless.network/http'],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: {
            name: 'Edgeless Wrapped Eth',
            symbol: 'EwEth',
            decimals: 18
        },
        infoURL: 'https://edgeless.network',
        shortName: 'edgeless-testnet',
        chainId: 202,
        networkId: 202,
        explorers: [
            {
                name: 'Edgeless Explorer',
                url: 'https://testnet.explorer.edgeless.network',
                standard: 'EIP3091'
            }
        ]
    },
    203: {
        name: 'WowChain Mainnet',
        title: 'WowChain Mainnet',
        chain: 'WowChain',
        rpc: ['https://rpc.wowchain.io'],
        faucets: [],
        nativeCurrency: { name: 'Dogecoin', symbol: 'DOGE', decimals: 18 },
        infoURL: 'https://wowchain.io',
        shortName: 'wow',
        chainId: 203,
        networkId: 203,
        icon: 'wowchain',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.wowchain.io',
                icon: 'wowchain',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZvveFvougFMXqHRi8jGQ1EStBFhmCxTyNK16RK2WWp8t'
    },
    204: {
        name: 'opBNB Mainnet',
        icon: 'bnbchain',
        chain: 'opBNB',
        rpc: [
            'https://opbnb-mainnet-rpc.bnbchain.org',
            'https://opbnb-mainnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3',
            'wss://opbnb-mainnet.nodereal.io/ws/v1/64a9df0874fb4a93b9d0a3849de012d3',
            'https://opbnb-mainnet.nodereal.io/v1/e9a36765eb8a40b9bd12e680a1fd2bc5',
            'wss://opbnb-mainnet.nodereal.io/ws/v1/e9a36765eb8a40b9bd12e680a1fd2bc5',
            'https://opbnb-rpc.publicnode.com',
            'wss://opbnb-rpc.publicnode.com',
            'https://opbnb.drpc.org',
            'wss://opbnb.drpc.org'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'BNB Chain Native Token',
            symbol: 'BNB',
            decimals: 18
        },
        infoURL: 'https://opbnb.bnbchain.org/en',
        shortName: 'obnb',
        chainId: 204,
        networkId: 204,
        slip44: 714,
        explorers: [
            {
                name: 'opbnbscan',
                url: 'https://mainnet.opbnbscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeib75gwytvblyvjpfminitr3i6mpat3a624udfsqsl5nysf5vuuvie'
    },
    205: {
        name: 'EKAASH',
        chain: 'EKAASH',
        rpc: ['https://mainnet.ekaash.biz'],
        faucets: [],
        nativeCurrency: {
            name: 'Global Mobile Money Gateway',
            symbol: '$EKH',
            decimals: 18
        },
        infoURL: 'https://ekaash.biz',
        shortName: 'ekaash',
        chainId: 205,
        networkId: 205,
        slip44: 1,
        explorers: []
    },
    206: {
        name: 'VinuChain Testnet',
        chain: 'VinuChain Testnet',
        rpc: ['https://vinufoundation-rpc.com'],
        faucets: [],
        nativeCurrency: { name: 'VinuChain', symbol: 'VC', decimals: 18 },
        infoURL: 'https://vitainu.org',
        shortName: 'VCTEST',
        chainId: 206,
        networkId: 206,
        slip44: 1,
        icon: 'vitainu-testnet',
        explorers: [
            {
                name: 'VinuScan Testnet',
                url: 'https://testnet.vinuscan.com',
                icon: 'vinuscan-testnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidtie4srt52ry67wd3dpxhklmug2ozrawvf3jdlljveinp3frutra'
    },
    207: {
        name: 'VinuChain Network',
        chain: 'VinuChain',
        rpc: ['https://vinuchain-rpc.com'],
        faucets: [],
        nativeCurrency: { name: 'VinuChain', symbol: 'VC', decimals: 18 },
        infoURL: 'https://vitainu.org',
        shortName: 'VC',
        chainId: 207,
        networkId: 207,
        icon: 'vitainu',
        explorers: [
            {
                name: 'VinuScan',
                url: 'https://vinuscan.com',
                icon: 'vinuscan',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeiderli6uaaxk7eboyf7g4abnybgrkbglmqbkmf25z57ode7zdzmvy'
    },
    208: {
        name: 'Structx Mainnet',
        chain: 'utx',
        rpc: ['https://mainnet.structx.io'],
        faucets: [],
        nativeCurrency: { name: 'Notes', symbol: 'utx', decimals: 18 },
        infoURL: 'https://structx.io',
        shortName: 'utx',
        chainId: 208,
        networkId: 208
    },
    210: {
        name: 'Bitnet',
        chain: 'BTN',
        icon: 'bitnet',
        rpc: [
            'https://rpc.bitnet.money',
            'https://rpc.btnscan.com',
            'https://rpc.btn.network',
            'https://rpc.bitnetmoney.com',
            'https://rpc.btn-network.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Bitnet', symbol: 'BTN', decimals: 18 },
        infoURL: 'https://bitnet.technology',
        shortName: 'BTN',
        chainId: 210,
        networkId: 210,
        explorers: [
            {
                name: 'Bitnet Explorer',
                url: 'https://btnscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmS9h3nFiCzaBLnBNw8Wot4U7vvEVK45EQfi8nxH4nvrmz'
    },
    211: {
        name: 'Freight Trust Network',
        chain: 'EDI',
        rpc: [
            'http://13.57.207.168:3435',
            'https://app.freighttrust.net/ftn/${API_KEY}'
        ],
        faucets: ['http://faucet.freight.sh'],
        nativeCurrency: {
            name: 'Freight Trust Native',
            symbol: '0xF',
            decimals: 18
        },
        infoURL: 'https://freighttrust.com',
        shortName: 'EDI',
        chainId: 211,
        networkId: 0
    },
    212: {
        name: 'MAPO Makalu',
        title: 'MAPO Testnet Makalu',
        chain: 'MAPO',
        rpc: ['https://testnet-rpc.maplabs.io'],
        faucets: ['https://faucet.mapprotocol.io'],
        nativeCurrency: { name: 'Makalu MAPO', symbol: 'MAPO', decimals: 18 },
        infoURL: 'https://mapprotocol.io/',
        shortName: 'makalu',
        chainId: 212,
        networkId: 212,
        explorers: [
            {
                name: 'maposcan',
                url: 'https://testnet.maposcan.io',
                standard: 'EIP3091'
            }
        ]
    },
    213: {
        name: 'B2 Hub Mainnet',
        chain: 'B2',
        rpc: ['https://hub-rpc.bsquared.network'],
        faucets: [],
        nativeCurrency: { name: 'BSquared Token', symbol: 'B2', decimals: 18 },
        infoURL: 'https://www.bsquared.network',
        shortName: 'B2Hub-mainnet',
        chainId: 213,
        networkId: 213,
        icon: 'bsquare',
        explorers: [
            {
                name: 'B2 Hub Mainnet Explorer',
                url: 'https://hub-explorer.bsquared.network',
                icon: 'bsquare',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPV6ASrQDEkEW3g3ni7p2rJMPeciRLpEpvrAc1QfzVkx9'
    },
    214: {
        name: 'Shinarium Mainnet',
        chain: 'Shinarium',
        icon: 'shinarium',
        rpc: ['https://mainnet.shinarium.org'],
        faucets: [],
        nativeCurrency: { name: 'Shina Inu', symbol: 'SHI', decimals: 18 },
        infoURL: 'https://shinarium.org',
        shortName: 'shinarium',
        chainId: 214,
        networkId: 214,
        explorers: [
            {
                name: 'shinascan',
                url: 'https://shinascan.shinarium.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeiadbavrwcial76vs5ovhyykyaobteltuhliqcthdairbja4klwzhu'
    },
    215: {
        name: 'IDN Mainnet',
        chain: 'IDN',
        icon: 'idn',
        rpc: [
            'https://dataseed1.idn-rpc.com',
            'https://dataseed2.idn-rpc.com',
            'https://dataseed3.idn-rpc.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'IDN', symbol: 'IDN', decimals: 18 },
        infoURL: 'https://www.idn.world',
        shortName: 'IDN',
        chainId: 215,
        networkId: 215,
        explorers: [
            {
                name: 'Idn Explorer',
                url: 'https://scan.idn-network.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiarbxyddbnz5x36rj4l2ousrwnsjminqjjcswsttzxqckqwz6b7ba'
    },
    216: {
        name: 'Happychain Testnet',
        chainId: 216,
        networkId: 216,
        chain: 'Happychain Testnet',
        rpc: ['https://rpc.testnet.happy.tech/http'],
        faucets: [],
        nativeCurrency: { name: 'Happy', symbol: 'HAPPY', decimals: 18 },
        shortName: 'happytestnet',
        infoURL: 'https://testnet.happy.tech',
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.testnet.happy.tech',
                standard: 'EIP3091'
            }
        ]
    },
    217: {
        name: 'SiriusNet V2',
        chain: 'SIN2',
        faucets: [],
        rpc: ['https://rpc2.siriusnet.io'],
        icon: 'siriusnet',
        nativeCurrency: { name: 'MCD', symbol: 'MCD', decimals: 18 },
        infoURL: 'https://siriusnet.io',
        shortName: 'SIN2',
        chainId: 217,
        networkId: 217,
        explorers: [
            {
                name: 'siriusnet explorer',
                url: 'https://scan.siriusnet.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeicxuxdzrzpwsil4owqmn7wpwka2rqsohpfqmukg57pifzyxr5om2q'
    },
    218: {
        name: 'SoterOne Mainnet old',
        chain: 'SOTER',
        rpc: ['https://rpc.soter.one'],
        faucets: [],
        nativeCurrency: {
            name: 'SoterOne Mainnet Ether',
            symbol: 'SOTER',
            decimals: 18
        },
        infoURL: 'https://www.soterone.com',
        shortName: 'SO1-old',
        chainId: 218,
        networkId: 218,
        status: 'deprecated'
    },
    220: {
        name: 'Scalind Testnet',
        chain: 'ETH',
        icon: 'scalind',
        rpc: ['https://rpc-sepolia.scalind.com'],
        faucets: ['https://faucet.scalind.com'],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://scalind.com',
        shortName: 'sepscal',
        chainId: 220,
        networkId: 220,
        explorers: [
            {
                name: 'scalind',
                url: 'https://explorer-sepolia.scalind.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmayuauUTSkYxbT1xi2AkkG5VLEMDhcMeZ18WZHiApPa9M'
    },
    221: {
        name: 'BlockEx Mainnet',
        chain: 'BlockEx',
        rpc: ['https://rpc.blockex.biz'],
        faucets: [],
        nativeCurrency: { name: 'BlockEx', symbol: 'XBE', decimals: 18 },
        infoURL: 'https://blockex.biz',
        shortName: 'BlockEx',
        chainId: 221,
        networkId: 221,
        explorers: [
            {
                name: 'BlockEx Scan',
                url: 'http://explorer.blockex.biz',
                standard: 'EIP3091'
            }
        ]
    },
    222: {
        name: 'Permission',
        chain: 'ASK',
        rpc: ['https://blockchain-api-mainnet.permission.io/rpc'],
        faucets: [],
        nativeCurrency: { name: 'ASK', symbol: 'ASK', decimals: 18 },
        infoURL: 'https://permission.io/',
        shortName: 'ASK',
        chainId: 222,
        networkId: 2221,
        slip44: 2221,
        status: 'deprecated'
    },
    223: {
        name: 'B2 Mainnet',
        title: 'B2 Mainnet',
        chain: 'B2',
        rpc: [
            'https://mainnet.b2-rpc.com',
            'https://rpc.bsquared.network',
            'https://b2-mainnet.alt.technology',
            'https://b2-mainnet-public.s.chainbase.com',
            'https://rpc.ankr.com/b2'
        ],
        faucets: [],
        nativeCurrency: { name: 'Bitcoin', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://www.bsquared.network',
        shortName: 'B2-mainnet',
        chainId: 223,
        networkId: 223,
        icon: 'bsquare',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.bsquared.network',
                icon: 'bsquare',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-213',
            bridges: [{ url: 'https://www.bsquared.network/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmPV6ASrQDEkEW3g3ni7p2rJMPeciRLpEpvrAc1QfzVkx9'
    },
    224: {
        name: 'Viridis Testnet',
        chain: 'VRD',
        icon: 'viridis',
        rpc: ['https://testnet-rpc.vrd.network'],
        faucets: ['https://faucet.vrd.network'],
        nativeCurrency: { name: 'Viridis Token', symbol: 'VRD', decimals: 18 },
        infoURL: 'https://viridis.network',
        shortName: 'VRD-Testnet',
        chainId: 224,
        networkId: 224,
        explorers: [
            {
                name: 'Viridis Testnet',
                url: 'https://testnet.vrd.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPdxcJwPogfZdec7UAqxeatRxrivEktpP1ftJBTeJQTdR'
    },
    225: {
        name: 'LACHAIN Mainnet',
        chain: 'LA',
        icon: 'lachain-io',
        rpc: ['https://rpc-mainnet.lachain.io'],
        faucets: [],
        nativeCurrency: { name: 'LA', symbol: 'LA', decimals: 18 },
        infoURL: 'https://lachain.io',
        shortName: 'LA',
        chainId: 225,
        networkId: 225,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://scan.lachain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQxGA6rhuCQDXUueVcNvFRhMEWisyTmnF57TqL7h6k6cZ'
    },
    226: {
        name: 'LACHAIN Testnet',
        chain: 'TLA',
        icon: 'lachain-io',
        rpc: ['https://rpc-testnet.lachain.io'],
        faucets: [],
        nativeCurrency: { name: 'TLA', symbol: 'TLA', decimals: 18 },
        infoURL: 'https://lachain.io',
        shortName: 'TLA',
        chainId: 226,
        networkId: 226,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://scan-test.lachain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQxGA6rhuCQDXUueVcNvFRhMEWisyTmnF57TqL7h6k6cZ'
    },
    227: {
        name: 'Prom',
        chain: 'Prom',
        icon: 'prom',
        rpc: ['https://prom-rpc.eu-north-2.gateway.fm'],
        faucets: [],
        nativeCurrency: { name: 'Prom', symbol: 'PROM', decimals: 18 },
        infoURL: 'https://prom.io',
        shortName: 'PROM',
        chainId: 227,
        networkId: 227,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://prom-blockscout.eu-north-2.gateway.fm',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://prom-bridge.eu-north-2.gateway.fm/' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmWK2y5qCZgb6uCR7RrsEgTK1ci5rCSxmCWYtt5yJwpoE1'
    },
    228: {
        name: 'Mind Network Mainnet',
        chain: 'FHE',
        rpc: [
            'https://rpc-mainnet.mindnetwork.xyz',
            'wss://rpc-mainnet.mindnetwork.xyz'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://mindnetwork.xyz',
        shortName: 'fhe',
        chainId: 228,
        networkId: 228
    },
    230: {
        name: 'SwapDEX',
        chain: 'SDX',
        rpc: ['https://rpc.swapdex.network', 'wss://ss.swapdex.network'],
        faucets: [],
        nativeCurrency: { name: 'SwapDEX', symbol: 'SDX', decimals: 18 },
        infoURL: 'https://swapdex.network/',
        shortName: 'SDX',
        chainId: 230,
        networkId: 230,
        explorers: [
            {
                name: 'SwapDEX',
                url: 'https://evm.swapdex.network',
                standard: 'none'
            }
        ]
    },
    232: {
        name: 'Lens',
        title: 'Lens mainnet',
        chain: 'Lens',
        rpc: ['https://rpc.lens.xyz'],
        faucets: [],
        chainId: 232,
        networkId: 232,
        nativeCurrency: { name: 'GHO', symbol: 'GHO', decimals: 18 },
        icon: 'lens',
        infoURL: 'https://lens.xyz',
        shortName: 'lens',
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://app.across.to/bridge?destinationChainId=232' }]
        },
        explorers: [
            {
                name: 'Lens Block Explorer',
                url: 'https://explorer.lens.xyz',
                icon: 'lens',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmP9HNKbbWQLEx5H57BSV3VhJNyVpVaC5B3NBCsyoomTMU'
    },
    233: {
        name: 'Ethernity Testnet',
        chain: 'Ethernity',
        rpc: ['https://testnet.ethernitychain.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.ethernity.io',
        shortName: 'ethernity-testnet',
        chainId: 233,
        networkId: 233,
        explorers: [
            {
                name: 'Ethernity Testnet Explorer',
                url: 'https://testnet.ernscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    234: {
        name: 'ProtoJumbo Testnet',
        chain: 'Jumbo',
        rpc: ['https://testnode.jumbochain.org'],
        faucets: ['https://protojumbo.jumbochain.org/faucet-smart'],
        nativeCurrency: { name: 'JNFTC', symbol: 'JNFTC', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://jumbochain.org',
        shortName: 'ProtoJumbo',
        chainId: 234,
        networkId: 234,
        slip44: 1,
        explorers: [
            {
                name: 'ProtoJumbo',
                url: 'https://protojumbo.jumbochain.org',
                standard: 'EIP3091'
            }
        ]
    },
    236: {
        name: 'Deamchain Testnet',
        chain: 'Deamchain',
        icon: 'deam',
        rpc: ['https://testnet.deamchain.com'],
        faucets: ['https://faucet.deamchain.com'],
        nativeCurrency: {
            name: 'Deamchain Native Token',
            symbol: 'DEAM',
            decimals: 18
        },
        infoURL: 'https://deamchain.com',
        shortName: 'deamtest',
        chainId: 236,
        networkId: 236,
        slip44: 1,
        explorers: [
            {
                name: 'Deamchain Testnet Explorer',
                url: 'https://testnet-scan.deamchain.com',
                standard: 'EIP3091',
                icon: 'deam'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXvHWmjfXKdZMSz7x82NR4SjEqigKdJELVHbnzUPkj17F'
    },
    238: {
        name: 'Blast Mainnet',
        chain: 'ETH',
        icon: 'blastIcon',
        rpc: ['https://zkevmrpc.blastchain.org'],
        faucets: [],
        nativeCurrency: { name: 'One World Chain', symbol: 'OWCT', decimals: 18 },
        infoURL: 'https://docs.blastchain.org',
        shortName: 'blast',
        chainId: 238,
        networkId: 238,
        explorers: [
            {
                name: 'Blast Mainnet',
                url: 'https://blastchain.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdHpjiepU2Q4bt4kR48tKHPgaQW57Sb6UVFgLh4MCyg6U'
    },
    239: {
        name: 'TAC Mainnet',
        title: 'TAC Mainnet',
        chain: 'TAC',
        icon: 'tac',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'TAC', symbol: 'TAC', decimals: 18 },
        infoURL: 'https://tac.build/',
        shortName: 'tac',
        chainId: 239,
        networkId: 239,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/bafkreigvlt7py3h7ehy75x3w2ksmncfj57xt6giyfkhoue2vlrnfokezse'
    },
    240: {
        name: 'Cronos zkEVM Testnet',
        chain: 'CronosZkEVMTestnet',
        rpc: ['https://testnet.zkevm.cronos.org'],
        faucets: ['https://zkevm.cronos.org/faucet'],
        nativeCurrency: {
            name: 'Cronos zkEVM Test Coin',
            symbol: 'zkTCRO',
            decimals: 18
        },
        infoURL: 'https://docs-zkevm.cronos.org',
        shortName: 'zkTCRO',
        chainId: 240,
        networkId: 240,
        slip44: 1,
        explorers: [
            {
                name: 'Cronos zkEVM Testnet Explorer',
                url: 'https://explorer.zkevm.cronos.org/testnet',
                standard: 'none'
            }
        ]
    },
    242: {
        name: 'Plinga Mainnet',
        chain: 'Plinga',
        icon: 'plinga',
        rpc: [
            'https://rpcurl.mainnet.plgchain.com',
            'https://rpcurl.plgchain.blockchain.evmnode.online',
            'https://rpcurl.mainnet.plgchain.plinga.technology'
        ],
        faucets: [],
        nativeCurrency: { name: 'Plinga', symbol: 'PLINGA', decimals: 18 },
        infoURL: 'https://www.plinga.technology/',
        shortName: 'plgchain',
        chainId: 242,
        networkId: 242,
        explorers: [
            {
                name: 'plgscan',
                url: 'https://www.plgscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeibpvlod5nyev6wyuvp6pbestmgvru3ovbadsul32odpno26xwld6y'
    },
    246: {
        name: 'Energy Web Chain',
        chain: 'Energy Web Chain',
        rpc: ['https://rpc.energyweb.org', 'wss://rpc.energyweb.org/ws'],
        faucets: [],
        nativeCurrency: { name: 'Energy Web Token', symbol: 'EWT', decimals: 18 },
        infoURL: 'https://energyweb.org',
        shortName: 'ewt',
        chainId: 246,
        networkId: 246,
        slip44: 246,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.energyweb.org',
                standard: 'none'
            }
        ]
    },
    247: {
        name: 'ChooChain',
        title: 'ChooChain Mainnet',
        chain: 'CHOO',
        rpc: ['https://rpc.choochain.io'],
        faucets: [],
        nativeCurrency: { name: 'ChooChain Token', symbol: 'CHOO', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://github.com/Trinketz/ChooChain',
        shortName: 'choo',
        chainId: 247,
        networkId: 247,
        explorers: [
            {
                name: 'ChooChain Explorer',
                url: 'https://blocks.choochain.io',
                standard: 'EIP3091'
            }
        ]
    },
    248: {
        name: 'Oasys Mainnet',
        chain: 'Oasys',
        icon: 'oasys',
        rpc: ['https://rpc.mainnet.oasys.games'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://oasys.games',
        shortName: 'OAS',
        chainId: 248,
        networkId: 248,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.oasys.games',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVjT18MJ7S965w5oTce5D3KPbzfoGGaKaNDKJcfGfSNWm'
    },
    250: {
        name: 'Fantom Opera',
        chain: 'FTM',
        rpc: [
            'https://rpc.ftm.tools',
            'https://fantom-rpc.publicnode.com',
            'wss://fantom-rpc.publicnode.com',
            'https://fantom.drpc.org',
            'wss://fantom.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Fantom', symbol: 'FTM', decimals: 18 },
        infoURL: 'https://fantom.foundation',
        shortName: 'ftm',
        chainId: 250,
        networkId: 250,
        icon: 'fantom',
        explorers: [
            {
                name: 'ftmscan',
                url: 'https://ftmscan.com',
                icon: 'ftmscan',
                standard: 'EIP3091'
            },
            {
                name: 'dexguru',
                url: 'https://fantom.dex.guru',
                icon: 'dexguru',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcM8kHNsNYoitt5S3kLThyrKVFTZo3k2rgnume6tnNroQ'
    },
    251: {
        name: 'Glide L1 Protocol XP',
        chain: 'GLXP',
        icon: 'glide',
        rpc: [
            'https://rpc-api.glideprotocol.xyz/l1-rpc/',
            'wss://rpc-api.glideprotocol.xyz/l1-rpc/'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Glide XP', symbol: 'GLXP', decimals: 18 },
        infoURL: 'https://glideprotocol.xyz',
        shortName: 'glide',
        chainId: 251,
        networkId: 251,
        slip44: 60,
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/bafkreihxec2ckjvyoh5rhk4j2fvyqquiw5mievvs7up7fl2dfef5d767aa'
    },
    252: {
        name: 'Fraxtal',
        chain: 'FRAX',
        rpc: [
            'https://rpc.frax.com',
            'https://fraxtal-rpc.publicnode.com',
            'wss://fraxtal-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Frax Ether', symbol: 'frxETH', decimals: 18 },
        infoURL: 'https://mainnet.frax.com',
        shortName: 'fraxtal',
        chainId: 252,
        networkId: 252,
        icon: 'fraxtal',
        explorers: [
            {
                name: 'fraxscan',
                url: 'https://fraxscan.com',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/bafkreiet3pmz37ymq6wlkglw5wmcee6jdyz4bbe4zg6h2voso2z2mf2s7q'
    },
    253: {
        name: 'Glide L2 Protocol XP',
        chain: 'GLXP',
        icon: 'glide',
        rpc: [
            'https://rpc-api.glideprotocol.xyz/l2-rpc/',
            'wss://rpc-api.glideprotocol.xyz/l2-rpc/'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Glide XP', symbol: 'GLXP', decimals: 18 },
        infoURL: 'https://glideprotocol.xyz',
        shortName: 'glidexp',
        chainId: 253,
        networkId: 253,
        explorers: [
            {
                name: 'glidescan',
                url: 'https://blockchain-explorer.glideprotocol.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-251' },
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/bafkreihxec2ckjvyoh5rhk4j2fvyqquiw5mievvs7up7fl2dfef5d767aa'
    },
    254: {
        name: 'Swan Chain Mainnet',
        chain: 'SWAN',
        rpc: [
            'https://mainnet-rpc.swanchain.org',
            'https://mainnet-rpc-01.swanchain.org',
            'https://mainnet-rpc-02.swanchain.org',
            'https://mainnet-rpc-03.swanchain.org',
            'https://mainnet-rpc-04.swanchain.org'
        ],
        faucets: [],
        icon: 'swan',
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://swanchain.io/',
        shortName: 'Swan',
        chainId: 254,
        networkId: 254,
        explorers: [
            {
                name: 'Swanchain Explorer',
                url: 'https://swanscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiduag3kgux5c5a2zdiv3cjcrhwwh3cudc2hxyxufeadpfzhrjbo4u'
    },
    255: {
        name: 'Kroma',
        chain: 'ETH',
        rpc: ['https://api.kroma.network', 'https://rpc-kroma.rockx.com'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://kroma.network',
        icon: 'kroma',
        shortName: 'kroma',
        chainId: 255,
        networkId: 255,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.kroma.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://kroma.network/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmVpV2WET6ZrqnvvPfE9hCwoE2y5ygbPuniuugpaRoxrho'
    },
    256: {
        name: 'Huobi ECO Chain Testnet',
        chain: 'Heco',
        rpc: [
            'https://http-testnet.hecochain.com',
            'wss://ws-testnet.hecochain.com'
        ],
        faucets: ['https://scan-testnet.hecochain.com/faucet'],
        nativeCurrency: {
            name: 'Huobi ECO Chain Test Native Token',
            symbol: 'htt',
            decimals: 18
        },
        infoURL: 'https://testnet.hecoinfo.com',
        shortName: 'hecot',
        chainId: 256,
        networkId: 256
    },
    258: {
        name: 'Setheum',
        chain: 'Setheum',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Setheum', symbol: 'SETM', decimals: 18 },
        infoURL: 'https://setheum.xyz',
        shortName: 'setm',
        chainId: 258,
        networkId: 258
    },
    259: {
        name: 'Neonlink Mainnet',
        chain: 'Neonlink',
        rpc: ['https://mainnet.neonlink.io'],
        faucets: [],
        nativeCurrency: {
            name: 'Neonlink Native Token',
            symbol: 'NEON',
            decimals: 18
        },
        infoURL: 'https://neonlink.io',
        shortName: 'neon',
        chainId: 259,
        networkId: 259,
        icon: 'neonlink',
        explorers: [
            {
                name: 'Neon Blockchain Explorer',
                url: 'https://scan.neonlink.io',
                standard: 'EIP3091',
                icon: 'neonlink'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmX3hBv8WyvVfYjh1gmgDfJCpJBvKk4TYG9wFX9sC8WAjz'
    },
    260: {
        name: 'Guru Network',
        chain: 'GURU',
        icon: 'GuruNetwork',
        rpc: ['https://rpc-main.gurunetwork.ai'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Guru', symbol: 'GURU', decimals: 18 },
        infoURL: 'https://gurunetwork.ai',
        shortName: 'guru',
        chainId: 260,
        networkId: 260,
        explorers: [
            {
                name: 'guruscan',
                url: 'https://scan.gurunetwork.ai',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTDWnSNSCcVPCYD1FKrUirkT2MVrShdVK9dsxAi6eZdbD'
    },
    261: {
        name: 'Guru Network Testnet',
        chain: 'tGURU',
        icon: 'GuruNetwork',
        rpc: ['https://rpc-test.gurunetwork.ai'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://v2.dex.guru/season-pass/faucet'],
        nativeCurrency: { name: 'testGURU', symbol: 'tGURU', decimals: 18 },
        infoURL: 'https://gurunetwork.ai',
        shortName: 'tguru',
        chainId: 261,
        networkId: 261,
        explorers: [
            {
                name: 'guruscan',
                url: 'https://sepolia.gurunetwork.ai',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTDWnSNSCcVPCYD1FKrUirkT2MVrShdVK9dsxAi6eZdbD'
    },
    262: {
        name: 'SUR Blockchain Network',
        chain: 'SUR',
        rpc: ['https://sur.nilin.org'],
        faucets: [],
        nativeCurrency: { name: 'Suren', symbol: 'SRN', decimals: 18 },
        infoURL: 'https://surnet.org',
        shortName: 'SUR',
        chainId: 262,
        networkId: 1,
        icon: 'SUR',
        explorers: [
            {
                name: 'Surnet Explorer',
                url: 'https://explorer.surnet.org',
                icon: 'SUR',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbUcDQHCvheYQrWk9WFJRMW5fTJQmtZqkoGUed4bhCM7T'
    },
    266: {
        name: 'Neura',
        title: 'Neura Mainnet',
        chain: 'NEURA',
        icon: 'neura',
        rpc: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Ankr', symbol: 'ANKR', decimals: 18 },
        infoURL: 'https://www.neuraprotocol.io/',
        shortName: 'neura',
        chainId: 266,
        networkId: 266,
        status: 'incubating',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmWdpK5WFKrosaCSpJRCvU7uXeKk2qVeCckTxh6Zw2JrK8'
    },
    267: {
        name: 'Neura Testnet',
        title: 'Neura Testnet',
        chain: 'NEURA',
        icon: 'neura',
        rpc: ['https://rpc.ankr.com/neura_testnet'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://testnet.neuraprotocol.io/faucet'],
        nativeCurrency: { name: 'Testnet Ankr', symbol: 'ANKR', decimals: 18 },
        infoURL: 'https://www.neuraprotocol.io/',
        shortName: 'tneura',
        chainId: 267,
        networkId: 267,
        explorers: [
            {
                name: 'ankrscan-neura',
                url: 'https://testnet.explorer.neuraprotocol.io',
                icon: 'neura',
                standard: 'EIP3091'
            },
            {
                name: 'blockscout',
                url: 'https://explorer.neura-testnet.ankr.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        slip44: 1,
        iconURL: 'https://ipfs.io/ipfs/QmWdpK5WFKrosaCSpJRCvU7uXeKk2qVeCckTxh6Zw2JrK8'
    },
    268: {
        name: 'Neura Devnet',
        title: 'Neura Devnet',
        chain: 'NEURA',
        icon: 'neura',
        rpc: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Devnet Ankr', symbol: 'ANKR', decimals: 18 },
        infoURL: 'https://www.neuraprotocol.io/',
        shortName: 'dneura',
        chainId: 268,
        networkId: 268,
        explorers: [],
        status: 'incubating',
        slip44: 1,
        iconURL: 'https://ipfs.io/ipfs/QmWdpK5WFKrosaCSpJRCvU7uXeKk2qVeCckTxh6Zw2JrK8'
    },
    269: {
        name: 'High Performance Blockchain',
        chain: 'HPB',
        rpc: ['https://hpbnode.com', 'wss://ws.hpbnode.com'],
        faucets: ['https://myhpbwallet.com/'],
        nativeCurrency: {
            name: 'High Performance Blockchain Ether',
            symbol: 'HPB',
            decimals: 18
        },
        infoURL: 'https://hpb.io',
        shortName: 'hpb',
        chainId: 269,
        networkId: 269,
        slip44: 269,
        explorers: [
            { name: 'hscan', url: 'https://hscan.org', standard: 'EIP3091' }
        ]
    },
    271: {
        name: 'EgonCoin Mainnet',
        chain: 'EGON',
        icon: 'egonicon',
        rpc: ['https://rpc.egonscan.com'],
        faucets: [],
        nativeCurrency: { name: 'EgonCoin', symbol: 'EGON', decimals: 18 },
        infoURL: 'https://egonscan.com',
        shortName: 'EGONm',
        chainId: 271,
        networkId: 271,
        explorers: [
            {
                name: 'EgonCoin Mainnet',
                url: 'https://egonscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNZiMmzMQYjyGtNSghtzLg4UooYhDgMQsa677DAP5KsBg'
    },
    273: {
        name: 'XR One',
        chain: 'ETH',
        rpc: ['https://xr1.calderachain.xyz/http', 'wss://xr1.calderachain.xyz/ws'],
        faucets: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'XR1', symbol: 'XR1', decimals: 18 },
        infoURL: 'https://xr-one.gitbook.io',
        shortName: 'xr1',
        chainId: 273,
        networkId: 273,
        icon: 'xr',
        slip44: 60,
        explorers: [
            {
                name: 'XR One Explorer',
                url: 'https://xr1.calderaexplorer.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-42161',
            bridges: [{ url: 'https://xr1.bridge.caldera.xyz' }]
        },
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmTrFxtjUBwxi87rty13jbXg4BW9nvVuBmtbzb9j9F99Gt'
    },
    274: {
        name: 'LaChain',
        chain: 'LaChain',
        icon: 'lachain-network',
        rpc: [
            'https://rpc1.mainnet.lachain.network',
            'https://rpc2.mainnet.lachain.network',
            'https://lachain.rpc-nodes.cedalio.dev'
        ],
        faucets: [],
        nativeCurrency: { name: 'LaCoin', symbol: 'LAC', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: '',
        shortName: 'lachain',
        chainId: 274,
        networkId: 274,
        explorers: [
            {
                name: 'LaChain Explorer',
                url: 'https://explorer.lachain.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQxGA6rhuCQDXUueVcNvFRhMEWisyTmnF57TqL7h6k6cZ'
    },
    278: {
        name: 'xFair.AI Mainnet',
        chain: 'FAI',
        rpc: ['https://rpc_mainnet.xfair.ai', 'wss://rpc_mainnet.xfair.ai'],
        faucets: [],
        nativeCurrency: { name: 'FAI', symbol: 'FAI', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://xfair.ai',
        shortName: 'fai',
        chainId: 278,
        networkId: 278
    },
    279: {
        name: 'BPX Chain',
        chain: 'BPX',
        icon: 'bpx',
        rpc: ['https://rpc.bpxchain.cc'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'BPX', symbol: 'BPX', decimals: 18 },
        infoURL: 'https://bpxchain.cc',
        shortName: 'bpx',
        chainId: 279,
        networkId: 279,
        explorers: [
            {
                name: 'BPX Chain Block Explorer',
                url: 'https://explorer.bpxchain.cc',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiatcu42wbjlo24mr35jou4awvsqpaqys6iv4kxgkjhno3haovsiaq'
    },
    280: {
        name: 'zkSync Era Goerli Testnet (deprecated)',
        status: 'deprecated',
        chain: 'ETH',
        rpc: ['https://testnet.era.zksync.dev'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://zksync.io/',
        shortName: 'zksync-goerli',
        chainId: 280,
        networkId: 280,
        slip44: 1,
        icon: 'zksync-era',
        explorers: [
            {
                name: 'zkSync Era Block Explorer',
                url: 'https://goerli.explorer.zksync.io',
                icon: 'zksync-era',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.zksync.io/' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmRkhUD6J3B9WhT4hEWLrcFVTrBhx3CQgNC783aJsrwxSN'
    },
    282: {
        name: 'Deprecated Cronos zkEVM Testnet',
        chain: 'deprecatedCronosZkEVMTestnet',
        rpc: ['https://deprecated.testnet.zkevm.cronos.org'],
        faucets: ['https://zkevm.cronos.org/faucet'],
        nativeCurrency: {
            name: 'Cronos zkEVM Test Coin',
            symbol: 'zkTCRO',
            decimals: 18
        },
        infoURL: 'https://docs-zkevm.cronos.org',
        shortName: 'deprecated-zkTCRO',
        chainId: 282,
        networkId: 282,
        slip44: 1,
        explorers: [
            {
                name: 'Cronos zkEVM Testnet Explorer',
                url: 'https://explorer.zkevm.cronos.org/testnet',
                standard: 'none'
            }
        ],
        status: 'deprecated'
    },
    288: {
        name: 'Boba Network',
        chain: 'ETH',
        rpc: [
            'https://mainnet.boba.network',
            'https://replica.boba.network',
            'https://boba-ethereum.gateway.tenderly.co',
            'https://gateway.tenderly.co/public/boba-ethereum',
            'wss://boba-ethereum.gateway.tenderly.co/',
            'wss://gateway.tenderly.co/public/boba-ethereum',
            'https://boba-eth.drpc.org',
            'wss://boba-eth.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://boba.network',
        shortName: 'Boba',
        chainId: 288,
        networkId: 288,
        explorers: [
            { name: 'Bobascan', url: 'https://bobascan.com', standard: 'none' }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://gateway.boba.network' }]
        }
    },
    291: {
        name: 'Orderly Mainnet',
        chain: 'ETH',
        rpc: ['https://rpc.orderly.network'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://orderly.network/',
        shortName: 'orderly',
        chainId: 291,
        networkId: 291,
        icon: 'orderly',
        explorers: [
            {
                name: 'orderlyscout',
                url: 'https://explorer.orderly.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSpwp3RAVhZsErAQrCQxEmjnGqJQMigarzZbfqr9Ktakb'
    },
    293: {
        name: 'DaVinci',
        chain: 'DCOIN',
        rpc: ['https://rpc.davinci.bz'],
        faucets: [],
        nativeCurrency: { name: 'DaVinci', symbol: 'DCOIN', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://davinci.bz',
        shortName: 'davinci',
        chainId: 293,
        networkId: 293,
        icon: 'davinci',
        explorers: [
            {
                name: 'davinciscan',
                icon: 'blockscout',
                url: 'https://mainnet-explorer.davinci.bz',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/bafkreierr6bqbopiokhqcisqdfxjkslnjgk2j77dmq2ec4oitpgxtm4wha'
    },
    295: {
        name: 'Hedera Mainnet',
        chain: 'Hedera',
        icon: 'hedera',
        rpc: ['https://mainnet.hashio.io/api', 'https://hedera.linkpool.pro'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'hbar', symbol: 'HBAR', decimals: 18 },
        infoURL: 'https://hedera.com',
        shortName: 'hedera-mainnet',
        chainId: 295,
        networkId: 295,
        slip44: 3030,
        explorers: [
            {
                name: 'Arkhia Explorer',
                url: 'https://explorer.arkhia.io',
                standard: 'none'
            },
            {
                name: 'DragonGlass',
                url: 'https://app.dragonglass.me',
                standard: 'none'
            },
            {
                name: 'Hedera Explorer',
                url: 'https://hederaexplorer.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQikzhvZKyMmbZJd7BVLZb2YTBDMgNDnaMCAErsVjsfuz'
    },
    296: {
        name: 'Hedera Testnet',
        chain: 'Hedera',
        icon: 'hedera',
        rpc: ['https://testnet.hashio.io/api'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://portal.hedera.com'],
        nativeCurrency: { name: 'hbar', symbol: 'HBAR', decimals: 18 },
        infoURL: 'https://hedera.com',
        shortName: 'hedera-testnet',
        chainId: 296,
        networkId: 296,
        slip44: 1,
        explorers: [
            {
                name: 'HashScan',
                url: 'https://hashscan.io/testnet',
                standard: 'EIP3091'
            },
            {
                name: 'Arkhia Explorer',
                url: 'https://explorer.arkhia.io',
                standard: 'none'
            },
            {
                name: 'DragonGlass',
                url: 'https://app.dragonglass.me',
                standard: 'none'
            },
            {
                name: 'Hedera Explorer',
                url: 'https://hederaexplorer.io',
                standard: 'none'
            },
            {
                name: 'Ledger Works Explore',
                url: 'https://explore.lworks.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQikzhvZKyMmbZJd7BVLZb2YTBDMgNDnaMCAErsVjsfuz'
    },
    297: {
        name: 'Hedera Previewnet',
        chain: 'Hedera',
        icon: 'hedera',
        rpc: ['https://previewnet.hashio.io/api'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://portal.hedera.com'],
        nativeCurrency: { name: 'hbar', symbol: 'HBAR', decimals: 18 },
        infoURL: 'https://hedera.com',
        shortName: 'hedera-previewnet',
        chainId: 297,
        networkId: 297,
        slip44: 3030,
        explorers: [
            {
                name: 'HashScan',
                url: 'https://hashscan.io/previewnet',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQikzhvZKyMmbZJd7BVLZb2YTBDMgNDnaMCAErsVjsfuz'
    },
    298: {
        name: 'Hedera Localnet',
        chain: 'Hedera',
        icon: 'hedera',
        rpc: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'hbar', symbol: 'HBAR', decimals: 18 },
        infoURL: 'https://hedera.com',
        shortName: 'hedera-localnet',
        chainId: 298,
        networkId: 298,
        slip44: 3030,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmQikzhvZKyMmbZJd7BVLZb2YTBDMgNDnaMCAErsVjsfuz'
    },
    300: {
        name: 'zkSync Sepolia Testnet',
        chain: 'ETH',
        rpc: [
            'https://sepolia.era.zksync.dev',
            'https://zksync-sepolia.drpc.org',
            'wss://zksync-sepolia.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://zksync.io/',
        shortName: 'zksync-sepolia',
        chainId: 300,
        networkId: 300,
        slip44: 1,
        icon: 'zksync-era',
        explorers: [
            {
                name: 'zkSync Block Explorer',
                url: 'https://sepolia.explorer.zksync.io',
                icon: 'zksync-era',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge.zksync.io/' }]
        },
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/QmRkhUD6J3B9WhT4hEWLrcFVTrBhx3CQgNC783aJsrwxSN'
    },
    301: {
        name: 'Bobaopera',
        chain: 'Bobaopera',
        status: 'deprecated',
        rpc: [
            'https://bobaopera.boba.network',
            'wss://wss.bobaopera.boba.network',
            'https://replica.bobaopera.boba.network',
            'wss://replica-wss.bobaopera.boba.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Boba Token', symbol: 'BOBA', decimals: 18 },
        infoURL: 'https://boba.network',
        shortName: 'Bobaopera',
        chainId: 301,
        networkId: 301,
        explorers: [
            {
                name: 'Bobaopera block explorer',
                url: 'https://blockexplorer.bobaopera.boba.network',
                standard: 'none'
            }
        ]
    },
    302: {
        name: 'ZKcandy Sepolia Testnet',
        chain: 'ETH',
        rpc: ['https://sepolia.rpc.zkcandy.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://zkcandy.io/',
        shortName: 'zkcandy-sepolia',
        chainId: 302,
        networkId: 302,
        icon: 'zkcandy',
        explorers: [
            {
                name: 'ZKcandy Block Explorer',
                url: 'https://sepolia.explorer.zkcandy.io',
                icon: 'zkcandy',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://sepolia.bridge.zkcandy.io/' }]
        },
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/bafkreib5jsvl6kxn2qvv4giag3l3e54d2wolo2lqbgkhivxu4cpjzi77eq'
    },
    303: {
        name: 'Neurochain Testnet',
        chain: 'NCN',
        rpc: ['https://nc-rpc-test1.neurochain.io'],
        faucets: [],
        nativeCurrency: { name: 'Neurochain', symbol: 'tNCN', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.neurochain.ai',
        shortName: 'ncnt',
        chainId: 303,
        networkId: 303,
        slip44: 1,
        explorers: [
            {
                name: 'neuroscan',
                url: 'https://testnet.ncnscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    305: {
        name: 'ZKSats Mainnet',
        title: 'ZKSats Mainnet',
        chain: 'ZKSats',
        rpc: ['https://mainnet.zksats.io'],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://zksats.io',
        shortName: 'ZKSats-Mainnet',
        chainId: 305,
        networkId: 305,
        icon: 'zksats',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.zksats.io',
                icon: 'zksats',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaopiJuCSxRKZJHDkCu9w77x2HEmbNb3QeLC1SUavehEE'
    },
    307: {
        name: 'Lovely Network Testnet',
        chain: 'Lovely',
        icon: 'lovely',
        rpc: ['https://trpc.lovely.network'],
        faucets: ['https://faucet.lovely.network'],
        nativeCurrency: { name: 'Lovely', symbol: 'LOVELY', decimals: 18 },
        infoURL: 'https://lovely.network',
        shortName: 'LOVELY-Testnet',
        chainId: 307,
        networkId: 307,
        explorers: [
            {
                name: 'Lovely Network Testnet',
                url: 'https://tscan.lovely.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPB7uW7Wj8zWWdeuPnUHPJ5FhaiTL76tv4ZQ4oKWEpb1g'
    },
    308: {
        name: 'Furtheon',
        chain: 'Furtheon Network',
        rpc: ['https://rpc.furtheon.org'],
        faucets: [],
        nativeCurrency: { name: 'Furtheon', symbol: 'FTH', decimals: 18 },
        infoURL: 'https://furtheon.org/',
        shortName: 'furtheon',
        chainId: 308,
        networkId: 308,
        explorers: [
            {
                name: 'furthscan',
                url: 'http://furthscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    309: {
        name: 'Wyzth Testnet',
        chain: 'WYZ',
        rpc: ['https://rpc-testnet3.wyzthchain.org/'],
        faucets: [],
        nativeCurrency: { name: 'Wyzth', symbol: 'WYZ', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://wyzth.org/',
        shortName: 'wyz',
        chainId: 309,
        networkId: 309,
        slip44: 1,
        icon: 'wyzth_icon',
        explorers: [
            {
                name: 'wyzth',
                url: 'http://24.199.108.65:4000',
                icon: 'wyzth',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeDfLgA5heAAXsU8kf5J23Y8up4uHN27uRBEAJFPMJEu7'
    },
    311: {
        name: 'Omax Mainnet',
        chain: 'OMAX Chain',
        rpc: ['https://mainapi.omaxray.com', 'https://mainapi.omaxscan.com'],
        faucets: ['https://faucet.omaxray.com/'],
        nativeCurrency: { name: 'OMAX COIN', symbol: 'OMAX', decimals: 18 },
        infoURL: 'https://www.omaxcoin.com/',
        shortName: 'omax',
        chainId: 311,
        networkId: 311,
        icon: 'omaxchain',
        explorers: [
            {
                name: 'Omax Chain Explorer',
                url: 'https://omaxray.com',
                icon: 'omaxray',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmd7omPxrehSuxHHPMYd5Nr7nfrtjKdRJQEhDLfTb87w8G'
    },
    313: {
        name: 'Neurochain Mainnet',
        chain: 'NCN',
        rpc: [
            'https://nc-rpc-prd1.neurochain.io',
            'https://nc-rpc-prd2.neurochain.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'Neurochain', symbol: 'NCN', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.neurochain.ai',
        shortName: 'ncn',
        chainId: 313,
        networkId: 313,
        explorers: [
            {
                name: 'neuroscan',
                url: 'https://ncnscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    314: {
        name: 'Filecoin - Mainnet',
        chain: 'FIL',
        icon: 'filecoin',
        rpc: [
            'https://api.node.glif.io/',
            'https://rpc.ankr.com/filecoin',
            'https://filecoin-mainnet.chainstacklabs.com/rpc/v1',
            'https://filfox.info/rpc/v1',
            'https://filecoin.drpc.org',
            'wss://filecoin.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'filecoin', symbol: 'FIL', decimals: 18 },
        infoURL: 'https://filecoin.io',
        shortName: 'filecoin',
        chainId: 314,
        networkId: 314,
        slip44: 461,
        explorers: [
            { name: 'Filfox', url: 'https://filfox.info/en', standard: 'none' },
            { name: 'Beryx', url: 'https://beryx.zondax.ch', standard: 'none' },
            {
                name: 'Glif Explorer',
                url: 'https://explorer.glif.io',
                standard: 'EIP3091'
            },
            {
                name: 'Dev.storage',
                url: 'https://dev.storage',
                standard: 'none'
            },
            { name: 'Filscan', url: 'https://filscan.io', standard: 'none' },
            {
                name: 'Filscout',
                url: 'https://filscout.io/en',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmS9r9XQkMHVomWcSBNDkKkz9n87h9bH9ssabeiKZtANoU'
    },
    315: {
        name: 'WorldEcoMoney',
        chain: 'WEM',
        rpc: ['https://rpc.wemblockchain.com'],
        faucets: [],
        nativeCurrency: { name: 'WEM Coin', symbol: 'WEM', decimals: 18 },
        features: [
            { name: 'EIP155' },
            { name: 'EIP1559' },
            { name: 'Smart Contracts' },
            { name: 'Custom Gas Model' },
            { name: 'Low-Latency Transactions' }
        ],
        infoURL: 'https://worldecomoney.com',
        shortName: 'wem',
        chainId: 315,
        networkId: 315,
        icon: 'wem',
        explorers: [
            {
                name: 'wemscan',
                url: 'https://wemscan.com',
                icon: 'wemscan',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreianwjcj56pf2cwlzl4jyuarqmxs6ewmfaz2aemxl74tdbg2fumps4'
    },
    320: {
        name: 'ZKcandy Mainnet',
        chain: 'ETH',
        rpc: ['https://rpc.zkcandy.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://zkcandy.io/',
        shortName: 'zkcandy',
        chainId: 320,
        networkId: 320,
        icon: 'zkcandymainnet',
        explorers: [
            {
                name: 'ZKcandy Block Explorer',
                url: 'https://explorer.zkcandy.io',
                icon: 'zkcandymainnet',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.zkcandy.io/' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreib5jsvl6kxn2qvv4giag3l3e54d2wolo2lqbgkhivxu4cpjzi77eq'
    },
    321: {
        name: 'KCC Mainnet',
        chain: 'KCC',
        rpc: [
            'https://rpc-mainnet.kcc.network',
            'https://kcc.mytokenpocket.vip',
            'https://public-rpc.blockpi.io/http/kcc'
        ],
        faucets: [],
        nativeCurrency: { name: 'KuCoin Token', symbol: 'KCS', decimals: 18 },
        infoURL: 'https://kcc.io',
        shortName: 'kcs',
        chainId: 321,
        networkId: 321,
        slip44: 641,
        explorers: [
            {
                name: 'KCC Explorer',
                url: 'https://explorer.kcc.io/en',
                standard: 'EIP3091'
            }
        ]
    },
    322: {
        name: 'KCC Testnet',
        chain: 'KCC',
        rpc: ['https://rpc-testnet.kcc.network'],
        faucets: ['https://faucet-testnet.kcc.network'],
        nativeCurrency: {
            name: 'KuCoin Testnet Token',
            symbol: 'tKCS',
            decimals: 18
        },
        infoURL: 'https://scan-testnet.kcc.network',
        shortName: 'kcst',
        chainId: 322,
        networkId: 322,
        slip44: 1,
        explorers: [
            {
                name: 'kcc-scan-testnet',
                url: 'https://scan-testnet.kcc.network',
                standard: 'EIP3091'
            }
        ]
    },
    323: {
        name: 'Cosvm Mainnet',
        chain: 'CVM',
        rpc: ['https://rpc.cosvm.net'],
        faucets: [],
        nativeCurrency: { name: 'Cosvm', symbol: 'CVM', decimals: 18 },
        infoURL: 'https://cosvm.network',
        shortName: 'cvm',
        chainId: 323,
        networkId: 323,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.cosvm.net',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    324: {
        name: 'zkSync Mainnet',
        chain: 'ETH',
        rpc: [
            'https://mainnet.era.zksync.io',
            'https://zksync.drpc.org',
            'wss://zksync.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://zksync.io/',
        shortName: 'zksync',
        chainId: 324,
        networkId: 324,
        icon: 'zksync-era',
        explorers: [
            {
                name: 'zkSync Era Block Explorer',
                url: 'https://explorer.zksync.io',
                icon: 'zksync-era',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.zksync.io/' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmRkhUD6J3B9WhT4hEWLrcFVTrBhx3CQgNC783aJsrwxSN'
    },
    325: {
        name: 'GRVT Exchange',
        chain: 'ETH',
        rpc: ['https://rpc.grvt.io'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://grvt.io/',
        shortName: 'grvt',
        chainId: 325,
        networkId: 325,
        icon: 'grvt',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmVRdhjaBYeUVCkF8SUYMqAgGtbePYaozzy4YtMVKazLut'
    },
    326: {
        name: 'GRVT Exchange Testnet',
        chain: 'ETH',
        rpc: ['https://zkrpc.testnet.grvt.io'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://grvt.io/',
        shortName: 'grvt-sepolia',
        chainId: 326,
        networkId: 326,
        icon: 'grvt',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmVRdhjaBYeUVCkF8SUYMqAgGtbePYaozzy4YtMVKazLut'
    },
    331: {
        name: 'Telos zkEVM Testnet',
        title: 'Telos zkEVM Testnet',
        chain: 'Telos',
        rpc: ['https://zkrpc.testnet.telos.net'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia ETH', symbol: 'ETH', decimals: 18 },
        infoURL: '',
        shortName: 'telos-zkevm-testnet',
        chainId: 331,
        networkId: 331,
        icon: 'telos',
        explorers: [
            {
                name: 'TeloScan',
                icon: 'teloscan',
                url: 'https://zkexplorer.testnet.telos.net',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://zkbridge.testnet.telos.net' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreig7dmdjzvamf53drtqm452vr3evozh5zfihbk4m5vi77zwmtae5a4'
    },
    332: {
        name: 'Omax Testnet',
        chain: 'Omax Chain',
        rpc: ['https://testapi.omaxray.com'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://faucet.omaxray.com/'],
        nativeCurrency: { name: 'OMAX TESTCOIN', symbol: 'OMAX', decimals: 18 },
        infoURL: 'https://www.omaxcoin.com/',
        shortName: 'omaxt',
        chainId: 332,
        networkId: 332,
        icon: 'omaxchain',
        explorers: [
            {
                name: 'Omax Chain Explorer',
                url: 'https://testnet.omaxscan.com',
                icon: 'omaxray',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmd7omPxrehSuxHHPMYd5Nr7nfrtjKdRJQEhDLfTb87w8G'
    },
    333: {
        name: 'Web3Q Mainnet',
        chain: 'Web3Q',
        rpc: ['https://mainnet.web3q.io:8545'],
        faucets: [],
        nativeCurrency: { name: 'Web3Q', symbol: 'W3Q', decimals: 18 },
        infoURL: 'https://web3q.io/home.w3q/',
        shortName: 'w3q',
        chainId: 333,
        networkId: 333,
        explorers: [
            {
                name: 'w3q-mainnet',
                url: 'https://explorer.mainnet.web3q.io',
                standard: 'EIP3091'
            }
        ]
    },
    335: {
        name: 'DFK Chain Test',
        chain: 'DFK',
        icon: 'dfk',
        rpc: ['https://subnets.avax.network/defi-kingdoms/dfk-chain-testnet/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Jewel', symbol: 'JEWEL', decimals: 18 },
        infoURL: 'https://defikingdoms.com',
        shortName: 'DFKTEST',
        chainId: 335,
        networkId: 335,
        slip44: 1,
        explorers: [
            {
                name: 'ethernal',
                url: 'https://explorer-test.dfkchain.com',
                icon: 'ethereum',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQB48m15TzhUFrmu56QCRQjkrkgUaKfgCmKE8o3RzmuPJ'
    },
    336: {
        name: 'Shiden',
        chain: 'SDN',
        rpc: [
            'https://shiden.api.onfinality.io/public',
            'https://shiden-rpc.dwellir.com',
            'https://shiden.public.blastapi.io',
            'wss://shiden.api.onfinality.io/public-ws',
            'wss://shiden.public.blastapi.io',
            'wss://shiden-rpc.dwellir.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Shiden', symbol: 'SDN', decimals: 18 },
        infoURL: 'https://shiden.astar.network/',
        shortName: 'sdn',
        chainId: 336,
        networkId: 336,
        icon: 'shiden',
        explorers: [
            {
                name: 'subscan',
                url: 'https://shiden.subscan.io',
                standard: 'none',
                icon: 'subscan'
            },
            {
                name: 'blockscout',
                url: 'https://blockscout.com/shiden',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQySjAoWHgk3ou1yvBi2TrTcgH6KhfGiU7GcrLzrAeRkE'
    },
    337: {
        name: 'R5 Network',
        chain: 'r5',
        rpc: ['https://rpc.r5.network'],
        faucets: [],
        nativeCurrency: { name: 'R5', symbol: 'R5', decimals: 18 },
        infoURL: 'https://r5.network',
        shortName: 'r5',
        chainId: 337,
        networkId: 337,
        icon: 'r5',
        explorers: [
            {
                name: 'R5 Explorer',
                url: 'https://explorer.r5.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihrnrmjndul22scpktxzfvm6lyuxdepjtbfrn7ce4znl2blrqw6te'
    },
    338: {
        name: 'Cronos Testnet',
        chain: 'CRO',
        rpc: [
            'https://evm-t3.cronos.org',
            'https://cronos-testnet.drpc.org',
            'wss://cronos-testnet.drpc.org'
        ],
        faucets: ['https://cronos.org/faucet'],
        nativeCurrency: { name: 'Cronos Test Coin', symbol: 'TCRO', decimals: 18 },
        infoURL: 'https://cronos.org',
        shortName: 'tcro',
        chainId: 338,
        networkId: 338,
        slip44: 1,
        explorers: [
            {
                name: 'Cronos Testnet Explorer',
                url: 'https://explorer.cronos.org/testnet',
                standard: 'none'
            }
        ]
    },
    339: {
        name: 'Pencils Protocol',
        chain: 'ETH',
        rpc: [],
        faucets: [],
        nativeCurrency: {
            name: 'Pencils Protocol Token',
            symbol: 'DAPP',
            decimals: 18
        },
        infoURL: 'https://pencilsprotocol.io/',
        shortName: 'dapp',
        chainId: 339,
        networkId: 339,
        status: 'incubating'
    },
    345: {
        name: 'TSC Mainnet',
        chain: 'Trust Smart Chain',
        rpc: ['https://rpc01.trias.one'],
        faucets: [],
        nativeCurrency: { name: 'TAS', symbol: 'TAS', decimals: 18 },
        infoURL: 'https://www.trias.one',
        shortName: 'TSC',
        icon: 'netx',
        chainId: 345,
        networkId: 16,
        explorers: [
            {
                name: 'tscscan',
                url: 'https://www.tscscan.io',
                icon: 'netxscan',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYmQAo5hSr16LDeSbWbXfKdF6qa2zCoK7e88r2f7RiFdt'
    },
    360: {
        name: 'Shape',
        chain: 'ETH',
        rpc: [
            'https://mainnet.shape.network',
            'https://shape-mainnet.g.alchemy.com/public'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://shape.network',
        shortName: 'shape',
        chainId: 360,
        networkId: 360,
        icon: 'shape',
        explorers: [
            {
                name: 'shapescan',
                url: 'https://shapescan.xyz',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmUfr1ufnNJ4PcA3Jgf6jdi4ZiRFr6mPzKafwK1pSqvY9j'
    },
    361: {
        name: 'Theta Mainnet',
        chain: 'Theta',
        rpc: ['https://eth-rpc-api.thetatoken.org/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Theta Fuel', symbol: 'TFUEL', decimals: 18 },
        infoURL: 'https://www.thetatoken.org/',
        shortName: 'theta-mainnet',
        chainId: 361,
        networkId: 361,
        explorers: [
            {
                name: 'Theta Mainnet Explorer',
                url: 'https://explorer.thetatoken.org',
                standard: 'EIP3091'
            }
        ]
    },
    363: {
        name: 'Theta Sapphire Testnet',
        chain: 'Theta',
        rpc: ['https://eth-rpc-api-sapphire.thetatoken.org/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Theta Fuel', symbol: 'TFUEL', decimals: 18 },
        infoURL: 'https://www.thetatoken.org/',
        shortName: 'theta-sapphire',
        chainId: 363,
        networkId: 363,
        slip44: 1,
        explorers: [
            {
                name: 'Theta Sapphire Testnet Explorer',
                url: 'https://guardian-testnet-sapphire-explorer.thetatoken.org',
                standard: 'EIP3091'
            }
        ]
    },
    364: {
        name: 'Theta Amber Testnet',
        chain: 'Theta',
        rpc: ['https://eth-rpc-api-amber.thetatoken.org/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Theta Fuel', symbol: 'TFUEL', decimals: 18 },
        infoURL: 'https://www.thetatoken.org/',
        shortName: 'theta-amber',
        chainId: 364,
        networkId: 364,
        slip44: 1,
        explorers: [
            {
                name: 'Theta Amber Testnet Explorer',
                url: 'https://guardian-testnet-amber-explorer.thetatoken.org',
                standard: 'EIP3091'
            }
        ]
    },
    365: {
        name: 'Theta Testnet',
        chain: 'Theta',
        rpc: ['https://eth-rpc-api-testnet.thetatoken.org/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Theta Fuel', symbol: 'TFUEL', decimals: 18 },
        infoURL: 'https://www.thetatoken.org/',
        shortName: 'theta-testnet',
        chainId: 365,
        networkId: 365,
        slip44: 1,
        explorers: [
            {
                name: 'Theta Testnet Explorer',
                url: 'https://testnet-explorer.thetatoken.org',
                standard: 'EIP3091'
            }
        ]
    },
    369: {
        name: 'PulseChain',
        shortName: 'pls',
        chain: 'PLS',
        chainId: 369,
        networkId: 369,
        infoURL: 'https://pulsechain.com/',
        rpc: [
            'https://rpc.pulsechain.com',
            'wss://rpc.pulsechain.com',
            'https://pulsechain-rpc.publicnode.com',
            'wss://pulsechain-rpc.publicnode.com',
            'https://rpc-pulsechain.g4mm4.io',
            'wss://rpc-pulsechain.g4mm4.io'
        ],
        icon: 'pulsechain',
        slip44: 60,
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        ens: { registry: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e' },
        status: 'active',
        nativeCurrency: { name: 'Pulse', symbol: 'PLS', decimals: 18 },
        explorers: [
            {
                name: 'pulsechain',
                url: 'https://ipfs.scan.pulsechain.com',
                icon: 'pulsechain',
                standard: 'EIP3091'
            },
            {
                name: 'otterscan',
                url: 'https://otter.pulsechain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmckj9B9F3jWDk9bv9HwoPmfjrx2Ju8J2BQSNoPFdYGduj'
    },
    371: {
        name: 'Consta Testnet',
        chain: 'tCNT',
        rpc: ['https://rpc-testnet.theconsta.com'],
        faucets: [],
        nativeCurrency: { name: 'tCNT', symbol: 'tCNT', decimals: 18 },
        infoURL: 'http://theconsta.com',
        shortName: 'tCNT',
        chainId: 371,
        networkId: 371,
        slip44: 1,
        icon: 'constachain',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer-testnet.theconsta.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfQ1yae6uvXgBSwnwJM4Mtp8ctH66tM6mB1Hsgu4XvsC9'
    },
    380: {
        name: 'ZKAmoeba Testnet',
        chain: 'FIL',
        rpc: [
            'https://rpc.testnet.zkamoeba.com:4050/',
            'https://rpc1.testnet.zkamoeba.com:4050/'
        ],
        faucets: [],
        nativeCurrency: { name: 'filecoin', symbol: 'FIL', decimals: 18 },
        infoURL: 'https://testnet.zkamoeba.com',
        shortName: 'zkamoeba-test',
        chainId: 380,
        networkId: 380,
        icon: 'zkamoeba-micro',
        explorers: [
            {
                name: 'ZKAmoeba Test Explorer',
                url: 'https://testnetexplorer.zkamoeba.com',
                icon: 'zkamoeba-micro',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-314',
            bridges: [{ url: 'https://testnet.zkamoeba.com/en/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmRTChjmiwh9HrGsLh9qECsH7WHQAhqT5Ww8S34s8ME2Cp'
    },
    381: {
        name: 'ZKAmoeba Mainnet',
        chain: 'FIL',
        rpc: ['https://rpc.mainnet.zkamoeba.com/rpc'],
        faucets: [],
        nativeCurrency: { name: 'filecoin', symbol: 'FIL', decimals: 18 },
        infoURL: 'https://www.zkamoeba.com',
        shortName: 'zkamoeba',
        chainId: 381,
        networkId: 381,
        icon: 'zkamoeba-micro',
        explorers: [
            {
                name: 'ZKAmoeba Explorer',
                url: 'https://explorer.zkamoeba.com',
                icon: 'zkamoeba-micro',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-314',
            bridges: [{ url: 'https://www.zkamoeba.com/en/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmRTChjmiwh9HrGsLh9qECsH7WHQAhqT5Ww8S34s8ME2Cp'
    },
    385: {
        name: 'Lisinski',
        chain: 'CRO',
        rpc: ['https://rpc-bitfalls1.lisinski.online'],
        faucets: ['https://pipa.lisinski.online'],
        nativeCurrency: { name: 'Lisinski Ether', symbol: 'LISINS', decimals: 18 },
        infoURL: 'https://lisinski.online',
        shortName: 'lisinski',
        chainId: 385,
        networkId: 385
    },
    388: {
        name: 'Cronos zkEVM Mainnet',
        chain: 'CronosZkEVMMainnet',
        rpc: ['https://mainnet.zkevm.cronos.org'],
        faucets: [],
        nativeCurrency: { name: 'Cronos zkEVM CRO', symbol: 'zkCRO', decimals: 18 },
        infoURL: 'https://cronos.org/zkevm',
        shortName: 'zkCRO',
        chainId: 388,
        networkId: 388,
        explorers: [
            {
                name: 'Cronos zkEVM (Mainnet) Chain Explorer',
                url: 'https://explorer.zkevm.cronos.org',
                standard: 'none'
            }
        ]
    },
    395: {
        name: 'CamDL Testnet',
        chain: 'CADL',
        rpc: ['https://rpc1.testnet.camdl.gov.kh/'],
        faucets: ['https://faucet.testnet.camdl.gov.kh/'],
        nativeCurrency: { name: 'CADL', symbol: 'CADL', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://camdl.gov.kh/',
        shortName: 'camdl-testnet',
        chainId: 395,
        networkId: 395,
        icon: 'camdl',
        explorers: [
            {
                name: 'CamDL Testnet Explorer',
                url: 'https://explorer.testnet.camdl.gov.kh',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmW5Fpb2Ywnfqcj4ibvpbKvPv5Mo5eseWdYZnnUvLkj2Hp'
    },
    397: {
        name: 'NEAR Protocol',
        chain: 'NEAR',
        rpc: ['https://eth-rpc.mainnet.near.org'],
        icon: 'near',
        faucets: [],
        nativeCurrency: { name: 'NEAR', symbol: 'NEAR', decimals: 18 },
        infoURL: 'https://near.org',
        shortName: 'near',
        chainId: 397,
        networkId: 397,
        explorers: [
            {
                name: 'NEAR Explorer',
                url: 'https://eth-explorer.near.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiayxzdbu3e5ahri3ooieg6k6pjxrwkrkc2x5cnyadqeu5zbmaummq'
    },
    398: {
        name: 'NEAR Protocol Testnet',
        chain: 'NEAR',
        rpc: ['https://eth-rpc.testnet.near.org'],
        icon: 'near',
        faucets: [],
        nativeCurrency: { name: 'NEAR', symbol: 'NEAR', decimals: 18 },
        infoURL: 'https://near.org',
        shortName: 'near-testnet',
        chainId: 398,
        networkId: 398,
        explorers: [
            {
                name: 'NEAR Explorer',
                url: 'https://eth-explorer-testnet.near.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiayxzdbu3e5ahri3ooieg6k6pjxrwkrkc2x5cnyadqeu5zbmaummq'
    },
    399: {
        name: 'Nativ3 Mainnet',
        chainId: 399,
        shortName: 'N3',
        chain: 'Nativ3',
        icon: 'nativ3',
        networkId: 399,
        nativeCurrency: { name: 'USNT', symbol: 'USNT', decimals: 18 },
        rpc: ['https://rpc.nativ3.network', 'wss://ws.nativ3.network'],
        faucets: [],
        explorers: [
            {
                name: 'N3scan',
                url: 'https://scan.nativ3.network',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://nativ3.network',
        parent: {
            type: 'L2',
            chain: 'eip155-42161',
            bridges: [{ url: 'https://bridge.nativ3.network' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmVzJDndPui6qBSeJWe5kMLA56C3KpVhqqqk9xvVKE1DGb'
    },
    400: {
        name: 'HyperonChain TestNet',
        chain: 'HPN',
        icon: 'hyperonchain',
        rpc: ['https://testnet-rpc.hyperonchain.com'],
        faucets: ['https://faucet.hyperonchain.com'],
        nativeCurrency: { name: 'HyperonChain', symbol: 'HPN', decimals: 18 },
        infoURL: 'https://docs.hyperonchain.com',
        shortName: 'hpn',
        chainId: 400,
        networkId: 400,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet.hyperonchain.com',
                icon: 'hyperonchain',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWxhyxXTEsWH98v7M3ck4ZL1qQoUaHG4HgtgxzD2KJQ5m'
    },
    401: {
        name: 'Ozone Chain Testnet',
        chain: 'OZONE',
        rpc: ['https://node1.testnet.ozonechain.io'],
        faucets: [],
        nativeCurrency: { name: 'OZONE', symbol: 'OZO', decimals: 18 },
        infoURL: 'https://ozonechain.io',
        shortName: 'ozo_tst',
        chainId: 401,
        networkId: 401,
        slip44: 1,
        icon: 'ozonechain',
        explorers: [
            {
                name: 'OZONE Scan',
                url: 'https://testnet.ozonescan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbM4weV8Bk6c9yNhosYntkVw39SNZtCHYGgWyXTxkevZ8'
    },
    404: {
        name: 'Syndr L3',
        chainId: 404,
        shortName: 'syndr-l3',
        title: 'Syndr L3 Rollup',
        chain: 'SYNDR',
        networkId: 404,
        icon: 'syndr',
        rpc: ['https://rpc.syndr.com', 'wss://rpc.syndr.com/ws'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://syndr.com',
        explorers: [
            {
                name: 'Syndr L3 Explorer',
                url: 'https://explorer.syndr.com',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-42161',
            bridges: [{ url: 'https://bridge.syndr.com' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreibsl7iuxeibovp7uddigbus3lyse2f7n4s2lomgvf33fmgyxjwq5i'
    },
    411: {
        name: 'Pepe Chain Mainnet',
        chain: 'PC',
        status: 'active',
        icon: 'pepechain',
        rpc: ['https://rpc.pepe-chain.vip'],
        faucets: [],
        nativeCurrency: { name: 'Pepe', symbol: 'PEPE', decimals: 18 },
        infoURL: 'https://pepe-chain.vip',
        shortName: 'pepe',
        chainId: 411,
        networkId: 411,
        explorers: [
            {
                name: 'pepechain explorer',
                url: 'https://explorer.pepe-chain.vip',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibjsc3gww3moti27za2hpyq552aevux3yv5y2ntdklksyr4v4uavy'
    },
    416: {
        name: 'SX Network Mainnet',
        chain: 'SX',
        icon: 'SX',
        rpc: ['https://rpc.sx.technology'],
        faucets: [],
        nativeCurrency: { name: 'SX Network', symbol: 'SX', decimals: 18 },
        infoURL: 'https://www.sx.technology',
        shortName: 'SX',
        chainId: 416,
        networkId: 416,
        explorers: [
            {
                name: 'SX Network Explorer',
                url: 'https://explorer.sx.technology',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSXLXqyr2H6Ja5XrmznXbWTEvF2gFaL8RXNXgyLmDHjAF'
    },
    418: {
        name: 'LaTestnet',
        chain: 'LaTestnet',
        icon: 'lachain-network',
        rpc: [
            'https://rpc.testnet.lachain.network',
            'https://lachain-testnet.rpc-nodes.cedalio.dev'
        ],
        faucets: ['https://faucet.lachain.network'],
        nativeCurrency: { name: 'Test LaCoin', symbol: 'TLA', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: '',
        shortName: 'latestnet',
        chainId: 418,
        networkId: 418,
        explorers: [
            {
                name: 'LaTestnet Explorer',
                url: 'https://testexplorer.lachain.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQxGA6rhuCQDXUueVcNvFRhMEWisyTmnF57TqL7h6k6cZ'
    },
    420: {
        name: 'Optimism Goerli Testnet',
        chain: 'ETH',
        rpc: [
            'https://goerli.optimism.io',
            'https://optimism-goerli-rpc.publicnode.com',
            'wss://optimism-goerli-rpc.publicnode.com',
            'https://optimism-goerli.gateway.tenderly.co',
            'wss://optimism-goerli.gateway.tenderly.co',
            'https://optimism-testnet.drpc.org',
            'wss://optimism-testnet.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Goerli Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://optimism.io',
        shortName: 'ogor',
        chainId: 420,
        networkId: 420,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://optimism-goerli.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    422: {
        name: 'Viridis Mainnet',
        chain: 'VRD',
        icon: 'viridis',
        rpc: ['https://mainnet-rpc.vrd.network'],
        faucets: [],
        nativeCurrency: { name: 'Viridis Token', symbol: 'VRD', decimals: 18 },
        infoURL: 'https://viridis.network',
        shortName: 'vrd',
        chainId: 422,
        networkId: 422,
        explorers: [
            {
                name: 'Viridis Mainnet',
                url: 'https://explorer.vrd.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPdxcJwPogfZdec7UAqxeatRxrivEktpP1ftJBTeJQTdR'
    },
    424: {
        name: 'PGN (Public Goods Network)',
        chain: 'ETH',
        rpc: ['https://rpc.publicgoods.network'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://publicgoods.network/',
        shortName: 'PGN',
        chainId: 424,
        networkId: 424,
        icon: 'publicGoodsNetwork',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.publicgoods.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.publicgoods.network' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmUVJ7MLCEAfq3pHVPFLscqRMiyAY5biVgTkeDQCmAhHNS'
    },
    425: {
        name: 'Stenix Mainnet',
        chain: 'STEN',
        rpc: ['https://stenix.network/pub'],
        faucets: [],
        nativeCurrency: { name: 'Stenix', symbol: 'STEN', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://stenix.org',
        shortName: 'sten',
        chainId: 425,
        networkId: 425,
        icon: 'stenix',
        explorers: [
            {
                name: 'stenscan',
                url: 'https://stenscan.com',
                icon: 'stenscan',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVM1zLyWDZYyje5qWWfDdve1fmrDm69J9pSKhivb1zkCH'
    },
    426: {
        name: 'The Widows Mite',
        chain: 'MITE',
        rpc: ['https://rpc.twmcrypto.com/'],
        faucets: ['https://faucet.twmcrypto.com/'],
        nativeCurrency: { name: 'The Widows Mite', symbol: 'MITE', decimals: 8 },
        infoURL: 'https://twmcrypto.com/',
        shortName: 'mite',
        chainId: 426,
        networkId: 426,
        icon: 'mite',
        explorers: [
            {
                name: 'The Widows Mite Explorer',
                url: 'https://scan.twmcrypto.com',
                icon: 'mite',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUdrSXS4729UQGVvUYfc8S1CHnG3JpG2HhCTDmsCw6jk8'
    },
    427: {
        name: 'Zeeth Chain',
        chain: 'ZeethChain',
        rpc: ['https://rpc.zeeth.io'],
        faucets: [],
        nativeCurrency: { name: 'Zeeth Token', symbol: 'ZTH', decimals: 18 },
        infoURL: '',
        shortName: 'zeeth',
        chainId: 427,
        networkId: 427,
        explorers: [
            {
                name: 'Zeeth Explorer',
                url: 'https://explorer.zeeth.io',
                standard: 'none'
            }
        ]
    },
    428: {
        name: 'Geso Verse',
        chain: 'Geso Verse',
        rpc: ['https://rpc.verse.gesoten.com/'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://gesoten.com/',
        shortName: 'GSV',
        icon: 'gesoten',
        chainId: 428,
        networkId: 428,
        explorers: [
            {
                name: 'Geso Verse Explorer',
                url: 'https://explorer.verse.gesoten.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmb7oJY9zd9sTzxNNQNTVZQz2hkd1aA94mWm4cvXfJ9QxV'
    },
    434: {
        name: 'Boyaa Mainnet',
        chain: 'BYC',
        rpc: ['https://evm-rpc.mainnet.boyaa.network'],
        faucets: [],
        nativeCurrency: {
            name: 'Boyaa mainnet native coin',
            symbol: 'BYC',
            decimals: 18
        },
        infoURL: 'https://boyaa.network',
        shortName: 'BYC',
        chainId: 434,
        networkId: 434,
        icon: 'boyaanetwork',
        explorers: [
            {
                name: 'Boyaa explorer',
                url: 'https://explorer.mainnet.boyaa.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeiapootrvggtigdlvgvk6srfseplpuowsqq3zpyup4j5yj5moxuala'
    },
    443: {
        name: 'Ten Testnet',
        title: 'Ten Sepolia Rollup Testnet',
        chainId: 443,
        shortName: 'ten-testnet',
        chain: 'ETH',
        networkId: 443,
        slip44: 1,
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        rpc: ['https://testnet.ten.xyz'],
        faucets: [],
        infoURL: 'https://ten.xyz',
        explorers: [
            {
                name: 'Ten Sepolia Rollup Explorer',
                url: 'https://tenscan.io',
                standard: 'none'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-5',
            bridges: [{ url: 'https://bridge.ten.xyz' }]
        }
    },
    444: {
        name: 'Synapse Chain Testnet',
        status: 'active',
        chain: 'ETH',
        rpc: ['https://sepolia.synapseprotocol.com'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://synapseprotocol.com',
        shortName: 'synapse-sepolia',
        chainId: 444,
        networkId: 444,
        slip44: 1,
        redFlags: ['reusedChainId'],
        explorers: [
            {
                name: 'Synapse Chain Sepolia',
                url: 'https://sepolia.synapsescan.com',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [
                {
                    url: 'https://docs.synapseprotocol.com/synapse-chain/using-synapse-chain/bridging-to-synapse-chain'
                }
            ]
        }
    },
    456: {
        name: 'ARZIO Chain',
        chain: 'ARZIO',
        icon: 'arzio',
        rpc: ['https://chain-rpc.arzio.co'],
        faucets: [],
        nativeCurrency: { name: 'ARZIO', symbol: 'AZO', decimals: 18 },
        infoURL: 'https://chain.arzio.co',
        shortName: 'arzio',
        chainId: 456,
        networkId: 456,
        explorers: [
            {
                name: 'ARZIO Scan',
                url: 'https://scan.arzio.co',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUwqGWGjjQweTprn5LBirAwRjYnteTiFLCVpSNHrfMmSL'
    },
    462: {
        name: 'Areon Network Testnet',
        chain: 'Areon',
        icon: 'areon',
        rpc: [
            'https://testnet-rpc.areon.network',
            'https://testnet-rpc2.areon.network',
            'https://testnet-rpc3.areon.network',
            'https://testnet-rpc4.areon.network',
            'https://testnet-rpc5.areon.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Areon', symbol: 'TAREA', decimals: 18 },
        infoURL: 'https://areon.network',
        shortName: 'tarea',
        chainId: 462,
        networkId: 462,
        slip44: 1,
        explorers: [
            {
                name: 'AreonScan',
                url: 'https://areonscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihs2nrnizpcuzjmuu2yi7wrtwd7qlqje46qnil5bnntfbfkb2roea'
    },
    463: {
        name: 'Areon Network Mainnet',
        chain: 'Areon',
        icon: 'areon',
        rpc: [
            'https://mainnet-rpc.areon.network',
            'https://mainnet-rpc2.areon.network',
            'https://mainnet-rpc3.areon.network',
            'https://mainnet-rpc4.areon.network',
            'https://mainnet-rpc5.areon.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Areon', symbol: 'AREA', decimals: 18 },
        infoURL: 'https://areon.network',
        shortName: 'area',
        chainId: 463,
        networkId: 463,
        explorers: [
            {
                name: 'AreonScan',
                url: 'https://areonscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihs2nrnizpcuzjmuu2yi7wrtwd7qlqje46qnil5bnntfbfkb2roea'
    },
    466: {
        name: 'AppChain',
        chain: 'AppChain',
        rpc: ['https://rpc.appchain.xyz/http', 'wss://rpc.appchain.xyz/ws'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://appchain.xyz',
        shortName: 'appchain',
        chainId: 466,
        networkId: 466,
        icon: 'appchain',
        explorers: [
            {
                name: 'AppChain Explorer',
                url: 'https://explorer.appchain.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.appchain.xyz' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafybeigx76uxvcvet7365sjdzuxxcgl5auzck6vbbigu2jeg6ixl5k3tya'
    },
    478: {
        name: 'Form Network',
        title: 'Form Network',
        chain: 'form',
        icon: 'form',
        rpc: ['https://rpc.form.network/http', 'wss://rpc.form.network/ws'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://info.form.network',
        shortName: 'formnetwork',
        chainId: 478,
        networkId: 478,
        explorers: [
            {
                name: 'Form Explorer',
                url: 'https://explorer.form.network',
                standard: 'EIP3091',
                icon: 'form'
            }
        ],
        faucets: [],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [
                { url: 'https://bridge.form.network' },
                { url: 'https://op-bridge.form.network' }
            ]
        },
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmWrjS43miGAKEzKyNn1YajFn4zG7cDiPiaNHF1gTqKR91'
    },
    480: {
        name: 'World Chain',
        chain: 'ETH',
        rpc: [
            'https://worldchain-mainnet.g.alchemy.com/public',
            'https://480.rpc.thirdweb.com',
            'https://worldchain-mainnet.gateway.tenderly.co',
            'wss://worldchain-mainnet.gateway.tenderly.co'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://world.org/world-chain',
        shortName: 'wc',
        chainId: 480,
        networkId: 480,
        slip44: 1,
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [
                { url: 'https://world-chain.superbridge.app' },
                { url: 'https://app.across.to/bridge?destinationChainId=480' },
                { url: 'https://worldchain-mainnet.bridge.alchemy.com' }
            ]
        },
        explorers: [
            {
                name: 'etherscan',
                url: 'https://worldscan.org',
                standard: 'EIP3091'
            },
            {
                name: 'blockscout',
                url: 'https://worldchain-mainnet.explorer.alchemy.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    486: {
        name: 'Standard Mainnet',
        chain: 'STND',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Standard', symbol: 'STND', decimals: 18 },
        infoURL: 'https://standardweb3.com',
        shortName: 'stnd',
        chainId: 486,
        networkId: 486,
        status: 'incubating'
    },
    488: {
        name: 'BlackFort Exchange Network',
        chain: 'BXN',
        rpc: ['https://rpc.blackfort.network/mainnet/rpc'],
        faucets: [],
        nativeCurrency: { name: 'BlackFort Token', symbol: 'BXN', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://blackfort.com',
        shortName: 'BXN',
        chainId: 488,
        networkId: 488,
        icon: 'bxn',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blackfortscan.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPasA8xykRtJDivB2bcKDiRCUNWDPtfUTTKVAcaF2wVxC'
    },
    495: {
        name: 'Landstars',
        chain: 'Landstars',
        icon: 'landstars',
        rpc: ['https://13882-60301.pph-server.de'],
        faucets: [],
        nativeCurrency: { name: 'Landstars', symbol: 'LDS', decimals: 18 },
        infoURL: 'https://github.com/khalikov001/landstars-info',
        shortName: 'lds',
        chainId: 495,
        networkId: 495,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/bafkreibjv5chptzvncnfrro7tlx43q4um2tho7kvebdpk6fm765irfle4q'
    },
    499: {
        name: 'Rupaya',
        chain: 'RUPX',
        rpc: ['https://rpc.rupaya.io'],
        faucets: ['https://faucet.rupaya.io'],
        nativeCurrency: { name: 'Rupaya', symbol: 'RUPX', decimals: 18 },
        infoURL: 'https://www.rupaya.io',
        shortName: 'rupx',
        chainId: 499,
        networkId: 499,
        slip44: 499,
        explorers: [
            {
                name: 'Rupaya Explorer',
                url: 'https://scan.rupaya.io',
                standard: 'EIP3091'
            }
        ]
    },
    500: {
        name: 'Camino C-Chain',
        chain: 'CAM',
        rpc: ['https://api.camino.network/ext/bc/C/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Camino', symbol: 'CAM', decimals: 18 },
        infoURL: 'https://camino.network/',
        shortName: 'Camino',
        chainId: 500,
        networkId: 1000,
        icon: 'camino',
        explorers: [
            {
                name: 'blockexplorer',
                url: 'https://suite.camino.network/explorer',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSEoUonisawfCvT3osysuZzbqUEHugtgNraePKWL8PKYa'
    },
    501: {
        name: 'Columbus Test Network',
        chain: 'CAM',
        rpc: ['https://columbus.camino.network/ext/bc/C/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Camino', symbol: 'CAM', decimals: 18 },
        infoURL: 'https://camino.network/',
        shortName: 'Columbus',
        chainId: 501,
        networkId: 1001,
        slip44: 1,
        icon: 'camino',
        explorers: [
            {
                name: 'blockexplorer',
                url: 'https://suite.camino.network/explorer',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSEoUonisawfCvT3osysuZzbqUEHugtgNraePKWL8PKYa'
    },
    510: {
        name: 'Syndicate Chain',
        title: 'Syndicate Chain',
        chain: 'Syndicate',
        rpc: ['https://rpc-mainnet.syndicate.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://syndicate.io',
        shortName: 'syndicate-chain-mainnet',
        chainId: 510,
        networkId: 510,
        status: 'incubating',
        icon: 'syndicate',
        iconURL: 'https://ipfs.io/ipfs/QmeSvQcD3XvLFAiMLoQSPbGK9JxVfbCWPBUTMLhhhzYPqX'
    },
    512: {
        name: 'Double-A Chain Mainnet',
        chain: 'AAC',
        rpc: ['https://rpc.acuteangle.com'],
        faucets: [],
        nativeCurrency: {
            name: 'Acuteangle Native Token',
            symbol: 'AAC',
            decimals: 18
        },
        infoURL: 'https://www.acuteangle.com/',
        shortName: 'aac',
        chainId: 512,
        networkId: 512,
        slip44: 1512,
        explorers: [
            {
                name: 'aacscan',
                url: 'https://scan.acuteangle.com',
                standard: 'EIP3091'
            }
        ],
        icon: 'aac',
        iconURL: 'https://ipfs.io/ipfs/QmRUrz4dULaoaMpnqd8qXT7ehwz3aaqnYKY4ePsy7isGaF'
    },
    513: {
        name: 'Double-A Chain Testnet',
        chain: 'AAC',
        icon: 'aac',
        rpc: ['https://rpc-testnet.acuteangle.com'],
        faucets: ['https://scan-testnet.acuteangle.com/faucet'],
        nativeCurrency: {
            name: 'Acuteangle Native Token',
            symbol: 'AAC',
            decimals: 18
        },
        infoURL: 'https://www.acuteangle.com/',
        shortName: 'aact',
        chainId: 513,
        networkId: 513,
        slip44: 1,
        explorers: [
            {
                name: 'aacscan-testnet',
                url: 'https://scan-testnet.acuteangle.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRUrz4dULaoaMpnqd8qXT7ehwz3aaqnYKY4ePsy7isGaF'
    },
    516: {
        name: 'Gear Zero Network Mainnet',
        chain: 'GearZero',
        rpc: ['https://gzn.linksme.info'],
        faucets: [],
        nativeCurrency: {
            name: 'Gear Zero Network Native Token',
            symbol: 'GZN',
            decimals: 18
        },
        infoURL: 'https://token.gearzero.ca/mainnet',
        shortName: 'gz-mainnet',
        chainId: 516,
        networkId: 516,
        slip44: 516,
        explorers: []
    },
    520: {
        name: 'XT Smart Chain Mainnet',
        chain: 'XSC',
        icon: 'xsc',
        rpc: [
            'https://datarpc1.xsc.pub',
            'https://datarpc2.xsc.pub',
            'https://datarpc3.xsc.pub'
        ],
        faucets: ['https://xsc.pub/faucet'],
        nativeCurrency: {
            name: 'XT Smart Chain Native Token',
            symbol: 'XT',
            decimals: 18
        },
        infoURL: 'https://xsc.pub/',
        shortName: 'xt',
        chainId: 520,
        networkId: 1024,
        explorers: [
            {
                name: 'xscscan',
                url: 'https://xscscan.pub',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNmAFgQKkjofaBR5mhB5ygE1Gna36YBVsGkgZQxrwW85s'
    },
    529: {
        name: 'Firechain Mainnet',
        chain: 'FIRE',
        rpc: [
            'https://rpc-mainnet.thefirechain.com',
            'https://rpc-mainnet.firestation.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'Firechain', symbol: 'FIRE', decimals: 18 },
        infoURL: 'https://thefirechain.com',
        shortName: 'fire',
        chainId: 529,
        networkId: 529,
        icon: 'firechain',
        explorers: [],
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmYjuztyURb3Fc6ZTLgCbwQa64CcVoigF5j9cafzuSbqgf'
    },
    530: {
        name: 'Pundi AIFX Omnilayer',
        chain: 'PUNDIAI',
        rpc: ['https://fx-json-web3.functionx.io:8545'],
        faucets: [],
        nativeCurrency: { name: 'Pundi AIFX', symbol: 'PUNDAI', decimals: 18 },
        infoURL: 'https://fx.pundi.ai/',
        shortName: 'pundiai',
        chainId: 530,
        networkId: 530,
        icon: 'pundiai',
        explorers: [
            {
                name: 'PundiScan Explorer',
                url: 'https://pundiscan.io/evm',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUve9vX4k6rtTX5dJZhXTGBGUosFccMZL9E349gdTHNkV'
    },
    534: {
        name: 'Candle',
        chain: 'Candle',
        rpc: ['https://candle-rpc.com/', 'https://rpc.cndlchain.com'],
        faucets: [],
        nativeCurrency: { name: 'CANDLE', symbol: 'CNDL', decimals: 18 },
        infoURL: 'https://candlelabs.org/',
        shortName: 'CNDL',
        chainId: 534,
        networkId: 534,
        slip44: 674,
        explorers: [
            {
                name: 'candleexplorer',
                url: 'https://candleexplorer.com',
                standard: 'EIP3091'
            }
        ]
    },
    537: {
        name: 'OpTrust Mainnet',
        chain: 'OpTrust',
        rpc: ['https://rpc.optrust.io'],
        faucets: [],
        nativeCurrency: { name: 'BSC', symbol: 'BNB', decimals: 18 },
        infoURL: 'https://optrust.io',
        shortName: 'optrust',
        chainId: 537,
        networkId: 537,
        icon: 'optrust',
        explorers: [
            {
                name: 'OpTrust explorer',
                url: 'https://scan.optrust.io',
                icon: 'optrust',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYktPMo4tdQhMA9nRJBVckjzHcFLbpHbTVNSpGUUPEP8J'
    },
    542: {
        name: 'PAWCHAIN Testnet',
        chain: 'PAW',
        rpc: ['https://pawchainx.com/'],
        faucets: [],
        nativeCurrency: { name: 'PAW', symbol: 'PAW', decimals: 18 },
        infoURL: 'https://pawchainx.com/',
        shortName: 'PAW',
        chainId: 542,
        networkId: 542,
        slip44: 1,
        explorers: [
            {
                name: 'PAWCHAIN Testnet',
                url: 'https://pawscan.io',
                standard: 'none'
            }
        ]
    },
    545: {
        name: 'Flow EVM Testnet',
        chain: 'Flow',
        rpc: ['https://testnet.evm.nodes.onflow.org'],
        faucets: ['https://faucet.flow.com/fund-account'],
        nativeCurrency: { name: 'FLOW', symbol: 'FLOW', decimals: 18 },
        infoURL: 'https://developers.flow.com/evm/about',
        shortName: 'flow-testnet',
        chainId: 545,
        networkId: 545,
        icon: 'flowevm',
        explorers: [
            {
                name: 'FlowScan Testnet',
                url: 'https://evm-testnet.flowscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQFugEvsfU3ARjjJ7YRLJwSxMfTk54WWzrofekTRBKFaC'
    },
    550: {
        name: 'River',
        chain: 'river',
        rpc: [
            'https://mainnet.rpc.river.build',
            'https://towns-mainnet.calderachain.xyz/http'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.river.build',
        shortName: 'river',
        chainId: 550,
        networkId: 550,
        icon: 'river',
        explorers: [
            {
                name: 'River Explorer',
                url: 'https://explorer.river.build',
                standard: 'EIP3091'
            },
            {
                name: 'River Caldera Explorer',
                url: 'https://towns-mainnet.calderaexplorer.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiafftbrpywlc4awvbgbdau4bpd5rg27za4eyh7somqw5pv755gbmq'
    },
    555: {
        name: 'Vela1 Chain Mainnet',
        chain: 'VELA1',
        rpc: ['https://rpc.velaverse.io'],
        faucets: [],
        nativeCurrency: { name: 'CLASS COIN', symbol: 'CLASS', decimals: 18 },
        infoURL: 'https://velaverse.io',
        shortName: 'CLASS',
        chainId: 555,
        networkId: 555,
        explorers: [
            {
                name: 'Vela1 Chain Mainnet Explorer',
                url: 'https://exp.velaverse.io',
                standard: 'EIP3091'
            }
        ]
    },
    558: {
        name: 'Tao Network',
        chain: 'TAO',
        rpc: [
            'https://rpc.testnet.tao.network',
            'http://rpc.testnet.tao.network:8545',
            'https://rpc.tao.network',
            'wss://rpc.tao.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Tao', symbol: 'TAO', decimals: 18 },
        infoURL: 'https://tao.network',
        shortName: 'tao',
        chainId: 558,
        networkId: 558
    },
    565: {
        name: 'Prometheuz Testnet',
        chain: 'Prometheuz',
        rpc: ['https://explorer.testnet.prometheuz.io'],
        faucets: ['https://faucet.testnet.prometheuz.io'],
        nativeCurrency: { name: 'Pyre', symbol: 'PYRE', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: '',
        shortName: 'prometheuz-testnet',
        chainId: 565,
        networkId: 565,
        explorers: [
            {
                name: 'Prometheuz Explorer',
                url: 'https://explorer.testnet.prometheuz.io',
                standard: 'none'
            }
        ]
    },
    568: {
        name: 'Dogechain Testnet',
        chain: 'DC',
        icon: 'dogechain',
        rpc: ['https://rpc-testnet.dogechain.dog'],
        faucets: ['https://faucet.dogechain.dog'],
        nativeCurrency: { name: 'Dogecoin', symbol: 'DOGE', decimals: 18 },
        infoURL: 'https://dogechain.dog',
        shortName: 'dct',
        chainId: 568,
        networkId: 568,
        slip44: 1,
        explorers: [
            {
                name: 'dogechain testnet explorer',
                url: 'https://explorer-testnet.dogechain.dog',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNS6B6L8FfgGSMTEi2SxD3bK5cdmKPNtQKcYaJeRWrkHs'
    },
    570: {
        name: 'Rollux Mainnet',
        chain: 'SYS',
        rpc: [
            'https://rpc.rollux.com',
            'wss://rpc.rollux.com/wss',
            'https://rpc.ankr.com/rollux'
        ],
        faucets: ['https://rollux.id/faucet'],
        nativeCurrency: { name: 'Syscoin', symbol: 'SYS', decimals: 18 },
        infoURL: 'https://rollux.com',
        shortName: 'sys-rollux',
        chainId: 570,
        networkId: 570,
        explorers: [
            {
                name: 'Rollux Mainnet Explorer',
                url: 'https://explorer.rollux.com',
                standard: 'EIP3091'
            }
        ]
    },
    571: {
        name: 'MetaChain Mainnet',
        chain: 'MTC',
        icon: 'metachain',
        rpc: ['https://rpc.metatime.com'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Metatime Coin', symbol: 'MTC', decimals: 18 },
        infoURL: 'https://metatime.com/en',
        shortName: 'metatime',
        chainId: 571,
        networkId: 571,
        slip44: 571,
        explorers: [
            {
                name: 'MetaExplorer',
                url: 'https://explorer.metatime.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUH2Ph2hW4upvevEAGCaSo7nd8nthqMx5RrHcrnNZ9Y3g'
    },
    579: {
        name: 'Filenova Mainnet',
        chain: 'Filenova',
        rpc: ['https://rpc.filenova.org'],
        faucets: [],
        nativeCurrency: { name: 'Filecoin', symbol: 'FIL', decimals: 18 },
        infoURL: 'https://filenova.org',
        shortName: 'filenova',
        chainId: 579,
        networkId: 579,
        icon: 'filenova',
        explorers: [
            {
                name: 'filenova explorer',
                url: 'https://scan.filenova.org',
                icon: 'filenova',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmc4KSKiAChhtN7ZNE5gvkLTRbvtLreKU9xaQFG8BKM8RE'
    },
    588: {
        name: 'Metis Stardust Testnet',
        chain: 'ETH',
        rpc: ['https://stardust.metis.io/?owner=588'],
        faucets: [],
        nativeCurrency: { name: 'tMetis', symbol: 'METIS', decimals: 18 },
        infoURL: 'https://www.metis.io',
        shortName: 'metis-stardust',
        chainId: 588,
        networkId: 588,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://stardust-explorer.metis.io',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-4',
            bridges: [{ url: 'https://bridge.metis.io' }]
        },
        status: 'deprecated'
    },
    592: {
        name: 'Astar',
        chain: 'ASTR',
        rpc: ['https://rpc.astar.network:8545'],
        faucets: [],
        nativeCurrency: { name: 'Astar', symbol: 'ASTR', decimals: 18 },
        infoURL: 'https://astar.network/',
        shortName: 'astr',
        chainId: 592,
        networkId: 592,
        icon: 'astar',
        explorers: [
            {
                name: 'subscan',
                url: 'https://astar.subscan.io',
                standard: 'none',
                icon: 'subscan'
            },
            {
                name: 'blockscout',
                url: 'https://blockscout.com/astar',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmdvmx3p6gXBCLUMU1qivscaTNkT6h3URdhUTZCHLwKudg'
    },
    595: {
        name: 'Acala Mandala Testnet TC9',
        chain: 'mACA',
        rpc: [
            'https://eth-rpc-tc9.aca-staging.network',
            'wss://eth-rpc-tc9.aca-staging.network'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: {
            name: 'Acala Mandala Token',
            symbol: 'mACA',
            decimals: 18
        },
        infoURL: 'https://acala.network',
        shortName: 'maca',
        chainId: 595,
        networkId: 595,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.mandala.aca-staging.network',
                standard: 'EIP3091'
            }
        ]
    },
    596: {
        name: 'Karura Network Testnet',
        chain: 'KAR',
        rpc: [
            'https://eth-rpc-karura-testnet.aca-staging.network',
            'wss://eth-rpc-karura-testnet.aca-staging.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Karura Token', symbol: 'KAR', decimals: 18 },
        infoURL: 'https://karura.network',
        shortName: 'tkar',
        chainId: 596,
        networkId: 596,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.karura-testnet.aca-staging.network',
                standard: 'EIP3091'
            }
        ]
    },
    597: {
        name: 'Acala Network Testnet',
        chain: 'ACA',
        rpc: [
            'https://eth-rpc-acala-testnet.aca-staging.network',
            'wss://eth-rpc-acala-testnet.aca-staging.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Acala Token', symbol: 'ACA', decimals: 18 },
        infoURL: 'https://acala.network',
        shortName: 'taca',
        chainId: 597,
        networkId: 597,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.acala-dev.aca-dev.network',
                standard: 'EIP3091'
            }
        ]
    },
    599: {
        name: 'Metis Goerli Testnet',
        chain: 'ETH',
        rpc: ['https://goerli.gateway.metisdevops.link'],
        faucets: ['https://goerli.faucet.metisdevops.link'],
        nativeCurrency: { name: 'Goerli Metis', symbol: 'METIS', decimals: 18 },
        infoURL: 'https://www.metis.io',
        shortName: 'metis-goerli',
        chainId: 599,
        networkId: 599,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://goerli.explorer.metisdevops.link',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-4',
            bridges: [{ url: 'https://testnet-bridge.metis.io' }]
        },
        status: 'deprecated'
    },
    600: {
        name: 'Meshnyan testnet',
        chain: 'MeshTestChain',
        rpc: [],
        faucets: [],
        nativeCurrency: {
            name: 'Meshnyan Testnet Native Token',
            symbol: 'MESHT',
            decimals: 18
        },
        infoURL: '',
        shortName: 'mesh-chain-testnet',
        chainId: 600,
        networkId: 600,
        slip44: 1
    },
    601: {
        name: 'Vine Testnet',
        chain: 'VINE',
        rpc: ['https://rpc-testnet.vne.network'],
        faucets: ['https://vne.network/rose'],
        nativeCurrency: { name: 'VINE', symbol: 'VNE', decimals: 18 },
        infoURL: 'https://www.peer.inc',
        shortName: 'VINE',
        chainId: 601,
        networkId: 601,
        icon: 'vine',
        explorers: [
            {
                name: 'Vine Explorer',
                url: 'https://vne.network/rose',
                standard: 'none',
                icon: 'vine'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTPbbhH4CkQiQWm4JUh3J9o5w79vXjFZaMBW4DKNuSVU3'
    },
    610: {
        name: 'Darwin Devnet',
        chain: 'Darwin',
        rpc: ['https://devnet-rpc.darwinchain.ai'],
        faucets: ['https://devnet-rpc.darwinchain.ai/faucet'],
        nativeCurrency: {
            name: 'Darwin Devnet token',
            symbol: 'DNA',
            decimals: 18
        },
        infoURL: 'https://darwinchain.ai',
        shortName: 'darwin-devnet',
        chainId: 610,
        networkId: 610,
        icon: 'darwin',
        explorers: [
            {
                name: 'Darwin Explorer',
                url: 'https://explorer.darwinchain.ai',
                icon: 'darwin',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiec5zeuhb4tkbhvbrmeeqrsqtjbhrjfpqx4yysejephiczresf5ci'
    },
    612: {
        name: 'EIOB Mainnet',
        chain: 'EIOB',
        icon: 'eiob',
        rpc: ['https://rpc.eiob.xyz'],
        faucets: [],
        nativeCurrency: { name: 'EIOB', symbol: 'EIOB', decimals: 18 },
        infoURL: '',
        shortName: 'eiob',
        chainId: 612,
        networkId: 612,
        explorers: [
            {
                name: 'EIOB Explorer',
                url: 'https://explorer.eiob.xyz',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfJLG2mXgSqKx2V3A2jzTwt4vkozvQTTXkRy3os27wEVm'
    },
    614: {
        name: 'Graphlinq Blockchain Mainnet',
        chain: 'GLQ Blockchain',
        rpc: ['https://glq-dataseed.graphlinq.io'],
        faucets: [],
        nativeCurrency: { name: 'GLQ', symbol: 'GLQ', decimals: 18 },
        infoURL: 'https://graphlinq.io',
        shortName: 'glq',
        chainId: 614,
        networkId: 614,
        explorers: [
            {
                name: 'GLQ Explorer',
                url: 'https://explorer.graphlinq.io',
                standard: 'none'
            }
        ]
    },
    619: {
        name: 'Skynet',
        chain: 'Skynet',
        rpc: ['http://rpc.skynet.io'],
        nativeCurrency: { name: 'SkyUSD', symbol: 'sUSD', decimals: 18 },
        infoURL: 'http://explorer.skynet.io',
        shortName: 'Skynet',
        chainId: 619,
        networkId: 619,
        explorers: [
            {
                name: 'tracehawk',
                url: 'http://explorer.skynet.io',
                standard: 'none'
            }
        ],
        faucets: [],
        parent: {
            type: 'L2',
            chain: 'eip155-42161',
            bridges: [{ url: 'http://bridge.skynet.io' }]
        }
    },
    624: {
        name: 'Binary Mainnet',
        chain: 'The Binary Holdings',
        rpc: ['https://rpc.zero.thebinaryholdings.com'],
        faucets: [],
        nativeCurrency: { name: 'Binary Token', symbol: 'BNRY', decimals: 18 },
        infoURL: '',
        shortName: 'thebinaryholdings-mainnet',
        chainId: 624,
        networkId: 624,
        explorers: [
            {
                name: 'Tracehawk',
                url: 'https://explorer.thebinaryholdings.com',
                standard: 'none'
            }
        ]
    },
    625: {
        name: 'Binary Sepolia',
        chain: 'The Binary Holdings',
        rpc: ['https://rpc.testnet.thebinaryholdings.com'],
        faucets: [],
        nativeCurrency: { name: 'Test BNRY', symbol: 'BNRY', decimals: 18 },
        infoURL: '',
        shortName: 'thebinaryholdings-sepolia',
        chainId: 625,
        networkId: 625,
        explorers: [
            {
                name: 'Tracehawk',
                url: 'https://explorer.sepolia.thebinaryholdings.com',
                standard: 'none'
            }
        ]
    },
    632: {
        name: 'NFB Chain',
        chain: 'NFB Chain',
        rpc: ['https://node.nfbchain.com'],
        faucets: [],
        nativeCurrency: { name: 'NFBCoin', symbol: 'NFBC', decimals: 18 },
        infoURL: 'https://nfbchain.com/',
        shortName: 'nfbchain',
        chainId: 632,
        networkId: 632,
        explorers: [
            {
                name: 'NFB Chain Explorer',
                url: 'https://scan.nfbchain.com',
                standard: 'none'
            }
        ]
    },
    634: {
        name: 'Avocado',
        chain: 'Avocado',
        rpc: ['https://rpc.avocado.instadapp.io'],
        faucets: [],
        nativeCurrency: { name: 'USDC', symbol: 'USDC', decimals: 18 },
        infoURL: 'https://avocado.instadapp.io',
        shortName: 'avocado',
        chainId: 634,
        networkId: 634,
        icon: 'avocado',
        explorers: [
            {
                name: 'avoscan',
                url: 'https://avoscan.co',
                icon: 'avocado',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qma9rJSgy32UL1iXtXKFZQJA6FjkcUcDU4HR6y13Wu1vjn'
    },
    646: {
        name: 'Flow EVM Previewnet',
        chain: 'Flow',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'FLOW', symbol: 'FLOW', decimals: 18 },
        infoURL: 'https://developers.flow.com/evm/about',
        shortName: 'flow-previewnet',
        chainId: 646,
        networkId: 646,
        icon: 'flowevm',
        explorers: [],
        status: 'deprecated',
        iconURL: 'https://ipfs.io/ipfs/QmQFugEvsfU3ARjjJ7YRLJwSxMfTk54WWzrofekTRBKFaC'
    },
    647: {
        name: 'SX Network Testnet',
        chain: 'SX',
        icon: 'SX',
        rpc: ['https://rpc.toronto.sx.technology'],
        faucets: ['https://faucet.toronto.sx.technology'],
        nativeCurrency: { name: 'SX Network', symbol: 'SX', decimals: 18 },
        infoURL: 'https://www.sx.technology',
        shortName: 'SX-Testnet',
        chainId: 647,
        networkId: 647,
        slip44: 1,
        explorers: [
            {
                name: 'SX Network Toronto Explorer',
                url: 'https://explorer.toronto.sx.technology',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSXLXqyr2H6Ja5XrmznXbWTEvF2gFaL8RXNXgyLmDHjAF'
    },
    648: {
        name: 'Endurance Smart Chain Mainnet',
        chain: 'ACE',
        rpc: ['https://rpc-endurance.fusionist.io/'],
        faucets: [],
        nativeCurrency: {
            name: 'Endurance Chain Native Token',
            symbol: 'ACE',
            decimals: 18
        },
        infoURL: 'https://ace.fusionist.io/',
        shortName: 'ace',
        chainId: 648,
        networkId: 648,
        explorers: [
            {
                name: 'Endurance Scan',
                url: 'https://explorer.endurance.fusionist.io',
                standard: 'EIP3091'
            }
        ]
    },
    653: {
        name: 'Kalichain Testnet',
        chain: 'Kalichain',
        rpc: ['https://rpc.kalichain.com'],
        faucets: [],
        nativeCurrency: { name: 'kalis', symbol: 'KALIS', decimals: 18 },
        infoURL: 'https://kalichain.com',
        shortName: 'kalichain',
        chainId: 653,
        networkId: 653,
        icon: 'kalichain',
        explorers: [
            {
                name: 'kalichain explorer',
                url: 'https://explorer.kalichain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreieox7v337p3jfhd37dz74mq6mn3uk5i5475rmzpirmyp6ydcfzzqi'
    },
    654: {
        name: 'Kalichain',
        chain: 'Kalichain',
        rpc: ['https://mainnet.kalichain.com'],
        faucets: [],
        nativeCurrency: { name: 'kalis', symbol: 'KALIS', decimals: 18 },
        infoURL: 'https://kalichain.com',
        shortName: 'kalichainMainnet',
        chainId: 654,
        networkId: 654,
        icon: 'kalichain',
        explorers: [
            {
                name: 'kalichain explorer',
                url: 'https://explorer.kalichain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreieox7v337p3jfhd37dz74mq6mn3uk5i5475rmzpirmyp6ydcfzzqi'
    },
    662: {
        name: 'AmaxSmartchain',
        chain: 'AmaxSmartchain',
        rpc: ['https://rpc.amaxchain.io'],
        faucets: [],
        nativeCurrency: { name: 'amax', symbol: 'AMAX', decimals: 18 },
        infoURL: 'https://amaxchain.io',
        shortName: 'Amaxsmartchain',
        chainId: 662,
        networkId: 662,
        icon: 'ultronsmartchain',
        explorers: [
            {
                name: 'Amaxsmartchain explorer',
                url: 'https://scan.amaxchain.io',
                standard: 'EIP3091'
            }
        ],
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/QmTns2FXAqDCq1QJsocUBGjhxsgWYK7pFfD4UrRZ9JBsF1'
    },
    666: {
        name: 'Pixie Chain Testnet',
        chain: 'PixieChain',
        rpc: [
            'https://http-testnet.chain.pixie.xyz',
            'wss://ws-testnet.chain.pixie.xyz'
        ],
        faucets: ['https://chain.pixie.xyz/faucet'],
        nativeCurrency: {
            name: 'Pixie Chain Testnet Native Token',
            symbol: 'PCTT',
            decimals: 18
        },
        infoURL: 'https://scan-testnet.chain.pixie.xyz',
        shortName: 'pixie-chain-testnet',
        chainId: 666,
        networkId: 666,
        slip44: 1
    },
    667: {
        name: 'LAOS Arrakis',
        title: 'LAOS Testnet Arrakis',
        chain: 'LAOS',
        icon: 'laos',
        rpc: [
            'https://arrakis.gorengine.com/own',
            'wss://arrakis.gorengine.com/own'
        ],
        faucets: [],
        nativeCurrency: { name: 'LAOS', symbol: 'LAOS', decimals: 18 },
        infoURL: 'https://www.laosfoundation.io/',
        shortName: 'laos',
        chainId: 667,
        networkId: 667,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://arrakis.gorengine.com',
                icon: 'laos',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZ4YYcvhcaeotMPaGXC5Vab7JFaVkka37V8TiTJpT7Mak'
    },
    668: {
        name: 'JuncaChain',
        chain: 'JuncaChain',
        rpc: ['https://rpc.juncachain.com'],
        nativeCurrency: {
            name: 'JuncaChain Native Token',
            symbol: 'JGC',
            decimals: 18
        },
        faucets: [],
        infoURL: 'https://junca-cash.world',
        shortName: 'junca',
        chainId: 668,
        networkId: 668,
        explorers: [
            {
                name: 'JuncaScan',
                url: 'https://scan.juncachain.com',
                standard: 'EIP3091'
            }
        ]
    },
    669: {
        name: 'JuncaChain testnet',
        chain: 'JuncaChain testnet',
        rpc: [
            'https://rpc-testnet.juncachain.com',
            'wss://ws-testnet.juncachain.com'
        ],
        faucets: ['https://faucet-testnet.juncachain.com'],
        nativeCurrency: {
            name: 'JuncaChain Testnet Native Token',
            symbol: 'JGCT',
            decimals: 18
        },
        infoURL: 'https://junca-cash.world',
        shortName: 'juncat',
        chainId: 669,
        networkId: 669,
        slip44: 1,
        explorers: [
            {
                name: 'JuncaScan',
                url: 'https://scan-testnet.juncachain.com',
                standard: 'EIP3091'
            }
        ]
    },
    678: {
        name: 'Janction',
        chain: 'Janction',
        rpc: ['https://rpc.janction.io', 'wss://rpc.janction.io'],
        faucets: [],
        nativeCurrency: { name: 'Janction', symbol: 'JCT', decimals: 18 },
        infoURL: 'https://janction.io',
        shortName: 'janction',
        chainId: 678,
        networkId: 678,
        icon: 'janction',
        explorers: [],
        parent: { type: 'L2', chain: 'eip155-1', bridges: [] },
        iconURL: 'https://ipfs.io/ipfs/bafkreieemyhmsjo3a3aghqcwcitqwdxt7fxtsz4tmvlu2io3hcbtetyg6e'
    },
    679: {
        name: 'Janction Testnet',
        chain: 'Janction Testnet',
        rpc: ['https://rpc_testnet.janction.io', 'wss://rpc_testnet.janction.io'],
        faucets: [],
        nativeCurrency: { name: 'Janction', symbol: 'JCT', decimals: 18 },
        infoURL: 'https://janction.io',
        shortName: 'janction_testnet',
        chainId: 679,
        networkId: 679,
        icon: 'janction',
        explorers: [],
        parent: { type: 'L2', chain: 'eip155-1', bridges: [] },
        iconURL: 'https://ipfs.io/ipfs/bafkreieemyhmsjo3a3aghqcwcitqwdxt7fxtsz4tmvlu2io3hcbtetyg6e'
    },
    686: {
        name: 'Karura Network',
        chain: 'KAR',
        rpc: [
            'https://eth-rpc-karura.aca-api.network',
            'wss://eth-rpc-karura.aca-api.network'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Karura Token', symbol: 'KAR', decimals: 18 },
        infoURL: 'https://acala.network/karura',
        shortName: 'kar',
        chainId: 686,
        networkId: 686,
        slip44: 686,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.karura.network',
                standard: 'EIP3091'
            }
        ]
    },
    689: {
        name: 'NERO Testnet',
        chain: 'NERO Chain',
        rpc: ['https://rpc-testnet.nerochain.io', 'wss://ws-testnet.nerochain.io'],
        faucets: ['https://faucet-testnet.nerochain.io'],
        nativeCurrency: { name: 'NERO', symbol: 'NERO', decimals: 18 },
        infoURL: 'https://docs.nerochain.io/',
        shortName: 'NEROT',
        chainId: 689,
        networkId: 689,
        slip44: 1,
        icon: 'nero',
        explorers: [
            {
                name: 'nero testnet scan',
                url: 'https://testnet.neroscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdkENLFjLRNts2kBspNbM3q84WjG5Yf7C8amVVr7FCQrp'
    },
    690: {
        name: 'Redstone',
        chain: 'ETH',
        rpc: ['https://rpc.redstonechain.com', 'wss://rpc.redstonechain.com'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://redstone.xyz',
        shortName: 'redstone',
        chainId: 690,
        networkId: 690,
        icon: 'redstone',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.redstone.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://redstone.xyz/deposit' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreieyaqgkgntvxuo5tnhgseladga5q6gutc37dab7kqqfdguhq7vkxq'
    },
    698: {
        name: 'Matchain',
        chain: 'Matchain',
        icon: 'matchain',
        rpc: ['https://rpc.matchain.io'],
        faucets: [],
        nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
        infoURL: 'https://www.matchain.io',
        shortName: 'Matchain',
        chainId: 698,
        networkId: 698,
        slip44: 714,
        explorers: [
            {
                name: 'Matchscan',
                url: 'https://matchscan.io',
                icon: 'matchain',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-56',
            bridges: [{ url: 'https://bnb-bridge.matchain.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmdGWNf6Tmq7Wn4TbJEDBHMZCGfYgsvmmYnFqYdE4CJTRn'
    },
    699: {
        name: 'Matchain Testnet',
        chain: 'Matchain',
        icon: 'matchain',
        rpc: ['https://testnet-rpc.matchain.io'],
        faucets: [],
        nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 },
        infoURL: 'https://www.matchain.io',
        shortName: 'tMatchain',
        chainId: 699,
        networkId: 699,
        explorers: [
            {
                name: 'Matchscan Testnet',
                url: 'https://testnet.matchscan.io',
                standard: 'EIP3091',
                icon: 'matchain'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdGWNf6Tmq7Wn4TbJEDBHMZCGfYgsvmmYnFqYdE4CJTRn'
    },
    700: {
        name: 'Star Social Testnet',
        chain: 'SNS',
        rpc: ['https://avastar.cc/ext/bc/C/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Social', symbol: 'SNS', decimals: 18 },
        infoURL: 'https://info.avastar.cc',
        shortName: 'SNS',
        chainId: 700,
        networkId: 700,
        slip44: 1,
        explorers: [
            {
                name: 'starscan',
                url: 'https://avastar.info',
                standard: 'EIP3091'
            }
        ]
    },
    701: {
        name: 'Darwinia Koi Testnet',
        chain: 'Darwinia Koi',
        rpc: ['https://koi-rpc.darwinia.network'],
        faucets: [],
        nativeCurrency: {
            name: 'Koi Network Native Token',
            symbol: 'KRING',
            decimals: 18
        },
        infoURL: 'https://darwinia.network/',
        shortName: 'darwinia-koi',
        chainId: 701,
        networkId: 701,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://koi-scan.darwinia.network',
                standard: 'EIP3091'
            }
        ]
    },
    707: {
        name: 'BlockChain Station Mainnet',
        chain: 'BCS',
        rpc: ['https://rpc-mainnet.bcsdev.io', 'wss://rpc-ws-mainnet.bcsdev.io'],
        faucets: [],
        nativeCurrency: { name: 'BCS Token', symbol: 'BCS', decimals: 18 },
        infoURL: 'https://blockchainstation.io',
        shortName: 'bcs',
        chainId: 707,
        networkId: 707,
        explorers: [
            {
                name: 'BlockChain Station Explorer',
                url: 'https://explorer.bcsdev.io',
                standard: 'EIP3091'
            }
        ]
    },
    708: {
        name: 'BlockChain Station Testnet',
        chain: 'BCS',
        rpc: ['https://rpc-testnet.bcsdev.io', 'wss://rpc-ws-testnet.bcsdev.io'],
        faucets: ['https://faucet.bcsdev.io'],
        nativeCurrency: { name: 'BCS Testnet Token', symbol: 'tBCS', decimals: 18 },
        infoURL: 'https://blockchainstation.io',
        shortName: 'tbcs',
        chainId: 708,
        networkId: 708,
        slip44: 1,
        explorers: [
            {
                name: 'BlockChain Station Explorer',
                url: 'https://testnet.bcsdev.io',
                standard: 'EIP3091'
            }
        ]
    },
    710: {
        name: 'Highbury',
        chain: 'HIGHBURY',
        rpc: ['https://highbury.furya.io', 'https://rest.furya.io'],
        faucets: [],
        nativeCurrency: { name: 'Fury', symbol: 'FURY', decimals: 18 },
        infoURL: 'https://www.fury.black',
        shortName: 'fury',
        chainId: 710,
        networkId: 710,
        icon: 'highbury',
        explorers: [
            {
                name: 'Furya EVM Explorer',
                url: 'https://explorer.furya.io',
                standard: 'EIP3091',
                icon: 'highbury'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiby27m6esbsjthmknckq5ktsaaj2z6hylzljbsmvx4fgezdra3q4m'
    },
    711: {
        name: 'Tucana',
        chain: 'Tucana',
        title: 'Tucana Testnet',
        rpc: ['https://evm-rpc.tucana.zone', 'wss://evm-ws.tucana.zone'],
        faucets: [],
        nativeCurrency: { name: 'Tucana', symbol: 'TUC', decimals: 18 },
        infoURL: 'https://tucana.zone',
        shortName: 'tuc',
        chainId: 711,
        networkId: 711,
        slip44: 1,
        icon: 'tucana',
        explorers: [
            {
                name: 'Tucana Explorer',
                url: 'https://explorer.tucana.zone',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmb7SKBSBusnRy77HsaEsSWNwyXVwuzbM4duxCLtjWZhT8'
    },
    712: {
        name: 'Birdee-2',
        chain: 'Tucana',
        title: 'Tucana Testnet',
        rpc: [
            'https://evm-rpc.birdee-2.tucana.zone',
            'wss://evm-ws.birdee-2.tucana.zone'
        ],
        faucets: [],
        nativeCurrency: { name: 'Tucana', symbol: 'TUC', decimals: 18 },
        infoURL: 'https://tucana.zone',
        shortName: 'birdee-2',
        chainId: 712,
        networkId: 712,
        slip44: 1,
        icon: 'tucana',
        explorers: [
            {
                name: 'Birdee-2 Explorer',
                url: 'https://explorer.birdee-2.tucana.zone',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmb7SKBSBusnRy77HsaEsSWNwyXVwuzbM4duxCLtjWZhT8'
    },
    713: {
        name: 'Vrcscan Mainnet',
        chain: 'VRC',
        rpc: [
            'https://rpc-mainnet-5.vrcscan.com',
            'https://rpc-mainnet-6.vrcscan.com',
            'https://rpc-mainnet-7.vrcscan.com',
            'https://rpc-mainnet-8.vrcscan.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'VRC Chain', symbol: 'VRC', decimals: 18 },
        infoURL: 'https://vrccoin.com',
        shortName: 'vrc',
        chainId: 713,
        networkId: 713,
        explorers: [
            {
                name: 'vrcscan',
                url: 'https://vrcscan.com',
                standard: 'EIP3091'
            },
            {
                name: 'dxbscan',
                url: 'https://dxb.vrcscan.com',
                standard: 'EIP3091'
            }
        ],
        icon: 'vrcscan',
        iconURL: 'https://ipfs.io/ipfs/QmasMkZJ6m7y77fgY6SooNnrH3Y4a3vVYNDWe9T3KusxeU'
    },
    718: {
        name: 'UXLINK ONE Mainnet',
        chain: 'UXLINK ONE',
        rpc: ['https://rpc.uxlinkone.com'],
        faucets: [],
        nativeCurrency: { name: 'UXLINK', symbol: 'UXLINK', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.uxlinkone.com',
        shortName: 'uxlink1',
        chainId: 718,
        networkId: 718,
        icon: 'uxlinkone',
        explorers: [
            {
                name: 'UXLINK ONE Mainnet Explorer',
                url: 'https://sepolia.uxlinkone.com',
                icon: 'uxlinkone',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibppp6mjqupwr5ffrcj4fcculphzoxxoqx5m4sjypsxwglljuq7sy'
    },
    719: {
        name: 'Shibarium Beta',
        chain: 'Shibarium',
        icon: 'shibarium',
        rpc: ['https://puppynet.shibrpc.com'],
        faucets: [],
        nativeCurrency: { name: 'BONE', symbol: 'BONE', decimals: 18 },
        infoURL: 'https://beta.shibariumtech.com',
        shortName: 'shibarium',
        chainId: 719,
        networkId: 719,
        explorers: [
            {
                name: 'shibscan',
                url: 'https://puppyscan.shib.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmd6rSbfpVjQQZXothmiwGqKo7zovnB9gkeoYcunDt7ZTb'
    },
    721: {
        name: 'Lycan Chain',
        chain: 'LYC',
        rpc: [
            'https://rpc.lycanchain.com/',
            'https://us-east.lycanchain.com',
            'https://us-west.lycanchain.com',
            'https://eu-north.lycanchain.com',
            'https://eu-west.lycanchain.com',
            'https://asia-southeast.lycanchain.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Lycan', symbol: 'LYC', decimals: 18 },
        infoURL: 'https://lycanchain.com',
        shortName: 'LYC',
        chainId: 721,
        networkId: 721,
        icon: 'lycanchain',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.lycanchain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZsp3gnmHCJPw3qReiqV8P8Ct5Eidib4E5jDNfBUxYEgP'
    },
    727: {
        name: 'Blucrates',
        chain: 'BLU',
        rpc: ['https://data.bluchain.pro'],
        faucets: [],
        nativeCurrency: { name: 'Blucrates', symbol: 'BLU', decimals: 18 },
        infoURL: 'https://www.blucrates.com',
        shortName: 'blu',
        chainId: 727,
        networkId: 727,
        slip44: 727
    },
    730: {
        name: 'Lovely Network Mainnet',
        chain: 'Lovely',
        icon: 'lovely',
        rpc: ['https://rpc.lovely.network'],
        faucets: [],
        nativeCurrency: { name: 'Lovely', symbol: 'LOVELY', decimals: 18 },
        infoURL: 'https://lovely.network',
        shortName: 'LOVELY',
        chainId: 730,
        networkId: 730,
        explorers: [
            {
                name: 'Lovely Network Mainnet',
                url: 'https://scan.lovely.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPB7uW7Wj8zWWdeuPnUHPJ5FhaiTL76tv4ZQ4oKWEpb1g'
    },
    740: {
        name: 'Canto Testnet',
        chain: 'Canto Tesnet',
        rpc: ['https://eth.plexnode.wtf/'],
        faucets: [],
        nativeCurrency: { name: 'Canto', symbol: 'CANTO', decimals: 18 },
        infoURL: 'https://canto.io',
        shortName: 'tcanto',
        chainId: 740,
        networkId: 740,
        slip44: 1,
        explorers: [
            {
                name: 'Canto Tesnet Explorer (Neobase)',
                url: 'https://testnet-explorer.canto.neobase.one',
                standard: 'none'
            }
        ],
        status: 'deprecated'
    },
    741: {
        name: 'Vention Smart Chain Testnet',
        chain: 'VSCT',
        icon: 'ventionTestnet',
        rpc: ['https://node-testnet.vention.network'],
        faucets: ['https://faucet.vention.network'],
        nativeCurrency: { name: 'VNT', symbol: 'VNT', decimals: 18 },
        infoURL: 'https://testnet.ventionscan.io',
        shortName: 'vsct',
        chainId: 741,
        networkId: 741,
        slip44: 1,
        explorers: [
            {
                name: 'ventionscan',
                url: 'https://testnet.ventionscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcNepHmbmHW1BZYM3MFqJW4awwhmDqhUPRXXmRnXwg1U4'
    },
    742: {
        name: 'Script Testnet',
        chain: 'SPAY',
        rpc: ['https://testeth-rpc-api.script.tv/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Script', symbol: 'SPAY', decimals: 18 },
        infoURL: 'https://token.script.tv',
        shortName: 'SPAY',
        chainId: 742,
        networkId: 742,
        slip44: 1,
        explorers: [
            {
                name: 'Script Explorer',
                url: 'https://explorer.script.tv',
                standard: 'none'
            }
        ]
    },
    743: {
        name: 'Tranched Mainnet',
        chain: 'tranched-mainnet',
        rpc: ['https://tranched-mainnet.calderachain.xyz/http'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://tranched-mainnet.hub.caldera.xyz',
        shortName: 'tranched-mainnet',
        chainId: 743,
        networkId: 743,
        icon: 'tranched-mainnet',
        explorers: [
            {
                name: 'Tranched Mainnet Caldera Explorer',
                url: 'https://tranched-mainnet.calderaexplorer.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreieb6bx5nqv43qgykfuycpfilf5xk7v3jugli74ofb7pm6t6f5wcmu'
    },
    747: {
        name: 'Flow EVM Mainnet',
        chain: 'Flow',
        rpc: ['https://mainnet.evm.nodes.onflow.org'],
        faucets: [],
        nativeCurrency: { name: 'FLOW', symbol: 'FLOW', decimals: 18 },
        infoURL: 'https://developers.flow.com/evm/about',
        shortName: 'flow-mainnet',
        chainId: 747,
        networkId: 747,
        icon: 'flowevm',
        explorers: [
            {
                name: 'FlowScan',
                url: 'https://evm.flowscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQFugEvsfU3ARjjJ7YRLJwSxMfTk54WWzrofekTRBKFaC'
    },
    753: {
        name: 'Rivalz',
        chain: 'rivalz',
        rpc: ['https://rivalz.calderachain.xyz/http'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://rivalz.hub.caldera.xyz',
        shortName: 'rivalz',
        chainId: 753,
        networkId: 753,
        icon: 'rivalz',
        explorers: [
            {
                name: 'Rivalz Caldera Explorer',
                url: 'https://rivalz.calderaexplorer.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiaykqfno5aveymgvrv3y725acslww2jidtaqr4nkmmti4zbayf2k4'
    },
    766: {
        name: 'QL1',
        chain: 'QOM',
        status: 'incubating',
        rpc: ['https://rpc.qom.one'],
        faucets: [],
        nativeCurrency: { name: 'Shiba Predator', symbol: 'QOM', decimals: 18 },
        infoURL: 'https://qom.one',
        shortName: 'qom',
        chainId: 766,
        networkId: 766,
        icon: 'qom',
        explorers: [
            {
                name: 'QL1 Mainnet Explorer',
                url: 'https://scan.qom.one',
                icon: 'qom',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRc1kJ7AgcDL1BSoMYudatWHTrz27K6WNTwGifQb5V17D'
    },
    776: {
        name: 'OpenChain Testnet',
        chain: 'OpenChain Testnet',
        rpc: [],
        faucets: ['https://faucet.openchain.info/'],
        nativeCurrency: { name: 'Openchain Testnet', symbol: 'TOPC', decimals: 18 },
        infoURL: 'https://testnet.openchain.info/',
        shortName: 'opc',
        chainId: 776,
        networkId: 776,
        slip44: 1,
        explorers: [
            {
                name: 'OPEN CHAIN TESTNET',
                url: 'https://testnet.openchain.info',
                standard: 'none'
            }
        ]
    },
    777: {
        name: 'cheapETH',
        chain: 'cheapETH',
        rpc: ['https://node.cheapeth.org/rpc'],
        faucets: [],
        nativeCurrency: { name: 'cTH', symbol: 'cTH', decimals: 18 },
        infoURL: 'https://cheapeth.org/',
        shortName: 'cth',
        chainId: 777,
        networkId: 777
    },
    785: {
        name: 'AUTHEO Testnet',
        chain: 'AUTHEO Testnet',
        rpc: ['https://testnet-rpc1.autheo.com'],
        faucets: ['https://testnet-faucet.autheo.com'],
        nativeCurrency: { name: 'THEO', symbol: 'THEO', decimals: 18 },
        infoURL: 'https://autheo.com',
        shortName: 'autheo-Test-Chain',
        chainId: 785,
        networkId: 785,
        explorers: [
            {
                name: 'tracehawk',
                url: 'https://testnet-explorer.autheo.com',
                standard: 'none'
            }
        ]
    },
    786: {
        name: 'MAAL Chain',
        chain: 'MAAL',
        icon: 'maal',
        rpc: [
            'https://node1-mainnet.maalscan.io/',
            'https://node2-mainnet.maalscan.io/',
            'https://node3-mainnet.maalscan.io/'
        ],
        faucets: [],
        nativeCurrency: { name: 'MAAL', symbol: 'MAAL', decimals: 18 },
        infoURL: 'https://www.maalchain.com/',
        shortName: 'maal',
        chainId: 786,
        networkId: 786,
        explorers: [
            {
                name: 'maalscan',
                url: 'https://maalscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiexfqfe2x4impvwhra3xxa5eb25gv25zi3kkaoatdnld7wbxdzf2a'
    },
    787: {
        name: 'Acala Network',
        chain: 'ACA',
        rpc: [
            'https://eth-rpc-acala.aca-api.network',
            'wss://eth-rpc-acala.aca-api.network'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Acala Token', symbol: 'ACA', decimals: 18 },
        infoURL: 'https://acala.network',
        shortName: 'aca',
        chainId: 787,
        networkId: 787,
        slip44: 787,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.acala.network',
                standard: 'EIP3091'
            }
        ]
    },
    788: {
        name: 'Aerochain Testnet',
        chain: 'Aerochain',
        rpc: ['https://testnet-rpc.aerochain.id/'],
        faucets: ['https://faucet.aerochain.id/'],
        nativeCurrency: {
            name: 'Aerochain Testnet',
            symbol: 'TAero',
            decimals: 18
        },
        infoURL: 'https://aerochaincoin.org/',
        shortName: 'taero',
        chainId: 788,
        networkId: 788,
        slip44: 1,
        explorers: [
            {
                name: 'aeroscan',
                url: 'https://testnet.aeroscan.id',
                standard: 'EIP3091'
            }
        ]
    },
    789: {
        name: 'Patex',
        chain: 'ETH',
        icon: 'patex',
        rpc: ['https://rpc.patex.io/'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://patex.io/',
        shortName: 'peth',
        chainId: 789,
        networkId: 789,
        explorers: [
            {
                name: 'patexscan',
                url: 'https://patexscan.io',
                icon: 'patex',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTNTSNn3t5WpSEzQmUYbkxYkBKaH6QahyVdVrRKyPHChr'
    },
    799: {
        name: 'Rupaya Testnet',
        chain: 'Rupaya Testnet',
        rpc: ['https://rpc.testnet.rupaya.io'],
        faucets: ['https://faucet.testnet.rupaya.io'],
        nativeCurrency: { name: 'Test Rupaya', symbol: 'TRUPX', decimals: 18 },
        infoURL: 'https://www.rupaya.io',
        shortName: 'RupayaTestnet',
        chainId: 799,
        networkId: 799,
        slip44: 1,
        explorers: [
            {
                name: 'rupayascan',
                url: 'https://scan.testnet.rupaya.io',
                standard: 'EIP3091'
            }
        ]
    },
    800: {
        name: 'Lucid Blockchain',
        chain: 'Lucid',
        icon: 'lucid',
        rpc: ['https://rpc.lucidcoin.io'],
        faucets: ['https://faucet.lucidcoin.io'],
        nativeCurrency: { name: 'LUCID', symbol: 'LUCID', decimals: 18 },
        infoURL: 'https://lucidcoin.io',
        shortName: 'LUCID',
        chainId: 800,
        networkId: 800,
        explorers: [
            {
                name: 'Lucid Explorer',
                url: 'https://explorer.lucidcoin.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeigxiyyxll4vst5cjjh732mr6zhsnligxubaldyiul2xdvvi6ibktu'
    },
    803: {
        name: 'Haic',
        chain: 'Haic',
        rpc: ['https://orig.haichain.io/'],
        faucets: [],
        nativeCurrency: { name: 'Haicoin', symbol: 'HAIC', decimals: 18 },
        infoURL: 'https://www.haichain.io/',
        shortName: 'haic',
        chainId: 803,
        networkId: 803
    },
    805: {
        name: 'Evoz Mainnet',
        chain: 'Evoz',
        rpc: ['https://rpc.evozscan.com'],
        faucets: [],
        nativeCurrency: { name: 'Evoz Mainnet', symbol: 'EVOZ', decimals: 18 },
        infoURL: 'https://rpc.evozscan.com',
        shortName: 'Evoz',
        chainId: 805,
        networkId: 805,
        icon: 'evoz',
        explorers: [
            {
                name: 'evozscan',
                url: 'https://evozscan.com',
                icon: 'evoz',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreia7pxdzauhdibtcjqhy4ywwshdgcspvh2jt3g4hyvamfymldlwhi4'
    },
    808: {
        name: 'Portal Fantasy Chain Test',
        chain: 'PF',
        icon: 'pf',
        rpc: ['https://subnets.avax.network/portal-fantasy/testnet/rpc'],
        faucets: [],
        nativeCurrency: {
            name: 'Portal Fantasy Token',
            symbol: 'PFT',
            decimals: 18
        },
        infoURL: 'https://portalfantasy.io',
        shortName: 'PFTEST',
        chainId: 808,
        networkId: 808,
        slip44: 1,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmeMa6aw3ebUKJdGgbzDgcVtggzp7cQdfSrmzMYmnt5ywc'
    },
    810: {
        name: 'Haven1 Testnet',
        chain: 'haven1',
        rpc: ['https://testnet-rpc.haven1.org'],
        faucets: ['https://www.haven1.org/faucet'],
        nativeCurrency: { name: 'Haven1', symbol: 'H1', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.haven1.org',
        shortName: 'h1',
        chainId: 810,
        networkId: 810,
        icon: 'haven1',
        explorers: [
            {
                name: 'Haven1 Explorer',
                url: 'https://testnet-explorer.haven1.org',
                icon: 'haven1',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreih4jq33lz2mjwvu62hmo2ptt277et5l6oqi5ejuyxv2dir2iohsai'
    },
    813: {
        name: 'Qitmeer Network Mainnet',
        chain: 'MEER',
        rpc: [
            'https://evm-dataseed1.meerscan.io',
            'https://evm-dataseed2.meerscan.io',
            'https://evm-dataseed3.meerscan.io',
            'https://evm-dataseed.meerscan.com',
            'https://qng.rpc.qitmeer.io',
            'https://mainnet.meerlabs.com',
            'https://rpc.dimai.ai',
            'https://rpc.woowow.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'Qitmeer', symbol: 'MEER', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'meer',
        chainId: 813,
        networkId: 813,
        slip44: 813,
        icon: 'meer',
        explorers: [
            {
                name: 'meerscan',
                icon: 'meer',
                url: 'https://qng.qitmeer.io',
                standard: 'EIP3091'
            },
            {
                name: 'meerscan',
                icon: 'meer',
                url: 'https://qng.meerscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    814: {
        name: 'Firechain zkEVM',
        title: 'Firechain zkEVM',
        chain: 'Firechain',
        rpc: [
            'https://rpc-zkevm.thefirechain.com',
            'https://rpc-zkevm.firestation.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://docs.thefirechain.com/',
        shortName: 'firechan-zkEVM',
        chainId: 814,
        networkId: 814,
        icon: 'ethereum',
        explorers: [],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://zkevm-bridge-rpc.thefirechain.com' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt'
    },
    818: {
        name: 'BeOne Chain Mainnet',
        chain: 'BOC',
        icon: 'beonechain',
        rpc: [
            'https://dataseed1.beonechain.com',
            'https://dataseed2.beonechain.com',
            'https://dataseed-us1.beonechain.com',
            'https://dataseed-us2.beonechain.com',
            'https://dataseed-uk1.beonechain.com',
            'https://dataseed-uk2.beonechain.com'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'BeOne Chain Mainnet',
            symbol: 'BOC',
            decimals: 18
        },
        infoURL: 'https://beonechain.com',
        shortName: 'BOC',
        chainId: 818,
        networkId: 818,
        slip44: 8181,
        explorers: [
            {
                name: 'BeOne Chain Mainnet',
                url: 'https://beonescan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbVLQnaMDu86bPyKgCvTGhFBeYwjr15hQnrCcsp1EkAGL'
    },
    820: {
        name: 'Callisto Mainnet',
        chain: 'CLO',
        icon: 'callistonetwork',
        rpc: ['https://rpc.callistodao.org'],
        faucets: ['https://faucet.callistodao.org'],
        nativeCurrency: { name: 'Callisto', symbol: 'CLO', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://callistodao.org',
        shortName: 'clo',
        chainId: 820,
        networkId: 1,
        slip44: 820,
        explorers: [
            {
                name: 'blockscout-callisto-network',
                url: 'https://explorer.callistodao.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQbn4Jr6PLSsgFo1eALKQ7eMfndJJJ4B15a9yj5G5vMLC'
    },
    821: {
        name: 'Callisto Testnet Deprecated',
        chain: 'CLO',
        rpc: [],
        faucets: [],
        nativeCurrency: {
            name: 'Callisto Testnet Ether',
            symbol: 'TCLO',
            decimals: 18
        },
        infoURL: 'https://callisto.network',
        shortName: 'tclo',
        chainId: 821,
        networkId: 2,
        slip44: 1,
        status: 'deprecated'
    },
    822: {
        name: 'Runic Chain Testnet',
        chain: 'Runic',
        rpc: ['https://rpc-testnet.runic.build'],
        faucets: ['https://faucet.runic.build'],
        nativeCurrency: { name: 'Bitcoin', symbol: 'rBTC', decimals: 18 },
        infoURL: 'https://runic.build',
        shortName: 'runic-testnet',
        chainId: 822,
        networkId: 822,
        status: 'active',
        icon: 'runic-testnet',
        explorers: [
            {
                name: 'RunicScan',
                url: 'https://scan.runic.build',
                icon: 'runic-testnet',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW3RZKwBq12F7jVV2pn6T9WzwU5rosLYkVqoRQckfKvXo'
    },
    824: {
        name: 'Daily Network Mainnet',
        chain: 'Daily Network',
        icon: 'daily',
        rpc: ['https://rpc.mainnet.dailycrypto.net'],
        faucets: [],
        nativeCurrency: { name: 'Daily', symbol: 'DLY', decimals: 18 },
        infoURL: 'https://dailycrypto.net',
        shortName: 'dly',
        chainId: 824,
        networkId: 824,
        explorers: [
            {
                name: 'Daily Mainnet Explorer',
                url: 'https://explorer.mainnet.dailycrypto.net',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme8Ju8Bn1XHMGGx2FfXCookAPLLhzxYpfZL7Fcm3QLgLp'
    },
    825: {
        name: 'Daily Network Testnet',
        chain: 'Daily Network',
        icon: 'daily',
        rpc: ['https://rpc.testnet.dailycrypto.net'],
        faucets: [],
        nativeCurrency: { name: 'Daily', symbol: 'DLY', decimals: 18 },
        infoURL: 'https://dailycrypto.net',
        shortName: 'tdly',
        chainId: 825,
        networkId: 825,
        explorers: [
            {
                name: 'Daily Testnet Explorer',
                url: 'https://explorer.testnet.dailycrypto.net',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme8Ju8Bn1XHMGGx2FfXCookAPLLhzxYpfZL7Fcm3QLgLp'
    },
    831: {
        name: 'CheckDot Blockchain Devnet',
        chain: 'CDT Blockchain',
        rpc: ['https://devnet.checkdot.io'],
        faucets: [],
        nativeCurrency: { name: 'CDT', symbol: 'CDT', decimals: 18 },
        infoURL: 'https://checkdot.io',
        shortName: 'cdt',
        chainId: 831,
        networkId: 831,
        explorers: [
            {
                name: 'CDT Explorer',
                url: 'https://explorer.checkdot.io',
                standard: 'none'
            }
        ]
    },
    841: {
        name: 'Taraxa Mainnet',
        chain: 'TARA',
        icon: 'taraxa',
        rpc: ['https://rpc.mainnet.taraxa.io/', 'https://ws.mainnet.taraxa.io'],
        faucets: [],
        nativeCurrency: { name: 'Tara', symbol: 'TARA', decimals: 18 },
        infoURL: 'https://taraxa.io',
        shortName: 'tara',
        chainId: 841,
        networkId: 841,
        slip44: 726,
        explorers: [
            {
                name: 'Tara.to Explorer',
                url: 'https://tara.to',
                standard: 'EIP3091',
                icon: 'blockscout'
            },
            {
                name: 'Taraxa Explorer',
                url: 'https://explorer.mainnet.taraxa.io',
                standard: 'none',
                icon: 'taraxa'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVeZJ3DfDuksxw58cHCRDKWDdhbmQsvrJdTxhZ74pv3tE'
    },
    842: {
        name: 'Taraxa Testnet',
        chain: 'TARA',
        icon: 'taraxa',
        rpc: ['https://rpc.testnet.taraxa.io/', 'https://ws.testnet.taraxa.io'],
        faucets: ['https://explorer.testnet.taraxa.io/faucet'],
        nativeCurrency: { name: 'Tara', symbol: 'TARA', decimals: 18 },
        infoURL: 'https://taraxa.io',
        shortName: 'taratest',
        chainId: 842,
        networkId: 842,
        slip44: 1,
        explorers: [
            {
                name: 'Tara.to Explorer',
                url: 'https://testnet.to',
                standard: 'EIP3091',
                icon: 'blockscout'
            },
            {
                name: 'Taraxa Explorer',
                url: 'https://explorer.testnet.taraxa.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVeZJ3DfDuksxw58cHCRDKWDdhbmQsvrJdTxhZ74pv3tE'
    },
    852: {
        name: 'HongKong Mainnet',
        chain: 'HONGKONG',
        rpc: ['https://eth.jegotrip.net'],
        faucets: [],
        nativeCurrency: { name: 'HongKong', symbol: 'HK', decimals: 18 },
        infoURL: 'https://www.cmi.chinamobile.com/',
        shortName: 'HongKong',
        chainId: 852,
        networkId: 852,
        explorers: [
            {
                name: 'HongKong Mainnet Explorer',
                url: 'http://47.238.205.52',
                standard: 'none'
            }
        ]
    },
    859: {
        name: 'Zeeth Chain Dev',
        chain: 'ZeethChainDev',
        rpc: ['https://rpc.dev.zeeth.io'],
        faucets: [],
        nativeCurrency: { name: 'Zeeth Token', symbol: 'ZTH', decimals: 18 },
        infoURL: '',
        shortName: 'zeethdev',
        chainId: 859,
        networkId: 859,
        explorers: [
            {
                name: 'Zeeth Explorer Dev',
                url: 'https://explorer.dev.zeeth.io',
                standard: 'none'
            }
        ]
    },
    861: {
        name: 'Electra Network',
        chain: 'Electra',
        rpc: ['https://rpc.electranetwork.tech'],
        faucets: [],
        nativeCurrency: { name: 'Electra', symbol: 'ELC', decimals: 18 },
        infoURL: 'https://www.electranetwork.tech',
        shortName: 'elc',
        chainId: 861,
        networkId: 861,
        explorers: [
            {
                name: 'Electra Explorer',
                url: 'https://scan.electranetwork.tech',
                standard: 'none'
            }
        ]
    },
    863: {
        name: 'Radius Testnet',
        chain: 'Radius',
        rpc: ['https://dev-secure.rpc.theradius.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Useless', symbol: 'USLS', decimals: 18 },
        infoURL: 'https://www.theradius.xyz/',
        shortName: 'radius-testnet',
        chainId: 863,
        networkId: 863
    },
    868: {
        name: 'Fantasia Chain Mainnet',
        chain: 'FSC',
        rpc: [
            'https://mainnet-data1.fantasiachain.com/',
            'https://mainnet-data2.fantasiachain.com/',
            'https://mainnet-data3.fantasiachain.com/'
        ],
        faucets: [],
        nativeCurrency: { name: 'FST', symbol: 'FST', decimals: 18 },
        infoURL: 'https://fantasiachain.com/',
        shortName: 'FSCMainnet',
        chainId: 868,
        networkId: 868,
        explorers: [
            {
                name: 'FSCScan',
                url: 'https://explorer.fantasiachain.com',
                standard: 'EIP3091'
            }
        ]
    },
    871: {
        name: 'Electra Test Network',
        chain: 'Electra',
        rpc: ['https://rpc.testnet.electranetwork.tech'],
        faucets: [],
        nativeCurrency: { name: 'Test Electra', symbol: 'TELC', decimals: 18 },
        infoURL: 'https://scan.testnet.electranetwork.tech',
        shortName: 'telc',
        chainId: 871,
        networkId: 871,
        explorers: [
            {
                name: 'Electra Testnet Explorer',
                url: 'https://scan.testnet.electranetwork.tech',
                standard: 'none'
            }
        ]
    },
    876: {
        name: 'Bandai Namco Research Verse Mainnet',
        chain: 'Bandai Namco Research Verse',
        icon: 'bnken',
        rpc: ['https://rpc.main.oasvrs.bnken.net'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://www.bandainamco-mirai.com/en/',
        shortName: 'BNKEN',
        chainId: 876,
        networkId: 876,
        explorers: [
            {
                name: 'Bandai Namco Research Verse Explorer',
                url: 'https://explorer.main.oasvrs.bnken.net',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-248' },
        iconURL: 'https://ipfs.io/ipfs/bafkreifhetalm3vpvjrg5u5d2momkcgvkz6rhltur5co3rslltbxzpr6yq'
    },
    877: {
        name: 'Dexit Network',
        chain: 'DXT',
        rpc: ['https://dxt.dexit.network'],
        faucets: ['https://faucet.dexit.network'],
        nativeCurrency: { name: 'Dexit network', symbol: 'DXT', decimals: 18 },
        infoURL: 'https://dexit.network',
        shortName: 'DXT',
        chainId: 877,
        networkId: 877,
        explorers: [
            {
                name: 'dxtscan',
                url: 'https://dxtscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    880: {
        name: 'Ambros Chain Mainnet',
        chain: 'ambroschain',
        rpc: ['https://api.ambros.network'],
        faucets: [],
        nativeCurrency: { name: 'AMBROS', symbol: 'AMBROS', decimals: 18 },
        infoURL: 'https://ambros.network',
        shortName: 'ambros',
        chainId: 880,
        networkId: 880,
        explorers: [
            {
                name: 'Ambros Chain Explorer',
                url: 'https://ambrosscan.com',
                standard: 'none'
            }
        ]
    },
    881: {
        name: 'Weber Governance Mainnet',
        chain: 'PTT',
        rpc: ['https://chain.myweber.org'],
        faucets: [],
        nativeCurrency: { name: 'PALLET', symbol: 'PTT', decimals: 18 },
        infoURL: 'https://myweber.org',
        shortName: 'ptt',
        chainId: 881,
        networkId: 881,
        icon: 'ptt',
        explorers: [
            {
                name: 'Weber Governance Mainnet Explorer',
                url: 'https://mainnet.myweber.org',
                icon: 'ptt',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihwjhyhzxernwjyxm4edujzhou4bg6bpinwj7r4azifoljubgr3sq'
    },
    888: {
        name: 'Wanchain',
        chain: 'WAN',
        rpc: ['https://gwan-ssl.wandevs.org:56891/'],
        faucets: [],
        nativeCurrency: { name: 'Wancoin', symbol: 'WAN', decimals: 18 },
        infoURL: 'https://www.wanscan.org',
        shortName: 'wan',
        chainId: 888,
        networkId: 888,
        slip44: 5718350,
        icon: 'wanchain',
        explorers: [
            {
                name: 'wanscan',
                icon: 'wanchain',
                url: 'https://wanscan.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcRVHdG7Sr1f26DhkBwE1YuwFZXFjNth5S3TookXoyFaq'
    },
    898: {
        name: 'MAXI Chain Testnet',
        chain: 'MAXI',
        rpc: ['https://rpc-testnet.maxi.network'],
        faucets: ['https://faucet.maxi.network'],
        nativeCurrency: { name: 'MAXI GAS', symbol: 'MGAS', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://maxi.network',
        shortName: 'maxi-testnet',
        chainId: 898,
        networkId: 898,
        icon: 'maxi',
        explorers: [
            {
                name: 'Maxi Chain Testnet Explorer',
                url: 'https://testnet.maxi.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcwqTBqA8ayxizG4XwLUSyg3xkQbpzUEvqQmWzyMSjnCo'
    },
    899: {
        name: 'MAXI Chain Mainnet',
        chain: 'MAXI',
        rpc: ['https://rpc.maxi.network'],
        faucets: [],
        nativeCurrency: { name: 'MAXI GAS', symbol: 'MGAS', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://maxi.network',
        shortName: 'maxi-mainnet',
        chainId: 899,
        networkId: 899,
        icon: 'maxi',
        explorers: [
            {
                name: 'Maxi Chain Mainnet Explorer',
                url: 'https://mainnet.maxi.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcwqTBqA8ayxizG4XwLUSyg3xkQbpzUEvqQmWzyMSjnCo'
    },
    900: {
        name: 'Garizon Testnet Stage0',
        chain: 'GAR',
        icon: 'garizon',
        rpc: ['https://s0-testnet.garizon.net/rpc'],
        faucets: ['https://faucet-testnet.garizon.com'],
        nativeCurrency: { name: 'Garizon', symbol: 'GAR', decimals: 18 },
        infoURL: 'https://garizon.com',
        shortName: 'gar-test-s0',
        chainId: 900,
        networkId: 900,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer-testnet.garizon.com',
                icon: 'garizon',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc'
    },
    901: {
        name: 'Garizon Testnet Stage1',
        chain: 'GAR',
        icon: 'garizon',
        rpc: ['https://s1-testnet.garizon.net/rpc'],
        faucets: ['https://faucet-testnet.garizon.com'],
        nativeCurrency: { name: 'Garizon', symbol: 'GAR', decimals: 18 },
        infoURL: 'https://garizon.com',
        shortName: 'gar-test-s1',
        chainId: 901,
        networkId: 901,
        slip44: 1,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer-testnet.garizon.com',
                icon: 'garizon',
                standard: 'EIP3091'
            }
        ],
        parent: { chain: 'eip155-900', type: 'shard' },
        iconURL: 'https://ipfs.io/ipfs/QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc'
    },
    902: {
        name: 'Garizon Testnet Stage2',
        chain: 'GAR',
        icon: 'garizon',
        rpc: ['https://s2-testnet.garizon.net/rpc'],
        faucets: ['https://faucet-testnet.garizon.com'],
        nativeCurrency: { name: 'Garizon', symbol: 'GAR', decimals: 18 },
        infoURL: 'https://garizon.com',
        shortName: 'gar-test-s2',
        chainId: 902,
        networkId: 902,
        slip44: 1,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer-testnet.garizon.com',
                icon: 'garizon',
                standard: 'EIP3091'
            }
        ],
        parent: { chain: 'eip155-900', type: 'shard' },
        iconURL: 'https://ipfs.io/ipfs/QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc'
    },
    903: {
        name: 'Garizon Testnet Stage3',
        chain: 'GAR',
        icon: 'garizon',
        rpc: ['https://s3-testnet.garizon.net/rpc'],
        faucets: ['https://faucet-testnet.garizon.com'],
        nativeCurrency: { name: 'Garizon', symbol: 'GAR', decimals: 18 },
        infoURL: 'https://garizon.com',
        shortName: 'gar-test-s3',
        chainId: 903,
        networkId: 903,
        slip44: 1,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer-testnet.garizon.com',
                icon: 'garizon',
                standard: 'EIP3091'
            }
        ],
        parent: { chain: 'eip155-900', type: 'shard' },
        iconURL: 'https://ipfs.io/ipfs/QmW3WRyuLZ95K8hvV2QN6rP5yWY98sSzWyVUxD2eUjXGrc'
    },
    909: {
        name: 'Portal Fantasy Chain',
        chain: 'PF',
        icon: 'pf',
        rpc: [],
        faucets: [],
        nativeCurrency: {
            name: 'Portal Fantasy Token',
            symbol: 'PFT',
            decimals: 18
        },
        infoURL: 'https://portalfantasy.io',
        shortName: 'PF',
        chainId: 909,
        networkId: 909,
        explorers: [],
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmeMa6aw3ebUKJdGgbzDgcVtggzp7cQdfSrmzMYmnt5ywc'
    },
    910: {
        name: 'DecentraBone Layer1 Testnet',
        chain: 'DBONE',
        rpc: ['https://layer1test.decentrabone.com'],
        faucets: [],
        nativeCurrency: { name: 'DecentraBone', symbol: 'DBONE', decimals: 18 },
        infoURL: 'https://decentrabone.com',
        shortName: 'DBONE',
        chainId: 910,
        networkId: 910,
        slip44: 1
    },
    911: {
        name: 'TAPROOT Mainnet',
        title: 'TAPROOT Mainnet',
        chain: 'TAPROOT CHAIN',
        rpc: ['https://rpc.taprootchain.io'],
        faucets: [],
        nativeCurrency: { name: 'TBTC', symbol: 'TBTC', decimals: 18 },
        infoURL: 'https://taprootchain.io',
        shortName: 'TAPROOT-Mainnet',
        chainId: 911,
        networkId: 911,
        icon: 'taproot',
        explorers: [
            {
                name: 'TAPROOT Scan',
                url: 'https://scan.taprootchain.io',
                icon: 'taproot',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeucqvcreQk8nnSRUiHo3QTvLoYYB7shJTKXj5Tk6BtWi'
    },
    917: {
        name: 'Rinia',
        title: 'Firechain Testnet Rinia',
        chain: 'FIRE',
        rpc: [
            'https://rinia-rpc1.thefirechain.com',
            'https://rpc-rinia.firestation.io'
        ],
        faucets: [
            'https://faucet.thefirechain.com',
            'https://faucet.firestation.io'
        ],
        nativeCurrency: { name: 'Firechain', symbol: 'FIRE', decimals: 18 },
        infoURL: 'https://thefirechain.com',
        shortName: 'tfire',
        chainId: 917,
        networkId: 917,
        icon: 'rinia',
        slip44: 1,
        explorers: [
            {
                name: 'FireScan',
                url: 'https://rinia.firescan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRnnw2gtbU9TWJMLJ6tks7SN6HQV5rRugeoyN6csTYHt1'
    },
    918: {
        name: 'SlerfChain Mainnet',
        title: 'SlerfChain Mainnet',
        chain: 'SLERF CHAIN',
        rpc: ['https://rpc.slerfchain.xyz'],
        faucets: [],
        nativeCurrency: { name: 'WSLERF', symbol: 'WSLERF', decimals: 18 },
        infoURL: 'https://slerfchain.xyz',
        shortName: 'SlerfChain-Mainnet',
        chainId: 918,
        networkId: 918,
        icon: 'slerf',
        explorers: [
            {
                name: 'SlerfChain Scan',
                url: 'https://scan.slerfchain.xyz',
                icon: 'slerf',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdDeCjjYSG5FEAxzAuERXnS3AbeZvqSFVTn9x7UbrQeuT'
    },
    919: {
        name: 'Mode Testnet',
        chain: 'ETH',
        rpc: ['https://sepolia.mode.network'],
        faucets: ['https://sepoliafaucet.com/'],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://docs.mode.network/',
        shortName: 'modesep',
        chainId: 919,
        networkId: 919,
        slip44: 1,
        icon: 'modeTestnet',
        explorers: [
            {
                name: 'modescout',
                url: 'https://sepolia.explorer.mode.network',
                standard: 'none'
            },
            {
                name: 'Routesan',
                url: 'https://testnet.modescan.io',
                standard: 'none'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge.mode.network/' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreidi5y7afj5z4xrz7uz5rkg2mcsv2p2n4ui4g7q4k4ecdz65i2agou'
    },
    927: {
        name: 'Yidark Chain Mainnet',
        chain: 'Yidark',
        icon: 'ydk',
        rpc: ['https://rpc.yidark.io'],
        faucets: [],
        nativeCurrency: { name: 'Yidark', symbol: 'YDK', decimals: 18 },
        infoURL: 'https://yidarkscan.com',
        shortName: 'ydk',
        chainId: 927,
        networkId: 927,
        explorers: [
            {
                name: 'Yidarkscan',
                url: 'https://yidarkscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdbFGqrpiLQGtAeUAyeS2NBvACfgrchEF466ni5q36fuZ'
    },
    938: {
        name: 'Haust Mainnet',
        title: 'Haust Mainnet',
        chain: 'Haust',
        rpc: ['https://haust-network-rpc.eu-north-2.gateway.fm'],
        faucets: [],
        features: [{ name: 'EIP155' }],
        nativeCurrency: { name: 'HAUST', symbol: 'HAUST', decimals: 18 },
        infoURL: 'https://haust.network/',
        shortName: 'haust',
        chainId: 938,
        networkId: 938,
        icon: 'haust',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://haust-network-blockscout.eu-north-2.gateway.fm',
                icon: 'haust',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://haust-network-bridge.eu-north-2.gateway.fm' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmRAjG8kc6PJr3xFGYhq1pWiiDoERD3Wj8wR7Cu59HoFnm'
    },
    940: {
        name: 'PulseChain Testnet',
        shortName: 'tpls',
        chain: 'tPLS',
        chainId: 940,
        networkId: 940,
        slip44: 1,
        infoURL: 'https://pulsechain.com/',
        rpc: [
            'https://rpc.v2.testnet.pulsechain.com/',
            'wss://rpc.v2.testnet.pulsechain.com/'
        ],
        faucets: ['https://faucet.v2.testnet.pulsechain.com/'],
        status: 'deprecated',
        nativeCurrency: { name: 'Test Pulse', symbol: 'tPLS', decimals: 18 }
    },
    941: {
        name: 'PulseChain Testnet v2b',
        shortName: 't2bpls',
        chain: 't2bPLS',
        chainId: 941,
        networkId: 941,
        slip44: 1,
        infoURL: 'https://pulsechain.com/',
        rpc: [
            'https://rpc.v2b.testnet.pulsechain.com/',
            'wss://rpc.v2b.testnet.pulsechain.com/'
        ],
        faucets: ['https://faucet.v2b.testnet.pulsechain.com/'],
        status: 'deprecated',
        nativeCurrency: { name: 'Test Pulse', symbol: 'tPLS', decimals: 18 }
    },
    942: {
        name: 'PulseChain Testnet v3',
        shortName: 't3pls',
        chain: 't3PLS',
        chainId: 942,
        networkId: 942,
        slip44: 1,
        infoURL: 'https://pulsechain.com/',
        rpc: [
            'https://rpc.v3.testnet.pulsechain.com/',
            'wss://rpc.v3.testnet.pulsechain.com/'
        ],
        faucets: ['https://faucet.v3.testnet.pulsechain.com/'],
        status: 'deprecated',
        nativeCurrency: { name: 'Test Pulse', symbol: 'tPLS', decimals: 18 }
    },
    943: {
        name: 'PulseChain Testnet v4',
        shortName: 't4pls',
        chain: 't4PLS',
        chainId: 943,
        networkId: 943,
        icon: 'pulsechain',
        infoURL: 'https://pulsechain.com',
        rpc: [
            'https://rpc.v4.testnet.pulsechain.com',
            'wss://rpc.v4.testnet.pulsechain.com',
            'https://pulsechain-testnet-rpc.publicnode.com',
            'wss://pulsechain-testnet-rpc.publicnode.com',
            'https://rpc-testnet-pulsechain.g4mm4.io',
            'wss://rpc-testnet-pulsechain.g4mm4.io'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://faucet.v4.testnet.pulsechain.com/'],
        ens: { registry: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e' },
        status: 'active',
        slip44: 1,
        nativeCurrency: { name: 'Test Pulse', symbol: 'tPLS', decimals: 18 },
        explorers: [
            {
                name: 'blockscout',
                url: 'https://scan.v4.testnet.pulsechain.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            },
            {
                name: 'blockscout',
                url: 'https://otter-testnet-pulsechain.g4mm4.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmckj9B9F3jWDk9bv9HwoPmfjrx2Ju8J2BQSNoPFdYGduj'
    },
    945: {
        name: 'Subtensor EVM Testnet',
        chain: 'Bittensor',
        rpc: ['https://test.chain.opentensor.ai'],
        faucets: [],
        nativeCurrency: { name: 'testTAO', symbol: 'TAO', decimals: 18 },
        infoURL: 'https://bittensor.com/',
        shortName: 'bittensor-evm-testnet',
        chainId: 945,
        networkId: 945,
        slip44: 1005,
        icon: 'bittensor',
        explorers: [
            {
                name: 'Subtensor EVM Explorer',
                url: 'https://evm-testscan.dev.opentensor.ai',
                icon: 'bittensor',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcwymedPKMBVUptXLeuco2kV7LEhyd3bQ6x3aAh4VAmNJ'
    },
    956: {
        name: 'muNode Testnet',
        chain: 'munode',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://munode.dev/',
        shortName: 'munode',
        chainId: 956,
        networkId: 956,
        slip44: 1
    },
    957: {
        name: 'Lyra Chain',
        chain: 'Lyra',
        rpc: ['https://rpc.lyra.finance'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://lyra.finance',
        shortName: 'lyra',
        chainId: 957,
        networkId: 957,
        icon: 'lyra',
        explorers: [
            {
                name: 'Lyra Explorer',
                url: 'https://explorer.lyra.finance',
                icon: 'lyra',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifrvwcwcgs2luampufdbdgohuxue5rep3u4p4owmwskob7hzpcfdq'
    },
    963: {
        name: 'BTC20 Smart Chain',
        chain: 'BTC20',
        rpc: ['https://rpc.bitcoincode.technology/'],
        faucets: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'BTCC', symbol: 'BTCC', decimals: 18 },
        infoURL: 'https://bitcoincode.technology',
        shortName: 'btc20',
        chainId: 963,
        networkId: 963,
        icon: 'btc20',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://scan.bitcoincode.technology',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRUzDpn3xqPYnjLuZvFs2Attio9VxGRUprXEjcNQDcpe5'
    },
    964: {
        name: 'Subtensor EVM',
        chain: 'Bittensor',
        rpc: ['https://lite.chain.opentensor.ai'],
        faucets: [],
        nativeCurrency: { name: 'TAO', symbol: 'TAO', decimals: 18 },
        infoURL: 'https://bittensor.com/',
        shortName: 'bittensor-evm-mainnet',
        chainId: 964,
        networkId: 964,
        slip44: 1005,
        icon: 'bittensor',
        iconURL: 'https://ipfs.io/ipfs/QmcwymedPKMBVUptXLeuco2kV7LEhyd3bQ6x3aAh4VAmNJ'
    },
    969: {
        name: 'EthXY',
        chain: 'EthXY',
        rpc: ['https://rpc.ethxy.com'],
        faucets: [],
        nativeCurrency: {
            name: 'Settled EthXY Token',
            symbol: 'SEXY',
            decimals: 18
        },
        icon: 'sexy',
        infoURL: 'https://ethxy.com',
        shortName: 'sexy',
        chainId: 969,
        networkId: 969,
        explorers: [
            {
                name: 'EthXY Network Explorer',
                url: 'https://explorer.ethxy.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihq3b3cqbg2ttlp4dfbgmirrwdw6bbpmmbr5wolddd2izbyqay4xq'
    },
    970: {
        name: 'Oort Mainnet',
        chain: 'Oort Mainnet',
        rpc: ['https://mainnet-rpc.oortech.com'],
        faucets: [],
        nativeCurrency: { name: 'Oort', symbol: 'OORT', decimals: 18 },
        infoURL: 'https://oortech.com',
        shortName: 'ccn',
        chainId: 970,
        networkId: 970,
        icon: 'oort',
        explorers: [
            {
                name: 'Oort Mainnet Explorer',
                url: 'https://mainnet-scan.oortech.com',
                standard: 'none',
                icon: 'oort'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidrbvklkb52sgmg7cmy42fhf7vqpig7qj7bnrq24ijdwywkzr2tfy'
    },
    971: {
        name: 'Oort Huygens',
        chain: 'Huygens',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Oort', symbol: 'CCN', decimals: 18 },
        infoURL: 'https://oortech.com',
        shortName: 'Huygens',
        chainId: 971,
        networkId: 971,
        icon: 'ccn',
        iconURL: 'https://ipfs.io/ipfs/QmZ1jbxFZcuotj3eZ6iKFrg9ZXnaV8AK6sGRa7ELrceWyD'
    },
    972: {
        name: 'Oort Ascraeus',
        title: 'Oort Ascraeus',
        chain: 'Ascraeus',
        rpc: ['https://ascraeus-rpc.oortech.com'],
        faucets: [],
        nativeCurrency: { name: 'Oort', symbol: 'CCNA', decimals: 18 },
        infoURL: 'https://oortech.com',
        shortName: 'Ascraeus',
        chainId: 972,
        networkId: 972,
        icon: 'oort',
        explorers: [
            {
                name: 'Oort Ascraeus Explorer',
                url: 'https://ascraeus-scan.oortech.com',
                standard: 'none',
                icon: 'oort'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidrbvklkb52sgmg7cmy42fhf7vqpig7qj7bnrq24ijdwywkzr2tfy'
    },
    973: {
        name: 'Palm Smart Chain',
        title: 'Palm Smart Chain',
        chain: 'Palm',
        rpc: ['https://rpc.palmsmartchain.io'],
        faucets: [],
        nativeCurrency: { name: 'PALM', symbol: 'PALM', decimals: 18 },
        infoURL: 'https://palmsmartchain.io',
        shortName: 'PalmChain',
        chainId: 973,
        networkId: 973,
        explorers: [
            {
                name: 'Palm Smart Chain Explorer',
                url: 'https://explorer.palmsmartchain.io',
                standard: 'EIP3091'
            }
        ]
    },
    977: {
        name: 'Nepal Blockchain Network',
        chain: 'YETI',
        rpc: [
            'https://api.nepalblockchain.dev',
            'https://api.nepalblockchain.network'
        ],
        faucets: ['https://faucet.nepalblockchain.network'],
        nativeCurrency: {
            name: 'Nepal Blockchain Network Ether',
            symbol: 'YETI',
            decimals: 18
        },
        infoURL: 'https://nepalblockchain.network',
        shortName: 'yeti',
        chainId: 977,
        networkId: 977
    },
    979: {
        name: 'EthXY Testnet',
        chain: 'EthXY',
        rpc: ['https://rpc.testnet.ethxy.com'],
        faucets: [],
        nativeCurrency: {
            name: 'Settled EthXY Token',
            symbol: 'SEXY',
            decimals: 18
        },
        icon: 'sexyTestnet',
        infoURL: 'https://ethxy.com',
        shortName: 'sexyTestnet',
        chainId: 979,
        networkId: 979,
        explorers: [
            {
                name: 'EthXY Testnet Network Explorer',
                url: 'https://explorer.testnet.ethxy.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihq3b3cqbg2ttlp4dfbgmirrwdw6bbpmmbr5wolddd2izbyqay4xq'
    },
    980: {
        name: 'TOP Mainnet EVM',
        chain: 'TOP',
        icon: 'top',
        rpc: ['https://ethapi.topnetwork.org'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.topnetwork.org/',
        shortName: 'top_evm',
        chainId: 980,
        networkId: 0,
        explorers: [
            {
                name: 'topscan.dev',
                url: 'https://www.topscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYikaM849eZrL8pGNeVhEHVTKWpxdGMvCY5oFBfZ2ndhd'
    },
    984: {
        name: 'IOPN Testnet',
        chain: 'IOPN Testnet',
        rpc: ['https://testnet-rpc.iopn.tech'],
        faucets: ['https://faucet.iopn.tech'],
        nativeCurrency: { name: 'OPN', symbol: 'OPN', decimals: 18 },
        infoURL: 'https://iopn.tech',
        shortName: 'iopn-Test-Chain',
        chainId: 984,
        networkId: 984,
        explorers: [
            {
                name: 'tracehawk',
                url: 'https://testnet.iopn.tech',
                standard: 'none'
            }
        ]
    },
    985: {
        name: 'Memo Smart Chain Mainnet',
        chain: 'MEMO',
        rpc: ['https://chain.metamemo.one:8501', 'wss://chain.metamemo.one:16801'],
        faucets: ['https://faucet.metamemo.one/'],
        nativeCurrency: { name: 'Memo', symbol: 'CMEMO', decimals: 18 },
        infoURL: 'www.memolabs.org',
        shortName: 'memochain',
        chainId: 985,
        networkId: 985,
        icon: 'memo',
        explorers: [
            {
                name: 'Memo Mainnet Explorer',
                url: 'https://scan.metamemo.one:8080',
                icon: 'memo',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreig52paynhccs4o5ew6f7mk3xoqu2bqtitmfvlgnwarh2pm33gbdrq'
    },
    986: {
        name: 'LAGOM Mainnet',
        chain: 'LAGOM Mainnet',
        rpc: ['https://rpc1.lagom.mainnet.zeeve.net'],
        faucets: [],
        nativeCurrency: { name: 'LAGO', symbol: 'LAGO', decimals: 18 },
        infoURL: 'https://lagomchain.com',
        shortName: 'Lagom-Chain',
        chainId: 986,
        networkId: 986,
        explorers: [
            {
                name: 'tracehawk',
                url: 'https://Explorer.lagomchain.com',
                standard: 'none'
            }
        ]
    },
    987: {
        name: 'BinaryChain Mainnet',
        chain: 'BinaryChain',
        icon: 'binary',
        rpc: ['https://rpc.binarychain.org'],
        faucets: [],
        nativeCurrency: { name: 'BINARY', symbol: 'BNRY', decimals: 18 },
        infoURL: 'https://binarychain.org',
        shortName: 'binary',
        chainId: 987,
        networkId: 987,
        explorers: [
            {
                name: 'BinaryChain Explorer',
                url: 'https://explorer.binarychain.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeifb4vnpn3jv7cfdlne2dwhe6agdnpgmu46a7nbc5divjuyaznkyay'
    },
    989: {
        name: 'TOP Mainnet',
        chain: 'TOP',
        icon: 'top',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'TOP', symbol: 'TOP', decimals: 6 },
        infoURL: 'https://www.topnetwork.org/',
        shortName: 'top',
        chainId: 989,
        networkId: 0,
        explorers: [
            {
                name: 'topscan.dev',
                url: 'https://www.topscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYikaM849eZrL8pGNeVhEHVTKWpxdGMvCY5oFBfZ2ndhd'
    },
    990: {
        name: 'eLiberty Mainnet',
        chain: '$EL',
        icon: 'eLiberty',
        rpc: ['https://rpc.eliberty.ngo'],
        faucets: ['https://faucet.eliberty.ngo'],
        nativeCurrency: { name: 'eLiberty', symbol: '$EL', decimals: 18 },
        infoURL: 'https://eliberty.ngo',
        shortName: 'ELm',
        chainId: 990,
        networkId: 990,
        explorers: [
            {
                name: 'eLiberty Mainnet',
                url: 'https://explorer.eliberty.ngo',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmcr8US1DZcK3ooiMtE8tEQPgep12abXzxPw1jCkgZhji9'
    },
    995: {
        name: '5ireChain Mainnet',
        chain: '5ireChain',
        rpc: ['https://rpc.5ire.network'],
        faucets: [],
        nativeCurrency: { name: '5ire Token', symbol: '5ire', decimals: 18 },
        infoURL: 'https://5ire.org',
        shortName: '5ire',
        chainId: 995,
        networkId: 995,
        icon: '5ireChain',
        explorers: [
            {
                name: '5ireChain Explorer',
                url: 'https://5irescan.io',
                standard: 'none',
                icon: '5ireChain'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaZDNDFLWESH4i3XqwEWfWBb1HPnQSNbDAr74nr2x8QAk'
    },
    996: {
        name: 'Bifrost Polkadot Mainnet',
        chain: 'Bifrost',
        rpc: ['https://hk.p.bifrost-rpc.liebi.com'],
        faucets: [],
        nativeCurrency: { name: 'Wrapped ETH', symbol: 'WETH', decimals: 18 },
        infoURL: 'https://bifrost.io/',
        shortName: 'bnc',
        chainId: 996,
        networkId: 996,
        icon: 'bifrost-polkadot',
        iconURL: 'https://ipfs.io/ipfs/QmcNsubj4ane1QXTfWt4Xm4SYU59TMnevtW5TuKprrBCHk'
    },
    997: {
        name: '5ireChain Thunder Testnet',
        chain: '5ireChain',
        rpc: ['https://rpc.testnet.5ire.network'],
        faucets: ['https://testnet.5irescan.io/faucet'],
        nativeCurrency: {
            name: '5ire Testnet Token',
            symbol: 'T5IRE',
            decimals: 18
        },
        infoURL: 'https://5ire.org',
        shortName: 'T5ire',
        chainId: 997,
        networkId: 997,
        icon: '5ireChain',
        explorers: [
            {
                name: '5ireChain Testnet Explorer',
                url: 'https://testnet.5irescan.io',
                standard: 'none',
                icon: '5ireChain'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaZDNDFLWESH4i3XqwEWfWBb1HPnQSNbDAr74nr2x8QAk'
    },
    998: {
        name: 'Hyperliquid EVM Testnet',
        chain: 'HYPE',
        rpc: ['https://api.hyperliquid-testnet.xyz/evm'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'HYPE', symbol: 'HYPE', decimals: 18 },
        infoURL: 'https://hyperfoundation.org/',
        shortName: 'hype-evm-testnet',
        chainId: 998,
        networkId: 998,
        explorers: [],
        redFlags: ['reusedChainId']
    },
    999: {
        name: 'Wanchain Testnet',
        chain: 'WAN',
        rpc: ['https://gwan-ssl.wandevs.org:46891/'],
        faucets: [],
        nativeCurrency: { name: 'Wancoin', symbol: 'WAN', decimals: 18 },
        infoURL: 'https://testnet.wanscan.org',
        shortName: 'twan',
        chainId: 999,
        networkId: 999,
        slip44: 1,
        icon: 'wanchain',
        explorers: [
            {
                name: 'wanscan',
                icon: 'wanchain',
                url: 'https://testnet.wanscan.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcRVHdG7Sr1f26DhkBwE1YuwFZXFjNth5S3TookXoyFaq'
    },
    1000: {
        name: 'GTON Mainnet',
        chain: 'GTON',
        rpc: ['https://rpc.gton.network/'],
        faucets: [],
        nativeCurrency: { name: 'GCD', symbol: 'GCD', decimals: 18 },
        infoURL: 'https://gton.capital',
        shortName: 'gton',
        chainId: 1000,
        networkId: 1000,
        explorers: [
            {
                name: 'GTON Network Explorer',
                url: 'https://explorer.gton.network',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-1' }
    },
    1001: {
        name: 'Kaia Kairos Testnet',
        chain: 'KAIA',
        rpc: ['https://public-en-kairos.node.kaia.io'],
        faucets: ['https://faucet.kaia.io'],
        nativeCurrency: { name: 'KAIA', symbol: 'KAIA', decimals: 18 },
        infoURL: 'https://kaia.io/',
        shortName: 'kaia-kairos',
        chainId: 1001,
        networkId: 1001,
        slip44: 1,
        explorers: [
            {
                name: 'Kaiascope',
                url: 'https://kairos.kaiascope.com',
                standard: 'EIP3091'
            },
            {
                name: 'Kaiascan',
                url: 'https://kairos.kaiascan.io',
                standard: 'EIP3091'
            }
        ]
    },
    1003: {
        name: 'Tectum Emission Token',
        chain: 'TET',
        rpc: ['https://rpc.softnote.com/'],
        faucets: [],
        nativeCurrency: { name: 'Tectum', symbol: 'TET', decimals: 8 },
        infoURL: 'https://softnote.com',
        shortName: 'tet',
        chainId: 1003,
        networkId: 1003,
        explorers: [
            {
                name: 'Tectum explorer',
                url: 'https://explorer.tectum.io',
                icon: 'Tettoken256',
                standard: 'EIP3091'
            }
        ]
    },
    1004: {
        name: 'T-EKTA',
        title: 'EKTA Testnet T-EKTA',
        chain: 'T-EKTA',
        rpc: ['https://test.ekta.io:8545'],
        faucets: [],
        nativeCurrency: { name: 'T-EKTA', symbol: 'T-EKTA', decimals: 18 },
        infoURL: 'https://www.ekta.io',
        shortName: 't-ekta',
        chainId: 1004,
        networkId: 1004,
        icon: 'ekta',
        explorers: [
            {
                name: 'test-ektascan',
                url: 'https://test.ektascan.io',
                icon: 'ekta',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfMd564KUPK8eKZDwGCT71ZC2jMnUZqP6LCtLpup3rHH1'
    },
    1005: {
        name: 'LemonChainTestnet',
        chain: 'tLEMX',
        rpc: [
            'https://rpc.testnet.lemonchain.io',
            'https://rpc.testnet.allthingslemon.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'testnet LEMX', symbol: 'tLEMX', decimals: 18 },
        infoURL: 'https://dapp.allthingslemon.io/home',
        shortName: 'tlemx',
        chainId: 1005,
        networkId: 1005,
        explorers: []
    },
    1006: {
        name: 'LemonChain',
        chain: 'LEMX',
        rpc: ['https://rpc.lemonchain.io', 'https://rpc.allthingslemon.io'],
        faucets: [],
        nativeCurrency: { name: 'LEMX', symbol: 'LEMX', decimals: 18 },
        infoURL: 'https://dapp.allthingslemon.io/home',
        shortName: 'lemx',
        chainId: 1006,
        networkId: 1006,
        explorers: []
    },
    1007: {
        name: 'Newton Testnet',
        chain: 'NEW',
        rpc: ['https://rpc1.newchain.newtonproject.org'],
        faucets: [],
        nativeCurrency: { name: 'Newton', symbol: 'NEW', decimals: 18 },
        infoURL: 'https://www.newtonproject.org/',
        shortName: 'tnew',
        chainId: 1007,
        networkId: 1007,
        slip44: 1
    },
    1008: {
        name: 'Eurus Mainnet',
        chain: 'EUN',
        rpc: ['https://mainnet.eurus.network/'],
        faucets: [],
        nativeCurrency: { name: 'Eurus', symbol: 'EUN', decimals: 18 },
        infoURL: 'https://eurus.network',
        shortName: 'eun',
        chainId: 1008,
        networkId: 1008,
        icon: 'eurus',
        explorers: [
            {
                name: 'eurusexplorer',
                url: 'https://explorer.eurus.network',
                icon: 'eurus',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaGd5L9jGPbfyGXBFhu9gjinWJ66YtNrXq8x6Q98Eep9e'
    },
    1009: {
        name: 'Jumbochain Mainnet',
        chain: 'Jumbo',
        rpc: [
            'https://rpcpriv.jumbochain.org',
            'https://rpc-datajumbo1.jumbochain.org',
            'https://rpc-datajumbo2.jumbochain.org',
            'https://rpc-datajumbo3.jumbochain.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'JNFTC', symbol: 'JNFTC', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://jumbochain.org',
        shortName: 'Jumboscan',
        chainId: 1009,
        networkId: 1009,
        slip44: 1,
        explorers: [
            {
                name: 'Jumboscan',
                url: 'https://jumboscan.jumbochain.org',
                standard: 'EIP3091'
            }
        ]
    },
    1010: {
        name: 'Evrice Network',
        chain: 'EVC',
        rpc: ['https://meta.evrice.com'],
        faucets: [],
        nativeCurrency: { name: 'Evrice', symbol: 'EVC', decimals: 18 },
        infoURL: 'https://evrice.com',
        shortName: 'EVC',
        chainId: 1010,
        networkId: 1010,
        slip44: 1020
    },
    1011: {
        name: 'Rebus Classic Mainnet',
        title: 'Rebuschain Mainnet',
        chain: 'REBUS',
        rpc: ['https://apievm.rebuschain.com/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Rebus Classic', symbol: 'REBUS', decimals: 18 },
        infoURL: 'https://www.rebuschain.com',
        shortName: 'rebusclassic',
        chainId: 1011,
        networkId: 1011,
        icon: 'rebusc',
        explorers: [
            {
                name: 'Rebus EVM Explorer (Blockscout)',
                url: 'https://evm-l1.rebuschain.com',
                icon: 'rebus',
                standard: 'none'
            },
            {
                name: 'Rebus Cosmos Explorer (ping.pub)',
                url: 'https://cosmos.rebuschain.com',
                icon: 'rebus',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifzag46dhp33vb2uldg4htqbqipuqrapjga6ml6pnhn5yibbvb4gq'
    },
    1012: {
        name: 'Newton',
        chain: 'NEW',
        rpc: ['https://global.rpc.mainnet.newtonproject.org'],
        faucets: [],
        nativeCurrency: { name: 'Newton', symbol: 'NEW', decimals: 18 },
        infoURL: 'https://www.newtonproject.org/',
        shortName: 'new',
        chainId: 1012,
        networkId: 1012
    },
    1022: {
        name: 'Sakura',
        chain: 'Sakura',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Sakura', symbol: 'SKU', decimals: 18 },
        infoURL: 'https://clover.finance/sakura',
        shortName: 'sku',
        chainId: 1022,
        networkId: 1022
    },
    1023: {
        name: 'Clover Testnet',
        chain: 'Clover',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Clover', symbol: 'CLV', decimals: 18 },
        infoURL: 'https://clover.finance',
        shortName: 'tclv',
        chainId: 1023,
        networkId: 1023,
        slip44: 1
    },
    1024: {
        name: 'CLV Parachain',
        chain: 'CLV',
        rpc: ['https://api-para.clover.finance'],
        faucets: [],
        nativeCurrency: { name: 'CLV', symbol: 'CLV', decimals: 18 },
        infoURL: 'https://clv.org',
        shortName: 'clv',
        chainId: 1024,
        networkId: 1024
    },
    1028: {
        name: 'BitTorrent Chain Testnet',
        chain: 'BTTC',
        rpc: ['https://testrpc.bittorrentchain.io/'],
        faucets: [],
        status: 'deprecated',
        nativeCurrency: { name: 'BitTorrent', symbol: 'BTT', decimals: 18 },
        infoURL: 'https://bittorrentchain.io/',
        shortName: 'tbtt-deprecated',
        chainId: 1028,
        networkId: 1028,
        slip44: 1,
        explorers: [
            {
                name: 'testbttcscan',
                url: 'https://testscan.bittorrentchain.io',
                standard: 'none'
            }
        ]
    },
    1029: {
        name: 'BitTorrent Chain Donau',
        chain: 'BTTC',
        icon: 'bttc',
        rpc: ['https://pre-rpc.bt.io'],
        faucets: ['https://testfaucet.bt.io'],
        nativeCurrency: { name: 'BitTorrent', symbol: 'BTT', decimals: 18 },
        infoURL: 'https://bt.io',
        shortName: 'tBTT',
        chainId: 1029,
        networkId: 1029,
        slip44: 1,
        explorers: [
            {
                name: 'BitTorrent Chain Donau Explorer',
                url: 'https://testnet.bttcscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW7DmMmWVH4xTWf573AkaUD87tsWZyAxwjyvYx8vU6bjK'
    },
    1030: {
        name: 'Conflux eSpace',
        chain: 'Conflux',
        rpc: ['https://evm.confluxrpc.com'],
        faucets: [],
        nativeCurrency: { name: 'CFX', symbol: 'CFX', decimals: 18 },
        infoURL: 'https://confluxnetwork.org',
        shortName: 'cfx',
        chainId: 1030,
        networkId: 1030,
        icon: 'conflux',
        explorers: [
            {
                name: 'Conflux Scan',
                url: 'https://evm.confluxscan.net',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifj7n24u2dslfijfihwqvpdeigt5aj3k3sxv6s35lv75sxsfr3ojy'
    },
    1031: {
        name: 'Proxy Network Testnet',
        chain: 'Proxy Network',
        rpc: ['http://128.199.94.183:8041'],
        faucets: [],
        nativeCurrency: { name: 'PRX', symbol: 'PRX', decimals: 18 },
        infoURL: 'https://theproxy.network',
        shortName: 'prx',
        chainId: 1031,
        networkId: 1031,
        slip44: 1,
        explorers: [
            {
                name: 'proxy network testnet',
                url: 'http://testnet-explorer.theproxy.network',
                standard: 'EIP3091'
            }
        ]
    },
    1038: {
        name: 'Bronos Testnet',
        chain: 'Bronos',
        rpc: ['https://evm-testnet.bronos.org'],
        faucets: ['https://faucet.bronos.org'],
        nativeCurrency: { name: 'tBRO', symbol: 'tBRO', decimals: 18 },
        infoURL: 'https://bronos.org',
        shortName: 'bronos-testnet',
        chainId: 1038,
        networkId: 1038,
        slip44: 1,
        icon: 'bronos',
        explorers: [
            {
                name: 'Bronos Testnet Explorer',
                url: 'https://tbroscan.bronos.org',
                standard: 'none',
                icon: 'bronos'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeifkgtmhnq4sxu6jn22i7ass7aih6ubodr77k6ygtu4tjbvpmkw2ga'
    },
    1039: {
        name: 'Bronos Mainnet',
        chain: 'Bronos',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'BRO', symbol: 'BRO', decimals: 18 },
        infoURL: 'https://bronos.org',
        shortName: 'bronos-mainnet',
        chainId: 1039,
        networkId: 1039,
        icon: 'bronos',
        explorers: [
            {
                name: 'Bronos Explorer',
                url: 'https://broscan.bronos.org',
                standard: 'none',
                icon: 'bronos'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeifkgtmhnq4sxu6jn22i7ass7aih6ubodr77k6ygtu4tjbvpmkw2ga'
    },
    1071: {
        name: 'OpenGPU Mainnet',
        chain: 'OGPU',
        icon: 'ogpu',
        rpc: ['https://mainnet-rpc.ogpuscan.io', 'wss://mainnet-rpc.ogpuscan.io'],
        faucets: [],
        nativeCurrency: { name: 'OGPU', symbol: 'OGPU', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://opengpu.network',
        shortName: 'ogpu',
        chainId: 1071,
        networkId: 1071,
        redFlags: ['reusedChainId'],
        explorers: [
            {
                name: 'OpenGPU Explorer',
                url: 'https://ogpuscan.io',
                icon: 'ogpu',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiehdja4bvfvcagywn32zj6rvc5eicnwsdtvrsgwil52y4palgtnrq'
    },
    1072: {
        name: 'ShimmerEVM Testnet Deprecated 1072',
        title: 'ShimmerEVM Testnet Deprecated 1072',
        chain: 'ShimmerEVM',
        icon: 'shimmerevm',
        rpc: [],
        faucets: [
            'https://evm-toolkit.evm.testnet.shimmer.network',
            'https://evm-faucet.testnet.shimmer.network'
        ],
        nativeCurrency: { name: 'SMR', symbol: 'SMR', decimals: 6 },
        infoURL: 'https://shimmer.network',
        shortName: 'shimmerevm-testnet-deprecated-1072',
        chainId: 1072,
        networkId: 1072,
        slip44: 1,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer.evm.testnet.shimmer.network',
                standard: 'EIP3091'
            }
        ],
        status: 'deprecated',
        iconURL: 'https://ipfs.io/ipfs/bafkreibky2sy6qhi6arktayvologkrgu5kudpgdxfkx4uosbvmstz7v4di'
    },
    1073: {
        name: 'ShimmerEVM Testnet',
        title: 'ShimmerEVM Testnet',
        chain: 'ShimmerEVM',
        icon: 'shimmerevm',
        rpc: ['https://json-rpc.evm.testnet.shimmer.network'],
        faucets: [
            'https://evm-toolkit.evm.testnet.shimmer.network',
            'https://evm-faucet.testnet.shimmer.network'
        ],
        nativeCurrency: { name: 'SMR', symbol: 'SMR', decimals: 18 },
        infoURL: 'https://shimmer.network',
        shortName: 'shimmerevm-testnet',
        chainId: 1073,
        networkId: 1073,
        slip44: 1,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer.evm.testnet.shimmer.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibky2sy6qhi6arktayvologkrgu5kudpgdxfkx4uosbvmstz7v4di'
    },
    1075: {
        name: 'IOTA EVM Testnet',
        title: 'IOTA EVM Testnet',
        chain: 'IOTA EVM',
        icon: 'iotaevm',
        rpc: ['https://json-rpc.evm.testnet.iotaledger.net'],
        faucets: ['https://evm-toolkit.evm.testnet.iotaledger.net'],
        nativeCurrency: { name: 'IOTA', symbol: 'IOTA', decimals: 18 },
        infoURL: 'https://www.iota.org',
        shortName: 'iotaevm-testnet',
        chainId: 1075,
        networkId: 1075,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer.evm.testnet.iotaledger.net',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibky2sy6qhi6arktayvologkrgu5kudpgdxfkx4uosbvmstz7v4di'
    },
    1079: {
        name: 'Mintara Testnet',
        title: 'Mintara Testnet',
        chain: 'Mintara',
        icon: 'mintara',
        rpc: ['https://subnets.avax.network/mintara/testnet/rpc'],
        faucets: [],
        nativeCurrency: { name: 'MINTARA', symbol: 'MNTR', decimals: 18 },
        infoURL: 'https://playthink.co.jp',
        shortName: 'mintara-testnet',
        chainId: 1079,
        networkId: 1079,
        slip44: 1,
        explorers: [
            {
                name: 'explorer',
                url: 'https://subnets-test.avax.network/mintara',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeie7jzlzlpz7c3a3oh4x5joej23dj2qf3cexmchjyc72hv3fblcaja'
    },
    1080: {
        name: 'Mintara Mainnet',
        title: 'Mintara Mainnet',
        chain: 'Mintara',
        icon: 'mintara',
        rpc: ['https://subnets.avax.network/mintara/mainnet/rpc'],
        faucets: [],
        nativeCurrency: { name: 'MINTARA', symbol: 'MNTR', decimals: 18 },
        infoURL: 'https://playthink.co.jp',
        shortName: 'mintara',
        chainId: 1080,
        networkId: 1080,
        explorers: [
            {
                name: 'explorer',
                url: 'https://subnets.avax.network/mintara',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeie7jzlzlpz7c3a3oh4x5joej23dj2qf3cexmchjyc72hv3fblcaja'
    },
    1088: {
        name: 'Metis Andromeda Mainnet',
        chain: 'ETH',
        rpc: [
            'https://andromeda.metis.io/?owner=1088',
            'https://metis.drpc.org',
            'wss://metis.drpc.org',
            'https://metis-rpc.publicnode.com',
            'wss://metis-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Metis', symbol: 'METIS', decimals: 18 },
        infoURL: 'https://www.metis.io',
        shortName: 'metis-andromeda',
        chainId: 1088,
        networkId: 1088,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://andromeda-explorer.metis.io',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.metis.io' }]
        }
    },
    1089: {
        name: 'Humans.ai Mainnet',
        chain: 'Humans',
        rpc: [
            'https://jsonrpc.humans.nodestake.top',
            'https://humans-mainnet-evm.itrocket.net',
            'https://humans-evm-rpc.staketab.org:443',
            'https://evm.humans.stakepool.dev.br',
            'https://mainnet-humans-evm.konsortech.xyz',
            'https://evm-rpc.mainnet.humans.zone',
            'https://json-rpc.humans.bh.rocks',
            'https://evm-rpc.humans.huginn.tech'
        ],
        faucets: [],
        nativeCurrency: { name: 'HEART', symbol: 'HEART', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://humans.ai',
        shortName: 'humans',
        chainId: 1089,
        networkId: 1089,
        icon: 'humans-dark',
        explorers: [
            {
                name: 'explorer.guru',
                url: 'https://humans.explorers.guru',
                icon: 'humans',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmX6XuoQDTTjYqAmdNJiieLDZSwHHyUx44yQb4E3tmHmEA'
    },
    1099: {
        name: 'MOAC mainnet',
        chain: 'MOAC',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'MOAC', symbol: 'mc', decimals: 18 },
        infoURL: 'https://moac.io',
        shortName: 'moac',
        chainId: 1099,
        networkId: 1099,
        slip44: 314,
        explorers: [
            {
                name: 'moac explorer',
                url: 'https://explorer.moac.io',
                standard: 'none'
            }
        ]
    },
    1100: {
        name: 'Dymension',
        chain: 'Dymension',
        rpc: [
            'https://dymension-evm.blockpi.network/v1/rpc/public',
            'https://dymension-evm-rpc.publicnode.com',
            'wss://dymension-evm-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'DYM', symbol: 'DYM', decimals: 18 },
        infoURL: 'https://dymension.xyz',
        shortName: 'dymension',
        icon: 'dymension',
        chainId: 1100,
        networkId: 1100,
        explorers: [
            { name: 'dym.fyi', url: 'https://dym.fyi', standard: 'EIP3091' }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreic4sjyqikz33xzpcctczvkiwfj44q5i3i7zslycnjiqmyx5ybc3fi'
    },
    1101: {
        name: 'Polygon zkEVM',
        title: 'Polygon zkEVM',
        chain: 'Polygon',
        rpc: [
            'https://zkevm-rpc.com',
            'https://polygon-zkevm.drpc.org',
            'wss://polygon-zkevm.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://polygon.technology/polygon-zkevm',
        shortName: 'zkevm',
        chainId: 1101,
        networkId: 1101,
        icon: 'zkevm',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://zkevm.polygonscan.com',
                icon: 'zkevm',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.zkevm-rpc.com' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmNmJZkQgx9RcFLS3rvxQTVYcPfyAFPr667keHTUxB9PDv'
    },
    1107: {
        name: 'BLXq Testnet',
        chain: 'BLXQ',
        icon: 'blxq',
        rpc: ['https://testnetq1.blx.org'],
        faucets: [],
        nativeCurrency: { name: 'BLXQ', symbol: 'BLXQ', decimals: 18 },
        infoURL: 'https://blx.org',
        shortName: 'tblxq',
        chainId: 1107,
        networkId: 1107,
        slip44: 1,
        explorers: [
            {
                name: 'BLXq Explorer',
                url: 'https://explorer.blx.org',
                icon: 'blxq',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmS9kDKr1rgcz5W55yCQVfFs1vRTCneaLHt1t9cBizpqpH'
    },
    1108: {
        name: 'BLXq Mainnet',
        chain: 'BLXQ',
        icon: 'blxq',
        rpc: ['https://mainnet.blxq.org'],
        faucets: [],
        nativeCurrency: { name: 'BLXQ', symbol: 'BLXQ', decimals: 18 },
        infoURL: 'https://blx.org',
        shortName: 'blxq',
        chainId: 1108,
        networkId: 1108,
        explorers: [
            {
                name: 'BLXq Explorer',
                url: 'https://explorer.blxq.org',
                icon: 'blxq',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmS9kDKr1rgcz5W55yCQVfFs1vRTCneaLHt1t9cBizpqpH'
    },
    1111: {
        name: 'WEMIX3.0 Mainnet',
        chain: 'WEMIX',
        rpc: ['https://api.wemix.com', 'wss://ws.wemix.com'],
        faucets: [],
        nativeCurrency: { name: 'WEMIX', symbol: 'WEMIX', decimals: 18 },
        infoURL: 'https://wemix.com',
        shortName: 'wemix',
        chainId: 1111,
        networkId: 1111,
        explorers: [
            {
                name: 'WEMIX Block Explorer',
                url: 'https://explorer.wemix.com',
                standard: 'EIP3091'
            }
        ]
    },
    1112: {
        name: 'WEMIX3.0 Testnet',
        chain: 'TWEMIX',
        rpc: ['https://api.test.wemix.com', 'wss://ws.test.wemix.com'],
        faucets: ['https://wallet.test.wemix.com/faucet'],
        nativeCurrency: { name: 'TestnetWEMIX', symbol: 'tWEMIX', decimals: 18 },
        infoURL: 'https://wemix.com',
        shortName: 'twemix',
        chainId: 1112,
        networkId: 1112,
        slip44: 1,
        explorers: [
            {
                name: 'WEMIX Testnet Microscope',
                url: 'https://microscope.test.wemix.com',
                standard: 'EIP3091'
            }
        ]
    },
    1113: {
        name: 'B2 Hub Testnet',
        chain: 'BSQ',
        rpc: ['https://testnet-hub-rpc.bsquared.network'],
        faucets: [],
        nativeCurrency: { name: 'BSquared Token', symbol: 'B2', decimals: 18 },
        infoURL: 'https://www.bsquared.network',
        shortName: 'B2Hub-testnet',
        chainId: 1113,
        networkId: 1113,
        icon: 'bsquare',
        explorers: [
            {
                name: 'B2 Hub Habitat Testnet Explorer',
                url: 'https://testnet-hub-explorer.bsquared.network',
                icon: 'bsquare',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPV6ASrQDEkEW3g3ni7p2rJMPeciRLpEpvrAc1QfzVkx9'
    },
    1114: {
        name: 'Core Blockchain Testnet2',
        chain: 'Core',
        icon: 'core',
        rpc: ['https://rpc.test2.btcs.network/'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://scan.test2.btcs.network/faucet'],
        nativeCurrency: {
            name: 'Core Blockchain Testnet2 Native Token',
            symbol: 'tCORE2',
            decimals: 18
        },
        infoURL: 'https://www.coredao.org',
        shortName: 'tcore2',
        chainId: 1114,
        networkId: 1114,
        slip44: 1,
        explorers: [
            {
                name: 'Core Scan Testnet2',
                url: 'https://scan.test2.btcs.network',
                icon: 'core',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdUgiGaD6fGjhb9x1NvfccvEBBFq2YHSm9yb8FNhpwHkW'
    },
    1115: {
        name: 'Core Blockchain Testnet',
        chain: 'Core',
        icon: 'core',
        rpc: ['https://rpc.test.btcs.network/'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://scan.test.btcs.network/faucet'],
        nativeCurrency: {
            name: 'Core Blockchain Testnet Native Token',
            symbol: 'tCORE',
            decimals: 18
        },
        infoURL: 'https://www.coredao.org',
        shortName: 'tcore',
        chainId: 1115,
        networkId: 1115,
        slip44: 1,
        explorers: [
            {
                name: 'Core Scan Testnet',
                url: 'https://scan.test.btcs.network',
                icon: 'core',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdUgiGaD6fGjhb9x1NvfccvEBBFq2YHSm9yb8FNhpwHkW'
    },
    1116: {
        name: 'Core Blockchain Mainnet',
        chain: 'Core',
        icon: 'core',
        rpc: [
            'https://rpc.coredao.org/',
            'https://rpc-core.icecreamswap.com',
            'https://core.drpc.org',
            'wss://core.drpc.org'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: {
            name: 'Core Blockchain Native Token',
            symbol: 'CORE',
            decimals: 18
        },
        infoURL: 'https://www.coredao.org',
        shortName: 'core',
        chainId: 1116,
        networkId: 1116,
        explorers: [
            {
                name: 'Core Scan',
                url: 'https://scan.coredao.org',
                icon: 'core',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdUgiGaD6fGjhb9x1NvfccvEBBFq2YHSm9yb8FNhpwHkW'
    },
    1117: {
        name: 'Dogcoin Mainnet',
        chain: 'DOGS',
        icon: 'dogs',
        rpc: ['https://mainnet-rpc.dogcoin.me'],
        faucets: ['https://faucet.dogcoin.network'],
        nativeCurrency: { name: 'Dogcoin', symbol: 'DOGS', decimals: 18 },
        infoURL: 'https://dogcoin.network',
        shortName: 'DOGSm',
        chainId: 1117,
        networkId: 1117,
        explorers: [
            {
                name: 'Dogcoin',
                url: 'https://explorer.dogcoin.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZCadkExKThak3msvszZjo6UnAbUJKE61dAcg4TixuMC3'
    },
    1123: {
        name: 'B2 Testnet',
        title: 'B2 Testnet',
        chain: 'Habitat',
        rpc: [
            'https://b2-testnet.alt.technology',
            'https://rpc.ankr.com/b2_testnet',
            'https://testnet-rpc.bsquared.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Bitcoin', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://www.bsquared.network',
        shortName: 'B2-testnet',
        chainId: 1123,
        networkId: 1123,
        icon: 'bsquare',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet-explorer.bsquared.network',
                icon: 'bsquare',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-1113' },
        iconURL: 'https://ipfs.io/ipfs/QmPV6ASrQDEkEW3g3ni7p2rJMPeciRLpEpvrAc1QfzVkx9'
    },
    1125: {
        name: 'Taker Chain Mainnet',
        chain: 'Taker',
        icon: 'taker',
        rpc: ['https://rpc-mainnet.taker.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Taker', symbol: 'TAKER', decimals: 18 },
        infoURL: 'https://www.taker.xyz',
        shortName: 'taker',
        chainId: 1125,
        networkId: 1125,
        explorers: [
            {
                name: 'TakerScan',
                url: 'https://explorer.taker.xyz',
                icon: 'taker',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmS3EEhWSZCXkKWddm1eQPifDY2kdFPaAfZuZUftPKB7x3'
    },
    1130: {
        name: 'DeFiChain EVM Network Mainnet',
        chain: 'defichain-evm',
        status: 'incubating',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'DeFiChain', symbol: 'DFI', decimals: 18 },
        infoURL: 'https://meta.defichain.com/',
        shortName: 'DFI',
        chainId: 1130,
        networkId: 1130,
        slip44: 1130,
        icon: 'defichain-network',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmdR3YL9F95ajwVwfxAGoEzYwm9w7JNsPSfUPjSaQogVjK'
    },
    1131: {
        name: 'DeFiChain EVM Network Testnet',
        chain: 'defichain-evm-testnet',
        status: 'incubating',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'DeFiChain', symbol: 'DFI', decimals: 18 },
        infoURL: 'https://meta.defichain.com/',
        shortName: 'DFI-T',
        chainId: 1131,
        networkId: 1131,
        slip44: 1,
        icon: 'defichain-network',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmdR3YL9F95ajwVwfxAGoEzYwm9w7JNsPSfUPjSaQogVjK'
    },
    1133: {
        name: 'DeFiMetaChain Changi Testnet',
        icon: 'defichain-network',
        chain: 'DFI',
        rpc: [
            'https://dmc.mydefichain.com/changi',
            'https://testnet-dmc.mydefichain.com:20551'
        ],
        faucets: ['http://tc04.mydefichain.com/faucet'],
        nativeCurrency: { name: 'DeFiChain Token', symbol: 'DFI', decimals: 18 },
        infoURL: 'https://meta.defichain.com',
        shortName: 'changi',
        chainId: 1133,
        networkId: 1133,
        explorers: [
            {
                name: 'MetaScan',
                url: 'https://meta.defiscan.live',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdR3YL9F95ajwVwfxAGoEzYwm9w7JNsPSfUPjSaQogVjK'
    },
    1134: {
        name: 'StateMesh',
        icon: 'statemesh',
        chain: 'MESH',
        rpc: ['https://rpc.statemesh.net'],
        faucets: [],
        nativeCurrency: { name: 'StateMesh', symbol: 'MESH', decimals: 18 },
        infoURL: 'https://statemesh.net',
        shortName: 'mesh',
        chainId: 1134,
        networkId: 1134,
        slip44: 1134,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://scan.statemesh.net',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmc7KBcdrXMKvaq1xN6mubEqpvHdheFxs1YGZwZgLEPDrK'
    },
    1135: {
        name: 'Lisk',
        chain: 'ETH',
        icon: 'lisk',
        rpc: ['https://rpc.api.lisk.com'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://lisk.com',
        shortName: 'lisk',
        chainId: 1135,
        networkId: 1135,
        slip44: 134,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.lisk.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVTS8jmWD5e7jVEn86wLjJsuMnc6s8fym3JbtE4etzSKf'
    },
    1138: {
        name: 'AmStar Testnet',
        chain: 'AmStar',
        icon: 'amstar',
        rpc: ['https://testnet-rpc.amstarscan.com'],
        faucets: [],
        nativeCurrency: { name: 'SINSO', symbol: 'SINSO', decimals: 18 },
        infoURL: 'https://sinso.io',
        shortName: 'ASARt',
        chainId: 1138,
        networkId: 1138,
        slip44: 1,
        explorers: [
            {
                name: 'amstarscan-testnet',
                url: 'https://testnet.amstarscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmd4TMQdnYxaUZqnVddh5S37NGH72g2kkK38ccCEgdZz1C'
    },
    1139: {
        name: 'MathChain',
        chain: 'MATH',
        rpc: [
            'https://mathchain-asia.maiziqianbao.net/rpc',
            'https://mathchain-us.maiziqianbao.net/rpc'
        ],
        faucets: [],
        nativeCurrency: { name: 'MathChain', symbol: 'MATH', decimals: 18 },
        infoURL: 'https://mathchain.org',
        shortName: 'MATH',
        chainId: 1139,
        networkId: 1139
    },
    1140: {
        name: 'MathChain Testnet',
        chain: 'MATH',
        rpc: ['https://galois-hk.maiziqianbao.net/rpc'],
        faucets: ['https://scan.boka.network/#/Galois/faucet'],
        nativeCurrency: { name: 'MathChain', symbol: 'MATH', decimals: 18 },
        infoURL: 'https://mathchain.org',
        shortName: 'tMATH',
        chainId: 1140,
        networkId: 1140,
        slip44: 1
    },
    1147: {
        name: 'Flag Testnet',
        chain: 'Flag',
        icon: 'flag',
        rpc: ['https://testnet-rpc.flagscan.xyz'],
        faucets: ['https://faucet.flagscan.xyz'],
        nativeCurrency: { name: 'Flag Testnet', symbol: 'FLAG', decimals: 18 },
        infoURL: 'https://testnet-explorer.flagscan.xyz',
        shortName: 'tFLAG',
        chainId: 1147,
        networkId: 1147,
        explorers: [
            {
                name: 'Flag Testnet Explorer',
                url: 'https://testnet-explorer.flagscan.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeibcrxeavdxpwwmj4mc6hhp232nkrfbpvfpngcqux2v5rmoshycj3u'
    },
    1149: {
        name: 'Symplexia Smart Chain',
        chain: 'Plexchain',
        rpc: ['https://plex-rpc.plexfinance.us'],
        faucets: [],
        nativeCurrency: { name: 'Plex Native Token', symbol: 'PLEX', decimals: 18 },
        infoURL: 'https://plexfinance.us/',
        shortName: 'Plexchain',
        chainId: 1149,
        networkId: 1149,
        icon: 'plexchain',
        explorers: [
            {
                name: 'Plexchain Explorer',
                url: 'https://explorer.plexfinance.us',
                icon: 'plexchain',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcXzfMNSQ7SZzKemNquVoXyG5ergdqCGeLWjRYETGBTUM'
    },
    1170: {
        name: 'Origin Testnet',
        chain: 'Origin',
        rpc: ['https://json-rpc.origin.uptick.network'],
        faucets: [],
        nativeCurrency: { name: 'Origin', symbol: 'UOC', decimals: 18 },
        infoURL: 'https://www.uptick.network',
        shortName: 'auoc',
        chainId: 1170,
        networkId: 1170,
        slip44: 1,
        icon: 'origin',
        explorers: [
            {
                name: 'Origin Explorer',
                url: 'https://evm-explorer.origin.uptick.network',
                icon: 'origin',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRGJ6PqYHDTWuUQ6xfnK8S82NzRXiMjTnSGat9qtLuaLP'
    },
    1174: {
        name: 'Litheum Test Network',
        chain: 'Litheum',
        rpc: ['https://testnet.litheum.com'],
        faucets: [],
        nativeCurrency: { name: 'Lith', symbol: 'LTH', decimals: 18 },
        infoURL: 'https://litheum.com',
        shortName: 'lith',
        chainId: 1174,
        networkId: 1174,
        explorers: [
            {
                name: 'Litheum Test Network Explorer',
                url: 'https://explorer.litheum.com',
                standard: 'EIP3091'
            }
        ]
    },
    1177: {
        name: 'Smart Host Teknoloji TESTNET',
        chain: 'SHT',
        rpc: ['https://s2.tl.web.tr:4041'],
        faucets: [],
        nativeCurrency: {
            name: 'Smart Host Teknoloji TESTNET',
            symbol: 'tSHT',
            decimals: 18
        },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://smart-host.com.tr',
        shortName: 'sht',
        chainId: 1177,
        networkId: 1177,
        slip44: 1,
        icon: 'smarthost',
        explorers: [
            {
                name: 'Smart Host Teknoloji TESTNET Explorer',
                url: 'https://s2.tl.web.tr:4000',
                icon: 'smarthost',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTrLGHyQ1Le25Q7EgNSF5Qq8D2SocKvroDkLqurdBuSQQ'
    },
    1188: {
        name: 'ClubMos Mainnet',
        chain: 'MOS',
        rpc: ['https://mainnet.mosscan.com'],
        faucets: [],
        nativeCurrency: { name: 'ClubMos', symbol: 'MOS', decimals: 18 },
        infoURL: 'https://www.mosscan.com',
        shortName: 'MOS',
        chainId: 1188,
        networkId: 1188,
        icon: 'clubmos',
        explorers: [
            {
                name: 'mosscan',
                url: 'https://www.mosscan.com',
                icon: 'clubmos',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmczQf61mZmg3NmmGnwseDxzH1AqapA252KCTT85GuNG96'
    },
    1197: {
        name: 'Iora Chain',
        chain: 'IORA',
        icon: 'iorachain',
        rpc: ['https://dataseed.iorachain.com'],
        faucets: [],
        nativeCurrency: { name: 'Iora', symbol: 'IORA', decimals: 18 },
        infoURL: 'https://iorachain.com',
        shortName: 'iora',
        chainId: 1197,
        networkId: 1197,
        explorers: [
            {
                name: 'ioraexplorer',
                url: 'https://explorer.iorachain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeiehps5cqdhqottu2efo4jeehwpkz5rbux3cjxd75rm6rjm4sgs2wi'
    },
    1200: {
        name: 'Cuckoo Chain',
        title: 'Cuckoo Chain',
        chain: 'CuckooAI',
        rpc: [
            'https://mainnet-rpc.cuckoo.network',
            'wss://mainnet-rpc.cuckoo.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'CuckooAI', symbol: 'CAI', decimals: 18 },
        infoURL: 'https://cuckoo.network',
        shortName: 'cai',
        chainId: 1200,
        networkId: 1200,
        explorers: [
            {
                name: 'Cuckoo Chain Explorer',
                url: 'https://scan.cuckoo.network',
                standard: 'EIP3091'
            }
        ]
    },
    1201: {
        name: 'Evanesco Testnet',
        chain: 'Evanesco Testnet',
        rpc: ['https://seed5.evanesco.org:8547'],
        faucets: [],
        nativeCurrency: { name: 'AVIS', symbol: 'AVIS', decimals: 18 },
        infoURL: 'https://evanesco.org/',
        shortName: 'avis',
        chainId: 1201,
        networkId: 1201,
        slip44: 1
    },
    1202: {
        name: 'World Trade Technical Chain Mainnet',
        chain: 'WTT',
        rpc: ['https://rpc.cadaut.com', 'wss://rpc.cadaut.com/ws'],
        faucets: [],
        nativeCurrency: { name: 'World Trade Token', symbol: 'WTT', decimals: 18 },
        infoURL: 'http://www.cadaut.com',
        shortName: 'wtt',
        chainId: 1202,
        networkId: 2048,
        explorers: [
            {
                name: 'WTTScout',
                url: 'https://explorer.cadaut.com',
                standard: 'EIP3091'
            }
        ]
    },
    1209: {
        name: 'SaitaBlockChain(SBC)',
        chain: 'SaitaBlockChain(SBC)',
        rpc: ['https://rpc-nodes.saitascan.io'],
        faucets: [],
        nativeCurrency: {
            name: 'SaitaBlockChain(SBC)',
            symbol: 'STC',
            decimals: 18
        },
        infoURL: 'https://saitachain.com',
        shortName: 'SBC',
        chainId: 1209,
        networkId: 1209,
        icon: 'SaitaBlockChain(SBC)',
        explorers: [
            {
                name: 'Saitascan explorer',
                url: 'https://saitascan.io',
                standard: 'none',
                icon: 'SaitaBlockChain(SBC)'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVFWTqfqnMXbiPKpDFucE9QSQ1SVsUWs4HxBqRGjgQCbu'
    },
    1210: {
        name: 'Cuckoo Sepolia',
        title: 'Cuckoo AI Testnet Sepolia',
        chain: 'CuckooAI',
        rpc: [
            'https://testnet-rpc.cuckoo.network',
            'wss://testnet-rpc.cuckoo.network'
        ],
        faucets: ['https://cuckoo.network/portal/faucet/'],
        nativeCurrency: { name: 'CuckooAI', symbol: 'CAI', decimals: 18 },
        infoURL: 'https://cuckoo.network',
        shortName: 'caisepolia',
        chainId: 1210,
        networkId: 1210,
        explorers: []
    },
    1212: {
        name: 'ADF Chain Testnet',
        chain: 'ADF Chain Testnet',
        icon: 'addfilltest',
        rpc: ['https://testnet.adftechnology.com/'],
        faucets: [],
        nativeCurrency: { name: 'ADDFILL Testnet', symbol: 'tADF', decimals: 18 },
        infoURL: 'https://www.adfstarworld.com/',
        shortName: 'tADF',
        chainId: 1212,
        networkId: 1212,
        explorers: [
            {
                name: 'ADF Testnet explorer',
                url: 'https://testnet-explorer.adftechnology.com',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmWoKvjVs92PNzqd6hz7714wHSx3TuWEMBVcdG7ujhW9Qx'
    },
    1213: {
        name: 'Popcateum Mainnet',
        chain: 'POPCATEUM',
        rpc: ['https://dataseed.popcateum.org'],
        faucets: [],
        nativeCurrency: { name: 'Popcat', symbol: 'POP', decimals: 18 },
        infoURL: 'https://popcateum.org',
        shortName: 'popcat',
        chainId: 1213,
        networkId: 1213,
        explorers: [
            {
                name: 'popcateum explorer',
                url: 'https://explorer.popcateum.org',
                standard: 'none'
            }
        ]
    },
    1214: {
        name: 'EnterChain Mainnet',
        chain: 'ENTER',
        rpc: ['https://tapi.entercoin.net/'],
        faucets: [],
        nativeCurrency: { name: 'EnterCoin', symbol: 'ENTER', decimals: 18 },
        infoURL: 'https://entercoin.net',
        shortName: 'enter',
        chainId: 1214,
        networkId: 1214,
        icon: 'enter',
        explorers: [
            {
                name: 'Enter Explorer - Expenter',
                url: 'https://explorer.entercoin.net',
                icon: 'enter',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmb2UYVc1MjLPi8vhszWRxqBJYoYkWQVxDJRSmtrgk6j2E'
    },
    1215: {
        name: 'ADF Chain',
        chain: 'ADF Chain',
        icon: 'addfillmain',
        rpc: ['https://mainnet.adftechnology.com/'],
        faucets: [],
        nativeCurrency: { name: 'ADDFILL', symbol: 'ADF', decimals: 18 },
        infoURL: 'https://www.adfstarworld.com/',
        shortName: 'ADF',
        chainId: 1215,
        networkId: 1215,
        explorers: [
            {
                name: 'ADF explorer',
                url: 'https://explorer.adftechnology.com',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmWoKvjVs92PNzqd6hz7714wHSx3TuWEMBVcdG7ujhW9Qx'
    },
    1221: {
        name: 'Cycle Network Testnet',
        chain: 'ETH',
        rpc: ['https://rpc-testnet.cyclenetwork.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.cyclenetwork.io/',
        shortName: 'Cycle',
        chainId: 1221,
        networkId: 1221,
        icon: 'cycle',
        iconURL: 'https://ipfs.io/ipfs/QmeC4mKGbBpwmLfFxUSsareWkSWJomevUmex8ajjxo1zHx'
    },
    1223: {
        name: 'Cycle Network Testnet Jellyfish',
        chain: 'ETH',
        rpc: ['https://jellyfish-rpc-testnet.cyclenetwork.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.cyclenetwork.io/',
        shortName: 'cyclej',
        chainId: 1223,
        networkId: 1223,
        icon: 'cycle',
        iconURL: 'https://ipfs.io/ipfs/QmeC4mKGbBpwmLfFxUSsareWkSWJomevUmex8ajjxo1zHx'
    },
    1224: {
        name: 'Hybrid Testnet (Deprecated)',
        chain: 'HYB',
        icon: 'hybridIcon',
        rpc: ['https://testnet-rpc.buildonhybrid.com'],
        faucets: [],
        nativeCurrency: { name: 'Hybrid', symbol: 'HYB', decimals: 18 },
        infoURL: 'https://buildonhybrid.com',
        shortName: 'hyb_deprecated',
        chainId: 1224,
        status: 'deprecated',
        networkId: 1224,
        explorers: [
            {
                name: 'Hybrid Testnet',
                url: 'https://explorer.buildonhybrid.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdGfvH9qfvbMXYKosS1nHbw3q5UtFJky4hdMDmmKDTx8Y'
    },
    1225: {
        name: 'Hybrid Testnet',
        chain: 'HYB',
        icon: 'hybridIcon',
        rpc: [
            'https://hybrid-testnet.rpc.caldera.xyz/http',
            'wss://hybrid-testnet.rpc.caldera.xyz/ws'
        ],
        faucets: [],
        nativeCurrency: { name: 'Hybrid', symbol: 'HYB', decimals: 18 },
        infoURL: 'https://buildonhybrid.com',
        shortName: 'hyb',
        chainId: 1225,
        networkId: 1225,
        explorers: [
            {
                name: 'Hybrid Testnet',
                url: 'https://explorer.buildonhybrid.com',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmdGfvH9qfvbMXYKosS1nHbw3q5UtFJky4hdMDmmKDTx8Y'
    },
    1227: {
        name: 'Bitcoin Protocol Testnet',
        chain: 'BTCP Testnet',
        icon: 'btcprotocol',
        rpc: ['https://testnet-chain.btcprotocol.io/'],
        faucets: [],
        nativeCurrency: { name: 'BTC Protocol', symbol: 'BTCP', decimals: 18 },
        infoURL: 'https://btcprotocol.io/',
        shortName: 'BTCP',
        chainId: 1227,
        networkId: 1227,
        explorers: [
            {
                name: 'BTCP explorer',
                url: 'https://explorer.btcprotocol.io',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmYgFtJjxUgUDr3L9fsXvgzUTanrzcNj2e6RJ8VmkwpcuB'
    },
    1228: {
        name: 'Cycle Network Testnet Cuttlefish',
        chain: 'ETH',
        rpc: ['https://cuttlefish-rpc-testnet.cyclenetwork.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.cyclenetwork.io/',
        shortName: 'cyclec',
        chainId: 1228,
        networkId: 1228,
        icon: 'cycle',
        iconURL: 'https://ipfs.io/ipfs/QmeC4mKGbBpwmLfFxUSsareWkSWJomevUmex8ajjxo1zHx'
    },
    1229: {
        name: 'Exzo Network Mainnet',
        chain: 'EXZO',
        icon: 'exzo',
        rpc: ['https://mainnet.exzo.technology'],
        faucets: [],
        nativeCurrency: { name: 'Exzo', symbol: 'XZO', decimals: 18 },
        infoURL: 'https://exzo.network',
        shortName: 'xzo',
        chainId: 1229,
        networkId: 1229,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://exzoscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeYpc2JfEsHa2Bh11SKRx3sgDtMeg6T8KpXNLepBEKnbJ'
    },
    1230: {
        name: 'Ultron Testnet',
        chain: 'Ultron',
        icon: 'ultron',
        rpc: ['https://ultron-dev.io'],
        faucets: [],
        nativeCurrency: { name: 'Ultron', symbol: 'ULX', decimals: 18 },
        infoURL: 'https://ultron.foundation',
        shortName: 'UltronTestnet',
        chainId: 1230,
        networkId: 1230,
        slip44: 1,
        explorers: [
            {
                name: 'Ultron Testnet Explorer',
                url: 'https://explorer.ultron-dev.io',
                icon: 'ultron',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPC6odFVyAQrXJQaZJVFpEQfRNbzZ5BjDZ7KBKmXPaYDw'
    },
    1231: {
        name: 'Ultron Mainnet',
        chain: 'Ultron',
        icon: 'ultron',
        rpc: ['https://ultron-rpc.net'],
        faucets: [],
        nativeCurrency: { name: 'Ultron', symbol: 'ULX', decimals: 18 },
        infoURL: 'https://ultron.foundation',
        shortName: 'UtronMainnet',
        chainId: 1231,
        networkId: 1231,
        explorers: [
            {
                name: 'Ultron Explorer',
                url: 'https://ulxscan.com',
                icon: 'ultron',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPC6odFVyAQrXJQaZJVFpEQfRNbzZ5BjDZ7KBKmXPaYDw'
    },
    1234: {
        name: 'Step Network',
        title: 'Step Main Network',
        chain: 'STEP',
        icon: 'step',
        rpc: ['https://rpc.step.network'],
        faucets: [],
        nativeCurrency: { name: 'FITFI', symbol: 'FITFI', decimals: 18 },
        infoURL: 'https://step.network',
        shortName: 'step',
        chainId: 1234,
        networkId: 1234,
        explorers: [
            {
                name: 'StepScan',
                url: 'https://stepscan.io',
                icon: 'step',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-43114',
            bridges: [{ url: 'https://bridge.step.network' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmVp9jyb3UFW71867yVtymmiRw7dPY4BTnsp3hEjr9tn8L'
    },
    1235: {
        name: 'ITX Mainnet',
        chain: 'ITX',
        rpc: ['https://rpc.itxchain.com'],
        faucets: [],
        nativeCurrency: { name: 'ITX', symbol: 'ITX', decimals: 18 },
        infoURL: 'https://explorer.itxchain.com',
        shortName: 'itx',
        chainId: 1235,
        networkId: 1235,
        explorers: [
            {
                name: 'ITX Mainnet Explorer (Blockscout)',
                url: 'https://explorer.itxchain.com',
                standard: 'EIP3091'
            }
        ]
    },
    1243: {
        name: 'ARC Mainnet',
        chain: 'ARC',
        icon: 'arc',
        rpc: ['https://rpc-main-1.archiechain.io'],
        faucets: [],
        nativeCurrency: { name: 'ARC', symbol: 'ARC', decimals: 18 },
        infoURL: 'https://archiechain.io/',
        shortName: 'ARC',
        chainId: 1243,
        networkId: 1243,
        explorers: [
            {
                name: 'archiescan',
                url: 'https://app.archiescan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeiady63oqduls2pm4aaykzjhahblagokhnpsc5qeq5dmkxqelh7i2i'
    },
    1244: {
        name: 'ARC Testnet',
        chain: 'ARC',
        icon: 'arc',
        rpc: ['https://rpc-test-1.archiechain.io'],
        faucets: ['https://faucet.archiechain.io'],
        nativeCurrency: { name: 'ARC', symbol: 'ARC', decimals: 18 },
        infoURL: 'https://archiechain.io/',
        shortName: 'TARC',
        chainId: 1244,
        networkId: 1244,
        slip44: 1,
        explorers: [
            {
                name: 'archiescan',
                url: 'https://testnet.archiescan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeiady63oqduls2pm4aaykzjhahblagokhnpsc5qeq5dmkxqelh7i2i'
    },
    1246: {
        name: 'OM Platform Mainnet',
        chain: 'omplatform',
        rpc: ['https://rpc-cnx.omplatform.com/'],
        faucets: [],
        nativeCurrency: { name: 'OMCOIN', symbol: 'OM', decimals: 18 },
        infoURL: 'https://omplatform.com/',
        shortName: 'om',
        chainId: 1246,
        networkId: 1246,
        explorers: [
            {
                name: 'OMSCAN - Expenter',
                url: 'https://omscan.omplatform.com',
                standard: 'none'
            }
        ]
    },
    1248: {
        name: 'Dogether Mainnet',
        chain: 'Dogether',
        rpc: ['https://rpc.dogether.dog/'],
        faucets: [],
        nativeCurrency: { name: 'Dogether', symbol: 'dogeth', decimals: 18 },
        infoURL: 'https://www.dogether.dog/',
        shortName: 'Dogether',
        chainId: 1248,
        networkId: 1248,
        explorers: [
            {
                name: 'DogetherExplorer',
                url: 'https://explorer.dogether.dog',
                standard: 'EIP3091'
            }
        ]
    },
    1252: {
        name: 'CIC Chain Testnet',
        chain: 'CICT',
        rpc: ['https://testapi.cicscan.com'],
        faucets: ['https://cicfaucet.com'],
        nativeCurrency: {
            name: 'Crazy Internet Coin',
            symbol: 'CICT',
            decimals: 18
        },
        infoURL: 'https://www.cicchain.net',
        shortName: 'CICT',
        chainId: 1252,
        networkId: 1252,
        slip44: 1,
        icon: 'cicchain',
        explorers: [
            {
                name: 'CICscan',
                url: 'https://testnet.cicscan.com',
                icon: 'cicchain',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNekc5gpyrQkeDQcmfJLBrP5fa6GMarB13iy6aHVdQJDU'
    },
    1260: {
        name: 'Metacces Testnet',
        chain: 'Metacces Testnet',
        icon: 'metacces',
        rpc: ['https://tapi.accesscan.io'],
        faucets: [],
        nativeCurrency: { name: 'Metacces', symbol: 'ACCES', decimals: 18 },
        infoURL: 'https://metacces.com',
        shortName: 'ACCESt',
        chainId: 1260,
        networkId: 1260,
        explorers: [
            {
                name: 'accesscan',
                url: 'https://testnet.accesscan.io',
                icon: 'metacces',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbpYHpqR68uuJZCwm1CXtN51zi744qWzZ32ob9BKfgFTV'
    },
    1280: {
        name: 'HALO Mainnet',
        chain: 'HALO',
        rpc: ['https://nodes.halo.land'],
        faucets: [],
        nativeCurrency: { name: 'HALO', symbol: 'HO', decimals: 18 },
        infoURL: 'https://halo.land/#/',
        shortName: 'HO',
        chainId: 1280,
        networkId: 1280,
        explorers: [
            {
                name: 'HALOexplorer',
                url: 'https://browser.halo.land',
                standard: 'none'
            }
        ]
    },
    1284: {
        name: 'Moonbeam',
        chain: 'MOON',
        icon: 'moonbeam',
        rpc: [
            'https://rpc.api.moonbeam.network',
            'wss://wss.api.moonbeam.network',
            'https://moonbeam.public.blastapi.io',
            'wss://moonbeam.public.blastapi.io',
            'https://moonbeam-rpc.dwellir.com',
            'wss://moonbeam-rpc.dwellir.com',
            'https://moonbeam.api.onfinality.io/public',
            'wss://moonbeam.api.onfinality.io/public-ws',
            'https://moonbeam.unitedbloc.com',
            'wss://moonbeam.unitedbloc.com',
            'https://moonbeam-rpc.publicnode.com',
            'wss://moonbeam-rpc.publicnode.com',
            'https://moonbeam.drpc.org',
            'wss://moonbeam.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Glimmer', symbol: 'GLMR', decimals: 18 },
        infoURL: 'https://moonbeam.network/networks/moonbeam/',
        shortName: 'mbeam',
        chainId: 1284,
        networkId: 1284,
        explorers: [
            {
                name: 'moonscan',
                url: 'https://moonbeam.moonscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNR7kbBew61cVxbwBf8EWCiYbUCqVhoJDLL6u3rQy9FrZ'
    },
    1285: {
        name: 'Moonriver',
        chain: 'MOON',
        icon: 'moonriver',
        rpc: [
            'https://rpc.api.moonriver.moonbeam.network',
            'wss://wss.api.moonriver.moonbeam.network',
            'https://moonriver.public.blastapi.io',
            'wss://moonriver.public.blastapi.io',
            'https://moonriver-rpc.dwellir.com',
            'wss://moonriver-rpc.dwellir.com',
            'https://moonriver.api.onfinality.io/public',
            'wss://moonriver.api.onfinality.io/public-ws',
            'https://moonriver.unitedbloc.com',
            'wss://moonriver.unitedbloc.com',
            'https://moonriver-rpc.publicnode.com',
            'wss://moonriver-rpc.publicnode.com',
            'https://moonriver.drpc.org',
            'wss://moonriver.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Moonriver', symbol: 'MOVR', decimals: 18 },
        infoURL: 'https://moonbeam.network/networks/moonriver/',
        shortName: 'mriver',
        chainId: 1285,
        networkId: 1285,
        explorers: [
            {
                name: 'moonscan',
                url: 'https://moonriver.moonscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcyP14ZLD6m6j7rYUgty9uuk9e82kUMTQDdqi2dKmZqjz'
    },
    1286: {
        name: 'Moonrock old',
        chain: 'MOON',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Rocs', symbol: 'ROC', decimals: 18 },
        infoURL: '',
        shortName: 'mrock-old',
        chainId: 1286,
        networkId: 1286,
        status: 'deprecated'
    },
    1287: {
        name: 'Moonbase Alpha',
        chain: 'MOON',
        icon: 'moonbasealpha',
        rpc: [
            'https://rpc.api.moonbase.moonbeam.network',
            'wss://wss.api.moonbase.moonbeam.network',
            'https://moonbase-alpha.public.blastapi.io',
            'wss://moonbase-alpha.public.blastapi.io',
            'https://moonbase-rpc.dwellir.com',
            'wss://moonbase-rpc.dwellir.com',
            'https://moonbeam-alpha.api.onfinality.io/public',
            'wss://moonbeam-alpha.api.onfinality.io/public-ws',
            'https://moonbase.unitedbloc.com',
            'wss://moonbase.unitedbloc.com',
            'https://moonbase-alpha.drpc.org',
            'wss://moonbase-alpha.drpc.org'
        ],
        faucets: ['https://faucet.moonbeam.network/'],
        nativeCurrency: { name: 'Dev', symbol: 'DEV', decimals: 18 },
        infoURL: 'https://docs.moonbeam.network/learn/platform/networks/moonbase/',
        shortName: 'mbase',
        chainId: 1287,
        networkId: 1287,
        slip44: 1,
        explorers: [
            {
                name: 'moonscan',
                url: 'https://moonbase.moonscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVydzWtkyatFgi8zTVR7X6g8SpeHANwKNceRm4nKFoF6o'
    },
    1288: {
        name: 'Moonrock',
        chain: 'MOON',
        rpc: [
            'https://rpc.api.moonrock.moonbeam.network',
            'wss://wss.api.moonrock.moonbeam.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Rocs', symbol: 'ROC', decimals: 18 },
        infoURL: 'https://docs.moonbeam.network/learn/platform/networks/overview/',
        shortName: 'mrock',
        chainId: 1288,
        networkId: 1288
    },
    1291: {
        name: 'Swisstronik Testnet',
        chain: 'SWTR Testnet',
        rpc: ['https://json-rpc.testnet.swisstronik.com'],
        faucets: ['https://faucet.testnet.swisstronik.com'],
        nativeCurrency: { name: 'Swisstronik', symbol: 'SWTR', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.swisstronik.com',
        shortName: 'swtr-testnet',
        chainId: 1291,
        networkId: 1291,
        slip44: 1,
        icon: 'swisstronik',
        explorers: [
            {
                name: 'Swisstronik Scout',
                url: 'https://explorer-evm.testnet.swisstronik.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreietv32mc3rwbzymhlju6mrvmiavvgqg3sflafl2fjjxguqky56sca'
    },
    1294: {
        name: 'Bobabeam',
        chain: 'Bobabeam',
        status: 'deprecated',
        rpc: [
            'https://bobabeam.boba.network',
            'wss://wss.bobabeam.boba.network',
            'https://replica.bobabeam.boba.network',
            'wss://replica-wss.bobabeam.boba.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Boba Token', symbol: 'BOBA', decimals: 18 },
        infoURL: 'https://boba.network',
        shortName: 'Bobabeam',
        chainId: 1294,
        networkId: 1294,
        explorers: [
            {
                name: 'Bobabeam block explorer',
                url: 'https://blockexplorer.bobabeam.boba.network',
                standard: 'none'
            }
        ]
    },
    1297: {
        name: 'Bobabase Testnet',
        chain: 'Bobabase Testnet',
        status: 'deprecated',
        rpc: [
            'https://bobabase.boba.network',
            'wss://wss.bobabase.boba.network',
            'https://replica.bobabase.boba.network',
            'wss://replica-wss.bobabase.boba.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Boba Token', symbol: 'BOBA', decimals: 18 },
        infoURL: 'https://boba.network',
        shortName: 'Bobabase',
        chainId: 1297,
        networkId: 1297,
        slip44: 1,
        explorers: [
            {
                name: 'Bobabase block explorer',
                url: 'https://blockexplorer.bobabase.boba.network',
                standard: 'none'
            }
        ]
    },
    1298: {
        name: 'Argochain Testnet',
        chain: 'Argochain',
        icon: 'argochain',
        rpc: [
            'https://rpc-testnet.devolvedai.com',
            'https://test-rpc.devolvedai.com'
        ],
        faucets: ['https://faucet.argoscan.net'],
        nativeCurrency: { name: 'Argocoin', symbol: 'AGC', decimals: 18 },
        infoURL: 'https://devolvedai.com',
        shortName: 'tAGC',
        chainId: 1298,
        networkId: 1298,
        explorers: [
            {
                name: 'Argochain Test Scanner',
                url: 'https://test-scanner.devolvedai.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVbs4mkn6N86izwQS1HzMP2uFxQLCPxsppojPhyq3cu1w'
    },
    1299: {
        name: 'Argochain',
        chain: 'Argochain',
        icon: 'argochain',
        rpc: ['https://rpc.devolvedai.com', 'https://rpc-mainnet.devolvedai.com'],
        faucets: [],
        nativeCurrency: { name: 'Argocoin', symbol: 'AGC', decimals: 18 },
        infoURL: 'https://devolvedai.com',
        shortName: 'AGC',
        chainId: 1299,
        networkId: 1299,
        explorers: [
            {
                name: 'Argochain Scanner',
                url: 'https://scanner.argoscan.net',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVbs4mkn6N86izwQS1HzMP2uFxQLCPxsppojPhyq3cu1w'
    },
    1300: {
        name: 'Glue Mainnet',
        chain: 'GLUE',
        rpc: ['https://rpc.glue.net'],
        faucets: [],
        nativeCurrency: { name: 'Glue', symbol: 'GLUE', decimals: 18 },
        infoURL: 'https://glue.net/',
        shortName: 'glue',
        chainId: 1300,
        networkId: 1300,
        icon: 'glue',
        explorers: [
            {
                name: 'Glue Explorer',
                url: 'https://explorer.glue.net',
                icon: 'glue',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRPBdzXX433zTD8zLjFu9uYYq16aLz1Pu1xCjJZYMP4wE'
    },
    1301: {
        name: 'Unichain Sepolia Testnet',
        chain: 'ETH',
        rpc: [
            'https://sepolia.unichain.org',
            'https://unichain-sepolia-rpc.publicnode.com',
            'wss://unichain-sepolia-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://unichain.org',
        shortName: 'unichain-sep',
        chainId: 1301,
        networkId: 1301,
        icon: 'unichain-testnet',
        explorers: [
            {
                name: 'Unichain Sepolia Testnet Explorer',
                url: 'https://unichain-sepolia.blockscout.com',
                standard: 'EIP3091'
            },
            {
                name: 'Unichain Sepolia Testnet Explorer',
                url: 'https://sepolia.uniscan.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbdpXXsDDtskhYSFVg3UZqFLcdVhcTKDD29CzKTpgCLCb'
    },
    1310: {
        name: 'COINZAX',
        chain: 'ZAX',
        icon: 'coinzaxIcon',
        rpc: ['https://rpc.coinzax.com'],
        faucets: [],
        nativeCurrency: { name: 'COINZAX', symbol: 'ZAX', decimals: 18 },
        infoURL: 'https://coinzax.com',
        shortName: 'zax',
        chainId: 1310,
        networkId: 1310,
        status: 'active',
        explorers: [
            {
                name: 'COINZAX Explorer',
                url: 'https://explorer.coinzax.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidkgk23jw6vwxrfoslz2hzucz5s63fyetewehoyldjjhmogx56qam'
    },
    1311: {
        name: 'Dos Fuji Subnet',
        chain: 'DOS',
        rpc: ['https://test.doschain.com/jsonrpc'],
        faucets: [],
        nativeCurrency: { name: 'Dos Native Token', symbol: 'DOS', decimals: 18 },
        infoURL: 'http://doschain.io/',
        shortName: 'TDOS',
        chainId: 1311,
        networkId: 1311,
        explorers: [
            {
                name: 'dos-testnet',
                url: 'https://test.doscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    1313: {
        name: 'JaiHo Chain',
        chain: 'JaiHoChain',
        icon: 'jaihoIcon',
        rpc: ['https://rpc.jaihochain.com'],
        faucets: [],
        nativeCurrency: { name: 'JaiHo', symbol: 'JaiHo', decimals: 18 },
        infoURL: 'https://jaihochain.com',
        shortName: 'JHC',
        chainId: 1313,
        networkId: 1313,
        explorers: [
            {
                name: 'JaiHo Chain Explorer',
                url: 'https://jaihochain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUtKXY4N9kNCs9hAkAyi1nsvMWvDzs5vUjgYXTJoZCYqu'
    },
    1314: {
        name: 'Alyx Mainnet',
        chain: 'ALYX',
        rpc: ['https://rpc.alyxchain.com'],
        faucets: [],
        nativeCurrency: {
            name: 'Alyx Chain Native Token',
            symbol: 'ALYX',
            decimals: 18
        },
        infoURL: 'https://www.alyxchain.com',
        shortName: 'alyx',
        chainId: 1314,
        networkId: 1314,
        explorers: [
            {
                name: 'alyxscan',
                url: 'https://www.alyxscan.com',
                standard: 'EIP3091'
            }
        ],
        icon: 'alyx',
        iconURL: 'https://ipfs.io/ipfs/bafkreifd43fcvh77mdcwjrpzpnlhthounc6b4u645kukqpqhduaveatf6i'
    },
    1315: {
        name: 'Story Aeneid Testnet',
        chain: 'Story Aeneid Testnet',
        rpc: ['https://aeneid.storyrpc.io'],
        faucets: [],
        nativeCurrency: { name: 'IP Token', symbol: 'IP', decimals: 18 },
        infoURL: 'https://story.foundation/',
        icon: 'story',
        shortName: 'story-aeneid',
        chainId: 1315,
        networkId: 1315,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://aeneid.storyscan.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreierdbo6kxvq5l353dqzg5qkaennz5s6hjp3nvmvyz2dx7gfka4nuu'
    },
    1319: {
        name: 'AIA Mainnet',
        chain: 'AIA',
        icon: 'aia',
        rpc: [
            'https://aia-dataseed1.aiachain.org',
            'https://aia-dataseed2.aiachain.org',
            'https://aia-dataseed3.aiachain.org',
            'https://aia-dataseed4.aiachain.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'AIA Mainnet', symbol: 'AIA', decimals: 18 },
        infoURL: 'https://aiachain.org/',
        shortName: 'aia',
        chainId: 1319,
        networkId: 1319,
        explorers: [
            {
                name: 'AIA Chain Explorer Mainnet',
                url: 'https://aiascan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPAcZioXaoJd8vFRrqdj2cWXWkbSHoCPiyZH9ukncfvfg'
    },
    1320: {
        name: 'AIA Testnet',
        chain: 'AIA',
        icon: 'aia',
        rpc: ['https://aia-dataseed1-testnet.aiachain.org'],
        faucets: ['https://aia-faucet-testnet.aiachain.org'],
        nativeCurrency: { name: 'AIA Testnet', symbol: 'AIA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://aiachain.org',
        shortName: 'aiatestnet',
        chainId: 1320,
        networkId: 1320,
        slip44: 1,
        explorers: [
            {
                name: 'AIA Chain Explorer Testnet',
                url: 'https://testnet.aiascan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPAcZioXaoJd8vFRrqdj2cWXWkbSHoCPiyZH9ukncfvfg'
    },
    1328: {
        name: 'Sei Testnet',
        chain: 'Sei',
        rpc: [
            'https://evm-rpc-testnet.sei-apis.com',
            'wss://evm-ws-testnet.sei-apis.com'
        ],
        faucets: ['https://atlantic-2.app.sei.io/faucet'],
        nativeCurrency: { name: 'Sei', symbol: 'SEI', decimals: 18 },
        infoURL: 'https://www.sei.io',
        shortName: 'sei-testnet',
        chainId: 1328,
        networkId: 1328,
        icon: 'sei',
        explorers: [
            {
                name: 'Seitrace',
                url: 'https://seitrace.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreih3l3iisplmikofkbfyimqlox7nmixzlkzhjoewmpi4jbqitwryoa'
    },
    1329: {
        name: 'Sei Network',
        chain: 'Sei',
        rpc: ['https://evm-rpc.sei-apis.com', 'wss://evm-ws.sei-apis.com'],
        faucets: [],
        nativeCurrency: { name: 'Sei', symbol: 'SEI', decimals: 18 },
        infoURL: 'https://www.sei.io',
        shortName: 'sei',
        chainId: 1329,
        networkId: 1329,
        icon: 'seiv2',
        explorers: [
            {
                name: 'Seitrace',
                url: 'https://seitrace.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreia2tiurhfkc2lifytbpv356d4rfmqoivzrepg2wsrqwrqgbb4bp7a'
    },
    1336: {
        name: 'Kii Testnet Oro',
        chain: 'KII',
        rpc: ['https://json-rpc.uno.sentry.testnet.v3.kiivalidator.com'],
        faucets: ['https://explorer.kiichain.io/testnet/faucet'],
        nativeCurrency: { name: 'Kii', symbol: 'KII', decimals: 18 },
        features: [],
        infoURL: 'https://kiichain.io',
        shortName: 'kiioro',
        chainId: 1336,
        networkId: 1336,
        icon: 'kii',
        explorers: [
            {
                name: 'KiiExplorer',
                url: 'https://explorer.kiichain.io/testnet',
                icon: 'kii',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreib5kb73tb5fdvikhxe7nlnf4mmlfcfpsslalaplqfihypcmudlal4'
    },
    1337: {
        name: 'Geth Testnet',
        title: 'Go Ethereum (Geth) Private Testnet',
        chain: 'ETH',
        rpc: ['http://127.0.0.1:8545'],
        faucets: [],
        nativeCurrency: { name: 'Geth Testnet Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://geth.ethereum.org',
        shortName: 'geth',
        chainId: 1337,
        networkId: 1337,
        slip44: 1
    },
    1338: {
        name: 'Elysium Testnet',
        title: 'An L1, carbon-neutral, tree-planting, metaverse dedicated blockchain created by VulcanForged',
        chain: 'Atlantis',
        rpc: ['https://rpc.atlantischain.network'],
        faucets: ['https://faucet.atlantischain.network'],
        nativeCurrency: { name: 'ELY', symbol: 'ELY', decimals: 18 },
        infoURL: 'https://elysiumchain.tech',
        shortName: 'ATL',
        chainId: 1338,
        networkId: 1338,
        explorers: [
            {
                name: 'Atlantis explorer',
                url: 'https://blockscout.atlantischain.network',
                standard: 'EIP3091'
            }
        ]
    },
    1339: {
        name: 'Elysium Mainnet',
        title: 'An L1, carbon-neutral, tree-planting, metaverse dedicated blockchain.',
        chain: 'Elysium',
        rpc: ['https://rpc.elysiumchain.tech', 'https://rpc.elysiumchain.us'],
        faucets: ['https://faucet.elysiumchain.tech'],
        nativeCurrency: { name: 'ELY', symbol: 'ELY', decimals: 18 },
        infoURL: 'https://elysiumchain.tech/',
        shortName: 'ELY',
        chainId: 1339,
        networkId: 1339,
        icon: 'elysium',
        explorers: [
            {
                name: 'Elysium mainnet explorer',
                url: 'https://explorer.elysiumchain.tech',
                standard: 'EIP3091'
            },
            {
                name: 'Elysium blockscout explorer',
                url: 'https://blockscout.elysiumchain.tech',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWNCNMtnJaphMJY3dbP2pXPLQG6xayhkc2JWahoXECgsG'
    },
    1343: {
        name: 'Blitz Subnet',
        chain: 'BLITZ',
        rpc: ['https://subnets.avax.network/blitz/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'BLITZ GAS', symbol: 'BGAS', decimals: 18 },
        infoURL: 'https://blitz.gg',
        shortName: 'blitz',
        chainId: 1343,
        networkId: 1343,
        explorers: [
            {
                name: 'BLITZ Explorer',
                url: 'https://subnets-test.avax.network/blitz',
                standard: 'EIP3091'
            }
        ]
    },
    1353: {
        name: 'CIC Chain Mainnet',
        chain: 'CIC',
        rpc: ['https://xapi.cicscan.com'],
        faucets: [],
        nativeCurrency: {
            name: 'Crazy Internet Coin',
            symbol: 'CIC',
            decimals: 18
        },
        infoURL: 'https://www.cicchain.net',
        shortName: 'CIC',
        chainId: 1353,
        networkId: 1353,
        icon: 'cicchain',
        explorers: [
            {
                name: 'CICscan',
                url: 'https://cicscan.com',
                icon: 'cicchain',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNekc5gpyrQkeDQcmfJLBrP5fa6GMarB13iy6aHVdQJDU'
    },
    1369: {
        name: 'Zafirium Mainnet',
        chain: 'ZAFIC',
        icon: 'zafirium',
        rpc: ['https://mainnet.zakumi.io'],
        faucets: [],
        nativeCurrency: {
            name: 'Zakumi Chain Native Token',
            symbol: 'ZAFIC',
            decimals: 18
        },
        infoURL: 'https://www.zakumi.io',
        shortName: 'zafic',
        chainId: 1369,
        networkId: 1369,
        explorers: [
            {
                name: 'zafirium-explorer',
                url: 'https://explorer.zakumi.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZT1Wq3P4YbgKBSUmCtgbs5ijPF5d91BzaMPh7Aub8d8t'
    },
    1370: {
        name: 'Ramestta Mainnet',
        chain: 'Ramestta',
        icon: 'ramestta',
        rpc: [
            'https://blockchain.ramestta.com',
            'https://blockchain2.ramestta.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Rama', symbol: 'RAMA', decimals: 18 },
        infoURL: 'https://www.ramestta.com',
        shortName: 'RAMA',
        chainId: 1370,
        networkId: 1370,
        explorers: [
            {
                name: 'ramascan',
                url: 'https://ramascan.com',
                icon: 'ramestta',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUtnYVBeDMKudGq2Wue25pqYfQEdgbyvzTzoGPMqRGMJZ'
    },
    1377: {
        name: 'Pingaksha testnet',
        chain: 'Pingaksha',
        icon: 'ramestta',
        rpc: ['https://testnet.ramestta.com'],
        faucets: [],
        nativeCurrency: { name: 'Rama', symbol: 'tRAMA', decimals: 18 },
        infoURL: 'https://www.ramestta.com',
        shortName: 'tRAMA',
        chainId: 1377,
        networkId: 1377,
        explorers: [
            {
                name: 'Pingaksha',
                url: 'https://pingaksha.ramascan.com',
                icon: 'ramestta',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUtnYVBeDMKudGq2Wue25pqYfQEdgbyvzTzoGPMqRGMJZ'
    },
    1379: {
        name: 'Kalar Chain',
        chain: 'KLC',
        icon: 'kalarchain',
        rpc: ['https://rpc-api.kalarchain.tech'],
        faucets: [],
        nativeCurrency: { name: 'Kalar', symbol: 'KLC', decimals: 18 },
        infoURL: 'https://kalarchain.tech',
        shortName: 'KLC',
        chainId: 1379,
        networkId: 1379,
        explorers: [
            {
                name: 'kalarscan',
                url: 'https://explorer.kalarchain.tech',
                icon: 'kalarscan',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihfoy2kgf2rebaoicso7z5h7ju46z6gtr64mskkths3qbfkrtnkjm'
    },
    1388: {
        name: 'AmStar Mainnet',
        chain: 'AmStar',
        icon: 'amstar',
        rpc: ['https://mainnet-rpc.amstarscan.com'],
        faucets: [],
        nativeCurrency: { name: 'SINSO', symbol: 'SINSO', decimals: 18 },
        infoURL: 'https://sinso.io',
        shortName: 'ASAR',
        chainId: 1388,
        networkId: 1388,
        explorers: [
            {
                name: 'amstarscan',
                url: 'https://mainnet.amstarscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmd4TMQdnYxaUZqnVddh5S37NGH72g2kkK38ccCEgdZz1C'
    },
    1392: {
        name: 'Joseon Mainnet',
        chain: 'Joseon',
        icon: 'joseon',
        rpc: ['https://rpc.modchain.net/blockchain.joseon.com/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Joseon Mun', symbol: 'JSM', decimals: 18 },
        infoURL: 'https://www.joseon.com/',
        shortName: 'mun',
        chainId: 1392,
        networkId: 1392,
        explorers: [
            {
                name: 'BlockExplorer',
                url: 'https://www.blockexplorer.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQjwcNRCLXU8JBtSkPLUnbWVrpoqbnZVffpJ9Bu8rG34e'
    },
    1402: {
        name: 'Polygon zkEVM Testnet old',
        title: 'Polygon zkEVM Testnet',
        chain: 'Polygon',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://polygon.technology/solutions/polygon-zkevm/',
        shortName: 'zkevmtest',
        chainId: 1402,
        networkId: 1402,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.public.zkevm-test.net',
                standard: 'EIP3091'
            }
        ],
        status: 'deprecated'
    },
    1414: {
        name: 'Silicon zkEVM Sepolia Testnet(Deprecated)',
        title: 'Silicon zkEVM Sepolia Testnet(Deprecated)',
        chain: 'Silicon',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: '',
        shortName: 'silicon-sepolia-testnet-deprecated',
        chainId: 1414,
        networkId: 1414,
        icon: 'silicon',
        explorers: [],
        parent: { type: 'L2', chain: 'eip155-11155111', bridges: [] },
        status: 'deprecated',
        iconURL: 'https://ipfs.io/ipfs/QmTEnk2fosqbY6HQW5vySrLGbopJfeni9ThZ6R9sVefbnq'
    },
    1422: {
        name: 'Polygon zkEVM Testnet Pre Audit-Upgraded',
        title: 'Polygon zkEVM Testnet Pre Audit-Upgraded',
        chain: 'Polygon',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://polygon.technology/solutions/polygon-zkevm/',
        shortName: 'testnet-zkEVM-mango-pre-audit-upgraded',
        chainId: 1422,
        networkId: 1422,
        slip44: 1,
        explorers: [
            {
                name: 'Polygon zkEVM explorer',
                url: 'https://explorer.public.zkevm-test.net',
                standard: 'EIP3091'
            }
        ],
        status: 'deprecated'
    },
    1424: {
        name: 'Perennial',
        chain: 'perennial',
        rpc: ['https://rpc.perennial.foundation'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://perennial.finance',
        shortName: 'perennial',
        chainId: 1424,
        networkId: 1424,
        icon: 'perennial',
        explorers: [
            {
                name: 'Perennial Explorer',
                url: 'https://explorer.perennial.foundation',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-8453',
            bridges: [{ url: 'https://bridge.perennial.foundation' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreidkqdec42orfj4yiufiqvo3n33yxiw75jybg2lewv36raq7qpijua'
    },
    1425: {
        name: 'ONINO Mainnet',
        chain: 'ONI',
        rpc: ['https://rpc.onino.io'],
        faucets: ['https://faucet.onino.io'],
        nativeCurrency: { name: 'ONI', symbol: 'ONI', decimals: 18 },
        infoURL: 'https://onino.io',
        shortName: 'onino',
        chainId: 1425,
        networkId: 1425,
        icon: 'onino',
        explorers: [
            {
                name: 'onino',
                url: 'https://explorer.onino.io',
                icon: 'onino',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW46cmj2fRUbfy3Fz9kyhm33BpXnNXZ4KW3vmK1z4Mg19'
    },
    1433: {
        name: 'Rikeza Network Mainnet',
        title: 'Rikeza Network Mainnet',
        chain: 'Rikeza',
        icon: 'rikeza',
        rpc: ['https://rpc.rikscan.com'],
        faucets: [],
        nativeCurrency: { name: 'Rikeza', symbol: 'RIK', decimals: 18 },
        infoURL: 'https://rikeza.io',
        shortName: 'RIK',
        chainId: 1433,
        networkId: 1433,
        explorers: [
            {
                name: 'Rikeza Blockchain explorer',
                url: 'https://rikscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfJ1Qxpzi6CSLeFeWY1Bwe435CpT5za5WfrLUE7vNzZfy'
    },
    1440: {
        name: 'Living Assets Mainnet',
        chain: 'LAS',
        icon: 'livingassets',
        rpc: [
            'https://beta.mainnet.livingassets.io/rpc',
            'https://gamma.mainnet.livingassets.io/rpc'
        ],
        faucets: [],
        nativeCurrency: { name: 'LAS', symbol: 'LAS', decimals: 18 },
        infoURL: 'https://dev.livingassets.io/',
        shortName: 'LAS',
        chainId: 1440,
        networkId: 1440,
        iconURL: 'https://ipfs.io/ipfs/QmRidubY7BVwC737BQwGEttenP1npAXN7ZNryktE416uUW'
    },
    1442: {
        name: 'Polygon zkEVM Testnet',
        title: 'Polygon zkEVM Testnet',
        chain: 'Polygon',
        rpc: [
            'https://rpc.public.zkevm-test.net',
            'https://polygon-zkevm-testnet.drpc.org',
            'wss://polygon-zkevm-testnet.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://polygon.technology/solutions/polygon-zkevm/',
        shortName: 'testnet-zkEVM-mango',
        chainId: 1442,
        networkId: 1442,
        slip44: 1,
        explorers: [
            {
                name: 'Polygon zkEVM explorer',
                url: 'https://explorer.public.zkevm-test.net',
                standard: 'EIP3091'
            }
        ]
    },
    1452: {
        name: 'GIL Testnet',
        chain: 'GIL',
        icon: 'gauss',
        rpc: ['https://rpc.giltestnet.com'],
        faucets: [],
        nativeCurrency: { name: 'GANG', symbol: 'GANG', decimals: 18 },
        infoURL: 'https://gaussgang.com/',
        shortName: 'gil',
        chainId: 1452,
        networkId: 1452,
        slip44: 1,
        explorers: [
            {
                name: 'GIL Explorer',
                url: 'https://explorer.giltestnet.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeDXUAYgQxwaSJLsqWgTqnrJVwicgEyNf9199xAMyRkqA'
    },
    1453: {
        name: 'MetaChain Istanbul',
        title: 'MetaChain Testnet Istanbul',
        chain: 'MTC',
        icon: 'metachain',
        rpc: ['https://istanbul-rpc.metachain.dev'],
        faucets: ['https://istanbul-faucet.metachain.dev'],
        nativeCurrency: { name: 'Metatime Coin', symbol: 'MTC', decimals: 18 },
        infoURL: 'https://metatime.com/en',
        shortName: 'metatimeistanbul',
        chainId: 1453,
        networkId: 1453,
        slip44: 1453,
        explorers: [
            {
                name: 'MetaExplorer',
                url: 'https://istanbul-explorer.metachain.dev',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUH2Ph2hW4upvevEAGCaSo7nd8nthqMx5RrHcrnNZ9Y3g'
    },
    1455: {
        name: 'Ctex Scan Blockchain',
        chain: 'Ctex Scan Blockchain',
        icon: 'ctex',
        rpc: ['https://mainnet-rpc.ctexscan.com/'],
        faucets: ['https://faucet.ctexscan.com'],
        nativeCurrency: { name: 'CTEX', symbol: 'CTEX', decimals: 18 },
        infoURL: 'https://ctextoken.io',
        shortName: 'CTEX',
        chainId: 1455,
        networkId: 1455,
        explorers: [
            {
                name: 'Ctex Scan Explorer',
                url: 'https://ctexscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreid5evn4qovxo6msuekizv5zn7va62tea7w2zpdx5sskconebuhqle'
    },
    1456: {
        name: 'ZKBase Mainnet',
        chain: 'ETH',
        rpc: ['https://mainnet-rpc.zkbase.app'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://zkbase.org/',
        shortName: 'zkbase',
        chainId: 1456,
        networkId: 1456,
        slip44: 1,
        icon: 'zkbase',
        explorers: [
            {
                name: 'ZKbase Block Explorer',
                url: 'https://explorer.zkbase.app',
                icon: 'zkbase',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://portal.zkbase.app/' }]
        },
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/QmRLtNvkVhC7rRDiLMHLckWbesaSU6sNYhQZgsAM1phTZx'
    },
    1480: {
        name: 'Vana',
        chain: 'Vana',
        rpc: ['https://rpc.vana.org/'],
        nativeCurrency: { name: 'Vana', symbol: 'VANA', decimals: 18 },
        faucets: ['https://faucet.vana.org/'],
        infoURL: 'https://vana.org',
        shortName: 'vana',
        chainId: 1480,
        networkId: 1480,
        icon: 'vana',
        explorers: [
            {
                name: 'Vana Block Explorer',
                url: 'https://vanascan.io',
                icon: 'vana',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QAZt75XixnEtFzqHTrJa8kJkV4ccXWaXqeMeqM8BcBomQc'
    },
    1490: {
        name: 'Vitruveo Mainnet',
        title: 'Vitruveo is a blockchain for Creators',
        chain: 'Vitruveo',
        rpc: ['https://rpc.vitruveo.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Vitruveo Coin', symbol: 'VTRU', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://www.vitruveo.xyz',
        shortName: 'vitruveo',
        chainId: 1490,
        networkId: 1490,
        icon: 'vitruveo',
        explorers: [
            {
                name: 'Vitruveo Explorer',
                url: 'https://explorer.vitruveo.xyz',
                icon: 'vitruveo',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidjhjv7uu7if745ys7ari3ka75spm2hqyr5po66sbe7kqsfk7ahua'
    },
    1499: {
        name: 'iDos Games Chain Testnet',
        chain: 'IGC',
        icon: 'igc-testnet',
        rpc: ['https://rpc-testnet.idos.games'],
        faucets: [],
        nativeCurrency: { name: 'iDos Games Coin', symbol: 'IGC', decimals: 18 },
        infoURL: 'https://idosgames.com/',
        shortName: 'IGC',
        chainId: 1499,
        networkId: 1499,
        explorers: [
            {
                name: 'IGC-Scan',
                url: 'https://igcscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeXuzaYXCDwHgQdpuE9L55JfEChzj11P73Ngrn8vDTE9T'
    },
    1501: {
        name: 'BEVM Canary',
        chain: 'ChainX',
        rpc: ['https://rpc-canary-1.bevm.io/', 'https://rpc-canary-2.bevm.io/'],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://chainx.org',
        shortName: 'chainx',
        chainId: 1501,
        networkId: 1501,
        icon: 'bevmcanary',
        explorers: [
            {
                name: 'bevm canary scan',
                url: 'https://scan-canary.bevm.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdDHRKWaQErTzt4SdcVgoVHEzBHCswhoaojBxT9LNR6sq'
    },
    1506: {
        name: 'Sherpax Mainnet',
        chain: 'Sherpax Mainnet',
        rpc: ['https://mainnet.sherpax.io/rpc'],
        faucets: [],
        nativeCurrency: { name: 'KSX', symbol: 'KSX', decimals: 18 },
        infoURL: 'https://sherpax.io/',
        shortName: 'Sherpax',
        chainId: 1506,
        networkId: 1506,
        explorers: [
            {
                name: 'Sherpax Mainnet Explorer',
                url: 'https://evm.sherpax.io',
                standard: 'none'
            }
        ]
    },
    1507: {
        name: 'Sherpax Testnet',
        chain: 'Sherpax Testnet',
        rpc: ['https://sherpax-testnet.chainx.org/rpc'],
        faucets: [],
        nativeCurrency: { name: 'KSX', symbol: 'KSX', decimals: 18 },
        infoURL: 'https://sherpax.io/',
        shortName: 'SherpaxTestnet',
        chainId: 1507,
        networkId: 1507,
        slip44: 1,
        explorers: [
            {
                name: 'Sherpax Testnet Explorer',
                url: 'https://evm-pre.sherpax.io',
                standard: 'none'
            }
        ]
    },
    1513: {
        name: 'Story Testnet',
        chain: 'Story Testnet',
        rpc: ['https://testnet.storyrpc.io'],
        faucets: ['https://faucet.story.foundation'],
        chainId: 1513,
        networkId: 1513,
        nativeCurrency: { name: 'IP', symbol: 'IP', decimals: 18 },
        infoURL: 'https://www.story.foundation',
        shortName: 'Story',
        explorers: [
            {
                name: 'Story Iliad Network explorer',
                url: 'https://testnet.storyscan.xyz',
                standard: 'EIP3091'
            }
        ]
    },
    1514: {
        name: 'Story',
        chain: 'STORY',
        rpc: ['https://mainnet.storyrpc.io'],
        faucets: [],
        nativeCurrency: { name: 'IP Token', symbol: 'IP', decimals: 18 },
        infoURL: 'https://story.foundation/',
        icon: 'story',
        shortName: 'sty',
        chainId: 1514,
        networkId: 1514,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://mainnet.storyscan.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreierdbo6kxvq5l353dqzg5qkaennz5s6hjp3nvmvyz2dx7gfka4nuu'
    },
    1515: {
        name: 'Beagle Messaging Chain',
        chain: 'BMC',
        rpc: ['https://beagle.chat/eth'],
        faucets: ['https://faucet.beagle.chat/'],
        nativeCurrency: { name: 'Beagle', symbol: 'BG', decimals: 18 },
        infoURL: 'https://beagle.chat/',
        shortName: 'beagle',
        chainId: 1515,
        networkId: 1515,
        explorers: [
            {
                name: 'Beagle Messaging Chain Explorer',
                url: 'https://eth.beagle.chat',
                standard: 'EIP3091'
            }
        ]
    },
    1516: {
        name: 'Story Odyssey Testnet',
        chain: 'Story Odyssey Testnet',
        rpc: ['https://odyssey.storyrpc.io'],
        faucets: [],
        chainId: 1516,
        networkId: 1516,
        nativeCurrency: { name: 'IP', symbol: 'IP', decimals: 18 },
        infoURL: 'https://www.story.foundation',
        shortName: 'story-testnet',
        explorers: [
            {
                name: 'Story Odyssey Network explorer',
                url: 'https://odyssey-testnet-explorer.storyscan.xyz',
                standard: 'EIP3091'
            }
        ]
    },
    1555: {
        name: 'Datacore Smart Chain',
        chain: 'Datacore Smart Chain',
        icon: 'dscscan',
        rpc: ['https://rpc01.dscscan.io'],
        faucets: [],
        nativeCurrency: {
            name: 'Datacore Smart Chain',
            symbol: 'DSC',
            decimals: 18
        },
        infoURL: 'https://rpc01.dscscan.io',
        shortName: 'DSCs',
        chainId: 1555,
        networkId: 1555,
        explorers: [
            {
                name: 'Datacore Smart Chain',
                url: 'https://dscscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfY4XoQCj3WbiSsj7nZyBXwkDX6PFsWSroTDvhP9Eoy6S'
    },
    1559: {
        name: 'Tenet',
        title: 'Tenet Mainnet',
        chain: 'TENET',
        icon: 'tenet',
        rpc: [
            'https://rpc.tenet.org',
            'https://tenet-evm.publicnode.com',
            'wss://tenet-evm.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'TENET', symbol: 'TENET', decimals: 18 },
        infoURL: 'https://tenet.org/',
        shortName: 'tenet',
        chainId: 1559,
        networkId: 1559,
        explorers: [
            {
                name: 'TenetScan Mainnet',
                url: 'https://tenetscan.io',
                icon: 'tenet',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmc1gqjWTzNo4pyFSGtQuCu7kRSZZBUVybtTjHn2nNEEPA'
    },
    1570: {
        name: 'StarCHAIN Testnet',
        chain: 'StarCHAIN',
        rpc: ['https://testnet-rpc1.starworksglobal.com'],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: { name: 'STARX', symbol: 'STARX', decimals: 18 },
        infoURL: 'https://www.starworksglobal.com',
        shortName: 'starchain-testnet',
        chainId: 1570,
        networkId: 1570,
        explorers: [
            {
                name: 'StarCHAIN Explorer',
                url: 'https://testnet.starchainscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    1578: {
        name: 'StarCHAIN',
        chain: 'StarCHAIN',
        rpc: ['https://rpc.starworksglobal.com'],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: { name: 'STARX', symbol: 'STARX', decimals: 18 },
        infoURL: 'https://www.starworksglobal.com',
        shortName: 'starchain',
        chainId: 1578,
        networkId: 1578,
        explorers: [
            {
                name: 'StarCHAIN Explorer',
                url: 'https://starchainscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    1597: {
        name: 'Reactive Mainnet',
        title: 'Reactive Network',
        chain: 'REACT',
        rpc: ['https://mainnet-rpc.rnk.dev'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'React', symbol: 'REACT', decimals: 18 },
        infoURL: 'https://reactive.network',
        shortName: 'react',
        icon: 'reactive',
        chainId: 1597,
        networkId: 1597,
        explorers: [
            {
                name: 'Reactscan',
                url: 'https://reactscan.net',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreih2sitkbspgnboiwga7k4zwz22h4u3qqpswxdr3miqtdwuovw2cte'
    },
    1605: {
        name: 'Betherance',
        chain: 'Beth',
        rpc: ['https://rpc.bethscan.io'],
        faucets: [],
        nativeCurrency: { name: 'Betherance', symbol: 'BETH', decimals: 18 },
        infoURL: 'https://rpc.bethscan.io',
        shortName: 'Beth',
        chainId: 1605,
        networkId: 1605,
        icon: 'betherance',
        explorers: [
            {
                name: 'bethscan',
                url: 'https://bethscan.io',
                icon: 'betherance',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQnf8Fp3xVimXszkCt7EfKWjUzGWK9HBq9EQ8xXbm1APH'
    },
    1617: {
        name: 'Ethereum Inscription Mainnet',
        chain: 'ETINS',
        rpc: ['https://rpc.etins.org'],
        faucets: [],
        nativeCurrency: {
            name: 'Ethereum Inscription',
            symbol: 'ETINS',
            decimals: 18
        },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.etins.org',
        shortName: 'etins',
        chainId: 1617,
        networkId: 1617,
        explorers: [
            {
                name: 'Ethereum Inscription Explorer',
                url: 'https://explorer.etins.org',
                standard: 'none'
            }
        ]
    },
    1618: {
        name: 'Catecoin Chain Mainnet',
        chain: 'Catechain',
        rpc: ['https://send.catechain.com'],
        faucets: [],
        nativeCurrency: { name: 'Catecoin', symbol: 'CATE', decimals: 18 },
        infoURL: 'https://catechain.com',
        shortName: 'cate',
        chainId: 1618,
        networkId: 1618
    },
    1620: {
        name: 'Atheios',
        chain: 'ATH',
        rpc: ['https://rpc.atheios.org/'],
        faucets: [],
        nativeCurrency: { name: 'Atheios Ether', symbol: 'ATH', decimals: 18 },
        infoURL: 'https://atheios.org',
        shortName: 'ath',
        chainId: 1620,
        networkId: 11235813,
        slip44: 1620
    },
    1625: {
        name: 'Gravity Alpha Mainnet',
        chain: 'Gravity',
        rpc: ['https://rpc.gravity.xyz', 'https://rpc.ankr.com/gravity'],
        faucets: [],
        nativeCurrency: { name: 'Gravity', symbol: 'G', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }, { name: 'EIP1108' }],
        infoURL: 'https://gravity.xyz',
        shortName: 'gravity',
        chainId: 1625,
        networkId: 1625,
        icon: 'gravity',
        explorers: [
            {
                name: 'Gravity Alpha Mainnet Explorer',
                url: 'https://explorer.gravity.xyz',
                standard: 'EIP3091'
            },
            { name: 'gscan', url: 'https://gscan.xyz', standard: 'EIP3091' },
            {
                name: 'OKLink',
                url: 'https://www.oklink.com/gravity-alpha',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.gravity.xyz' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmU5XU4S5oaGM5fj8oU1ovhWoXCzGWspwRj2zWRTuJrU4k'
    },
    1648: {
        name: 'Pivotal Mainnet',
        chainId: 1648,
        networkId: 1648,
        chain: 'Pivotal',
        rpc: ['https://mainnet.pivotalprotocol.com'],
        faucets: [],
        shortName: 'pivotal-mainnet',
        nativeCurrency: { name: 'Pivotal ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'http://thepivotal.xyz/',
        explorers: [
            {
                name: 'Pivotal Scan',
                url: 'https://pivotalscan.xyz',
                standard: 'EIP3091'
            }
        ]
    },
    1657: {
        name: 'Btachain',
        chain: 'btachain',
        rpc: ['https://dataseed1.btachain.com/'],
        faucets: [],
        nativeCurrency: { name: 'Bitcoin Asset', symbol: 'BTA', decimals: 18 },
        infoURL: 'https://bitcoinasset.io/',
        shortName: 'bta',
        chainId: 1657,
        networkId: 1657
    },
    1662: {
        name: 'Liquichain',
        shortName: 'Liquichain',
        chain: 'LQC',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Licoin', symbol: 'LCN', decimals: 18 },
        infoURL: 'https://liquichain.io/',
        chainId: 1662,
        networkId: 1662,
        explorers: [
            {
                name: 'Liquichain Mainnet',
                url: 'https://mainnet.liquichain.io',
                standard: 'EIP3091'
            }
        ],
        redFlags: ['reusedChainId']
    },
    1663: {
        name: 'Horizen Gobi Testnet',
        shortName: 'Gobi',
        chain: 'Gobi',
        icon: 'eon',
        rpc: [
            'https://gobi-rpc.horizenlabs.io/ethv1',
            'https://rpc.ankr.com/horizen_gobi_testnet'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://faucet.horizen.io'],
        nativeCurrency: { name: 'Testnet Zen', symbol: 'tZEN', decimals: 18 },
        infoURL: 'https://horizen.io/',
        chainId: 1663,
        networkId: 1663,
        slip44: 1,
        explorers: [
            {
                name: 'Gobi Testnet Block Explorer',
                url: 'https://gobi-explorer.horizen.io',
                icon: 'eon',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSFMBk3rMyu45Sy9KQHjgArFj4HdywANNYrSosLMUdcti'
    },
    1686: {
        name: 'Mint Testnet',
        chain: 'ETH',
        rpc: ['https://testnet-rpc.mintchain.io'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.mintchain.io',
        shortName: 'minttest',
        chainId: 1686,
        networkId: 1686,
        status: 'deprecated',
        icon: 'mintTestnet',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet-explorer.mintchain.io',
                icon: 'mintTestnet',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://testnet-bridge.mintchain.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmQsYisbKkCTKoKG2YSVs94UGuWWMiBspirH4Af4FyZeZz'
    },
    1687: {
        name: 'Mint Sepolia Testnet',
        chain: 'ETH',
        rpc: ['https://sepolia-testnet-rpc.mintchain.io'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.mintchain.io',
        shortName: 'mintsepoliatest',
        chainId: 1687,
        networkId: 1687,
        icon: 'mintTestnet',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://sepolia-testnet-explorer.mintchain.io',
                icon: 'mintTestnet',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://sepolia-testnet-bridge.mintchain.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmQsYisbKkCTKoKG2YSVs94UGuWWMiBspirH4Af4FyZeZz'
    },
    1688: {
        name: 'LUDAN Mainnet',
        chain: 'LUDAN',
        rpc: ['https://rpc.ludan.org/'],
        faucets: [],
        nativeCurrency: { name: 'LUDAN', symbol: 'LUDAN', decimals: 18 },
        infoURL: 'https://www.ludan.org/',
        shortName: 'LUDAN',
        icon: 'ludan',
        chainId: 1688,
        networkId: 1688,
        iconURL: 'https://ipfs.io/ipfs/bafkreigzeanzqgxrzzep45t776ovbwi242poqxbryuu2go5eedeuwwcsay'
    },
    1689: {
        name: 'NERO Mainnet',
        chain: 'NERO Chain',
        rpc: ['https://rpc.nerochain.io', 'wss://ws.nerochain.io'],
        faucets: [],
        nativeCurrency: { name: 'NERO', symbol: 'NERO', decimals: 18 },
        infoURL: 'https://docs.nerochain.io/',
        shortName: 'NERO',
        chainId: 1689,
        networkId: 1689,
        slip44: 1,
        icon: 'nero',
        explorers: [
            {
                name: 'nero mainnet scan',
                url: 'https://www.neroscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdkENLFjLRNts2kBspNbM3q84WjG5Yf7C8amVVr7FCQrp'
    },
    1701: {
        name: 'Anytype EVM Chain',
        chain: 'ETH',
        icon: 'any',
        rpc: ['https://geth.anytype.io'],
        faucets: ['https://evm.anytype.io/faucet'],
        nativeCurrency: { name: 'ANY', symbol: 'ANY', decimals: 18 },
        infoURL: 'https://evm.anytype.io',
        shortName: 'AnytypeChain',
        chainId: 1701,
        networkId: 1701,
        explorers: [
            {
                name: 'Anytype Explorer',
                url: 'https://explorer.anytype.io',
                icon: 'any',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaARJiAQUn4Z6wG8GLEry3kTeBB3k6RfHzSZU9SPhBgcG'
    },
    1707: {
        name: 'TBSI Mainnet',
        title: 'Thai Blockchain Service Infrastructure Mainnet',
        chain: 'TBSI',
        rpc: ['https://rpc.blockchain.or.th'],
        faucets: [],
        nativeCurrency: { name: 'Jinda', symbol: 'JINDA', decimals: 18 },
        infoURL: 'https://blockchain.or.th',
        shortName: 'TBSI',
        chainId: 1707,
        networkId: 1707,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://exp.blockchain.or.th',
                standard: 'EIP3091'
            }
        ]
    },
    1708: {
        name: 'TBSI Testnet',
        title: 'Thai Blockchain Service Infrastructure Testnet',
        chain: 'TBSI',
        rpc: ['https://rpc.testnet.blockchain.or.th'],
        faucets: ['https://faucet.blockchain.or.th'],
        nativeCurrency: { name: 'Jinda', symbol: 'JINDA', decimals: 18 },
        infoURL: 'https://blockchain.or.th',
        shortName: 'tTBSI',
        chainId: 1708,
        networkId: 1708,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://exp.testnet.blockchain.or.th',
                standard: 'EIP3091'
            }
        ]
    },
    1717: {
        name: 'Doric Network',
        chain: 'DRC',
        icon: 'doric',
        rpc: ['https://mainnet.doric.network'],
        faucets: [],
        nativeCurrency: { name: 'Doric Native Token', symbol: 'DRC', decimals: 18 },
        infoURL: 'https://doric.network',
        shortName: 'DRC',
        chainId: 1717,
        networkId: 1717,
        explorers: [
            {
                name: 'Doric Explorer',
                url: 'https://explorer.doric.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdFEozqneC8abhpfgtGpvfKpWVEbL8eMZjJKtUPuBTanK'
    },
    1718: {
        name: 'Palette Chain Mainnet',
        chain: 'PLT',
        rpc: ['https://palette-rpc.com:22000'],
        faucets: [],
        nativeCurrency: { name: 'Palette Token', symbol: 'PLT', decimals: 18 },
        features: [],
        infoURL: 'https://hashpalette.com/',
        shortName: 'PCM',
        chainId: 1718,
        networkId: 1718,
        icon: 'PLT',
        explorers: [
            {
                name: 'Palettescan',
                url: 'https://palettescan.com',
                icon: 'PLT',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPCEGZD1p1keTT2YfPp725azx1r9Ci41hejeUuGL2whFA'
    },
    1727: {
        name: 'Ethpar Mainnet',
        chain: 'ETP',
        rpc: ['https://rpc01.ethpar.net/'],
        faucets: [],
        nativeCurrency: { name: 'Ethpar', symbol: 'ETP', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://ethpar.com',
        shortName: 'ethpar',
        chainId: 1727,
        networkId: 1727,
        icon: 'ethpar',
        explorers: [
            {
                name: 'Ethpar Mainnet Explorer',
                url: 'https://dora.ethpar.net',
                icon: 'ethpar',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiezag3ijij32zbo3ko7xes2hafsqjhru22ab6ia35ygafc66kjb6u'
    },
    1729: {
        name: 'Reya Network',
        chain: 'Reya',
        rpc: ['https://rpc.reya.network', 'wss://ws.reya.network'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://reya.network',
        shortName: 'reya',
        chainId: 1729,
        networkId: 1729,
        explorers: [
            {
                name: 'Reya Network Explorer',
                url: 'https://explorer.reya.network',
                standard: 'EIP3091'
            }
        ]
    },
    1732: {
        name: 'Fuga Mainnet',
        chain: 'Fuga',
        rpc: ['https://rpc.fuga.blue'],
        faucets: [],
        nativeCurrency: { name: 'FUGA', symbol: 'FUGA', decimals: 18 },
        infoURL: 'https://fuga.one',
        shortName: 'FUGA',
        chainId: 1732,
        networkId: 1732,
        slip44: 732,
        explorers: [],
        status: 'incubating'
    },
    1733: {
        name: 'Fuga Testnet',
        chain: 'Fuga',
        rpc: ['https://rpc-testnet.fuga.blue'],
        faucets: [],
        nativeCurrency: { name: 'FUGA', symbol: 'FUGA', decimals: 18 },
        infoURL: 'https://fuga.one',
        shortName: 'FUGA_T',
        chainId: 1733,
        networkId: 1733,
        slip44: 1,
        explorers: [],
        status: 'incubating'
    },
    1734: {
        name: 'Fuga Develop',
        chain: 'Fuga',
        rpc: ['https://rpc-develop.fuga.blue'],
        faucets: [],
        nativeCurrency: { name: 'FUGA', symbol: 'FUGA', decimals: 18 },
        infoURL: 'https://fuga.one',
        shortName: 'FUGA_D',
        chainId: 1734,
        networkId: 1734,
        slip44: 1,
        explorers: [],
        status: 'incubating'
    },
    1740: {
        name: 'Metal L2 Testnet',
        chain: 'Metal L2 Testnet',
        rpc: ['https://testnet.rpc.metall2.com'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://metall2.com',
        shortName: 'metall2-testnet',
        chainId: 1740,
        networkId: 1740,
        icon: 'metal',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet.explorer.metall2.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmesm61n8vVVDEeZU7npz39aQYofes9vMfXYwWM4JehLFS'
    },
    1750: {
        name: 'Metal L2',
        chain: 'Metal L2',
        rpc: ['https://rpc.metall2.com'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://metall2.com',
        shortName: 'metall2',
        chainId: 1750,
        networkId: 1750,
        icon: 'metal',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.metall2.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmesm61n8vVVDEeZU7npz39aQYofes9vMfXYwWM4JehLFS'
    },
    1773: {
        name: 'PartyChain',
        chain: 'mainnet',
        rpc: ['https://tea.mining4people.com/rpc', 'http://172.104.194.36:8545'],
        faucets: [],
        nativeCurrency: { name: 'Grams', symbol: 'GRAMS', decimals: 18 },
        infoURL: 'TeaPartyCrypto.com',
        shortName: 'TeaParty',
        chainId: 1773,
        networkId: 1773,
        icon: 'grams',
        status: 'incubating',
        explorers: [
            {
                name: 'PartyExplorer',
                url: 'https://partyexplorer.co',
                icon: 'grams',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmerDBFoXvgev2xx9U71gAaAK4CtxaaQVaAPf9Qi6UF9MS'
    },
    1777: {
        name: 'Gauss Mainnet',
        chain: 'Gauss',
        icon: 'gauss',
        rpc: ['https://rpc.gaussgang.com'],
        faucets: [],
        nativeCurrency: { name: 'GANG', symbol: 'GANG', decimals: 18 },
        infoURL: 'https://gaussgang.com/',
        shortName: 'gauss',
        chainId: 1777,
        networkId: 1777,
        explorers: [
            {
                name: 'Gauss Explorer',
                url: 'https://explorer.gaussgang.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeDXUAYgQxwaSJLsqWgTqnrJVwicgEyNf9199xAMyRkqA'
    },
    1789: {
        name: 'ZKBase Sepolia Testnet',
        chain: 'ETH',
        rpc: ['https://sepolia-rpc.zkbase.app'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://zkbase.org/',
        shortName: 'zkbase-sepolia',
        chainId: 1789,
        networkId: 1789,
        slip44: 1,
        icon: 'zkbase',
        explorers: [
            {
                name: 'ZKbase Block Explorer',
                url: 'https://sepolia-explorer.zkbase.app',
                icon: 'zkbase',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://portal.zkbase.app/' }]
        },
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/QmRLtNvkVhC7rRDiLMHLckWbesaSU6sNYhQZgsAM1phTZx'
    },
    1804: {
        name: 'Kerleano',
        title: 'Proof of Climate awaReness testnet',
        chain: 'CRC',
        status: 'active',
        rpc: [
            'https://cacib-saturn-test.francecentral.cloudapp.azure.com',
            'wss://cacib-saturn-test.francecentral.cloudapp.azure.com:9443'
        ],
        faucets: [
            'https://github.com/ethereum-pocr/kerleano/blob/main/docs/faucet.md'
        ],
        nativeCurrency: {
            name: 'Climate awaReness Coin',
            symbol: 'CRC',
            decimals: 18
        },
        infoURL: 'https://github.com/ethereum-pocr/kerleano',
        shortName: 'kerleano',
        chainId: 1804,
        networkId: 1804,
        slip44: 1,
        icon: 'pocr',
        explorers: [
            {
                name: 'Lite Explorer',
                url: 'https://ethereum-pocr.github.io/explorer/kerleano',
                icon: 'pocr',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRLwpq47tyEd3rfK4tKRhbTvyb3fc7PCutExnL1XAb37A'
    },
    1807: {
        name: 'Rabbit Analog Testnet Chain',
        chain: 'rAna',
        icon: 'rabbit',
        rpc: ['https://rabbit.analog-rpc.com'],
        faucets: ['https://analogfaucet.com'],
        nativeCurrency: {
            name: 'Rabbit Analog Test Chain Native Token ',
            symbol: 'rAna',
            decimals: 18
        },
        infoURL: 'https://rabbit.analogscan.com',
        shortName: 'rAna',
        chainId: 1807,
        networkId: 1807,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://rabbit.analogscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdfbjjF3ZzN2jTkH9REgrA8jDS6A6c21n7rbWSVbSnvQc'
    },
    1811: {
        name: 'Lif3 Chain Testnet',
        chain: 'lif3chain',
        rpc: ['https://testnet-evm.lif3.com'],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: { name: 'LIF3', symbol: 'LIF3', decimals: 18 },
        infoURL: 'https://docs.lif3.com/',
        shortName: 'lif3-testnet',
        icon: 'lif3',
        chainId: 1811,
        networkId: 1811,
        explorers: [
            {
                name: 'lif3scout',
                url: 'https://testnet.lif3scout.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQqNBEqNnNsaSV6rik6mM8VnaSgYFxfEkjkiXSwgmEgaH'
    },
    1818: {
        name: 'Cube Chain Mainnet',
        chain: 'Cube',
        icon: 'cube',
        rpc: [
            'https://http-mainnet.cube.network',
            'wss://ws-mainnet.cube.network',
            'https://http-mainnet-sg.cube.network',
            'wss://ws-mainnet-sg.cube.network',
            'https://http-mainnet-us.cube.network',
            'wss://ws-mainnet-us.cube.network'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'Cube Chain Native Token',
            symbol: 'CUBE',
            decimals: 18
        },
        infoURL: 'https://www.cube.network',
        shortName: 'cube',
        chainId: 1818,
        networkId: 1818,
        slip44: 1818,
        explorers: [
            {
                name: 'cube-scan',
                url: 'https://cubescan.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbENgHTymTUUArX5MZ2XXH69WGenirU3oamkRD448hYdz'
    },
    1819: {
        name: 'Cube Chain Testnet',
        chain: 'Cube',
        icon: 'cube',
        rpc: [
            'https://http-testnet.cube.network',
            'wss://ws-testnet.cube.network',
            'https://http-testnet-sg.cube.network',
            'wss://ws-testnet-sg.cube.network',
            'https://http-testnet-jp.cube.network',
            'wss://ws-testnet-jp.cube.network',
            'https://http-testnet-us.cube.network',
            'wss://ws-testnet-us.cube.network'
        ],
        faucets: ['https://faucet.cube.network'],
        nativeCurrency: {
            name: 'Cube Chain Test Native Token',
            symbol: 'CUBET',
            decimals: 18
        },
        infoURL: 'https://www.cube.network',
        shortName: 'cubet',
        chainId: 1819,
        networkId: 1819,
        slip44: 1,
        explorers: [
            {
                name: 'cubetest-scan',
                url: 'https://testnet.cubescan.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbENgHTymTUUArX5MZ2XXH69WGenirU3oamkRD448hYdz'
    },
    1821: {
        name: 'Ruby Smart Chain MAINNET',
        chain: 'RUBY',
        rpc: [
            'https://mainnet-data.rubychain.io/',
            'https://mainnet.rubychain.io/'
        ],
        nativeCurrency: {
            name: 'RUBY Smart Chain Native Token',
            symbol: 'RUBY',
            decimals: 18
        },
        infoURL: 'https://rubychain.io',
        faucets: [],
        shortName: 'RUBY',
        chainId: 1821,
        networkId: 1821,
        slip44: 1,
        icon: 'ruby',
        explorers: [
            {
                name: 'RUBY Smart Chain MAINNET Explorer',
                icon: 'ruby',
                url: 'https://rubyscan.net',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXGJevyPHHKT28hDfsJ9Cq2DQ2bAavdie37MEwFQUVCQz'
    },
    1829: {
        name: 'PlayBlock',
        chain: 'playblock',
        rpc: ['https://rpc.playblock.io', 'wss://ws.playblock.io'],
        faucets: [],
        nativeCurrency: { name: 'PlayBlock', symbol: 'PBG', decimals: 18 },
        infoURL: 'https://www.playnance.com',
        shortName: 'playblock',
        chainId: 1829,
        slip44: 60,
        networkId: 1829,
        explorers: [
            {
                name: 'PlayBlock',
                url: 'https://explorer.playblock.io',
                standard: 'none'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-42161',
            bridges: [{ url: 'https://bridge.gelato.network/bridge/playblock' }]
        }
    },
    1833: {
        name: 'Verify testnet',
        title: 'Verify Testnet',
        chain: 'verify-testnet',
        rpc: [
            'https://rpc.verify-testnet.gelato.digital',
            'wss://ws.verify-testnet.gelato.digital'
        ],
        nativeCurrency: { name: 'Matic', symbol: 'MATIC', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/verify-testnet',
        faucets: [],
        shortName: 'verify-testnet',
        chainId: 1833,
        networkId: 1833,
        slip44: 60,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://verify-testnet.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-80002',
            bridges: [{ url: 'https://bridge.gelato.network/bridge/verify-testnet' }]
        }
    },
    1848: {
        name: 'Swisstronik Mainnet',
        chain: 'SWTR',
        rpc: [
            'https://json-rpc.mainnet.swisstronik.com/unencrypted/',
            'https://json-rpc.mainnet.swisstronik.com',
            'wss://ws-rpc.mainnet.swisstronik.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Swisstronik', symbol: 'SWTR', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.swisstronik.com',
        shortName: 'swtr',
        chainId: 1848,
        networkId: 1848,
        slip44: 1,
        icon: 'swisstronik',
        explorers: [
            {
                name: 'Swisstronik EVM Explorer',
                url: 'https://explorer-evm.mainnet.swisstronik.com',
                standard: 'EIP3091',
                icon: 'ethernal'
            },
            {
                name: 'Swisstronik Cosmos Explorer',
                url: 'https://explorer-cosmos.mainnet.swisstronik.com/swisstronik',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreietv32mc3rwbzymhlju6mrvmiavvgqg3sflafl2fjjxguqky56sca'
    },
    1853: {
        name: 'HighOctane Subnet',
        chain: 'HighOctane Subnet',
        rpc: [
            'https://subnets.avax.network/highoctane/mainnet/rpc',
            'wss://subnets.avax.network/highoctane/mainnet/ws'
        ],
        faucets: [],
        nativeCurrency: { name: 'HighOctane', symbol: 'HO', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://subnets.avax.network/highoctane/details',
        shortName: 'HighOctane',
        chainId: 1853,
        networkId: 1853,
        icon: 'highOctane',
        explorers: [
            {
                name: 'HighOctane Subnet Explorer',
                url: 'https://subnets.avax.network/highoctane',
                icon: 'highOctane',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibmj6pnsiybggr3koh5hbl2saungutcwbxme6pehteg5kzpzleubu'
    },
    1856: {
        name: 'Teslafunds',
        chain: 'TSF',
        rpc: ['https://tsfapi.europool.me'],
        faucets: [],
        nativeCurrency: { name: 'Teslafunds Ether', symbol: 'TSF', decimals: 18 },
        infoURL: 'https://teslafunds.io',
        shortName: 'tsf',
        chainId: 1856,
        networkId: 1
    },
    1868: {
        name: 'Soneium',
        shortName: 'soneium',
        title: 'Soneium mainnet',
        chain: 'ETH',
        rpc: ['https://rpc.soneium.org'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://soneium.org',
        chainId: 1868,
        networkId: 1868,
        status: 'active',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://soneium.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            },
            {
                name: 'OKLink',
                url: 'https://www.okx.com/web3/explorer/soneium',
                standard: 'EIP3091'
            },
            {
                name: 'SlamVision',
                url: 'https://soneium.slam.vision',
                standard: 'none'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://superbridge.app/soneium' }]
        }
    },
    1875: {
        name: 'Whitechain',
        chain: 'WBT',
        rpc: ['https://rpc.whitechain.io'],
        faucets: [],
        nativeCurrency: { name: 'WhiteBIT Coin', symbol: 'WBT', decimals: 18 },
        infoURL: 'https://whitechain.io',
        shortName: 'wbt',
        chainId: 1875,
        networkId: 1875,
        icon: 'whitechain',
        explorers: [
            {
                name: 'whitechain-explorer',
                url: 'https://explorer.whitechain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNeELax6vjkR9WZVmtggk8cam9xHVABZ4WvQyqkGCJ5qf'
    },
    1881: {
        name: 'Gitshock Cartenz Testnet',
        chain: 'Gitshock Cartenz',
        icon: 'gitshockchain',
        rpc: ['https://rpc.cartenz.works'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Gitshock Cartenz', symbol: 'tGTFX', decimals: 18 },
        infoURL: 'https://gitshock.com',
        shortName: 'gitshockchain',
        chainId: 1881,
        networkId: 1881,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://scan.cartenz.works',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifqpj5jkjazvh24muc7wv4r22tihzzl75cevgecxhvojm4ls6mzpq'
    },
    1890: {
        name: 'Lightlink Phoenix Mainnet',
        chain: 'Lightlink Phoenix Mainnet',
        icon: 'lightlink',
        rpc: ['https://replicator.phoenix.lightlink.io/rpc/v1'],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: { name: 'Ethereum', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://lightlink.io',
        shortName: 'lightlink_phoenix',
        chainId: 1890,
        networkId: 1890,
        explorers: [
            {
                name: 'phoenix',
                url: 'https://phoenix.lightlink.io',
                icon: 'lightlink',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXMDj6iAFn2ducQcUU1M87PMMdT2jfyL3Tp3Lz5uUD5Lv'
    },
    1891: {
        name: 'Lightlink Pegasus Testnet',
        chain: 'Lightlink Pegasus Testnet',
        icon: 'lightlink',
        rpc: ['https://replicator.pegasus.lightlink.io/rpc/v1'],
        features: [{ name: 'EIP155' }],
        faucets: ['https://faucet.pegasus.lightlink.io/'],
        nativeCurrency: { name: 'Ethereum', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://lightlink.io',
        shortName: 'lightlink_pegasus',
        chainId: 1891,
        networkId: 1891,
        slip44: 1,
        explorers: [
            {
                name: 'pegasus',
                url: 'https://pegasus.lightlink.io',
                icon: 'lightlink',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXMDj6iAFn2ducQcUU1M87PMMdT2jfyL3Tp3Lz5uUD5Lv'
    },
    1898: {
        name: 'BON Network',
        chain: 'BON',
        rpc: ['http://rpc.boyanet.org:8545', 'ws://rpc.boyanet.org:8546'],
        faucets: [],
        nativeCurrency: { name: 'BOYACoin', symbol: 'BOY', decimals: 18 },
        infoURL: 'https://boyanet.org',
        shortName: 'boya',
        chainId: 1898,
        networkId: 1,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer.boyanet.org:4001',
                standard: 'EIP3091'
            }
        ]
    },
    1899: {
        name: 'ReDeFi Layer 2',
        chain: 'ReDeFi',
        icon: 'redefi',
        rpc: ['https://layer2.redefi.world'],
        faucets: [],
        nativeCurrency: { name: 'RED', symbol: 'RED', decimals: 18 },
        infoURL: 'https://redefi.world',
        shortName: 'red',
        chainId: 1899,
        networkId: 1899,
        slip44: 1899,
        explorers: [
            {
                name: 'ReDeFi Scan',
                url: 'https://scanlayer2.redefi.world',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQd2MWwDkGsH6JsHPAKXqy8o2kedYMzbnaEHoRpmvSiLW'
    },
    1904: {
        name: 'Sports Chain Network',
        chain: 'SCN',
        rpc: ['https://rpc.sportschainnetwork.xyz/'],
        faucets: [],
        nativeCurrency: { name: 'SCN', symbol: 'SCN', decimals: 18 },
        infoURL: 'https://sportschainnetwork.xyz',
        shortName: 'SCN',
        chainId: 1904,
        networkId: 1904,
        icon: 'scn',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.sportschainnetwork.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdW7XfRgeyoaHXEvXp8MaVteonankR32CxhL3K5Yc2uQM'
    },
    1907: {
        name: 'Bitcichain Mainnet',
        chain: 'BITCI',
        icon: 'bitci',
        rpc: ['https://rpc.bitci.com'],
        faucets: [],
        nativeCurrency: { name: 'Bitci', symbol: 'BITCI', decimals: 18 },
        infoURL: 'https://www.bitcichain.com',
        shortName: 'bitci',
        chainId: 1907,
        networkId: 1907,
        explorers: [
            {
                name: 'Bitci Explorer',
                url: 'https://bitciexplorer.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbxmfWw5sVMASz5EbR1DCgLfk8PnqpSJGQKpYuEUpoxqn'
    },
    1908: {
        name: 'Bitcichain Testnet',
        chain: 'TBITCI',
        icon: 'bitci',
        rpc: ['https://testnet.bitcichain.com'],
        faucets: ['https://faucet.bitcichain.com'],
        nativeCurrency: { name: 'Test Bitci', symbol: 'TBITCI', decimals: 18 },
        infoURL: 'https://www.bitcichain.com',
        shortName: 'tbitci',
        chainId: 1908,
        networkId: 1908,
        slip44: 1,
        explorers: [
            {
                name: 'Bitci Explorer Testnet',
                url: 'https://testnet.bitciexplorer.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbxmfWw5sVMASz5EbR1DCgLfk8PnqpSJGQKpYuEUpoxqn'
    },
    1909: {
        name: 'Merkle Scan',
        chain: 'MRK',
        icon: 'merklescan',
        rpc: ['https://marklechain-rpc.merklescan.com'],
        faucets: [],
        nativeCurrency: { name: 'Merkle', symbol: 'MRK', decimals: 18 },
        infoURL: 'https://merklescan.com',
        shortName: 'MRK',
        chainId: 1909,
        networkId: 1909,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://merklescan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZocJpCSLoQqoYFkF1kn7uKDuAiFRNTK8P5PoVeiigDBU'
    },
    1911: {
        name: 'Scalind',
        chain: 'ETH',
        icon: 'scalind',
        rpc: ['https://rpc.scalind.com'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://scalind.com',
        shortName: 'scal',
        chainId: 1911,
        networkId: 1911,
        explorers: [
            {
                name: 'scalind',
                url: 'https://explorer.scalind.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmayuauUTSkYxbT1xi2AkkG5VLEMDhcMeZ18WZHiApPa9M'
    },
    1912: {
        name: 'Ruby Smart Chain Testnet',
        chain: 'RUBY',
        rpc: ['https://testnet-rchain.rubychain.io/'],
        nativeCurrency: {
            name: 'RUBY Smart Chain Native Token',
            symbol: 'tRUBY',
            decimals: 18
        },
        infoURL: 'https://rubychain.io',
        faucets: ['https://claim-faucet.rubychain.io/'],
        shortName: 'tRUBY',
        chainId: 1912,
        networkId: 1912,
        slip44: 1,
        icon: 'ruby',
        explorers: [
            {
                name: 'RUBY Smart Chain Testnet Explorer',
                icon: 'ruby',
                url: 'https://testnet.rubyscan.net',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXGJevyPHHKT28hDfsJ9Cq2DQ2bAavdie37MEwFQUVCQz'
    },
    1918: {
        name: 'UPB CRESCDI Testnet',
        chain: 'UPBEth',
        rpc: ['https://testnet.crescdi.pub.ro'],
        infoURL: 'https://mobylab.docs.crescdi.pub.ro/blog/UPB-CRESCDI-Testnet',
        faucets: [],
        nativeCurrency: { name: 'UPBEth', symbol: 'UPBEth', decimals: 18 },
        shortName: 'UPBEth',
        chainId: 1918,
        networkId: 1918,
        explorers: []
    },
    1923: {
        name: 'Swellchain',
        chain: 'ETH',
        rpc: ['https://swell-mainnet.alt.technology', 'https://rpc.ankr.com/swell'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://app.swellnetwork.io/layer2/swell-l2',
        shortName: 'swellchain',
        chainId: 1923,
        networkId: 1923,
        icon: 'swell',
        explorers: [
            {
                name: 'Swellchain Explorer',
                url: 'https://explorer.swellnetwork.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZcZreqE6P7JQCduEkXtni8UTJVjtX1PEiPFm7WpSEPc3'
    },
    1924: {
        name: 'Swellchain Testnet',
        chain: 'ETH',
        rpc: [
            'https://swell-testnet.alt.technology',
            'https://rpc.ankr.com/swell-testnet'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://app.swellnetwork.io/layer2/swell-l2',
        shortName: 'swellchain-sep',
        chainId: 1924,
        networkId: 1924,
        icon: 'swell',
        explorers: [
            {
                name: 'Swellchain Testnet Explorer',
                url: 'https://swell-testnet-explorer.alt.technology',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZcZreqE6P7JQCduEkXtni8UTJVjtX1PEiPFm7WpSEPc3'
    },
    1927: {
        name: 'Arvix Testnet',
        chain: 'Arvix',
        rpc: [
            'https://rpc-testnet-market.arvix.network',
            'https://rpc-dev-testnet.arvix.network'
        ],
        faucets: ['https://claim-faucet.arvix.network'],
        nativeCurrency: {
            name: 'Arvix Testnet Native Token',
            symbol: 'tARV',
            decimals: 18
        },
        infoURL: 'https://arvix.network',
        shortName: 'arvix',
        chainId: 1927,
        networkId: 1927,
        icon: 'arvix',
        explorers: [
            {
                name: 'Arvix Explorer Testnet',
                url: 'https://testnet.arvixscan.com',
                standard: 'EIP3091',
                icon: 'arvix'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcwGGWyemrFUZPriS3PqxLUoT7vdtS7FqNY5fAaoTG27Q'
    },
    1945: {
        name: 'ONUS Chain Testnet',
        title: 'ONUS Chain Testnet',
        chain: 'onus',
        rpc: ['https://rpc-testnet.onuschain.io'],
        faucets: [],
        nativeCurrency: { name: 'ONUS', symbol: 'ONUS', decimals: 18 },
        infoURL: 'https://onuschain.io',
        shortName: 'onus-testnet',
        chainId: 1945,
        networkId: 1945,
        slip44: 1,
        explorers: [
            {
                name: 'Onus explorer testnet',
                url: 'https://explorer-testnet.onuschain.io',
                icon: 'onus',
                standard: 'EIP3091'
            }
        ]
    },
    1946: {
        name: 'Soneium Testnet Minato',
        shortName: 'soneium-minato',
        title: 'Soneium Testnet Minato',
        chain: 'ETH',
        icon: 'minato',
        rpc: ['https://rpc.minato.soneium.org'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://soneium.org',
        chainId: 1946,
        networkId: 1946,
        explorers: [
            {
                name: 'Blockscout Minato explorer',
                url: 'https://soneium-minato.blockscout.com',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge.soneium.org/testnet' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafybeighhofhlz3qi5yv6ukqw6gthkuedhmgs5xcej4iibwan4dnvghnvi'
    },
    1949: {
        name: 'Bionix Testnet',
        chain: 'Bionix',
        rpc: ['https://testnet-chain.bionixnetwork.com'],
        faucets: [],
        nativeCurrency: { name: 'Bionix', symbol: 'tBIO', decimals: 18 },
        icon: 'bionix',
        infoURL: 'https://bionixnetwork.com',
        shortName: 'tbio',
        chainId: 1949,
        networkId: 1949,
        explorers: [
            {
                name: 'Bionix Testnet Explorer',
                url: 'https://testnet.bionixnetwork.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNVegdThJHrdcJxYTrmgccARTDTz9DkhxLffDCvDMp4an'
    },
    1951: {
        name: 'D-Chain Mainnet',
        chain: 'D-Chain',
        rpc: [
            'https://mainnet.d-chain.network/ext/bc/2ZiR1Bro5E59siVuwdNuRFzqL95NkvkbzyLBdrsYR9BLSHV7H4/rpc'
        ],
        nativeCurrency: { name: 'DOINX', symbol: 'DOINX', decimals: 18 },
        shortName: 'dchain-mainnet',
        chainId: 1951,
        networkId: 1951,
        icon: 'dchain',
        faucets: [],
        infoURL: '',
        iconURL: 'https://ipfs.io/ipfs/QmV2vhTqS9UyrX9Q6BSCbK4JrKBnS8ErHvstMjfb2oVWaj'
    },
    1953: {
        name: 'Selendra Network Testnet',
        chain: 'tSEL',
        rpc: ['https://rpc-testnet.selendra.org'],
        faucets: [],
        nativeCurrency: { name: 'Selendra', symbol: 'tSEL', decimals: 18 },
        infoURL: 'https://selendra.org',
        shortName: 'tSEL',
        chainId: 1953,
        networkId: 1953,
        icon: 'selendra',
        explorers: [
            {
                name: 'Selendra Portal',
                url: 'https://explorer.selendra.org',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbnLDuVc4JReFysyKvmpuqUtj9HCus6qoKD5nQ9QkokzK'
    },
    1954: {
        name: 'Dexilla Testnet',
        chain: 'Dexilla',
        rpc: ['https://rpc.dexilla.com'],
        faucets: [],
        icon: 'dxz',
        nativeCurrency: {
            name: 'Dexilla Native Token',
            symbol: 'DXZ',
            decimals: 18
        },
        infoURL: 'https://dexilla.com',
        shortName: 'Dexilla',
        chainId: 1954,
        networkId: 1954,
        slip44: 1,
        explorers: [
            {
                name: 'dos-mainnet',
                url: 'https://exp.dexilla.com',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge.dexilla.com' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmUBveetVibvSEWQrjyxySgUphLuoMGSVLGmYnobt5FgEZ'
    },
    1956: {
        name: 'AIW3 Testnet',
        chain: 'AIW3',
        rpc: ['https://rpc-testnet.aiw3.io/'],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://aiw3.io/',
        shortName: 'AIW3-Testnet',
        chainId: 1956,
        networkId: 1956,
        icon: 'aiw3',
        explorers: [
            {
                name: 'aiw3 testnet scan',
                url: 'https://scan-testnet.aiw3.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigfxcyvnx2r46a3unljb2auxeez5olbg56lbu4gkpa4me7wqoajjy'
    },
    1961: {
        name: 'Selendra Network Mainnet',
        chain: 'SEL',
        rpc: ['https://rpc.selendra.org', 'https://rpc2.selendra.org'],
        faucets: [],
        nativeCurrency: { name: 'Selendra', symbol: 'SEL', decimals: 18 },
        infoURL: 'https://selendra.org',
        shortName: 'SEL',
        chainId: 1961,
        networkId: 1961,
        icon: 'selendra',
        explorers: [
            {
                name: 'Selendra Portal',
                url: 'https://explorer.selendra.org',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbnLDuVc4JReFysyKvmpuqUtj9HCus6qoKD5nQ9QkokzK'
    },
    1967: {
        name: 'Eleanor',
        title: 'Metatime Testnet Eleanor',
        chain: 'MTC',
        rpc: ['https://rpc.metatime.com/eleanor', 'wss://ws.metatime.com/eleanor'],
        faucets: ['https://faucet.metatime.com/eleanor'],
        nativeCurrency: { name: 'Eleanor Metacoin', symbol: 'MTC', decimals: 18 },
        infoURL: 'https://eleanor.metatime.com',
        shortName: 'mtc',
        chainId: 1967,
        networkId: 1967,
        slip44: 1,
        explorers: [
            {
                name: 'metaexplorer-eleanor',
                url: 'https://explorer.metatime.com/eleanor',
                standard: 'EIP3091'
            }
        ]
    },
    1969: {
        name: 'Super Smart Chain Testnet',
        chain: 'TSCS',
        rpc: ['https://testnetrpc.scschain.com'],
        faucets: ['https://testnet.scschain.com'],
        nativeCurrency: {
            name: 'Super Chain Native Token',
            symbol: 'TSCS',
            decimals: 18
        },
        infoURL: 'https://testnet.scschain.com',
        shortName: 'tscs',
        chainId: 1969,
        networkId: 1969,
        slip44: 1,
        icon: 'super',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnetscan.scschain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW4C4QHLMhLeH5MsdVbauMc2Skb4ehzLKU3egLKKoux4D'
    },
    1970: {
        name: 'Super Smart Chain Mainnet',
        chain: 'SCS',
        rpc: ['https://rpc.scschain.com'],
        faucets: [],
        nativeCurrency: {
            name: 'Super Chain Native Token',
            symbol: 'SCS',
            decimals: 18
        },
        infoURL: 'https://scschain.com',
        shortName: 'scs',
        chainId: 1970,
        networkId: 1970,
        icon: 'super',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://scan.scschain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW4C4QHLMhLeH5MsdVbauMc2Skb4ehzLKU3egLKKoux4D'
    },
    1971: {
        name: 'Atelier',
        title: 'Atelier Test Network',
        chain: 'ALTR',
        rpc: ['https://1971.network/atlr', 'wss://1971.network/atlr'],
        faucets: [],
        nativeCurrency: { name: 'ATLR', symbol: 'ATLR', decimals: 18 },
        infoURL: 'https://1971.network/',
        shortName: 'atlr',
        chainId: 1971,
        networkId: 1971,
        slip44: 1,
        icon: 'atlr',
        iconURL: 'https://ipfs.io/ipfs/bafkreigcquvoalec3ll2m26v4wsx5enlxwyn6nk2mgfqwncyqrgwivla5u'
    },
    1972: {
        name: 'RedeCoin',
        chain: 'REDEV2',
        rpc: ['https://rpc2.redecoin.eu'],
        faucets: [],
        nativeCurrency: { name: 'RedeCoin', symbol: 'REDEV2', decimals: 18 },
        infoURL: 'https://www.redecoin.eu',
        shortName: 'rede',
        chainId: 1972,
        networkId: 1972,
        explorers: [
            {
                name: 'RedeCoin Explorer',
                url: 'https://explorer3.redecoin.eu',
                standard: 'none'
            }
        ]
    },
    1975: {
        name: 'ONUS Chain Mainnet',
        title: 'ONUS Chain Mainnet',
        chain: 'onus',
        rpc: ['https://rpc.onuschain.io', 'wss://ws.onuschain.io'],
        faucets: [],
        nativeCurrency: { name: 'ONUS', symbol: 'ONUS', decimals: 18 },
        infoURL: 'https://onuschain.io',
        shortName: 'onus-mainnet',
        chainId: 1975,
        networkId: 1975,
        explorers: [
            {
                name: 'Onus explorer mainnet',
                url: 'https://explorer.onuschain.io',
                icon: 'onus',
                standard: 'EIP3091'
            }
        ]
    },
    1984: {
        name: 'Eurus Testnet',
        chain: 'EUN',
        rpc: ['https://testnet.eurus.network'],
        faucets: [],
        nativeCurrency: { name: 'Eurus', symbol: 'EUN', decimals: 18 },
        infoURL: 'https://eurus.network',
        shortName: 'euntest',
        chainId: 1984,
        networkId: 1984,
        slip44: 1,
        icon: 'eurus',
        explorers: [
            {
                name: 'testnetexplorer',
                url: 'https://testnetexplorer.eurus.network',
                icon: 'eurus',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaGd5L9jGPbfyGXBFhu9gjinWJ66YtNrXq8x6Q98Eep9e'
    },
    1985: {
        name: 'SatoshIE',
        chain: 'TUSHY',
        rpc: ['http://rpc.satosh.ie'],
        faucets: [],
        nativeCurrency: { name: 'Tushy Token', symbol: 'TUSHY', decimals: 18 },
        infoURL: 'https://satosh.ie',
        shortName: 'satoshie',
        chainId: 1985,
        networkId: 1985,
        icon: 'satoshie',
        explorers: [
            {
                name: 'mainnetexplorer',
                url: 'http://explore.satosh.ie',
                icon: 'satoshie',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRHT4o9ihiY6nVkkRdwZjdugbEAQiXrrov3GS9a3GTuL7'
    },
    1986: {
        name: 'SatoshIE Testnet',
        chain: 'TUSHY',
        rpc: ['http://testnet.satosh.ie'],
        faucets: [],
        nativeCurrency: { name: 'Tushy Token', symbol: 'TUSHY', decimals: 18 },
        infoURL: 'https://satosh.ie',
        shortName: 'satoshie_testnet',
        chainId: 1986,
        networkId: 1986,
        slip44: 1,
        icon: 'satoshie',
        explorers: [
            {
                name: 'testnetexplorer',
                url: 'http://explore-testnet.satosh.ie',
                icon: 'satoshie',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRHT4o9ihiY6nVkkRdwZjdugbEAQiXrrov3GS9a3GTuL7'
    },
    1987: {
        name: 'EtherGem',
        chain: 'EGEM',
        rpc: ['https://jsonrpc.egem.io/custom'],
        faucets: [],
        nativeCurrency: { name: 'EtherGem Ether', symbol: 'EGEM', decimals: 18 },
        infoURL: 'https://egem.io',
        shortName: 'egem',
        chainId: 1987,
        networkId: 1987,
        slip44: 1987
    },
    1989: {
        name: 'Lydia Coin',
        chain: 'LYDIA',
        rpc: ['https://rpc.lydiacoins.com'],
        faucets: [],
        nativeCurrency: { name: 'Lydia Coin', symbol: 'BSW', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/lydia-coin',
        shortName: 'lydia',
        chainId: 1989,
        networkId: 1989
    },
    1992: {
        name: 'Hubble Exchange',
        chain: 'Hubblenet',
        icon: 'hubblenet',
        rpc: ['https://rpc.hubble.exchange', 'wss://ws-rpc.hubble.exchange'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'USD Coin', symbol: 'USDC', decimals: 18 },
        infoURL: 'https://www.hubble.exchange',
        shortName: 'hubblenet',
        chainId: 1992,
        networkId: 1992,
        slip44: 60,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmU9t9fZaWiqpAZ9dw2ojTpJycnB8BxekLWVSCJikJVgjW'
    },
    1993: {
        name: 'B3 Sepolia Testnet',
        chain: 'B3 Sepolia Testnet',
        icon: 'b3',
        rpc: ['https://sepolia.b3.fun'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://b3.fun',
        shortName: 'b3-sepolia',
        chainId: 1993,
        networkId: 1993,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://sepolia.explorer.b3.fun',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme5W7SmKGv3gqciYFWuZvA4QKJAU2XKwSzC6cXLx7wGJu'
    },
    1994: {
        name: 'Ekta',
        chain: 'EKTA',
        rpc: ['https://main.ekta.io'],
        faucets: [],
        nativeCurrency: { name: 'EKTA', symbol: 'EKTA', decimals: 18 },
        infoURL: 'https://www.ekta.io',
        shortName: 'ekta',
        chainId: 1994,
        networkId: 1994,
        icon: 'ekta',
        explorers: [
            {
                name: 'ektascan',
                url: 'https://ektascan.io',
                icon: 'ekta',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfMd564KUPK8eKZDwGCT71ZC2jMnUZqP6LCtLpup3rHH1'
    },
    1995: {
        name: 'edeXa Testnet',
        chain: 'edeXa',
        rpc: ['https://rpc.testnet.edexa.network', 'https://rpc.testnet.edexa.com'],
        faucets: ['https://faucet.edexa.com/'],
        nativeCurrency: { name: 'edeXa', symbol: 'tEDX', decimals: 18 },
        infoURL: 'https://edexa.network/',
        shortName: 'edxt',
        chainId: 1995,
        networkId: 1995,
        slip44: 1,
        icon: 'edexa',
        explorers: [
            {
                name: 'edexa-testnet-explorer',
                url: 'https://explorer.testnet.edexa.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSgvmLpRsCiu2ySqyceA5xN4nwi7URJRNEZLffwEKXdoR'
    },
    1996: {
        name: 'Sanko',
        chain: 'Sanko',
        rpc: ['https://mainnet.sanko.xyz'],
        faucets: [],
        nativeCurrency: { name: 'DMT', symbol: 'DMT', decimals: 18 },
        infoURL: 'https://sanko.xyz/',
        shortName: 'Sanko',
        chainId: 1996,
        networkId: 1996,
        icon: 'sanko',
        explorers: [
            {
                name: 'Sanko Explorer',
                url: 'https://explorer.sanko.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmbwi5FoJdL6HuFmQGQu1sdyoGrSuj45H12tMNTnpRAmLw'
    },
    1997: {
        name: 'Kyoto',
        chain: 'KYOTO',
        rpc: ['https://rpc.kyotochain.io'],
        faucets: [],
        nativeCurrency: { name: 'Kyoto', symbol: 'KYOTO', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://kyotoprotocol.io',
        shortName: 'kyoto',
        chainId: 1997,
        networkId: 1997,
        slip44: 1,
        explorers: [
            {
                name: 'Kyotoscan',
                url: 'https://kyotoscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    1998: {
        name: 'Kyoto Testnet',
        chain: 'KYOTO',
        rpc: ['https://rpc.testnet.kyotoprotocol.io:8545'],
        faucets: ['https://faucet.kyotoprotocol.io'],
        nativeCurrency: { name: 'Kyoto', symbol: 'KYOTO', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://kyotoprotocol.io',
        shortName: 'kyoto-testnet',
        chainId: 1998,
        networkId: 1998,
        slip44: 1,
        explorers: [
            {
                name: 'Kyotoscan',
                url: 'https://testnet.kyotoscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    2000: {
        name: 'Dogechain Mainnet',
        chain: 'DC',
        icon: 'dogechain',
        rpc: [
            'https://rpc.dogechain.dog',
            'https://rpc01-sg.dogechain.dog',
            'https://rpc.ankr.com/dogechain'
        ],
        faucets: [],
        nativeCurrency: { name: 'Dogecoin', symbol: 'DOGE', decimals: 18 },
        infoURL: 'https://dogechain.dog',
        shortName: 'dc',
        chainId: 2000,
        networkId: 2000,
        explorers: [
            {
                name: 'dogechain explorer',
                url: 'https://explorer.dogechain.dog',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNS6B6L8FfgGSMTEi2SxD3bK5cdmKPNtQKcYaJeRWrkHs'
    },
    2001: {
        name: 'Milkomeda C1 Mainnet',
        chain: 'milkAda',
        icon: 'milkomeda',
        rpc: [
            'https://rpc-mainnet-cardano-evm.c1.milkomeda.com',
            'wss://rpc-mainnet-cardano-evm.c1.milkomeda.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'milkAda', symbol: 'mADA', decimals: 18 },
        infoURL: 'https://milkomeda.com',
        shortName: 'milkAda',
        chainId: 2001,
        networkId: 2001,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer-mainnet-cardano-evm.c1.milkomeda.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdoUtvHDybu5ppYBZT8BMRp6AqByVSoQs8nFwKbaS55jd'
    },
    2002: {
        name: 'Milkomeda A1 Mainnet',
        chain: 'milkALGO',
        icon: 'milkomeda',
        rpc: [
            'https://rpc-mainnet-algorand-rollup.a1.milkomeda.com',
            'wss://rpc-mainnet-algorand-rollup.a1.milkomeda.com/ws'
        ],
        faucets: [],
        nativeCurrency: { name: 'milkALGO', symbol: 'mALGO', decimals: 18 },
        infoURL: 'https://milkomeda.com',
        shortName: 'milkALGO',
        chainId: 2002,
        networkId: 2002,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer-mainnet-algorand-rollup.a1.milkomeda.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdoUtvHDybu5ppYBZT8BMRp6AqByVSoQs8nFwKbaS55jd'
    },
    2004: {
        name: 'MetaLink Network',
        chain: 'MetaLink',
        rpc: ['http://77.237.237.69:9933'],
        icon: 'metaLink',
        faucets: [],
        shortName: 'mtl',
        nativeCurrency: { name: 'MetaLink', symbol: 'MTL', decimals: 18 },
        infoURL: 'http://totwo3.com:3000',
        chainId: 2004,
        networkId: 2004,
        explorers: [
            {
                name: 'MetaScan',
                url: 'http://twoto3.com:3000',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfSXRkDPSwt7heQ24pDtWKN6vvervEaTJHmueyRp1mpg1'
    },
    2008: {
        name: 'CloudWalk Testnet',
        chain: 'CloudWalk Testnet',
        rpc: [],
        faucets: [],
        nativeCurrency: {
            name: 'CloudWalk Native Token',
            symbol: 'CWN',
            decimals: 18
        },
        infoURL: 'https://cloudwalk.io',
        shortName: 'cloudwalk_testnet',
        chainId: 2008,
        networkId: 2008,
        slip44: 1,
        explorers: [
            {
                name: 'CloudWalk Testnet Explorer',
                url: 'https://explorer.testnet.cloudwalk.io',
                standard: 'none'
            }
        ]
    },
    2009: {
        name: 'CloudWalk Mainnet',
        chain: 'CloudWalk Mainnet',
        rpc: [],
        faucets: [],
        nativeCurrency: {
            name: 'CloudWalk Native Token',
            symbol: 'CWN',
            decimals: 18
        },
        infoURL: 'https://cloudwalk.io',
        shortName: 'cloudwalk_mainnet',
        chainId: 2009,
        networkId: 2009,
        explorers: [
            {
                name: 'CloudWalk Mainnet Explorer',
                url: 'https://explorer.mainnet.cloudwalk.io',
                standard: 'none'
            }
        ]
    },
    2013: {
        name: 'Panarchy',
        chain: 'Panarchy',
        rpc: ['https://polytopia.org:8545'],
        faucets: [],
        nativeCurrency: { name: 'GAS', symbol: 'GAS', decimals: 18 },
        infoURL: 'https://polytopia.org/',
        shortName: 'panarchy',
        chainId: 2013,
        networkId: 1
    },
    2014: {
        name: 'NOW Chain Testnet',
        chain: 'NOW',
        icon: 'nowchain',
        rpc: ['https://rpc-testnet.nowscan.io'],
        faucets: ['https://faucet.nowchain.co'],
        nativeCurrency: { name: 'NOW Coin', symbol: 'NOW', decimals: 18 },
        infoURL: 'https://nowchain.co',
        shortName: 'tnow',
        chainId: 2014,
        networkId: 2014,
        explorers: [
            {
                name: 'nowscan testnet',
                url: 'https://testnet.nowscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSUzhRGzMyMyGwBcE3ooZ5jvHKyJ1FjVjh5SfoGHG36MX'
    },
    2016: {
        name: 'MainnetZ Mainnet',
        chain: 'NetZ',
        icon: 'mainnetz',
        rpc: ['https://mainnet-rpc.mainnetz.io', 'https://eu-rpc.mainnetz.io'],
        faucets: [],
        nativeCurrency: { name: 'MainnetZ', symbol: 'NetZ', decimals: 18 },
        infoURL: 'https://mainnetz.io',
        shortName: 'netz',
        chainId: 2016,
        networkId: 2016,
        explorers: [
            {
                name: 'MainnetZ',
                url: 'https://explorer.mainnetz.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmT5gJ5weBiLT3GoYuF5yRTRLdPLCVZ3tXznfqW7M8fxgG'
    },
    2017: {
        name: 'Adiri',
        title: 'Telcoin Network Testnet',
        chain: 'TEL',
        icon: 'telcoin',
        rpc: [
            'https://rpc.telcoin.network',
            'https://adiri.tel',
            'https://node1.telcoin.network',
            'https://node2.telcoin.network',
            'https://node3.telcoin.network',
            'https://node4.telcoin.network'
        ],
        faucets: ['https://telcoin.network/faucet'],
        nativeCurrency: { name: 'Telcoin', symbol: 'TEL', decimals: 18 },
        infoURL: 'https://telcoin.network',
        shortName: 'tel',
        chainId: 2017,
        networkId: 2017,
        slip44: 1,
        explorers: [
            {
                name: 'telscan',
                url: 'https://telscan.io',
                icon: 'telcoin',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreih4obvrymfdqohzhiafhvpcy6zwqbgpfm26aahrv3qx2dtcei7hk4'
    },
    2018: {
        name: 'PublicMint Devnet',
        title: 'Public Mint Devnet',
        chain: 'PublicMint',
        rpc: ['https://rpc.dev.publicmint.io:8545'],
        faucets: [],
        nativeCurrency: { name: 'USD', symbol: 'USD', decimals: 18 },
        infoURL: 'https://publicmint.com',
        shortName: 'pmint_dev',
        chainId: 2018,
        networkId: 2018,
        slip44: 60,
        explorers: [
            {
                name: 'PublicMint Explorer',
                url: 'https://explorer.dev.publicmint.io',
                standard: 'EIP3091'
            }
        ]
    },
    2019: {
        name: 'PublicMint Testnet',
        title: 'Public Mint Testnet',
        chain: 'PublicMint',
        rpc: ['https://rpc.tst.publicmint.io:8545'],
        faucets: [],
        nativeCurrency: { name: 'USD', symbol: 'USD', decimals: 18 },
        infoURL: 'https://publicmint.com',
        shortName: 'pmint_test',
        chainId: 2019,
        networkId: 2019,
        slip44: 1,
        explorers: [
            {
                name: 'PublicMint Explorer',
                url: 'https://explorer.tst.publicmint.io',
                standard: 'EIP3091'
            }
        ]
    },
    2020: {
        name: 'Ronin Mainnet',
        title: 'Ronin',
        chain: 'ronin',
        rpc: ['https://api.roninchain.com/rpc'],
        faucets: [],
        nativeCurrency: { name: 'RON', symbol: 'RON', decimals: 18 },
        infoURL: 'https://roninchain.com',
        shortName: 'ron',
        chainId: 2020,
        networkId: 2020,
        redFlags: ['reusedChainId'],
        explorers: [
            {
                name: 'Ronin Block Explorer',
                url: 'https://app.roninchain.com',
                standard: 'EIP3091'
            }
        ]
    },
    2021: {
        name: 'Edgeware EdgeEVM Mainnet',
        chain: 'EDG',
        icon: 'edgeware',
        rpc: [
            'https://edgeware-evm.jelliedowl.net',
            'https://edgeware-evm0.jelliedowl.net',
            'https://edgeware-evm1.jelliedowl.net',
            'https://edgeware-evm2.jelliedowl.net',
            'https://edgeware-evm3.jelliedowl.net',
            'wss://edgeware.jelliedowl.net',
            'wss://edgeware-rpc0.jelliedowl.net',
            'wss://edgeware-rpc1.jelliedowl.net',
            'wss://edgeware-rpc2.jelliedowl.net',
            'wss://edgeware-rpc3.jelliedowl.net'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Edgeware', symbol: 'EDG', decimals: 18 },
        infoURL: 'https://edgeware.io',
        shortName: 'edg',
        chainId: 2021,
        networkId: 2021,
        slip44: 523,
        explorers: [
            {
                name: 'Edgscan EdgeEVM explorer by Bharathcoorg',
                url: 'https://edgscan.live',
                standard: 'EIP3091'
            },
            {
                name: 'Edgscan EdgeWASM explorer by Bharathcoorg',
                url: 'https://edgscan.ink',
                standard: 'none',
                icon: 'edgscan'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWCSXYLigYE6qEiese4cso2icgKQyosV3x1adtxJnRyJ9'
    },
    2022: {
        name: 'Beresheet BereEVM Testnet',
        chain: 'EDG',
        rpc: [
            'https://beresheet-evm.jelliedowl.net',
            'wss://beresheet.jelliedowl.net'
        ],
        faucets: [],
        nativeCurrency: { name: 'Testnet EDG', symbol: 'tEDG', decimals: 18 },
        infoURL: 'https://edgeware.io/build',
        shortName: 'edgt',
        chainId: 2022,
        networkId: 2022,
        slip44: 1,
        explorers: [
            {
                name: 'Edgscan by Bharathcoorg',
                url: 'https://testnet.edgscan.live',
                standard: 'EIP3091'
            }
        ]
    },
    2023: {
        name: 'Taycan Testnet',
        chain: 'Taycan',
        rpc: ['https://test-taycan.hupayx.io'],
        faucets: ['https://ttaycan-faucet.hupayx.io/'],
        nativeCurrency: { name: 'test-Shuffle', symbol: 'tSFL', decimals: 18 },
        infoURL: 'https://hupayx.io',
        shortName: 'taycan-testnet',
        chainId: 2023,
        networkId: 2023,
        slip44: 1,
        icon: 'shuffle',
        explorers: [
            {
                name: 'Taycan Explorer(Blockscout)',
                url: 'https://evmscan-test.hupayx.io',
                standard: 'none',
                icon: 'shuffle'
            },
            {
                name: 'Taycan Cosmos Explorer',
                url: 'https://cosmoscan-test.hupayx.io',
                standard: 'none',
                icon: 'shuffle'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidvjcc73v747lqlyrhgbnkvkdepdvepo6baj6hmjsmjtvdyhmzzmq'
    },
    2024: {
        name: 'Swan Saturn Testnet',
        chain: 'SWAN',
        rpc: ['https://saturn-rpc.swanchain.io'],
        faucets: [],
        nativeCurrency: { name: 'SWANETH', symbol: 'sETH', decimals: 18 },
        infoURL: 'https://swanchain.io/',
        shortName: 'saturn',
        chainId: 2024,
        networkId: 2024
    },
    2025: {
        name: 'Rangers Protocol Mainnet',
        chain: 'Rangers',
        icon: 'rangers',
        rpc: ['https://mainnet.rangersprotocol.com/api/jsonrpc'],
        faucets: [],
        nativeCurrency: {
            name: 'Rangers Protocol Gas',
            symbol: 'RPG',
            decimals: 18
        },
        infoURL: 'https://rangersprotocol.com',
        shortName: 'rpg',
        chainId: 2025,
        networkId: 2025,
        slip44: 1008,
        explorers: [
            {
                name: 'rangersscan',
                url: 'https://scan.rangersprotocol.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXR5e5SDABWfQn6XT9uMsVYAo5Bv7vUv4jVs8DFqatZWG'
    },
    2026: {
        name: 'Edgeless Network',
        chain: 'Edgeless',
        rpc: ['https://rpc.edgeless.network/http'],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: {
            name: 'Edgeless Wrapped Eth',
            symbol: 'EwEth',
            decimals: 18
        },
        infoURL: 'https://edgeless.network',
        shortName: 'edgeless',
        chainId: 2026,
        networkId: 2026,
        explorers: [
            {
                name: 'Edgeless Explorer',
                url: 'https://explorer.edgeless.network',
                standard: 'EIP3091'
            }
        ]
    },
    2031: {
        name: 'Centrifuge',
        chain: 'CFG',
        icon: 'centrifuge',
        rpc: [
            'https://fullnode.centrifuge.io',
            'wss://fullnode.centrifuge.io',
            'https://centrifuge-parachain.api.onfinality.io/public',
            'wss://centrifuge-parachain.api.onfinality.io/public-ws',
            'https://centrifuge-rpc.dwellir.com',
            'wss://centrifuge-rpc.dwellir.com',
            'https://rpc-centrifuge.luckyfriday.io',
            'wss://rpc-centrifuge.luckyfriday.io'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Centrifuge', symbol: 'CFG', decimals: 18 },
        infoURL: 'https://centrifuge.io',
        shortName: 'cfg',
        chainId: 2031,
        networkId: 2031,
        explorers: [
            {
                name: 'subscan',
                url: 'https://centrifuge.subscan.io',
                standard: 'EIP3091',
                icon: 'subscan'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmedNc3WvTm66iNK2NYW6Fzu5tx5FgNa6HCBf3DTHpzQZ1'
    },
    2032: {
        name: 'Catalyst',
        chain: 'CFG',
        rpc: ['wss://fullnode.catalyst.cntrfg.com'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Catalyst CFG', symbol: 'NCFG', decimals: 18 },
        infoURL: 'https://centrifuge.io',
        shortName: 'ncfg',
        chainId: 2032,
        networkId: 2032
    },
    2035: {
        name: 'Phala Network',
        chain: 'ETH',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://phala.network',
        shortName: 'phala',
        chainId: 2035,
        networkId: 2035,
        status: 'incubating'
    },
    2037: {
        name: 'Kiwi Subnet',
        chain: 'KIWI',
        rpc: ['https://subnets.avax.network/kiwi/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Shrapgas', symbol: 'SHRAP', decimals: 18 },
        infoURL: '',
        shortName: 'kiwi',
        chainId: 2037,
        networkId: 2037,
        slip44: 1,
        explorers: [
            {
                name: 'KIWI Explorer',
                url: 'https://subnets-test.avax.network/kiwi',
                standard: 'EIP3091'
            }
        ]
    },
    2038: {
        name: 'Shrapnel Testnet',
        chain: 'SHRAPNEL',
        rpc: ['https://subnets.avax.network/shrapnel/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'SHRAPG', symbol: 'SHRAPG', decimals: 18 },
        infoURL: 'https://www.shrapnel.com/',
        shortName: 'shraptest',
        chainId: 2038,
        networkId: 2038,
        slip44: 1,
        explorers: [
            {
                name: 'SHRAPNEL Explorer',
                url: 'https://subnets-test.avax.network/shrapnel',
                standard: 'EIP3091'
            }
        ]
    },
    2039: {
        name: 'Aleph Zero',
        chain: 'Aleph Zero',
        icon: 'aleph',
        rpc: [
            'https://rpc.alephzero-testnet.gelato.digital',
            'wss://rpc.alephzero-testnet.gelato.digital'
        ],
        faucets: [],
        nativeCurrency: { name: 'TZERO', symbol: 'TZERO', decimals: 18 },
        infoURL: 'https://alephzero.org/',
        shortName: 'aleph',
        chainId: 2039,
        networkId: 2039,
        explorers: [
            {
                name: 'Aleph Zero',
                url: 'https://evm-explorer-testnet.alephzero.org',
                icon: 'aleph',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbeSYW2c5pXAyEUzj8UFRdJhp5oMQzRMPqAsxJAqbGiem'
    },
    2040: {
        name: 'Vanar Mainnet',
        title: 'Vanarchain',
        chain: 'VANAR',
        rpc: ['https://rpc.vanarchain.com', 'wss://ws.vanarchain.com'],
        faucets: [],
        nativeCurrency: { name: 'VANRY', symbol: 'VANRY', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://vanarchain.com',
        shortName: 'Vanar',
        chainId: 2040,
        networkId: 2040,
        icon: 'vanar',
        explorers: [
            {
                name: 'Vanar Explorer',
                url: 'https://explorer.vanarchain.com',
                icon: 'vanar',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmbx25iq4Vn4zLooPit9bbguXJzdiogwtVQWtSseyQPuSC'
    },
    2043: {
        name: 'NeuroWeb',
        chain: 'NEUROWEB',
        rpc: [
            'https://astrosat.origintrail.network',
            'wss://parachain-rpc.origin-trail.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'NeuroWeb Token', symbol: 'NEURO', decimals: 12 },
        infoURL: 'https://neuroweb.ai',
        shortName: 'NEURO',
        chainId: 2043,
        networkId: 2043
    },
    2044: {
        name: 'Shrapnel Subnet',
        chain: 'shrapnel',
        rpc: ['https://subnets.avax.network/shrapnel/mainnet/rpc'],
        faucets: [],
        nativeCurrency: {
            name: 'Shrapnel Gas Token',
            symbol: 'SHRAPG',
            decimals: 18
        },
        infoURL: 'https://www.shrapnel.com/',
        shortName: 'Shrapnel',
        chainId: 2044,
        networkId: 2044
    },
    2045: {
        name: 'AIW3 Mainnet',
        chain: 'AIW3',
        status: 'incubating',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://aiw3.io/',
        shortName: 'AIW3',
        chainId: 2045,
        networkId: 2045,
        icon: 'aiw3',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/bafkreigfxcyvnx2r46a3unljb2auxeez5olbg56lbu4gkpa4me7wqoajjy'
    },
    2047: {
        name: 'Stratos Testnet',
        chain: 'STOS',
        rpc: ['https://web3-rpc-mesos.thestratos.org'],
        faucets: [],
        nativeCurrency: { name: 'STOS', symbol: 'STOS', decimals: 18 },
        infoURL: 'https://www.thestratos.org',
        shortName: 'stos-testnet',
        chainId: 2047,
        networkId: 2047,
        slip44: 1,
        explorers: [
            {
                name: 'Stratos EVM Explorer (Blockscout)',
                url: 'https://web3-explorer-mesos.thestratos.org',
                standard: 'none'
            },
            {
                name: 'Stratos Cosmos Explorer (BigDipper)',
                url: 'https://big-dipper-mesos.thestratos.org',
                standard: 'none'
            }
        ]
    },
    2048: {
        name: 'Stratos',
        chain: 'STOS',
        rpc: ['https://web3-rpc.thestratos.org'],
        faucets: [],
        nativeCurrency: { name: 'STOS', symbol: 'STOS', decimals: 18 },
        infoURL: 'https://www.thestratos.org',
        shortName: 'stos-mainnet',
        chainId: 2048,
        networkId: 2048,
        explorers: [
            {
                name: 'Stratos EVM Explorer (Blockscout)',
                url: 'https://web3-explorer.thestratos.org',
                standard: 'none'
            },
            {
                name: 'Stratos Cosmos Explorer (BigDipper)',
                url: 'https://explorer.thestratos.org',
                standard: 'none'
            }
        ]
    },
    2049: {
        name: 'Movo Smart Chain Mainnet',
        chain: 'MOVO',
        icon: 'movo',
        rpc: [
            'https://msc-rpc.movoscan.com',
            'https://msc-rpc.movochain.org',
            'https://msc-rpc.movoswap.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Movo Smart Chain', symbol: 'MOVO', decimals: 18 },
        infoURL: 'https://movo.uk',
        shortName: 'movo',
        chainId: 2049,
        networkId: 2049,
        slip44: 2050,
        explorers: [
            {
                name: 'movoscan',
                url: 'https://movoscan.com',
                icon: 'movoscan',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSQGKhhBpMTM7vYpGdgMTDFyzaAN3PGG5AnmWy7KQPdSn'
    },
    2071: {
        name: 'Metacces Mainnet',
        chain: 'Metacces Mainnet',
        icon: 'metacces',
        rpc: ['https://oli.accesscan.io'],
        faucets: [],
        nativeCurrency: { name: 'Metacces', symbol: 'ACCES', decimals: 18 },
        infoURL: 'https://metacces.com',
        shortName: 'ACCES',
        chainId: 2071,
        networkId: 2071,
        explorers: [
            {
                name: 'accesscan',
                url: 'https://accesscan.io',
                icon: 'metacces',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbpYHpqR68uuJZCwm1CXtN51zi744qWzZ32ob9BKfgFTV'
    },
    2077: {
        name: 'Quokkacoin Mainnet',
        chain: 'Qkacoin',
        rpc: ['https://rpc.qkacoin.org'],
        faucets: [],
        nativeCurrency: { name: 'Qkacoin', symbol: 'QKA', decimals: 18 },
        infoURL: 'https://qkacoin.org',
        shortName: 'QKA',
        chainId: 2077,
        networkId: 2077,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.qkacoin.org',
                standard: 'EIP3091'
            }
        ]
    },
    2088: {
        name: 'Altair',
        chain: 'AIR',
        icon: 'altair',
        rpc: [
            'wss://fullnode.altair.centrifuge.io',
            'wss://altair.api.onfinality.io/public-ws'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Altair', symbol: 'AIR', decimals: 18 },
        infoURL: 'https://centrifuge.io',
        shortName: 'air',
        chainId: 2088,
        networkId: 2088,
        iconURL: 'https://ipfs.io/ipfs/QmSwqWxZ5HRdc25HMhEmVKxZkwSKapuuyGHb8kyrtuzxat'
    },
    2089: {
        name: 'Algol',
        chain: 'algol',
        status: 'deprecated',
        rpc: ['wss://fullnode.algol.cntrfg.com'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Algol', symbol: 'ALGL', decimals: 18 },
        infoURL: 'https://centrifuge.io',
        shortName: 'algl',
        chainId: 2089,
        networkId: 2089
    },
    2100: {
        name: 'Ecoball Mainnet',
        chain: 'ECO',
        rpc: ['https://api.ecoball.org/ecoball/'],
        faucets: [],
        nativeCurrency: { name: 'Ecoball Coin', symbol: 'ECO', decimals: 18 },
        infoURL: 'https://ecoball.org',
        shortName: 'eco',
        chainId: 2100,
        networkId: 2100,
        explorers: [
            {
                name: 'Ecoball Explorer',
                url: 'https://scan.ecoball.org',
                standard: 'EIP3091'
            }
        ]
    },
    2101: {
        name: 'Ecoball Testnet Espuma',
        chain: 'ECO',
        rpc: ['https://api.ecoball.org/espuma/'],
        faucets: [],
        nativeCurrency: { name: 'Espuma Coin', symbol: 'ECO', decimals: 18 },
        infoURL: 'https://ecoball.org',
        shortName: 'esp',
        chainId: 2101,
        networkId: 2101,
        slip44: 1,
        explorers: [
            {
                name: 'Ecoball Testnet Explorer',
                url: 'https://espuma-scan.ecoball.org',
                standard: 'EIP3091'
            }
        ]
    },
    2109: {
        name: 'Exosama Network',
        chain: 'EXN',
        rpc: ['https://rpc.exosama.com', 'wss://rpc.exosama.com'],
        faucets: [],
        nativeCurrency: { name: 'Sama Token', symbol: 'SAMA', decimals: 18 },
        infoURL: 'https://moonsama.com',
        shortName: 'exn',
        chainId: 2109,
        networkId: 2109,
        slip44: 2109,
        icon: 'exn',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.exosama.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaQxfwpXYTomUd24PMx5tKjosupXcm99z1jL1XLq9LWBS'
    },
    2112: {
        name: 'UCHAIN Mainnet',
        chain: 'UCHAIN',
        rpc: ['https://rpc.uchain.link/'],
        faucets: [],
        nativeCurrency: { name: 'UCASH', symbol: 'UCASH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://u.cash/',
        shortName: 'uchain',
        chainId: 2112,
        networkId: 2112,
        icon: 'ucash',
        explorers: [
            {
                name: 'uchain.info',
                url: 'https://uchain.info',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUz6jimQbYZ43aeQBC6nSy2m7W7U6xR2qG8tCki2Jvj9k'
    },
    2121: {
        name: 'Catena Mainnet',
        chain: 'CMCX',
        rpc: ['https://rpc1.catenarpc.com'],
        faucets: [],
        nativeCurrency: { name: 'Catena', symbol: 'CMCX', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://catena.network',
        shortName: 'cmcx',
        chainId: 2121,
        networkId: 2121,
        icon: 'catena',
        explorers: [
            {
                name: 'catenascan',
                url: 'https://catenascan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeAwHS3wcYz7k24LSYEjN1G7nwSfWmGf5FghNZ2qzVD4N'
    },
    2122: {
        name: 'Metaplayerone Mainnet',
        chain: 'METAD',
        icon: 'metad',
        rpc: ['https://rpc.metaplayer.one/'],
        faucets: [],
        nativeCurrency: { name: 'METAD', symbol: 'METAD', decimals: 18 },
        infoURL: 'https://docs.metaplayer.one/',
        shortName: 'Metad',
        chainId: 2122,
        networkId: 2122,
        explorers: [
            {
                name: 'Metad Scan',
                url: 'https://scan.metaplayer.one',
                icon: 'metad',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZyxS9BfRGYWWDtvrV6qtthCYV4TwdjLoH2sF6MkiTYFf'
    },
    2124: {
        name: 'Metaplayerone Dubai Testnet',
        chain: 'MP1 Dubai-Testnet',
        rpc: ['https://rpc-dubai.mp1network.com/'],
        faucets: [],
        nativeCurrency: { name: 'Metaunit', symbol: 'MEU', decimals: 18 },
        infoURL: 'https://docs.metaplayer.one/',
        shortName: 'MEU',
        chainId: 2124,
        networkId: 2124,
        slip44: 1,
        explorers: [
            {
                name: 'MP1Scan',
                url: 'https://dubai.mp1scan.io',
                standard: 'EIP3091'
            }
        ]
    },
    2136: {
        name: 'BigShortBets Testnet',
        chain: 'BIGSB Testnet',
        rpc: [
            'https://test-market.bigsb.network',
            'wss://test-market.bigsb.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Dolarz', symbol: 'Dolarz', decimals: 18 },
        infoURL: 'https://bigshortbets.com/',
        shortName: 'bigsb_testnet',
        chainId: 2136,
        networkId: 2136,
        explorers: [
            {
                name: 'Polkadot.js',
                url: 'https://polkadot.js.org/apps/?rpc=wss://test-market.bigsb.network#/explorer',
                standard: 'none'
            }
        ]
    },
    2137: {
        name: 'BigShortBets',
        chain: 'BIGSB',
        rpc: ['https://market.bigsb.io', 'wss://market.bigsb.io'],
        faucets: [],
        nativeCurrency: { name: 'USD Coin', symbol: 'USDC', decimals: 18 },
        infoURL: 'https://bigshortbets.com/',
        shortName: 'bigsb',
        chainId: 2137,
        networkId: 2137,
        explorers: []
    },
    2138: {
        name: 'Defi Oracle Meta Testnet',
        chain: 'dfiometatest',
        icon: 'defioraclemeta',
        rpc: [
            'https://rpc.public-2138.defi-oracle.io',
            'wss://rpc.public-2138.defi-oracle.io'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'testEther', symbol: 'tETH', decimals: 18 },
        infoURL: 'https://defi-oracle.io/',
        shortName: 'dfio-meta-test',
        chainId: 2138,
        networkId: 21,
        slip44: 1,
        ens: { registry: '0x57f1887a8BF19b14fC0dF6Fd9B2acc9Af147eA85' },
        explorers: [
            {
                name: 'Quorum Explorer',
                url: 'https://public-2138.defi-oracle.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYrMRnjQJcNkYq9AvZ2FQ9kzYj9szzP4YDmyNA1ybd8xE'
    },
    2140: {
        name: 'Oneness Network',
        chain: 'Oneness',
        rpc: ['https://rpc.onenesslabs.io/'],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: '',
        shortName: 'oneness',
        chainId: 2140,
        networkId: 2140,
        explorers: [
            {
                name: 'oneness-mainnet',
                url: 'https://scan.onenesslabs.io',
                standard: 'EIP3091'
            }
        ]
    },
    2141: {
        name: 'Oneness TestNet',
        chain: 'Oneness-Testnet',
        rpc: ['https://rpc.testnet.onenesslabs.io/'],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: '',
        shortName: 'oneness-testnet',
        chainId: 2141,
        networkId: 2141,
        explorers: [
            {
                name: 'oneness-testnet',
                url: 'https://scan.testnet.onenesslabs.io',
                standard: 'EIP3091'
            }
        ]
    },
    2151: {
        name: 'BOSagora Mainnet',
        chain: 'ETH',
        rpc: ['https://mainnet.bosagora.org', 'https://rpc.bosagora.org'],
        faucets: [],
        nativeCurrency: { name: 'BOSAGORA', symbol: 'BOA', decimals: 18 },
        infoURL: 'https://docs.bosagora.org',
        shortName: 'boa',
        chainId: 2151,
        networkId: 2151,
        icon: 'agora',
        explorers: [
            {
                name: 'BOASCAN',
                url: 'https://boascan.io',
                icon: 'agora',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW3CT4SHmso5dRJdsjR8GL1qmt79HkdAebCn2uNaWXFYh'
    },
    2152: {
        name: 'Findora Mainnet',
        chain: 'Findora',
        rpc: ['https://rpc-mainnet.findora.org'],
        faucets: [],
        nativeCurrency: { name: 'FRA', symbol: 'FRA', decimals: 18 },
        infoURL: 'https://findora.org/',
        shortName: 'fra',
        chainId: 2152,
        networkId: 2152,
        explorers: [
            {
                name: 'findorascan',
                url: 'https://evm.findorascan.io',
                standard: 'EIP3091'
            }
        ]
    },
    2153: {
        name: 'Findora Testnet',
        chain: 'Testnet-anvil',
        rpc: ['https://prod-testnet.prod.findora.org:8545/'],
        faucets: [],
        nativeCurrency: { name: 'FRA', symbol: 'FRA', decimals: 18 },
        infoURL: 'https://findora.org/',
        shortName: 'findora-testnet',
        chainId: 2153,
        networkId: 2153,
        slip44: 1,
        explorers: [
            {
                name: 'findorascan',
                url: 'https://testnet-anvil.evm.findorascan.io',
                standard: 'EIP3091'
            }
        ]
    },
    2154: {
        name: 'Findora Forge',
        chain: 'Testnet-forge',
        rpc: ['https://prod-forge.prod.findora.org:8545/'],
        faucets: [],
        nativeCurrency: { name: 'FRA', symbol: 'FRA', decimals: 18 },
        infoURL: 'https://findora.org/',
        shortName: 'findora-forge',
        chainId: 2154,
        networkId: 2154,
        slip44: 1,
        explorers: [
            {
                name: 'findorascan',
                url: 'https://testnet-forge.evm.findorascan.io',
                standard: 'EIP3091'
            }
        ]
    },
    2162: {
        name: 'Animechain Testnet',
        chain: 'Animechain',
        rpc: ['https://rpc.kanda.animechain.ai'],
        faucets: [],
        nativeCurrency: { name: 'Coin', symbol: 'COIN', decimals: 18 },
        infoURL: 'https://animechain.ai',
        shortName: 'animechaint',
        chainId: 2162,
        networkId: 2162,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.kanda.animechain.ai',
                standard: 'EIP3091'
            }
        ]
    },
    2187: {
        name: 'Game7',
        title: 'Game7',
        chain: 'Game7',
        rpc: [
            'https://mainnet-rpc.game7.io',
            'wss://mainnet-rpc.game7.io',
            'https://mainnet-rpc.game7.build',
            'wss://mainnet-rpc.game7.build'
        ],
        faucets: [],
        nativeCurrency: { name: 'G7', symbol: 'G7', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://game7.io/',
        shortName: 'g7',
        chainId: 2187,
        networkId: 2187,
        icon: 'game7',
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://mainnet.game7.io',
                icon: 'game7',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmbk23C5vXpGBfq8SuPXR1PrfWER2m8w6LGqBkhXAvxia9'
    },
    2192: {
        name: 'SnaxChain',
        chain: 'ETH',
        rpc: ['https://mainnet.snaxchain.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://synthetix.io',
        shortName: 'snax',
        chainId: 2192,
        networkId: 2192,
        icon: 'snax',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.snaxchain.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQPHTTpgSjvP18Yc522ZxHYKRwLLxeR6xWdEdcw1XHwZo'
    },
    2199: {
        name: 'Moonsama Network',
        chain: 'MSN',
        rpc: ['https://rpc.moonsama.com', 'wss://rpc.moonsama.com/ws'],
        faucets: ['https://multiverse.moonsama.com/faucet'],
        nativeCurrency: { name: 'Sama Token', symbol: 'SAMA', decimals: 18 },
        infoURL: 'https://moonsama.com',
        shortName: 'msn',
        chainId: 2199,
        networkId: 2199,
        slip44: 2199,
        icon: 'msn',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.moonsama.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaQxfwpXYTomUd24PMx5tKjosupXcm99z1jL1XLq9LWBS'
    },
    2202: {
        name: 'Antofy Mainnet',
        chain: 'ABN',
        icon: 'antofy',
        rpc: ['https://rpc.antofy.io'],
        faucets: ['https://faucet.antofy.io'],
        nativeCurrency: { name: 'Antofy', symbol: 'ABN', decimals: 18 },
        infoURL: 'https://antofy.io',
        shortName: 'ABNm',
        chainId: 2202,
        networkId: 2202,
        explorers: [
            {
                name: 'Antofy Mainnet',
                url: 'https://antofyscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdTfku81ohnG9ECU1Xswmeumt678cBhwHWuFYZ7i1Qsto'
    },
    2203: {
        name: 'Bitcoin EVM',
        chain: 'Bitcoin EVM',
        rpc: ['https://connect.bitcoinevm.com'],
        faucets: [],
        nativeCurrency: { name: 'Bitcoin', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://bitcoinevm.com',
        shortName: 'BTC',
        chainId: 2203,
        networkId: 2203,
        icon: 'ebtc',
        explorers: [
            {
                name: 'Explorer',
                url: 'https://explorer.bitcoinevm.com',
                icon: 'ebtc',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreic4aq265oaf6yze7ba5okefqh6vnqudyrz6ovukvbnrlhet36itle'
    },
    2213: {
        name: 'Evanesco Mainnet',
        chain: 'EVA',
        rpc: ['https://seed4.evanesco.org:8546'],
        faucets: [],
        nativeCurrency: { name: 'EVA', symbol: 'EVA', decimals: 18 },
        infoURL: 'https://evanesco.org/',
        shortName: 'evanesco',
        chainId: 2213,
        networkId: 2213,
        icon: 'evanesco',
        explorers: [
            {
                name: 'Evanesco Explorer',
                url: 'https://explorer.evanesco.org',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZbmGYdfbMRrWJore3c7hyD6q7B5pXHJqTSNjbZZUK6V8'
    },
    2221: {
        name: 'Kava Testnet',
        chain: 'KAVA',
        rpc: [
            'https://evm.testnet.kava.io',
            'https://kava-evm-testnet.rpc.thirdweb.com',
            'wss://wevm.testnet.kava.io',
            'https://kava-testnet.drpc.org',
            'wss://kava-testnet.drpc.org'
        ],
        faucets: ['https://faucet.kava.io'],
        nativeCurrency: { name: 'TKava', symbol: 'TKAVA', decimals: 18 },
        infoURL: 'https://www.kava.io',
        shortName: 'tkava',
        chainId: 2221,
        networkId: 2221,
        icon: 'kava',
        explorers: [
            {
                name: 'Kava Testnet Explorer',
                url: 'http://testnet.kavascan.com',
                standard: 'EIP3091',
                icon: 'kava'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdpRTk6oL1HRW9xC6cAc4Rnf9gs6zgdAcr4Z3HcLztusm'
    },
    2222: {
        name: 'Kava',
        chain: 'KAVA',
        rpc: [
            'https://evm.kava.io',
            'https://kava-rpc.gateway.pokt.network',
            'https://kava-evm.rpc.thirdweb.com',
            'wss://wevm.kava.io',
            'https://kava-evm-rpc.publicnode.com',
            'wss://kava-evm-rpc.publicnode.com',
            'https://evm.kava-rpc.com',
            'https://rpc.ankr.com/kava_evm',
            'wss://wevm.kava-rpc.com',
            'https://kava.drpc.org',
            'wss://kava.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Kava', symbol: 'KAVA', decimals: 18 },
        infoURL: 'https://www.kava.io',
        shortName: 'kava',
        chainId: 2222,
        networkId: 2222,
        icon: 'kava',
        explorers: [
            {
                name: 'Kava EVM Explorer',
                url: 'https://kavascan.com',
                standard: 'EIP3091',
                icon: 'kava'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdpRTk6oL1HRW9xC6cAc4Rnf9gs6zgdAcr4Z3HcLztusm'
    },
    2223: {
        name: 'VChain Mainnet',
        chain: 'VChain',
        rpc: ['https://bc.vcex.xyz'],
        faucets: [],
        nativeCurrency: { name: 'VNDT', symbol: 'VNDT', decimals: 18 },
        infoURL: 'https://bo.vcex.xyz/',
        shortName: 'VChain',
        chainId: 2223,
        networkId: 2223,
        explorers: [
            {
                name: 'VChain Scan',
                url: 'https://scan.vcex.xyz',
                standard: 'EIP3091'
            }
        ]
    },
    2241: {
        name: 'Krest Network',
        chain: 'Krest',
        icon: 'krest',
        rpc: ['https://erpc-krest.peaq.network', 'https://krest.unitedbloc.com'],
        faucets: [],
        nativeCurrency: { name: 'Krest', symbol: 'KRST', decimals: 18 },
        infoURL: 'https://www.peaq.network',
        shortName: 'KRST',
        chainId: 2241,
        networkId: 2241,
        explorers: [
            {
                name: 'Polkadot.js',
                url: 'https://polkadot.js.org/apps/?rpc=wss://wss-krest.peaq.network#/explorer',
                standard: 'none'
            },
            {
                name: 'Subscan',
                url: 'https://krest.subscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreid732273ib5at7krjdl2t7lteljlepwd3tvifqge7mu7g6naxavhe'
    },
    2300: {
        name: 'BOMB Chain',
        chain: 'BOMB',
        rpc: ['https://rpc.bombchain.com'],
        faucets: [],
        nativeCurrency: { name: 'BOMB Token', symbol: 'BOMB', decimals: 18 },
        infoURL: 'https://www.bombchain.com',
        shortName: 'bomb',
        chainId: 2300,
        networkId: 2300,
        icon: 'bomb',
        explorers: [
            {
                name: 'bombscan',
                icon: 'bomb',
                url: 'https://bombscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmc44uSjfdNHdcxPTgZAL8eZ8TLe4UmSHibcvKQFyGJxTB'
    },
    2306: {
        name: 'Ebro Network',
        chain: 'ebro',
        rpc: ['https://greendinoswap.com'],
        faucets: [],
        nativeCurrency: { name: 'Ebro', symbol: 'ebro', decimals: 18 },
        infoURL: 'https://www.ebrochain.com',
        shortName: 'ebro',
        chainId: 2306,
        networkId: 2306
    },
    2309: {
        name: 'Arevia',
        chain: 'Arevia',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Arev', symbol: 'ARÉV', decimals: 18 },
        infoURL: '',
        shortName: 'arevia',
        chainId: 2309,
        networkId: 2309,
        explorers: [],
        status: 'incubating'
    },
    2310: {
        name: 'CratD2C',
        chain: 'CRATD2C',
        rpc: [
            'https://node1.cratd2csmartchain.io',
            'https://node2.cratd2csmartchain.io',
            'https://node3.cratd2csmartchain.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'CRATD2C', symbol: 'CRAT', decimals: 18 },
        infoURL: 'https://cratd2csmartchain.io',
        shortName: 'cratd2c',
        chainId: 2310,
        networkId: 2310,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.cratd2csmartchain.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    2311: {
        name: 'Chronicle Vesuvius - Lit Protocol Testnet',
        chain: 'LPV',
        icon: 'lit',
        rpc: ['https://vesuvius-rpc.litprotocol.com'],
        faucets: ['https://developer.litprotocol.com/support/intro'],
        nativeCurrency: { name: 'Test LPX', symbol: 'tstLPX', decimals: 18 },
        infoURL: 'https://litprotocol.com',
        shortName: 'lpv',
        chainId: 2311,
        networkId: 2311,
        explorers: [
            {
                name: 'Lit Chronicle Vesuvius Explorer',
                url: 'https://vesuvius-explorer.litprotocol.com',
                icon: 'lit',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXZcwET1LhUxfc2mCdiCJFm61jUHsVVXuZYwx8zhvHQxn'
    },
    2323: {
        name: 'SOMA Network Testnet',
        chain: 'SOMA',
        rpc: [
            'https://data-testnet-v1.somanetwork.io/',
            'https://testnet-au-server-2.somanetwork.io',
            'https://testnet-au-server-1.somanetwork.io',
            'https://testnet-sg-server-1.somanetwork.io',
            'https://testnet-sg-server-2.somanetwork.io'
        ],
        faucets: ['https://faucet.somanetwork.io'],
        nativeCurrency: { name: 'SMA', symbol: 'tSMA', decimals: 18 },
        infoURL: 'https://somanetwork.io',
        shortName: 'sma',
        chainId: 2323,
        networkId: 2323,
        slip44: 1,
        icon: 'soma',
        explorers: [
            {
                name: 'SOMA Testnet Explorer',
                icon: 'soma',
                url: 'https://testnet.somascan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmadSU2tcyvuzssDYGJ4rVLag43QLnKwcBerZR2zKLVU2N'
    },
    2330: {
        name: 'Altcoinchain',
        chain: 'mainnet',
        rpc: ['https://rpc0.altcoinchain.org/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Altcoin', symbol: 'ALT', decimals: 18 },
        infoURL: 'https://altcoinchain.org',
        shortName: 'alt',
        chainId: 2330,
        networkId: 2330,
        icon: 'altcoinchain',
        status: 'active',
        explorers: [
            {
                name: 'expedition',
                url: 'http://expedition.altcoinchain.org',
                icon: 'altcoinchain',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYwHmGC9CRVcKo1LSesqxU31SDj9vk2iQxcFjQArzhix4'
    },
    2331: {
        name: 'RSS3 VSL Sepolia Testnet',
        chain: 'RSS3',
        rpc: ['https://rpc.testnet.rss3.io'],
        faucets: [],
        nativeCurrency: { name: 'RSS3', symbol: 'RSS3', decimals: 18 },
        infoURL: 'https://rss3.io',
        shortName: 'rss3-testnet',
        chainId: 2331,
        networkId: 2331,
        icon: 'rss3-testnet',
        explorers: [
            {
                name: 'RSS3 VSL Sepolia Testnet Scan',
                url: 'https://scan.testnet.rss3.io',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://explorer.testnet.rss3.io/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmTE6hnMTQaGU8Fm7nQbeTqQ5Ha3kyLKHR6QTd59prP2mC'
    },
    2332: {
        name: 'SOMA Network Mainnet',
        chain: 'SOMA',
        rpc: [
            'https://data-mainnet-v1.somanetwork.io/',
            'https://id-mainnet.somanetwork.io',
            'https://hk-mainnet.somanetwork.io',
            'https://sg-mainnet.somanetwork.io'
        ],
        faucets: ['https://airdrop.somanetwork.io'],
        nativeCurrency: { name: 'Soma Native Token', symbol: 'SMA', decimals: 18 },
        infoURL: 'https://somanetwork.io',
        shortName: 'smam',
        chainId: 2332,
        networkId: 2332,
        icon: 'soma',
        status: 'incubating',
        explorers: [
            {
                name: 'SOMA Explorer Mainnet',
                icon: 'soma',
                url: 'https://somascan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmadSU2tcyvuzssDYGJ4rVLag43QLnKwcBerZR2zKLVU2N'
    },
    2340: {
        name: 'Atleta Olympia',
        chain: 'Atleta Testnet Olympia',
        rpc: [
            'https://testnet-rpc.atleta.network',
            'https://rpc.ankr.com/atleta_olympia',
            'wss://testnet-rpc.atleta.network',
            'https://atleta-testnet.htw.tech/',
            'https://public-atleta.nownodes.io',
            'https://public-atla-testnet.fastnode.io'
        ],
        faucets: ['https://app-olympia.atleta.network/faucet'],
        nativeCurrency: { name: 'Atla Olympia', symbol: 'ATLA', decimals: 18 },
        infoURL: 'https://atleta.network',
        shortName: 'olym',
        chainId: 2340,
        networkId: 2340,
        slip44: 1,
        icon: 'atleta',
        explorers: [
            {
                name: 'Atleta Olympia Explorer',
                icon: 'atleta',
                url: 'https://blockscout.testnet-v2.atleta.network',
                standard: 'none'
            },
            {
                name: 'Atleta Olympia Polka Explorer',
                icon: 'atleta',
                url: 'https://polkadot-explorer.atleta.network/#/explorer',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmV2JVr4FCcb6aRiUoA3wS5erLoxtLBLonQ1Nvz8fNuEcR'
    },
    2342: {
        name: 'Omnia Chain',
        chain: 'OMNIA',
        icon: 'omnia',
        rpc: ['https://rpc.omniaverse.io'],
        faucets: ['https://www.omniaverse.io'],
        nativeCurrency: { name: 'Omnia', symbol: 'OMNIA', decimals: 18 },
        infoURL: 'https://www.omniaverse.io',
        shortName: 'omnia',
        chainId: 2342,
        networkId: 2342,
        explorers: [
            {
                name: 'OmniaVerse Explorer',
                url: 'https://scan.omniaverse.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdNQMFxcjB9PAP1LZVqaQmyppV5QGTqXXmbBeQyaTUpMM'
    },
    2345: {
        name: 'GOAT Network',
        title: 'GOAT Network',
        chain: 'GOAT',
        rpc: ['https://rpc.goat.network'],
        faucets: [],
        nativeCurrency: { name: 'Bitcoin', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://www.goat.network',
        shortName: 'goat',
        chainId: 2345,
        networkId: 2345,
        icon: 'goat',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.goat.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifrhbzlufbvxbhywu4rmkkij4ur2qcg3zlk6irqnbabbjfj3cud2u'
    },
    2355: {
        name: 'Silicon zkEVM',
        title: 'Silicon zkEVM Mainnet',
        chain: 'Silicon',
        rpc: [
            'https://rpc.silicon.network',
            'https://silicon-mainnet.nodeinfra.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://docs.silicon.network',
        shortName: 'silicon-zk',
        chainId: 2355,
        networkId: 2355,
        icon: 'silicon',
        explorers: [
            {
                name: 'siliconscope',
                url: 'https://scope.silicon.network',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [
                { url: 'https://bridge.silicon.network' },
                { url: 'https://bridge.orbitchain.io' }
            ]
        },
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmTEnk2fosqbY6HQW5vySrLGbopJfeni9ThZ6R9sVefbnq'
    },
    2357: {
        name: '(deprecated) Kroma Sepolia',
        title: '(deprecated) Kroma Testnet Sepolia',
        chainId: 2357,
        shortName: 'deprecated-kroma-sepolia',
        chain: 'ETH',
        networkId: 2357,
        slip44: 1,
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        rpc: ['https://api.sepolia-deprecated.kroma.network'],
        faucets: [],
        infoURL: 'https://kroma.network',
        icon: 'kroma',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.sepolia-deprecated.kroma.network',
                icon: 'kroma',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://kroma.network/bridge' }]
        },
        status: 'deprecated',
        iconURL: 'https://ipfs.io/ipfs/QmVpV2WET6ZrqnvvPfE9hCwoE2y5ygbPuniuugpaRoxrho'
    },
    2358: {
        name: 'Kroma Sepolia',
        title: 'Kroma Testnet Sepolia',
        chainId: 2358,
        shortName: 'kroma-sepolia',
        chain: 'ETH',
        networkId: 2358,
        slip44: 1,
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        rpc: ['https://api.sepolia.kroma.network'],
        faucets: [],
        infoURL: 'https://kroma.network',
        icon: 'kroma',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.sepolia.kroma.network',
                icon: 'kroma',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://kroma.network/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmVpV2WET6ZrqnvvPfE9hCwoE2y5ygbPuniuugpaRoxrho'
    },
    2368: {
        name: 'KiteAI Testnet',
        chain: 'KiteAI',
        icon: 'kite',
        rpc: ['https://rpc-testnet.gokite.ai'],
        faucets: ['https://faucet.gokite.ai/'],
        nativeCurrency: { name: 'Kite', symbol: 'KITE', decimals: 18 },
        infoURL: 'https://gokite.ai/',
        shortName: 'KiteAI',
        chainId: 2368,
        networkId: 1,
        slip44: 1,
        explorers: [
            {
                name: 'Kitescan',
                url: 'https://testnet.kitescan.ai',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZmY5VTAaYo3Hd7Y1dyWn5DcffFtr2xpYEHammzfKVoZ2'
    },
    2370: {
        name: 'Nexis Network Testnet',
        chain: 'Nexis Network',
        icon: 'nexis',
        rpc: ['https://evm-testnet.nexis.network'],
        faucets: ['https://evm-faucet.nexis.network'],
        nativeCurrency: { name: 'Nexis', symbol: 'NZT', decimals: 18 },
        infoURL: 'https://nexis.network/',
        shortName: 'nzt',
        chainId: 2370,
        networkId: 2370,
        explorers: [
            {
                name: 'Nexis Testnet Explorer',
                url: 'https://evm-testnet.nexscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdJwWuMgbhoZhgFM4zWrZne6qs5ktcL1vBLKX12VGgALM'
    },
    2390: {
        name: 'TAC Turin',
        title: 'TAC Testnet Turin',
        chain: 'TAC',
        icon: 'tactestnet',
        rpc: [
            'https://turin.rpc.tac.build',
            'https://rpc.ankr.com/tac_turin',
            'https://turin-ws.rpc.tac.build'
        ],
        faucets: ['https://turin.faucet.tac.build/'],
        nativeCurrency: { name: 'TAC', symbol: 'TAC', decimals: 18 },
        infoURL: 'https://tac.build/',
        shortName: 'tacchain_2390-1',
        chainId: 2390,
        networkId: 2390,
        slip44: 1,
        explorers: [
            {
                name: 'TAC Turin Blockscout',
                url: 'https://turin.explorer.tac.build',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidhtm3kefmhw3vh7kl5uwx2rigq7h7r7beoq7sepblcrmclgyynue'
    },
    2399: {
        name: 'BOMB Chain Testnet',
        chain: 'BOMB',
        rpc: ['https://bombchain-testnet.ankr.com/bas_full_rpc_1'],
        faucets: ['https://faucet.bombchain-testnet.ankr.com/'],
        nativeCurrency: { name: 'BOMB Token', symbol: 'tBOMB', decimals: 18 },
        infoURL: 'https://www.bombmoney.com',
        shortName: 'bombt',
        chainId: 2399,
        networkId: 2399,
        slip44: 1,
        icon: 'bomb',
        explorers: [
            {
                name: 'bombscan-testnet',
                icon: 'bomb',
                url: 'https://explorer.bombchain-testnet.ankr.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmc44uSjfdNHdcxPTgZAL8eZ8TLe4UmSHibcvKQFyGJxTB'
    },
    2400: {
        name: 'TCG Verse Mainnet',
        chain: 'TCG Verse',
        icon: 'tcg_verse',
        rpc: ['https://rpc.tcgverse.xyz'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://tcgverse.xyz/',
        shortName: 'TCGV',
        chainId: 2400,
        networkId: 2400,
        explorers: [
            {
                name: 'TCG Verse Explorer',
                url: 'https://explorer.tcgverse.xyz',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-248' },
        iconURL: 'https://ipfs.io/ipfs/bafkreidg4wpewve5mdxrofneqblydkrjl3oevtgpdf3fk3z3vjqam6ocoe'
    },
    2410: {
        name: 'K2 Mainnet',
        chain: 'K2',
        icon: 'karak',
        rpc: ['https://rpc.karak.network'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://karak.network',
        shortName: 'K2-mainnet',
        chainId: 2410,
        networkId: 2410,
        explorers: [
            {
                name: 'K2 Mainnet Explorer',
                url: 'https://explorer.karak.network',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-1' },
        iconURL: 'https://ipfs.io/ipfs/bafybeic3dihuytvtm2hnfo7lvsqf43eqbzobtkxn3o3pxptktifsefy7su'
    },
    2415: {
        name: 'XODEX',
        chain: 'XODEX',
        rpc: ['https://mainnet.xo-dex.com/rpc', 'https://xo-dex.io'],
        faucets: [],
        nativeCurrency: {
            name: 'XODEX Native Token',
            symbol: 'XODEX',
            decimals: 18
        },
        infoURL: 'https://xo-dex.com',
        shortName: 'xodex',
        chainId: 2415,
        networkId: 10,
        icon: 'xodex',
        explorers: [
            {
                name: 'XODEX Explorer',
                url: 'https://explorer.xo-dex.com',
                standard: 'EIP3091',
                icon: 'xodex'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXt49jPfHUmDF4n8TF7ks6txiPztx6qUHanWmHnCoEAhW'
    },
    2420: {
        name: 'Rufus',
        chain: 'rufus',
        rpc: ['https://rufus.calderachain.xyz/http'],
        faucets: [],
        nativeCurrency: { name: 'Dogelon', symbol: 'ELON', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://rufus.hub.caldera.xyz',
        shortName: 'rufus',
        chainId: 2420,
        networkId: 2420,
        icon: 'rufus',
        explorers: [
            {
                name: 'Rufus Caldera Explorer',
                url: 'https://rufus.calderaexplorer.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihcbx557v446mhd7z4kfogqy3f3i5zdx2fsc5udg2obdstzxt66be'
    },
    2424: {
        name: 'inEVM Testnet',
        chain: 'inEVM testnet',
        icon: 'inevm',
        rpc: ['https://testnet.rpc.inevm.com/http'],
        faucets: [],
        nativeCurrency: { name: 'Injective', symbol: 'INJ', decimals: 18 },
        infoURL: 'https://inevm.com',
        shortName: 'inevm-testnet',
        chainId: 2424,
        networkId: 2424,
        explorers: [],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmU9KU1qgReJR7vyVxN5zwWB3nkhSs658ViArUjT7GCh4r'
    },
    2425: {
        name: 'King Of Legends Mainnet',
        title: 'King Of Legends Mainnet',
        chain: 'KCC',
        icon: 'kol',
        rpc: ['https://rpc-mainnet.kinggamer.org/'],
        faucets: [],
        nativeCurrency: { name: 'King Of Legends', symbol: 'KCC', decimals: 18 },
        infoURL: 'https://kingoflegends.net/',
        shortName: 'kcc',
        chainId: 2425,
        networkId: 2425,
        slip44: 1,
        explorers: [
            {
                name: 'King Of Legends Mainnet Explorer',
                url: 'https://kingscan.org',
                icon: 'kol',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTZFXhYJboYE9fbaeje12iTF3QPLn6xgyFgrDVe2isDBH'
    },
    2426: {
        name: 'Standard Testnet',
        chain: 'STND Testnet',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Standard', symbol: 'STND', decimals: 18 },
        infoURL: 'https://standardweb3.com',
        shortName: 'stndtestnet',
        chainId: 2426,
        networkId: 2426,
        status: 'incubating'
    },
    2440: {
        name: 'Atleta Network',
        chain: 'Atleta',
        rpc: [
            'https://rpc.mainnet.atleta.network',
            'wss://rpc.mainnet.atleta.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Atla', symbol: 'ATLA', decimals: 18 },
        infoURL: 'https://atleta.network',
        shortName: 'atla',
        chainId: 2440,
        networkId: 2440,
        slip44: 965,
        icon: 'atleta',
        explorers: [
            {
                name: 'Atleta Explorer',
                icon: 'atleta',
                url: 'https://blockscout.atleta.network',
                standard: 'none'
            },
            {
                name: 'Atleta Polka Explorer',
                icon: 'atleta',
                url: 'https://polkadot-explorer.atleta.network/#/explorer',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmV2JVr4FCcb6aRiUoA3wS5erLoxtLBLonQ1Nvz8fNuEcR'
    },
    2442: {
        name: 'Polygon zkEVM Cardona Testnet',
        title: 'Polygon zkEVM Cardona Testnet',
        chain: 'Polygon',
        rpc: ['https://rpc.cardona.zkevm-rpc.com'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://polygon.technology/polygon-zkevm',
        shortName: 'zkevm-testnet-cardona',
        chainId: 2442,
        networkId: 2442,
        icon: 'zkevm',
        explorers: [
            {
                name: 'polygonscan',
                url: 'https://cardona-zkevm.polygonscan.com',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge-ui.cardona.zkevm-rpc.com' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmNmJZkQgx9RcFLS3rvxQTVYcPfyAFPr667keHTUxB9PDv'
    },
    2458: {
        name: 'Hybrid Chain Network Testnet',
        chain: 'HYBRID',
        rpc: ['https://rpc-testnet.hybridchain.ai/'],
        faucets: ['https://faucet-testnet.hybridchain.ai'],
        nativeCurrency: {
            name: 'Hybrid Chain Native Token',
            symbol: 'tHRC',
            decimals: 18
        },
        infoURL: 'https://hybridchain.ai',
        shortName: 'thrc',
        chainId: 2458,
        networkId: 2458,
        slip44: 1,
        icon: 'hybrid',
        explorers: [
            {
                name: 'Hybrid Chain Explorer Testnet',
                icon: 'hybrid',
                url: 'https://testnet.hybridscan.ai',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQDNdhPvCrrijEKC3G9Px5if2CHgdxq7Q2Pg66cy9xwbF'
    },
    2468: {
        name: 'Hybrid Chain Network Mainnet',
        chain: 'HYBRID',
        rpc: [
            'https://coredata-mainnet.hybridchain.ai/',
            'https://rpc-mainnet.hybridchain.ai'
        ],
        faucets: ['https://faucet-testnet.hybridchain.ai'],
        nativeCurrency: {
            name: 'Hybrid Chain Native Token',
            symbol: 'HRC',
            decimals: 18
        },
        infoURL: 'https://hybridchain.ai',
        shortName: 'hrc',
        chainId: 2468,
        networkId: 2468,
        icon: 'hybrid',
        explorers: [
            {
                name: 'Hybrid Chain Explorer Mainnet',
                icon: 'hybrid',
                url: 'https://hybridscan.ai',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQDNdhPvCrrijEKC3G9Px5if2CHgdxq7Q2Pg66cy9xwbF'
    },
    2477: {
        name: '6Degree of Outreach',
        chain: '6DO',
        rpc: [
            'https://rpc.6dochain.com',
            'https://rpc2.6dochain.com',
            'https://rpc3.6dochain.com'
        ],
        faucets: [],
        nativeCurrency: { name: '6Degree Coin', symbol: '6DO', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://6do.world',
        shortName: '6do',
        chainId: 2477,
        networkId: 2477,
        icon: '6do',
        explorers: [
            {
                name: '6Degree Chain Explorer',
                url: 'https://explorer.6dochain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWyyraWiYNJRAb4AEEkozjh8u5TAnFNG7YnFd7A54AjPi'
    },
    2484: {
        name: 'Unicorn Ultra Nebulas Testnet',
        chain: 'u2u',
        rpc: ['https://rpc-nebulas-testnet.uniultra.xyz'],
        faucets: ['https://faucet.uniultra.xyz'],
        nativeCurrency: {
            name: 'Unicorn Ultra Nebulas Testnet',
            symbol: 'U2U',
            decimals: 18
        },
        infoURL: 'https://uniultra.xyz',
        shortName: 'u2u_nebulas',
        chainId: 2484,
        networkId: 2484,
        slip44: 1,
        icon: 'u2u_nebulas',
        explorers: [
            {
                icon: 'u2u_nebulas',
                name: 'U2U Explorer',
                url: 'https://testnet.u2uscan.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcW64RgqQVHnNbVFyfaMNKt7dJvFqEbfEHZmeyeK8dpEa'
    },
    2488: {
        name: 'NOW Chain Mainnet',
        chain: 'NOW',
        icon: 'nowchain',
        rpc: ['https://rpc.nowscan.io'],
        faucets: [],
        nativeCurrency: { name: 'NOW Coin', symbol: 'NOW', decimals: 18 },
        infoURL: 'https://nowchain.co',
        shortName: 'now',
        chainId: 2488,
        networkId: 2488,
        explorers: [
            {
                name: 'NOW Scan',
                url: 'https://nowscan.io',
                icon: 'nowchain',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSUzhRGzMyMyGwBcE3ooZ5jvHKyJ1FjVjh5SfoGHG36MX'
    },
    2511: {
        name: 'Karak Goerli',
        chain: 'Karak',
        icon: 'karak',
        status: 'deprecated',
        rpc: ['https://goerli.node1.karak.network'],
        faucets: [],
        nativeCurrency: { name: 'Karak', symbol: 'KRK', decimals: 18 },
        infoURL: 'https://karak.network',
        shortName: 'karak-goerli',
        chainId: 2511,
        networkId: 2511,
        explorers: [
            {
                name: 'Karak Goerli Explorer',
                url: 'https://goerli.scan.karak.network',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-5' },
        iconURL: 'https://ipfs.io/ipfs/bafybeic3dihuytvtm2hnfo7lvsqf43eqbzobtkxn3o3pxptktifsefy7su'
    },
    2512: {
        name: 'K2 Testnet',
        chain: 'K2',
        icon: 'karak',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://karak.network',
        shortName: 'K2-testnet',
        chainId: 2512,
        networkId: 2512,
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/bafybeic3dihuytvtm2hnfo7lvsqf43eqbzobtkxn3o3pxptktifsefy7su'
    },
    2522: {
        name: 'Fraxtal Testnet',
        chain: 'FRAX',
        rpc: [
            'https://rpc.testnet.frax.com',
            'https://fraxtal-holesky-rpc.publicnode.com',
            'wss://fraxtal-holesky-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Frax', symbol: 'FRAX', decimals: 18 },
        infoURL: 'https://testnet.frax.com',
        shortName: 'fraxtal-testnet',
        chainId: 2522,
        networkId: 2522,
        slip44: 1,
        icon: 'fraxtal',
        explorers: [
            {
                name: 'fraxscan',
                url: 'https://holesky.fraxscan.com',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/bafkreiet3pmz37ymq6wlkglw5wmcee6jdyz4bbe4zg6h2voso2z2mf2s7q'
    },
    2525: {
        name: 'inEVM Mainnet',
        chain: 'inEVM',
        icon: 'inevm',
        rpc: ['https://mainnet.rpc.inevm.com/http'],
        faucets: [],
        nativeCurrency: { name: 'Injective', symbol: 'INJ', decimals: 18 },
        infoURL: 'https://inevm.com',
        shortName: 'inevm',
        chainId: 2525,
        networkId: 2525,
        explorers: [],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmU9KU1qgReJR7vyVxN5zwWB3nkhSs658ViArUjT7GCh4r'
    },
    2552: {
        name: 'Bahamut horizon',
        title: 'Bahamut horizon',
        chain: 'Bahamut',
        icon: 'bahamut',
        rpc: ['https://horizon-fastex-testnet.zeeve.net'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'FTN', symbol: 'FTN', decimals: 18 },
        shortName: 'horizon',
        infoURL: 'https://bahamut.io',
        chainId: 2552,
        networkId: 2552,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://horizon.ftnscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSemioP83RXnDWwTZbet8VpwJxcFRboX4B3pcdhLZGodP'
    },
    2559: {
        name: 'Kortho Mainnet',
        chain: 'Kortho Chain',
        rpc: ['https://www.kortho-chain.com'],
        faucets: [],
        nativeCurrency: { name: 'KorthoChain', symbol: 'KTO', decimals: 11 },
        infoURL: 'https://www.kortho.io/',
        shortName: 'ktoc',
        chainId: 2559,
        networkId: 2559
    },
    2569: {
        name: 'TechPay Mainnet',
        chain: 'TPC',
        rpc: ['https://api.techpay.io/'],
        faucets: [],
        nativeCurrency: { name: 'TechPay', symbol: 'TPC', decimals: 18 },
        infoURL: 'https://techpay.io/',
        shortName: 'tpc',
        chainId: 2569,
        networkId: 2569,
        icon: 'techpay',
        explorers: [
            {
                name: 'tpcscan',
                url: 'https://tpcscan.com',
                icon: 'techpay',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQyTyJUnhD1dca35Vyj96pm3v3Xyw8xbG9m8HXHw3k2zR'
    },
    2605: {
        name: 'Pho Blockchain Mainnet',
        chain: 'PHO',
        icon: 'pho',
        rpc: ['https://mainnet.phochain.org'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Pho', symbol: 'PHO', decimals: 18 },
        infoURL: 'phochain.org',
        shortName: 'pho',
        chainId: 2605,
        networkId: 2605,
        explorers: [
            {
                name: 'Pho Scan',
                url: 'https://phoscan.org',
                standard: 'EIP3091',
                icon: 'pho'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZ6WDmzPq5ECRaTW8mEcJmMYonqFTDVizZoG9UaRZ5tsW'
    },
    2606: {
        name: 'PoCRNet',
        title: 'Proof of Climate awaReness mainnet',
        chain: 'CRC',
        status: 'active',
        rpc: [
            'https://pocrnet.westeurope.cloudapp.azure.com/http',
            'wss://pocrnet.westeurope.cloudapp.azure.com/ws'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'Climate awaReness Coin',
            symbol: 'CRC',
            decimals: 18
        },
        infoURL: 'https://github.com/ethereum-pocr/pocrnet',
        shortName: 'pocrnet',
        chainId: 2606,
        networkId: 2606,
        icon: 'pocr',
        explorers: [
            {
                name: 'Lite Explorer',
                url: 'https://ethereum-pocr.github.io/explorer/pocrnet',
                icon: 'pocr',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRLwpq47tyEd3rfK4tKRhbTvyb3fc7PCutExnL1XAb37A'
    },
    2611: {
        name: 'Redlight Chain Mainnet',
        chain: 'REDLC',
        rpc: ['https://dataseed2.redlightscan.finance'],
        faucets: [],
        nativeCurrency: { name: 'Redlight Coin', symbol: 'REDLC', decimals: 18 },
        infoURL: 'https://redlight.finance/',
        shortName: 'REDLC',
        chainId: 2611,
        networkId: 2611,
        explorers: [
            {
                name: 'REDLC Explorer',
                url: 'https://redlightscan.finance',
                standard: 'EIP3091'
            }
        ]
    },
    2612: {
        name: 'EZChain C-Chain Mainnet',
        chain: 'EZC',
        rpc: ['https://api.ezchain.com/ext/bc/C/rpc'],
        faucets: [],
        nativeCurrency: { name: 'EZChain', symbol: 'EZC', decimals: 18 },
        infoURL: 'https://ezchain.com',
        shortName: 'EZChain',
        chainId: 2612,
        networkId: 2612,
        icon: 'ezchain',
        explorers: [
            {
                name: 'ezchain',
                url: 'https://cchain-explorer.ezchain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPKJbYCFjGmY9X2cA4b9YQjWYHQncmKnFtKyQh9rHkFTb'
    },
    2613: {
        name: 'EZChain C-Chain Testnet',
        chain: 'EZC',
        rpc: ['https://testnet-api.ezchain.com/ext/bc/C/rpc'],
        faucets: ['https://testnet-faucet.ezchain.com'],
        nativeCurrency: { name: 'EZChain', symbol: 'EZC', decimals: 18 },
        infoURL: 'https://ezchain.com',
        shortName: 'Fuji-EZChain',
        chainId: 2613,
        networkId: 2613,
        slip44: 1,
        icon: 'ezchain',
        explorers: [
            {
                name: 'ezchain',
                url: 'https://testnet-cchain-explorer.ezchain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPKJbYCFjGmY9X2cA4b9YQjWYHQncmKnFtKyQh9rHkFTb'
    },
    2625: {
        name: 'Whitechain Testnet',
        chain: 'WBT',
        rpc: ['https://rpc-testnet.whitechain.io'],
        faucets: ['https://testnet.whitechain.io/faucet'],
        nativeCurrency: { name: 'WhiteBIT Coin', symbol: 'WBT', decimals: 18 },
        infoURL: 'https://whitechain.io',
        shortName: 'twbt',
        chainId: 2625,
        networkId: 2625,
        slip44: 1,
        icon: 'whitechain-testnet',
        explorers: [
            {
                name: 'whitechain-testnet-explorer',
                url: 'https://testnet.whitechain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNeELax6vjkR9WZVmtggk8cam9xHVABZ4WvQyqkGCJ5qf'
    },
    2648: {
        name: 'AILayer Testnet',
        chain: 'AILayer',
        rpc: ['https://testnet-rpc.ailayer.xyz', 'wss://testnet-rpc.ailayer.xyz'],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://ailayer.xyz/',
        shortName: 'ailayer-testnet',
        chainId: 2648,
        networkId: 2648,
        icon: 'ailayer',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet-explorer.ailayer.xyz',
                icon: 'ailayer',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYoqc8rm8PrBg9jqfpsrxd6zdPEqDozbyNVMkBo3QMAFP'
    },
    2649: {
        name: 'AILayer Mainnet',
        chain: 'AILayer',
        rpc: ['https://mainnet-rpc.ailayer.xyz', 'wss://mainnet-rpc.ailayer.xyz'],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://ailayer.xyz/',
        shortName: 'ailayer-mainnet',
        chainId: 2649,
        networkId: 2649,
        icon: 'ailayer',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://mainnet-explorer.ailayer.xyz',
                icon: 'ailayer',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYoqc8rm8PrBg9jqfpsrxd6zdPEqDozbyNVMkBo3QMAFP'
    },
    2662: {
        name: 'APEX',
        status: 'incubating',
        chain: 'ETH',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://apexlayer.xyz/',
        shortName: 'apexmainnet',
        chainId: 2662,
        networkId: 2662,
        icon: 'apexmainnet',
        explorers: [],
        parent: { type: 'L2', chain: 'eip155-1' },
        iconURL: 'https://ipfs.io/ipfs/QmTYgeN1E3GGXnMF2oa43v2ehX2bYqrHPrGQ9xbBMXy1we'
    },
    2710: {
        name: 'Morph Testnet',
        chain: 'ETH',
        rpc: ['https://rpc-testnet.morphl2.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://morphl2.io',
        shortName: 'tmorph',
        chainId: 2710,
        networkId: 2710,
        slip44: 1,
        explorers: [
            {
                name: 'Morph Testnet Explorer',
                url: 'https://explorer-testnet.morphl2.io',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge-testnet.morphl2.io' }]
        }
    },
    2718: {
        name: 'K-LAOS',
        title: 'K-LAOS: LAOS on Kusama',
        chain: 'K-LAOS',
        icon: 'k-laos',
        rpc: [
            'https://rpc.klaos.laosfoundation.io',
            'wss://rpc.klaos.laosfoundation.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'KLAOS', symbol: 'KLAOS', decimals: 18 },
        infoURL: 'https://www.laosfoundation.io/',
        shortName: 'k-laos',
        chainId: 2718,
        networkId: 2718,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.klaos.laosfoundation.io',
                icon: 'k-laos',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW26eoxJeyUfikZ4DUT1Gfk78sBkvydEo8QzHa1BXjUUL'
    },
    2730: {
        name: 'XR Sepolia',
        chain: 'ETH',
        rpc: ['https://xr-sepolia-testnet.rpc.caldera.xyz/http'],
        faucets: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'tXR', symbol: 'tXR', decimals: 18 },
        infoURL: 'https://xr-one.gitbook.io',
        shortName: 'txr',
        chainId: 2730,
        networkId: 2730,
        icon: 'xr',
        slip44: 60,
        explorers: [
            {
                name: 'XR Sepolia Explorer',
                url: 'https://xr-sepolia-testnet.explorer.caldera.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-421614',
            bridges: [{ url: 'https://xr-sepolia-testnet.bridge.caldera.xyz' }]
        },
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmTrFxtjUBwxi87rty13jbXg4BW9nvVuBmtbzb9j9F99Gt'
    },
    2731: {
        name: 'Elizabeth Testnet',
        chain: 'Elizabeth',
        rpc: ['https://testnet-rpc.timenetwork.io'],
        faucets: [],
        nativeCurrency: { name: 'TIME', symbol: 'TIME', decimals: 18 },
        infoURL: 'https://whitepaper.anttime.net/overview/anttime',
        shortName: 'TIME',
        chainId: 2731,
        networkId: 2731,
        icon: 'timenet',
        explorers: [
            {
                name: 'Time Network Explorer',
                url: 'https://testnet-scanner.timenetwork.io',
                standard: 'none',
                icon: 'timenet'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidoudwo453gr3hoxpreleguga73rm55yl6vuedxrfmhknljppqbiu'
    },
    2741: {
        name: 'Abstract',
        chain: 'Abstract',
        rpc: ['https://api.mainnet.abs.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://abs.xyz',
        shortName: 'abstract',
        chainId: 2741,
        networkId: 2741,
        icon: 'abstract',
        explorers: [
            {
                name: 'Etherscan',
                url: 'https://abscan.org',
                standard: 'EIP3091'
            },
            {
                name: 'Abstract Explorer',
                url: 'https://explorer.mainnet.abs.xyz',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://portal.mainnet.abs.xyz/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmSRp5BGvwW9xmNNiRwZkJiTnjkyeQFU8Fy2BYwaBVJn58'
    },
    2748: {
        name: 'Nanon',
        title: 'Nanon Rollup',
        chain: 'ETH',
        rpc: ['https://rpc.nanon.network'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.nanon.network',
        shortName: 'Nanon',
        chainId: 2748,
        networkId: 2748,
        slip44: 1,
        icon: 'nanon',
        explorers: [
            {
                name: 'Nanon Rollup Explorer',
                url: 'https://explorer.nanon.network',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.nanon.network' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafybeiduib2fygrwziqpy4yuqr6vvnd6elhahpigbcowcipjjhk6c3qiny'
    },
    2777: {
        name: 'GM Network Mainnet',
        chain: 'GM Network Mainnet',
        rpc: ['https://rpc.gmnetwork.ai'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://gmnetwork.ai',
        shortName: 'gmnetwork-mainnet',
        chainId: 2777,
        networkId: 2777,
        explorers: [
            {
                name: 'GM Network Mainnet Explorer',
                url: 'https://scan.gmnetwork.ai',
                standard: 'EIP3091'
            }
        ],
        status: 'active'
    },
    2786: {
        name: 'Apertum',
        title: 'Apertum',
        chain: 'APTM',
        rpc: [
            'https://rpc.apertum.io/ext/bc/YDJ1r9RMkewATmA7B35q1bdV18aywzmdiXwd9zGBq3uQjsCnn/rpc'
        ],
        faucets: [],
        nativeCurrency: { name: 'Apertum', symbol: 'APTM', decimals: 18 },
        infoURL: 'https://apertum.io',
        shortName: 'aptm',
        chainId: 2786,
        networkId: 2786,
        icon: 'apertum',
        explorers: [
            {
                name: 'Apertum Explorer',
                url: 'https://explorer.apertum.io',
                icon: 'apertum',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreido4d2frhuuh4zwyyowesuslczaibgf3dtlwjjor52euqqqiashxy'
    },
    2810: {
        name: 'Morph Holesky',
        title: 'Morph Holesky Testnet',
        chain: 'ETH',
        rpc: [
            'https://rpc-quicknode-holesky.morphl2.io',
            'wss://rpc-quicknode-holesky.morphl2.io',
            'https://rpc-holesky.morphl2.io'
        ],
        faucets: ['https://morphfaucet.com/'],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://morphl2.io',
        shortName: 'hmorph',
        chainId: 2810,
        networkId: 2810,
        slip44: 1,
        explorers: [
            {
                name: 'Morph Holesky Testnet Explorer',
                url: 'https://explorer-holesky.morphl2.io',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge-holesky.morphl2.io' }]
        }
    },
    2818: {
        name: 'Morph',
        title: 'Morph Mainnet',
        chain: 'ETH',
        rpc: [
            'https://rpc.morphl2.io',
            'wss://rpc.morphl2.io:8443',
            'https://rpc-quicknode.morphl2.io',
            'wss://rpc-quicknode.morphl2.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://morphl2.io',
        shortName: 'morph',
        chainId: 2818,
        networkId: 2818,
        slip44: 1,
        explorers: [
            {
                name: 'Morph Mainnet Explorer',
                url: 'https://explorer.morphl2.io',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.morphl2.io/' }]
        }
    },
    2868: {
        name: 'HyperAGI Mainnet',
        chain: 'HyperAGI',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Hyperdust', symbol: 'HYPT', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://hyperagi.network',
        shortName: 'hypt',
        chainId: 2868,
        networkId: 1,
        explorers: [
            {
                name: 'hyptscan',
                url: 'https://block.hyperagi.network',
                standard: 'EIP3091'
            }
        ]
    },
    2882: {
        name: 'Chips Network',
        chain: 'CHIPS',
        rpc: [
            'https://node.chips.ooo/wasp/api/v1/chains/iota1pp3d3mnap3ufmgqnjsnw344sqmf5svjh26y2khnmc89sv6788y3r207a8fn/evm'
        ],
        faucets: [],
        nativeCurrency: { name: 'IOTA', symbol: 'IOTA', decimals: 18 },
        infoURL: 'https://www.chips.ooo',
        shortName: 'chips',
        chainId: 2882,
        networkId: 2882
    },
    2888: {
        name: 'Boba Network Goerli Testnet',
        chain: 'ETH',
        status: 'deprecated',
        rpc: ['https://goerli.boba.network/', 'wss://wss.goerli.boba.network/'],
        faucets: [],
        nativeCurrency: { name: 'Goerli Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://boba.network',
        shortName: 'BobaGoerli',
        chainId: 2888,
        networkId: 2888,
        slip44: 1,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://testnet.bobascan.com',
                standard: 'none'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-5',
            bridges: [{ url: 'https://gateway.boba.network' }]
        }
    },
    2889: {
        name: 'Aarma Mainnet',
        chain: 'Aarma',
        rpc: ['https://aarmarpc.com/'],
        faucets: [],
        nativeCurrency: { name: 'Aarma', symbol: 'ARMA', decimals: 18 },
        infoURL: 'https://aarmachain.com',
        shortName: 'ARMA',
        chainId: 2889,
        networkId: 2889,
        icon: 'arma',
        explorers: [
            {
                name: 'aarmascan',
                url: 'https://aarmascan.com',
                icon: 'arma',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcwQFHeLV7PCMe37nDb6pAgisUo5tVH6TBXsySDGtC9b9'
    },
    2907: {
        name: 'Elux Chain',
        chain: 'ELUX',
        icon: 'eluxchain',
        rpc: ['https://rpc.eluxscan.com'],
        faucets: [],
        nativeCurrency: { name: 'Elux Chain', symbol: 'ELUX', decimals: 18 },
        infoURL: 'https://eluxscan.com',
        shortName: 'ELUX',
        chainId: 2907,
        networkId: 2907,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://eluxscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQC7LzzFj8kL71a1MXRgn3TSeRrgF1tTuVEzvWx5cQjv1'
    },
    2911: {
        name: 'HYCHAIN',
        chainId: 2911,
        shortName: 'hychain',
        chain: 'ETH',
        networkId: 2911,
        nativeCurrency: { name: 'TOPIA', symbol: 'TOPIA', decimals: 18 },
        rpc: ['https://rpc.hychain.com/http'],
        faucets: [],
        infoURL: 'https://www.hychain.com',
        icon: 'hychain',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.hychain.com',
                icon: 'hychain',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.hychain.com' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmcSJmAfk3iay6uCGJxgUPd9pTsRxbtF4BrNnC5txE9cg8'
    },
    2941: {
        name: 'Xenon Chain Testnet',
        chain: 'XEN',
        rpc: [
            'https://testnet-chain.xenonchain.com/',
            'https://testnet-dev.xenonchain.com/'
        ],
        faucets: ['https://xfaucet.xenonchain.com'],
        nativeCurrency: { name: 'Xenon Testnet', symbol: 'tXEN', decimals: 18 },
        infoURL: 'https://xenonchain.com',
        shortName: 'xenon',
        chainId: 2941,
        networkId: 2941,
        icon: 'xenon',
        slip44: 1,
        explorers: [
            {
                name: 'Xenon testnet Explorer',
                url: 'https://testnet.xenonchain.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNSoxDnj6MV8mPJWiuzzLbATcbk5op11NTwMTdzcr272F'
    },
    2999: {
        name: 'BitYuan Mainnet',
        chain: 'BTY',
        rpc: ['https://mainnet.bityuan.com/eth'],
        faucets: [],
        nativeCurrency: { name: 'BTY', symbol: 'BTY', decimals: 18 },
        infoURL: 'https://www.bityuan.com',
        shortName: 'bty',
        chainId: 2999,
        networkId: 2999,
        icon: 'bty',
        explorers: [
            {
                name: 'BitYuan Block Chain Explorer',
                url: 'https://mainnet.bityuan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUmJVof2m5e4HUXb3GmijWUFsLUNhrQiwwQG3CqcXEtHt'
    },
    3000: {
        name: 'CENNZnet Rata',
        chain: 'CENNZnet',
        rpc: [],
        faucets: ['https://app-faucet.centrality.me'],
        nativeCurrency: { name: 'CPAY', symbol: 'CPAY', decimals: 18 },
        infoURL: 'https://cennz.net',
        shortName: 'cennz-r',
        chainId: 3000,
        networkId: 3000,
        icon: 'cennz',
        iconURL: 'https://ipfs.io/ipfs/QmWhNm7tTi6SYbiumULDRk956hxgqaZSX77vcxBNn8fvnw'
    },
    3001: {
        name: 'CENNZnet Nikau',
        chain: 'CENNZnet',
        rpc: ['https://nikau.centrality.me/public'],
        faucets: ['https://app-faucet.centrality.me'],
        nativeCurrency: { name: 'CPAY', symbol: 'CPAY', decimals: 18 },
        infoURL: 'https://cennz.net',
        shortName: 'cennz-n',
        chainId: 3001,
        networkId: 3001,
        icon: 'cennz',
        explorers: [
            {
                name: 'UNcover',
                url: 'https://www.uncoverexplorer.com/?network=Nikau',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWhNm7tTi6SYbiumULDRk956hxgqaZSX77vcxBNn8fvnw'
    },
    3003: {
        name: 'Canxium Mainnet',
        chain: 'CAU',
        icon: 'canxium',
        rpc: ['https://rpc.canxium.org'],
        faucets: [],
        nativeCurrency: { name: 'Canxium', symbol: 'CAU', decimals: 18 },
        infoURL: 'https://canxium.org',
        shortName: 'cau',
        chainId: 3003,
        networkId: 3003,
        explorers: [
            {
                name: 'canxium explorer',
                url: 'https://explorer.canxium.org',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXHSbtVNCJVfe2CvRH7njdyf2SrX5u5bNTfvhqjLeFN2A'
    },
    3011: {
        name: 'PLAYA3ULL GAMES',
        chain: '3ULL',
        rpc: ['https://api.mainnet.playa3ull.games'],
        faucets: [],
        nativeCurrency: { name: '3ULL', symbol: '3ULL', decimals: 18 },
        features: [{ name: 'EIP1559' }],
        infoURL: 'https://playa3ull.games',
        shortName: '3ULL',
        chainId: 3011,
        networkId: 3011,
        icon: 'playa3ull',
        explorers: [
            {
                name: 'PLAYA3ULL GAMES Explorer',
                url: 'https://3011.routescan.io',
                icon: 'playa3ull',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreib62bv2d65d7nidojgpkgatrt7smee2l4ov6i6ozqhpfaqsonxku4'
    },
    3030: {
        name: 'BC Hyper Chain Mainnet',
        chain: 'BC Hyper Chain',
        rpc: ['https://mainapi.bchscan.io'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'VERSATIZE COIN', symbol: 'VTCN', decimals: 18 },
        infoURL: 'https://www.versatizecoin.com/',
        shortName: 'BCHYPER',
        chainId: 3030,
        networkId: 3030,
        icon: 'bchyper',
        explorers: [
            {
                name: 'bcexplorer mainnet',
                url: 'https://bchscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreia5iw3fygyim6ivv4lznrsak2x6e573vybexlnpxpcp775hcgmjyi'
    },
    3031: {
        name: 'Orlando Chain',
        chain: 'ORL',
        rpc: ['https://rpc-testnet.orlchain.com'],
        faucets: [],
        nativeCurrency: { name: 'Orlando', symbol: 'ORL', decimals: 18 },
        infoURL: 'https://orlchain.com',
        shortName: 'ORL',
        chainId: 3031,
        networkId: 3031,
        icon: 'orl',
        explorers: [
            {
                name: 'Orlando (ORL) Explorer',
                url: 'https://orlscan.com',
                icon: 'orl',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNsuuBBTHErnuFDcdyzaY8CKoVJtobsLJx2WQjaPjcp7g'
    },
    3033: {
        name: 'Rebus Testnet',
        title: 'Rebuschain Testnet',
        chain: 'REBUS',
        rpc: ['https://testnet.rebus.money/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Rebus', symbol: 'REBUS', decimals: 18 },
        infoURL: 'https://www.rebuschain.com',
        shortName: 'rebus-testnet',
        chainId: 3033,
        networkId: 3033,
        icon: 'rebus',
        explorers: [
            {
                name: 'Rebus EVM Explorer (Blockscout)',
                url: 'https://evm.testnet.rebus.money',
                icon: 'rebus',
                standard: 'none'
            },
            {
                name: 'Rebus Cosmos Explorer (ping.pub)',
                url: 'https://testnet.rebus.money/rebustestnet',
                icon: 'rebus',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifzag46dhp33vb2uldg4htqbqipuqrapjga6ml6pnhn5yibbvb4gq'
    },
    3068: {
        name: 'Bifrost Mainnet',
        title: 'Bifrost Network Mainnet',
        chain: 'BFC',
        rpc: [
            'https://public-01.mainnet.bifrostnetwork.com/rpc',
            'https://public-02.mainnet.bifrostnetwork.com/rpc'
        ],
        faucets: [],
        nativeCurrency: { name: 'Bifrost', symbol: 'BFC', decimals: 18 },
        infoURL: 'https://bifrostnetwork.com',
        shortName: 'bfc',
        chainId: 3068,
        networkId: 3068,
        icon: 'bifrost',
        explorers: [
            {
                name: 'explorer-thebifrost',
                url: 'https://explorer.mainnet.bifrostnetwork.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYxniqbiFD7nXBNjN8boUhoXYEAW23YquArD2Rnkq8WHS'
    },
    3073: {
        name: 'Movement EVM',
        chain: 'MOVE',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Move', symbol: 'MOVE', decimals: 18 },
        infoURL: 'https://movementlabs.xyz',
        shortName: 'move',
        chainId: 3073,
        networkId: 3073,
        icon: 'move',
        explorers: [
            {
                name: 'mevm explorer',
                url: 'https://explorer.movementlabs.xyz',
                standard: 'none'
            }
        ],
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWRAor77N6VyjJiQgtsEE7h9Bd1Q7vtRveTYv2A6wZyAT'
    },
    3084: {
        name: 'XL Network Testnet',
        chain: 'XL Network Testnet',
        rpc: [
            'https://subnets.avax.network/xlnetworkt/testnet/rpc',
            'wss://subnets.avax.network/xlnetworkt/testnet/ws'
        ],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'XLNetwork', symbol: 'XLN', decimals: 18 },
        infoURL: 'https://www.nysl.io/',
        shortName: 'nysl',
        icon: 'nysl',
        chainId: 3084,
        networkId: 3084,
        explorers: [
            {
                name: 'XL Network Explorer',
                url: 'https://subnets-test.avax.network/xlnetworkt',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeiaybbrbmfizoy3zdnypi2yefozyfjnrqa6ug6bel7ld7caack5d6e'
    },
    3100: {
        name: 'Immu3 EVM',
        chain: 'EVMCC',
        rpc: [
            'https://fraa-flashbox-2800-rpc.a.stagenet.tanssi.network',
            'wss://fraa-flashbox-2800-rpc.a.stagenet.tanssi.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'IMMU', symbol: 'IMMU', decimals: 18 },
        infoURL: 'https://immu3.io',
        shortName: 'Immu3',
        chainId: 3100,
        networkId: 3100,
        explorers: []
    },
    3102: {
        name: 'Vulture EVM Beta',
        chain: 'VFIEVMCC',
        rpc: [
            'https://fraa-dancebox-3050-rpc.a.dancebox.tanssi.network',
            'wss://fraa-dancebox-3050-rpc.a.dancebox.tanssi.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'VFI', symbol: 'VFI', decimals: 18 },
        infoURL: 'https://vulture.finance',
        shortName: 'VFI',
        chainId: 3102,
        networkId: 3102,
        explorers: []
    },
    3109: {
        name: 'SatoshiVM Alpha Mainnet',
        chain: 'SatoshiVM',
        rpc: ['https://alpha-rpc-node-http.svmscan.io'],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://www.satoshivm.io/',
        shortName: 'SAVM',
        chainId: 3109,
        networkId: 3109,
        icon: 'satoshivm',
        iconURL: 'https://ipfs.io/ipfs/QmdXnQw9YwzEBZnciSe42MMwnH1SqhfY3FcVbseyM4k7Th'
    },
    3110: {
        name: 'SatoshiVM Testnet',
        chain: 'SatoshiVM',
        rpc: ['https://test-rpc-node-http.svmscan.io'],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://www.satoshivm.io/',
        shortName: 'tSAVM',
        chainId: 3110,
        networkId: 3110,
        icon: 'satoshivm',
        iconURL: 'https://ipfs.io/ipfs/QmdXnQw9YwzEBZnciSe42MMwnH1SqhfY3FcVbseyM4k7Th'
    },
    3141: {
        name: 'Filecoin - Hyperspace testnet',
        status: 'deprecated',
        chain: 'FIL',
        icon: 'filecoin',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'testnet filecoin', symbol: 'tFIL', decimals: 18 },
        infoURL: 'https://filecoin.io',
        shortName: 'filecoin-hyperspace',
        chainId: 3141,
        networkId: 3141,
        slip44: 1,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmS9r9XQkMHVomWcSBNDkKkz9n87h9bH9ssabeiKZtANoU'
    },
    3269: {
        name: 'Dubxcoin network',
        chain: 'DUBX',
        rpc: ['https://rpcmain.arabianchain.org'],
        faucets: [],
        nativeCurrency: { name: 'Dubxcoin mainnet', symbol: 'DUBX', decimals: 18 },
        infoURL: 'https://arabianchain.org',
        shortName: 'dubx',
        chainId: 3269,
        networkId: 3269
    },
    3270: {
        name: 'Dubxcoin testnet',
        chain: 'TESTDUBX',
        rpc: ['https://rpctestnet.arabianchain.org'],
        faucets: ['https://faucet.arabianchain.org/'],
        nativeCurrency: { name: 'Dubxcoin testnet', symbol: 'TDUBX', decimals: 18 },
        infoURL: 'https://arabianchain.org',
        shortName: 'testdubx',
        chainId: 3270,
        networkId: 3270,
        slip44: 1
    },
    3306: {
        name: 'Debounce Subnet Testnet',
        chain: 'Debounce Network',
        icon: 'debounce',
        rpc: ['https://dev-rpc.debounce.network'],
        faucets: [],
        nativeCurrency: { name: 'Debounce Network', symbol: 'DB', decimals: 18 },
        infoURL: 'https://debounce.network',
        shortName: 'debounce-devnet',
        chainId: 3306,
        networkId: 3306,
        slip44: 1,
        explorers: [
            {
                name: 'Debounce Devnet Explorer',
                url: 'https://explorer.debounce.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeib5q4hez37s7b2fx4hqt2q4ji2tuudxjhfdgnp6q3d5mqm6wsxdfq'
    },
    3331: {
        name: 'ZCore Testnet',
        chain: 'Beach',
        icon: 'zcore',
        rpc: ['https://rpc-testnet.zcore.cash'],
        faucets: ['https://faucet.zcore.cash'],
        nativeCurrency: { name: 'ZCore', symbol: 'ZCR', decimals: 18 },
        infoURL: 'https://zcore.cash',
        shortName: 'zcrbeach',
        chainId: 3331,
        networkId: 3331,
        slip44: 1,
        iconURL: 'https://ipfs.io/ipfs/QmQnXu13ym8W1VA3QxocaNVXGAuEPmamSCkS7bBscVk1f4'
    },
    3332: {
        name: 'EthStorage L2 Mainnet',
        chain: 'EthStorage',
        rpc: ['http://mainnet.l2.ethstorage.io:9540'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://ethstorage.io/',
        shortName: 'esl2-m',
        chainId: 3332,
        networkId: 3332,
        slip44: 1,
        status: 'incubating',
        parent: { type: 'L2', chain: 'eip155-1' }
    },
    3333: {
        name: 'EthStorage Testnet',
        chain: 'EthStorage',
        rpc: ['http://testnet.ethstorage.io:9540'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://ethstorage.io/',
        shortName: 'es-t',
        chainId: 3333,
        networkId: 3333,
        slip44: 1
    },
    3334: {
        name: 'Web3Q Galileo',
        chain: 'Web3Q',
        rpc: ['https://galileo.web3q.io:8545'],
        faucets: [],
        nativeCurrency: { name: 'Web3Q', symbol: 'W3Q', decimals: 18 },
        infoURL: 'https://galileo.web3q.io/home.w3q/',
        shortName: 'w3q-g',
        chainId: 3334,
        networkId: 3334,
        explorers: [
            {
                name: 'w3q-galileo',
                url: 'https://explorer.galileo.web3q.io',
                standard: 'EIP3091'
            }
        ]
    },
    3335: {
        name: 'QuarkChain L2 Beta Testnet',
        chain: 'QuarkChain',
        rpc: ['https://rpc.beta.testnet.l2.quarkchain.io:8545'],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkcl2-b',
        chainId: 3335,
        networkId: 3335,
        slip44: 1,
        parent: { type: 'L2', chain: 'eip155-11155111' },
        explorers: [
            {
                name: 'quarkchain-beta-test',
                url: 'https://explorer.beta.testnet.l2.quarkchain.io',
                standard: 'EIP3091'
            }
        ]
    },
    3336: {
        name: 'EthStorage L2 Testnet',
        chain: 'EthStorage',
        rpc: ['http://testnet.l2.ethstorage.io:9540'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://ethstorage.io/',
        shortName: 'esl2-t',
        chainId: 3336,
        networkId: 3336,
        slip44: 1,
        status: 'incubating',
        parent: { type: 'L2', chain: 'eip155-11155111' }
    },
    3337: {
        name: 'EthStorage Devnet',
        chain: 'EthStorage',
        rpc: ['http://devnet.ethstorage.io:9540'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://ethstorage.io/',
        shortName: 'es-d',
        chainId: 3337,
        networkId: 3337,
        slip44: 1,
        status: 'incubating'
    },
    3338: {
        name: 'peaq',
        chain: 'peaq',
        icon: 'peaq',
        rpc: [
            'https://peaq.api.onfinality.io/public',
            'https://peaq-rpc.dwellir.com',
            'https://peaq-rpc.publicnode.com',
            'https://evm.peaq.network',
            'https://responsive-powerful-mansion.peaq-mainnet.quiknode.pro/29963d0a2deee01a20b091926b08d68db12bc68b'
        ],
        faucets: [],
        nativeCurrency: { name: 'peaq', symbol: 'PEAQ', decimals: 18 },
        infoURL: 'https://www.peaq.network',
        shortName: 'PEAQ',
        chainId: 3338,
        networkId: 3338,
        explorers: [
            {
                name: 'Subscan',
                url: 'https://peaq.subscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQ7Jue8v2YXyhmDTkSbzCJxzZDa2v4GZZKViESdyswzrj'
    },
    3339: {
        name: 'EthStorage Mainnet',
        chain: 'EthStorage',
        rpc: ['http://mainnet.ethstorage.io:9540'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://ethstorage.io/',
        shortName: 'es-m',
        chainId: 3339,
        networkId: 3339,
        slip44: 1,
        status: 'incubating'
    },
    3344: {
        name: 'Pentagon Chain',
        chain: 'Pentagon Chain',
        rpc: ['https://rpc.pentagon.games'],
        faucets: ['https://bridge.pentagon.games'],
        nativeCurrency: { name: 'Pentagon Chain', symbol: 'PC', decimals: 18 },
        icon: 'pentagonchain',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://pentagon.games',
        shortName: 'PentagonChain',
        chainId: 3344,
        networkId: 3344,
        explorers: [
            {
                name: 'Pentagon Chain Explorer',
                url: 'https://explorer.pentagon.games',
                icon: 'pentagonchain',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/bafkreibiwnnehj2j3tbla2yvvama6p7tfxvjfeqymw6ptoecoxb66glhkm'
    },
    3366: {
        name: 'Meroneum',
        chain: 'MERON',
        icon: 'meron',
        rpc: [
            'https://mainnet-node1.meronscan.ai/',
            'https://mainnet-node2.meronscan.ai/',
            'https://mainnet-node3.meronscan.ai/'
        ],
        faucets: [],
        nativeCurrency: { name: 'MERON', symbol: 'MERON', decimals: 18 },
        infoURL: 'https://www.meroneum.ai',
        shortName: 'meron-testnet',
        chainId: 3366,
        networkId: 3366,
        explorers: [
            {
                name: 'meronscan',
                url: 'https://meronscan.ai',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdNnuHVDHttkw1Xjp8RZBN2doF9QmBbFpBGf8nxktwdJH'
    },
    3369: {
        name: 'Meroneum Testnet',
        chain: 'MERON',
        icon: 'meron',
        rpc: [
            'https://testnet-node1.meronscan.ai/',
            'https://testnet-node2.meronscan.ai/',
            'https://testnet-node3.meronscan.ai/'
        ],
        faucets: [],
        nativeCurrency: { name: 'MERON', symbol: 'MERON', decimals: 18 },
        infoURL: 'https://www.meroneum.ai/',
        shortName: 'meron',
        chainId: 3369,
        networkId: 3369,
        explorers: [
            {
                name: 'meronscan',
                url: 'https://testnet.meronscan.ai',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdNnuHVDHttkw1Xjp8RZBN2doF9QmBbFpBGf8nxktwdJH'
    },
    3400: {
        name: 'Paribu Net Mainnet',
        chain: 'PRB',
        rpc: ['https://rpc.paribu.network'],
        faucets: [],
        nativeCurrency: { name: 'PRB', symbol: 'PRB', decimals: 18 },
        infoURL: 'https://net.paribu.com',
        shortName: 'prb',
        chainId: 3400,
        networkId: 3400,
        icon: 'prb',
        explorers: [
            {
                name: 'Paribu Net Explorer',
                url: 'https://explorer.paribu.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVgc77jYo2zrxQjhYwT4KzvSrSZ1DBJraJVX57xAvP8MD'
    },
    3409: {
        name: 'Pepe Unchained',
        chain: 'PEPU',
        icon: 'pepu',
        rpc: ['https://rpc-pepe-unchained-gupg0lo9wf.t.conduit.xyz'],
        faucets: [],
        nativeCurrency: { name: 'PEPU', symbol: 'PEPU', decimals: 18 },
        infoURL: 'https://pepeunchained.com/',
        shortName: 'PEPU',
        chainId: 3409,
        networkId: 3409,
        explorers: [
            {
                name: 'pepuscan',
                url: 'https://pepuscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreib2gexi344ssvsusvdco5uga52ffflxprksd5g2nokndsb572ijja'
    },
    3424: {
        name: 'EVOLVE Mainnet',
        chain: 'EVO',
        icon: 'evolveIcon',
        rpc: ['https://rpc.evoexplorer.com'],
        faucets: [],
        nativeCurrency: { name: 'Evolve', symbol: 'EVO', decimals: 18 },
        infoURL: 'https://evolveblockchain.io',
        shortName: 'EVOm',
        chainId: 3424,
        networkId: 3424,
        explorers: [
            {
                name: 'Evolve Mainnet Explorer',
                url: 'https://evoexplorer.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVxtpYYzc5214CB7BgsMC4mRNRHCD8fpbNMzZguBWyRwa'
    },
    3434: {
        name: 'SecureChain Testnet',
        chain: 'SCAI',
        icon: 'scaiIcon',
        rpc: ['https://testnet-rpc.securechain.ai'],
        faucets: ['https://faucet.securechain.ai'],
        nativeCurrency: { name: 'SCAI', symbol: 'SCAI', decimals: 18 },
        infoURL: 'https://securechain.ai',
        shortName: 'SCAIt',
        chainId: 3434,
        networkId: 3434,
        slip44: 1,
        explorers: [
            {
                name: 'SecureChain',
                url: 'https://testnet.securechain.ai',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme2Z8VFYjhHGfLQPBnfseNpEdRfmTDy7VXqrdH4AHETJf'
    },
    3456: {
        name: 'LayerEdge testnet',
        chain: 'LayerEdge',
        rpc: ['https://testnet-rpc.layeredge.io'],
        faucets: ['https://testnet-faucet.layeredge.io'],
        nativeCurrency: { name: 'Bitcoin', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://www.layeredge.io',
        shortName: 'LayerEdge-testnet',
        chainId: 3456,
        networkId: 3456,
        icon: 'layerEdge',
        explorers: [
            {
                name: 'LayerEdge Testnet Explorer',
                url: 'https://testnet-explorer.layeredge.io',
                icon: 'layerEdge',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmT2RotFAn8edji6FqBiP1TpTb1EFqHr28qbQGoRaJ9nTN'
    },
    3490: {
        name: 'GTCSCAN',
        chain: 'GTC',
        icon: 'gtc',
        rpc: ['https://gtc-dataseed.gtcscan.io/'],
        faucets: [],
        nativeCurrency: { name: 'GTC', symbol: 'GTC', decimals: 18 },
        infoURL: 'https://gtcscan.io/',
        shortName: 'gtc',
        chainId: 3490,
        networkId: 3490,
        slip44: 1,
        explorers: [
            {
                name: 'GTCScan Explorer',
                url: 'https://gtcscan.io',
                standard: 'none',
                icon: 'gtc'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeiaaq7gogws6uqcvo6imxbxfgpdhewybh7bxgtfny2i2as5nidbdje'
    },
    3500: {
        name: 'Paribu Net Testnet',
        chain: 'PRB',
        rpc: ['https://rpc.testnet.paribuscan.com'],
        faucets: ['https://faucet.paribuscan.com'],
        nativeCurrency: { name: 'PRB', symbol: 'PRB', decimals: 18 },
        infoURL: 'https://net.paribu.com',
        shortName: 'prbtestnet',
        chainId: 3500,
        networkId: 3500,
        slip44: 1,
        icon: 'prb',
        explorers: [
            {
                name: 'Paribu Net Testnet Explorer',
                url: 'https://testnet.paribuscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVgc77jYo2zrxQjhYwT4KzvSrSZ1DBJraJVX57xAvP8MD'
    },
    3501: {
        name: 'JFIN Chain',
        chain: 'JFIN',
        rpc: ['https://rpc.jfinchain.com'],
        faucets: [],
        nativeCurrency: { name: 'JFIN Coin', symbol: 'JFIN', decimals: 18 },
        infoURL: 'https://jfinchain.com',
        shortName: 'JFIN',
        chainId: 3501,
        networkId: 3501,
        explorers: [
            {
                name: 'JFIN Chain Explorer',
                url: 'https://exp.jfinchain.com',
                standard: 'EIP3091'
            }
        ]
    },
    3502: {
        name: 'JFINPOS',
        chain: 'JFINPOS',
        icon: 'jfinpos',
        rpc: ['https://rpc.jfinpos.com'],
        faucets: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'JFINPOS', symbol: 'JPOS', decimals: 18 },
        infoURL: 'https://jfinpos.com',
        shortName: 'jzero',
        chainId: 3502,
        networkId: 3502,
        explorers: [
            {
                name: 'JFINPOS Explorer',
                url: 'https://exp.jfinpos.com',
                icon: 'jfinpos',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVXd6Jm541mVJbfzHQaZNZce9znvm8iXfxgf91J2XNg61'
    },
    3601: {
        name: 'PandoProject Mainnet',
        chain: 'PandoProject',
        icon: 'pando',
        rpc: ['https://eth-rpc-api.pandoproject.org/rpc'],
        faucets: [],
        nativeCurrency: { name: 'pando-token', symbol: 'PTX', decimals: 18 },
        infoURL: 'https://www.pandoproject.org/',
        shortName: 'pando-mainnet',
        chainId: 3601,
        networkId: 3601,
        explorers: [
            {
                name: 'Pando Mainnet Explorer',
                url: 'https://explorer.pandoproject.org',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNduBtT5BNGDw7DjRwDvaZBb6gjxf46WD7BYhn4gauGc9'
    },
    3602: {
        name: 'PandoProject Testnet',
        chain: 'PandoProject',
        icon: 'pando',
        rpc: ['https://testnet.ethrpc.pandoproject.org/rpc'],
        faucets: [],
        nativeCurrency: { name: 'pando-token', symbol: 'PTX', decimals: 18 },
        infoURL: 'https://www.pandoproject.org/',
        shortName: 'pando-testnet',
        chainId: 3602,
        networkId: 3602,
        slip44: 1,
        explorers: [
            {
                name: 'Pando Testnet Explorer',
                url: 'https://testnet.explorer.pandoproject.org',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNduBtT5BNGDw7DjRwDvaZBb6gjxf46WD7BYhn4gauGc9'
    },
    3630: {
        name: 'Tycooncoin',
        chain: 'TYCON',
        rpc: ['https://mainnet-rpc.tycoscan.com'],
        faucets: [],
        nativeCurrency: { name: 'Tycooncoin', symbol: 'TYCO', decimals: 18 },
        infoURL: '',
        shortName: 'TYCON',
        chainId: 3630,
        networkId: 3630
    },
    3636: {
        name: 'Botanix Testnet',
        chain: 'BOTANIX',
        icon: 'botanix',
        rpc: ['https://node.botanixlabs.dev'],
        faucets: ['https://faucet.botanixlabs.dev'],
        nativeCurrency: { name: 'Botanix', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://botanixlabs.xyz',
        shortName: 'BTNX',
        chainId: 3636,
        networkId: 3636,
        slip44: 1,
        explorers: [
            {
                name: 'Botanix Explorer',
                url: 'https://testnet.botanixscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVE5s2pXiqdMnAcxhAmWkZYhpFB5CysypeLyPKzT4rGYe'
    },
    3637: {
        name: 'Botanix Mainnet',
        chain: 'BTC',
        icon: 'botanix',
        rpc: ['https://rpc.btxtestchain.com'],
        faucets: ['https://faucet.btxtestchain.com'],
        nativeCurrency: { name: 'Botanix', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://btxtestchain.com',
        shortName: 'BTCm',
        chainId: 3637,
        networkId: 3637,
        explorers: [
            {
                name: 'Botanix',
                url: 'https://btxtestchain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVE5s2pXiqdMnAcxhAmWkZYhpFB5CysypeLyPKzT4rGYe'
    },
    3639: {
        name: 'iChain Network',
        chain: 'iChain',
        icon: 'iChain',
        rpc: ['https://rpc.ichainscan.com'],
        faucets: [],
        nativeCurrency: { name: 'ISLAMICOIN', symbol: 'ISLAMI', decimals: 18 },
        infoURL: 'https://islamicoin.finance',
        shortName: 'ISLAMI',
        chainId: 3639,
        networkId: 3639,
        explorers: [
            {
                name: 'iChainscan',
                url: 'https://ichainscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcumhDxUyoLTHkcMKgPqkpGnnjwSTqE2KGFnDXXFY8mMo'
    },
    3645: {
        name: 'iChain Testnet',
        chain: 'iChain Testnet',
        icon: 'iChain',
        rpc: ['https://istanbul.ichainscan.com'],
        faucets: [],
        nativeCurrency: { name: 'ISLAMICOIN', symbol: 'ISLAMI', decimals: 18 },
        infoURL: 'https://islamicoin.finance',
        shortName: 'ISLAMIT',
        chainId: 3645,
        networkId: 3645,
        explorers: [
            {
                name: 'iChainscan',
                url: 'https://test.ichainscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcumhDxUyoLTHkcMKgPqkpGnnjwSTqE2KGFnDXXFY8mMo'
    },
    3666: {
        name: 'Jouleverse Mainnet',
        chain: 'Jouleverse',
        rpc: ['https://rpc.jnsdao.com:8503'],
        faucets: [],
        nativeCurrency: { name: 'J', symbol: 'J', decimals: 18 },
        infoURL: 'https://jnsdao.com',
        shortName: 'jouleverse',
        chainId: 3666,
        networkId: 3666,
        explorers: [
            {
                name: 'jscan',
                url: 'https://jscan.jnsdao.com',
                standard: 'EIP3091'
            }
        ]
    },
    3690: {
        name: 'Bittex Mainnet',
        chain: 'BTX',
        rpc: ['https://rpc1.bittexscan.info', 'https://rpc2.bittexscan.info'],
        faucets: [],
        nativeCurrency: { name: 'Bittex', symbol: 'BTX', decimals: 18 },
        infoURL: 'https://bittexscan.com',
        shortName: 'btx',
        chainId: 3690,
        networkId: 3690,
        explorers: [
            {
                name: 'bittexscan',
                url: 'https://bittexscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    3693: {
        name: 'Empire Network',
        chain: 'EMPIRE',
        rpc: ['https://rpc.empirenetwork.io'],
        faucets: [],
        nativeCurrency: { name: 'Empire', symbol: 'EMPIRE', decimals: 18 },
        infoURL: 'https://www.empirenetwork.io/',
        shortName: 'empire',
        chainId: 3693,
        networkId: 3693,
        explorers: [
            {
                name: 'Empire Explorer',
                url: 'https://explorer.empirenetwork.io',
                standard: 'none'
            }
        ]
    },
    3698: {
        name: 'SenjePowers Testnet',
        chain: 'SPC',
        icon: 'SenjePowers',
        rpc: ['https://testnet-rpc.senjepowersscan.com'],
        faucets: ['https://faucet.senjepowersscan.com'],
        nativeCurrency: { name: 'SenjePowers', symbol: 'SPC', decimals: 18 },
        infoURL: 'https://senjepowersscan.com',
        shortName: 'SPCt',
        chainId: 3698,
        networkId: 3698,
        slip44: 1,
        explorers: [
            {
                name: 'SenjePowers',
                url: 'https://testnet.senjepowersscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcpyTj4hUyHJZ2VmSdkXFpPpRcNKRP1VxMs7Cp1anymNy'
    },
    3699: {
        name: 'SenjePowers Mainnet',
        chain: 'SPC',
        icon: 'SenjePowers',
        rpc: ['https://rpc.senjepowersscan.com'],
        faucets: ['https://faucet.senjepowersscan.com'],
        nativeCurrency: { name: 'SenjePowers', symbol: 'SPC', decimals: 18 },
        infoURL: 'https://senjepowersscan.com',
        shortName: 'SPCm',
        chainId: 3699,
        networkId: 3699,
        explorers: [
            {
                name: 'SenjePowers',
                url: 'https://senjepowersscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcpyTj4hUyHJZ2VmSdkXFpPpRcNKRP1VxMs7Cp1anymNy'
    },
    3701: {
        name: 'Xpla Testnet',
        chain: 'XPLATest',
        rpc: ['https://dimension-rpc.xpla.dev'],
        faucets: ['https://faucet.xpla.io'],
        nativeCurrency: { name: 'XPLA', symbol: 'XPLA', decimals: 18 },
        infoURL: 'https://xpla.io',
        shortName: 'xplatest',
        chainId: 3701,
        networkId: 3701,
        slip44: 1,
        icon: 'xpla',
        explorers: [
            {
                name: 'XPLA Explorer',
                url: 'https://explorer.xpla.io',
                standard: 'none'
            }
        ],
        status: 'deprecated',
        iconURL: 'https://ipfs.io/ipfs/Qmf4GoxfpeA5VGqu7KP5eyv1WKaCpNDbvMxq1MjQBwFWxq'
    },
    3721: {
        name: 'Xone Mainnet',
        chain: 'XOC',
        icon: 'Xonechain',
        rpc: ['https://rpc.xone.org', 'wss://rpc-wss.xone.org'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://faucet.xone.org/'],
        nativeCurrency: { name: 'Xone Coin', symbol: 'XOC', decimals: 18 },
        infoURL: 'https://xone.org',
        shortName: 'XOC',
        chainId: 3721,
        networkId: 3721,
        explorers: [
            {
                name: 'Xonescan',
                url: 'https://xscscan.com',
                icon: 'Xonescan',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmR3twvfhDES34nLhcVmUbAZpW4eynZoSfA2XpWUBnH7gB'
    },
    3737: {
        name: 'Crossbell',
        chain: 'Crossbell',
        rpc: ['https://rpc.crossbell.io'],
        faucets: ['https://faucet.crossbell.io'],
        nativeCurrency: { name: 'Crossbell Token', symbol: 'CSB', decimals: 18 },
        infoURL: 'https://crossbell.io',
        shortName: 'csb',
        chainId: 3737,
        networkId: 3737,
        icon: 'crossbell',
        explorers: [
            {
                name: 'Crossbell Explorer',
                url: 'https://scan.crossbell.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmS8zEetTb6pwdNpVjv5bz55BXiSMGP9BjTJmNcjcUT91t'
    },
    3776: {
        name: 'Astar zkEVM',
        shortName: 'astrzk',
        title: 'Astar zkEVM Mainnet',
        chain: 'ETH',
        icon: 'astar',
        rpc: ['https://rpc.startale.com/astar-zkevm'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://astar.network',
        chainId: 3776,
        networkId: 3776,
        explorers: [
            {
                name: 'Blockscout Astar zkEVM explorer',
                url: 'https://astar-zkevm.explorer.startale.com',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://portal.astar.network' }]
        },
        iconURL: 'https://ipfs.io/ipfs/Qmdvmx3p6gXBCLUMU1qivscaTNkT6h3URdhUTZCHLwKudg'
    },
    3797: {
        name: 'AlveyChain Mainnet',
        chain: 'ALV',
        rpc: [
            'https://elves-core1.alvey.io',
            'https://elves-core2.alvey.io',
            'https://elves-core3.alvey.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'AlveyCoin', symbol: 'ALV', decimals: 18 },
        infoURL: 'https://alveychain.com/',
        shortName: 'alv',
        chainId: 3797,
        networkId: 3797,
        explorers: [
            {
                name: 'AlveyScan',
                url: 'https://alveyscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    3799: {
        name: 'Tangle Testnet',
        chain: 'Tangle Testnet',
        icon: 'tangle',
        rpc: [
            'https://testnet-rpc.tangle.tools',
            'https://testnet-rpc-archive.tangle.tools',
            'wss://testnet-rpc.tangle.tools',
            'wss://testnet-rpc-archive.tangle.tools'
        ],
        faucets: ['https://faucet.tangle.tools'],
        nativeCurrency: {
            name: 'Testnet Tangle Network Token',
            symbol: 'tTNT',
            decimals: 18
        },
        infoURL: 'https://docs.tangle.tools',
        shortName: 'tTangle',
        chainId: 3799,
        networkId: 3799,
        explorers: [
            {
                name: 'ttntscan',
                url: 'https://testnet-explorer.tangle.tools',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbxMNBTeQgch8t9GpWdLiS2R3wPYCzVRaX5kCQ4o5QU3w'
    },
    3885: {
        name: 'Firechain zkEVM Ghostrider',
        title: 'Firechain zkEVM Testnet',
        chain: 'Firechain',
        rpc: [
            'https://rpc-zkevm-ghostrider.thefirechain.com',
            'https://rpc-zkevm-ghostrider.firestation.io'
        ],
        faucets: [
            'zkevm-faucet.thefirechain.com',
            'https://zkevm-faucet.firestation.io'
        ],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://docs.thefirechain.com/',
        shortName: 'firechain-zkEVM-testnet',
        chainId: 3885,
        networkId: 3885,
        icon: 'ethereum',
        explorers: [
            {
                name: 'FireScan',
                url: 'https://ghostrider-zkevm.firescan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt'
    },
    3888: {
        name: 'KalyChain Mainnet',
        chain: 'KLC',
        icon: 'kalychain',
        rpc: ['https://rpc.kalychain.io/rpc'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'KalyCoin', symbol: 'KLC', decimals: 18 },
        infoURL: 'https://kalychain.io',
        shortName: 'kalymainnet',
        chainId: 3888,
        networkId: 3888,
        explorers: [
            {
                name: 'KalyScan',
                url: 'https://kalyscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUaXcPewLuQtY5a7xPTzJyVdjkH487VfV7gSR8UXrbxQ3'
    },
    3889: {
        name: 'KalyChain Testnet',
        chain: 'KLC',
        icon: 'kalychain',
        rpc: ['https://testnetrpc.kalychain.io/rpc'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'KalyCoin', symbol: 'KLC', decimals: 18 },
        infoURL: 'https://kalychain.io',
        shortName: 'kalytestnet',
        chainId: 3889,
        networkId: 3889,
        slip44: 1,
        explorers: [
            {
                name: 'KalyScan',
                url: 'https://testnet.kalyscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUaXcPewLuQtY5a7xPTzJyVdjkH487VfV7gSR8UXrbxQ3'
    },
    3912: {
        name: 'DRAC Network',
        chain: 'DRAC',
        rpc: ['https://www.dracscan.com/rpc'],
        faucets: ['https://www.dracscan.io/faucet'],
        nativeCurrency: { name: 'DRAC', symbol: 'DRAC', decimals: 18 },
        infoURL: 'https://drac.io/',
        shortName: 'drac',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        chainId: 3912,
        networkId: 3912,
        icon: 'drac',
        explorers: [
            {
                name: 'DRAC_Network Scan',
                url: 'https://www.dracscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXbsQe7QsVFZJZdBmbZVvS6LgX9ZFoaTMBs9MiQXUzJTw'
    },
    3939: {
        name: 'DOS Testnet',
        chain: 'DOS',
        rpc: ['https://test.doschain.com/'],
        faucets: [],
        nativeCurrency: { name: 'DOS', symbol: 'DOS', decimals: 18 },
        infoURL: 'http://doschain.io/',
        shortName: 'dost',
        chainId: 3939,
        networkId: 3939,
        slip44: 1,
        icon: 'doschain',
        explorers: [
            {
                name: 'DOScan-Test',
                url: 'https://test.doscan.io',
                icon: 'doschain',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmV2Nowzo81F6pi2qFcHePA4MwmmdMKBMUzBJUrxcymxx4'
    },
    3966: {
        name: 'DYNO Mainnet',
        chain: 'DYNO',
        rpc: ['https://api.dynoprotocol.com'],
        faucets: ['https://faucet.dynoscan.io'],
        nativeCurrency: { name: 'DYNO Token', symbol: 'DYNO', decimals: 18 },
        infoURL: 'https://dynoprotocol.com',
        shortName: 'dyno',
        chainId: 3966,
        networkId: 3966,
        explorers: [
            {
                name: 'DYNO Explorer',
                url: 'https://dynoscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    3967: {
        name: 'DYNO Testnet',
        chain: 'DYNO',
        rpc: ['https://tapi.dynoprotocol.com'],
        faucets: ['https://faucet.dynoscan.io'],
        nativeCurrency: { name: 'DYNO Token', symbol: 'tDYNO', decimals: 18 },
        infoURL: 'https://dynoprotocol.com',
        shortName: 'tdyno',
        chainId: 3967,
        networkId: 3967,
        slip44: 1,
        explorers: [
            {
                name: 'DYNO Explorer',
                url: 'https://testnet.dynoscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    3969: {
        name: 'PayNetwork Mainnet',
        chain: 'paynetwork',
        rpc: [
            'https://rpc.paynetwork.io',
            'https://paynetwork-main.calderachain.xyz/http'
        ],
        faucets: [],
        nativeCurrency: { name: 'PayNetwork', symbol: 'Pay', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://paynetwork-main.hub.caldera.xyz',
        shortName: 'paynetwork',
        chainId: 3969,
        networkId: 3969,
        icon: 'paynetwork',
        explorers: [
            {
                name: 'PayNetwork Mainnet Caldera Explorer',
                url: 'https://paynetwork-main.calderaexplorer.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidti4l2gj2bcafth2awvg6xn3fpx7wkautyyb23pfvd7pxzza2psq'
    },
    3993: {
        name: 'APEX Testnet',
        chain: 'ETH',
        rpc: ['https://rpc-testnet.apexlayer.xyz'],
        faucets: ['https://sepoliafaucet.com/'],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://docs.apexlayer.xyz/',
        shortName: 'apexsep',
        chainId: 3993,
        networkId: 3993,
        slip44: 1,
        icon: 'apextestnet',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://exp-testnet.apexlayer.xyz',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://apexlayer.xyz/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/qmxhs7fvjanzwm14vjpbnmklre32gsiy9chsarrnbtfa1n'
    },
    3999: {
        name: 'YuanChain Mainnet',
        chain: 'YCC',
        rpc: ['https://mainnet.yuan.org/eth'],
        faucets: [],
        nativeCurrency: { name: 'YCC', symbol: 'YCC', decimals: 18 },
        infoURL: 'https://www.yuan.org',
        shortName: 'ycc',
        chainId: 3999,
        networkId: 3999,
        icon: 'ycc',
        explorers: [
            {
                name: 'YuanChain Explorer',
                url: 'https://mainnet.yuan.org',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdbPhiB5W2gbHZGkYsN7i2VTKKP9casmAN2hRnpDaL9W4'
    },
    4000: {
        name: 'Ozone Chain Mainnet',
        chain: 'OZONE',
        rpc: ['https://node1.ozonechain.io'],
        faucets: [],
        nativeCurrency: { name: 'OZONE', symbol: 'OZO', decimals: 18 },
        infoURL: 'https://ozonechain.io',
        shortName: 'ozo',
        chainId: 4000,
        networkId: 4000,
        icon: 'ozonechain',
        explorers: [
            {
                name: 'OZONE Scan',
                url: 'https://ozonescan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbM4weV8Bk6c9yNhosYntkVw39SNZtCHYGgWyXTxkevZ8'
    },
    4001: {
        name: 'Peperium Chain Testnet',
        chain: 'PERIUM',
        rpc: ['https://rpc-testnet.peperium.io'],
        faucets: [],
        nativeCurrency: {
            name: 'Peperium Chain Testnet',
            symbol: 'PERIUM',
            decimals: 18
        },
        infoURL: 'https://peperium.io',
        shortName: 'PERIUM',
        chainId: 4001,
        networkId: 4001,
        slip44: 1,
        icon: 'peperium',
        explorers: [
            {
                name: 'Peperium Chain Explorer',
                url: 'https://scan-testnet.peperium.io',
                icon: 'peperium',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmag2hr5DQghRzKPN3oUFBkjWzqd5CndQzZeb5LfoiMCXf'
    },
    4002: {
        name: 'Fantom Testnet',
        chain: 'FTM',
        rpc: [
            'https://rpc.testnet.fantom.network',
            'https://fantom-testnet-rpc.publicnode.com',
            'wss://fantom-testnet-rpc.publicnode.com',
            'https://fantom-testnet.drpc.org',
            'wss://fantom-testnet.drpc.org'
        ],
        faucets: ['https://faucet.fantom.network'],
        nativeCurrency: { name: 'Fantom', symbol: 'FTM', decimals: 18 },
        infoURL: 'https://docs.fantom.foundation/quick-start/short-guide#fantom-testnet',
        shortName: 'tftm',
        chainId: 4002,
        networkId: 4002,
        slip44: 1,
        icon: 'fantom',
        explorers: [
            {
                name: 'ftmscan',
                url: 'https://testnet.ftmscan.com',
                icon: 'ftmscan',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcM8kHNsNYoitt5S3kLThyrKVFTZo3k2rgnume6tnNroQ'
    },
    4003: {
        name: 'X1 Fastnet',
        chain: 'X1',
        rpc: ['https://x1-fastnet.xen.network'],
        faucets: [],
        nativeCurrency: { name: 'XN', symbol: 'XN', decimals: 18 },
        infoURL: 'https://docs.xen.network/go-x1/',
        shortName: 'x1-fastnet',
        chainId: 4003,
        networkId: 4003,
        slip44: 1,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.x1-fastnet.xen.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    4040: {
        name: 'Carbonium Testnet Network',
        chain: 'CBR',
        rpc: [
            'https://rpc-dev.carbonium.network/',
            'https://server-testnet.carbonium.network'
        ],
        nativeCurrency: { name: 'Carbonium', symbol: 'tCBR', decimals: 18 },
        infoURL: 'https://carbonium.network',
        shortName: 'tcbr',
        chainId: 4040,
        networkId: 4040,
        slip44: 1,
        icon: 'cbr',
        faucets: ['https://getfaucet.carbonium.network'],
        explorers: [
            {
                name: 'Carbonium Network tesnet Explorer',
                icon: 'cbr',
                url: 'https://testnet.carboniumscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUTDMvoY7JgDs9sZuuBhsyJz6B2dNfc5jj6xUj355be2C'
    },
    4048: {
        name: 'GAN Testnet',
        chain: 'GAN',
        icon: 'gpu',
        rpc: ['https://rpc.gpu.net'],
        faucets: [],
        nativeCurrency: { name: 'GP Token', symbol: 'GP', decimals: 18 },
        infoURL: 'https://docs.gpu.net/',
        shortName: 'GANTestnet',
        chainId: 4048,
        networkId: 4048,
        explorers: [
            {
                name: 'ganscan',
                url: 'https://ganscan.gpu.net',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTYgL4PMNJya3XchuRx99ggNzMHL9kWaZvj3wycdEwpQA'
    },
    4051: {
        name: 'Bobaopera Testnet',
        chain: 'Bobaopera Testnet',
        status: 'deprecated',
        rpc: [
            'https://testnet.bobaopera.boba.network',
            'wss://wss.testnet.bobaopera.boba.network',
            'https://replica.testnet.bobaopera.boba.network',
            'wss://replica-wss.testnet.bobaopera.boba.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Boba Token', symbol: 'BOBA', decimals: 18 },
        infoURL: 'https://boba.network',
        shortName: 'BobaoperaTestnet',
        chainId: 4051,
        networkId: 4051,
        slip44: 1,
        explorers: [
            {
                name: 'Bobaopera Testnet block explorer',
                url: 'https://blockexplorer.testnet.bobaopera.boba.network',
                standard: 'none'
            }
        ]
    },
    4058: {
        name: 'Bahamut ocean',
        title: 'Bahamut ocean',
        chain: 'Bahamut',
        icon: 'bahamut',
        rpc: ['https://rpc1.ocean.bahamutchain.com'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'FTN', symbol: 'FTN', decimals: 18 },
        shortName: 'ocean',
        infoURL: 'https://bahamut.io',
        chainId: 4058,
        networkId: 4058,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://ocean.ftnscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSemioP83RXnDWwTZbet8VpwJxcFRboX4B3pcdhLZGodP'
    },
    4061: {
        name: 'Nahmii 3 Mainnet',
        chain: 'Nahmii',
        rpc: ['https://rpc.n3.nahmii.io'],
        status: 'active',
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://nahmii.io',
        shortName: 'Nahmii3Mainnet',
        chainId: 4061,
        networkId: 4061,
        icon: 'nahmii',
        explorers: [
            {
                name: 'Nahmii 3 Mainnet Explorer',
                url: 'https://explorer.nahmii.io',
                icon: 'nahmii',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://accounts.nahmii.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmZhKXgoGpzvthr2eh8ZNgT75YvMtEBegdELAaMPPzf5QT'
    },
    4062: {
        name: 'Nahmii 3 Testnet',
        chain: 'Nahmii',
        rpc: ['https://rpc.testnet.nahmii.io'],
        status: 'active',
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://nahmii.io',
        shortName: 'Nahmii3Testnet',
        chainId: 4062,
        networkId: 4062,
        slip44: 1,
        icon: 'nahmii',
        explorers: [
            {
                name: 'Nahmii 3 Testnet Explorer',
                url: 'https://explorer.testnet.nahmii.io',
                icon: 'nahmii',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://accounts.testnet.nahmii.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmZhKXgoGpzvthr2eh8ZNgT75YvMtEBegdELAaMPPzf5QT'
    },
    4078: {
        name: 'Muster Mainnet',
        chainId: 4078,
        shortName: 'muster',
        chain: 'Muster',
        icon: 'muster',
        networkId: 4078,
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        rpc: ['https://muster.alt.technology'],
        faucets: [],
        explorers: [
            {
                name: 'Musterscan',
                url: 'https://muster-explorer.alt.technology',
                standard: 'EIP3091'
            }
        ],
        infoURL: '',
        parent: { type: 'L2', chain: 'eip155-42161', bridges: [] },
        iconURL: 'https://ipfs.io/ipfs/bafkreiexm4aoscqo4d7dipicdgmfaemgzck2w7qhfp5mnoo7z2plcxleju'
    },
    4080: {
        name: 'Tobe Chain Testnet',
        chain: 'TBC',
        icon: 'tobe',
        rpc: ['https://rpc-testnet.tobescan.com'],
        faucets: ['https://faucet.tobescan.com/faucet'],
        nativeCurrency: { name: 'Tobe Coin', symbol: 'TOBE', decimals: 18 },
        infoURL: 'https://tobechain.net',
        shortName: 'tbc',
        chainId: 4080,
        networkId: 4080,
        explorers: [
            {
                name: 'tobescan testnet',
                url: 'https://testnet.tobescan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXARMjJGkXEVEdjUyxkeG4ffsWvEo9vSJpVon3JwRxckS'
    },
    4088: {
        name: 'Zeroth Mainnet',
        chain: 'ZRH',
        icon: 'zeroth',
        rpc: ['https://my.zeroth.run'],
        faucets: [],
        nativeCurrency: { name: 'ZRH', symbol: 'ZRH', decimals: 18 },
        infoURL: 'https://www.zeroth.foundation',
        shortName: 'ZRH',
        chainId: 4088,
        networkId: 4088,
        explorers: [
            {
                name: 'Zeroth Explorer',
                url: 'https://scan.zeroth.run',
                icon: 'zeroth',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVz2jPdp5vXo4mJVuTXLmwcfQsw3XVojkmochPckvCowz'
    },
    4090: {
        name: 'Fastex Chain (Bahamut) Oasis Testnet',
        title: 'Bahamut testnet Oasis',
        icon: 'bahamut',
        chain: 'Fastex Chain (Bahamut)',
        rpc: ['https://rpc1.oasis.bahamutchain.com'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://faucet.oasis.fastexchain.com'],
        nativeCurrency: { name: 'FTN', symbol: 'FTN', decimals: 18 },
        infoURL: 'https://fastexchain.com',
        shortName: 'Oasis',
        chainId: 4090,
        networkId: 4090,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://oasis.ftnscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSemioP83RXnDWwTZbet8VpwJxcFRboX4B3pcdhLZGodP'
    },
    4096: {
        name: 'Bitindi Testnet',
        chain: 'BNI',
        icon: 'bitindiTestnet',
        rpc: ['https://testnet-rpc.bitindi.org'],
        faucets: ['https://faucet.bitindi.org'],
        nativeCurrency: { name: 'BNI', symbol: '$BNI', decimals: 18 },
        infoURL: 'https://bitindi.org',
        shortName: 'BNIt',
        chainId: 4096,
        networkId: 4096,
        slip44: 1,
        explorers: [
            {
                name: 'Bitindi',
                url: 'https://testnet.bitindiscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRAFFPiLiSgjGTs9QaZdnR9fsDgyUdTejwSxcnPXo292s'
    },
    4099: {
        name: 'Bitindi Mainnet',
        chain: 'BNI',
        icon: 'bitindi',
        rpc: ['https://mainnet-rpc.bitindi.org'],
        faucets: ['https://faucet.bitindi.org'],
        nativeCurrency: { name: 'BNI', symbol: '$BNI', decimals: 18 },
        infoURL: 'https://bitindi.org',
        shortName: 'BNIm',
        chainId: 4099,
        networkId: 4099,
        explorers: [
            {
                name: 'Bitindi',
                url: 'https://bitindiscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRAFFPiLiSgjGTs9QaZdnR9fsDgyUdTejwSxcnPXo292s'
    },
    4102: {
        name: 'AIOZ Network Testnet',
        chain: 'AIOZ',
        icon: 'aioz',
        rpc: ['https://eth-ds.testnet.aioz.network'],
        faucets: [],
        nativeCurrency: { name: 'testAIOZ', symbol: 'AIOZ', decimals: 18 },
        infoURL: 'https://aioz.network',
        shortName: 'aioz-testnet',
        chainId: 4102,
        networkId: 4102,
        slip44: 1,
        explorers: [
            {
                name: 'AIOZ Network Testnet Explorer',
                url: 'https://testnet.explorer.aioz.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRAGPFhvQiXgoJkui7WHajpKctGFrJNhHqzYdwcWt5V3Z'
    },
    4139: {
        name: 'Humans.ai Testnet',
        chain: 'Humans Testnet',
        rpc: ['https://evm-rpc.testnet.humans.zone'],
        faucets: [],
        nativeCurrency: { name: 'HEART', symbol: 'HEART', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://humans.ai',
        shortName: 'humans_testnet',
        chainId: 4139,
        networkId: 4139,
        slip44: 1,
        icon: 'humans-dark',
        iconURL: 'https://ipfs.io/ipfs/QmX6XuoQDTTjYqAmdNJiieLDZSwHHyUx44yQb4E3tmHmEA'
    },
    4141: {
        name: 'Tipboxcoin Testnet',
        chain: 'TPBX',
        icon: 'tipboxcoinIcon',
        rpc: ['https://testnet-rpc.tipboxcoin.net'],
        faucets: ['https://faucet.tipboxcoin.net'],
        nativeCurrency: { name: 'Tipboxcoin', symbol: 'TPBX', decimals: 18 },
        infoURL: 'https://tipboxcoin.net',
        shortName: 'TPBXt',
        chainId: 4141,
        networkId: 4141,
        slip44: 1,
        explorers: [
            {
                name: 'Tipboxcoin',
                url: 'https://testnet.tipboxcoin.net',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbiaHnR3fVVofZ7Xq2GYZxwHkLEy3Fh5qDtqnqXD6ACAh'
    },
    4157: {
        name: 'CrossFi Testnet',
        title: 'CrossFi Testnet',
        chain: 'XFI',
        icon: 'crossfi',
        rpc: ['https://rpc.testnet.ms'],
        faucets: [],
        nativeCurrency: { name: 'XFI', symbol: 'XFI', decimals: 18 },
        infoURL: 'https://crossfi.org',
        shortName: 'crossfi-testnet',
        chainId: 4157,
        networkId: 4157,
        slip44: 1,
        explorers: [
            {
                name: 'CrossFi Testnet Scan',
                url: 'https://test.xfiscan.com',
                standard: 'EIP3091',
                icon: 'crossfi'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbRJzDeAdMkEXkqDwBwezpUxyjTPHZ2iXEomqKPvWZcWE'
    },
    4158: {
        name: 'CrossFi Mainnet',
        icon: 'crossfi',
        chain: 'crossfi',
        rpc: ['https://rpc.mainnet.ms/'],
        faucets: [],
        nativeCurrency: { name: 'CrossFi Token', symbol: 'XFI', decimals: 18 },
        infoURL: 'https://crossfi.org',
        shortName: 'crossfi',
        chainId: 4158,
        networkId: 4158,
        slip44: 1,
        explorers: [
            {
                name: 'CrossFi Mainnet Scan',
                url: 'https://xfiscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbRJzDeAdMkEXkqDwBwezpUxyjTPHZ2iXEomqKPvWZcWE'
    },
    4162: {
        name: 'SX Rollup',
        chain: 'SX',
        icon: 'SX',
        rpc: ['https://rpc.sx-rollup.gelato.digital'],
        faucets: [],
        nativeCurrency: { name: 'SX Network', symbol: 'SX', decimals: 18 },
        infoURL: 'https://www.sx.technology',
        shortName: 'SXR',
        chainId: 4162,
        networkId: 4162,
        explorers: [
            {
                name: 'SX L2 Explorer',
                url: 'https://explorerl2.sx.technology',
                standard: 'EIP3091',
                icon: 'SX'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-1' },
        iconURL: 'https://ipfs.io/ipfs/QmSXLXqyr2H6Ja5XrmznXbWTEvF2gFaL8RXNXgyLmDHjAF'
    },
    4181: {
        name: 'PHI Network V1',
        chain: 'PHI V1',
        rpc: ['https://rpc1.phi.network', 'https://rpc2.phi.network'],
        faucets: [],
        nativeCurrency: { name: 'PHI', symbol: 'Φ', decimals: 18 },
        infoURL: 'https://phi.network',
        shortName: 'PHIv1',
        chainId: 4181,
        networkId: 4181,
        icon: 'phi',
        explorers: [
            {
                name: 'PHI Explorer',
                url: 'https://explorer.phi.network',
                icon: 'phi',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreid6pm3mic7izp3a6zlfwhhe7etd276bjfsq2xash6a4s2vmcdf65a'
    },
    4200: {
        name: 'Merlin Mainnet',
        title: 'Merlin Mainnet',
        chain: 'Merlin',
        rpc: [
            'https://rpc.merlinchain.io',
            'https://merlin-mainnet-enterprise.unifra.io',
            'https://rpc-merlin.rockx.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://merlinchain.io',
        shortName: 'Merlin-Mainnet',
        chainId: 4200,
        networkId: 4200,
        icon: 'merlin',
        explorers: [
            {
                name: 'L2scan',
                url: 'https://scan.merlinchain.io',
                icon: 'merlin',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmULpMFUvKSmJT8sWXS3WDnTm4EacgRbsEynDenpxcfrAj'
    },
    4201: {
        name: 'LUKSO Testnet',
        chain: 'LUKSO Testnet',
        icon: 'lukso',
        rpc: [
            'https://rpc.testnet.lukso.network',
            'wss://ws-rpc.testnet.lukso.network'
        ],
        faucets: ['https://faucet.testnet.lukso.network'],
        nativeCurrency: { name: 'TestLYX', symbol: 'LYXt', decimals: 18 },
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.execution.testnet.lukso.network',
                standard: 'none'
            }
        ],
        infoURL: 'https://lukso.network',
        shortName: 'lukso-testnet',
        chainId: 4201,
        networkId: 4201,
        slip44: 1,
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        iconURL: 'https://ipfs.io/ipfs/Qmeg9sFF5tAGi6MCx7YjtVHW6a23zqvHRK1xwzSdp9iE7z'
    },
    4202: {
        name: 'Lisk Sepolia Testnet',
        chain: 'ETH',
        icon: 'lisk',
        rpc: ['https://rpc.sepolia-api.lisk.com'],
        faucets: ['https://app.optimism.io/faucet'],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://lisk.com',
        shortName: 'lisksep',
        chainId: 4202,
        networkId: 4202,
        slip44: 134,
        explorers: [
            {
                name: 'liskscout',
                url: 'https://sepolia-blockscout.lisk.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVTS8jmWD5e7jVEn86wLjJsuMnc6s8fym3JbtE4etzSKf'
    },
    4203: {
        name: 'Merlin Erigon Testnet',
        title: 'Merlin Erigon Testnet',
        chain: 'Merlin',
        rpc: ['https://testnet-erigon-rpc.merlinchain.io'],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://merlinchain.io',
        shortName: 'Merlin-Testnet',
        chainId: 4203,
        networkId: 4203,
        icon: 'merlin',
        explorers: [
            {
                name: 'L2scan',
                url: 'https://testnet-erigon-scan.merlinchain.io',
                icon: 'merlin',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmULpMFUvKSmJT8sWXS3WDnTm4EacgRbsEynDenpxcfrAj'
    },
    4242: {
        name: 'Nexi Mainnet',
        chain: 'Nexi',
        icon: 'nexi',
        rpc: [
            'https://rpc.chain.nexi.technology/',
            'https://chain.nexilix.com',
            'https://chain.nexi.evmnode.online'
        ],
        faucets: [],
        nativeCurrency: { name: 'Nexi', symbol: 'NEXI', decimals: 18 },
        infoURL: 'https://www.nexi.technology/',
        shortName: 'nexi',
        chainId: 4242,
        networkId: 4242,
        slip44: 2500,
        explorers: [
            {
                name: 'nexiscan',
                url: 'https://www.nexiscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeifxqd7zel2m237kq5enavnh2s6cshaavswigogyvae2wevxy5k2ti'
    },
    4243: {
        name: 'Nexi V2 Mainnet',
        chain: 'Nexi V2',
        icon: 'nexi',
        rpc: [
            'https://chain.nexiv2.nexilix.com',
            'https://rpc.chainv1.nexi.technology'
        ],
        faucets: [],
        nativeCurrency: { name: 'NexiV2', symbol: 'NEXI', decimals: 18 },
        infoURL: 'https://www.nexi.technology/',
        shortName: 'NexiV2',
        chainId: 4243,
        networkId: 4243,
        slip44: 2500,
        explorers: [
            {
                name: 'nexiscan',
                url: 'https://www.nexiscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeifxqd7zel2m237kq5enavnh2s6cshaavswigogyvae2wevxy5k2ti'
    },
    4269: {
        name: 'Laika Testnet',
        chain: 'LAIKA',
        rpc: ['https://testnetrpc1.laikachain.dog'],
        faucets: ['https://laikachain.dog/faucets'],
        nativeCurrency: { name: 'Dogecoin', symbol: 'DOGE', decimals: 18 },
        infoURL: 'https://laikachain.dog',
        shortName: 'laika-testnet',
        chainId: 4269,
        networkId: 4269,
        icon: 'laika',
        explorers: [
            {
                name: 'Laika Testnet Explorer',
                url: 'https://testnet.laikachain.dog',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTMbwvGznhMwxWbX28FWtj4Me8ayGQjUQG7zrXPCJzLTa'
    },
    4321: {
        name: 'Echos Chain',
        chain: 'Echos',
        rpc: ['https://rpc-echos-mainnet-0.t.conduit.xyz'],
        features: [],
        faucets: [],
        nativeCurrency: { name: 'USD Coin', symbol: 'USDC', decimals: 18 },
        infoURL: 'https://www.echos.fun/',
        shortName: 'echos',
        chainId: 4321,
        networkId: 4321,
        explorers: [
            {
                name: 'Echos Explorer',
                url: 'https://explorer.echos.fun',
                standard: 'none'
            }
        ]
    },
    4328: {
        name: 'Bobafuji Testnet',
        chain: 'Bobafuji Testnet',
        status: 'deprecated',
        rpc: [
            'https://testnet.avax.boba.network',
            'wss://wss.testnet.avax.boba.network',
            'https://replica.testnet.avax.boba.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Boba Token', symbol: 'BOBA', decimals: 18 },
        infoURL: 'https://boba.network',
        shortName: 'BobaFujiTestnet',
        chainId: 4328,
        networkId: 4328,
        slip44: 1,
        explorers: [
            {
                name: 'Bobafuji Testnet block explorer',
                url: 'https://blockexplorer.testnet.avax.boba.network',
                standard: 'none'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-5',
            bridges: [{ url: 'https://gateway.boba.network' }]
        }
    },
    4337: {
        name: 'Beam',
        chain: 'BEAM',
        rpc: [
            'https://build.onbeam.com/rpc',
            'wss://build.onbeam.com/ws',
            'https://subnets.avax.network/beam/mainnet/rpc',
            'wss://subnets.avax.network/beam/mainnet/ws'
        ],
        features: [{ name: 'EIP1559' }],
        faucets: ['https://faucet.onbeam.com'],
        nativeCurrency: { name: 'Beam', symbol: 'BEAM', decimals: 18 },
        infoURL: 'https://www.onbeam.com',
        shortName: 'beam',
        icon: 'beam',
        chainId: 4337,
        networkId: 4337,
        explorers: [
            {
                name: 'Beam Explorer',
                url: 'https://subnets.avax.network/beam',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQJ21NWyGGDraicVEzS1Uqq1yXahM9NCuNZgnfYvtspdt'
    },
    4352: {
        name: 'MemeCore',
        title: 'MemeCore',
        chain: 'MemeCore',
        icon: 'memecore',
        rpc: ['https://rpc.memecore.net', 'wss://ws.memecore.net'],
        nativeCurrency: { name: 'M', symbol: 'M', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        infoURL: 'https://memecore.com',
        shortName: 'm',
        chainId: 4352,
        networkId: 4352,
        explorers: [
            {
                name: 'OKX-MemeCore',
                url: 'https://www.okx.com/web3/explorer/memecore',
                standard: 'EIP3091'
            },
            {
                name: 'MemeCoreScan',
                url: 'https://memecorescan.io',
                standard: 'EIP3091'
            },
            {
                name: 'MemeCore explorer',
                url: 'https://blockscout.memecore.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmX2DPJqHjMRUYD4CMpXBDBpqa3p8c4DkE4iiHtcxBJe3i'
    },
    4400: {
        name: 'Credit Smart Chain Mainnet',
        chain: 'CREDIT',
        rpc: ['https://rpc.creditsmartchain.com'],
        faucets: [],
        nativeCurrency: { name: 'Credit', symbol: 'CREDIT', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://creditsmartchain.com',
        shortName: 'CreditEdge',
        chainId: 4400,
        networkId: 4400,
        icon: 'credit',
        explorers: [
            {
                name: 'Creditscan',
                url: 'https://scan.creditsmartchain.com',
                icon: 'credit',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifbso3gd4wu5wxl27xyurxctmuae2jyuy37guqtzx23nga6ba4ag4'
    },
    4422: {
        name: 'Testnet Pika',
        chain: 'tPKA',
        rpc: ['https://testnet-rpc1.pikascan.com'],
        faucets: [],
        icon: 'testnetpsc',
        nativeCurrency: { name: 'Testnet Pika', symbol: 'tPKA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://pikaminter.com',
        shortName: 'PikaMinter',
        chainId: 4422,
        networkId: 4422,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmXmBxoHWyPfpYP3gLfVB2d5DfVKT4FXKb4Bt6m7nf19wL'
    },
    4444: {
        name: 'Htmlcoin Mainnet',
        chain: 'mainnet',
        rpc: ['https://janus.htmlcoin.com/api/'],
        faucets: ['https://gruvin.me/htmlcoin'],
        nativeCurrency: { name: 'Htmlcoin', symbol: 'HTML', decimals: 8 },
        infoURL: 'https://htmlcoin.com',
        shortName: 'html',
        chainId: 4444,
        networkId: 4444,
        icon: 'htmlcoin',
        status: 'active',
        explorers: [
            {
                name: 'htmlcoin',
                url: 'https://explorer.htmlcoin.com',
                icon: 'htmlcoin',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmR1oDRSadPerfyWMhKHNP268vPKvpczt5zPawgFSZisz2'
    },
    4460: {
        name: 'Orderly Sepolia Testnet',
        chain: 'ETH',
        rpc: ['https://testnet-rpc.orderly.org'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://orderly.network',
        shortName: 'orderlyl2',
        chainId: 4460,
        networkId: 4460,
        slip44: 1,
        icon: 'orderlyTestnet',
        explorers: [
            {
                name: 'basescout',
                url: 'https://testnet-explorer.orderly.org',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSpwp3RAVhZsErAQrCQxEmjnGqJQMigarzZbfqr9Ktakb'
    },
    4488: {
        name: 'Hydra Chain',
        chain: 'HYDRA',
        rpc: ['https://rpc-mainnet.hydrachain.org'],
        faucets: [],
        nativeCurrency: { name: 'Hydra', symbol: 'HYDRA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://hydrachain.org',
        shortName: 'HYDRA',
        chainId: 4488,
        networkId: 4488,
        icon: 'hydra',
        explorers: [
            {
                name: 'Hydra Chain Mainnet explorer',
                url: 'https://skynet.hydrachain.org',
                icon: 'hydra',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVxyUjuA8t9q3oWDgv8ExqaUXcRuDqiKrZAiLaBWHYcmG'
    },
    4544: {
        name: 'Emoney Network Testnet',
        chain: 'Emoney',
        rpc: ['https://testnet.emoney.network/'],
        faucets: ['https://faucet.emoney.network/faucet'],
        nativeCurrency: { name: 'Emoney Network', symbol: 'EMYC', decimals: 18 },
        infoURL: 'https://emoney.network/',
        shortName: 'EmoneyTestnet',
        chainId: 4544,
        networkId: 4544,
        slip44: 118,
        icon: 'emoney',
        explorers: [
            {
                name: 'EMoney Explorer',
                url: 'https://explore-stage.emoney.network',
                icon: 'emoney',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigo4gtboztftjdnbvy2rb2ku2gxxbhm4iwutzgnzhvden3vcbsqui'
    },
    4545: {
        name: 'Emoney Network Mainnet',
        chain: 'Emoney',
        rpc: [
            'https://rpc-publicnode.emoney.io/',
            'https://public-node1-rpc.emoney.network/'
        ],
        faucets: [],
        nativeCurrency: { name: 'Emoney Coin', symbol: 'EMYC', decimals: 18 },
        infoURL: 'https://emoney.io/',
        shortName: 'emoney',
        chainId: 4545,
        networkId: 4545,
        icon: 'emoney',
        explorers: [
            {
                name: 'EMoney Explorer',
                url: 'https://explore.emoney.network',
                icon: 'emoney',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigo4gtboztftjdnbvy2rb2ku2gxxbhm4iwutzgnzhvden3vcbsqui'
    },
    4547: {
        name: 'TRUMPCHAIN',
        chain: 'trumpchain',
        rpc: [
            'https://testnet.trumpchain.dev/http',
            'wss://testnet.trumpchain.dev/ws'
        ],
        faucets: [],
        nativeCurrency: { name: 'Official Trump', symbol: 'TRUMP', decimals: 18 },
        infoURL: 'https://trumpchain.dev',
        shortName: 'TRUMPCHAIN',
        chainId: 4547,
        networkId: 4547,
        icon: 'trump',
        explorers: [
            {
                name: 'TRUMPCHAIN Explorer',
                url: 'https://explorer.trumpchain.dev',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPFt5rH4hGCdt1L9WT5ZMWfuxvX1Dss7GEB8crjDSm7Xh'
    },
    4613: {
        name: 'VERY Mainnet',
        title: 'VERY Mainnet',
        chain: 'VERY Mainnet',
        icon: 'very',
        rpc: ['https://rpc.verylabs.io'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'VERY', symbol: 'VERY', decimals: 18 },
        infoURL: 'https://www.verylabs.io/',
        shortName: 'very',
        chainId: 4613,
        networkId: 4613,
        explorers: [
            {
                name: 'VERY explorer',
                url: 'https://www.veryscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreie5ozo663ddewiqfiuc5kq44giy4zdhvpq2hamsdub5gwa77hcplu'
    },
    4646: {
        name: 'MST Chain',
        title: 'MST Chain',
        chain: 'MST',
        rpc: [
            'https://mariorpc.mstblockchain.com',
            'https://craftrpc.mstblockchain.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'MST', symbol: 'MST', decimals: 18 },
        infoURL: 'https://mstblockchain.com',
        shortName: 'mst',
        chainId: 4646,
        networkId: 4646,
        slip44: 4646,
        icon: 'mst',
        explorers: [
            {
                name: 'MST Mainnet Scan',
                url: 'https://mstscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiepbqd2czcifzkfxk2xjd4nfrlnt5yns3t57umhvhdtpnggn6esym'
    },
    4653: {
        name: 'Gold Chain',
        title: 'Gold Chain',
        chain: 'Gold',
        rpc: ['https://chain-rpc.gold.dev'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://gold.dev',
        shortName: 'gold',
        chainId: 4653,
        networkId: 4653,
        status: 'incubating',
        icon: 'gold',
        iconURL: 'https://ipfs.io/ipfs/QmbvuHpn8Np5uTTbVNgv4JHCj2zfHBfmSoRcVNdWbcV5Vq'
    },
    4661: {
        name: 'AppChain Testnet',
        chain: 'AppChain Testnet',
        rpc: [
            'https://appchaintestnet.rpc.caldera.xyz/http',
            'wss://appchaintestnet.rpc.caldera.xyz/ws'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://appchain.xyz',
        shortName: 'appchaintestnet',
        chainId: 4661,
        networkId: 4661,
        icon: 'appchain',
        explorers: [
            {
                name: 'AppChain Testnet Explorer',
                url: 'https://appchaintestnet.explorer.caldera.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://appchaintestnet.bridge.caldera.xyz' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafybeigx76uxvcvet7365sjdzuxxcgl5auzck6vbbigu2jeg6ixl5k3tya'
    },
    4689: {
        name: 'IoTeX Network Mainnet',
        chain: 'iotex.io',
        rpc: ['https://babel-api.mainnet.iotex.io'],
        faucets: [],
        nativeCurrency: { name: 'IoTeX', symbol: 'IOTX', decimals: 18 },
        infoURL: 'https://iotex.io',
        shortName: 'iotex-mainnet',
        chainId: 4689,
        networkId: 4689,
        explorers: [
            {
                name: 'iotexscan',
                url: 'https://iotexscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    4690: {
        name: 'IoTeX Network Testnet',
        chain: 'iotex.io',
        rpc: ['https://babel-api.testnet.iotex.io'],
        faucets: ['https://faucet.iotex.io/'],
        nativeCurrency: { name: 'IoTeX', symbol: 'IOTX', decimals: 18 },
        infoURL: 'https://iotex.io',
        shortName: 'iotex-testnet',
        chainId: 4690,
        networkId: 4690,
        slip44: 1,
        explorers: [
            {
                name: 'testnet iotexscan',
                url: 'https://testnet.iotexscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    4759: {
        name: 'MEVerse Chain Testnet',
        chain: 'MEVerse',
        rpc: ['https://rpc.meversetestnet.io'],
        faucets: [],
        nativeCurrency: { name: 'MEVerse', symbol: 'MEV', decimals: 18 },
        infoURL: 'https://www.meverse.sg',
        shortName: 'TESTMEV',
        chainId: 4759,
        networkId: 4759,
        slip44: 1,
        icon: 'meverse',
        explorers: [
            {
                name: 'MEVerse Chain Testnet Explorer',
                url: 'https://testnet.meversescan.io',
                standard: 'none',
                icon: 'meverse'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPuQ6gaCfUtNdRuaEDbdhot2m2KCy2ZHCJUvZXJAtdeyJ'
    },
    4777: {
        name: 'BlackFort Exchange Network Testnet DEPRECATED',
        chain: 'TBXN',
        rpc: ['https://testnet.blackfort.network/rpc'],
        faucets: [],
        nativeCurrency: {
            name: 'BlackFort Testnet Token',
            symbol: 'TBXN',
            decimals: 18
        },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://blackfort.exchange',
        shortName: 'TBXN',
        chainId: 4777,
        networkId: 4777,
        slip44: 1,
        icon: 'bxn',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet-explorer.blackfort.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        status: 'deprecated',
        iconURL: 'https://ipfs.io/ipfs/QmPasA8xykRtJDivB2bcKDiRCUNWDPtfUTTKVAcaF2wVxC'
    },
    4786: {
        name: 'Evnode Testnet',
        chain: 'Evnode',
        rpc: ['https://rpc-testnet.evnode.org/'],
        faucets: ['https://faucet.evnode.org'],
        nativeCurrency: {
            name: 'Evnode Testnet Native Token',
            symbol: 'tEVO',
            decimals: 18
        },
        infoURL: 'https://evnode.org',
        shortName: 'evnode',
        chainId: 4786,
        networkId: 4786,
        icon: 'evnode',
        explorers: [
            {
                name: 'Evnode Explorer Testnet',
                url: 'https://testnet.evscan.net',
                standard: 'EIP3091',
                icon: 'evnode'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWjBJXdpBzNHtakvEkjKXU5XMJn8JaUTNLfaUt8Y1swPE'
    },
    4801: {
        name: 'World Chain Sepolia Testnet',
        chain: 'ETH',
        rpc: [
            'https://worldchain-sepolia.g.alchemy.com/public',
            'https://4801.rpc.thirdweb.com',
            'https://worldchain-sepolia.gateway.tenderly.co',
            'wss://worldchain-sepolia.gateway.tenderly.co'
        ],
        faucets: [
            'https://www.alchemy.com/faucets/world-chain-sepolia',
            'https://console.optimism.io/faucet'
        ],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://world.org/world-chain',
        shortName: 'wcsep',
        chainId: 4801,
        networkId: 4801,
        slip44: 1,
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://worldchain-sepolia.bridge.alchemy.com' }]
        },
        explorers: [
            {
                name: 'etherscan',
                url: 'https://sepolia.worldscan.org',
                standard: 'EIP3091'
            },
            {
                name: 'blockscout',
                url: 'https://worldchain-sepolia.explorer.alchemy.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    4888: {
        name: 'BlackFort Exchange Network Testnet',
        chain: 'BXNT',
        rpc: ['https://rpc.blackfort.network/testnet/rpc'],
        faucets: [],
        nativeCurrency: {
            name: 'BlackFort Testnet Token',
            symbol: 'BXNT',
            decimals: 18
        },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://blackfort.com',
        shortName: 'BXNT',
        chainId: 4888,
        networkId: 4888,
        slip44: 1,
        icon: 'bxn',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet.blackfortscan.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPasA8xykRtJDivB2bcKDiRCUNWDPtfUTTKVAcaF2wVxC'
    },
    4893: {
        name: 'Globel Chain',
        chain: 'GC',
        icon: 'globelchain',
        rpc: ['https://rpc.gcscan.io'],
        faucets: [],
        nativeCurrency: { name: 'Globel Chain', symbol: 'GC', decimals: 18 },
        infoURL: 'https://gcscan.io',
        shortName: 'GC',
        chainId: 4893,
        networkId: 4893,
        explorers: [
            { name: 'blockscout', url: 'https://gcscan.io', standard: 'none' }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPRHDsVNpRZ72GoQgDbpa3R4wKENmrXCRNuYJkxocFRDb'
    },
    4913: {
        name: 'OEV Network',
        chain: 'oev-network',
        rpc: [
            'https://oev.rpc.api3.org',
            'https://oev-network.calderachain.xyz/http'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://api3.org/oev/',
        shortName: 'oev-network',
        chainId: 4913,
        networkId: 4913,
        icon: 'oev-network',
        explorers: [
            {
                name: 'OEV Network Explorer',
                url: 'https://oev.explorer.api3.org',
                standard: 'EIP3091'
            },
            {
                name: 'OEV Network Caldera Explorer',
                url: 'https://oev-network.calderaexplorer.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreicwebttrkbqxtiqduye67sgg54isk3psoll5huizyldcpfkxo63hi'
    },
    4918: {
        name: 'Venidium Testnet',
        chain: 'XVM',
        rpc: ['https://rpc-evm-testnet.venidium.io'],
        faucets: [],
        nativeCurrency: { name: 'Venidium', symbol: 'XVM', decimals: 18 },
        infoURL: 'https://venidium.io',
        shortName: 'txvm',
        chainId: 4918,
        networkId: 4918,
        slip44: 1,
        explorers: [
            {
                name: 'Venidium EVM Testnet Explorer',
                url: 'https://evm-testnet.venidiumexplorer.com',
                standard: 'EIP3091'
            }
        ]
    },
    4919: {
        name: 'Venidium Mainnet',
        chain: 'XVM',
        icon: 'venidium',
        rpc: ['https://rpc.venidium.io'],
        faucets: [],
        nativeCurrency: { name: 'Venidium', symbol: 'XVM', decimals: 18 },
        infoURL: 'https://venidium.io',
        shortName: 'xvm',
        chainId: 4919,
        networkId: 4919,
        explorers: [
            {
                name: 'Venidium Explorer',
                url: 'https://evm.venidiumexplorer.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiaplwlym5g27jm4mjhotfqq6al2cxp3fnkmzdusqjg7wnipq5wn2e'
    },
    4999: {
        name: 'BlackFort Exchange Network Deprecated',
        chain: 'BXNdpr',
        rpc: [
            'https://mainnet.blackfort.network/rpc',
            'https://mainnet-1.blackfort.network/rpc',
            'https://mainnet-2.blackfort.network/rpc',
            'https://mainnet-3.blackfort.network/rpc'
        ],
        faucets: [],
        nativeCurrency: { name: 'BlackFort Token', symbol: 'BXNdpr', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://blackfort.exchange',
        shortName: 'BXNdpr',
        chainId: 4999,
        networkId: 4999,
        icon: 'bxn',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.blackfort.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        status: 'deprecated',
        iconURL: 'https://ipfs.io/ipfs/QmPasA8xykRtJDivB2bcKDiRCUNWDPtfUTTKVAcaF2wVxC'
    },
    5000: {
        name: 'Mantle',
        chain: 'ETH',
        icon: 'mantle',
        rpc: [
            'https://rpc.mantle.xyz',
            'https://mantle-rpc.publicnode.com',
            'wss://mantle-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Mantle', symbol: 'MNT', decimals: 18 },
        infoURL: 'https://mantle.xyz',
        shortName: 'mantle',
        chainId: 5000,
        networkId: 5000,
        explorers: [
            {
                name: 'mantlescan',
                url: 'https://mantlescan.xyz',
                standard: 'EIP3091'
            },
            {
                name: 'Mantle Explorer',
                url: 'https://explorer.mantle.xyz',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.mantle.xyz' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmYddHh5zdceSsBU7uGfQvEHg6UUtAFbzQBBaePS4whx7o'
    },
    5001: {
        name: 'Mantle Testnet',
        chain: 'ETH',
        rpc: ['https://rpc.testnet.mantle.xyz'],
        faucets: ['https://faucet.testnet.mantle.xyz'],
        nativeCurrency: { name: 'Testnet Mantle', symbol: 'MNT', decimals: 18 },
        infoURL: 'https://mantle.xyz',
        shortName: 'mantle-testnet',
        chainId: 5001,
        networkId: 5001,
        slip44: 1,
        explorers: [
            {
                name: 'Mantle Testnet Explorer',
                url: 'https://explorer.testnet.mantle.xyz',
                standard: 'EIP3091'
            }
        ]
    },
    5002: {
        name: 'Treasurenet Mainnet Alpha',
        chain: 'Treasurenet Mainnet Alpha',
        icon: 'treasurenet',
        rpc: [
            'https://node0.treasurenet.io',
            'https://node1.treasurenet.io',
            'https://node2.treasurenet.io',
            'https://node3.treasurenet.io'
        ],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: { name: 'UNIT', symbol: 'UNIT', decimals: 18 },
        infoURL: 'https://www.treasurenet.io',
        shortName: 'treasurenet',
        chainId: 5002,
        networkId: 5002,
        explorers: [
            {
                name: 'Treasurenet EVM BlockExplorer',
                url: 'https://evmexplorer.treasurenet.io',
                icon: 'treasurenet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTcNX8ukHkXiVfVah1W8Sed3vtGN95Sq2QSimfLuHva6B'
    },
    5003: {
        name: 'Mantle Sepolia Testnet',
        chain: 'ETH',
        rpc: ['https://rpc.sepolia.mantle.xyz'],
        faucets: ['https://faucet.sepolia.mantle.xyz'],
        nativeCurrency: { name: 'Sepolia Mantle', symbol: 'MNT', decimals: 18 },
        infoURL: 'https://mantle.xyz',
        shortName: 'mnt-sep',
        chainId: 5003,
        networkId: 5003,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.sepolia.mantle.xyz',
                standard: 'EIP3091'
            }
        ]
    },
    5005: {
        name: 'Treasurenet Testnet',
        chain: 'Treasurenet Testnet',
        icon: 'treasurenet',
        rpc: [
            'https://node0.testnet.treasurenet.io',
            'https://node1.testnet.treasurenet.io',
            'https://node2.testnet.treasurenet.io',
            'https://node3.testnet.treasurenet.io'
        ],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: { name: 'UNIT', symbol: 'UNIT', decimals: 18 },
        infoURL: 'https://www.testnet.treasurenet.io',
        shortName: 'tntest',
        chainId: 5005,
        networkId: 5005,
        slip44: 1,
        explorers: [
            {
                name: 'Treasurenet EVM BlockExplorer',
                url: 'https://evmexplorer.testnet.treasurenet.io',
                icon: 'treasurenet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTcNX8ukHkXiVfVah1W8Sed3vtGN95Sq2QSimfLuHva6B'
    },
    5039: {
        name: 'ONIGIRI Test Subnet',
        chain: 'ONIGIRI',
        rpc: ['https://subnets.avax.network/onigiri/testnet/rpc'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'ONIGIRI', symbol: 'ONGR', decimals: 18 },
        infoURL: 'https://www.ongr.org/',
        shortName: 'onigiritest',
        chainId: 5039,
        networkId: 5039,
        icon: 'onigiri',
        explorers: [
            {
                name: 'ONIGIRI Explorer',
                url: 'https://subnets-test.avax.network/onigiri',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreieenivbkpmaxslvvvaybi53hynnarng4ek37xhtf5euvsyunvhbai'
    },
    5040: {
        name: 'ONIGIRI Subnet',
        chain: 'ONIGIRI',
        rpc: ['https://subnets.avax.network/onigiri/mainnet/rpc'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'ONIGIRI', symbol: 'ONGR', decimals: 18 },
        infoURL: 'https://www.ongr.org/',
        shortName: 'onigiri',
        chainId: 5040,
        networkId: 5040,
        icon: 'onigiri',
        explorers: [
            {
                name: 'ONIGIRI Explorer',
                url: 'https://subnets.avax.network/onigiri',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreieenivbkpmaxslvvvaybi53hynnarng4ek37xhtf5euvsyunvhbai'
    },
    5050: {
        name: 'Skate Mainnet',
        chain: 'ETH',
        rpc: ['https://rpc.skatechain.org/'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://www.skatechain.org/',
        shortName: 'skate',
        chainId: 5050,
        networkId: 5050,
        icon: 'skate',
        explorers: [
            {
                name: 'Skate Explorer',
                url: 'https://scan.skatechain.org',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        parent: { type: 'L2', chain: 'eip155-1', bridges: [{ url: '' }] },
        iconURL: 'https://ipfs.io/ipfs/QmdofX1W8QFt4TSDaq2wyPvYuUba9LabgD1MYcn3Hezu8h'
    },
    5051: {
        name: 'Nollie Skatechain Testnet',
        chain: 'Skatechain',
        rpc: ['https://nollie-rpc.skatechain.org/'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: '',
        shortName: 'nollie-testnet',
        chainId: 5051,
        networkId: 5051,
        icon: 'nollie',
        explorers: [
            {
                name: 'Nollie Skate Chain Testnet Explorer',
                url: 'https://nolliescan.skatechain.org',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmdofX1W8QFt4TSDaq2wyPvYuUba9LabgD1MYcn3Hezu8h'
    },
    5080: {
        name: 'Pione Zero',
        chain: 'PZO',
        icon: 'pzo',
        rpc: ['https://rpc.zeroscan.org'],
        faucets: ['https://dex.pionechain.com/testnet/faucet/'],
        nativeCurrency: { name: 'Pione Zero', symbol: 'PZO', decimals: 18 },
        infoURL: 'https://pionechain.com',
        shortName: 'pzo',
        chainId: 5080,
        networkId: 5080,
        explorers: [
            {
                name: 'Pione Zero Explorer',
                url: 'https://zeroscan.org',
                standard: 'EIP3091'
            },
            {
                name: 'Pione Zero Explorer',
                url: 'https://zero.pionescan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigml24fbobs5lalh4l54xwtccey7dqxkbmt4jkbkq3morydgjfy2a'
    },
    5090: {
        name: 'Pione Chain Mainnet',
        chain: 'PIO',
        icon: 'pio',
        rpc: ['https://rpc.pionescan.com'],
        faucets: [],
        nativeCurrency: { name: 'Pione', symbol: 'PIO', decimals: 18 },
        infoURL: 'https://pionechain.com',
        shortName: 'pio',
        chainId: 5090,
        networkId: 5090,
        explorers: [
            {
                name: 'Pione Chain Explorer',
                url: 'https://pionescan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibbs2nlmnd7vrur6fyfjl4mqqjcjnjbtwrk35juma6zoxtn2l3xce'
    },
    5100: {
        name: 'Syndicate Testnet',
        title: 'Syndicate Testnet',
        chain: 'Syndicate',
        rpc: ['https://rpc-testnet.syndicate.io'],
        faucets: [],
        nativeCurrency: { name: 'S-Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://syndicate.io',
        shortName: 'syndicate-chain-testnet',
        chainId: 5100,
        networkId: 5100,
        status: 'incubating',
        icon: 'syndicate',
        iconURL: 'https://ipfs.io/ipfs/QmeSvQcD3XvLFAiMLoQSPbGK9JxVfbCWPBUTMLhhhzYPqX'
    },
    5101: {
        name: 'Syndicate Frame Chain',
        title: 'Syndicate Frame Chain',
        chain: 'Syndicate Frame',
        rpc: ['https://rpc-frame.syndicate.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://syndicate.io',
        shortName: 'syndicate-chain-frame',
        chainId: 5101,
        networkId: 5101,
        status: 'incubating',
        icon: 'syndicate',
        iconURL: 'https://ipfs.io/ipfs/QmeSvQcD3XvLFAiMLoQSPbGK9JxVfbCWPBUTMLhhhzYPqX'
    },
    5102: {
        name: 'SIC Testnet',
        chain: 'SIC Testnet',
        rpc: ['https://rpc-sic-testnet-zvr7tlkzsi.t.conduit.xyz'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.fwb.help/',
        shortName: 'sic-testnet',
        chainId: 5102,
        networkId: 5102,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorerl2new-sic-testnet-zvr7tlkzsi.t.conduit.xyz',
                standard: 'EIP3091'
            }
        ]
    },
    5103: {
        name: 'Coordinape Testnet',
        chain: 'Coordinape Testnet',
        rpc: ['https://rpc-coordinape-testnet-vs9se3oc4v.t.conduit.xyz'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://coordinape.com/',
        shortName: 'coordinape-testnet',
        chainId: 5103,
        networkId: 5103
    },
    5104: {
        name: 'Charmverse Testnet',
        chain: 'Charmverse Testnet',
        rpc: ['https://rpc-charmverse-testnet-g6blnaebes.t.conduit.xyz'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://charmverse.io/',
        shortName: 'charmverse-testnet',
        chainId: 5104,
        networkId: 5104
    },
    5105: {
        name: 'Superloyalty Testnet',
        chain: 'Superloyalty Testnet',
        rpc: ['https://rpc-superloyalty-testnet-1m5gwjbsv1.t.conduit.xyz'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.superloyal.com/',
        shortName: 'superloyalty-testnet',
        chainId: 5105,
        networkId: 5105
    },
    5106: {
        name: 'Azra Testnet',
        chain: 'Azra Testnet',
        rpc: ['https://rpc-azra-testnet-6hz86owb1n.t.conduit.xyz'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://azragames.com',
        shortName: 'azra-testnet',
        chainId: 5106,
        networkId: 5106,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorerl2new-azra-testnet-6hz86owb1n.t.conduit.xyz',
                standard: 'EIP3091'
            }
        ]
    },
    5112: {
        name: 'Ham',
        chain: 'Ham',
        rpc: ['https://rpc.ham.fun'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://ham.fun',
        shortName: 'ham',
        chainId: 5112,
        networkId: 5112,
        icon: 'ham',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.ham.fun',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmcbYVenTET9HBS7vs7SGv1MNqnRscAKVF5kaRVHaVCfvs'
    },
    5115: {
        name: 'Citrea Testnet',
        chain: 'Citrea',
        rpc: ['https://rpc.testnet.citrea.xyz'],
        faucets: ['https://citrea.xyz/faucet'],
        nativeCurrency: { name: 'Citrea BTC', symbol: 'cBTC', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://citrea.xyz',
        shortName: 'citrea-testnet',
        chainId: 5115,
        networkId: 5115,
        icon: 'citrea',
        explorers: [
            {
                name: 'Citrea Testnet Explorer',
                url: 'https://explorer.testnet.citrea.xyz',
                icon: 'citrea',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTfgH4X7ZWkHprKgjUZ7SDcCGtS5f2CBuaTEtQYMsydmJ'
    },
    5124: {
        name: 'Seismic devnet',
        chain: 'Seismic',
        rpc: ['https://node-2.seismicdev.net/rpc'],
        faucets: ['https://faucet-2.seismicdev.net/'],
        nativeCurrency: { name: 'Seismic Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://seismic.systems',
        shortName: 'seismic-devnet',
        chainId: 5124,
        networkId: 5124,
        explorers: [
            {
                name: 'Seismic Devnet Explorer',
                url: 'https://explorer-2.seismicdev.net',
                standard: 'EIP3091'
            }
        ]
    },
    5151: {
        name: 'Moca Chain Testnet',
        chain: 'Moca Chain',
        rpc: ['https://testnet-rpc.mechain.tech'],
        faucets: ['https://faucet.mechain.tech'],
        nativeCurrency: { name: 'MOCA', symbol: 'MOCA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://mechain.tech',
        shortName: 'MOCA',
        chainId: 5151,
        networkId: 5151,
        icon: 'moca',
        explorers: [
            {
                name: 'Moca Chain Scan',
                url: 'https://testnet-scan.mechain.tech',
                icon: 'moca',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNqJnEL2Aj7pLKYnJwRnWGZFwUWTsvfZm8CofA8ztvD6J'
    },
    5165: {
        name: 'Bahamut',
        title: 'Bahamut mainnet',
        chain: 'Bahamut',
        icon: 'bahamut',
        rpc: [
            'https://rpc1.bahamut.io',
            'https://rpc2.bahamut.io',
            'wss://ws1.sahara.bahamutchain.com',
            'wss://ws2.sahara.bahamutchain.com',
            'https://bahamut-rpc.publicnode.com',
            'wss://bahamut-rpc.publicnode.com'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'FTN', symbol: 'FTN', decimals: 18 },
        shortName: 'ftn',
        infoURL: 'https://bahamut.io',
        chainId: 5165,
        networkId: 5165,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://ftnscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSemioP83RXnDWwTZbet8VpwJxcFRboX4B3pcdhLZGodP'
    },
    5169: {
        name: 'Smart Layer Network',
        chain: 'SLN',
        rpc: ['https://rpc.main.smartlayer.network'],
        faucets: [],
        nativeCurrency: { name: 'Service Unit Token', symbol: 'SU', decimals: 18 },
        infoURL: 'https://www.smartlayer.network/',
        shortName: 'SLN',
        chainId: 5169,
        networkId: 5169,
        explorers: [
            {
                name: 'SLN Mainnet Explorer',
                url: 'https://explorer.main.smartlayer.network',
                standard: 'EIP3091'
            }
        ]
    },
    5177: {
        name: 'TLChain Network Mainnet',
        chain: 'TLC',
        icon: 'tlc',
        rpc: ['https://mainnet-rpc.tlxscan.com/'],
        faucets: [],
        nativeCurrency: { name: 'TLChain Network', symbol: 'TLC', decimals: 18 },
        infoURL: 'https://tlchain.network/',
        shortName: 'tlc',
        chainId: 5177,
        networkId: 5177,
        explorers: [
            {
                name: 'TLChain Explorer',
                url: 'https://explorer.tlchain.network',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaR5TsgnWSjLys6wGaciKUbc5qYL3Es4jtgQcosVqDWR3'
    },
    5197: {
        name: 'EraSwap Mainnet',
        chain: 'ESN',
        icon: 'eraswap',
        rpc: [
            'https://mainnet.eraswap.network',
            'https://rpc-mumbai.mainnet.eraswap.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'EraSwap', symbol: 'ES', decimals: 18 },
        infoURL: 'https://eraswap.info/',
        shortName: 'es',
        chainId: 5197,
        networkId: 5197,
        iconURL: 'https://ipfs.io/ipfs/QmV1wZ1RVXeD7216aiVBpLkbBBHWNuoTvcSzpVQsqi2uaH'
    },
    5234: {
        name: 'Humanode Mainnet',
        chain: 'HMND',
        rpc: ['https://explorer-rpc-http.mainnet.stages.humanode.io'],
        faucets: [],
        nativeCurrency: { name: 'eHMND', symbol: 'eHMND', decimals: 18 },
        infoURL: 'https://humanode.io',
        shortName: 'hmnd',
        chainId: 5234,
        networkId: 5234,
        icon: 'humanode',
        explorers: [
            {
                name: 'Subscan',
                url: 'https://humanode.subscan.io',
                standard: 'EIP3091',
                icon: 'subscan'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeihuskzfwqogwvutaxil6sztmvpiavzbrzwjwpn6w2i4j3jysbybra'
    },
    5290: {
        name: 'Firechain Mainnet Old',
        chain: 'FIRE',
        icon: 'firechain',
        rpc: ['https://mainnet.rpc1.thefirechain.com'],
        faucets: [],
        nativeCurrency: { name: 'Firechain', symbol: 'FIRE', decimals: 18 },
        infoURL: 'https://thefirechain.com',
        shortName: '_old_fire',
        chainId: 5290,
        networkId: 5290,
        explorers: [],
        status: 'deprecated',
        iconURL: 'https://ipfs.io/ipfs/QmYjuztyURb3Fc6ZTLgCbwQa64CcVoigF5j9cafzuSbqgf'
    },
    5315: {
        name: 'Uzmi Network Mainnet',
        chain: 'UZMI',
        rpc: ['https://network.uzmigames.com.br/'],
        faucets: [],
        nativeCurrency: { name: 'UZMI', symbol: 'UZMI', decimals: 18 },
        infoURL: 'https://uzmigames.com.br/',
        shortName: 'UZMI',
        chainId: 5315,
        networkId: 5315
    },
    5317: {
        name: 'OpTrust Testnet',
        chain: 'OpTrust',
        rpc: ['https://rpctest.optrust.io'],
        faucets: [],
        nativeCurrency: { name: 'TestBSC', symbol: 'tBNB', decimals: 18 },
        infoURL: 'https://optrust.io',
        shortName: 'toptrust',
        chainId: 5317,
        networkId: 5317,
        icon: 'optrust',
        explorers: [
            {
                name: 'OpTrust Testnet explorer',
                url: 'https://scantest.optrust.io',
                icon: 'optrust',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYktPMo4tdQhMA9nRJBVckjzHcFLbpHbTVNSpGUUPEP8J'
    },
    5321: {
        name: 'ITX Testnet',
        chain: 'ITX',
        rpc: ['https://rpc.testnet.itxchain.com'],
        faucets: [],
        nativeCurrency: { name: 'ITX', symbol: 'ITX', decimals: 18 },
        infoURL: 'https://explorer.testnet.itxchain.com',
        shortName: 'itx-testnet',
        chainId: 5321,
        networkId: 5321,
        explorers: [
            {
                name: 'ITX Testnet Explorer (Blockscout)',
                url: 'https://explorer.testnet.itxchain.com',
                standard: 'EIP3091'
            }
        ]
    },
    5330: {
        name: 'Superseed',
        chain: 'ETH',
        rpc: ['https://mainnet.superseed.xyz', 'wss://mainnet.superseed.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.superseed.xyz',
        shortName: 'sseed',
        chainId: 5330,
        networkId: 5330,
        slip44: 1,
        icon: 'superseed',
        explorers: [
            {
                name: 'seedscout',
                url: 'https://explorer.superseed.xyz',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmVa1MhJhixPzFfvhggQWg8hLtS77vg7QFvQtQGrXbVYSg'
    },
    5333: {
        name: 'Netsbo',
        chain: 'NETSBO',
        rpc: ['https://rpc1.netsbo.io', 'https://rpc2.netsbo.io'],
        faucets: [],
        nativeCurrency: { name: 'Netsbo', symbol: 'NETS', decimals: 18 },
        infoURL: 'https://netsbo.io',
        shortName: 'nets',
        chainId: 5333,
        networkId: 5333,
        icon: 'netsbo',
        explorers: [
            {
                name: 'netsbo',
                url: 'https://explorer.netsbo.io',
                icon: 'netsbo',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfGRakPDaDGTq5yCXifGmWZBSJotYfeEVamWi8Mv4HFWt'
    },
    5353: {
        name: 'Tritanium Testnet',
        chain: 'TRITANIUM',
        rpc: [
            'https://nodetestnet-station-one.tritanium.network/',
            'https://nodetestnet-station-two.tritanium.network/'
        ],
        faucets: ['https://faucet.tritanium.network'],
        nativeCurrency: {
            name: 'Tritanium Native Token',
            symbol: 'tTRN',
            decimals: 18
        },
        infoURL: 'https://tritanium.network',
        shortName: 'ttrn',
        chainId: 5353,
        networkId: 5353,
        slip44: 1,
        icon: 'tritanium',
        explorers: [
            {
                name: 'TRITANIUM Testnet Explorer',
                icon: 'tritanium',
                url: 'https://testnet.tritanium.network',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRm6gcEPJmU9a86zrmyP7FALTN4Toz9HrnrL2Kwg6FPeh'
    },
    5371: {
        name: 'Settlus',
        chain: 'ETH',
        rpc: ['https://settlus-mainnet.g.alchemy.com/public'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://settlus.org',
        shortName: 'setl',
        chainId: 5371,
        networkId: 5371,
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://settlus-mainnet.bridge.alchemy.com/' }]
        },
        explorers: [
            {
                name: 'Settlus Mainnet Explorer',
                url: 'https://mainnet.settlus.network',
                standard: 'EIP3091'
            }
        ],
        status: 'active'
    },
    5372: {
        name: 'Settlus Testnet',
        chain: 'Settlus',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Setl', symbol: 'SETL', decimals: 18 },
        infoURL: 'https://settlus.org',
        shortName: 'settlus-testnet',
        chainId: 5372,
        networkId: 5372,
        status: 'deprecated'
    },
    5373: {
        name: 'Settlus Sepolia Testnet',
        chain: 'ETH',
        rpc: ['https://settlus-septestnet.g.alchemy.com/public'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://settlus.org',
        shortName: 'setl-sepolia',
        chainId: 5373,
        networkId: 5373,
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://settlus-sep-testnet.bridge.alchemy.com/' }]
        },
        explorers: [
            {
                name: 'Settlus Sepolia Testnet Explorer',
                url: 'https://sepolia.settlus.network',
                standard: 'EIP3091'
            }
        ],
        status: 'active'
    },
    5424: {
        name: 'edeXa Mainnet',
        chain: 'edeXa',
        rpc: ['https://rpc.edexa.network', 'https://rpc.edexa.com'],
        faucets: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'edeXa', symbol: 'EDX', decimals: 18 },
        infoURL: 'https://edexa.network/',
        shortName: 'edx',
        chainId: 5424,
        networkId: 5424,
        slip44: 1,
        icon: 'edexa',
        explorers: [
            {
                name: 'edexa-mainnet-explorer',
                url: 'https://explorer.edexa.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSgvmLpRsCiu2ySqyceA5xN4nwi7URJRNEZLffwEKXdoR'
    },
    5433: {
        name: 'Inertia Scan',
        chain: 'IRTA',
        icon: 'inertiascan',
        rpc: ['https://rpc.inertiascan.com'],
        faucets: [],
        nativeCurrency: { name: 'Inertia', symbol: 'IRTA', decimals: 18 },
        infoURL: 'https://inertiascan.com',
        shortName: 'IRTA',
        chainId: 5433,
        networkId: 5433,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://inertiascan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbgWUbQMgc4ASEjN7HcNU7yfgPahYaTeogNLfzvWmcYEJ'
    },
    5439: {
        name: 'Egochain',
        chainId: 5439,
        shortName: 'egax',
        chain: 'EGAX',
        networkId: 5439,
        nativeCurrency: { name: 'EGAX', symbol: 'EGAX', decimals: 18 },
        rpc: ['https://mainnet.egochain.org'],
        faucets: [],
        infoURL: 'https://docs.egochain.org/',
        explorers: [
            { name: 'egoscan', url: 'https://egoscan.io', standard: 'EIP3091' }
        ]
    },
    5464: {
        name: 'Saga',
        chain: 'SAGA',
        rpc: ['http://sagaevm-5464-1.jsonrpc.sagarpc.io'],
        faucets: [],
        nativeCurrency: { name: 'gas', symbol: 'GAS', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.saga.xyz',
        shortName: 'saga',
        chainId: 5464,
        networkId: 5464,
        icon: 'saga',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://sagaevm-5464-1.sagaexplorer.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreieuaf4anwbg4s6ptuxszdn5e6q4eodbae2dmyglb4v2o7xbbxepte'
    },
    5511: {
        name: 'PointPay Mainnet',
        chain: 'pointpay',
        rpc: ['https://rpc-mainnet.pointpay.io'],
        faucets: [],
        nativeCurrency: { name: 'PointPay', symbol: 'PXP', decimals: 18 },
        infoURL: 'https://pointpay.io',
        shortName: 'PP',
        chainId: 5511,
        networkId: 5511,
        icon: 'pointpay',
        explorers: [
            {
                name: 'PointPay Mainnet Explorer',
                url: 'https://explorer.pointpay.io',
                icon: 'pointpay',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPVsJrzshxQMVDSqn45aiaNJcFY8zWU27fg8vq5Mht4z7'
    },
    5522: {
        name: 'VEX EVM TESTNET',
        chain: 'vex',
        icon: 'vex',
        rpc: ['https://testnet.vexascan.com/evmapi'],
        faucets: ['https://t.me/vexfaucetbot'],
        nativeCurrency: { name: 'VEX EVM TESTNET', symbol: 'VEX', decimals: 18 },
        infoURL: 'https://vexanium.com',
        shortName: 'VEX',
        chainId: 5522,
        networkId: 5522,
        slip44: 1,
        explorers: [
            {
                name: 'Vexascan-EVM-TestNet',
                url: 'https://testnet.vexascan.com/evmexplorer',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcZiEAGFYEEax1uxYnDUh8X5YBvZqMi9K92yZoq4o2zeM'
    },
    5545: {
        name: 'DuckChain Mainnet',
        title: 'DuckChain Mainnet',
        chain: 'DuckChain',
        icon: 'duckchain',
        rpc: ['https://rpc.duckchain.io', 'https://rpc-hk.duckchain.io'],
        faucets: [],
        nativeCurrency: { name: 'TON', symbol: 'TON', decimals: 18 },
        infoURL: 'https://duckchain.io',
        shortName: 'Duck-Chain-Mainnet',
        chainId: 5545,
        networkId: 5545,
        iconURL: 'https://ipfs.io/ipfs/QmTJwaQcF6widssKvbNgdM4AVaddiTqFM2j4n6x17Sp3FL'
    },
    5551: {
        name: 'Nahmii 2 Mainnet',
        chain: 'Nahmii',
        rpc: ['https://l2.nahmii.io'],
        status: 'active',
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://nahmii.io',
        shortName: 'Nahmii',
        chainId: 5551,
        networkId: 5551,
        icon: 'nahmii',
        explorers: [
            {
                name: 'Nahmii 2 Mainnet Explorer',
                url: 'https://explorer.n2.nahmii.io',
                icon: 'nahmii',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://n2.bridge.nahmii.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmZhKXgoGpzvthr2eh8ZNgT75YvMtEBegdELAaMPPzf5QT'
    },
    5553: {
        name: 'Nahmii 2 Testnet',
        chain: 'Nahmii',
        rpc: ['https://l2.testnet.nahmii.io'],
        status: 'deprecated',
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://nahmii.io',
        shortName: 'NahmiiTestnet',
        chainId: 5553,
        networkId: 5553,
        slip44: 1,
        icon: 'nahmii',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.testnet.nahmii.io',
                icon: 'nahmii',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-3',
            bridges: [{ url: 'https://bridge.nahmii.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmZhKXgoGpzvthr2eh8ZNgT75YvMtEBegdELAaMPPzf5QT'
    },
    5555: {
        name: 'Chain Verse Mainnet',
        chain: 'CVERSE',
        icon: 'chain_verse',
        rpc: ['https://rpc.chainverse.info'],
        faucets: [],
        nativeCurrency: { name: 'Oasys', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://chainverse.info',
        shortName: 'cverse',
        chainId: 5555,
        networkId: 5555,
        explorers: [
            {
                name: 'Chain Verse Explorer',
                url: 'https://explorer.chainverse.info',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQyJt28h4wN3QHPXUQJQYQqGiFUD77han3zibZPzHbitk'
    },
    5611: {
        name: 'opBNB Testnet',
        chain: 'opBNB',
        icon: 'bnbchain',
        rpc: [
            'https://opbnb-testnet-rpc.bnbchain.org',
            'https://opbnb-testnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3',
            'wss://opbnb-testnet.nodereal.io/ws/v1/64a9df0874fb4a93b9d0a3849de012d3',
            'https://opbnb-testnet.nodereal.io/v1/e9a36765eb8a40b9bd12e680a1fd2bc5',
            'wss://opbnb-testnet.nodereal.io/ws/v1/e9a36765eb8a40b9bd12e680a1fd2bc5',
            'https://opbnb-testnet-rpc.publicnode.com',
            'wss://opbnb-testnet-rpc.publicnode.com'
        ],
        faucets: ['https://testnet.bnbchain.org/faucet-smart'],
        nativeCurrency: {
            name: 'BNB Chain Native Token',
            symbol: 'tBNB',
            decimals: 18
        },
        infoURL: 'https://opbnb.bnbchain.org/en',
        shortName: 'obnbt',
        chainId: 5611,
        networkId: 5611,
        slip44: 1,
        explorers: [
            {
                name: 'bscscan-opbnb-testnet',
                url: 'https://opbnb-testnet.bscscan.com',
                standard: 'EIP3091'
            },
            {
                name: 'opbnbscan',
                url: 'https://opbnbscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeib75gwytvblyvjpfminitr3i6mpat3a624udfsqsl5nysf5vuuvie'
    },
    5615: {
        name: 'Arcturus Testneet',
        chain: 'Arcturus',
        rpc: ['https://rpc-testnet.arcturuschain.io/'],
        faucets: ['https://faucet.arcturuschain.io'],
        nativeCurrency: { name: 'tARC', symbol: 'tARC', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://arcturuschain.io',
        shortName: 'arcturus-testnet',
        chainId: 5615,
        networkId: 5615,
        explorers: [
            {
                name: 'explorer-arcturus-testnet',
                url: 'https://testnet.arcscan.net',
                standard: 'EIP3091'
            }
        ]
    },
    5616: {
        name: 'Arcturus Chain Testnet',
        chain: 'ARCTURUS',
        rpc: ['http://185.99.196.3:8545'],
        faucets: [],
        nativeCurrency: { name: 'Test Arct', symbol: 'tARCT', decimals: 18 },
        infoURL: 'https://arcturuschain.io',
        shortName: 'ARCT',
        chainId: 5616,
        networkId: 5616,
        slip44: 1
    },
    5656: {
        name: 'QIE Blockchain',
        chain: 'QIE',
        icon: 'qie',
        rpc: [
            'https://rpc-main1.qiblockchain.online/',
            'https://rpc-main2.qiblockchain.online/'
        ],
        faucets: [],
        nativeCurrency: { name: 'QIE Blockchain', symbol: 'QIE', decimals: 18 },
        infoURL: 'https://qiblockchain.online/',
        shortName: 'QIE',
        chainId: 5656,
        networkId: 5656,
        explorers: [
            {
                name: 'QIE Explorer',
                url: 'https://mainnet.qiblockchain.online',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRoNxCti6cHrPgZ48YQVSMg9g6ympfXuV8kGQJXrbbmed'
    },
    5675: {
        name: 'Filenova Testnet',
        chain: 'Filenova',
        rpc: ['https://rpctest.filenova.org'],
        faucets: [],
        nativeCurrency: { name: 'Test Filecoin', symbol: 'tFIL', decimals: 18 },
        infoURL: 'https://filenova.org',
        shortName: 'tfilenova',
        chainId: 5675,
        networkId: 5675,
        icon: 'filenova',
        explorers: [
            {
                name: 'filenova testnet explorer',
                url: 'https://scantest.filenova.org',
                icon: 'filenova',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmc4KSKiAChhtN7ZNE5gvkLTRbvtLreKU9xaQFG8BKM8RE'
    },
    5678: {
        name: 'Tanssi Demo',
        chain: 'TANGO',
        rpc: [
            'https://dancebox-3001.tanssi-api.network',
            'wss://dancebox-3001.tanssi-api.network'
        ],
        faucets: ['https://apps.tanssi.network/demo'],
        nativeCurrency: { name: 'TANGO', symbol: 'TANGO', decimals: 18 },
        infoURL: 'https://docs.tanssi.network/builders/tanssi-network/networks/dancebox/demo-evm-containerchain',
        shortName: 'tango',
        chainId: 5678,
        networkId: 5678,
        explorers: [
            {
                name: 'BlockScout',
                url: 'https://fra-dancebox-3001-bs.a.dancebox.tanssi.network',
                standard: 'EIP3091'
            }
        ]
    },
    5700: {
        name: 'Syscoin Tanenbaum Testnet',
        chain: 'SYS',
        rpc: [
            'https://rpc.tanenbaum.io',
            'wss://rpc.tanenbaum.io/wss',
            'https://syscoin-tanenbaum-evm.publicnode.com',
            'wss://syscoin-tanenbaum-evm.publicnode.com'
        ],
        faucets: ['https://faucet.tanenbaum.io'],
        nativeCurrency: { name: 'Testnet Syscoin', symbol: 'tSYS', decimals: 18 },
        infoURL: 'https://syscoin.org',
        shortName: 'tsys',
        chainId: 5700,
        networkId: 5700,
        slip44: 1,
        explorers: [
            {
                name: 'Syscoin Testnet Block Explorer',
                url: 'https://explorer.tanenbaum.io',
                standard: 'EIP3091'
            }
        ]
    },
    5729: {
        name: 'Hika Network Testnet',
        title: 'Hika Network Testnet',
        chain: 'HIK',
        icon: 'hik',
        rpc: ['https://rpc-testnet.hika.network/'],
        faucets: [],
        nativeCurrency: { name: 'Hik Token', symbol: 'HIK', decimals: 18 },
        infoURL: 'https://hika.network/',
        shortName: 'hik',
        chainId: 5729,
        networkId: 5729,
        explorers: [
            {
                name: 'Hika Network Testnet Explorer',
                url: 'https://scan-testnet.hika.network',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW44FPm3CMM2JDs8BQxLNvUtykkUtrGkQkQsUDJSi3Gmp'
    },
    5758: {
        name: 'SatoshiChain Testnet',
        chain: 'SATS',
        icon: 'satoshichain',
        rpc: ['https://testnet-rpc.satoshichain.io'],
        faucets: ['https://faucet.satoshichain.io'],
        nativeCurrency: { name: 'SatoshiChain Coin', symbol: 'SATS', decimals: 18 },
        infoURL: 'https://satoshichain.net',
        shortName: 'satst',
        chainId: 5758,
        networkId: 5758,
        slip44: 1,
        explorers: [
            {
                name: 'SatoshiChain Testnet Explorer',
                url: 'https://testnet.satoshiscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRegpZQBW4o1imYNsW3d27MQjygBSU23Gf6JKje26nvs7'
    },
    5777: {
        name: 'Ganache',
        title: 'Ganache GUI Ethereum Testnet',
        chain: 'ETH',
        icon: 'ganache',
        rpc: ['https://127.0.0.1:7545'],
        faucets: [],
        nativeCurrency: { name: 'Ganache Test Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://trufflesuite.com/ganache/',
        shortName: 'ggui',
        chainId: 5777,
        networkId: 5777,
        slip44: 1,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/Qmc9N7V8CiLB4r7FEcG7GojqfiGGsRCZqcFWCahwMohbDW'
    },
    5845: {
        name: 'Tangle',
        chain: 'Tangle',
        rpc: ['https://rpc.tangle.tools', 'wss://rpc.tangle.tools'],
        faucets: [],
        nativeCurrency: { name: 'Tangle', symbol: 'TNT', decimals: 18 },
        infoURL: 'https://docs.tangle.tools',
        shortName: 'tangle',
        chainId: 5845,
        networkId: 5845,
        icon: 'tangle',
        explorers: [
            {
                name: 'Tangle EVM Explorer',
                url: 'https://explorer.tangle.tools',
                standard: 'EIP3091',
                icon: 'tangle'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbxMNBTeQgch8t9GpWdLiS2R3wPYCzVRaX5kCQ4o5QU3w'
    },
    5851: {
        name: 'Ontology Testnet',
        chain: 'Ontology',
        icon: 'ontology',
        rpc: [
            'http://polaris1.ont.io:20339',
            'http://polaris2.ont.io:20339',
            'http://polaris3.ont.io:20339',
            'http://polaris4.ont.io:20339',
            'https://polaris1.ont.io:10339',
            'https://polaris2.ont.io:10339',
            'https://polaris3.ont.io:10339',
            'https://polaris4.ont.io:10339'
        ],
        faucets: ['https://developer.ont.io/'],
        nativeCurrency: { name: 'ONG', symbol: 'ONG', decimals: 18 },
        infoURL: 'https://ont.io/',
        shortName: 'OntologyTestnet',
        chainId: 5851,
        networkId: 5851,
        slip44: 1,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer.ont.io/testnet',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigmvn6spvbiirtutowpq6jmetevbxoof5plzixjoerbeswy4htfb4'
    },
    5858: {
        name: 'Chang Chain Foundation Mainnet',
        chain: 'ChangChain',
        rpc: ['https://rpc.cthscan.com/'],
        faucets: [],
        nativeCurrency: {
            name: 'Chang Coin Thailand',
            symbol: 'CTH',
            decimals: 18
        },
        infoURL: 'https://changcoin.foundation/',
        shortName: 'ChangChain',
        chainId: 5858,
        networkId: 5858,
        icon: 'changchain',
        explorers: [
            {
                name: 'CTH Scan',
                url: 'https://cthscan.com',
                standard: 'EIP3091',
                icon: 'blockscout'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbEytMCh2xFr7q87HjthX4K2MKmjfHih2mqS42tqTZoMy'
    },
    5869: {
        name: 'Wegochain Rubidium Mainnet',
        chain: 'RBD',
        rpc: ['https://proxy.wegochain.io', 'http://wallet.wegochain.io:7764'],
        faucets: [],
        nativeCurrency: { name: 'Rubid', symbol: 'RBD', decimals: 18 },
        infoURL: 'https://www.wegochain.io',
        shortName: 'rbd',
        chainId: 5869,
        networkId: 5869,
        explorers: [
            {
                name: 'wegoscan2',
                url: 'https://scan2.wegochain.io',
                standard: 'EIP3091'
            }
        ]
    },
    6000: {
        name: 'BounceBit Testnet',
        chain: 'BounceBit',
        rpc: ['https://fullnode-testnet.bouncebitapi.com/'],
        faucets: [],
        nativeCurrency: { name: 'BounceBit', symbol: 'BB', decimals: 18 },
        infoURL: 'https://bouncebit.io',
        shortName: 'bouncebit-testnet',
        chainId: 6000,
        networkId: 6000,
        icon: 'bouncebit',
        explorers: [
            {
                name: 'BBScan Testnet Explorer',
                url: 'https://bbscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXry4fg4n371PCokLGKUMwmws1SoJb5giZM3EedeEQaZz'
    },
    6001: {
        name: 'BounceBit Mainnet',
        chain: 'BounceBit',
        rpc: ['https://fullnode-mainnet.bouncebitapi.com/'],
        faucets: [],
        nativeCurrency: { name: 'BounceBit', symbol: 'BB', decimals: 18 },
        infoURL: 'https://bouncebit.io',
        shortName: 'bouncebit-mainnet',
        chainId: 6001,
        networkId: 6001,
        icon: 'bouncebit',
        explorers: [
            {
                name: 'BBScan Mainnet Explorer',
                url: 'https://bbscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXry4fg4n371PCokLGKUMwmws1SoJb5giZM3EedeEQaZz'
    },
    6060: {
        name: 'BC Hyper Chain Testnet',
        chain: 'BC Hyper Chain',
        rpc: ['https://rpc.bchscan.io'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: {
            name: 'TEST VERSATIZE COIN',
            symbol: 'TVTCN',
            decimals: 18
        },
        infoURL: 'https://www.versatizecoin.com/',
        shortName: 'BCH',
        chainId: 6060,
        networkId: 6060,
        icon: 'bchyper',
        explorers: [
            {
                name: 'bcexplorer testnet',
                url: 'https://testnet.bchscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreia5iw3fygyim6ivv4lznrsak2x6e573vybexlnpxpcp775hcgmjyi'
    },
    6065: {
        name: 'Tres Testnet',
        chain: 'TresLeches',
        rpc: ['https://rpc-test.tresleches.finance/'],
        faucets: ['http://faucet.tresleches.finance:8080'],
        nativeCurrency: { name: 'TRES', symbol: 'TRES', decimals: 18 },
        infoURL: 'https://treschain.com',
        shortName: 'TRESTEST',
        chainId: 6065,
        networkId: 6065,
        slip44: 1,
        icon: 'tresleches',
        explorers: [
            {
                name: 'treslechesexplorer',
                url: 'https://explorer-test.tresleches.finance',
                icon: 'treslechesexplorer',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmS33ypsZ1Hx5LMMACaJaxePy9QNYMwu4D12niobExLK74'
    },
    6066: {
        name: 'Tres Mainnet',
        chain: 'TresLeches',
        rpc: ['https://rpc.tresleches.finance/', 'https://rpc.treschain.io/'],
        faucets: [],
        nativeCurrency: { name: 'TRES', symbol: 'TRES', decimals: 18 },
        infoURL: 'https://treschain.com',
        shortName: 'TRESMAIN',
        chainId: 6066,
        networkId: 6066,
        icon: 'tresleches',
        explorers: [
            {
                name: 'treslechesexplorer',
                url: 'https://explorer.tresleches.finance',
                icon: 'treslechesexplorer',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmS33ypsZ1Hx5LMMACaJaxePy9QNYMwu4D12niobExLK74'
    },
    6102: {
        name: 'Cascadia Testnet',
        chain: 'Cascadia',
        rpc: ['https://testnet.cascadia.foundation'],
        faucets: ['https://www.cascadia.foundation/faucet'],
        nativeCurrency: { name: 'CC', symbol: 'tCC', decimals: 18 },
        infoURL: 'https://www.cascadia.foundation',
        shortName: 'cascadia',
        chainId: 6102,
        networkId: 6102,
        icon: 'cascadia',
        explorers: [
            {
                name: 'Cascadia EVM Explorer',
                url: 'https://explorer.cascadia.foundation',
                standard: 'none',
                icon: 'cascadia'
            },
            {
                name: 'Cascadia Cosmos Explorer',
                url: 'https://validator.cascadia.foundation',
                standard: 'none',
                icon: 'cascadia'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQtcwxNiJ9D1QDz4k6jZ7qacLcqMk6CeW85TTBWBvNp3z'
    },
    6118: {
        name: 'UPTN Testnet',
        chain: 'UPTN',
        icon: 'uptn',
        rpc: ['https://node-api.alp.uptn.io/v1/ext/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'UPTN', symbol: 'UPTN', decimals: 18 },
        infoURL: 'https://uptn.io',
        shortName: 'UPTN-TEST',
        chainId: 6118,
        networkId: 6118,
        slip44: 1,
        explorers: [
            {
                name: 'UPTN Testnet Explorer',
                url: 'https://testnet.explorer.uptn.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qma6cGPCDcJPFxy5KQaMBrLtuVQiqeLncXVybcBoQuhai5'
    },
    6119: {
        name: 'UPTN',
        chain: 'UPTN',
        icon: 'uptn',
        rpc: ['https://node-api.uptn.io/v1/ext/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'UPTN', symbol: 'UPTN', decimals: 18 },
        infoURL: 'https://uptn.io',
        shortName: 'UPTN',
        chainId: 6119,
        networkId: 6119,
        explorers: [
            {
                name: 'UPTN Explorer',
                url: 'https://explorer.uptn.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qma6cGPCDcJPFxy5KQaMBrLtuVQiqeLncXVybcBoQuhai5'
    },
    6122: {
        name: 'Tea Mainnet',
        chain: 'TEA',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Tea', symbol: 'TEA', decimals: 18 },
        infoURL: 'https://tea.xyz',
        shortName: 'tea',
        chainId: 6122,
        networkId: 6122,
        parent: { type: 'L2', chain: 'eip155-1' },
        status: 'incubating'
    },
    6278: {
        name: 'Rails',
        title: 'Rails Network Mainnet',
        chain: 'RAILS',
        icon: 'rails',
        rpc: ['https://mainnet.steamexchange.io'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }, { name: 'EIP6551' }],
        faucets: [],
        nativeCurrency: { name: 'SteamX', symbol: 'STEAMX', decimals: 18 },
        infoURL: 'https://steamexchange.io',
        shortName: 'rails',
        chainId: 6278,
        networkId: 6278,
        slip44: 6278,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explore.steamexchange.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfDnMYCXc1By1bQ1yiBWVLaYrzdGAXuA8SLTs6yDkLBfM'
    },
    6283: {
        name: 'LAOS',
        title: 'LAOS Mainnet',
        chain: 'LAOS',
        icon: 'laosnetwork',
        rpc: [
            'https://rpc.laos.laosfoundation.io',
            'wss://rpc.laos.laosfoundation.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'LAOS', symbol: 'LAOS', decimals: 18 },
        infoURL: 'https://laosnetwork.io',
        shortName: 'laosnetwork',
        chainId: 6283,
        networkId: 6283,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.laos.laosfoundation.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmR8HgbKrHys8QFtH99soGx9KreixpCXJqkFejJdhpyNGo'
    },
    6320: {
        name: 'NFB Chain Testnet',
        chain: 'NFB Chain Testnet',
        rpc: ['https://testnet-node.nfbchain.com'],
        faucets: [],
        nativeCurrency: { name: 'NFBCoinTest', symbol: 'NFBCT', decimals: 18 },
        infoURL: 'https://nfbchain.com/',
        shortName: 'nfbchaintest',
        chainId: 6320,
        networkId: 6320,
        explorers: [
            {
                name: 'NFB Chain Testnet Explorer',
                url: 'https://testnet-scan.nfbchain.com',
                standard: 'none'
            }
        ]
    },
    6321: {
        name: 'Aura Euphoria Testnet',
        chain: 'Aura',
        rpc: ['https://jsonrpc.euphoria.aura.network'],
        faucets: ['https://aura.faucetme.pro'],
        nativeCurrency: { name: 'test-EAura', symbol: 'eAura', decimals: 18 },
        infoURL: 'https://aura.network',
        shortName: 'eaura',
        chainId: 6321,
        networkId: 6321,
        slip44: 1,
        icon: 'aura',
        explorers: [
            {
                name: 'Aurascan Explorer',
                url: 'https://euphoria.aurascan.io',
                standard: 'none',
                icon: 'aura'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbpQPpjKy1bkDmuzCSSE9iFTUK37AiWYgJbgN3Fr7MWYq'
    },
    6322: {
        name: 'Aura Mainnet',
        chain: 'Aura',
        rpc: ['https://jsonrpc.aura.network'],
        faucets: [],
        nativeCurrency: { name: 'Aura', symbol: 'AURA', decimals: 18 },
        infoURL: 'https://aura.network',
        shortName: 'aura',
        chainId: 6322,
        networkId: 6322,
        slip44: 1,
        icon: 'aura',
        explorers: [
            {
                name: 'Aurascan Explorer',
                url: 'https://aurascan.io',
                standard: 'none',
                icon: 'aura'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbpQPpjKy1bkDmuzCSSE9iFTUK37AiWYgJbgN3Fr7MWYq'
    },
    6342: {
        name: 'MegaETH Testnet',
        chain: 'ETH',
        nativeCurrency: {
            name: 'MegaETH Testnet Ether',
            symbol: 'ETH',
            decimals: 18
        },
        rpc: ['https://carrot.megaeth.com/rpc', 'wss://carrot.megaeth.com/ws'],
        faucets: [],
        infoURL: 'https://testnet.megaeth.com',
        shortName: 'megatest',
        chainId: 6342,
        networkId: 6342,
        slip44: 1
    },
    6363: {
        name: 'Digit Soul Smart Chain',
        chain: 'DGS',
        rpc: ['https://dsc-rpc.digitsoul.co.th'],
        faucets: [],
        icon: 'pnet',
        nativeCurrency: { name: 'Digit Coin', symbol: 'DGC', decimals: 18 },
        infoURL: '',
        shortName: 'DGS',
        chainId: 6363,
        networkId: 6363,
        iconURL: 'https://ipfs.io/ipfs/QmRiAUu3xV5uiX6Nk1iXD5w6qjki5ugGFETRVavzJ2h5QF'
    },
    6398: {
        name: 'Connext Sepolia',
        chain: 'Connext Sepolia',
        rpc: ['https://rpc.connext-sepolia.gelato.digital/'],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        faucets: [],
        infoURL: '',
        shortName: 'connext-sepolia',
        chainId: 6398,
        networkId: 6398,
        explorers: [
            {
                name: 'Connext Sepolia',
                url: 'https://connext-sepolia.blockscout.com',
                icon: 'connext',
                standard: 'none'
            }
        ]
    },
    6502: {
        name: 'Peerpay',
        chain: 'P2P',
        rpc: ['https://peerpay.su.gy/p2p'],
        faucets: [],
        nativeCurrency: { name: 'Peerpay', symbol: 'P2P', decimals: 18 },
        infoURL: 'https://peerpay.su.gy',
        shortName: 'Peerpay',
        chainId: 6502,
        networkId: 6502,
        explorers: []
    },
    6550: {
        name: 'Flamma Testnet',
        chain: 'Flamma',
        rpc: ['https://testnetrpc.flamma.network'],
        faucets: [],
        nativeCurrency: { name: 'Flamma', symbol: 'FLA', decimals: 18 },
        infoURL: 'https://flamma.network',
        shortName: 'FlammaTestnet',
        chainId: 6550,
        networkId: 6550,
        explorers: [
            {
                name: 'flascan',
                url: 'https://testnet.flascan.net',
                standard: 'EIP3091'
            }
        ]
    },
    6552: {
        name: 'Scolcoin WeiChain Testnet',
        chain: 'SCOLWEI-testnet',
        rpc: ['https://testnet-rpc.scolcoin.com'],
        faucets: ['https://faucet.scolcoin.com'],
        nativeCurrency: { name: 'Scolcoin', symbol: 'SCOL', decimals: 18 },
        infoURL: 'https://scolcoin.com',
        shortName: 'SRC-test',
        chainId: 6552,
        networkId: 6552,
        slip44: 1,
        icon: 'scolcoin',
        explorers: [
            {
                name: 'Scolscan Testnet Explorer',
                url: 'https://testnet-explorer.scolcoin.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVES1eqDXhP8SdeCpM85wvjmhrQDXGRquQebDrSdvJqpt'
    },
    6565: {
        name: 'Fox Testnet Network',
        chain: 'FOX',
        rpc: [
            'https://rpc-testnet-v1.foxchain.app/',
            'https://rpc2-testnet-v1.foxchain.app/',
            'https://rpc3-testnet-v1.foxchain.app'
        ],
        faucets: ['https://faucet.foxchain.app'],
        nativeCurrency: { name: 'FOX Native Token', symbol: 'tFOX', decimals: 18 },
        infoURL: 'https://foxchain.app',
        shortName: 'fox',
        chainId: 6565,
        networkId: 6565,
        slip44: 1,
        icon: 'fox',
        explorers: [
            {
                name: 'FOX Testnet Explorer',
                icon: 'fox',
                url: 'https://testnet.foxscan.app',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmbp1rwhtRr6JQRyYqyfLqkbmzXr1T17zbmChsi2ouvg3M'
    },
    6626: {
        name: 'Pixie Chain Mainnet',
        chain: 'PixieChain',
        rpc: [
            'https://http-mainnet.chain.pixie.xyz',
            'wss://ws-mainnet.chain.pixie.xyz'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'Pixie Chain Native Token',
            symbol: 'PIX',
            decimals: 18
        },
        infoURL: 'https://chain.pixie.xyz',
        shortName: 'pixie-chain',
        chainId: 6626,
        networkId: 6626,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://scan.chain.pixie.xyz',
                standard: 'none'
            }
        ]
    },
    6660: {
        name: 'Latest Chain Testnet',
        chain: 'LATEST',
        icon: 'latestChain',
        rpc: ['https://testnet-rpc.latestcoin.io'],
        faucets: ['http://faucet.latestchain.io'],
        nativeCurrency: { name: 'Latest', symbol: 'LATEST', decimals: 18 },
        infoURL: 'https://latestcoin.io',
        shortName: 'LATESTt',
        chainId: 6660,
        networkId: 6660,
        explorers: [
            {
                name: 'Latest Chain',
                url: 'http://testnet.latestchain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUU784i1ZHDNwgXvt9weZmq6YbHHkyXvuDS7r4iDzao72'
    },
    6661: {
        name: 'Cybria Mainnet',
        chain: 'CYBA',
        rpc: ['https://rpc-mainnet.cybria.io'],
        faucets: [],
        nativeCurrency: { name: 'Cybria', symbol: 'CYBA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://cybria.io',
        shortName: 'cyba',
        chainId: 6661,
        networkId: 6661,
        icon: 'cybria',
        explorers: [
            {
                name: 'Cybria Explorer',
                url: 'https://cybascan.io',
                icon: 'cybascan',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155420',
            bridges: [{ url: 'https://app.optimism.io/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreiarso74bytq5ccnl3mlfhd4ejiylwautsr6ovbqgmynzjzmkorn6y'
    },
    6666: {
        name: 'Cybria Testnet',
        chain: 'CYBA',
        rpc: ['https://l2-rpc.cybascan.io'],
        faucets: ['https://faucet.cybascan.io'],
        nativeCurrency: { name: 'Cybria', symbol: 'CYBA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://cybria.io',
        shortName: 'tcyba',
        chainId: 6666,
        networkId: 6666,
        icon: 'cybria',
        explorers: [
            {
                name: 'Cybria Explorer',
                url: 'https://explorer.cybascan.io',
                icon: 'cybascan',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155420',
            bridges: [{ url: 'https://app.optimism.io/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreiarso74bytq5ccnl3mlfhd4ejiylwautsr6ovbqgmynzjzmkorn6y'
    },
    6667: {
        name: 'Storchain',
        chain: 'STR',
        rpc: ['https://rpc.storchain.io'],
        faucets: [],
        nativeCurrency: { name: 'Storchain', symbol: 'STR', decimals: 18 },
        infoURL: 'https://storchain.io',
        shortName: 'str',
        chainId: 6667,
        networkId: 6667,
        icon: 'str',
        explorers: [
            {
                name: 'storscan',
                url: 'https://scan.storchain.io',
                icon: 'str',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdXSyjZvtVPDTLAuYoVU1cuRTEKnY96p65jgcz6wt7pfA'
    },
    6678: {
        name: 'Edge Matrix Chain',
        chain: 'EMC',
        icon: 'emc',
        rpc: ['https://rpc1-mainnet.emc.network'],
        faucets: [],
        nativeCurrency: {
            name: 'Edge Matrix Chain Token',
            symbol: 'EMC',
            decimals: 18
        },
        infoURL: '',
        shortName: 'EMC',
        chainId: 6678,
        networkId: 6678,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://emcscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUDymyXZS9eUn5p3tyDyxhD8GMB91HUBAAvySwENfPevh'
    },
    6688: {
        name: 'IRIShub',
        chain: 'IRIShub',
        rpc: [
            'https://evmrpc.irishub-1.irisnet.org',
            'https://iris-evm.publicnode.com',
            'wss://iris-evm.publicnode.com'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Eris', symbol: 'ERIS', decimals: 18 },
        infoURL: 'https://www.irisnet.org',
        shortName: 'iris',
        chainId: 6688,
        networkId: 6688,
        icon: 'irishub',
        explorers: [
            {
                name: 'IRISHub Cosmos Explorer (IOBScan)',
                url: 'https://irishub.iobscan.io',
                standard: 'none',
                icon: 'irishub'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTKgKs7kJiWDhdjbELE4Y2HVZ36KS4bYkNCbXdsXk66sW'
    },
    6699: {
        name: 'OX Chain',
        title: 'OX Chain',
        chain: 'OX',
        rpc: ['https://rpc.oxscan.io'],
        faucets: [],
        nativeCurrency: { name: 'OX', symbol: 'OX', decimals: 18 },
        infoURL: 'https://ox.fun/chain',
        shortName: 'ox-chain',
        chainId: 6699,
        networkId: 6699,
        status: 'incubating'
    },
    6701: {
        name: 'PAXB Mainnet',
        chain: 'PAXB',
        rpc: ['https://chain.paxb.io'],
        faucets: [],
        nativeCurrency: { name: 'PAXB', symbol: 'PAXB', decimals: 18 },
        infoURL: 'https://paxb.io/',
        shortName: 'PAXB',
        chainId: 6701,
        networkId: 6701,
        icon: 'paxb',
        explorers: [
            {
                name: 'PAXB Explorer',
                url: 'https://scan.paxb.io',
                icon: 'paxb',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSP66CHynXpMYkjV28uLjTR4kjuoJyy92igYYpvLoqHtG'
    },
    6779: {
        name: 'Compverse Mainnet',
        chain: 'CPV',
        icon: 'compverse',
        rpc: ['https://rpc.compverse.io/', 'https://rpc-useast1.compverse.io/'],
        faucets: [],
        nativeCurrency: { name: 'compverse', symbol: 'CPV', decimals: 18 },
        infoURL: 'https://compverse.io',
        shortName: 'compverse',
        chainId: 6779,
        networkId: 6779,
        slip44: 7779,
        explorers: [
            {
                name: 'cpvscan',
                url: 'https://scan.compverse.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYbskrGpidbMwsJekTeLrr8Z6GA9q4Uxh7piS1F9BdWWv'
    },
    6789: {
        name: 'Gold Smart Chain Mainnet',
        chain: 'STAND',
        icon: 'stand',
        rpc: ['https://rpc-mainnet.goldsmartchain.com'],
        faucets: ['https://faucet.goldsmartchain.com'],
        nativeCurrency: { name: 'Standard in Gold', symbol: 'STAND', decimals: 18 },
        infoURL: 'https://goldsmartchain.com',
        shortName: 'STANDm',
        chainId: 6789,
        networkId: 6789,
        explorers: [
            {
                name: 'Gold Smart Chain',
                url: 'https://mainnet.goldsmartchain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPNuymyaKLJhCaXnyrsL8358FeTxabZFsaxMmWNU4Tzt3'
    },
    6805: {
        name: 'RACE Mainnet',
        chain: 'ETH',
        rpc: ['https://racemainnet.io/'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://race.foundation/',
        shortName: 'raceeth',
        chainId: 6805,
        networkId: 6805,
        slip44: 1,
        icon: 'race',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://racescan.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.race.foundation/' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmQGaiPkSHc8ZGLAE4A8yZdFWLeuEts4VX6FjEqnuPXvxh'
    },
    6806: {
        name: 'RACE Testnet',
        chain: 'ETH',
        rpc: ['https://racetestnet.io/'],
        faucets: ['https://faucet.racetestnet.io/'],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://race.foundation/',
        shortName: 'racesep',
        chainId: 6806,
        networkId: 6806,
        slip44: 1,
        icon: 'race',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet.racescan.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://testnet-bridge.race.foundation/' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmQGaiPkSHc8ZGLAE4A8yZdFWLeuEts4VX6FjEqnuPXvxh'
    },
    6868: {
        name: 'Pools Mainnet',
        chain: 'Pools',
        rpc: ['https://rpc.poolsmobility.com'],
        faucets: [],
        nativeCurrency: {
            name: 'POOLS Native Token',
            symbol: 'POOLS',
            decimals: 18
        },
        infoURL: 'https://www.poolschain.org',
        shortName: 'POOLS',
        icon: 'POOLS',
        chainId: 6868,
        networkId: 6868,
        slip44: 6868,
        explorers: [
            {
                name: 'poolsscan',
                url: 'https://scan.poolsmobility.com',
                icon: 'POOLS',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmV18PRFPkp9pwKKJp4ksVDhMEiqNZ8A5DhQapdNCckeeQ'
    },
    6880: {
        name: 'MTT Network',
        chain: 'MTT',
        rpc: ['https://evm-rpc.mtt.network'],
        faucets: [],
        nativeCurrency: {
            name: 'MTT Network native coin',
            symbol: 'MTT',
            decimals: 18
        },
        infoURL: 'https://mtt.network',
        shortName: 'mtt-network',
        chainId: 6880,
        networkId: 6880,
        icon: 'mttnetwork',
        explorers: [
            {
                name: 'Mtt explorer',
                url: 'https://explorer.mtt.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigl72xrnfxf2wbu2l6ul46tmonbmshgfuxmthcax2c6z4sy5bbfga'
    },
    6900: {
        name: 'Nibiru cataclysm-1',
        chain: 'Nibiru',
        rpc: ['https://evm-rpc.nibiru.fi'],
        faucets: [],
        nativeCurrency: { name: 'NIBI', symbol: 'NIBI', decimals: 18 },
        infoURL: 'https://nibiru.fi',
        shortName: 'cataclysm-1',
        chainId: 6900,
        networkId: 6900,
        icon: 'nibiru',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmZ4ujZagoLozYSypp7uJESgExJhGGJTmmpT6AoDV8GzZW'
    },
    6911: {
        name: 'Nibiru testnet-2',
        chain: 'Nibiru',
        rpc: ['https://evm-rpc.testnet-2.nibiru.fi'],
        faucets: [],
        nativeCurrency: { name: 'NIBI', symbol: 'NIBI', decimals: 18 },
        infoURL: 'https://nibiru.fi',
        shortName: 'nibiru-testnet-2',
        chainId: 6911,
        networkId: 6911,
        icon: 'nibiru',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmZ4ujZagoLozYSypp7uJESgExJhGGJTmmpT6AoDV8GzZW'
    },
    6934: {
        name: 'Xylume TestNet',
        chain: 'XYL',
        rpc: ['https://xyl-testnet.glitch.me/rpc/'],
        faucets: ['https://debxylen.github.io/XYL_TestNet/faucet.html'],
        nativeCurrency: { name: 'XYL', symbol: 'XYL', decimals: 18 },
        features: [
            { name: 'EIP155' },
            { name: 'EIP1559' },
            { name: 'Directed Acyclic Graph (DAG)' }
        ],
        infoURL: 'https://debxylen.github.io/Xylume_TestNet',
        shortName: 'xyl',
        chainId: 6934,
        networkId: 6934,
        icon: 'xylume-testnet',
        explorers: [
            {
                name: 'Xylume Explorer',
                url: 'https://debxylen.github.io/XylumeExplorer',
                icon: 'xylume-testnet',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRk9t6g5otTX6XcQjvFwsfzn2KjZwbstptH9C7uG2kVdD'
    },
    6942: {
        name: 'Laika Mainnet',
        chain: 'LAIKA',
        rpc: ['https://mainnetrpc.laikachain.dog'],
        faucets: ['https://laikachain.dog/faucets'],
        nativeCurrency: { name: 'Dogecoin', symbol: 'DOGE', decimals: 18 },
        infoURL: 'https://laikachain.dog',
        shortName: 'laika',
        chainId: 6942,
        networkId: 6942,
        icon: 'laika',
        explorers: [
            {
                name: 'Laika Mainnet Explorer',
                url: 'https://explorer.laikachain.dog',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTMbwvGznhMwxWbX28FWtj4Me8ayGQjUQG7zrXPCJzLTa'
    },
    6969: {
        name: 'Tomb Chain Mainnet',
        chain: 'Tomb Chain',
        rpc: ['https://rpc.tombchain.com/'],
        faucets: [],
        nativeCurrency: { name: 'Tomb', symbol: 'TOMB', decimals: 18 },
        infoURL: 'https://tombchain.com/',
        shortName: 'tombchain',
        chainId: 6969,
        networkId: 6969,
        explorers: [
            {
                name: 'tombscout',
                url: 'https://tombscout.com',
                standard: 'none'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-250',
            bridges: [{ url: 'https://lif3.com/bridge' }]
        }
    },
    6999: {
        name: 'PolySmartChain',
        chain: 'PSC',
        rpc: [
            'https://seed0.polysmartchain.com/',
            'https://seed1.polysmartchain.com/',
            'https://seed2.polysmartchain.com/'
        ],
        faucets: [],
        nativeCurrency: { name: 'PSC', symbol: 'PSC', decimals: 18 },
        infoURL: 'https://www.polysmartchain.com/',
        shortName: 'psc',
        chainId: 6999,
        networkId: 6999
    },
    7000: {
        name: 'ZetaChain Mainnet',
        chain: 'ZetaChain',
        icon: 'zetachain',
        rpc: [
            'https://zetachain-evm.blockpi.network/v1/rpc/public',
            'https://zetachain-mainnet.g.allthatnode.com/archive/evm',
            'https://zeta-chain.drpc.org',
            'https://zetachain-mainnet.public.blastapi.io',
            'https://7000.rpc.thirdweb.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Zeta', symbol: 'ZETA', decimals: 18 },
        infoURL: 'https://zetachain.com/docs/',
        shortName: 'zetachain-mainnet',
        chainId: 7000,
        networkId: 7000,
        status: 'active',
        explorers: [
            {
                name: 'ZetaChain Mainnet Explorer',
                url: 'https://explorer.zetachain.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmP4Gnf4Lkp8q5LQVePNjAWxSqrw8vU2JAf7amcFz4vEUy'
    },
    7001: {
        name: 'ZetaChain Testnet',
        chain: 'ZetaChain',
        icon: 'zetachain',
        rpc: [
            'https://zetachain-athens-evm.blockpi.network/v1/rpc/public',
            'https://zetachain-testnet.public.blastapi.io',
            'https://zetachain-athens.g.allthatnode.com/archive/evm',
            'https://7001.rpc.thirdweb.com',
            'https://zeta-chain-testnet.drpc.org'
        ],
        faucets: [
            'https://www.zetachain.com/docs/reference/apps/get-testnet-zeta/'
        ],
        nativeCurrency: { name: 'Zeta', symbol: 'ZETA', decimals: 18 },
        infoURL: 'https://zetachain.com/docs',
        shortName: 'zetachain-testnet',
        chainId: 7001,
        networkId: 7001,
        slip44: 1,
        status: 'active',
        explorers: [
            {
                name: 'ZetaScan',
                url: 'https://athens.explorer.zetachain.com',
                standard: 'none'
            },
            {
                name: 'Blockscout',
                url: 'https://zetachain-athens-3.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmP4Gnf4Lkp8q5LQVePNjAWxSqrw8vU2JAf7amcFz4vEUy'
    },
    7007: {
        name: 'BST Chain',
        chain: 'BSTC',
        rpc: ['https://rpc.bstchain.io/'],
        faucets: [],
        nativeCurrency: { name: 'BST Chain', symbol: 'BSTC', decimals: 18 },
        infoURL: 'https://bstchain.io',
        shortName: 'BSTC',
        chainId: 7007,
        networkId: 7007,
        icon: 'bstc',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://bstscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPko9BJhR5FWTsThcwUFnnnjgLjrXVDm1n98dCuaQNW59'
    },
    7027: {
        name: 'Ella the heart',
        chain: 'ella',
        icon: 'ella',
        rpc: ['https://rpc.ella.network'],
        faucets: [],
        nativeCurrency: { name: 'Ella', symbol: 'ELLA', decimals: 18 },
        infoURL: 'https://ella.network',
        shortName: 'ELLA',
        chainId: 7027,
        networkId: 7027,
        explorers: [
            { name: 'Ella', url: 'https://ella.network', standard: 'EIP3091' }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVkAhSaHhH3wKoLT56Aq8dNyEH4RySPEpqPcLwsptGBDm'
    },
    7070: {
        name: 'Planq Mainnet',
        chain: 'Planq',
        icon: 'planq',
        rpc: ['https://evm-rpc.planq.network'],
        faucets: [],
        nativeCurrency: { name: 'Planq', symbol: 'PLQ', decimals: 18 },
        infoURL: 'https://planq.network',
        shortName: 'planq',
        chainId: 7070,
        networkId: 7070,
        explorers: [
            {
                name: 'Planq EVM Explorer (Blockscout)',
                url: 'https://evm.planq.network',
                standard: 'none'
            },
            {
                name: 'Planq Cosmos Explorer (BigDipper)',
                url: 'https://explorer.planq.network',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWEy9xK5BoqxPuVs7T48WM4exJrxzkEFt45iHcxWqUy8D'
    },
    7077: {
        name: 'Planq Atlas Testnet',
        chain: 'Planq',
        icon: 'planq',
        rpc: ['https://evm-rpc-atlas.planq.network'],
        faucets: [],
        nativeCurrency: { name: 'Planq', symbol: 'tPLQ', decimals: 18 },
        infoURL: 'https://planq.network',
        shortName: 'planq-atlas-testnet',
        chainId: 7077,
        networkId: 7077,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmWEy9xK5BoqxPuVs7T48WM4exJrxzkEFt45iHcxWqUy8D'
    },
    7099: {
        name: 'Bharat Blockchain Network',
        chain: 'BBNT',
        rpc: ['https://bbnrpc.testnet.bharatblockchain.io'],
        faucets: ['https://www.bon.bharatblockchain.io/faucet'],
        nativeCurrency: { name: 'BBNT', symbol: 'BBN', decimals: 18 },
        features: [],
        infoURL: 'https://bharatblockchain.io/',
        shortName: 'bbnt',
        chainId: 7099,
        networkId: 7099,
        explorers: []
    },
    7100: {
        name: 'Nume',
        title: 'Nume',
        chain: 'Nume',
        rpc: ['https://rpc.numecrypto.com'],
        faucets: [],
        nativeCurrency: { name: 'Dai Stablecoin', symbol: 'DAI', decimals: 18 },
        infoURL: 'https://numecrypto.com',
        shortName: 'nume',
        chainId: 7100,
        networkId: 7100,
        icon: 'nume',
        explorers: [
            {
                name: 'numeexplorer',
                url: 'https://explorer.numecrypto.com',
                icon: 'nume',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNbp1K6vKKFYh7bWeWtjBqKgdH88suDVbztP5CYU3pYNG'
    },
    7117: {
        name: '0XL3',
        chain: '0XL3',
        icon: '0xl3',
        rpc: ['https://rpc.0xl3.com'],
        faucets: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'XL3', symbol: 'XL3', decimals: 18 },
        infoURL: 'https://0xl3.com',
        shortName: '0xl3',
        chainId: 7117,
        networkId: 7117,
        explorers: [
            {
                name: '0XL3 Explorer',
                url: 'https://exp.0xl3.com',
                icon: '0xl3',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSsUNLDQXspXXLCH6bUW5CKJgon42yiVZ2Gp4ZBWL79Vx'
    },
    7118: {
        name: 'Help The Homeless',
        chain: 'mainnet',
        rpc: [],
        faucets: [],
        nativeCurrency: {
            name: 'Help The Homeless Coin',
            symbol: 'HTH',
            decimals: 18
        },
        infoURL: 'https://hth.world',
        shortName: 'hth',
        chainId: 7118,
        networkId: 7118,
        icon: 'hth',
        status: 'incubating',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmNR4Y3cUxefV7KGpGxMkjp5ofeJvbaUkR1GavsmTtK248'
    },
    7171: {
        name: 'Bitrock Mainnet',
        chain: 'Bitrock',
        icon: 'bitrock',
        rpc: ['https://connect.bit-rock.io', 'https://brockrpc.io'],
        faucets: [],
        nativeCurrency: { name: 'BITROCK', symbol: 'BROCK', decimals: 18 },
        infoURL: 'https://bit-rock.io',
        shortName: 'bitrock',
        chainId: 7171,
        networkId: 7171,
        explorers: [
            {
                name: 'Bitrock Explorer',
                url: 'https://brockscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfXZCAh3HWS2bJroUStN9TieL4QA9QArMotie3X4pwBfj'
    },
    7181: {
        name: 'UXLINK One Testnet',
        chain: 'UXLINK One',
        rpc: ['https://rpc-sepolia.uxlinkone.com'],
        faucets: [],
        nativeCurrency: { name: 'UXLINK', symbol: 'UXLINK', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.uxlinkone.io',
        shortName: 'uxlink1-sep',
        chainId: 7181,
        networkId: 7181,
        icon: 'uxlinkone',
        explorers: [
            {
                name: 'UXLINK One Sepolia Explorer',
                url: 'https://sepolia.uxlinkone.com',
                icon: 'uxlinkone',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibppp6mjqupwr5ffrcj4fcculphzoxxoqx5m4sjypsxwglljuq7sy'
    },
    7200: {
        name: 'exSat Mainnet',
        chain: 'exSat',
        icon: 'exsat',
        rpc: ['https://evm.exsat.network'],
        faucets: [],
        nativeCurrency: { name: 'Bitcoin', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://exsat.network/',
        shortName: 'xsat',
        chainId: 7200,
        networkId: 7200,
        explorers: [
            {
                name: 'exSat Explorer',
                url: 'https://scan.exsat.network',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-1', bridges: [{ url: '' }] },
        iconURL: 'https://ipfs.io/ipfs/QmYZ1FjYCByj89pNiZfae2a9uTm7pJMKrzdQ1V1UKwhwNs'
    },
    7208: {
        name: 'Nexera Mainnet',
        chain: 'Nexera',
        chainId: 7208,
        networkId: 7208,
        infoURL: 'https://nexera.network',
        shortName: 'nxra-mainnet',
        rpc: ['https://rpc.nexera.network'],
        faucets: [],
        nativeCurrency: { name: 'NXRA', symbol: 'NXRA', decimals: 18 },
        explorers: []
    },
    7210: {
        name: 'Nibiru testnet-1',
        chain: 'Nibiru',
        rpc: ['https://evm-rpc.testnet-1.nibiru.fi'],
        faucets: [],
        nativeCurrency: { name: 'NIBI', symbol: 'NIBI', decimals: 18 },
        status: 'deprecated',
        infoURL: 'https://nibiru.fi',
        shortName: 'nibiru-testnet-1',
        chainId: 7210,
        networkId: 7210,
        icon: 'nibiru',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmZ4ujZagoLozYSypp7uJESgExJhGGJTmmpT6AoDV8GzZW'
    },
    7222: {
        name: 'Nibiru devnet-3',
        chain: 'Nibiru',
        rpc: ['https://evm-rpc.devnet-3.nibiru.fi'],
        faucets: [],
        nativeCurrency: { name: 'NIBI', symbol: 'NIBI', decimals: 18 },
        status: 'deprecated',
        infoURL: 'https://nibiru.fi',
        shortName: 'nibiru-devnet-3',
        chainId: 7222,
        networkId: 7222,
        icon: 'nibiru',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmZ4ujZagoLozYSypp7uJESgExJhGGJTmmpT6AoDV8GzZW'
    },
    7233: {
        name: 'InitVerse Mainnet',
        chain: 'InitVerse',
        rpc: ['https://rpc-mainnet.inichain.com'],
        faucets: [],
        nativeCurrency: { name: 'InitVerse', symbol: 'INI', decimals: 18 },
        infoURL: 'https://www.inichain.com',
        shortName: 'INI',
        chainId: 7233,
        networkId: 7233,
        icon: 'initverse',
        explorers: [
            {
                name: 'initverse',
                url: 'https://www.iniscan.com',
                icon: 'initverse',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreieuowxl2syu2cfiebhqkdjrokbwq4sulcdrww3z4wws3vssm3phzi'
    },
    7234: {
        name: 'InitVerse genesis testnet',
        chain: 'InitVerse',
        rpc: ['http://rpc-testnet.inichain.com'],
        faucets: [],
        nativeCurrency: { name: 'InitVerse', symbol: 'INI', decimals: 18 },
        infoURL: 'https://genesis-testnet.inichain.com',
        shortName: 'INICHAIN',
        chainId: 7234,
        networkId: 7234,
        icon: 'initverse',
        explorers: [
            {
                name: 'initverse',
                url: 'https://genesis-testnet.iniscan.com',
                icon: 'initverse',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreieuowxl2syu2cfiebhqkdjrokbwq4sulcdrww3z4wws3vssm3phzi'
    },
    7244: {
        name: 'ZEUS Testnet',
        chain: 'tZEUS',
        icon: 'zeusicon',
        rpc: ['https://testnet-rpc.zeuschainscan.io'],
        nativeCurrency: { name: 'The ZEUS Token', symbol: 'ZEUSX', decimals: 18 },
        infoURL: 'https://testnet-explorer.zeuschainscan.io',
        shortName: 'ZEUS-Testnet',
        chainId: 7244,
        networkId: 7244,
        faucets: ['https://faucet.zeuschainscan.io'],
        explorers: [
            {
                name: 'ZEUS Testnet Explorer',
                url: 'https://testnet-explorer.zeuschainscan.io',
                icon: 'zeusicon',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdktFyG3dM6Jk4j7V9xzvWwSpmnLcaNDuWhPwFHJw7K6e'
    },
    7300: {
        name: 'XPLA Verse',
        chain: 'XPLA Verse',
        icon: 'xpla_verse',
        rpc: ['https://rpc-xpla-verse.xpla.dev'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://www.xpla.io',
        shortName: 'XPLAVERSE',
        chainId: 7300,
        networkId: 7300,
        explorers: [
            {
                name: 'XPLA Verse Explorer',
                url: 'https://explorer-xpla-verse.xpla.dev',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-248' },
        iconURL: 'https://ipfs.io/ipfs/QmZvqcTNWPUoT1F3r9DTAMhdjt3zQC8eRUStvUGEF68KCt'
    },
    7331: {
        name: 'KLYNTAR',
        chain: 'KLY',
        rpc: [
            'https://evm.klyntar.org/kly_evm_rpc',
            'https://evm.klyntarscan.org/kly_evm_rpc'
        ],
        faucets: [],
        nativeCurrency: { name: 'KLYNTAR', symbol: 'KLY', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://klyntar.org',
        shortName: 'kly',
        chainId: 7331,
        networkId: 7331,
        icon: 'klyntar',
        explorers: [],
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmaDr9R6dKnZLsogRxojjq4dwXuXcudR8UeTZ8Nq553K4u'
    },
    7332: {
        name: 'Horizen EON Mainnet',
        shortName: 'EON',
        chain: 'EON',
        icon: 'eon',
        rpc: [
            'https://eon-rpc.horizenlabs.io/ethv1',
            'https://rpc.ankr.com/horizen_eon'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Zencash', symbol: 'ZEN', decimals: 18 },
        infoURL: 'https://horizen.io/',
        chainId: 7332,
        networkId: 7332,
        slip44: 121,
        explorers: [
            {
                name: 'Horizen EON Block Explorer',
                url: 'https://eon-explorer.horizenlabs.io',
                icon: 'eon',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSFMBk3rMyu45Sy9KQHjgArFj4HdywANNYrSosLMUdcti'
    },
    7341: {
        name: 'Shyft Mainnet',
        chain: 'SHYFT',
        icon: 'shyft',
        rpc: ['https://rpc.shyft.network/'],
        faucets: [],
        nativeCurrency: { name: 'Shyft', symbol: 'SHYFT', decimals: 18 },
        infoURL: 'https://shyft.network',
        shortName: 'shyft',
        chainId: 7341,
        networkId: 7341,
        slip44: 2147490989,
        explorers: [
            {
                name: 'Shyft BX',
                url: 'https://bx.shyft.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUkFZC2ZmoYPTKf7AHdjwRPZoV2h1MCuHaGM4iu8SNFpi'
    },
    7368: {
        name: 'Rarimo',
        title: 'Rarimo Mainnet',
        chain: 'ETH',
        rpc: ['https://l2.rarimo.com', 'wss://wss.l2.rarimo.com'],
        faucets: [],
        nativeCurrency: { name: 'Rarimo Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://rarimo.com',
        shortName: 'rarimo',
        chainId: 7368,
        networkId: 7368,
        icon: 'rarimo',
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://l2bridge.rarimo.com' }]
        },
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://scan.rarimo.com',
                standard: 'EIP3091',
                icon: 'rarimo'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/bafkreiaqnwdizg5xub4vbye3py6ddt5djdwu7dytkf7j3reoonzug4twxi'
    },
    7484: {
        name: 'Raba Network Mainnet',
        chain: 'Raba',
        icon: 'raba',
        rpc: ['https://rpc.x.raba.app/', 'wss://rpc.x.raba.app/ws/'],
        faucets: [],
        nativeCurrency: { name: 'Raba', symbol: 'RABA', decimals: 18 },
        infoURL: 'https://x.raba.app/',
        shortName: 'raba',
        chainId: 7484,
        networkId: 7484,
        explorers: [
            {
                name: 'raba',
                url: 'https://x.raba.app/explorer',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmatP9qMHEYoXqRDyHMTyjYRQa6j6Gk7pmv1QLxQkvpGRP'
    },
    7518: {
        name: 'MEVerse Chain Mainnet',
        chain: 'MEVerse',
        rpc: ['https://rpc.meversemainnet.io'],
        faucets: [],
        nativeCurrency: { name: 'MEVerse', symbol: 'MEV', decimals: 18 },
        infoURL: 'https://www.meverse.sg',
        shortName: 'MEV',
        chainId: 7518,
        networkId: 7518,
        icon: 'meverse',
        explorers: [
            {
                name: 'MEVerse Chain Explorer',
                url: 'https://www.meversescan.io',
                standard: 'none',
                icon: 'meverse'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPuQ6gaCfUtNdRuaEDbdhot2m2KCy2ZHCJUvZXJAtdeyJ'
    },
    7560: {
        name: 'Cyber Mainnet',
        chain: 'Cyber',
        rpc: [
            'https://cyber.alt.technology/',
            'wss://cyber-ws.alt.technology/',
            'https://rpc.cyber.co/',
            'wss://rpc.cyber.co/'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        icon: 'cyber',
        infoURL: 'https://cyber.co/',
        shortName: 'cyeth',
        chainId: 7560,
        networkId: 7560,
        explorers: [
            {
                name: 'Cyber Mainnet Explorer',
                url: 'https://cyberscan.co',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://cyber.co/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmR8NuaSqALStb95YsMsJRG2BoYkibjS1XE1pZFtvEkAXY'
    },
    7575: {
        name: 'ADIL Testnet',
        chain: 'ADIL',
        icon: 'adil',
        rpc: ['https://testnet.adilchain-rpc.io'],
        faucets: ['https://testnet-faucet.adil-scan.io'],
        nativeCurrency: { name: 'Testnet ADIL', symbol: 'ADIL', decimals: 18 },
        infoURL: 'https://adilchain.io',
        shortName: 'tadil',
        chainId: 7575,
        networkId: 7575,
        slip44: 1,
        explorers: [
            {
                name: 'ADIL Testnet Explorer',
                url: 'https://testnet.adilchain-scan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeHNYUx6n8CjUFSLWNT17oAtDYrUq6r8buyvGCUBXCJw6'
    },
    7576: {
        name: 'Adil Chain V2 Mainnet',
        chain: 'ADIL',
        icon: 'adil',
        rpc: ['https://adilchain-rpc.io'],
        faucets: [],
        nativeCurrency: { name: 'ADIL', symbol: 'ADIL', decimals: 18 },
        infoURL: 'https://adilchain.io',
        shortName: 'adil',
        chainId: 7576,
        networkId: 7576,
        explorers: [
            {
                name: 'ADIL Mainnet Explorer',
                url: 'https://adilchain-scan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeHNYUx6n8CjUFSLWNT17oAtDYrUq6r8buyvGCUBXCJw6'
    },
    7668: {
        name: 'The Root Network - Mainnet',
        chain: 'TRN',
        rpc: [
            'https://root.rootnet.live/archive',
            'wss://root.rootnet.live/archive/ws'
        ],
        faucets: [],
        nativeCurrency: { name: 'XRP', symbol: 'XRP', decimals: 6 },
        infoURL: 'https://www.futureverse.com/technology/root',
        shortName: 'trn-mainnet',
        chainId: 7668,
        networkId: 7668,
        explorers: [
            {
                name: 'rootnet',
                url: 'https://explorer.rootnet.live',
                standard: 'EIP3091'
            }
        ]
    },
    7672: {
        name: 'The Root Network - Porcini Testnet',
        chain: 'TRN',
        rpc: [
            'https://porcini.rootnet.app/archive',
            'wss://porcini.rootnet.app/archive/ws'
        ],
        faucets: [],
        nativeCurrency: { name: 'XRP', symbol: 'XRP', decimals: 6 },
        infoURL: 'https://www.futureverse.com/technology/root',
        shortName: 'trn-porcini',
        chainId: 7672,
        networkId: 7672,
        slip44: 1,
        explorers: [
            {
                name: 'rootnet',
                url: 'https://explorer.rootnet.cloud',
                standard: 'EIP3091'
            }
        ]
    },
    7700: {
        name: 'Canto',
        chain: 'Canto',
        rpc: [
            'https://canto.slingshot.finance',
            'https://canto-rpc.ansybl.io',
            'https://mainnode.plexnode.org:8545',
            'https://canto.gravitychain.io/'
        ],
        faucets: [],
        nativeCurrency: { name: 'Canto', symbol: 'CANTO', decimals: 18 },
        infoURL: 'https://canto.io',
        shortName: 'canto',
        chainId: 7700,
        networkId: 7700,
        explorers: [
            {
                name: 'Canto Explorer (OKLink)',
                url: 'https://www.oklink.com/canto',
                standard: 'EIP3091'
            },
            {
                name: 'Canto EVM Explorer (Blockscout)',
                url: 'https://tuber.build',
                standard: 'EIP3091'
            },
            {
                name: 'dexguru',
                url: 'https://canto.dex.guru',
                icon: 'dexguru',
                standard: 'EIP3091'
            }
        ]
    },
    7701: {
        name: 'Canto Tesnet',
        chain: 'Canto',
        rpc: ['https://testnet-archive.plexnode.wtf'],
        faucets: [],
        nativeCurrency: { name: 'Testnet Canto', symbol: 'CANTO', decimals: 18 },
        infoURL: 'https://canto.io',
        shortName: 'TestnetCanto',
        chainId: 7701,
        networkId: 7701,
        slip44: 1,
        explorers: [
            {
                name: 'Canto Testnet EVM Explorer (Blockscout)',
                url: 'https://testnet.tuber.build',
                standard: 'none'
            },
            {
                name: 'dexguru',
                url: 'https://canto-test.dex.guru',
                icon: 'dexguru',
                standard: 'EIP3091'
            }
        ]
    },
    7744: {
        name: 'Phron Testnet',
        chain: 'PHR',
        icon: 'phron',
        rpc: ['https://testnet.phron.ai', 'wss://testnet.phron.ai'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://faucet.phron.ai'],
        nativeCurrency: { name: 'Phron', symbol: 'TPHR', decimals: 18 },
        infoURL: 'https://phron.ai',
        shortName: 'phr',
        chainId: 7744,
        networkId: 7744,
        explorers: [
            {
                name: 'phronscan',
                url: 'https://testnet.phronscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmf77sTNKpnTbwYjauyQ7KpxV5EbgTPP27Fmx24svB84gY'
    },
    7770: {
        name: 'PandaSea Testnet',
        chain: 'PandaSea Testnet',
        rpc: ['https://rpc.testnet.pandasea.io'],
        faucets: ['https://faucet.pandasea.io'],
        nativeCurrency: { name: 'PandaSea Coin', symbol: 'PANDA', decimals: 18 },
        infoURL: 'https://test.pandaseascan.com',
        shortName: 'Pandasea-Testnet',
        chainId: 7770,
        networkId: 7770,
        explorers: [
            {
                name: 'tracehawk',
                url: 'https://test.pandaseascan.com',
                standard: 'none'
            }
        ]
    },
    7771: {
        name: 'Bitrock Testnet',
        chain: 'Bitrock',
        icon: 'bitrock',
        rpc: ['https://testnet.bit-rock.io'],
        faucets: ['https://faucet.bit-rock.io'],
        nativeCurrency: { name: 'BITROCK', symbol: 'BROCK', decimals: 18 },
        infoURL: 'https://bit-rock.io',
        shortName: 'tbitrock',
        chainId: 7771,
        networkId: 7771,
        slip44: 1,
        explorers: [
            {
                name: 'Bitrock Testnet Explorer',
                url: 'https://testnetscan.bit-rock.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfXZCAh3HWS2bJroUStN9TieL4QA9QArMotie3X4pwBfj'
    },
    7774: {
        name: 'GDCC MAINNET',
        chain: 'GDCC',
        icon: 'gdcc',
        rpc: ['https://mainnet-rpc-1.gdccscan.io'],
        faucets: [],
        nativeCurrency: { name: 'GDCC', symbol: 'GDCC', decimals: 18 },
        infoURL: 'https://gdcchain.com',
        shortName: 'GdccMainnet',
        chainId: 7774,
        networkId: 7774,
        explorers: [{ name: 'GDCC', url: 'https://gdccscan.io', standard: 'none' }],
        iconURL: 'https://ipfs.io/ipfs/QmY4vp1mJoGpUiuWbRVenNiDZC17wSyyueGPK9A5QyK1M2'
    },
    7775: {
        name: 'GDCC TESTNET',
        chain: 'GDCC',
        icon: 'gdcc',
        rpc: ['https://testnet-rpc1.gdccscan.io'],
        faucets: [],
        nativeCurrency: { name: 'GDCC', symbol: 'GDCC', decimals: 18 },
        infoURL: 'https://gdcchain.com',
        shortName: 'GDCC',
        chainId: 7775,
        networkId: 7775,
        explorers: [
            {
                name: 'GDCC',
                url: 'https://testnet.gdccscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmY4vp1mJoGpUiuWbRVenNiDZC17wSyyueGPK9A5QyK1M2'
    },
    7776: {
        name: 'PandaSea Mainnet',
        chain: 'PandaSea',
        rpc: ['https://rpc1.pandasea.io'],
        faucets: [],
        nativeCurrency: { name: 'PandaSea Coin', symbol: 'PANDA', decimals: 18 },
        infoURL: '',
        shortName: 'pandaSea-mainnet',
        chainId: 7776,
        networkId: 7776,
        explorers: [
            {
                name: 'Tracehawk',
                url: 'https://pandaseascan.com',
                standard: 'none'
            }
        ]
    },
    7777: {
        name: 'Rise of the Warbots Testnet',
        chain: 'nmactest',
        rpc: [
            'https://testnet1.riseofthewarbots.com',
            'https://testnet2.riseofthewarbots.com',
            'https://testnet3.riseofthewarbots.com',
            'https://testnet4.riseofthewarbots.com',
            'https://testnet5.riseofthewarbots.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Nano Machines', symbol: 'NMAC', decimals: 18 },
        infoURL: 'https://riseofthewarbots.com/',
        shortName: 'RiseOfTheWarbotsTestnet',
        chainId: 7777,
        networkId: 7777,
        slip44: 1,
        explorers: [
            {
                name: 'avascan',
                url: 'https://testnet.avascan.info/blockchain/2mZ9doojfwHzXN3VXDQELKnKyZYxv7833U8Yq5eTfFx3hxJtiy',
                standard: 'none'
            }
        ]
    },
    7778: {
        name: 'Orenium Mainnet Protocol',
        chain: 'ORE',
        rpc: [
            'https://validator-mainnet.orenium.org',
            'https://rpc-oracle-mainnet.orenium.org',
            'https://portalmainnet.orenium.org'
        ],
        nativeCurrency: { name: 'ORENIUM', symbol: 'ORE', decimals: 18 },
        infoURL: 'https://orenium.org',
        shortName: 'ore',
        chainId: 7778,
        networkId: 7778,
        slip44: 1,
        icon: 'ore',
        faucets: [],
        explorers: [
            {
                name: 'ORE Mainnet Explorer',
                icon: 'ore',
                url: 'https://oreniumscan.org',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXszYAtQxaFCG3s9vGHoLJnqxGJw2wTKNbruTJ8iDXU7K'
    },
    7788: {
        name: 'Draw Coin',
        chain: 'DRW',
        icon: 'drawchain',
        rpc: ['https://rpc.drawchain.org'],
        faucets: [],
        nativeCurrency: { name: 'DRW', symbol: 'DRW', decimals: 18 },
        infoURL: 'https://drawchain.io/',
        shortName: 'drw',
        chainId: 7788,
        networkId: 7788,
        explorers: [
            {
                name: 'Draw Chain Explorer',
                url: 'https://drawscan.io',
                standard: 'EIP3091',
                icon: 'drawchain'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihhhjsjsmsl3tpoocu244vul47dxtfvumokncmeg6fu7rgdpze7ia'
    },
    7798: {
        name: 'OpenEX LONG Testnet',
        title: 'OpenEX LONG Testnet',
        chain: 'OEX',
        icon: 'oex',
        rpc: ['https://long.rpc.openex.network/'],
        faucets: ['https://long.hub.openex.network/faucet'],
        nativeCurrency: { name: 'USDT Testnet', symbol: 'USDT', decimals: 18 },
        infoURL: 'https://openex.network',
        shortName: 'oex',
        chainId: 7798,
        networkId: 7798,
        slip44: 1,
        explorers: [
            {
                name: 'OpenEX Long Testnet Explorer',
                url: 'https://scan.long.openex.network',
                icon: 'oex',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidnu6p6vmmplerzvkboq7fz73ygkomzpnnokuxstrqv2fvxgmgg7i'
    },
    7860: {
        name: 'MaalChain Testnet',
        chain: 'MaalChain Testnet',
        icon: 'maal-test',
        rpc: ['https://node1.maalscan.io/', 'https://rpc-bntest.maalscan.io/'],
        faucets: ['https://faucet-testnet.maalscan.io/'],
        nativeCurrency: { name: 'MAAL', symbol: 'MAAL', decimals: 18 },
        infoURL: 'https://www.maalchain.com/',
        shortName: 'maal-test',
        chainId: 7860,
        networkId: 7860,
        slip44: 1,
        explorers: [
            {
                name: 'maalscan testnet',
                url: 'https://testnet.maalscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiexfqfe2x4impvwhra3xxa5eb25gv25zi3kkaoatdnld7wbxdzf2a'
    },
    7862: {
        name: 'MaalChain V2',
        chain: 'MAAL',
        icon: 'maal',
        rpc: [
            'https://node1-mainnet-new.maalscan.io/',
            'https://node2-mainnet-new.maalscan.io/',
            'https://node3-mainnet-new.maalscan.io/'
        ],
        faucets: [],
        nativeCurrency: { name: 'MAAL', symbol: 'MAAL', decimals: 18 },
        infoURL: 'https://www.maalchain.com/',
        shortName: 'maal-v2',
        chainId: 7862,
        networkId: 7862,
        explorers: [
            {
                name: 'maalscan',
                url: 'https://v2.maalscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiexfqfe2x4impvwhra3xxa5eb25gv25zi3kkaoatdnld7wbxdzf2a'
    },
    7863: {
        name: 'MaalChain Testnet V2',
        chain: 'MaalChain Testnet V2',
        icon: 'maal-test',
        rpc: [
            'https://node-testnet.maalscan.io/',
            'https://node2-testnet.maalscan.io/'
        ],
        faucets: ['https://faucet-new-testnet.maalscan.io/'],
        nativeCurrency: { name: 'MAAL', symbol: 'MAAL', decimals: 18 },
        infoURL: 'https://www.maalchain.com/',
        shortName: 'maal-test-v2',
        chainId: 7863,
        networkId: 7863,
        slip44: 1,
        explorers: [
            {
                name: 'maalscan testnet',
                url: 'https://new-testnet.maalscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiexfqfe2x4impvwhra3xxa5eb25gv25zi3kkaoatdnld7wbxdzf2a'
    },
    7865: {
        name: 'Powerloom Mainnet',
        chain: 'POWER',
        rpc: ['https://rpc.powerloom.network'],
        faucets: [],
        nativeCurrency: { name: 'Powerloom Token', symbol: 'POWER', decimals: 18 },
        infoURL: 'https://powerloom.network',
        shortName: 'power',
        chainId: 7865,
        networkId: 7865,
        icon: 'power',
        status: 'active',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.powerloom.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaYJaMfMowoBe7te9tHCKzJzz5DbhodrmhwGab6XCDgtM'
    },
    7869: {
        name: 'Powerloom Mainnet V2',
        chain: 'Powerloom Mainnet V2',
        rpc: ['https://rpc-v2.powerloom.network'],
        faucets: [],
        nativeCurrency: { name: 'Powerloom Token', symbol: 'POWER', decimals: 18 },
        infoURL: 'https://powerloom.network',
        shortName: 'powerloom',
        chainId: 7869,
        networkId: 7869,
        icon: 'power',
        status: 'active',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer-v2.powerloom.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaYJaMfMowoBe7te9tHCKzJzz5DbhodrmhwGab6XCDgtM'
    },
    7878: {
        name: 'Hazlor Testnet',
        chain: 'SCAS',
        rpc: [
            'https://hatlas.rpc.hazlor.com:8545',
            'wss://hatlas.rpc.hazlor.com:8546'
        ],
        faucets: ['https://faucet.hazlor.com'],
        nativeCurrency: { name: 'Hazlor Test Coin', symbol: 'TSCAS', decimals: 18 },
        infoURL: 'https://hazlor.com',
        shortName: 'tscas',
        chainId: 7878,
        networkId: 7878,
        slip44: 1,
        explorers: [
            {
                name: 'Hazlor Testnet Explorer',
                url: 'https://explorer.hazlor.com',
                standard: 'none'
            }
        ]
    },
    7879: {
        name: 'Vexon Testnet',
        chain: 'Vexon',
        rpc: [
            'https://rpc-testnet-asia1.vexonhub.org',
            'https://rpc-testnet-europe1.vexonhub.org',
            'https://rpc-testnet-01.vexonhub.org'
        ],
        faucets: ['https://faucet-drip.vexonhub.org'],
        nativeCurrency: {
            name: 'Vexon Testnet Native Token',
            symbol: 'tVEX',
            decimals: 18
        },
        infoURL: 'https://vexonhub.org',
        shortName: 'vexon',
        chainId: 7879,
        networkId: 7879,
        icon: 'vexon',
        explorers: [
            {
                name: 'Vexon Testnet Explorer',
                url: 'https://testnet.vexonhub.org',
                standard: 'EIP3091',
                icon: 'vexon'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVCPcYVXB9ZEAN87LV5RrSBqxoD8zwwgVF6dcVetffSv2'
    },
    7887: {
        name: 'Kinto Mainnet',
        chain: 'Kinto Mainnet',
        rpc: [
            'https://rpc.kinto.xyz/http',
            'https://kinto-mainnet.calderachain.xyz/http'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ethereum', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://kinto.xyz',
        shortName: 'kintoMainnet',
        chainId: 7887,
        networkId: 7887,
        icon: 'kinto',
        explorers: [
            {
                name: 'Kinto Explorer',
                url: 'https://explorer.kinto.xyz',
                icon: 'kinto',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZw4zfR4Q8MD6MZRwkQrMeiiiu77AJffHdCMdemt4R2VM'
    },
    7895: {
        name: 'ARDENIUM Athena',
        chain: 'ATHENA',
        rpc: ['https://rpc-athena.ardescan.com/'],
        faucets: ['https://faucet-athena.ardescan.com/'],
        nativeCurrency: { name: 'ARD', symbol: 'tARD', decimals: 18 },
        infoURL: 'https://ardenium.org',
        shortName: 'ard',
        chainId: 7895,
        networkId: 7895,
        icon: 'ard',
        explorers: [
            {
                name: 'ARDENIUM Athena Explorer',
                icon: 'ard',
                url: 'https://testnet.ardscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdwifhejRfF8QfyzYrNdFVhfhCR6iuzWMmppK4eL7kttG'
    },
    7897: {
        name: 'arena-z',
        title: 'arena-z',
        chain: 'arena-z',
        rpc: ['https://rpc.arena-z.gg', 'wss://ws.arena-z.gg'],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/arena-z',
        faucets: [],
        shortName: 'arena-z',
        chainId: 7897,
        networkId: 7897,
        slip44: 60,
        icon: 'arena-z-mainnet',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.arena-z.gg',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.gelato.network/bridge/arena-z' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmPRGaSPsmbDwRgQUCJSfkEErrfXxHbpUhQSvvDTLgJ25R'
    },
    7923: {
        name: 'Dot Blox',
        chain: 'DTBX',
        icon: 'dotblox',
        rpc: ['https://rpc.dotblox.io'],
        faucets: [],
        nativeCurrency: { name: 'Dot Blox', symbol: 'DTBX', decimals: 18 },
        infoURL: 'https://explorer.dotblox.io',
        shortName: 'DTBX',
        chainId: 7923,
        networkId: 7923,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.dotblox.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZy2TMY881ghRxXJA7VyRA8Zhj2LJJ86DpHRZs3VQZqoJ'
    },
    7924: {
        name: 'MO Mainnet',
        chainId: 7924,
        shortName: 'MO',
        chain: 'MO',
        icon: 'mo',
        networkId: 7924,
        nativeCurrency: { name: 'MO', symbol: 'MO', decimals: 18 },
        rpc: ['https://mainnet-rpc.mochain.app/'],
        faucets: ['https://faucet.mochain.app/'],
        explorers: [
            {
                name: 'MO Explorer',
                url: 'https://moscan.app',
                standard: 'none'
            }
        ],
        infoURL: 'https://mochain.app',
        iconURL: 'https://ipfs.io/ipfs/QmfJYJiR7L8xMG3KAWroVA9CQEfRGcbprC4JmVsiVk1E4e'
    },
    7957: {
        name: 'Exorium Testnet',
        chain: 'EXOR',
        rpc: [
            'https://rpc-1-testnet.exorium.net',
            'https://rpc-2-testnet.exorium.net',
            'https://rpc-testnet.exoscan.net/'
        ],
        faucets: ['https://faucet-testnet.exorium.net'],
        nativeCurrency: { name: 'EXOR', symbol: 'tEXOR', decimals: 18 },
        infoURL: 'https://exorium.net',
        shortName: 'texor',
        chainId: 7957,
        networkId: 7957,
        slip44: 1,
        icon: 'exorium',
        explorers: [
            {
                name: 'EXORIUM Testnet Explorer',
                icon: 'exorium',
                url: 'https://testnet.exoscan.net',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTY2Z7AEEWxmzQyh7DFG8fyR3w6Y166GDJfi6o3xo6GgV'
    },
    7979: {
        name: 'DOS Chain',
        chain: 'DOS',
        rpc: ['https://main.doschain.com'],
        faucets: [],
        nativeCurrency: { name: 'DOS', symbol: 'DOS', decimals: 18 },
        infoURL: 'https://doschain.io',
        shortName: 'dos',
        chainId: 7979,
        networkId: 7979,
        icon: 'doschain',
        explorers: [
            {
                name: 'DOScan',
                url: 'https://doscan.io',
                icon: 'doschain',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmV2Nowzo81F6pi2qFcHePA4MwmmdMKBMUzBJUrxcymxx4'
    },
    8000: {
        name: 'Teleport',
        chain: 'Teleport',
        rpc: ['https://evm-rpc.teleport.network'],
        faucets: [],
        nativeCurrency: { name: 'Tele', symbol: 'TELE', decimals: 18 },
        infoURL: 'https://teleport.network',
        shortName: 'teleport',
        chainId: 8000,
        networkId: 8000,
        icon: 'teleport',
        explorers: [
            {
                name: 'Teleport EVM Explorer (Blockscout)',
                url: 'https://evm-explorer.teleport.network',
                standard: 'none',
                icon: 'teleport'
            },
            {
                name: 'Teleport Cosmos Explorer (Big Dipper)',
                url: 'https://explorer.teleport.network',
                standard: 'none',
                icon: 'teleport'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdP1sLnsmW9dwnfb1GxAXU1nHDzCvWBQNumvMXpdbCSuz'
    },
    8001: {
        name: 'Teleport Testnet',
        chain: 'Teleport',
        rpc: ['https://evm-rpc.testnet.teleport.network'],
        faucets: ['https://chain-docs.teleport.network/testnet/faucet.html'],
        nativeCurrency: { name: 'Tele', symbol: 'TELE', decimals: 18 },
        infoURL: 'https://teleport.network',
        shortName: 'teleport-testnet',
        chainId: 8001,
        networkId: 8001,
        slip44: 1,
        icon: 'teleport',
        explorers: [
            {
                name: 'Teleport EVM Explorer (Blockscout)',
                url: 'https://evm-explorer.testnet.teleport.network',
                standard: 'none',
                icon: 'teleport'
            },
            {
                name: 'Teleport Cosmos Explorer (Big Dipper)',
                url: 'https://explorer.testnet.teleport.network',
                standard: 'none',
                icon: 'teleport'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdP1sLnsmW9dwnfb1GxAXU1nHDzCvWBQNumvMXpdbCSuz'
    },
    8008: {
        name: 'Polynomial',
        chain: 'Polynomial',
        rpc: ['https://rpc.polynomial.fi'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://polynomial.fi',
        shortName: 'polynomial',
        chainId: 8008,
        networkId: 8008,
        icon: 'polynomial',
        explorers: [
            {
                name: 'Polynomial Explorer',
                url: 'https://polynomialscan.io',
                standard: 'none',
                icon: 'polynomial'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeiadb4izxxptk3wy34cam3k2rxgqb2vrzxtltqnp3vwdvd2igwoghu'
    },
    8017: {
        name: 'iSunCoin Mainnet',
        chain: 'iSunCoin',
        icon: 'isuncoin',
        rpc: ['https://mainnet.isuncoin.com'],
        faucets: [],
        nativeCurrency: { name: 'ISC', symbol: 'ISC', decimals: 18 },
        infoURL: 'https://isuncoin.com',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        shortName: 'isc',
        chainId: 8017,
        networkId: 8017,
        slip44: 8017,
        explorers: [
            {
                name: 'iSunCoin Explorer',
                icon: 'isuncoin',
                url: 'https://baifa.io/app/chains/8017',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmdj8PwchmbpZKYvkB3oJiRX9eZdY6C16AbEz6D1DU3Vqn'
    },
    8029: {
        name: 'MDGL Testnet',
        chain: 'MDGL',
        rpc: ['https://testnet.mdgl.io'],
        faucets: [],
        nativeCurrency: { name: 'MDGL Token', symbol: 'MDGLT', decimals: 18 },
        infoURL: 'https://mdgl.io',
        shortName: 'mdgl',
        chainId: 8029,
        networkId: 8029,
        slip44: 1
    },
    8047: {
        name: 'BOAT Mainnet',
        title: 'BOAT Mainnet',
        chain: 'BOAT',
        icon: 'boat',
        rpc: ['https://rpc0.come.boat/'],
        faucets: [],
        nativeCurrency: {
            name: 'Best Of All Time Token',
            symbol: 'BOAT',
            decimals: 18
        },
        infoURL: 'https://come.boats',
        shortName: 'boat',
        chainId: 8047,
        networkId: 8047,
        slip44: 1,
        explorers: [
            {
                name: 'BOAT Mainnet Explorer',
                url: 'https://scan.come.boats',
                icon: 'boat',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibqgh23s7yt7rikybybiwfivwtoh32n24scjykvgbgewo3ecbrcye'
    },
    8054: {
        name: 'Karak Sepolia',
        title: 'Karak Testnet Sepolia',
        chain: 'Karak',
        icon: 'karak',
        rpc: ['https://rpc.sepolia.karak.network'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://karak.network',
        shortName: 'karak-sepolia',
        chainId: 8054,
        networkId: 8054,
        explorers: [
            {
                name: 'Karak Sepolia Explorer',
                url: 'https://explorer.sepolia.karak.network',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111' },
        iconURL: 'https://ipfs.io/ipfs/bafybeic3dihuytvtm2hnfo7lvsqf43eqbzobtkxn3o3pxptktifsefy7su'
    },
    8080: {
        name: 'Shardeum Liberty 1.X',
        chain: 'Shardeum',
        icon: 'shardeum',
        rpc: ['https://liberty10.shardeum.org/'],
        faucets: ['https://faucet.liberty10.shardeum.org'],
        nativeCurrency: { name: 'Shardeum SHM', symbol: 'SHM', decimals: 18 },
        infoURL: 'https://docs.shardeum.org/',
        shortName: 'Liberty10',
        chainId: 8080,
        networkId: 8080,
        explorers: [
            {
                name: 'Shardeum Scan',
                url: 'https://explorer-liberty10.shardeum.org',
                standard: 'EIP3091'
            }
        ],
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/Qma1bfuubpepKn7DLDy4NPSKDeT3S4VPCNhu6UmdGrb6YD'
    },
    8081: {
        name: 'Shardeum Liberty 2.X',
        chain: 'Shardeum',
        icon: 'shardeum',
        rpc: ['https://liberty20.shardeum.org/'],
        faucets: ['https://faucet.liberty20.shardeum.org'],
        nativeCurrency: { name: 'Shardeum SHM', symbol: 'SHM', decimals: 18 },
        infoURL: 'https://docs.shardeum.org/',
        shortName: 'Liberty20',
        chainId: 8081,
        networkId: 8081,
        explorers: [
            {
                name: 'Shardeum Scan',
                url: 'https://explorer-liberty20.shardeum.org',
                standard: 'EIP3091'
            }
        ],
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/Qma1bfuubpepKn7DLDy4NPSKDeT3S4VPCNhu6UmdGrb6YD'
    },
    8082: {
        name: 'Shardeum Sphinx 1.X',
        chain: 'Shardeum',
        icon: 'shardeum',
        rpc: ['https://sphinx.shardeum.org/'],
        faucets: ['https://faucet-sphinx.shardeum.org/'],
        nativeCurrency: { name: 'Shardeum SHM', symbol: 'SHM', decimals: 18 },
        infoURL: 'https://docs.shardeum.org/',
        shortName: 'Sphinx10',
        chainId: 8082,
        networkId: 8082,
        explorers: [
            {
                name: 'Shardeum Scan',
                url: 'https://explorer-sphinx.shardeum.org',
                standard: 'EIP3091'
            }
        ],
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/Qma1bfuubpepKn7DLDy4NPSKDeT3S4VPCNhu6UmdGrb6YD'
    },
    8083: {
        name: 'Shardeum Testnet',
        chain: 'ShardeumTestnet',
        icon: 'shardeum',
        rpc: ['https://api-testnet.shardeum.org/'],
        faucets: [],
        nativeCurrency: { name: 'Shardeum Test SHM', symbol: 'SHM', decimals: 18 },
        infoURL: 'https://docs.shardeum.org/',
        shortName: 'ShardeumTestnet',
        chainId: 8083,
        networkId: 8083,
        explorers: [
            {
                name: 'Shardeum Testnet Explorer',
                url: 'https://explorer-testnet.shardeum.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qma1bfuubpepKn7DLDy4NPSKDeT3S4VPCNhu6UmdGrb6YD'
    },
    8086: {
        name: 'Bitcoin Chain',
        chain: 'BTC',
        icon: 'BTCChain',
        rpc: ['https://rpc.bitcoinevm.org'],
        faucets: [],
        nativeCurrency: { name: 'Bitcoin', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://bitcoinevm.org',
        shortName: 'Bitcoin',
        chainId: 8086,
        networkId: 8086,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/bafkreib6is2nmoadrbvigzrd54z53eya5whfmyeukrl5mfxmskvbw5juxa'
    },
    8087: {
        name: 'E-Dollar',
        chain: 'USD',
        icon: 'edollar',
        rpc: ['https://rpc.e-dollar.org'],
        faucets: [],
        nativeCurrency: { name: 'E-Dollar', symbol: 'USD', decimals: 18 },
        infoURL: 'https://e-dollar.org',
        shortName: 'E-Dollar',
        chainId: 8087,
        networkId: 8087,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/bafkreic4aq265oaf6yze7ba5okefqh6vnqudyrz6ovukvbnrlhet36itle'
    },
    8098: {
        name: 'StreamuX Blockchain',
        chain: 'StreamuX',
        rpc: [
            'https://u0ma6t6heb:KDNwOsRDGcyM2Oeui1p431Bteb4rvcWkuPgQNHwB4FM@u0xy4x6x82-u0e2mg517m-rpc.us0-aws.kaleido.io/'
        ],
        faucets: [],
        nativeCurrency: { name: 'StreamuX', symbol: 'SmuX', decimals: 18 },
        infoURL: 'https://www.streamux.cloud',
        shortName: 'StreamuX',
        chainId: 8098,
        networkId: 8098
    },
    8099: {
        name: 'Bharat Blockchain Network Mainnet',
        chain: 'BBN',
        rpc: ['https://bbnrpc.mainnet.bharatblockchain.io'],
        faucets: [],
        nativeCurrency: { name: 'BBN', symbol: 'BBN', decimals: 18 },
        features: [],
        infoURL: 'https://bharatblockchain.io/',
        shortName: 'bbn',
        chainId: 8099,
        networkId: 8099,
        explorers: []
    },
    8108: {
        name: 'ZenChain',
        chain: 'ZTC',
        icon: 'zenchain',
        rpc: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'ZTC', symbol: 'ZTC', decimals: 18 },
        infoURL: 'https://zenchain.io',
        shortName: 'zen',
        chainId: 8108,
        networkId: 8108,
        slip44: 60,
        explorers: [],
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmSnaHBAeCQEaibgsGqU1enFFyWsq5Eh3dDSMBA1Qztj91'
    },
    8118: {
        name: 'Shardeum',
        chain: 'Shardeum',
        icon: 'shardeum',
        rpc: ['https://api.shardeum.org/'],
        faucets: [],
        nativeCurrency: { name: 'Shardeum', symbol: 'SHM', decimals: 18 },
        infoURL: 'https://docs.shardeum.org/',
        shortName: 'Shardeum',
        chainId: 8118,
        networkId: 8118,
        explorers: [
            {
                name: 'Shardeum Explorer',
                url: 'https://explorer.shardeum.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qma1bfuubpepKn7DLDy4NPSKDeT3S4VPCNhu6UmdGrb6YD'
    },
    8131: {
        name: 'Qitmeer Network Testnet',
        chain: 'MEER',
        rpc: [
            'https://testnet-qng.rpc.qitmeer.io',
            'https://testnet.meerlabs.com',
            'https://meer.testnet.meerfans.club'
        ],
        faucets: ['https://faucet.qitmeer.io'],
        nativeCurrency: { name: 'Qitmeer Testnet', symbol: 'MEER-T', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'meertest',
        chainId: 8131,
        networkId: 8131,
        slip44: 1,
        icon: 'meer',
        explorers: [
            {
                name: 'meerscan testnet',
                icon: 'meer',
                url: 'https://testnet-qng.qitmeer.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    8132: {
        name: 'Qitmeer Network Mixnet',
        chain: 'MEER',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Qitmeer Mixnet', symbol: 'MEER-M', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'meermix',
        icon: 'meer',
        chainId: 8132,
        networkId: 8132,
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    8133: {
        name: 'Qitmeer Network Privnet',
        chain: 'MEER',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Qitmeer Privnet', symbol: 'MEER-P', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'meerpriv',
        icon: 'meer',
        chainId: 8133,
        networkId: 8133,
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    8134: {
        name: 'Amana',
        chain: 'MEER',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Amana Mainnet', symbol: 'MEER', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'amana',
        icon: 'meer',
        chainId: 8134,
        networkId: 8134,
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    8135: {
        name: 'Flana',
        chain: 'MEER',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Flana Mainnet', symbol: 'MEER', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'flana',
        icon: 'meer',
        chainId: 8135,
        networkId: 8135,
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    8136: {
        name: 'Mizana',
        chain: 'MEER',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Mizana Mainnet', symbol: 'MEER', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'mizana',
        icon: 'meer',
        chainId: 8136,
        networkId: 8136,
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    8181: {
        name: 'Testnet BeOne Chain',
        chain: 'tBOC',
        rpc: ['https://pre-boc1.beonechain.com'],
        faucets: ['https://testnet.beonescan.com/faucet'],
        nativeCurrency: {
            name: 'Testnet BeOne Chain',
            symbol: 'tBOC',
            decimals: 18
        },
        infoURL: 'https://testnet.beonescan.com',
        shortName: 'tBOC',
        chainId: 8181,
        networkId: 8181,
        slip44: 1,
        icon: 'beonechain',
        explorers: [
            {
                name: 'Testnet BeOne Chain',
                url: 'https://testnet.beonescan.com',
                icon: 'beonechain',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbVLQnaMDu86bPyKgCvTGhFBeYwjr15hQnrCcsp1EkAGL'
    },
    8192: {
        name: 'Torus Mainnet',
        chain: 'TQF',
        icon: 'torus',
        rpc: ['https://rpc.toruschain.com'],
        faucets: [],
        nativeCurrency: { name: 'TQF', symbol: 'TQF', decimals: 18 },
        infoURL: 'https://docs.toruschain.com',
        shortName: 'tqf',
        chainId: 8192,
        networkId: 8192,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://toruscan.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidchntjaxmq52cuqqoalpajk5ssk4p77k7n4jgywqmkpldo5qgobm'
    },
    8194: {
        name: 'Torus Testnet',
        chain: 'TQF',
        icon: 'torus',
        rpc: ['https://rpc.testnet.toruschain.com'],
        faucets: [],
        nativeCurrency: { name: 'tTQF', symbol: 'TTQF', decimals: 18 },
        infoURL: 'https://docs.toruschain.com',
        shortName: 'ttqf',
        chainId: 8194,
        networkId: 8194,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet.toruscan.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidchntjaxmq52cuqqoalpajk5ssk4p77k7n4jgywqmkpldo5qgobm'
    },
    8217: {
        name: 'Kaia Mainnet',
        chain: 'KAIA',
        rpc: ['https://public-en.node.kaia.io'],
        faucets: [],
        nativeCurrency: { name: 'KAIA', symbol: 'KAIA', decimals: 18 },
        infoURL: 'https://kaia.io',
        shortName: 'kaia-mainnet',
        chainId: 8217,
        networkId: 8217,
        slip44: 8217,
        explorers: [
            {
                name: 'Kaiascope',
                url: 'https://kaiascope.com',
                standard: 'EIP3091'
            },
            {
                name: 'Kaiascan',
                url: 'https://kaiascan.io',
                standard: 'EIP3091'
            }
        ]
    },
    8227: {
        name: 'Space Subnet',
        chain: 'SPACE',
        rpc: ['https://subnets.avax.network/space/mainnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'FUEL', symbol: 'FUEL', decimals: 18 },
        infoURL: 'https://otherworld.network',
        shortName: 'space',
        chainId: 8227,
        networkId: 8227,
        explorers: [
            {
                name: 'SPACE Explorer',
                url: 'https://subnets.avax.network/space',
                standard: 'EIP3091'
            }
        ]
    },
    8272: {
        name: 'Blockton Blockchain',
        chain: 'Blockton Blockchain',
        icon: 'bton',
        rpc: ['https://rpc.blocktonscan.com/'],
        faucets: ['https://faucet.blocktonscan.com/'],
        nativeCurrency: { name: 'BLOCKTON', symbol: 'BTON', decimals: 18 },
        infoURL: 'https://blocktoncoin.com',
        shortName: 'BTON',
        chainId: 8272,
        networkId: 8272,
        explorers: [
            {
                name: 'Blockton Explorer',
                url: 'https://blocktonscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreig3hoedafisrgc6iffdo2jcblm6kov35h72gcblc3zkmt7t4ucwhy'
    },
    8285: {
        name: 'KorthoTest',
        chain: 'Kortho',
        rpc: ['https://www.krotho-test.net'],
        faucets: [],
        nativeCurrency: { name: 'Kortho Test', symbol: 'KTO', decimals: 11 },
        infoURL: 'https://www.kortho.io/',
        shortName: 'Kortho',
        chainId: 8285,
        networkId: 8285,
        slip44: 1
    },
    8329: {
        name: 'Lorenzo',
        chain: 'Lorenzo',
        rpc: ['https://rpc.lorenzo-protocol.xyz'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Lorenzo stBTC', symbol: 'stBTC', decimals: 18 },
        infoURL: 'https://www.lorenzo-protocol.xyz/',
        shortName: 'lrz',
        chainId: 8329,
        networkId: 8329,
        icon: 'lorenzo',
        explorers: [
            {
                name: 'Lorenzo Explorer',
                url: 'https://scan.lorenzo-protocol.xyz',
                standard: 'none',
                icon: 'lorenzo'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcwDCeZpzvRWBwtTgyEFv4tLJk6SFUb26rwsRXyJrhnP7'
    },
    8333: {
        name: 'B3',
        chain: 'B3',
        icon: 'b3',
        rpc: ['https://mainnet-rpc.b3.fun'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://b3.fun',
        shortName: 'b3',
        chainId: 8333,
        networkId: 8333,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.b3.fun',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme5W7SmKGv3gqciYFWuZvA4QKJAU2XKwSzC6cXLx7wGJu'
    },
    8386: {
        name: 'XProtocol',
        chain: 'XPROTOCOL',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Kick', symbol: 'KICK', decimals: 18 },
        shortName: 'xprotocol',
        chainId: 8386,
        networkId: 8386,
        status: 'incubating',
        parent: { type: 'L2', chain: 'eip155-8453' },
        infoURL: 'https://xprotocol.org/'
    },
    8387: {
        name: 'Dracones Financial Services',
        title: 'The Dracones Mainnet',
        chain: 'FUCK',
        rpc: ['https://api.dracones.net/'],
        faucets: [],
        nativeCurrency: {
            name: 'Functionally Universal Coin Kind',
            symbol: 'FUCK',
            decimals: 18
        },
        infoURL: 'https://wolfery.com',
        shortName: 'fuck',
        chainId: 8387,
        networkId: 8387,
        icon: 'dracones',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/bafybeibpyckp65pqjvrvqhdt26wqoqk55m6anshbfgyqnaemn6l34nlwya'
    },
    8408: {
        name: 'ZenChain Testnet',
        chain: 'ZTC',
        icon: 'zenchain',
        rpc: [
            'https://zenchain-testnet.api.onfinality.io/public',
            'wss://zenchain-testnet.api.onfinality.io/public-ws'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://facuet.zenchain.io'],
        nativeCurrency: { name: 'ZTC', symbol: 'ZTC', decimals: 18 },
        infoURL: 'https://zenchain.io',
        shortName: 'zentest',
        chainId: 8408,
        networkId: 8408,
        slip44: 60,
        explorers: [
            {
                name: 'zentrace',
                url: 'https://zentrace.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSnaHBAeCQEaibgsGqU1enFFyWsq5Eh3dDSMBA1Qztj91'
    },
    8428: {
        name: 'THAT Mainnet',
        chain: 'THAT',
        rpc: ['https://api.thatchain.io', 'https://api.thatchain.io/mainnet'],
        faucets: [],
        nativeCurrency: { name: 'THAT', symbol: 'THAT', decimals: 18 },
        infoURL: 'https://that.website',
        shortName: 'THAT',
        chainId: 8428,
        networkId: 8428,
        icon: 'that',
        explorers: [
            {
                name: 'THAT Explorer',
                url: 'https://that.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQM3TAFBskGGpog4EZkEGj2svtmTbxzcNZBcbWCMnu5JL'
    },
    8453: {
        name: 'Base',
        chain: 'ETH',
        rpc: [
            'https://mainnet.base.org/',
            'https://developer-access-mainnet.base.org/',
            'https://base.gateway.tenderly.co',
            'wss://base.gateway.tenderly.co',
            'https://base-rpc.publicnode.com',
            'wss://base-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://base.org',
        shortName: 'base',
        chainId: 8453,
        networkId: 8453,
        icon: 'base',
        explorers: [
            {
                name: 'basescan',
                url: 'https://basescan.org',
                standard: 'EIP3091'
            },
            {
                name: 'basescout',
                url: 'https://base.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            },
            {
                name: 'dexguru',
                url: 'https://base.dex.guru',
                icon: 'dexguru',
                standard: 'EIP3091'
            },
            {
                name: 'Routescan',
                url: 'https://base.superscan.network',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmaxRoHpxZd8PqccAynherrMznMufG6sdmHZLihkECXmZv'
    },
    8545: {
        name: 'Chakra Testnet',
        chain: 'Chakra Testnet',
        rpc: ['https://rpcv1-dn-1.chakrachain.io/'],
        faucets: [],
        nativeCurrency: { name: 'Chakra', symbol: 'CKR', decimals: 18 },
        infoURL: '',
        shortName: 'ChakraTN',
        chainId: 8545,
        networkId: 8545,
        explorers: []
    },
    8569: {
        name: 'New Reality Blockchain',
        chain: 'NEWRL',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'NewReal', symbol: 'NEWRL', decimals: 18 },
        features: [],
        infoURL: 'https://newreality.bond/',
        shortName: 'newrl',
        chainId: 8569,
        networkId: 8569,
        status: 'incubating'
    },
    8654: {
        name: 'Toki Network',
        chain: 'TOKI',
        rpc: ['https://mainnet.buildwithtoki.com/v0/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Toki', symbol: 'TOKI', decimals: 18 },
        infoURL: 'https://www.buildwithtoki.com',
        shortName: 'toki',
        chainId: 8654,
        networkId: 8654,
        icon: 'toki',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmbCBBH4dFHGr8u1yQspCieQG9hLcPFNYdRx1wnVsX8hUw'
    },
    8655: {
        name: 'Toki Testnet',
        chain: 'TOKI',
        rpc: ['https://testnet.buildwithtoki.com/v0/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Toki', symbol: 'TOKI', decimals: 18 },
        infoURL: 'https://www.buildwithtoki.com',
        shortName: 'toki-testnet',
        chainId: 8655,
        networkId: 8655,
        slip44: 1,
        icon: 'toki',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmbCBBH4dFHGr8u1yQspCieQG9hLcPFNYdRx1wnVsX8hUw'
    },
    8668: {
        name: 'Hela Official Runtime Mainnet',
        chain: 'Hela',
        icon: 'hela',
        rpc: ['https://mainnet-rpc.helachain.com'],
        faucets: [],
        nativeCurrency: { name: 'Hela HLUSD', symbol: 'HLUSD', decimals: 18 },
        infoURL: 'https://helalabs.com',
        shortName: 'hela',
        chainId: 8668,
        networkId: 8668,
        explorers: [
            {
                name: 'Hela Official Runtime Mainnet Explorer',
                url: 'https://mainnet-blockexplorer.helachain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQbUVcaxFwY8gqMq1Jeup4NEyivo12QYhbLvVRvgXRBFb'
    },
    8723: {
        name: 'TOOL Global Mainnet',
        chain: 'OLO',
        rpc: ['https://mainnet-web3.wolot.io'],
        faucets: [],
        nativeCurrency: { name: 'TOOL Global', symbol: 'OLO', decimals: 18 },
        infoURL: 'https://ibdt.io',
        shortName: 'olo',
        chainId: 8723,
        networkId: 8723,
        slip44: 479,
        explorers: [
            {
                name: 'OLO Block Explorer',
                url: 'https://www.olo.network',
                standard: 'EIP3091'
            }
        ]
    },
    8724: {
        name: 'TOOL Global Testnet',
        chain: 'OLO',
        rpc: ['https://testnet-web3.wolot.io'],
        faucets: ['https://testnet-explorer.wolot.io'],
        nativeCurrency: { name: 'TOOL Global', symbol: 'OLO', decimals: 18 },
        infoURL: 'https://testnet-explorer.wolot.io',
        shortName: 'tolo',
        chainId: 8724,
        networkId: 8724,
        slip44: 1
    },
    8726: {
        name: 'Storagechain Mainnet',
        chain: 'Storagechain',
        rpc: ['https://mainnet-validator.storagechain.io'],
        icon: 'storagechain',
        faucets: [],
        shortName: 'stor',
        nativeCurrency: { name: 'Storagechain', symbol: 'STOR', decimals: 18 },
        infoURL: 'https://storagechain.io/about-us',
        chainId: 8726,
        networkId: 8726,
        explorers: [
            {
                name: 'Storscan',
                url: 'https://explorer-storagechain.invo.zone/?network=StorageChain',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfN9r1S7FvzkbjqfNMdUikhHmCw5e6UqsTuRD51S8T6Cq'
    },
    8727: {
        name: 'Storagechain Testnet',
        chain: 'Storagechain',
        rpc: ['https://testnet-validator.storagechain.io'],
        icon: 'storagechain',
        faucets: [],
        nativeCurrency: { name: 'Storagechain', symbol: 'STOR', decimals: 18 },
        shortName: 'tstor',
        infoURL: 'https://storagechain.io/about-us',
        chainId: 8727,
        networkId: 8727,
        explorers: [
            {
                name: 'Storscan',
                url: 'https://explorer-storagechain.invo.zone/?network=StorageChain%20Testnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfN9r1S7FvzkbjqfNMdUikhHmCw5e6UqsTuRD51S8T6Cq'
    },
    8732: {
        name: 'Bullions Smart Chain',
        chain: 'Bullions',
        rpc: ['https://rpc.bullionsx.org'],
        faucets: [],
        nativeCurrency: { name: 'Bullions', symbol: 'BLN', decimals: 18 },
        infoURL: 'https://www.bullionsx.io',
        shortName: 'bln',
        chainId: 8732,
        networkId: 8732,
        slip44: 8732,
        explorers: [
            {
                name: 'Bullionscan',
                url: 'https://bullionscan.org',
                standard: 'EIP3091'
            }
        ]
    },
    8738: {
        name: 'Alph Network',
        chain: 'ALPH',
        rpc: ['https://rpc.alph.network', 'wss://rpc.alph.network'],
        faucets: [],
        nativeCurrency: { name: 'Alph Network', symbol: 'ALPH', decimals: 18 },
        infoURL: 'https://alph.network',
        shortName: 'alph',
        chainId: 8738,
        networkId: 8738,
        explorers: [
            {
                name: 'alphscan',
                url: 'https://explorer.alph.network',
                standard: 'EIP3091'
            }
        ]
    },
    8768: {
        name: 'TMY Chain',
        chain: 'TMY',
        icon: 'tmychain',
        rpc: ['https://node1.tmyblockchain.org/rpc'],
        faucets: ['https://faucet.tmychain.org/'],
        nativeCurrency: { name: 'TMY', symbol: 'TMY', decimals: 18 },
        infoURL: 'https://tmychain.org/',
        shortName: 'tmy',
        chainId: 8768,
        networkId: 8768,
        iconURL: 'https://ipfs.io/ipfs/Qmcd19ksUvNMD1XQFSC55jJhDPoF2zUzzV7woteFiugwBH'
    },
    8801: {
        name: 'Okto Testnet',
        chain: 'Okto',
        rpc: ['https://rpc.okto-testnet.zeeve.online'],
        faucets: ['https://faucet.okto-testnet.zeeve.online'],
        nativeCurrency: { name: 'Okto', symbol: 'OKTO', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: '',
        shortName: 'okto-testnet',
        chainId: 8801,
        networkId: 8801,
        explorers: [
            {
                name: 'Okto Testnet Explorer',
                url: 'https://explorer.okto-testnet.zeeve.online',
                standard: 'none'
            }
        ]
    },
    8811: {
        name: 'Haven1',
        chain: 'haven1',
        rpc: ['https://rpc.haven1.org'],
        faucets: [],
        nativeCurrency: { name: 'Haven1', symbol: 'H1', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.haven1.org',
        shortName: 'haven1',
        chainId: 8811,
        networkId: 8811,
        icon: 'haven1',
        explorers: [
            {
                name: 'Haven1 Explorer',
                url: 'https://explorer.haven1.org',
                icon: 'haven1',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreih4jq33lz2mjwvu62hmo2ptt277et5l6oqi5ejuyxv2dir2iohsai'
    },
    8822: {
        name: 'IOTA EVM',
        title: 'IOTA EVM',
        chain: 'IOTA EVM',
        rpc: [
            'https://json-rpc.evm.iotaledger.net',
            'wss://ws.json-rpc.evm.iotaledger.net'
        ],
        faucets: [],
        nativeCurrency: { name: 'IOTA', symbol: 'IOTA', decimals: 18 },
        infoURL: 'https://www.iota.org',
        shortName: 'iotaevm',
        chainId: 8822,
        networkId: 8822,
        icon: 'iotaevm',
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer.evm.iota.org',
                icon: 'iotaevm',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibky2sy6qhi6arktayvologkrgu5kudpgdxfkx4uosbvmstz7v4di'
    },
    8844: {
        name: 'Hydra Chain Testnet',
        chain: 'HYDRA',
        rpc: ['https://rpc-testnet.hydrachain.org'],
        faucets: ['https://testnetapp.hydrachain.org/faucet'],
        nativeCurrency: { name: 'tHydra', symbol: 'tHYDRA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://hydrachain.org',
        shortName: 'THYDRA',
        chainId: 8844,
        networkId: 8844,
        icon: 'hydra',
        explorers: [
            {
                name: 'Hydra Chain Testnet explorer',
                url: 'https://hydragon.hydrachain.org',
                icon: 'hydra',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVxyUjuA8t9q3oWDgv8ExqaUXcRuDqiKrZAiLaBWHYcmG'
    },
    8848: {
        name: 'MARO Blockchain Mainnet',
        chain: 'MARO Blockchain',
        icon: 'MARO',
        rpc: ['https://rpc-mainnet.ma.ro'],
        faucets: [],
        nativeCurrency: { name: 'MARO', symbol: 'MARO', decimals: 18 },
        infoURL: 'https://ma.ro/',
        shortName: 'maro',
        chainId: 8848,
        networkId: 8848,
        explorers: [
            {
                name: 'MARO Scan',
                url: 'https://scan.ma.ro/#',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreig47k53aipns6nu3u5fxpysp7mogzk6zyvatgpbam7yut3yvtuefa'
    },
    8866: {
        name: 'SuperLumio',
        chain: 'SuperLumio',
        icon: 'superlumio',
        rpc: ['https://mainnet.lumio.io/'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://lumio.io/',
        shortName: 'superlumio',
        chainId: 8866,
        networkId: 8866,
        explorers: [
            {
                name: 'Lumio explorer',
                url: 'https://explorer.lumio.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXiatdz5WBFypfsudoDsFnsLdiHzDwcD3pWcHwBovbPiZ'
    },
    8869: {
        name: 'Lif3 Chain',
        chain: 'lif3chain',
        rpc: ['https://rpc.lif3.com'],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: { name: 'LIF3', symbol: 'LIF3', decimals: 18 },
        infoURL: 'https://docs.lif3.com/',
        shortName: 'lif3-mainnet',
        icon: 'lif3',
        chainId: 8869,
        networkId: 8869,
        explorers: [
            {
                name: 'lif3scout',
                url: 'https://lif3scout.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQqNBEqNnNsaSV6rik6mM8VnaSgYFxfEkjkiXSwgmEgaH'
    },
    8880: {
        name: 'Unique',
        icon: 'unique',
        chain: 'UNQ',
        rpc: [
            'https://rpc.unique.network',
            'https://eu-rpc.unique.network',
            'https://asia-rpc.unique.network',
            'https://us-rpc.unique.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Unique', symbol: 'UNQ', decimals: 18 },
        infoURL: 'https://unique.network',
        shortName: 'unq',
        chainId: 8880,
        networkId: 8880,
        explorers: [
            {
                name: 'Unique Scan',
                url: 'https://uniquescan.io/unique',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbJ7CGZ2GxWMp7s6jy71UGzRsMe4w3KANKXDAExYWdaFR'
    },
    8881: {
        name: 'Quartz by Unique',
        icon: 'quartz',
        chain: 'UNQ',
        rpc: [
            'https://rpc-quartz.unique.network',
            'https://quartz.api.onfinality.io/public-ws',
            'https://eu-rpc-quartz.unique.network',
            'https://asia-rpc-quartz.unique.network',
            'https://us-rpc-quartz.unique.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Quartz', symbol: 'QTZ', decimals: 18 },
        infoURL: 'https://unique.network',
        shortName: 'qtz',
        chainId: 8881,
        networkId: 8881,
        explorers: [
            {
                name: 'Unique Scan / Quartz',
                url: 'https://uniquescan.io/quartz',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaGPdccULQEFcCGxzstnmE8THfac2kSiGwvWRAiaRq4dp'
    },
    8882: {
        name: 'Opal testnet by Unique',
        icon: 'opal',
        chain: 'UNQ',
        rpc: [
            'https://rpc-opal.unique.network',
            'https://us-rpc-opal.unique.network',
            'https://eu-rpc-opal.unique.network',
            'https://asia-rpc-opal.unique.network'
        ],
        faucets: ['https://t.me/unique2faucet_opal_bot'],
        nativeCurrency: { name: 'Opal', symbol: 'UNQ', decimals: 18 },
        infoURL: 'https://unique.network',
        shortName: 'opl',
        chainId: 8882,
        networkId: 8882,
        slip44: 1,
        explorers: [
            {
                name: 'Unique Scan / Opal',
                url: 'https://uniquescan.io/opal',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYJDpmWyjDa3H6BxweFmQXk4fU8b1GU7M9EqYcaUNvXzc'
    },
    8883: {
        name: 'Sapphire by Unique',
        icon: 'sapphire',
        chain: 'UNQ',
        rpc: [
            'https://rpc-sapphire.unique.network',
            'https://us-rpc-sapphire.unique.network',
            'https://eu-rpc-sapphire.unique.network',
            'https://asia-rpc-sapphire.unique.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Quartz', symbol: 'QTZ', decimals: 18 },
        infoURL: 'https://unique.network',
        shortName: 'sph',
        chainId: 8883,
        networkId: 8883,
        explorers: [
            {
                name: 'Unique Scan / Sapphire',
                url: 'https://uniquescan.io/sapphire',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmd1PGt4cDRjFbh4ihP5QKEd4XQVwN1MkebYKdF56V74pf'
    },
    8886: {
        name: 'Avenium Testnet',
        chain: 'AVE',
        rpc: [
            'https://eu-testnet.avenium.io/',
            'https://connect-testnet.avenium.io'
        ],
        faucets: ['https://faucet-testnet.avenium.io'],
        nativeCurrency: { name: 'Ave Native Token', symbol: 'tAVE', decimals: 18 },
        infoURL: 'https://avenium.io',
        shortName: 'tave',
        chainId: 8886,
        networkId: 8886,
        icon: 'avenium',
        status: 'incubating',
        explorers: [
            {
                name: 'Avenium Explorer Testnet',
                icon: 'avenium',
                url: 'https://testnet.avescan.net',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmU5yJvjdeVGzNutn2U6wLWfHDGsDafLfZg7HRJ8ji3yfJ'
    },
    8888: {
        name: 'XANAChain',
        chain: 'XANAChain',
        rpc: ['https://mainnet.xana.net/rpc'],
        faucets: [],
        nativeCurrency: { name: 'XETA', symbol: 'XETA', decimals: 18 },
        infoURL: 'https://xanachain.xana.net/',
        shortName: 'XANAChain',
        chainId: 8888,
        networkId: 8888,
        icon: 'xeta',
        explorers: [
            {
                name: 'XANAChain',
                url: 'https://xanachain.xana.net',
                standard: 'EIP3091'
            }
        ],
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/QmWGNfwJ9o2vmKD3E6fjrxpbFP8W5q45zmYzHHoXwqqAoj'
    },
    8889: {
        name: 'Vyvo Smart Chain',
        chain: 'VSC',
        rpc: ['https://vsc-dataseed.vyvo.org:8889'],
        faucets: [],
        nativeCurrency: { name: 'VSC', symbol: 'VSC', decimals: 18 },
        infoURL: 'https://vsc-dataseed.vyvo.org',
        shortName: 'vsc',
        chainId: 8889,
        networkId: 8889
    },
    8890: {
        name: 'Orenium Testnet Protocol',
        chain: 'ORE',
        rpc: [
            'https://rpc-dev-testnet.orenium.org/',
            'https://rpc-testnet.orenium.org/',
            'https://rpc-orc.oredex.finance',
            'https://testnet-rpc.oredex.finance',
            'https://oredex-node.oredex.finance'
        ],
        nativeCurrency: { name: 'ORENIUM', symbol: 'tORE', decimals: 18 },
        infoURL: 'https://orenium.org',
        shortName: 'tore',
        chainId: 8890,
        networkId: 8890,
        slip44: 1,
        icon: 'ore',
        faucets: ['https://faucetcoin.orenium.org'],
        explorers: [
            {
                name: 'ORE Testnet Explorer',
                icon: 'ore',
                url: 'https://testnet.oreniumscan.org',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXszYAtQxaFCG3s9vGHoLJnqxGJw2wTKNbruTJ8iDXU7K'
    },
    8898: {
        name: 'Mammoth Mainnet',
        title: 'Mammoth Chain',
        chain: 'MMT',
        rpc: [
            'https://dataseed.mmtscan.io',
            'https://dataseed1.mmtscan.io',
            'https://dataseed2.mmtscan.io'
        ],
        faucets: ['https://faucet.mmtscan.io/'],
        nativeCurrency: { name: 'Mammoth Token', symbol: 'MMT', decimals: 18 },
        infoURL: 'https://mmtchain.io/',
        shortName: 'mmt',
        chainId: 8898,
        networkId: 8898,
        icon: 'mmt',
        explorers: [
            {
                name: 'mmtscan',
                url: 'https://mmtscan.io',
                standard: 'EIP3091',
                icon: 'mmt'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaF5gi2CbDKsJ2UchNkjBqmWjv8JEDP3vePBmxeUHiaK4'
    },
    8899: {
        name: 'JIBCHAIN L1',
        chain: 'JBC',
        rpc: ['https://rpc-l1.jibchain.net', 'https://rpc-l1.inan.in.th'],
        faucets: [],
        icon: 'jbc',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'JIBCOIN', symbol: 'JBC', decimals: 18 },
        infoURL: 'https://jibchain.net',
        shortName: 'jbc',
        chainId: 8899,
        networkId: 8899,
        explorers: [
            {
                name: 'JIBCHAIN Explorer',
                url: 'https://exp-l1.jibchain.net',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWvTUSCcQ17mDiKg3w1X5nW3q4wZGuVsZ9vwzJ8S9oCns'
    },
    8911: {
        name: 'Algen',
        chain: 'ALG',
        rpc: ['https://rpc.algen.network'],
        faucets: [],
        nativeCurrency: { name: 'ALG', symbol: 'ALG', decimals: 18 },
        infoURL: 'https://www.algen.network',
        shortName: 'alg',
        chainId: 8911,
        networkId: 8911,
        icon: 'alg',
        explorers: [
            {
                name: 'algscan',
                url: 'https://scan.algen.network',
                icon: 'alg',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdSNGv2Atdaexawc4L3uAL7dL5aDREgWwPo2HNayQbpLm'
    },
    8912: {
        name: 'Algen Testnet',
        chain: 'ALG',
        rpc: ['https://rpc.test.algen.network'],
        faucets: [],
        nativeCurrency: { name: 'ALG', symbol: 'ALG', decimals: 18 },
        infoURL: 'https://www.algen.network',
        shortName: 'algTest',
        chainId: 8912,
        networkId: 8912,
        icon: 'alg',
        explorers: [
            {
                name: 'algscan',
                url: 'https://scan.test.algen.network',
                icon: 'alg',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdSNGv2Atdaexawc4L3uAL7dL5aDREgWwPo2HNayQbpLm'
    },
    8921: {
        name: 'Algen Layer2',
        chain: 'ALG L2',
        rpc: ['https://rpc.alg2.algen.network'],
        faucets: [],
        nativeCurrency: { name: 'ALG', symbol: 'ALG', decimals: 18 },
        infoURL: 'https://www.algen.network',
        shortName: 'algl2',
        chainId: 8921,
        networkId: 8921,
        icon: 'algl2',
        explorers: [
            {
                name: 'algl2scan',
                url: 'https://scan.alg2.algen.network',
                icon: 'algl2',
                standard: 'EIP3091'
            }
        ],
        parent: { chain: 'eip155-8911', type: 'shard' },
        iconURL: 'https://ipfs.io/ipfs/QmbLWspX1WryyfhiiuPpG5A7AGBJUvwdZtVPuzZoJyxS23'
    },
    8922: {
        name: 'Algen Layer2 Testnet',
        chain: 'ALG L2',
        rpc: ['https://rpc.alg2-test.algen.network'],
        faucets: [],
        nativeCurrency: { name: 'ALG', symbol: 'ALG', decimals: 18 },
        infoURL: 'https://www.algen.network',
        shortName: 'algl2Test',
        chainId: 8922,
        networkId: 8922,
        icon: 'algl2',
        explorers: [
            {
                name: 'algl2scan',
                url: 'https://scan.alg2-test.algen.network',
                icon: 'algl2',
                standard: 'EIP3091'
            }
        ],
        parent: { chain: 'eip155-8921', type: 'shard' },
        iconURL: 'https://ipfs.io/ipfs/QmbLWspX1WryyfhiiuPpG5A7AGBJUvwdZtVPuzZoJyxS23'
    },
    8989: {
        name: 'Giant Mammoth Mainnet',
        title: 'Giant Mammoth Chain',
        chain: 'GMMT',
        rpc: ['https://rpc-asia.gmmtchain.io'],
        faucets: [],
        nativeCurrency: {
            name: 'Giant Mammoth Coin',
            symbol: 'GMMT',
            decimals: 18
        },
        infoURL: 'https://gmmtchain.io/',
        shortName: 'gmmt',
        chainId: 8989,
        networkId: 8989,
        icon: 'gmmt',
        explorers: [
            {
                name: 'gmmtscan',
                url: 'https://scan.gmmtchain.io',
                standard: 'EIP3091',
                icon: 'gmmt'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVth4aPeskDTFqRifUugJx6gyEHCmx2PFbMWUtsCSQFkF'
    },
    8995: {
        name: 'bloxberg',
        chain: 'bloxberg',
        rpc: ['https://core.bloxberg.org'],
        faucets: ['https://faucet.bloxberg.org/'],
        nativeCurrency: { name: 'BERG', symbol: 'U+25B3', decimals: 18 },
        infoURL: 'https://bloxberg.org',
        shortName: 'berg',
        chainId: 8995,
        networkId: 8995
    },
    9000: {
        name: 'Evmos Testnet',
        chain: 'Evmos',
        rpc: [
            'https://evmos-testnet.lava.build',
            'https://eth.bd.evmos.dev:8545',
            'https://evmos-testnet-evm-rpc.publicnode.com',
            'wss://evmos-testnet-evm-rpc.publicnode.com'
        ],
        faucets: ['https://faucet.evmos.dev'],
        nativeCurrency: { name: 'test-Evmos', symbol: 'tEVMOS', decimals: 18 },
        infoURL: 'https://evmos.org',
        shortName: 'evmos-testnet',
        chainId: 9000,
        networkId: 9000,
        slip44: 1,
        icon: 'evmos',
        explorers: [
            {
                name: 'Evmos Explorer (Escan)',
                url: 'https://testnet.escan.live',
                standard: 'none',
                icon: 'evmos'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeZW6VKUFTbz7PPW8PmDR3ZHa6osYPLBFPnW8T5LSU49c'
    },
    9001: {
        name: 'Evmos',
        chain: 'Evmos',
        rpc: [
            'https://evmos.lava.build',
            'wss://evmos.lava.build/websocket',
            'https://evmos-evm-rpc.publicnode.com',
            'wss://evmos-evm-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Evmos', symbol: 'EVMOS', decimals: 18 },
        infoURL: 'https://evmos.org',
        shortName: 'evmos',
        chainId: 9001,
        networkId: 9001,
        icon: 'evmos',
        explorers: [
            {
                name: 'Evmos Explorer (Escan)',
                url: 'https://escan.live',
                standard: 'none',
                icon: 'evmos'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeZW6VKUFTbz7PPW8PmDR3ZHa6osYPLBFPnW8T5LSU49c'
    },
    9003: {
        name: 'Qubetics Alpha Testnet',
        chain: 'Qubetics Alpha Testnet',
        rpc: ['https://alphatestnet-evm-rpc.qubetics.work/'],
        faucets: ['https://alphatestnet-explorer.qubetics.work/faucet'],
        nativeCurrency: {
            name: 'Qubetics Testnet Token',
            symbol: 'TICS',
            decimals: 18
        },
        infoURL: 'https://www.qubetics.com/',
        shortName: 'QubeticsAlpha',
        chainId: 9003,
        networkId: 9003,
        icon: 'qubetics',
        explorers: [
            {
                name: 'Qubetics Alpha Testnet Explorer',
                url: 'https://alphatestnet-explorer.qubetics.work/dashboard',
                standard: 'none',
                icon: 'qubetics'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigsioq2bd4c6slficwtzjq6gbti2c4vhzjlsjtihz2b762j4zjqhy'
    },
    9007: {
        name: 'Shido Testnet Block',
        chain: 'Shido Testnet',
        rpc: [
            'https://rpc-testnet-nodes.shidoscan.com',
            'wss://wss-testnet-nodes.shidoscan.com'
        ],
        faucets: ['https://testnet.shidoscan.com/faucet'],
        nativeCurrency: {
            name: 'Shido Testnet Token',
            symbol: 'SHIDO',
            decimals: 18
        },
        infoURL: 'https://www.nexablock.io',
        shortName: 'ShidoTestnet',
        chainId: 9007,
        networkId: 9007,
        icon: 'shidoChain',
        explorers: [
            {
                name: 'Shidoblock Testnet Explorer',
                url: 'https://testnet.shidoscan.com',
                standard: 'none',
                icon: 'shidoChain'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiatrf5pp7ywvrwvsv4otrex73u6v6bvhorqkxiop2hy2i572zjrba'
    },
    9008: {
        name: 'Shido Network',
        chain: 'Shido Mainnet',
        rpc: [
            'https://shido-mainnet-archive-lb-nw5es9.zeeve.net/USjg7xqUmCZ4wCsqEOOE/rpc',
            'wss://shido-mainnet-archive-lb-nw5es9.zeeve.net/USjg7xqUmCZ4wCsqEOOE/ws',
            'https://evm.shidoscan.net',
            'wss://wss.shidoscan.net'
        ],
        faucets: [],
        nativeCurrency: { name: 'Shido', symbol: 'SHIDO', decimals: 18 },
        infoURL: 'https://shido.io',
        shortName: 'Shido',
        chainId: 9008,
        networkId: 9008,
        icon: 'shidoChain',
        explorers: [
            {
                name: 'Shidoscan',
                url: 'https://shidoscan.com',
                standard: 'none',
                icon: 'shidoChain'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiatrf5pp7ywvrwvsv4otrex73u6v6bvhorqkxiop2hy2i572zjrba'
    },
    9012: {
        name: 'BerylBit Mainnet',
        chain: 'BRB',
        rpc: ['https://mainnet.berylbit.io'],
        faucets: ['https://t.me/BerylBit'],
        nativeCurrency: {
            name: 'BerylBit Chain Native Token',
            symbol: 'BRB',
            decimals: 18
        },
        infoURL: 'https://www.beryl-bit.com',
        shortName: 'brb',
        chainId: 9012,
        networkId: 9012,
        icon: 'berylbit',
        explorers: [
            {
                name: 'berylbit-explorer',
                url: 'https://explorer.berylbit.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeDXHkpranzqGN1BmQqZSrFp4vGXf4JfaB5iq8WHHiwDi'
    },
    9024: {
        name: 'Nexa Testnet Block',
        chain: 'Nexa Testnet',
        rpc: ['https://rpc-testnet-nodes.nexablockscan.io'],
        faucets: ['https://testnet.nexablockscan.io/faucet'],
        nativeCurrency: {
            name: 'Nexa Testnet Token',
            symbol: 'NEXB',
            decimals: 18
        },
        infoURL: 'https://www.nexablock.io',
        shortName: 'NexaTestnet',
        chainId: 9024,
        networkId: 9024,
        icon: 'nexaChain',
        explorers: [
            {
                name: 'Nexablock Testnet Explorer',
                url: 'https://testnet.nexablockscan.io',
                standard: 'none',
                icon: 'nexaChain'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreib2t2lcaoh6iixrx4gjjvepws5tlsszfla5hb36b3mgyq7clve35y'
    },
    9025: {
        name: 'Nexa Mainnet Block',
        chain: 'Nexa Mainnet',
        rpc: [
            'https://rpc-nodes.nexablockscan.io',
            'wss://wss-nodes.nexablockscan.io',
            'https://rpc-nodes-delta.nexablockscan.io'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'Nexa Mainnet Token',
            symbol: 'NEXB',
            decimals: 18
        },
        infoURL: 'https://www.nexablock.io',
        shortName: 'Nexa',
        chainId: 9025,
        networkId: 9025,
        icon: 'nexaChain',
        explorers: [
            {
                name: 'Nexablock Mainnet Explorer',
                url: 'https://nexablockscan.io',
                standard: 'none',
                icon: 'nexaChain'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreib2t2lcaoh6iixrx4gjjvepws5tlsszfla5hb36b3mgyq7clve35y'
    },
    9029: {
        name: 'Qubetics Testnet',
        chain: 'Qubetics Testnet',
        rpc: ['https://rpc-testnet.qubetics.work/'],
        faucets: ['https://testnet.qubetics.work/faucet'],
        nativeCurrency: {
            name: 'Qubetics Testnet Token',
            symbol: 'TICS',
            decimals: 18
        },
        infoURL: 'https://www.qubetics.com/',
        shortName: 'Qubetics',
        chainId: 9029,
        networkId: 9029,
        icon: 'qubetics',
        explorers: [
            {
                name: 'Qubetics Testnet Explorer',
                url: 'https://testnet.qubetics.work',
                standard: 'none',
                icon: 'qubetics'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigsioq2bd4c6slficwtzjq6gbti2c4vhzjlsjtihz2b762j4zjqhy'
    },
    9069: {
        name: 'Apex Fusion - Nexus Mainnet',
        chain: 'Nexus Mainnet',
        rpc: ['https://rpc.nexus.mainnet.apexfusion.org/'],
        faucets: [],
        nativeCurrency: { name: 'Apex Fusion Token', symbol: 'AP3X', decimals: 18 },
        infoURL: 'https://apexfusion.org/',
        features: [{ name: 'EIP155' }],
        shortName: 'AP3X',
        chainId: 9069,
        networkId: 9069,
        icon: 'apexfusion',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmSnqLVwFyeX9AZDvBKVS7diDf2Xb7m9nDcamGgpCMhL3d'
    },
    9070: {
        name: 'Apex Fusion - Nexus testnet',
        chain: 'Nexus testnet',
        rpc: ['https://rpc.nexus.testnet.apexfusion.org/'],
        faucets: [],
        nativeCurrency: {
            name: 'Apex Fusion Token',
            symbol: 'tAP3X',
            decimals: 18
        },
        infoURL: 'https://apexfusion.org/',
        features: [{ name: 'EIP155' }],
        shortName: 'tAP3X',
        chainId: 9070,
        networkId: 9070,
        icon: 'apexfusion',
        explorers: [
            {
                name: 'apexfusion',
                url: 'https://explorer.nexus.testnet.apexfusion.org',
                icon: 'apexfusion',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSnqLVwFyeX9AZDvBKVS7diDf2Xb7m9nDcamGgpCMhL3d'
    },
    9090: {
        name: 'Inco Gentry Testnet',
        chain: 'INCO',
        rpc: ['https://testnet.inco.org'],
        faucets: ['https://faucet.inco.org'],
        nativeCurrency: { name: 'INCO', symbol: 'INCO', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.inco.org',
        shortName: 'inco-gentry',
        chainId: 9090,
        networkId: 9090,
        explorers: [
            {
                name: 'Inco Gentry Testnet Explorer',
                url: 'https://explorer.testnet.inco.org',
                standard: 'EIP3091'
            }
        ]
    },
    9091: {
        name: 'KPA Smart Chain Testnet',
        chain: 'KSC',
        rpc: [
            'https://tkpa-rpc1.kpachain.com/',
            'https://tkpa-rpc2.kpachain.com/',
            'https://tkpa-rpc3.kpachain.com/',
            'https://tkpa-rpc4.kpachain.com/',
            'https://testnet-rpc1.kpascan.com/',
            'https://testnet-rpc2.kpascan.com/',
            'https://testnet-rpc3.kpascan.com/',
            'https://testnet-rpc4.kpascan.com/'
        ],
        faucets: ['https://mint.kpachain.com'],
        nativeCurrency: {
            name: 'KPA Smart Chain Testnet',
            symbol: 'tKPA',
            decimals: 18
        },
        features: [],
        infoURL: 'https://kpachain.com',
        shortName: 'KPA',
        chainId: 9091,
        networkId: 9091,
        icon: 'koppa',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmbEzU7QQ4uJR2XTmkGAW9GNEsTMt6o8oYshPVeWVbSGaC'
    },
    9100: {
        name: 'Genesis Coin',
        chain: 'Genesis',
        rpc: ['https://genesis-gn.com', 'wss://genesis-gn.com'],
        faucets: [],
        nativeCurrency: { name: 'GN Coin', symbol: 'GNC', decimals: 18 },
        infoURL: 'https://genesis-gn.com',
        shortName: 'GENEC',
        chainId: 9100,
        networkId: 9100
    },
    9108: {
        name: 'Destra Dubai Testnet',
        chain: 'Destra',
        status: 'active',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Sync', symbol: 'SYNC', decimals: 18 },
        infoURL: '',
        shortName: 'Destra',
        chainId: 9108,
        networkId: 9108,
        slip44: 1,
        explorers: [],
        parent: { type: 'L2', chain: 'eip155-4', bridges: [] }
    },
    9170: {
        name: 'Rinia Testnet Old',
        chain: 'FIRE',
        icon: 'rinia',
        rpc: [],
        faucets: ['https://faucet.thefirechain.com'],
        nativeCurrency: { name: 'Firechain', symbol: 'FIRE', decimals: 18 },
        infoURL: 'https://thefirechain.com',
        shortName: '_old_tfire',
        chainId: 9170,
        networkId: 9170,
        slip44: 1,
        explorers: [],
        status: 'deprecated',
        iconURL: 'https://ipfs.io/ipfs/QmRnnw2gtbU9TWJMLJ6tks7SN6HQV5rRugeoyN6csTYHt1'
    },
    9223: {
        name: 'Codefin Mainnet',
        chain: 'COF',
        icon: 'codefin',
        rpc: ['https://chain-rpc.codefin.pro'],
        faucets: [],
        nativeCurrency: { name: 'Codefin', symbol: 'COF', decimals: 18 },
        infoURL: 'https://network.codefin.pro',
        shortName: 'COF',
        chainId: 9223,
        networkId: 9223,
        explorers: [
            {
                name: 'Codefin Net Explorer',
                url: 'https://explorer.codefin.pro',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVyAuAnKKNnGEpqeYMLPRfMdysLgPBTZeEXihXbRytGhp'
    },
    9302: {
        name: 'Galactica-Reticulum',
        chain: 'Galactica Testnet',
        rpc: ['https://evm-rpc-http-reticulum.galactica.com/'],
        faucets: [],
        nativeCurrency: {
            name: 'Galactica Reticulum',
            symbol: 'GNET',
            decimals: 18
        },
        infoURL: 'https://galactica.com',
        shortName: 'GNET',
        chainId: 9302,
        networkId: 9302,
        explorers: [
            {
                name: 'Galactica-Reticulum Explorer',
                url: 'https://explorer-reticulum.galactica.com',
                standard: 'EIP3091'
            }
        ]
    },
    9339: {
        name: 'Dogcoin Testnet',
        chain: 'DOGS',
        icon: 'dogs',
        rpc: ['https://testnet-rpc.dogcoin.me'],
        faucets: ['https://faucet.dogcoin.network'],
        nativeCurrency: { name: 'Dogcoin', symbol: 'DOGS', decimals: 18 },
        infoURL: 'https://dogcoin.network',
        shortName: 'DOGSt',
        chainId: 9339,
        networkId: 9339,
        slip44: 1,
        explorers: [
            {
                name: 'Dogcoin',
                url: 'https://testnet.dogcoin.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZCadkExKThak3msvszZjo6UnAbUJKE61dAcg4TixuMC3'
    },
    9369: {
        name: 'Z Chain',
        title: 'Z Chain',
        chain: 'Z',
        rpc: ['https://rpc.zchain.org'],
        faucets: [],
        features: [{ name: 'EIP155' }],
        nativeCurrency: { name: 'Z', symbol: 'Z', decimals: 18 },
        infoURL: 'https://zero.tech',
        shortName: 'z',
        chainId: 9369,
        networkId: 9369,
        icon: 'z',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://zscan.live',
                icon: 'z',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'bridge.zchain.org' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafybeiech76mp6ro4lo7pyferpovrnvghwb745upatj5h6be4cnav52zwu'
    },
    9372: {
        name: 'Oasys Testnet',
        chain: 'Oasys',
        icon: 'oasys',
        rpc: ['https://rpc.testnet.oasys.games'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://oasys.games',
        shortName: 'OAS_TEST',
        chainId: 9372,
        networkId: 9372,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.testnet.oasys.games',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVjT18MJ7S965w5oTce5D3KPbzfoGGaKaNDKJcfGfSNWm'
    },
    9393: {
        name: 'Dela Sepolia Testnet',
        chain: 'ETH',
        rpc: ['https://sepolia-dela.deperp.com'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.deperp.com/dela',
        shortName: 'delasep',
        chainId: 9393,
        networkId: 9393,
        slip44: 1,
        icon: 'delaTestnet',
        explorers: [
            {
                name: 'basescout',
                url: 'https://sepolia-delascan.deperp.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZQbfJfxYez8iQyVsB65y7ZTssKbgUpMXzPTEk5xGDwQB'
    },
    9395: {
        name: 'Evoke Mainnet',
        chain: 'MTHN',
        icon: 'mthn',
        rpc: ['https://mainnet-rpc.evokescan.org'],
        faucets: [],
        nativeCurrency: { name: 'MTHN', symbol: 'MTHN', decimals: 18 },
        infoURL: 'https://explorer.evokescan.org',
        shortName: 'MTHN',
        chainId: 9395,
        networkId: 9395,
        explorers: [
            {
                name: 'Evoke SmartChain Explorer',
                url: 'https://explorer.evokescan.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreia5q26knsvxgkwxze7woepvsqat5n2hodokh4ozzphmhexqez5s34'
    },
    9496: {
        name: 'Load Alphanet',
        chain: 'LOAD',
        rpc: ['https://alphanet.load.network'],
        faucets: ['https://load.network/faucet'],
        nativeCurrency: {
            name: 'Testnet Load Token',
            symbol: 'tLOAD',
            decimals: 18
        },
        infoURL: 'https://load.network',
        shortName: 'tload',
        chainId: 9496,
        networkId: 9496,
        icon: 'loadnetwork',
        explorers: [
            {
                name: 'Load Network Explorer',
                url: 'https://explorer.load.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidgb2du22hxgj23jhyi2gipiovejn75cp6agmrklhxclu63v5pjxu'
    },
    9527: {
        name: 'Rangers Protocol Testnet Robin',
        chain: 'Rangers',
        icon: 'rangers',
        rpc: ['https://robin.rangersprotocol.com/api/jsonrpc'],
        faucets: ['https://robin-faucet.rangersprotocol.com'],
        nativeCurrency: {
            name: 'Rangers Protocol Gas',
            symbol: 'tRPG',
            decimals: 18
        },
        infoURL: 'https://rangersprotocol.com',
        shortName: 'trpg',
        chainId: 9527,
        networkId: 9527,
        slip44: 1,
        explorers: [
            {
                name: 'rangersscan-robin',
                url: 'https://robin-rangersscan.rangersprotocol.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXR5e5SDABWfQn6XT9uMsVYAo5Bv7vUv4jVs8DFqatZWG'
    },
    9528: {
        name: 'QEasyWeb3 Testnet',
        chain: 'QET',
        rpc: ['https://qeasyweb3.com'],
        faucets: ['http://faucet.qeasyweb3.com'],
        nativeCurrency: { name: 'QET', symbol: 'QET', decimals: 18 },
        infoURL: 'https://www.qeasyweb3.com',
        shortName: 'QETTest',
        chainId: 9528,
        networkId: 9528,
        slip44: 1,
        explorers: [
            {
                name: 'QEasyWeb3 Explorer',
                url: 'https://www.qeasyweb3.com',
                standard: 'EIP3091'
            }
        ]
    },
    9559: {
        name: 'Neonlink Testnet',
        chain: 'Neonlink',
        rpc: ['https://testnet.neonlink.io'],
        faucets: ['https://faucet.neonlink.io/'],
        nativeCurrency: {
            name: 'Neonlink Native Token',
            symbol: 'tNEON',
            decimals: 18
        },
        infoURL: 'https://neonlink.io',
        shortName: 'testneon',
        chainId: 9559,
        networkId: 9559,
        slip44: 1,
        icon: 'neonlink',
        explorers: [
            {
                name: 'Neon Blockchain Explorer',
                url: 'https://testnet-scan.neonlink.io',
                standard: 'EIP3091',
                icon: 'neonlink'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmX3hBv8WyvVfYjh1gmgDfJCpJBvKk4TYG9wFX9sC8WAjz'
    },
    9696: {
        name: 'Rebus Mainnet',
        title: 'Rebuschain Mainnet',
        chain: 'ETH',
        rpc: ['https://apievml2.rebuschain.com/l2rpc'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.rebuschain.com',
        shortName: 'rebus',
        chainId: 9696,
        networkId: 9696,
        icon: 'rebus',
        explorers: [
            {
                name: 'Rebus EVM Explorer (Blockscout)',
                url: 'https://evm.rebuschain.com',
                icon: 'rebus',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifzag46dhp33vb2uldg4htqbqipuqrapjga6ml6pnhn5yibbvb4gq'
    },
    9700: {
        name: 'Oort MainnetDev',
        title: 'Oort MainnetDev',
        chain: 'MainnetDev',
        rpc: ['https://dev-rpc.oortech.com'],
        faucets: [],
        nativeCurrency: { name: 'Oort', symbol: 'OORT', decimals: 18 },
        infoURL: 'https://oortech.com',
        shortName: 'MainnetDev',
        chainId: 9700,
        networkId: 9700,
        icon: 'oort',
        explorers: [
            {
                name: 'Oort MainnetDev Scan',
                url: 'https://dev-scan.oortech.com',
                standard: 'none',
                icon: 'oort'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidrbvklkb52sgmg7cmy42fhf7vqpig7qj7bnrq24ijdwywkzr2tfy'
    },
    9728: {
        name: 'Boba BNB Testnet',
        chain: 'Boba BNB Testnet',
        rpc: [
            'https://testnet.bnb.boba.network',
            'wss://wss.testnet.bnb.boba.network',
            'https://replica.testnet.bnb.boba.network',
            'wss://replica-wss.testnet.bnb.boba.network',
            'https://boba-bnb-testnet.gateway.tenderly.co',
            'wss://boba-bnb-testnet.gateway.tenderly.co'
        ],
        faucets: [],
        nativeCurrency: { name: 'Boba Token', symbol: 'BOBA', decimals: 18 },
        infoURL: 'https://boba.network',
        shortName: 'BobaBnbTestnet',
        chainId: 9728,
        networkId: 9728,
        slip44: 1,
        explorers: [
            {
                name: 'Boba BNB Testnet block explorer',
                url: 'https://testnet.bobascan.com',
                standard: 'none'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-28882',
            bridges: [{ url: 'https://gateway.boba.network' }]
        }
    },
    9768: {
        name: 'MainnetZ Testnet',
        chain: 'NetZ',
        icon: 'mainnetzTestnet',
        rpc: ['https://testnet-rpc.mainnetz.io'],
        faucets: ['https://faucet.mainnetz.io'],
        nativeCurrency: { name: 'MainnetZ', symbol: 'NetZ', decimals: 18 },
        infoURL: 'https://testnet.mainnetz.io',
        shortName: 'NetZt',
        chainId: 9768,
        networkId: 9768,
        slip44: 1,
        explorers: [
            {
                name: 'MainnetZ',
                url: 'https://testnet.mainnetz.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmT5gJ5weBiLT3GoYuF5yRTRLdPLCVZ3tXznfqW7M8fxgG'
    },
    9779: {
        name: 'PepeNetwork Mainnet',
        chain: 'PepeNetwork',
        rpc: ['https://rpc-mainnet.pepenetwork.io'],
        faucets: [],
        nativeCurrency: { name: 'Pepe', symbol: 'WPEPE', decimals: 18 },
        infoURL: 'https://pepenetwork.io',
        shortName: 'pn',
        chainId: 9779,
        networkId: 9779,
        icon: 'pepenetwork',
        explorers: [
            {
                name: 'Pepe Explorer',
                url: 'https://explorer.pepenetwork.io',
                icon: 'pepenetwork',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPX3uipdwd195z1MJff7uj8hpZdSuVvM5z47eiz2o7Gz5'
    },
    9788: {
        name: 'Tabi Testnetv2',
        chain: 'TabiNetworkv2',
        rpc: ['https://rpc.testnetv2.tabichain.com'],
        faucets: ['https://carnival.tabichain.com'],
        nativeCurrency: { name: 'Tabi', symbol: 'TABI', decimals: 18 },
        infoURL: 'https://www.tabichain.com',
        shortName: 'tabitestv2',
        chainId: 9788,
        networkId: 9788,
        explorers: [
            {
                name: 'Tabi Testnet V2 Explorer',
                url: 'https://testnetv2.tabiscan.com',
                standard: 'none'
            }
        ]
    },
    9789: {
        name: 'Tabi Testnet',
        chain: 'TabiNetwork',
        rpc: ['https://rpc.testnet.tabichain.com'],
        faucets: ['https://faucet.testnet.tabichain.com'],
        nativeCurrency: { name: 'Tabi', symbol: 'TABI', decimals: 18 },
        infoURL: 'https://www.tabichain.com',
        shortName: 'tabitest',
        chainId: 9789,
        networkId: 9789,
        explorers: [
            {
                name: 'Tabi Testnet Explorer',
                url: 'https://testnet.tabiscan.com',
                standard: 'none'
            }
        ]
    },
    9790: {
        name: 'Carbon EVM',
        chain: 'Carbon',
        icon: 'carbon',
        rpc: ['https://evm-api.carbon.network/'],
        faucets: [],
        nativeCurrency: { name: 'swth', symbol: 'SWTH', decimals: 18 },
        infoURL: 'https://carbon.network/',
        shortName: 'carbon',
        chainId: 9790,
        networkId: 9790,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmQUHqi1gyuTuKmJQHqt9EyhN1FPmmmLNUK8u93nMGrxAy'
    },
    9792: {
        name: 'Carbon EVM Testnet',
        chain: 'Carbon',
        icon: 'carbon',
        rpc: ['https://test-evm-api.carbon.network/'],
        faucets: [],
        nativeCurrency: { name: 'swth', symbol: 'SWTH', decimals: 18 },
        infoURL: 'https://carbon.network/',
        shortName: 'carbon-testnet',
        chainId: 9792,
        networkId: 9792,
        slip44: 1,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmQUHqi1gyuTuKmJQHqt9EyhN1FPmmmLNUK8u93nMGrxAy'
    },
    9797: {
        name: 'OptimusZ7 Mainnet',
        chain: 'OptimusZ7',
        icon: 'OZ7Icon',
        rpc: ['https://rpc.optimusz7.com'],
        faucets: [],
        nativeCurrency: { name: 'OptimusZ7', symbol: 'OZ7', decimals: 18 },
        infoURL: 'http://optimusz7.com',
        shortName: 'OZ7m',
        chainId: 9797,
        networkId: 9797,
        explorers: [
            {
                name: 'OptimusZ7 Mainnet Explorer',
                url: 'https://explorer.optimusz7.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmerd9Q3otjDuQAFbdiQyUnZk7UfPvkCr21E5N4VCNvhbj'
    },
    9818: {
        name: 'IMPERIUM TESTNET',
        chain: 'tIMP',
        rpc: [
            'https://data-aws-testnet.imperiumchain.com',
            'https://data-aws2-testnet.imperiumchain.com'
        ],
        faucets: ['https://faucet.imperiumchain.com/'],
        nativeCurrency: { name: 'tIMP', symbol: 'tIMP', decimals: 18 },
        infoURL: 'https://imperiumchain.com',
        shortName: 'tIMP',
        chainId: 9818,
        networkId: 9818,
        slip44: 1,
        icon: 'timp',
        explorers: [
            {
                name: 'IMPERIUM TESTNET Explorer',
                icon: 'timp',
                url: 'https://network.impscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcNGLzKyc7Gu2dgpBFF6t3KJwFuKC79D56DW8GTc5DWRw'
    },
    9819: {
        name: 'IMPERIUM MAINNET',
        chain: 'IMP',
        rpc: [
            'https://data-aws-mainnet.imperiumchain.com',
            'https://data-aws2-mainnet.imperiumchain.com'
        ],
        faucets: ['https://faucet.imperiumchain.com/'],
        nativeCurrency: { name: 'IMP', symbol: 'IMP', decimals: 18 },
        infoURL: 'https://imperiumchain.com',
        shortName: 'IMP',
        chainId: 9819,
        networkId: 9819,
        icon: 'imp',
        explorers: [
            {
                name: 'IMPERIUM Explorer',
                icon: 'imp',
                url: 'https://impscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcNGLzKyc7Gu2dgpBFF6t3KJwFuKC79D56DW8GTc5DWRw'
    },
    9876: {
        name: 'BinaryChain Testnet',
        chain: 'BinaryChain',
        icon: 'binary',
        rpc: ['https://rpctestnet.binarychain.org'],
        faucets: ['https://faucet.testnet.binarychain.org'],
        nativeCurrency: { name: 'BINARY', symbol: 'BNRY', decimals: 18 },
        infoURL: 'https://binarychain.org',
        shortName: 'binarytestnet',
        chainId: 9876,
        networkId: 9876,
        explorers: [
            {
                name: 'BinaryChain Testnet Explorer',
                url: 'https://explorer.testnet.binarychain.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeifb4vnpn3jv7cfdlne2dwhe6agdnpgmu46a7nbc5divjuyaznkyay'
    },
    9888: {
        name: 'Dogelayer Mainnet',
        chain: 'Dogelayer',
        rpc: ['https://dl-rpc.dogelayer.org'],
        faucets: [],
        nativeCurrency: { name: 'Dogecoin', symbol: 'DOGE', decimals: 18 },
        infoURL: 'https://dogelayer.org',
        shortName: 'Dogelayer',
        chainId: 9888,
        networkId: 9888,
        explorers: [
            {
                name: 'Dogelayer mainnet explorer',
                url: 'https://dl-explorer.dogelayer.org',
                standard: 'EIP3091'
            }
        ]
    },
    9889: {
        name: 'pointledger',
        chain: 'pointledger',
        icon: 'pointledger',
        rpc: ['https://rpc.pointledger.net'],
        faucets: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'PLG', symbol: 'PLG', decimals: 18 },
        infoURL: 'https://pointledger.net',
        shortName: 'pointledger',
        chainId: 9889,
        networkId: 9889,
        explorers: [
            {
                name: 'pointledger Explorer',
                url: 'https://exp.pointledger.net',
                icon: 'pointledger',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmV1Q7Q9XKRin5C5Qg6TTb3BnqmC1Qb6jyebUbTMXGPV1L'
    },
    9897: {
        name: 'arena-z-testnet',
        title: 'Arena-Z-Testnet',
        chain: 'arena-z-testnet',
        rpc: [
            'https://rpc.arena-z.t.raas.gelato.cloud',
            'wss://ws.arena-z.t.raas.gelato.cloud'
        ],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        icon: 'arena-z',
        infoURL: 'https://raas.gelato.network/rollups/details/public/arena-z-testnet',
        faucets: [],
        shortName: 'arena-z-testnet',
        chainId: 9897,
        networkId: 9897,
        slip44: 60,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://arena-z.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [
                {
                    url: 'https://testnet-bridge.gelato.network/bridge/arena-z-testnet'
                }
            ]
        },
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/bafkreic2vglaqxdbk5u7uw4vgksxri5xcbrnlysam57dsob2uvr33dzoma'
    },
    9898: {
        name: 'Larissa Chain',
        title: 'Larissa Chain',
        chain: 'Larissa',
        rpc: ['https://rpc.larissa.network'],
        faucets: [],
        nativeCurrency: { name: 'Larissa', symbol: 'LRS', decimals: 18 },
        infoURL: 'https://larissa.network',
        shortName: 'lrs',
        chainId: 9898,
        networkId: 1,
        slip44: 9898,
        status: 'active',
        icon: 'larissa',
        explorers: [
            {
                name: 'Larissa Scan',
                url: 'https://scan.larissa.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZTWoZ3LvivSinaJ4aSwqU8pCXw8oSZNnUCh4wwXxtAoQ'
    },
    9901: {
        name: 'Zytron Linea Mainnet',
        chain: 'ETH',
        icon: 'zytron',
        rpc: ['https://rpc.zypher.network/'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://zytron.zypher.network/',
        shortName: 'zytron-linea',
        chainId: 9901,
        networkId: 9901,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.zypher.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmY9cfmkCxJfPwKfCv6aF6CNiMWM5aN3jUSTf4rMfxaaJd'
    },
    9911: {
        name: 'Espento Mainnet',
        chain: 'SPENT',
        rpc: ['https://rpc.escscan.com/'],
        faucets: [],
        nativeCurrency: { name: 'ESPENTO', symbol: 'SPENT', decimals: 18 },
        infoURL: 'https://espento.network',
        shortName: 'spent',
        chainId: 9911,
        networkId: 9911,
        icon: 'espento',
        explorers: [
            {
                name: 'escscan',
                url: 'https://escscan.com',
                icon: 'espento',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVvQdmAj6GNQjP1dsxQKbA7xgzqsciooGTQtQ2RsJ37Lf'
    },
    9966: {
        name: 'UXER TESTNET NETWORK',
        chain: 'UXER',
        rpc: [
            'https://dev-testnet.uxer.network',
            'https://data-cloud-testnet.uxer.network'
        ],
        faucets: ['https://faucet.uxer.network'],
        nativeCurrency: { name: 'UXER', symbol: 'tUXER', decimals: 18 },
        infoURL: 'https://uxer.network',
        shortName: 'uxer',
        chainId: 9966,
        networkId: 9966,
        slip44: 1,
        icon: 'uxer',
        explorers: [
            {
                name: 'UXER TESTNET EXPLORER',
                icon: 'uxer',
                url: 'https://testnet.uxer.network',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQurJBRScSDar6oDJ4pAeKKvzHr49KJfS1iuCkbtiNe4x'
    },
    9977: {
        name: 'Mind Smart Chain Testnet',
        chain: 'tMIND',
        icon: 'mindchain',
        rpc: [
            'https://testnet-msc.mindchain.info/',
            'wss://testnet-msc.mindchain.info/ws'
        ],
        faucets: ['https://faucet.mindchain.info/'],
        nativeCurrency: { name: 'MIND Coin', symbol: 'tMIND', decimals: 18 },
        infoURL: 'https://mindchain.info',
        shortName: 'tMIND',
        chainId: 9977,
        networkId: 9977,
        slip44: 1,
        explorers: [
            {
                name: 'Mind Chain explorer',
                url: 'https://testnet.mindscan.info',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmX2b4CzNyrNgy4ERBEteSS9MsuYNVYeq2sSMMiogGjbFP'
    },
    9980: {
        name: 'Combo Mainnet',
        chain: 'Combo',
        icon: 'combo',
        rpc: ['https://rpc.combonetwork.io'],
        faucets: [],
        nativeCurrency: {
            name: 'BNB Chain Native Token',
            symbol: 'BNB',
            decimals: 18
        },
        infoURL: 'https://combonetwork.io',
        shortName: 'combo-mainnet',
        chainId: 9980,
        networkId: 9980,
        explorers: [
            {
                name: 'combotrace explorer',
                url: 'https://combotrace.nodereal.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRR4v6h6z21BpgS9xY3ExLB4Gkmm3i3dJWQx27oTGifq8'
    },
    9981: {
        name: 'Volley Mainnet',
        chain: 'Volley',
        icon: 'volley',
        rpc: ['https://main-rpc.volleychain.com'],
        faucets: [],
        nativeCurrency: { name: 'V2X', symbol: 'V2X', decimals: 18 },
        infoURL: 'https://www.volleychain.com',
        shortName: 'volley-mainnet',
        chainId: 9981,
        networkId: 9981,
        explorers: [
            {
                name: 'Volley Mainnet Explorer',
                url: 'https://volleyscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmd8hyeNQ2zvJh6b1F1A7ujKaDAoznqA9ejH2RJdRaimUk'
    },
    9982: {
        name: 'MFEV CHAIN MAINNET',
        chain: 'MFEV CHAIN',
        rpc: ['https://rpc.mfevscan.com'],
        faucets: [],
        nativeCurrency: { name: 'MFEV', symbol: 'MFEV', decimals: 18 },
        infoURL: 'https://mfevscan.com',
        shortName: 'mfevscan',
        chainId: 9982,
        networkId: 9982,
        slip44: 108,
        explorers: [
            {
                name: 'MFEV CHAIN',
                url: 'https://mfevscan.com',
                icon: 'mfev',
                standard: 'EIP3091'
            }
        ]
    },
    9990: {
        name: 'Agung Network',
        chain: 'Agung',
        icon: 'agung',
        rpc: ['https://wss-async.agung.peaq.network'],
        faucets: [],
        nativeCurrency: { name: 'Agung', symbol: 'AGNG', decimals: 18 },
        infoURL: 'https://www.peaq.network',
        shortName: 'AGNG',
        chainId: 9990,
        networkId: 9990,
        explorers: [
            {
                name: 'Polkadot.js',
                url: 'https://polkadot.js.org/apps/?rpc=wss:///wss-async.agung.peaq.network#/explorer',
                standard: 'none'
            },
            {
                name: 'Subscan',
                url: 'https://agung-testnet.subscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibkqdof3ztkdhgukwvkacwgrjb27e23hgz5c6mmudzu5hipyvgisa'
    },
    9996: {
        name: 'Mind Smart Chain Mainnet',
        chain: 'MIND',
        icon: 'mindchain',
        rpc: [
            'https://rpc-msc.mindchain.info/',
            'https://seednode.mindchain.info',
            'https://archive.mindchain.info/',
            'https://mind-smart-chain.rpc.thirdweb.com',
            'wss://archive.mindchain.info/ws',
            'wss://seednode.mindchain.info/ws'
        ],
        faucets: [],
        nativeCurrency: { name: 'MIND Coin', symbol: 'MIND', decimals: 18 },
        infoURL: 'https://mindchain.info',
        shortName: 'MIND',
        chainId: 9996,
        networkId: 9996,
        explorers: [
            {
                name: 'Mind Chain explorer',
                url: 'https://mainnet.mindscan.info',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmX2b4CzNyrNgy4ERBEteSS9MsuYNVYeq2sSMMiogGjbFP'
    },
    9997: {
        name: 'AltLayer Testnet',
        chain: 'ETH',
        rpc: ['https://testnet-rollup-api.altlayer.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://altlayer.io',
        shortName: 'alt-testnet',
        chainId: 9997,
        networkId: 9997,
        slip44: 1,
        icon: 'altlayer',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet-rollup-explorer.altlayer.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcEfZJU7NMn9ycTAcEooQgGNfa2nYBToSUZHdFCFadcjb'
    },
    9998: {
        name: 'Ztc Mainnet',
        chain: 'ZTC',
        rpc: ['https://zitcoin.us'],
        faucets: [],
        nativeCurrency: { name: 'Ztcer', symbol: 'ZTC', decimals: 5 },
        infoURL: 'https://ztc.best',
        shortName: 'ZTC',
        chainId: 9998,
        networkId: 9998
    },
    9999: {
        name: 'myOwn Testnet',
        chain: 'myOwn',
        rpc: ['https://geth.dev.bccloud.net'],
        faucets: [],
        nativeCurrency: { name: 'MYN', symbol: 'MYN', decimals: 18 },
        infoURL: 'https://docs.bccloud.net/',
        shortName: 'myn',
        chainId: 9999,
        networkId: 9999,
        slip44: 1
    },
    10000: {
        name: 'Smart Bitcoin Cash',
        chain: 'smartBCH',
        rpc: [
            'https://smartbch.greyh.at',
            'https://rpc-mainnet.smartbch.org',
            'https://smartbch.fountainhead.cash/mainnet',
            'https://smartbch.devops.cash/mainnet'
        ],
        faucets: [],
        nativeCurrency: { name: 'Bitcoin Cash', symbol: 'BCH', decimals: 18 },
        infoURL: 'https://smartbch.org/',
        shortName: 'smartbch',
        chainId: 10000,
        networkId: 10000
    },
    10001: {
        name: 'Smart Bitcoin Cash Testnet',
        chain: 'smartBCHTest',
        rpc: [
            'https://rpc-testnet.smartbch.org',
            'https://smartbch.devops.cash/testnet'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'Bitcoin Cash Test Token',
            symbol: 'BCHT',
            decimals: 18
        },
        infoURL: 'http://smartbch.org/',
        shortName: 'smartbchtest',
        chainId: 10001,
        networkId: 10001,
        slip44: 1
    },
    10010: {
        name: 'Warden Testnet',
        chain: 'WARD',
        rpc: [
            'https://evm.chiado.wardenprotocol.org',
            'wss://evm-ws.chiado.wardenprotocol.org'
        ],
        faucets: ['https://faucet.chiado.wardenprotocol.org'],
        nativeCurrency: { name: 'WARD', symbol: 'WARD', decimals: 18 },
        infoURL: 'https://wardenprotocol.org',
        icon: 'warden',
        shortName: 'ward',
        chainId: 10010,
        networkId: 10010,
        iconURL: 'https://ipfs.io/ipfs/Qmdz49xumH5yHb9jXKLR69Liv4STJQq5xW1g9xCQ9vJ3fB'
    },
    10011: {
        name: 'DeepSafe Beta Mainnet',
        chain: 'DeepSafe',
        rpc: ['https://betamainnet-rpc-node-http.deepsafe.network'],
        faucets: [],
        nativeCurrency: {
            name: 'DeepSafe Native Token',
            symbol: 'DEF',
            decimals: 18
        },
        infoURL: 'https://deepsafe.network/',
        shortName: 'DeepSafe',
        chainId: 10011,
        networkId: 10011,
        icon: 'deepsafe',
        iconURL: 'https://ipfs.io/ipfs/QmQJi1wfrLzywtbvNetvc6hV6SL825qvgZSKe3coJv8JNm'
    },
    10024: {
        name: 'Gon Chain',
        chain: 'GonChain',
        icon: 'gonchain',
        rpc: [
            'https://node1.testnet.gaiaopen.network',
            'https://node1.mainnet.gon.network',
            'https://node2.mainnet.gon.network',
            'https://node3.mainnet.gon.network',
            'https://node4.mainnet.gon.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Gon Token', symbol: 'GT', decimals: 18 },
        infoURL: '',
        shortName: 'gon',
        chainId: 10024,
        networkId: 10024,
        explorers: [
            {
                name: 'Gon Explorer',
                url: 'https://gonscan.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPtiJGaApbW3ATZhPW3pKJpw3iGVrRGsZLWhrDKF9ZK18'
    },
    10025: {
        name: 'AEON Chain',
        chain: 'AEON Chain',
        icon: 'aeon',
        rpc: ['https://node.aeon.xyz/rpc'],
        faucets: [],
        nativeCurrency: { name: 'AEON Token', symbol: 'AEON', decimals: 18 },
        infoURL: '',
        shortName: 'aeon',
        chainId: 10025,
        networkId: 10025,
        explorers: [
            {
                name: 'AEON Explorer',
                url: 'https://scan.aeon.xyz',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmeq49hbjDHYyWs4UyUHwwde5WUemJYJSLSXiik6up5NjE'
    },
    10066: {
        name: 'Chain Opera Testnet',
        chain: 'Chain Opera Testnet',
        rpc: ['http://40.78.123.6:8545'],
        faucets: [],
        nativeCurrency: { name: 'coai', symbol: 'CO', decimals: 18 },
        infoURL: 'https://chainopera.ai/',
        shortName: 'chainopera-testnet',
        chainId: 10066,
        networkId: 10066
    },
    10081: {
        name: 'Japan Open Chain Testnet',
        chain: 'JOCT',
        rpc: [
            'https://rpc-1.testnet.japanopenchain.org:8545',
            'https://rpc-2.testnet.japanopenchain.org:8545',
            'https://rpc-3.testnet.japanopenchain.org'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'Japan Open Chain Testnet Token',
            symbol: 'JOCT',
            decimals: 18
        },
        infoURL: 'https://www.japanopenchain.org/',
        shortName: 'joct',
        chainId: 10081,
        networkId: 10081,
        icon: 'joct',
        slip44: 1,
        explorers: [
            {
                name: 'Testnet Block Explorer',
                url: 'https://explorer.testnet.japanopenchain.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreih2t3wrflgcnha4aeonyn23h43rcbskatzvwliyatp5shudkwu2d4'
    },
    10085: {
        name: 'Volcano Chain Mainnet',
        chain: 'Volcano',
        icon: 'volcano',
        rpc: ['https://mainnet.vchain.pro', 'wss://wss.mainnet.vchain.pro'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Volcano Coin', symbol: 'VC', decimals: 18 },
        infoURL: 'https://vex.pro',
        shortName: 'volcanochain',
        chainId: 10085,
        networkId: 10085,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://vchainscan.com',
                icon: 'volcano',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihuzbawkb6ymsqrptcalixg6z4wom2dt4sqsfz7zs5abcyw23jfcu'
    },
    10086: {
        name: 'SJATSH',
        chain: 'ETH',
        rpc: ['http://geth.free.idcfengye.com'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://sjis.me',
        shortName: 'SJ',
        chainId: 10086,
        networkId: 10086
    },
    10096: {
        name: 'MetaNova Verse',
        chain: 'MNV',
        rpc: ['https://web3.metanovaverse.com'],
        faucets: [],
        nativeCurrency: { name: 'MNV', symbol: 'MNV', decimals: 18 },
        features: [],
        infoURL: 'https://metanovaverse.com/',
        shortName: 'mnv',
        chainId: 10096,
        networkId: 10096,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.metanovaverse.com',
                standard: 'EIP3091'
            },
            {
                name: 'Cosmos Explorer (Ping)',
                url: 'https://ping.metanovaverse.com/metanovaverse',
                standard: 'none'
            }
        ]
    },
    10101: {
        name: 'Blockchain Genesis Mainnet',
        chain: 'GEN',
        rpc: [
            'https://eu.mainnet.xixoio.com',
            'https://us.mainnet.xixoio.com',
            'https://asia.mainnet.xixoio.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'GEN', symbol: 'GEN', decimals: 18 },
        infoURL: 'https://www.xixoio.com/',
        shortName: 'GEN',
        chainId: 10101,
        networkId: 10101
    },
    10143: {
        name: 'Monad Testnet',
        chain: 'MON',
        icon: 'monad',
        rpc: ['https://testnet-rpc.monad.xyz'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Testnet MON Token', symbol: 'MON', decimals: 18 },
        infoURL: 'https://monad.xyz',
        shortName: 'mon-testnet',
        chainId: 10143,
        networkId: 10143,
        slip44: 1,
        explorers: [
            {
                name: 'Monad Testnet Explorer',
                url: 'https://testnet.monadexplorer.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreia4vjioitvcrm5umefahnp4wttswooykroarjo5itdvohvk6epiya'
    },
    10200: {
        name: 'Gnosis Chiado Testnet',
        chain: 'GNO',
        icon: 'gnosis',
        rpc: [
            'https://rpc.chiadochain.net',
            'https://rpc.chiado.gnosis.gateway.fm',
            'wss://rpc.chiadochain.net/wss',
            'https://gnosis-chiado-rpc.publicnode.com',
            'wss://gnosis-chiado-rpc.publicnode.com',
            'https://gnosis-chiado.drpc.org',
            'wss://gnosis-chiado.drpc.org'
        ],
        faucets: ['https://gnosisfaucet.com'],
        nativeCurrency: { name: 'Chiado xDAI', symbol: 'XDAI', decimals: 18 },
        infoURL: 'https://docs.gnosischain.com',
        shortName: 'chi',
        chainId: 10200,
        networkId: 10200,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout-chiadochain',
                url: 'https://blockscout.chiadochain.net',
                icon: 'blockscout',
                standard: 'EIP3091'
            },
            {
                name: 'blockscout',
                url: 'https://gnosis-chiado.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeidk4swpgdyqmpz6shd5onvpaujvwiwthrhypufnwr6xh3dausz2dm'
    },
    10201: {
        name: 'MaxxChain Mainnet',
        chain: 'MaxxChain',
        rpc: [
            'https://rpc.maxxchain.org',
            'https://rpc1.maxxchain.org',
            'https://rpc2.maxxchain.org'
        ],
        faucets: ['https://faucet.maxxchain.org'],
        nativeCurrency: { name: 'Power', symbol: 'PWR', decimals: 18 },
        icon: 'pwr',
        infoURL: 'https://www.maxxchain.org/',
        shortName: 'PWR',
        chainId: 10201,
        networkId: 10201,
        explorers: [
            {
                name: 'MaxxChain Block Explorer',
                url: 'https://explorer.maxxchain.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRhQG9TZrXDdbQeTzBmjg3pqgwaD5TKVZj8k4kaz8AoZx'
    },
    10218: {
        name: 'Tea Sepolia Testnet',
        chain: 'ETH',
        rpc: ['https://tea-sepolia.g.alchemy.com/public'],
        faucets: ['https://faucet-sepolia.tea.xyz'],
        explorers: [
            {
                name: 'blockscout',
                url: 'https://sepolia.tea.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        nativeCurrency: { name: 'Sepolia Tea', symbol: 'TEA', decimals: 18 },
        infoURL: 'https://tea.xyz',
        shortName: 'teasep',
        chainId: 10218,
        networkId: 10218,
        parent: { type: 'L2', chain: 'eip155-11155111' },
        status: 'active'
    },
    10222: {
        name: 'GLScan',
        chain: 'GLC',
        icon: 'glc',
        rpc: ['https://glc-dataseed.glscan.io/'],
        faucets: [],
        nativeCurrency: { name: 'GLC', symbol: 'GLC', decimals: 18 },
        infoURL: 'https://glscan.io/',
        shortName: 'glc',
        chainId: 10222,
        networkId: 10222,
        slip44: 1,
        explorers: [
            {
                name: 'GLScan Explorer',
                url: 'https://glscan.io',
                standard: 'none',
                icon: 'glc'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTw21p6UfXVH2BCU81G2Ck28ecoknz4v9mC35fF8Z987i'
    },
    10242: {
        name: 'Arthera Mainnet',
        chain: 'AA',
        icon: 'arthera',
        rpc: ['https://rpc.arthera.net'],
        faucets: [],
        nativeCurrency: { name: 'Arthera', symbol: 'AA', decimals: 18 },
        infoURL: 'https://docs.arthera.net/build/developing-sc/using-hardhat',
        shortName: 'aa',
        chainId: 10242,
        networkId: 10242,
        slip44: 10242,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.arthera.net',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYQp3e52KjkT4bYdAvB6ACEEpXs2D8DozsDitaADRY2Ak'
    },
    10243: {
        name: 'Arthera Testnet',
        chain: 'AA',
        icon: 'arthera',
        rpc: ['https://rpc-test.arthera.net'],
        faucets: ['https://faucet.arthera.net'],
        nativeCurrency: { name: 'Arthera', symbol: 'AA', decimals: 18 },
        infoURL: 'https://docs.arthera.net',
        shortName: 'aat',
        chainId: 10243,
        networkId: 10243,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer-test.arthera.net',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYQp3e52KjkT4bYdAvB6ACEEpXs2D8DozsDitaADRY2Ak'
    },
    10248: {
        name: '0XTade',
        chain: '0XTade Chain',
        rpc: ['https://node.0xtchain.com'],
        faucets: [],
        nativeCurrency: { name: '0XT', symbol: '0XT', decimals: 18 },
        infoURL: 'https://www.0xtrade.finance/',
        shortName: '0xt',
        chainId: 10248,
        networkId: 10248,
        explorers: [
            {
                name: '0xtrade Scan',
                url: 'https://www.0xtscan.com',
                standard: 'none'
            }
        ]
    },
    10321: {
        name: 'TAO EVM Mainnet',
        chain: 'TAO EVM',
        icon: 'taoevmIcon',
        rpc: ['https://rpc.taoevm.io'],
        faucets: [],
        nativeCurrency: { name: 'TAO', symbol: 'TAO', decimals: 18 },
        infoURL: 'https://taoevm.io',
        shortName: 'TAOm',
        chainId: 10321,
        networkId: 10321,
        explorers: [
            {
                name: 'TAO Mainnet Explorer',
                url: 'https://taoscan.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmS78hUX5zqYDqoFgyVmtWpCcx7bZW86Nhw5Nqt2GJrLh2'
    },
    10324: {
        name: 'TAO EVM Testnet',
        chain: 'TAO EVM',
        icon: 'taoevmIcon',
        rpc: ['https://testnet-rpc.taoevm.io'],
        faucets: ['https://faucet.taoevm.io'],
        nativeCurrency: { name: 'TAO', symbol: 'TAO', decimals: 18 },
        infoURL: 'https://taoevm.io',
        shortName: 'TAOt',
        chainId: 10324,
        networkId: 10324,
        explorers: [
            {
                name: 'TAO Testnet Explorer',
                url: 'https://testnet.taoscan.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmS78hUX5zqYDqoFgyVmtWpCcx7bZW86Nhw5Nqt2GJrLh2'
    },
    10395: {
        name: 'WorldLand Testnet',
        chain: 'Worldland',
        icon: 'worldland',
        rpc: ['https://gwangju.worldland.foundation'],
        faucets: [],
        nativeCurrency: { name: 'Worldland', symbol: 'WLC', decimals: 18 },
        infoURL: 'https://worldland.foundation',
        shortName: 'TWLC',
        chainId: 10395,
        networkId: 10395,
        slip44: 1,
        explorers: [
            {
                name: 'Worldland Explorer',
                url: 'https://testscan.worldland.foundation',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYZNTfK3byhgLsTjXP8vPubVHRz2CWsBrTJxZrQmKq6JZ'
    },
    10507: {
        name: 'Numbers Mainnet',
        chain: 'NUM',
        icon: 'num',
        rpc: ['https://mainnetrpc.num.network'],
        faucets: [],
        nativeCurrency: { name: 'NUM Token', symbol: 'NUM', decimals: 18 },
        infoURL: 'https://numbersprotocol.io',
        shortName: 'Jade',
        chainId: 10507,
        networkId: 10507,
        explorers: [
            {
                name: 'ethernal',
                url: 'https://mainnet.num.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreie3ba6ofosjqqiya6empkyw6u5xdrtcfzi2evvyt4u6utzeiezyhi'
    },
    10508: {
        name: 'Numbers Testnet',
        chain: 'NUM',
        icon: 'num',
        rpc: ['https://testnetrpc.num.network'],
        faucets: [
            'https://faucet.avax.network/?subnet=num',
            'https://faucet.num.network'
        ],
        nativeCurrency: { name: 'NUM Token', symbol: 'NUM', decimals: 18 },
        infoURL: 'https://numbersprotocol.io',
        shortName: 'Snow',
        chainId: 10508,
        networkId: 10508,
        slip44: 1,
        explorers: [
            {
                name: 'ethernal',
                url: 'https://testnet.num.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreie3ba6ofosjqqiya6empkyw6u5xdrtcfzi2evvyt4u6utzeiezyhi'
    },
    10823: {
        name: 'CryptoCoinPay',
        chain: 'CCP',
        rpc: [
            'http://node106.cryptocoinpay.info:8545',
            'ws://node106.cryptocoinpay.info:8546'
        ],
        faucets: [],
        icon: 'ccp',
        nativeCurrency: { name: 'CryptoCoinPay', symbol: 'CCP', decimals: 18 },
        infoURL: 'https://www.cryptocoinpay.co',
        shortName: 'CCP',
        chainId: 10823,
        networkId: 10823,
        explorers: [
            {
                name: 'CCP Explorer',
                url: 'https://cryptocoinpay.info',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPw1ixYYeXvTiRWoCt2jWe4YMd3B5o7TzL18SBEHXvhXX'
    },
    10849: {
        name: 'Lamina1',
        chain: 'Lamina1',
        rpc: ['https://subnets.avax.network/lamina1/mainnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'L1', symbol: 'L1', decimals: 18 },
        infoURL: 'https://www.lamina1.com/',
        shortName: 'lamina1',
        chainId: 10849,
        networkId: 10849,
        slip44: 1,
        explorers: [
            {
                name: 'Lamina1 Explorer',
                url: 'https://subnets.avax.network/lamina1',
                standard: 'EIP3091'
            }
        ]
    },
    10850: {
        name: 'Lamina1 Identity',
        chain: 'Lamina1 Identity',
        rpc: ['https://subnets.avax.network/lamina1id/mainnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'L1 ID', symbol: 'L1ID', decimals: 18 },
        infoURL: 'https://www.lamina1.com/',
        shortName: 'lamina1id',
        chainId: 10850,
        networkId: 10850,
        slip44: 1,
        explorers: [
            {
                name: 'Lamina1 Identity Explorer',
                url: 'https://subnets.avax.network/lamina1id',
                standard: 'EIP3091'
            }
        ]
    },
    10888: {
        name: 'GameSwift Chain Testnet',
        title: 'GameSwift Chain Testnet',
        chain: 'gameswift-chain-testnet',
        rpc: ['https://rpc-testnet.gameswift.io', 'wss://ws-testnet.gameswift.io'],
        nativeCurrency: { name: 'TGameSwift', symbol: 'tGS', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/gameswift-chain-testnet',
        faucets: [],
        shortName: 'gameswift-chain-testnet',
        chainId: 10888,
        networkId: 10888,
        slip44: 60,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet.gameswift.io',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [
                {
                    url: 'https://testnet-bridge-gelato.gameswift.io/bridge/gameswift-chain-testnet'
                }
            ]
        }
    },
    10920: {
        name: 'Fuse Flash Testnet',
        chain: 'Fuse Flash',
        rpc: [],
        faucets: ['https://faucet.quicknode.com'],
        nativeCurrency: { name: 'Fuse', symbol: 'FUSE', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://www.fuse.io',
        shortName: 'fuseflash',
        chainId: 10920,
        networkId: 10920,
        icon: 'fuse',
        parent: { type: 'L2', chain: 'eip155-11155111' },
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmR3gooSiRfCuryT2y7Q37a3DqmdCKvV6vYp1fVpJW3VWz'
    },
    10946: {
        name: 'Quadrans Blockchain',
        chain: 'QDC',
        icon: 'quadrans',
        rpc: [
            'https://rpc.quadrans.io',
            'https://rpcna.quadrans.io',
            'https://rpceu.quadrans.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'Quadrans Coin', symbol: 'QDC', decimals: 18 },
        infoURL: 'https://quadrans.io',
        shortName: 'quadrans',
        chainId: 10946,
        networkId: 10946,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer.quadrans.io',
                icon: 'quadrans',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZFiYHnE4TrezPz8wSap9nMxG6m98w4fv7ataj2TfLNck'
    },
    10947: {
        name: 'Quadrans Blockchain Testnet',
        chain: 'tQDC',
        icon: 'quadrans',
        rpc: ['https://rpctest.quadrans.io', 'https://rpctest2.quadrans.io'],
        faucets: ['https://faucetpage.quadrans.io'],
        nativeCurrency: {
            name: 'Quadrans Testnet Coin',
            symbol: 'tQDC',
            decimals: 18
        },
        infoURL: 'https://quadrans.io',
        shortName: 'quadranstestnet',
        chainId: 10947,
        networkId: 10947,
        slip44: 1,
        explorers: [
            {
                name: 'explorer',
                url: 'https://explorer.testnet.quadrans.io',
                icon: 'quadrans',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZFiYHnE4TrezPz8wSap9nMxG6m98w4fv7ataj2TfLNck'
    },
    11000: {
        name: 'KB Chain',
        chain: 'KB',
        rpc: ['https://mainnet-rpc.kbcfoundation.com'],
        faucets: [],
        features: [{ name: 'EIP155' }],
        nativeCurrency: { name: 'KBC', symbol: 'KBC', decimals: 18 },
        infoURL: 'https://kbcfoundation.com',
        shortName: 'KBC',
        chainId: 11000,
        networkId: 11000,
        explorers: [
            {
                name: 'KBC Explorer',
                url: 'https://scan.kbcfoundation.com',
                standard: 'EIP3091'
            }
        ]
    },
    11011: {
        name: 'Shape Sepolia Testnet',
        chain: 'ETH',
        rpc: ['https://sepolia.shape.network'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://shape.network',
        shortName: 'shapesep',
        chainId: 11011,
        networkId: 11011,
        icon: 'shapeTestnet',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer-sepolia.shape.network',
                standard: 'EIP3091'
            }
        ],
        slip44: 1,
        iconURL: 'https://ipfs.io/ipfs/QmUfr1ufnNJ4PcA3Jgf6jdi4ZiRFr6mPzKafwK1pSqvY9j'
    },
    11100: {
        name: 'Bool Network Beta Mainnet',
        chain: 'BOOL',
        rpc: ['https://beta-rpc-node-http.bool.network'],
        faucets: [],
        nativeCurrency: { name: 'BOL', symbol: 'BOL', decimals: 18 },
        infoURL: 'https://bool.network/',
        shortName: 'BOL',
        chainId: 11100,
        networkId: 11100,
        icon: 'boolnetwork',
        iconURL: 'https://ipfs.io/ipfs/QmPVnYRhenXH8X9NF3vy7oU1sHnoBoNU2xDU68uBqWoy3b'
    },
    11110: {
        name: 'Astra',
        chain: 'Astra',
        rpc: ['https://rpc.astranaut.io', 'https://rpc1.astranaut.io'],
        faucets: [],
        nativeCurrency: { name: 'Astra', symbol: 'ASA', decimals: 18 },
        infoURL: 'https://astranaut.io',
        shortName: 'astra',
        chainId: 11110,
        networkId: 11110,
        icon: 'astra',
        explorers: [
            {
                name: 'Astra EVM Explorer (Blockscout)',
                url: 'https://explorer.astranaut.io',
                standard: 'none',
                icon: 'astra'
            },
            {
                name: 'Astra PingPub Explorer',
                url: 'https://ping.astranaut.io/astra',
                standard: 'none',
                icon: 'astra'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaBtaukPNNUNjdJSUAwuFFQMLbZX1Pc3fvXKTKQcds7Kf'
    },
    11111: {
        name: 'WAGMI',
        chain: 'WAGMI',
        icon: 'wagmi',
        rpc: ['https://subnets.avax.network/wagmi/wagmi-chain-testnet/rpc'],
        faucets: ['https://faucet.avax.network/?subnet=wagmi'],
        nativeCurrency: { name: 'WAGMI', symbol: 'WGM', decimals: 18 },
        infoURL: 'https://subnets-test.avax.network/wagmi/details',
        shortName: 'WAGMI',
        chainId: 11111,
        networkId: 11111,
        explorers: [
            {
                name: 'Avalanche Subnet Explorer',
                url: 'https://subnets-test.avax.network/wagmi',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNoyUXxnak8B3xgFxErkVfyVEPJUMHBzq7qJcYzkUrPR4'
    },
    11115: {
        name: 'Astra Testnet',
        chain: 'Astra',
        rpc: ['https://rpc.astranaut.dev'],
        faucets: ['https://faucet.astranaut.dev'],
        nativeCurrency: { name: 'test-Astra', symbol: 'tASA', decimals: 18 },
        infoURL: 'https://astranaut.io',
        shortName: 'astra-testnet',
        chainId: 11115,
        networkId: 11115,
        slip44: 1,
        icon: 'astra',
        explorers: [
            {
                name: 'Astra EVM Explorer',
                url: 'https://explorer.astranaut.dev',
                standard: 'EIP3091',
                icon: 'astra'
            },
            {
                name: 'Astra PingPub Explorer',
                url: 'https://ping.astranaut.dev/astra',
                standard: 'none',
                icon: 'astra'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaBtaukPNNUNjdJSUAwuFFQMLbZX1Pc3fvXKTKQcds7Kf'
    },
    11119: {
        name: 'HashBit Mainnet',
        chain: 'HBIT',
        rpc: ['https://mainnet-rpc.hashbit.org', 'https://rpc.hashbit.org'],
        faucets: [],
        nativeCurrency: {
            name: 'HashBit Native Token',
            symbol: 'HBIT',
            decimals: 18
        },
        infoURL: 'https://hashbit.org',
        shortName: 'hbit',
        chainId: 11119,
        networkId: 11119,
        explorers: [
            {
                name: 'hashbitscan',
                url: 'https://explorer.hashbit.org',
                standard: 'EIP3091'
            }
        ]
    },
    11124: {
        name: 'Abstract Sepolia Testnet',
        chain: 'Abstract Sepolia Testnet',
        rpc: ['https://api.testnet.abs.xyz'],
        faucets: ['https://faucet.triangleplatform.com/abstract/testnet'],
        chainId: 11124,
        networkId: 11124,
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://abs.xyz/',
        shortName: 'abstract-sepolia',
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://portal.testnet.abs.xyz/bridge' }]
        },
        explorers: [
            {
                name: 'Abstract Sepolia Testnet Explorer',
                url: 'https://sepolia.abscan.org',
                standard: 'EIP3091'
            }
        ]
    },
    11221: {
        name: 'Shine Chain',
        chain: 'SC20',
        rpc: ['https://rpc.shinescan.io'],
        faucets: [],
        nativeCurrency: { name: 'Shine', symbol: 'SC20', decimals: 18 },
        infoURL: 'https://shinechain.tech',
        shortName: 'SC20',
        chainId: 11221,
        networkId: 11221,
        icon: 'shine',
        explorers: [
            {
                name: 'shinescan',
                url: 'https://shinescan.io',
                icon: 'shine',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUBkpY3prCTZHpx1fjrYLAJ6dPaGvNVTj97iy6p3NPUi1'
    },
    11227: {
        name: 'Jiritsu Testnet Subnet',
        chain: 'JIRITSUTES',
        rpc: ['https://subnets.avax.network/jiritsutes/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'JIRI', symbol: 'TZW', decimals: 18 },
        infoURL: 'https://jiritsu.network',
        shortName: 'jiritsutes',
        chainId: 11227,
        networkId: 11227,
        explorers: [
            {
                name: 'JIRITSUTES Explorer',
                url: 'https://subnets-test.avax.network/jiritsutes',
                standard: 'EIP3091'
            }
        ]
    },
    11235: {
        name: 'Haqq Network',
        chain: 'Haqq',
        rpc: [
            'https://rpc.eth.haqq.network',
            'https://haqq-evm-rpc.publicnode.com',
            'wss://haqq-evm-rpc.publicnode.com',
            'https://haqq.drpc.org',
            'wss://haqq.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Islamic Coin', symbol: 'ISLM', decimals: 18 },
        infoURL: 'https://islamiccoin.net',
        shortName: 'ISLM',
        chainId: 11235,
        networkId: 11235,
        explorers: [
            {
                name: 'Mainnet HAQQ Explorer',
                url: 'https://explorer.haqq.network',
                standard: 'EIP3091'
            }
        ]
    },
    11343: {
        name: 'StateMesh Testnet',
        icon: 'statemesh',
        chain: 'MESH',
        rpc: ['https://rpc-test.statemesh.net'],
        faucets: ['https://faucet.statemesh.net'],
        nativeCurrency: { name: 'StateMesh', symbol: 'MESH', decimals: 18 },
        infoURL: 'https://statemesh.net',
        shortName: 'mesh-test',
        chainId: 11343,
        networkId: 11343,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer-test.statemesh.net',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmc7KBcdrXMKvaq1xN6mubEqpvHdheFxs1YGZwZgLEPDrK'
    },
    11437: {
        name: 'Shyft Testnet',
        chain: 'SHYFTT',
        icon: 'shyft',
        rpc: [],
        faucets: [],
        nativeCurrency: {
            name: 'Shyft Test Token',
            symbol: 'SHYFTT',
            decimals: 18
        },
        infoURL: 'https://shyft.network',
        shortName: 'shyftt',
        chainId: 11437,
        networkId: 11437,
        slip44: 1,
        explorers: [
            {
                name: 'Shyft Testnet BX',
                url: 'https://bx.testnet.shyft.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUkFZC2ZmoYPTKf7AHdjwRPZoV2h1MCuHaGM4iu8SNFpi'
    },
    11451: {
        name: 'eGold Chain',
        chain: 'EGC',
        icon: 'egoldchain',
        rpc: ['https://rpc.egoldchain.com', 'wss://rpc.egoldchain.com'],
        faucets: [],
        nativeCurrency: { name: 'Aurum', symbol: 'XAU', decimals: 18 },
        infoURL: 'https://www.egoldchain.com',
        shortName: 'egoldchain',
        chainId: 11451,
        networkId: 11451,
        explorers: [
            {
                name: 'eGold Chain Block Explorer',
                url: 'https://egoldscan.io',
                standard: 'none',
                icon: 'egoldchain'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTQh54Rf3DFYxZZoQQ9yCjeAYXwzTaVua4KLmXX8AsFNF'
    },
    11501: {
        name: 'GEB Mainnet',
        chain: 'GEB',
        rpc: [
            'https://rpc-mainnet-1.geb.network/',
            'https://rpc-mainnet-2.geb.network/'
        ],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://geb.network',
        shortName: 'geb',
        chainId: 11501,
        networkId: 11501,
        icon: 'geb',
        explorers: [
            {
                name: 'geb mainnet scan',
                url: 'https://scan.geb.network',
                standard: 'none'
            },
            {
                name: 'bevm mainnet oklink',
                url: 'https://www.oklink.com/bevm',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmT8DN1zVgkDDWV17kmKqP6vcJQZfhCKVj3HtgqbxUbi9g'
    },
    11503: {
        name: 'BEVM Testnet',
        chain: 'BEVM',
        rpc: ['https://testnet.bevm.io/'],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://bevm.io',
        shortName: 'bevm-test',
        chainId: 11503,
        networkId: 11503,
        icon: 'bevm',
        explorers: [
            {
                name: 'bevm testnet scan',
                url: 'https://scan-testnet.bevm.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfMXiYn4xF9JwdjaqM5YKhqoByox51XvnL68VvKJS6yyu'
    },
    11504: {
        name: 'GEB Signet',
        chain: 'GEB',
        rpc: ['https://signet.geb.network/'],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://geb.network',
        shortName: 'geb-signet',
        chainId: 11504,
        networkId: 11504,
        icon: 'geb',
        explorers: [
            {
                name: 'geb signet scan',
                url: 'https://scan-signet.geb.network',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmT8DN1zVgkDDWV17kmKqP6vcJQZfhCKVj3HtgqbxUbi9g'
    },
    11521: {
        name: 'SatsChain',
        chain: 'SatsChain',
        rpc: ['https://rpc-satschain-1.bevm.io'],
        faucets: [],
        nativeCurrency: { name: 'SATS', symbol: 'SATS', decimals: 18 },
        infoURL: 'https://github.com/BTCSatsNetwork',
        shortName: 'satschain',
        chainId: 11521,
        networkId: 11521,
        icon: 'satschain',
        explorers: [
            {
                name: 'satschain scan',
                url: 'https://scan-satschain.bevm.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreicvi5dgn3wmkquqaicx743xc65dlqvnnuxsbsxq5hbzhaaaksxyo4'
    },
    11612: {
        name: 'Sardis Testnet',
        chain: 'SRDX',
        icon: 'sardisTestnet',
        rpc: ['https://testnet-rpc.sardisnetwork.com'],
        faucets: ['https://faucet.sardisnetwork.com'],
        nativeCurrency: { name: 'Sardis', symbol: 'SRDX', decimals: 18 },
        infoURL: 'https://mysardis.com',
        shortName: 'SRDXt',
        chainId: 11612,
        networkId: 11612,
        slip44: 1,
        explorers: [
            {
                name: 'Sardis',
                url: 'https://testnet.sardisnetwork.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdR9QJjQEh1mBnf2WbJfehverxiP5RDPWMtEECbDP2rc3'
    },
    11820: {
        name: 'Artela Mainnet',
        chain: 'Artela',
        rpc: ['https://node-euro.artela.network/rpc'],
        faucets: [],
        nativeCurrency: { name: 'ART', symbol: 'ART', decimals: 18 },
        infoURL: 'https://artela.network/',
        shortName: 'artela-mainnet',
        chainId: 11820,
        networkId: 11820,
        icon: 'artela',
        explorers: [
            {
                name: 'ArtelaScan',
                url: 'https://artscan.artela.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVLphQTid27kfv3R6Vd2UdiHYWYu3oUTmztmiqSBkZ3nu'
    },
    11822: {
        name: 'Artela Testnet',
        chain: 'Artela',
        rpc: ['https://betanet-rpc1.artela.network'],
        faucets: [],
        nativeCurrency: { name: 'ART', symbol: 'ART', decimals: 18 },
        infoURL: 'https://artela.network/',
        shortName: 'Artela',
        chainId: 11822,
        networkId: 11822,
        explorers: [
            {
                name: 'ArtelaScan',
                url: 'https://betanet-scan.artela.network',
                standard: 'EIP3091'
            },
            {
                name: 'OKXExplorer',
                url: 'https://www.okx.com/web3/explorer/artela-testnet',
                standard: 'EIP3091'
            }
        ]
    },
    11888: {
        status: 'deprecated',
        name: 'Santiment Intelligence Network DEPRECATED',
        chain: 'Santiment Intelligence Network DEPRECATED',
        rpc: ['https://sanrchain-node.santiment.net'],
        faucets: [],
        nativeCurrency: { name: 'SANold', symbol: 'SANold', decimals: 18 },
        infoURL: 'https://sanr.app',
        shortName: 'SANold',
        chainId: 11888,
        networkId: 11888,
        icon: 'sanrchain',
        parent: {
            chain: 'eip155-1',
            type: 'L2',
            bridges: [{ url: 'https://sanr.app' }]
        },
        explorers: [
            {
                name: 'Santiment Intelligence Explorer',
                url: 'https://app-explorer-pos.sanr.app',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPLMg5mYD8XRknvYbDkD2x7FXxYan7MPTeUWZC2CihwDM'
    },
    11891: {
        name: 'Polygon Supernet Arianee',
        chain: 'Arianee',
        rpc: ['https://rpc.polygonsupernet.public.arianee.net'],
        faucets: [],
        nativeCurrency: { name: 'Arianee', symbol: 'ARIA20', decimals: 18 },
        infoURL: 'https://arianee.org',
        shortName: 'Arianee',
        chainId: 11891,
        networkId: 11891,
        explorers: [
            {
                name: 'Polygon Supernet Arianee Explorer',
                url: 'https://polygonsupernet.explorer.arianee.net',
                standard: 'EIP3091'
            }
        ],
        parent: { chain: 'eip155-1', type: 'L2' }
    },
    12001: {
        name: 'Fuse Testnet',
        chain: 'Fuse',
        rpc: ['https://rpc.flash.fuse.io'],
        faucets: ['https://faucet.flash.fuse.io'],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: '',
        shortName: 'fuseZK',
        chainId: 12001,
        networkId: 12001,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.flash.fuse.io',
                standard: 'none'
            }
        ]
    },
    12009: {
        name: 'SatoshiChain Mainnet',
        chain: 'SATS',
        icon: 'satoshichain',
        rpc: ['https://mainnet-rpc.satoshichain.io'],
        faucets: [],
        nativeCurrency: { name: 'SatoshiChain Coin', symbol: 'SATS', decimals: 18 },
        infoURL: 'https://satoshichain.net',
        shortName: 'sats',
        chainId: 12009,
        networkId: 12009,
        explorers: [
            {
                name: 'SatoshiChain Explorer',
                url: 'https://satoshiscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRegpZQBW4o1imYNsW3d27MQjygBSU23Gf6JKje26nvs7'
    },
    12020: {
        name: 'Aternos',
        chain: 'Aternos',
        icon: 'aternos',
        rpc: ['https://rpc.aternoschain.com'],
        faucets: ['https://faucet.aternoschain.com'],
        nativeCurrency: { name: 'Aternos', symbol: 'ATR', decimals: 18 },
        infoURL: 'https://aternoschain.com',
        shortName: 'ATR',
        chainId: 12020,
        networkId: 12020,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.aternoschain.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUgfhv3rEsS6t9g6Lsf3TJ1mbnJqBrb8YUFPDiNG59QvT'
    },
    12051: {
        name: 'Singularity ZERO Testnet',
        chain: 'ZERO',
        rpc: ['https://betaenv.singularity.gold:18545'],
        faucets: ['https://nft.singularity.gold'],
        nativeCurrency: { name: 'ZERO', symbol: 'tZERO', decimals: 18 },
        infoURL: 'https://www.singularity.gold',
        shortName: 'tZERO',
        chainId: 12051,
        networkId: 12051,
        slip44: 1,
        explorers: [
            {
                name: 'zeroscan',
                url: 'https://betaenv.singularity.gold:18002',
                standard: 'EIP3091'
            }
        ]
    },
    12052: {
        name: 'Singularity ZERO Mainnet',
        chain: 'ZERO',
        rpc: ['https://zerorpc.singularity.gold'],
        faucets: ['https://zeroscan.singularity.gold'],
        nativeCurrency: { name: 'ZERO', symbol: 'ZERO', decimals: 18 },
        infoURL: 'https://www.singularity.gold',
        shortName: 'ZERO',
        chainId: 12052,
        networkId: 12052,
        slip44: 621,
        explorers: [
            {
                name: 'zeroscan',
                url: 'https://zeroscan.singularity.gold',
                standard: 'EIP3091'
            }
        ]
    },
    12123: {
        name: 'BRC Chain Mainnet',
        chain: 'BRC',
        rpc: ['https://rpc.brcchain.io'],
        faucets: ['https://faucet.brcchain.io'],
        nativeCurrency: {
            name: 'BRC Chain mainnet native token',
            symbol: 'BRC',
            decimals: 18
        },
        infoURL: 'https://bridge.brcchain.io',
        shortName: 'BRC',
        chainId: 12123,
        networkId: 12123,
        icon: 'brcchain',
        explorers: [
            {
                name: 'BRC Chain Explorer',
                url: 'https://scan.brcchain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmX8qGX7xoZqYUpHxA85uZwQX2fgbTHvmddE1NfseDyBED'
    },
    12306: {
        name: 'Fibonacci Mainnet',
        chain: 'FIBO',
        icon: 'fibonacci',
        rpc: [
            'https://node1.fibo-api.asia',
            'https://node2.fibo-api.asia',
            'https://node3.fibo-api.asia',
            'https://node4.fibo-api.asia',
            'https://node5.fibo-api.asia',
            'https://node6.fibo-api.asia',
            'https://node7.fibo-api.asia',
            'https://node1.fibo-rpc.asia',
            'https://node2.fibo-rpc.asia',
            'https://node3.fibo-rpc.asia',
            'https://node4.fibo-rpc.asia',
            'https://node5.fibo-rpc.asia',
            'https://node6.fibo-rpc.asia',
            'https://node7.fibo-rpc.asia'
        ],
        faucets: ['https://test.fibochain.org/faucets'],
        nativeCurrency: {
            name: 'FIBONACCI UTILITY TOKEN',
            symbol: 'FIBO',
            decimals: 18
        },
        infoURL: 'https://fibochain.org',
        shortName: 'fibo',
        chainId: 12306,
        networkId: 1230,
        explorers: [
            {
                name: 'fiboscan',
                url: 'https://scan.fibochain.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidiedaz3jugxmh2ylzlc4nympbd5iwab33adhwkcnblyop6vvj25y'
    },
    12321: {
        name: 'BLG Testnet',
        chain: 'BLG',
        icon: 'blg',
        rpc: ['https://rpc.blgchain.com'],
        faucets: ['https://faucet.blgchain.com'],
        nativeCurrency: { name: 'Blg', symbol: 'BLG', decimals: 18 },
        infoURL: 'https://blgchain.com',
        shortName: 'blgchain',
        chainId: 12321,
        networkId: 12321,
        slip44: 1,
        iconURL: 'https://ipfs.io/ipfs/QmUN5j2cre8GHKv52JE8ag88aAnRmuHMGFxePPvKMogisC'
    },
    12323: {
        name: 'Huddle01 dRTC Chain',
        chain: 'huddle01',
        rpc: ['https://huddle01.calderachain.xyz/http'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://huddle01.com/',
        shortName: 'huddle01',
        chainId: 12323,
        networkId: 12323,
        icon: 'huddle01',
        explorers: [
            {
                name: 'Huddle01 Caldera Explorer',
                url: 'https://huddle01.calderaexplorer.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiboef4bxbv2nnnvi4zph7poolk6kyno5qycnjzvbyep3gv6zkd2qa'
    },
    12324: {
        name: 'L3X Protocol',
        chainId: 12324,
        shortName: 'l3x',
        chain: 'L3X',
        icon: 'l3x',
        networkId: 12324,
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        rpc: ['https://rpc-mainnet.l3x.com'],
        faucets: [],
        explorers: [
            {
                name: 'L3X Mainnet Explorer',
                url: 'https://explorer.l3x.com',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://l3x.com',
        parent: {
            type: 'L2',
            chain: 'eip155-42161',
            bridges: [{ url: 'https://bridge.arbitrum.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/Qmf1cim2ZvkgszKiFtmZj3K1z2YgVY7A4VtLkWw8kQxijq'
    },
    12325: {
        name: 'L3X Protocol Testnet',
        chainId: 12325,
        shortName: 'l3x-testnet',
        chain: 'L3X',
        icon: 'l3x',
        networkId: 12325,
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        rpc: ['https://rpc-testnet.l3x.com'],
        faucets: [],
        explorers: [
            {
                name: 'L3X Testnet Explorer',
                url: 'https://explorer-testnet.l3x.com',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://l3x.com',
        parent: {
            type: 'L2',
            chain: 'eip155-421614',
            bridges: [{ url: 'https://bridge.arbitrum.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/Qmf1cim2ZvkgszKiFtmZj3K1z2YgVY7A4VtLkWw8kQxijq'
    },
    12345: {
        name: 'Step Testnet',
        title: 'Step Test Network',
        chain: 'STEP',
        icon: 'step',
        rpc: ['https://rpc.testnet.step.network'],
        faucets: ['https://faucet.step.network'],
        nativeCurrency: { name: 'FITFI', symbol: 'FITFI', decimals: 18 },
        infoURL: 'https://step.network',
        shortName: 'steptest',
        chainId: 12345,
        networkId: 12345,
        slip44: 1,
        explorers: [
            {
                name: 'StepScan',
                url: 'https://testnet.stepscan.io',
                icon: 'step',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-43113' },
        iconURL: 'https://ipfs.io/ipfs/QmVp9jyb3UFW71867yVtymmiRw7dPY4BTnsp3hEjr9tn8L'
    },
    12358: {
        name: 'GDPR Mainnet',
        chain: 'GDPR',
        rpc: ['https://rpc.gdprchain.com'],
        faucets: [],
        nativeCurrency: { name: 'GDPR', symbol: 'GDPR', decimals: 18 },
        infoURL: 'https://explorer.gdprchain.com',
        shortName: 'gdpr',
        chainId: 12358,
        networkId: 12358,
        explorers: [
            {
                name: 'GDPR Mainnet Explorer (Blockscout)',
                url: 'https://explorer.gdprchain.com',
                standard: 'EIP3091'
            }
        ]
    },
    12553: {
        name: 'RSS3 VSL Mainnet',
        chain: 'RSS3',
        rpc: ['https://rpc.rss3.io'],
        faucets: [],
        nativeCurrency: { name: 'RSS3', symbol: 'RSS3', decimals: 18 },
        infoURL: 'https://rss3.io',
        shortName: 'rss3',
        chainId: 12553,
        networkId: 12553,
        icon: 'rss3',
        explorers: [
            {
                name: 'RSS3 VSL Scan',
                url: 'https://scan.rss3.io',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://explorer.rss3.io/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmZFWYnufi6G2Z54oJ25sx2yf2Skx5tseJHJJa6Hc1G34t'
    },
    12715: {
        name: 'Rikeza Network Testnet',
        title: 'Rikeza Network Testnet',
        chain: 'Rikeza',
        icon: 'rikeza',
        rpc: ['https://testnet-rpc.rikscan.com'],
        faucets: [],
        nativeCurrency: { name: 'Rikeza', symbol: 'RIK', decimals: 18 },
        infoURL: 'https://rikeza.io',
        shortName: 'tRIK',
        chainId: 12715,
        networkId: 12715,
        slip44: 1,
        explorers: [
            {
                name: 'Rikeza Blockchain explorer',
                url: 'https://testnet.rikscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfJ1Qxpzi6CSLeFeWY1Bwe435CpT5za5WfrLUE7vNzZfy'
    },
    12781: {
        name: 'Playdapp Testnet',
        chain: 'PDA',
        icon: 'pda',
        rpc: ['https://subnets.avax.network/playdappte/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Playdapp', symbol: 'PDA', decimals: 18 },
        infoURL: 'https://playdapp.io',
        shortName: 'PDA-TESTNET',
        chainId: 12781,
        networkId: 12781,
        explorers: [
            {
                name: 'Playdapp Testnet Explorer',
                url: 'https://subnets-test.avax.network/playdappte',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmY6AkNb5TYrDbM5M7YpSM8X3aYn2LcPXeLXz6F7WoB27r'
    },
    12890: {
        name: 'Quantum Chain Testnet',
        chain: 'tQNET',
        icon: 'qnet',
        rpc: ['https://testnet-rpc.quantumscan.org'],
        faucets: [],
        nativeCurrency: { name: 'Quantum Chain', symbol: 'tQNET', decimals: 18 },
        infoURL: 'https://quantumnetwork.gg',
        shortName: 'tqnet',
        chainId: 12890,
        networkId: 12890,
        slip44: 1,
        explorers: [
            {
                name: 'Quantum Scan Testnet',
                url: 'https://testnet.quantumscan.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibwywok67uewqbtqdzgr7nlk3lvvg7hxmbgwtn7kdwxe34useucvm'
    },
    12898: {
        name: 'PlayFair Testnet Subnet',
        chain: 'PLAYFAIR',
        icon: 'playfair',
        rpc: [
            'https://rpc.letsplayfair.ai/ext/bc/2hhXFNp1jR4RuqvCmWQnBtt9CZnCmmyGr7TNTkxt7XY7pAzHMY/rpc'
        ],
        faucets: [],
        nativeCurrency: { name: 'BTLT Token', symbol: 'BTLT', decimals: 18 },
        infoURL: 'https://letsplayfair.ai',
        shortName: 'playfair',
        chainId: 12898,
        networkId: 12898,
        explorers: [
            {
                name: 'Avalanche Subnet Explorer',
                url: 'https://subnets-test.avax.network/letsplayfair',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNvoUp2RWiWQzHUKrZ7SnPzwF3FbCNd3jSdpGJhQdH1y5'
    },
    13000: {
        name: 'SPS',
        chain: 'SPS',
        rpc: ['https://rpc.ssquad.games'],
        faucets: [],
        nativeCurrency: { name: 'ECG', symbol: 'ECG', decimals: 18 },
        infoURL: 'https://ssquad.games/',
        shortName: 'SPS',
        chainId: 13000,
        networkId: 13000,
        explorers: [
            {
                name: 'SPS Explorer',
                url: 'http://spsscan.ssquad.games',
                standard: 'EIP3091'
            }
        ]
    },
    13308: {
        name: 'Credit Smart Chain',
        chain: 'CREDIT',
        rpc: ['https://rpc.creditsmartchain.com'],
        faucets: [],
        nativeCurrency: { name: 'Credit', symbol: 'CREDIT', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://creditsmartchain.com',
        shortName: 'Credit',
        chainId: 13308,
        networkId: 13308,
        icon: 'credit',
        explorers: [
            {
                name: 'Creditscan',
                url: 'https://scan.creditsmartchain.com',
                icon: 'credit',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifbso3gd4wu5wxl27xyurxctmuae2jyuy37guqtzx23nga6ba4ag4'
    },
    13337: {
        name: 'Beam Testnet',
        chain: 'BEAM',
        rpc: [
            'https://build.onbeam.com/rpc/testnet',
            'wss://build.onbeam.com/ws/testnet',
            'https://subnets.avax.network/beam/testnet/rpc',
            'wss://subnets.avax.network/beam/testnet/ws'
        ],
        features: [{ name: 'EIP1559' }],
        faucets: [
            'https://faucet.avax.network/?subnet=beam',
            'https://faucet.onbeam.com'
        ],
        nativeCurrency: { name: 'Beam', symbol: 'BEAM', decimals: 18 },
        infoURL: 'https://www.onbeam.com',
        shortName: 'beam-testnet',
        icon: 'beam',
        chainId: 13337,
        networkId: 13337,
        slip44: 1,
        explorers: [
            {
                name: 'Beam Explorer',
                url: 'https://subnets-test.avax.network/beam',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQJ21NWyGGDraicVEzS1Uqq1yXahM9NCuNZgnfYvtspdt'
    },
    13370: {
        name: 'Cannon Testnet',
        title: 'Cannon Private Testnet',
        chain: 'ETH',
        rpc: ['http://127.0.0.1:8545'],
        faucets: [],
        nativeCurrency: {
            name: 'Cannon Testnet Ether',
            symbol: 'ETH',
            decimals: 18
        },
        infoURL: 'https://usecannon.com',
        shortName: 'cannon',
        chainId: 13370,
        networkId: 13370
    },
    13371: {
        name: 'Immutable zkEVM',
        chain: 'Immutable zkEVM',
        rpc: [
            'https://rpc.immutable.com',
            'https://immutable-zkevm.drpc.org',
            'wss://immutable-zkevm.drpc.org'
        ],
        faucets: ['https://docs.immutable.com/docs/zkEVM/guides/faucet'],
        nativeCurrency: { name: 'IMX', symbol: 'IMX', decimals: 18 },
        infoURL: 'https://www.immutable.com',
        shortName: 'imx',
        chainId: 13371,
        networkId: 13371,
        icon: 'immutable',
        explorers: [
            {
                name: 'Immutable explorer',
                url: 'https://explorer.immutable.com',
                standard: 'EIP3091',
                icon: 'immutable'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXFUYFW4e6wifbU9LKVq7owM14bnE6ZbbYq3bn1jBP3Mw'
    },
    13381: {
        name: 'Phoenix Mainnet',
        chain: 'Phoenix',
        rpc: ['https://rpc.phoenixplorer.com/'],
        faucets: [],
        nativeCurrency: { name: 'Phoenix', symbol: 'PHX', decimals: 18 },
        infoURL: 'https://cryptophoenix.org/phoenix',
        shortName: 'Phoenix',
        chainId: 13381,
        networkId: 13381,
        icon: 'phoenix',
        explorers: [
            {
                name: 'phoenixplorer',
                url: 'https://phoenixplorer.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYiLMeKDXMSNuQmtxNdxm53xR588pcRXMf7zuiZLjQnc6'
    },
    13396: {
        name: 'Masa',
        chain: 'MASA',
        icon: 'masa',
        rpc: ['https://subnets.avax.network/masanetwork/mainnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Masa Token', symbol: 'MASA', decimals: 18 },
        infoURL: 'https://masa.finance',
        shortName: 'masa',
        chainId: 13396,
        networkId: 13396,
        explorers: [
            {
                name: 'Masa Explorer',
                url: 'https://subnets.avax.network/masa',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmV4f9byENNduHgLi8o1pC1sBNe3QAege2NnFkqGkTKojT'
    },
    13473: {
        name: 'Immutable zkEVM Testnet',
        chain: 'Immutable zkEVM',
        rpc: [
            'https://rpc.testnet.immutable.com',
            'https://immutable-zkevm-testnet.drpc.org',
            'wss://immutable-zkevm-testnet.drpc.org'
        ],
        faucets: ['https://docs.immutable.com/docs/zkEVM/guides/faucet'],
        nativeCurrency: { name: 'Test IMX', symbol: 'tIMX', decimals: 18 },
        infoURL: 'https://www.immutable.com',
        shortName: 'imx-testnet',
        chainId: 13473,
        networkId: 13473,
        slip44: 1,
        icon: 'immutable',
        explorers: [
            {
                name: 'Immutable Testnet explorer',
                url: 'https://explorer.testnet.immutable.com',
                standard: 'EIP3091',
                icon: 'immutable'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXFUYFW4e6wifbU9LKVq7owM14bnE6ZbbYq3bn1jBP3Mw'
    },
    13505: {
        name: 'Gravity Alpha Testnet Sepolia',
        chain: 'Gravity',
        rpc: ['https://rpc-sepolia.gravity.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Gravity', symbol: 'G', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }, { name: 'EIP1108' }],
        infoURL: 'https://gravity.xyz',
        shortName: 'gravitysep',
        chainId: 13505,
        networkId: 13505,
        icon: 'gravity',
        explorers: [
            {
                name: 'Gravity Alpha Testnet Sepolia Explorer',
                url: 'https://explorer-sepolia.gravity.xyz',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111', bridges: [] },
        iconURL: 'https://ipfs.io/ipfs/QmU5XU4S5oaGM5fj8oU1ovhWoXCzGWspwRj2zWRTuJrU4k'
    },
    13600: {
        name: 'Kronobit Mainnet',
        title: 'Kronobit Mainnet',
        chain: 'KNB',
        rpc: ['https://mainnet-rpc.qbitscan.com'],
        faucets: [],
        nativeCurrency: { name: 'Kronobit', symbol: 'KNB', decimals: 18 },
        infoURL: 'https://kronobit.org',
        shortName: 'KNB',
        chainId: 13600,
        networkId: 13600,
        icon: 'kronobit',
        explorers: [
            {
                name: 'qbitscan',
                url: 'https://explorer.qbitscan.com',
                icon: 'kronobit',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZEuR4bJaZkC497qQnsxHv23pZFcXb9dTdaDPCPo2sj9Z'
    },
    13746: {
        name: 'Game7 Testnet',
        title: 'Game7 Testnet',
        chain: 'Game7',
        rpc: [
            'https://testnet-rpc.game7.io',
            'wss://testnet-rpc.game7.io',
            'https://testnet-rpc.game7.build',
            'wss://testnet-rpc.game7.build'
        ],
        faucets: [],
        nativeCurrency: { name: 'TG7T', symbol: 'TG7T', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://game7.io',
        shortName: 'g7t',
        chainId: 13746,
        networkId: 13746,
        icon: 'game7testnet',
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://testnet.game7.io',
                icon: 'game7testnet',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmbk23C5vZpGBfq8SuPXR1PrfWER2m8w6LGqBkhXAvxia1'
    },
    13812: {
        name: 'Susono',
        chain: 'SUS',
        rpc: [
            'https://gateway.opn.network/node/ext/bc/2VsZe5DstWw2bfgdx3YbjKcMsJnNDjni95sZorBEdk9L9Qr9Fr/rpc'
        ],
        faucets: [],
        nativeCurrency: { name: 'Susono', symbol: 'OPN', decimals: 18 },
        infoURL: '',
        shortName: 'sus',
        chainId: 13812,
        networkId: 13812,
        explorers: [
            {
                name: 'Susono',
                url: 'http://explorer.opn.network',
                standard: 'none'
            }
        ]
    },
    14000: {
        name: 'SPS Testnet',
        chain: 'SPS-Testnet',
        rpc: ['https://www.3sps.net'],
        faucets: [],
        nativeCurrency: { name: 'ECG', symbol: 'ECG', decimals: 18 },
        infoURL: 'https://ssquad.games/',
        shortName: 'SPS-Test',
        chainId: 14000,
        networkId: 14000,
        slip44: 1,
        explorers: [
            {
                name: 'SPS Test Explorer',
                url: 'https://explorer.3sps.net',
                standard: 'EIP3091'
            }
        ]
    },
    14088: {
        name: 'Zeroth Testnet',
        chain: 'Zeroth',
        icon: 'zeroth',
        rpc: ['https://test-my.zeroth.run'],
        faucets: [],
        nativeCurrency: { name: 'Zeroth', symbol: 'ZRHt', decimals: 18 },
        infoURL: 'https://www.zeroth.foundation',
        shortName: 'ZRHt',
        chainId: 14088,
        networkId: 14088,
        explorers: [
            {
                name: 'Zeroth Explorer',
                url: 'https://test-scan.zeroth.run',
                icon: 'zeroth',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVz2jPdp5vXo4mJVuTXLmwcfQsw3XVojkmochPckvCowz'
    },
    14149: {
        name: 'Bitharvest Chain Mainnet',
        chain: 'Bitharvest Chain Mainnet',
        rpc: ['https://rpc.bthscan.io/'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: {
            name: 'Bitharvest Mainnet Native Token',
            symbol: 'BTH',
            decimals: 18
        },
        infoURL: '',
        shortName: 'BitharvestMainnet',
        chainId: 14149,
        networkId: 14149,
        explorers: [
            {
                name: 'Bitharvest Mainnet Scan',
                url: 'https://bthscan.io',
                standard: 'EIP3091'
            }
        ],
        icon: 'bth',
        iconURL: 'https://ipfs.io/ipfs/QmPdGw9RLstggj3xcVtAfzmP2rUy6i2FuM4KPLC9wTiQqm'
    },
    14235: {
        name: 'Bitlazer',
        chain: 'bitlazer',
        rpc: ['https://bitlazer.calderachain.xyz/http'],
        faucets: [],
        nativeCurrency: { name: 'lzrBTC', symbol: 'lzrBTC', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://bitlazer.hub.caldera.xyz',
        shortName: 'bitlazer',
        chainId: 14235,
        networkId: 14235,
        icon: 'bitlazer',
        explorers: [
            {
                name: 'Bitlazer Caldera Explorer',
                url: 'https://bitlazer.calderaexplorer.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreia4fgi2yp3ked4p356pbitpklsastu5zrztgdlkoihykm3vfmstyi'
    },
    14324: {
        name: 'EVOLVE Testnet',
        chain: 'EVO',
        icon: 'evolveIcon',
        rpc: ['https://testnet-rpc.evolveblockchain.io'],
        faucets: ['https://faucet.evolveblockchain.io'],
        nativeCurrency: { name: 'Evolve', symbol: 'EVO', decimals: 18 },
        infoURL: 'https://evolveblockchain.io',
        shortName: 'evo',
        chainId: 14324,
        networkId: 14324,
        explorers: [
            {
                name: 'Evolve Testnet Explorer',
                url: 'https://testnet.evolveblockchain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVxtpYYzc5214CB7BgsMC4mRNRHCD8fpbNMzZguBWyRwa'
    },
    14333: {
        name: 'Vitruveo Testnet',
        title: 'Vitruveo is a blockchain for Creators',
        chain: 'Vitruveo',
        rpc: ['https://test-rpc.vitruveo.xyz'],
        faucets: ['https://faucet.vitruveo.xyz'],
        nativeCurrency: {
            name: 'Vitruveo Test Coin',
            symbol: 'tVTRU',
            decimals: 18
        },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://www.vitruveo.xyz',
        shortName: 'vitruveo-test',
        chainId: 14333,
        networkId: 14333,
        icon: 'vitruveo',
        explorers: [
            {
                name: 'Vitruveo Testnet Explorer',
                url: 'https://test-explorer.vitruveo.xyz',
                icon: 'vitruveo',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidjhjv7uu7if745ys7ari3ka75spm2hqyr5po66sbe7kqsfk7ahua'
    },
    14800: {
        name: 'Vana Moksha Testnet',
        chain: 'Vana Moksha Testnet',
        rpc: ['https://rpc.moksha.vana.org'],
        nativeCurrency: { name: 'VANA', symbol: 'VANA', decimals: 18 },
        faucets: [],
        infoURL: '',
        shortName: 'vana-moksha',
        chainId: 14800,
        networkId: 14800,
        explorers: [
            {
                name: 'Vana Moksha Testnet',
                url: 'https://vanascan.io',
                icon: 'vanamoksha',
                standard: 'none'
            }
        ]
    },
    14801: {
        name: 'Vana Satori Testnet',
        chain: 'Satori',
        rpc: ['http://rpc.satori.vana.org'],
        faucets: ['https://faucet.vana.org'],
        nativeCurrency: { name: 'DAT', symbol: 'DAT', decimals: 18 },
        infoURL: 'https://satori.vana.org',
        shortName: 'satori',
        chainId: 14801,
        networkId: 14801,
        explorers: [
            {
                name: 'satoriscan',
                url: 'https://satori.vanascan.io',
                standard: 'EIP3091'
            }
        ]
    },
    14853: {
        name: 'Humanode Testnet 5 Israfel',
        chain: 'Humanode Testnet 5',
        rpc: ['https://explorer-rpc-http.testnet5.stages.humanode.io'],
        faucets: ['https://t.me/HumanodeTestnet5FaucetBot'],
        nativeCurrency: { name: 'eHMND', symbol: 'eHMND', decimals: 18 },
        infoURL: 'https://humanode.io',
        shortName: 'hmnd-t5',
        chainId: 14853,
        networkId: 14853,
        slip44: 1,
        icon: 'humanode',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/bafybeihuskzfwqogwvutaxil6sztmvpiavzbrzwjwpn6w2i4j3jysbybra'
    },
    15003: {
        name: 'Immutable zkEVM Devnet',
        chain: 'Immutable zkEVM',
        rpc: ['https://rpc.dev.immutable.com'],
        faucets: ['https://docs.immutable.com/docs/zkEVM/guides/faucet'],
        nativeCurrency: { name: 'Dev IMX', symbol: 'dIMX', decimals: 18 },
        infoURL: 'https://www.immutable.com',
        shortName: 'imx-devnet',
        chainId: 15003,
        networkId: 15003,
        icon: 'immutable',
        explorers: [
            {
                name: 'Immutable Devnet explorer',
                url: 'https://explorer.dev.immutable.com',
                standard: 'EIP3091',
                icon: 'immutable'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXFUYFW4e6wifbU9LKVq7owM14bnE6ZbbYq3bn1jBP3Mw'
    },
    15257: {
        name: 'Poodl Testnet',
        chain: 'Poodl',
        icon: 'poodlIcon',
        rpc: ['https://testnet-rpc.poodl.org'],
        faucets: ['https://faucet.poodl.org'],
        nativeCurrency: { name: 'Poodl', symbol: 'POODL', decimals: 18 },
        infoURL: 'https://poodl.org',
        shortName: 'poodlt',
        chainId: 15257,
        networkId: 15257,
        explorers: [
            {
                name: 'Poodl Testnet Explorer',
                url: 'https://testnet.poodl.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXfBFHHb5kJGQ3dMLnhDhfFBsgAvm9U72jBSYcfmRHL2p'
    },
    15259: {
        name: 'Poodl Mainnet',
        chain: 'Poodl',
        icon: 'poodlIcon',
        rpc: ['https://rpc.poodl.org'],
        faucets: [],
        nativeCurrency: { name: 'Poodl', symbol: 'POODL', decimals: 18 },
        infoURL: 'https://poodl.org',
        shortName: 'poodle',
        chainId: 15259,
        networkId: 15259,
        explorers: [
            {
                name: 'Poodl Mainnet Explorer',
                url: 'https://explorer.poodl.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXfBFHHb5kJGQ3dMLnhDhfFBsgAvm9U72jBSYcfmRHL2p'
    },
    15430: {
        name: 'KYMTC Mainnet',
        chain: 'KYMTC',
        icon: 'kymtc',
        rpc: ['https://mainnet-rpc.kymaticscan.online'],
        faucets: [],
        nativeCurrency: { name: 'KYMTC', symbol: 'KYMTC', decimals: 18 },
        infoURL: 'https://kymaticscan.online',
        shortName: 'KYMTC',
        chainId: 15430,
        networkId: 15430,
        explorers: [
            {
                name: 'KYMTC Mainnet Explorer',
                url: 'https://kymaticscan.online',
                icon: 'kymtc',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmR1AnNYGeXpVmsKyzqktk4K1BtFPiaJpeXuLktb9Kwmer'
    },
    15551: {
        name: 'LoopNetwork Mainnet',
        chain: 'LoopNetwork',
        rpc: ['https://api.mainnetloop.com'],
        faucets: [],
        nativeCurrency: { name: 'LOOP', symbol: 'LOOP', decimals: 18 },
        infoURL: 'http://theloopnetwork.org/',
        shortName: 'loop',
        chainId: 15551,
        networkId: 15551,
        explorers: [
            {
                name: 'loopscan',
                url: 'http://explorer.mainnetloop.com',
                standard: 'none'
            }
        ]
    },
    15555: {
        name: 'Trust EVM Testnet',
        chain: 'Trust EVM Testnet',
        rpc: ['https://api.testnet-dev.trust.one'],
        faucets: ['https://faucet.testnet-dev.trust.one/'],
        nativeCurrency: { name: 'Trust EVM', symbol: 'EVM', decimals: 18 },
        infoURL: 'https://www.trust.one/',
        shortName: 'TrustTestnet',
        chainId: 15555,
        networkId: 15555,
        slip44: 1,
        explorers: [
            {
                name: 'Trust EVM Explorer',
                url: 'https://trustscan.one',
                standard: 'EIP3091'
            }
        ]
    },
    15557: {
        name: 'EOS EVM Network Testnet',
        chain: 'EOS',
        icon: 'eos',
        rpc: ['https://api.testnet.evm.eosnetwork.com'],
        faucets: [],
        nativeCurrency: { name: 'EOS', symbol: 'EOS', decimals: 18 },
        infoURL: 'https://eosnetwork.com/eos-evm',
        shortName: 'eos-testnet',
        chainId: 15557,
        networkId: 15557,
        slip44: 1,
        explorers: [
            {
                name: 'EOS EVM Explorer',
                url: 'https://explorer.testnet.evm.eosnetwork.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXkK5D5GWizvY1FmL6pV8cYLAbhehKETubktCgh6qDJZb'
    },
    16000: {
        name: 'MetaDot Mainnet',
        chain: 'MTT',
        rpc: ['https://mainnet.metadot.network'],
        faucets: [],
        nativeCurrency: { name: 'MetaDot Token', symbol: 'MTT', decimals: 18 },
        infoURL: 'https://metadot.network',
        shortName: 'mtt',
        chainId: 16000,
        networkId: 16000
    },
    16001: {
        name: 'MetaDot Testnet',
        chain: 'MTTTest',
        rpc: ['https://testnet.metadot.network'],
        faucets: ['https://faucet.metadot.network/'],
        nativeCurrency: {
            name: 'MetaDot Token TestNet',
            symbol: 'MTTest',
            decimals: 18
        },
        infoURL: 'https://metadot.network',
        shortName: 'mtttest',
        chainId: 16001,
        networkId: 16001,
        slip44: 1
    },
    16116: {
        name: 'DeFiVerse Mainnet',
        chain: 'DeFiVerse',
        icon: 'defiverse',
        rpc: ['https://rpc.defi-verse.org/'],
        faucets: [],
        nativeCurrency: { name: 'Oasys', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://defi-verse.org',
        shortName: 'DFV',
        chainId: 16116,
        networkId: 16116,
        explorers: [
            {
                name: 'DeFiVerse Explorer',
                url: 'https://scan.defi-verse.org',
                icon: 'defiverse',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-248' },
        iconURL: 'https://ipfs.io/ipfs/QmaSqPELi11UepS3odwHyiwfUPkLBnE4WP4zNkwumHoPmw'
    },
    16166: {
        name: 'Cypherium Mainnet',
        chain: 'CPH',
        rpc: ['https://pubnodes.cypherium.io/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Cypherium', symbol: 'CPH', decimals: 18 },
        infoURL: 'https://www.cypherium.io/',
        shortName: 'cph',
        chainId: 16166,
        networkId: 16166,
        explorers: [
            {
                name: 'Testnet Block Explorer',
                url: 'https://cypherium.tryethernal.com',
                standard: 'EIP3091'
            }
        ]
    },
    16180: {
        name: 'PLYR PHI',
        chain: 'PLYR',
        icon: 'plyr',
        rpc: ['https://subnets.avax.network/plyr/mainnet/rpc'],
        faucets: [],
        nativeCurrency: { name: 'PLYR', symbol: 'PLYR', decimals: 18 },
        infoURL: 'https://plyr.network',
        shortName: 'plyr-phi',
        chainId: 16180,
        networkId: 16180,
        explorers: [
            {
                name: 'PLYR PHI Explorer',
                url: 'https://explorer.plyr.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVhG7xeTc78ibQunQ5sBJ4533r9FDM2xUCQKV72DPd1ux'
    },
    16182: {
        name: 'Eventum Testnet',
        title: 'Eventum Testnet',
        chain: 'eventum-testnet',
        rpc: ['https://testnet-rpc.eh-dev.app', 'wss://testnet-ws.eh-dev.app'],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/event-horizon-eventum-testnet',
        faucets: [],
        shortName: 'eventum-testnet',
        chainId: 16182,
        networkId: 16182,
        slip44: 60,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet-blockscout.eh-dev.app',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-421614',
            bridges: [
                {
                    url: 'https://testnet-bridge.eh-dev.app/bridge/event-horizon-eventum-testnet'
                }
            ]
        },
        status: 'active'
    },
    16350: {
        name: 'Incentiv Devnet',
        chain: 'Incentiv',
        rpc: ['https://rpc.ankr.com/incentiv_devnet'],
        faucets: ['https://faucet.incentiv-dev.ankr.network'],
        nativeCurrency: { name: 'Testnet INC', symbol: 'INC', decimals: 18 },
        infoURL: 'https://incentiv.net',
        shortName: 'tIncentiv',
        chainId: 16350,
        networkId: 16350,
        slip44: 1
    },
    16481: {
        name: 'Pivotal Sepolia',
        chainId: 16481,
        networkId: 16481,
        chain: 'Pivotal',
        rpc: ['https://sepolia.pivotalprotocol.com'],
        faucets: [],
        shortName: 'pivotal-sepolia',
        nativeCurrency: { name: 'Pivotal ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'http://thepivotal.xyz/',
        explorers: [
            {
                name: 'Pivotal Scan',
                url: 'https://sepolia.pivotalscan.xyz',
                standard: 'EIP3091'
            }
        ]
    },
    16507: {
        name: 'Genesys Mainnet',
        chain: 'Genesys',
        icon: 'genesys',
        rpc: ['https://rpc.genesys.network'],
        faucets: [],
        nativeCurrency: { name: 'Genesys', symbol: 'GSYS', decimals: 18 },
        infoURL: 'https://www.genesys.network/',
        shortName: 'Genesys',
        chainId: 16507,
        networkId: 16507,
        explorers: [
            {
                name: 'GchainExplorer',
                url: 'https://gchainexplorer.genesys.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreie6nai3yhykcdlsyshn5lbcbyba5y7zwsqg6owcfek2urhoucr6rm'
    },
    16600: {
        name: '0G-Newton-Testnet',
        chain: '0G-Testnet',
        rpc: ['https://evmrpc-testnet.0g.ai'],
        faucets: ['https://faucet.0g.ai'],
        nativeCurrency: { name: 'A0GI', symbol: 'A0GI', decimals: 18 },
        infoURL: 'https://0g.ai',
        shortName: '0gai-testnet',
        chainId: 16600,
        networkId: 16600,
        icon: '0gai',
        explorers: [
            {
                name: '0G BlockChain Explorer',
                url: 'https://chainscan-newton.0g.ai',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreic6mqwxp4g3defk5emaw6hbnimtjhmnxgzh5nje4gsvjgxhl64mqa'
    },
    16688: {
        name: 'IRIShub Testnet',
        chain: 'IRIShub',
        rpc: ['https://evmrpc.nyancat.irisnet.org'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Eris', symbol: 'ERIS', decimals: 18 },
        infoURL: 'https://www.irisnet.org',
        shortName: 'nyancat',
        chainId: 16688,
        networkId: 16688,
        slip44: 1,
        icon: 'nyancat',
        explorers: [
            {
                name: 'IRISHub Testnet Cosmos Explorer (IOBScan)',
                url: 'https://nyancat.iobscan.io',
                standard: 'none',
                icon: 'nyancat'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRaSx7AX1VDgcqjwLgSDP4WZmKBHPdHhbjkcEEXPA2Fnc'
    },
    16718: {
        name: 'AirDAO Mainnet',
        chain: 'ambnet',
        icon: 'airdao',
        rpc: ['https://network.ambrosus.io'],
        faucets: [],
        nativeCurrency: { name: 'Amber', symbol: 'AMB', decimals: 18 },
        infoURL: 'https://airdao.io',
        shortName: 'airdao',
        chainId: 16718,
        networkId: 16718,
        explorers: [
            {
                name: 'AirDAO Network Explorer',
                url: 'https://airdao.io/explorer',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSxXjvWng3Diz4YwXDV2VqSPgMyzLYBNfkjJcr7rzkxom'
    },
    16888: {
        name: 'IVAR Chain Testnet',
        chain: 'IVAR',
        icon: 'ivar',
        rpc: ['https://testnet-rpc.ivarex.com'],
        faucets: ['https://tfaucet.ivarex.com/'],
        nativeCurrency: { name: 'tIvar', symbol: 'tIVAR', decimals: 18 },
        infoURL: 'https://ivarex.com',
        shortName: 'tivar',
        chainId: 16888,
        networkId: 16888,
        slip44: 1,
        explorers: [
            {
                name: 'ivarscan',
                url: 'https://testnet.ivarscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmV8UmSwqGF2fxrqVEBTHbkyZueahqyYtkfH2RBF5pNysM'
    },
    17000: {
        name: 'Holesky',
        title: 'Ethereum Testnet Holesky',
        chain: 'ETH',
        rpc: [
            'https://rpc.holesky.ethpandaops.io',
            'https://ethereum-holesky-rpc.publicnode.com',
            'wss://ethereum-holesky-rpc.publicnode.com',
            'https://holesky.drpc.org',
            'wss://holesky.drpc.org',
            'https://rpc-holesky.rockx.com'
        ],
        faucets: [
            'https://faucet.holesky.ethpandaops.io',
            'https://holesky-faucet.pk910.de'
        ],
        nativeCurrency: { name: 'Testnet ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://holesky.ethpandaops.io',
        shortName: 'holesky',
        chainId: 17000,
        networkId: 17000,
        slip44: 1,
        icon: 'ethereum',
        status: 'incubating',
        explorers: [
            {
                name: 'Holesky Explorer',
                url: 'https://holesky.beaconcha.in',
                icon: 'ethereum',
                standard: 'EIP3091'
            },
            {
                name: 'otterscan-holesky',
                url: 'https://holesky.otterscan.io',
                icon: 'ethereum',
                standard: 'EIP3091'
            },
            {
                name: 'Holesky Etherscan',
                url: 'https://holesky.etherscan.io',
                icon: 'ethereum',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt'
    },
    17001: {
        name: 'Redstone Holesky Testnet',
        chain: 'ETH',
        rpc: ['https://rpc.holesky.redstone.xyz'],
        faucets: [],
        nativeCurrency: {
            name: 'Redstone Testnet Ether',
            symbol: 'ETH',
            decimals: 18
        },
        infoURL: 'https://redstone.xyz/docs/network-info',
        shortName: 'redstone-holesky',
        chainId: 17001,
        networkId: 17001,
        slip44: 1,
        icon: 'redstone',
        explorers: [
            {
                name: 'Redstone Holesky Explorer',
                url: 'https://explorer.holesky.redstone.xyz',
                icon: 'ethereum',
                standard: 'EIP3091'
            }
        ],
        status: 'deprecated',
        iconURL: 'https://ipfs.io/ipfs/bafkreieyaqgkgntvxuo5tnhgseladga5q6gutc37dab7kqqfdguhq7vkxq'
    },
    17069: {
        name: 'Garnet Holesky',
        chain: 'ETH',
        rpc: ['https://rpc.garnetchain.com', 'wss://rpc.garnetchain.com'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://redstone.xyz',
        shortName: 'garnet',
        chainId: 17069,
        networkId: 17069,
        icon: 'garnet',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.garnetchain.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-17000',
            bridges: [{ url: 'https://garnetchain.com/deposit' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmWhHvjbjTiNNsHKpbEz9rxSt4CCL2Q5xVZjk8eQkp82B9'
    },
    17071: {
        name: 'Onchain Points',
        chain: 'POP',
        rpc: [
            'https://rpc.onchainpoints.xyz',
            'https://rpc-onchain-points-8n0qkkpr2j.t.conduit.xyz/{CONDUIT_API_KEY}'
        ],
        faucets: [],
        nativeCurrency: { name: 'OnchainPoints.xyz', symbol: 'POP', decimals: 18 },
        infoURL: 'https://onchainpoints.xyz',
        shortName: 'pop',
        chainId: 17071,
        networkId: 17071,
        icon: 'pop',
        status: 'incubating',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.onchainpoints.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbY9ZPnveSEnFhbhfHr5B2R8SPhQBKbAZnwQCoEkvAQtT'
    },
    17117: {
        name: 'DeFiVerse Testnet',
        chain: 'DeFiVerse Testnet',
        icon: 'defiverse',
        rpc: ['https://rpc-testnet.defi-verse.org/'],
        faucets: [],
        nativeCurrency: { name: 'Oasys', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://defi-verse.org',
        shortName: 'DFV-testnet',
        chainId: 17117,
        networkId: 17117,
        explorers: [
            {
                name: 'DeFiVerse Testnet Explorer',
                url: 'https://scan-testnet.defi-verse.org',
                icon: 'defiverse',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaSqPELi11UepS3odwHyiwfUPkLBnE4WP4zNkwumHoPmw'
    },
    17171: {
        name: 'G8Chain Mainnet',
        chain: 'G8C',
        icon: 'G8Chain',
        rpc: ['https://mainnet-rpc.oneg8.network'],
        faucets: ['https://faucet.oneg8.network'],
        nativeCurrency: { name: 'G8Chain', symbol: 'G8C', decimals: 18 },
        infoURL: 'https://oneg8.one',
        shortName: 'G8Cm',
        chainId: 17171,
        networkId: 17171,
        explorers: [
            {
                name: 'G8Chain',
                url: 'https://mainnet.oneg8.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbkCVC5vZpVAfq8SuPXR9PhpTRS2m8w6LGqBkhXAvmie6'
    },
    17172: {
        name: 'Eclipse Subnet',
        chain: 'ECLIPSE',
        rpc: ['https://subnets.avax.network/eclipse/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Eclipse', symbol: 'ECLP', decimals: 16 },
        infoURL: 'http://eclipsenet.io',
        shortName: 'eclipse',
        chainId: 17172,
        networkId: 17172,
        explorers: [
            {
                name: 'ECLIPSE Explorer',
                url: 'https://subnets-test.avax.network/eclipse',
                standard: 'EIP3091'
            }
        ]
    },
    17180: {
        name: 'Palette Chain Testnet',
        chain: 'PLT',
        rpc: ['https://palette-opennet.com:22000'],
        faucets: [],
        nativeCurrency: { name: 'Palette Token', symbol: 'PLT', decimals: 18 },
        features: [],
        infoURL: 'https://hashpalette.com/',
        shortName: 'PCT',
        chainId: 17180,
        networkId: 17180,
        slip44: 1,
        icon: 'PLT',
        explorers: [
            {
                name: 'Palettescan',
                url: 'https://testnet.palettescan.com',
                icon: 'PLT',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPCEGZD1p1keTT2YfPp725azx1r9Ci41hejeUuGL2whFA'
    },
    17217: {
        name: 'KONET Mainnet',
        chain: 'KONET',
        rpc: ['https://api.kon-wallet.com'],
        faucets: [],
        nativeCurrency: { name: 'KONET', symbol: 'KONET', decimals: 18 },
        infoURL: 'https://konetmain.com',
        shortName: 'KONET',
        chainId: 17217,
        networkId: 17217,
        slip44: 1,
        icon: 'konet',
        explorers: [
            {
                name: 'konet-explorer',
                url: 'https://explorer.kon-wallet.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSszu2AhLPgcp8SZYiBYCQiRVwb9ueqbnGbcTx9H9CJjZ'
    },
    17735: {
        name: 'Esports Chain',
        chain: 'ESPT',
        icon: 'esports',
        rpc: ['https://esportsblock.org/rpc/'],
        faucets: [],
        nativeCurrency: { name: 'Esport Token', symbol: 'ESPT', decimals: 18 },
        infoURL: 'https://esportsblock.org',
        shortName: 'Esports',
        chainId: 17735,
        networkId: 17735,
        explorers: [
            {
                name: 'esportsblock_explorer',
                url: 'https://esportsblock.org/explorer',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaNywdCUrHoe3grk3hhHXrsTgc3tHVpt2ZaoRYoNkgEvc'
    },
    17777: {
        name: 'EOS EVM Network',
        chain: 'EOS',
        icon: 'eos',
        rpc: ['https://api.evm.eosnetwork.com'],
        faucets: [],
        nativeCurrency: { name: 'EOS', symbol: 'EOS', decimals: 18 },
        infoURL: 'https://eosnetwork.com/eos-evm',
        shortName: 'eos',
        chainId: 17777,
        networkId: 17777,
        explorers: [
            {
                name: 'EOS EVM Explorer',
                url: 'https://explorer.evm.eosnetwork.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXkK5D5GWizvY1FmL6pV8cYLAbhehKETubktCgh6qDJZb'
    },
    18000: {
        name: 'Frontier of Dreams Testnet',
        chain: 'Game Network',
        rpc: ['https://rpc.fod.games/'],
        nativeCurrency: { name: 'ZKST', symbol: 'ZKST', decimals: 18 },
        faucets: [],
        shortName: 'ZKST',
        chainId: 18000,
        networkId: 18000,
        slip44: 1,
        infoURL: 'https://goexosphere.com',
        explorers: [
            {
                name: 'Game Network',
                url: 'https://explorer.fod.games',
                standard: 'EIP3091'
            }
        ]
    },
    18122: {
        name: 'Smart Trade Networks',
        chain: 'Smart Trade Networks',
        rpc: ['https://beefledgerwallet.com:8544'],
        faucets: [],
        nativeCurrency: { name: 'STN', symbol: 'STN', decimals: 18 },
        infoURL: 'https://www.smarttradenetworks.com',
        shortName: 'STN',
        chainId: 18122,
        networkId: 18122,
        icon: 'stn',
        explorers: [
            {
                name: 'stnscan',
                url: 'https://stnscan.com',
                icon: 'stn',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRgZVpjik4cH3Sb6wLRpdnfv9kiMEZ8fugfkzTgk3bpRW'
    },
    18159: {
        name: 'Proof Of Memes',
        title: 'Proof Of Memes Mainnet',
        chain: 'POM',
        icon: 'pom',
        rpc: [
            'https://mainnet-rpc.memescan.io',
            'https://mainnet-rpc2.memescan.io',
            'https://mainnet-rpc3.memescan.io',
            'https://mainnet-rpc4.memescan.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'Proof Of Memes', symbol: 'POM', decimals: 18 },
        infoURL: 'https://proofofmemes.org',
        shortName: 'pom',
        chainId: 18159,
        networkId: 18159,
        explorers: [
            {
                name: 'explorer-proofofmemes',
                url: 'https://memescan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmePhfibWz9jnGUqF9Rven4x734br1h3LxrChYTEjbbQvo'
    },
    18181: {
        name: 'G8Chain Testnet',
        chain: 'G8C',
        icon: 'G8Chain',
        rpc: ['https://testnet-rpc.oneg8.network'],
        faucets: ['https://faucet.oneg8.network'],
        nativeCurrency: { name: 'G8Coin', symbol: 'G8C', decimals: 18 },
        infoURL: 'https://oneg8.one',
        shortName: 'G8Ct',
        chainId: 18181,
        networkId: 18181,
        slip44: 1,
        explorers: [
            {
                name: 'G8Chain',
                url: 'https://testnet.oneg8.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbkCVC5vZpVAfq8SuPXR9PhpTRS2m8w6LGqBkhXAvmie6'
    },
    18231: {
        name: 'unreal-old',
        title: 'unreal testnet for re.al',
        chain: 'unreal',
        rpc: [
            'https://rpc.unreal.gelato.digital',
            'wss://ws.unreal.gelato.digital'
        ],
        nativeCurrency: { name: 'unreal Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/unreal',
        faucets: [],
        shortName: 'unreal-old',
        chainId: 18231,
        networkId: 18231,
        slip44: 60,
        icon: 'unreal',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://unreal.blockscout.com',
                icon: 'unreal',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111', bridges: [] },
        status: 'deprecated',
        iconURL: 'https://ipfs.io/ipfs/QmZbtoK9Q1DHTHjsgPUfHkzb9xdWzrSfPwPQ8M8FPu84mA'
    },
    18233: {
        name: 'unreal',
        title: 'unreal testnet for re.al',
        chain: 'unreal',
        rpc: [
            'https://rpc.unreal-orbit.gelato.digital',
            'wss://ws.unreal-orbit.gelato.digital'
        ],
        nativeCurrency: { name: 'unreal Ether', symbol: 'reETH', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/unreal',
        faucets: [],
        shortName: 'unreal',
        chainId: 18233,
        networkId: 18233,
        slip44: 60,
        icon: 'unreal',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://unreal.blockscout.com',
                icon: 'unreal',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-17000',
            bridges: [{ url: 'https://bridge.gelato.network/bridge/unreal' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmZbtoK9Q1DHTHjsgPUfHkzb9xdWzrSfPwPQ8M8FPu84mA'
    },
    18686: {
        name: 'MXC zkEVM Moonchain',
        chain: 'MXC zkEVM',
        icon: 'mxczkevm',
        rpc: ['https://rpc.mxc.com'],
        faucets: [],
        nativeCurrency: {
            name: 'MXC zkEVM Moonchain',
            symbol: 'MXC',
            decimals: 18
        },
        infoURL: 'https://doc.mxc.com/docs/intro',
        shortName: 'MXCzkEVM',
        chainId: 18686,
        networkId: 18686,
        explorers: [
            {
                name: 'MXC zkEVM Moonchain',
                url: 'https://explorer.moonchain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdGCthKA11K9kCZJdbTP5WPAyq1wiRZ3REn6KG58MrWaE'
    },
    18880: {
        name: 'EXPchain Testnet',
        chain: 'EXPCHAIN',
        rpc: ['https://rpc1-testnet.expchain.ai'],
        faucets: [],
        nativeCurrency: { name: 'tZKJ', symbol: 'tZKJ', decimals: 18 },
        infoURL: 'https://expchain.ai',
        shortName: 'expchain',
        chainId: 18880,
        networkId: 18880,
        icon: 'expchain',
        explorers: [
            {
                name: 'EXPchain Testnet Explorer',
                url: 'https://blockscout-testnet.expchain.ai',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUf9AtP2ZjQFvE8V4UV5RXQJkfUrCAh4tyY7ZHesBhCMB'
    },
    18881: {
        name: 'Ultra EVM Network Testnet',
        chain: 'Ultra',
        icon: 'ultra',
        rpc: ['https://evm.test.ultra.eosusa.io'],
        faucets: [],
        nativeCurrency: { name: 'Ultra Token', symbol: 'UOS', decimals: 18 },
        infoURL: 'https://ultra.io/',
        shortName: 'ultra-testnet',
        chainId: 18881,
        networkId: 18881,
        slip44: 1,
        explorers: [
            {
                name: 'Ultra EVM Testnet Explorer',
                url: 'https://evmexplorer.testnet.ultra.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeGtXdTHHMnf6rWUWFcefMGaVp7dJ6SWNgxgbVgm9YHTZ'
    },
    18888: {
        name: 'Titan (TKX)',
        chain: 'Titan (TKX)',
        rpc: [
            'https://titan-json-rpc.titanlab.io',
            'https://titan-json-rpc-tokyo.titanlab.io',
            'https://titan-json-rpc-seoul.titanlab.io',
            'https://titan-json-rpc-hongkong.titanlab.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'Titan tkx', symbol: 'TKX', decimals: 18 },
        infoURL: 'https://titanlab.io',
        shortName: 'titan_tkx',
        chainId: 18888,
        networkId: 18888,
        slip44: 1,
        icon: 'titan_tkx',
        explorers: [
            {
                name: 'Titan Explorer',
                url: 'https://tkxscan.io/Titan',
                standard: 'none',
                icon: 'titan_tkx'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreicyvc7t55zsejv6vwaxbmhvea5vdfkkbgqkmn65rhyyifpg3mq3ua'
    },
    18889: {
        name: 'Titan (TKX) Testnet',
        chain: 'Titan (TKX)',
        rpc: [
            'https://titan-testnet-json-rpc.titanlab.io',
            'https://titan-testnet-json-rpc-1.titanlab.io',
            'https://titan-testnet-json-rpc-2.titanlab.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'Titan tkx', symbol: 'TKX', decimals: 18 },
        infoURL: 'https://titanlab.io',
        shortName: 'titan_tkx-testnet',
        chainId: 18889,
        networkId: 18889,
        slip44: 1,
        icon: 'titan_tkx',
        explorers: [
            {
                name: 'Titan Explorer',
                url: 'https://titan-testnet-explorer-light.titanlab.io/Titan%20Testnet',
                standard: 'none',
                icon: 'titan_tkx'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreicyvc7t55zsejv6vwaxbmhvea5vdfkkbgqkmn65rhyyifpg3mq3ua'
    },
    19011: {
        name: 'HOME Verse Mainnet',
        chain: 'HOME Verse',
        icon: 'home_verse',
        rpc: ['https://rpc.mainnet.oasys.homeverse.games/'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://www.homeverse.games/',
        shortName: 'HMV',
        chainId: 19011,
        networkId: 19011,
        explorers: [
            {
                name: 'HOME Verse Explorer',
                url: 'https://explorer.oasys.homeverse.games',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-248' },
        iconURL: 'https://ipfs.io/ipfs/QmeGb65zSworzoHmwK3jdkPtEsQZMUSJRxf8K8Feg56soU'
    },
    19077: {
        name: 'BlockX Atlantis Testnet',
        chain: 'blockx',
        rpc: ['https://atlantis-web3.blockxnet.com'],
        faucets: ['https://ping.blockxnet.com/blockx-atlantis-testnet/faucet'],
        nativeCurrency: { name: 'BCX', symbol: 'BCX', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.blockxnet.com/',
        shortName: 'tbcx',
        chainId: 19077,
        networkId: 19077,
        explorers: [
            {
                name: 'BlockX EVM Explorer (Blockscout)',
                url: 'https://testnet-explorer.blockxnet.com',
                standard: 'EIP3091'
            },
            {
                name: 'BlockX Cosmos Explorer (Ping)',
                url: 'https://ping.blockxnet.com/blockx-atlantis-testnet',
                standard: 'none'
            }
        ]
    },
    19180: {
        name: 'LocaChain Mainnet',
        chain: 'LocaChain',
        rpc: ['https://tgrpntwm.locachain.io'],
        faucets: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'LocaCoin', symbol: 'LCC', decimals: 18 },
        infoURL: 'https://locachain.io',
        shortName: 'locachain',
        chainId: 19180,
        networkId: 19180,
        icon: 'locacoin',
        explorers: [
            {
                name: 'Locachain Explorer',
                url: 'https://explorer.locachain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSk1Kf6UyA5NxXfBUV4xqxDgpsZnsggWGb7hXhz6to1fz'
    },
    19191: {
        name: 'BlockX Mainnet',
        chain: 'blockx',
        rpc: ['https://web3.blockxnet.com'],
        faucets: ['https://ping.blockxnet.com/blockx/faucet'],
        nativeCurrency: { name: 'BCX', symbol: 'BCX', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.blockxnet.com/',
        shortName: 'bcx',
        chainId: 19191,
        networkId: 19191,
        explorers: [
            {
                name: 'BlockX EVM Explorer (Blockscout)',
                url: 'https://explorer.blockxnet.com',
                standard: 'EIP3091'
            },
            {
                name: 'BlockX Cosmos Explorer (Ping)',
                url: 'https://ping.blockxnet.com/blockx',
                standard: 'none'
            }
        ]
    },
    19224: {
        name: 'Decentraconnect Social',
        chain: 'DCSM',
        icon: 'dcsmIcon',
        rpc: ['https://rpc.decentraconnect.io'],
        faucets: [],
        nativeCurrency: {
            name: 'Decentraconnect Social',
            symbol: 'DCSM',
            decimals: 18
        },
        infoURL: 'https://docs.decentraconnect.io',
        shortName: 'DCSMs',
        chainId: 19224,
        networkId: 19224,
        explorers: [
            {
                name: 'Decentraconnect Social',
                url: 'https://decentraconnect.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmatvJXLgMthjXwydGBVFRtga9fZXJ3qFEVJ6cMRxniFUc'
    },
    19515: {
        name: 'SEC Testnet',
        chain: 'SEC',
        icon: 'secIcon',
        rpc: ['https://testnet-rpc.secexplorer.io'],
        faucets: ['https://faucet.secexplorer.io'],
        nativeCurrency: { name: 'SEP', symbol: 'SEP', decimals: 18 },
        infoURL: 'https://smartenergychain.org',
        shortName: 'SEPt',
        chainId: 19515,
        networkId: 19515,
        explorers: [
            {
                name: 'SEC Testnet Explorer',
                url: 'https://testnet.secexplorer.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWeJdWk2HiZhcCtecHyzxm7DBH5KDH2ERj9ZiqxmxgUto'
    },
    19516: {
        name: 'SEC Mainnet',
        chain: 'SEC',
        icon: 'secIcon',
        rpc: ['https://rpc.secexplorer.io'],
        faucets: [],
        nativeCurrency: { name: 'SEP', symbol: 'SEP', decimals: 18 },
        infoURL: 'https://smartenergychain.org',
        shortName: 'SECm',
        chainId: 19516,
        networkId: 19516,
        explorers: [
            {
                name: 'SEC Mainnet Explorer',
                url: 'https://secexplorer.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWeJdWk2HiZhcCtecHyzxm7DBH5KDH2ERj9ZiqxmxgUto'
    },
    19527: {
        name: 'Magnet Network',
        chain: 'Magnet',
        rpc: ['https://magnet-rpc.magport.io/'],
        faucets: [],
        nativeCurrency: { name: 'Magnet Network', symbol: 'DOT', decimals: 18 },
        infoURL: 'https://magnet.magport.io/',
        shortName: 'mgt',
        chainId: 19527,
        networkId: 19527,
        explorers: []
    },
    19546: {
        name: 'Zytron Linea Testnet',
        chain: 'ETH',
        icon: 'zytron',
        rpc: ['https://linea-testnet-zytron.zypher.game/'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://zytron.zypher.network/',
        shortName: 'zytron-linea-testnet',
        chainId: 19546,
        networkId: 19546,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://linea-testnet-zytron-blockscout.zypher.game',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmY9cfmkCxJfPwKfCv6aF6CNiMWM5aN3jUSTf4rMfxaaJd'
    },
    19600: {
        name: 'LBRY Mainnet',
        chain: 'LBRY',
        icon: 'lbry',
        rpc: ['https://lbry.nl/rpc'],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: { name: 'LBRY Credits', symbol: 'LBC', decimals: 8 },
        infoURL: 'https://lbry.com',
        shortName: 'LBRY',
        chainId: 19600,
        networkId: 19600,
        slip44: 140,
        explorers: [
            {
                name: 'LBRY Block Explorer',
                url: 'https://explorer.lbry.com',
                icon: 'lbry',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUoSiFWaPTbVY6ZfJswzrM9jKuhfhXWwstRo49cVCWr8x'
    },
    19777: {
        name: 'Astra Sepolia',
        chain: 'Astra Sepolia',
        icon: 'astrasepolia',
        rpc: ['https://rpc-astra-9on2f72wzn.t.conduit.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Astra', symbol: 'ATX', decimals: 18 },
        infoURL: 'https://explorer-astra-9on2f72wzn.t.conduit.xyz',
        shortName: 'astra-sepolia',
        chainId: 19777,
        networkId: 19777,
        slip44: 1,
        explorers: [
            {
                name: 'Astra Sepolia Explorer',
                url: 'https://explorer-astra-9on2f72wzn.t.conduit.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQW8DuuyxjdLWAPq3V9zSfdAimaStptZ4gxZ3aEviAafc'
    },
    19845: {
        name: 'BTCIX Network',
        chain: 'BTCIX',
        rpc: ['https://seed.btcix.org/rpc'],
        faucets: [],
        nativeCurrency: { name: 'BTCIX Network', symbol: 'BTCIX', decimals: 18 },
        infoURL: 'https://bitcolojix.org',
        shortName: 'btcix',
        chainId: 19845,
        networkId: 19845,
        explorers: [
            {
                name: 'BTCIXScan',
                url: 'https://btcixscan.com',
                standard: 'none'
            }
        ]
    },
    19991: {
        name: 'Ultra EVM Network',
        chain: 'Ultra',
        icon: 'ultra',
        rpc: ['https://evm.ultra.eosusa.io'],
        faucets: [],
        nativeCurrency: { name: 'Ultra Token', symbol: 'UOS', decimals: 18 },
        infoURL: 'https://ultra.io',
        shortName: 'ultra',
        chainId: 19991,
        networkId: 19991,
        explorers: [
            {
                name: 'Ultra EVM Explorer',
                url: 'https://evmexplorer.ultra.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeGtXdTHHMnf6rWUWFcefMGaVp7dJ6SWNgxgbVgm9YHTZ'
    },
    20001: {
        name: 'Camelark Mainnet',
        chainId: 20001,
        shortName: 'Camelark',
        chain: 'ETHW',
        icon: 'camelark',
        networkId: 20001,
        nativeCurrency: { name: 'EthereumPoW', symbol: 'ETHW', decimals: 18 },
        rpc: ['https://mainnet-http-rpc.camelark.com'],
        faucets: [],
        explorers: [
            {
                name: 'CamelarkScan',
                url: 'https://scan.camelark.com',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://www.camelark.com',
        iconURL: 'https://ipfs.io/ipfs/QmeJerrsURFNt2LL7DE7TxeunjrQXiuezdfHyqmsbwX3MZ'
    },
    20041: {
        name: 'Niza Chain Mainnet',
        chain: 'NIZA',
        icon: 'niza',
        rpc: ['https://nizascan.io/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Niza Global', symbol: 'NIZA', decimals: 18 },
        infoURL: 'https://niza.io',
        shortName: 'niza',
        chainId: 20041,
        networkId: 20041,
        explorers: [
            {
                name: 'NizaScan',
                url: 'https://nizascan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPh2FdjoPWBaCKNrknv6HjruxdUCr8AvJYvhpgHZP6e2C'
    },
    20073: {
        name: 'Niza Chain Testnet',
        chain: 'NIZA',
        icon: 'niza',
        rpc: ['https://testnet.nizascan.io/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Niza Global', symbol: 'NIZA', decimals: 18 },
        infoURL: 'https://niza.io',
        shortName: 'niza_testnet',
        chainId: 20073,
        networkId: 20073,
        explorers: [
            {
                name: 'NizaScan',
                url: 'https://testnet.nizascan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPh2FdjoPWBaCKNrknv6HjruxdUCr8AvJYvhpgHZP6e2C'
    },
    20143: {
        name: 'Monad Devnet',
        chain: 'MON',
        icon: 'monad',
        rpc: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Devnet MON Token', symbol: 'MON', decimals: 18 },
        infoURL: 'https://monad.xyz',
        shortName: 'mon-devnet',
        chainId: 20143,
        networkId: 20143,
        slip44: 1,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/bafkreia4vjioitvcrm5umefahnp4wttswooykroarjo5itdvohvk6epiya'
    },
    20441: {
        name: 'XUSD ONE StableChain Mainnet',
        chain: 'XUSD ONE',
        icon: 'xusd',
        rpc: ['https://xusd.live'],
        faucets: [],
        nativeCurrency: { name: 'XUSD ONE', symbol: 'X1', decimals: 18 },
        infoURL: 'https://xusd.co',
        shortName: 'xusd',
        chainId: 20441,
        networkId: 20441,
        explorers: [
            {
                name: 'xusdscan',
                url: 'https://xusdscan.com',
                icon: 'xusdscan',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreid7fdetal6wmyum5tbuhacb66gkcqkrvphcsrc3vid5xidiulycwu'
    },
    20729: {
        name: 'Callisto Testnet',
        chain: 'CLO',
        rpc: ['https://testnet-rpc.callisto.network/'],
        faucets: ['https://faucet.callisto.network/'],
        nativeCurrency: { name: 'Callisto', symbol: 'CLO', decimals: 18 },
        infoURL: 'https://callisto.network',
        shortName: 'CLOTestnet',
        chainId: 20729,
        networkId: 79,
        slip44: 1
    },
    20736: {
        name: 'P12 Chain',
        chain: 'P12',
        icon: 'p12',
        rpc: ['https://rpc-chain.p12.games'],
        faucets: [],
        nativeCurrency: { name: 'Hooked P2', symbol: 'hP2', decimals: 18 },
        infoURL: 'https://p12.network',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        shortName: 'p12',
        chainId: 20736,
        networkId: 20736,
        explorers: [
            {
                name: 'P12 Chain Explorer',
                url: 'https://explorer.p12.games',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreieiro4imoujeewc4r4thf5hxj47l56j2iwuz6d6pdj6ieb6ub3h7e'
    },
    20765: {
        name: 'Jono11 Subnet',
        chain: 'JONO11',
        icon: 'jono11',
        rpc: ['https://subnets.avax.network/jono11/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Jono11 Token', symbol: 'JONO', decimals: 18 },
        infoURL: '',
        shortName: 'jono11',
        chainId: 20765,
        networkId: 20765,
        explorers: [
            {
                name: 'JONO11 Explorer',
                url: 'https://subnets-test.avax.network/jono11',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreievzx4ke62dtc77o47x7vs7nn67ghzrwku6h5dxo3hwcsqfeblke4'
    },
    20993: {
        name: 'Fluent Developer Preview',
        chain: 'Fluent',
        rpc: ['https://rpc.dev.gblend.xyz'],
        faucets: ['https://faucet.dev.gblend.xyz'],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://fluent.xyz',
        shortName: 'fluent-dev-net',
        chainId: 20993,
        networkId: 20993,
        explorers: [
            {
                name: 'Fluent Blockscout Explorer',
                url: 'https://blockscout.dev.gblend.xyz',
                standard: 'EIP3091'
            }
        ]
    },
    21000: {
        name: 'Action Mainnet',
        chain: 'Action',
        icon: 'action',
        rpc: ['https://rpc.actionblockchain.org'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Action', symbol: 'ACTN', decimals: 18 },
        infoURL: 'https://docs.actioncoin.com',
        shortName: 'ACTN',
        chainId: 21000,
        networkId: 21000,
        explorers: [
            {
                name: 'Action Mainnet Explorer',
                url: 'http://exp.actionblockchain.org',
                icon: 'action',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNkyJNwgHEWYnxq8BPaQ83WxrVVPrdzvQKKY22PRqhRts'
    },
    21004: {
        name: 'C4EI',
        chain: 'C4EI',
        rpc: ['https://rpc.c4ei.net'],
        faucets: ['https://play.google.com/store/apps/details?id=net.c4ei.fps2'],
        nativeCurrency: { name: 'C4EI', symbol: 'C4EI', decimals: 18 },
        infoURL: 'https://c4ei.net',
        shortName: 'c4ei',
        chainId: 21004,
        networkId: 21004,
        explorers: [
            {
                name: 'C4EI sirato',
                url: 'https://exp.c4ei.net',
                icon: 'c4ei',
                standard: 'none'
            }
        ]
    },
    21097: {
        name: 'Rivest Testnet',
        chain: 'Inco',
        rpc: [
            'https://validator.rivest.inco.org',
            'https://gateway.rivest.inco.org'
        ],
        faucets: ['https://faucet.rivest.inco.org'],
        nativeCurrency: { name: 'test-Inco', symbol: 'tINCO', decimals: 18 },
        infoURL: 'https://inco.org',
        shortName: 'rivest-testnet',
        chainId: 21097,
        networkId: 21097,
        slip44: 1,
        icon: 'inco',
        explorers: [
            {
                name: 'Rivest Testnet Explorer',
                url: 'https://explorer.rivest.inco.org',
                standard: 'EIP3091',
                icon: 'inco'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmU9aHw1i3qM8rZekXfb4rFZHPxVvsLdnpohKLGGFYewMg'
    },
    21133: {
        name: 'All About Healthy',
        chain: 'AAH',
        rpc: ['https://rpc.c4ex.net'],
        faucets: ['https://t.me/c4eiAirdrop'],
        nativeCurrency: { name: 'AAH', symbol: 'AAH', decimals: 18 },
        infoURL: 'https://c4ex.net',
        shortName: 'aah',
        chainId: 21133,
        networkId: 21133,
        explorers: [
            {
                name: 'AAH Blockscout',
                url: 'https://exp.c4ex.net',
                icon: 'aah',
                standard: 'EIP3091'
            }
        ]
    },
    21210: {
        name: '1Money Network Mainnet',
        chain: '1Money Network',
        rpc: ['https://mainnet.1money.network'],
        faucets: [],
        nativeCurrency: { name: 'USD1', symbol: 'USD1', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://1money.com',
        shortName: '1money',
        chainId: 21210,
        networkId: 21210,
        explorers: []
    },
    21223: {
        name: 'DCpay Mainnet',
        chain: 'DCpay',
        icon: 'dcpayIcon',
        rpc: ['https://rpc.dcpay.io'],
        faucets: [],
        nativeCurrency: { name: 'DCP', symbol: 'DCP', decimals: 18 },
        infoURL: 'https://dcpay.io',
        shortName: 'DCPm',
        chainId: 21223,
        networkId: 21223,
        explorers: [
            {
                name: 'DCpay Mainnet Explorer',
                url: 'https://mainnet.dcpay.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmezBwVepoegoCqb86idzPgvPxtaSuXzMLBGiiYfyTGTkc'
    },
    21224: {
        name: 'DCpay Testnet',
        chain: 'DCpay',
        icon: 'dcpayIcon',
        rpc: ['https://testnet-rpc.dcpay.io'],
        faucets: ['https://faucet.dcpay.io'],
        nativeCurrency: { name: 'DCP', symbol: 'DCP', decimals: 18 },
        infoURL: 'https://dcpay.io',
        shortName: 'DCPt',
        chainId: 21224,
        networkId: 21224,
        explorers: [
            {
                name: 'DCpay Testnet Explorer',
                url: 'https://testnet.dcpay.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmezBwVepoegoCqb86idzPgvPxtaSuXzMLBGiiYfyTGTkc'
    },
    21337: {
        name: 'CENNZnet Azalea',
        chain: 'CENNZnet',
        rpc: ['https://cennznet.unfrastructure.io/public'],
        faucets: [],
        nativeCurrency: { name: 'CPAY', symbol: 'CPAY', decimals: 18 },
        infoURL: 'https://cennz.net',
        shortName: 'cennz-a',
        chainId: 21337,
        networkId: 21337,
        icon: 'cennz',
        explorers: [
            {
                name: 'UNcover',
                url: 'https://uncoverexplorer.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWhNm7tTi6SYbiumULDRk956hxgqaZSX77vcxBNn8fvnw'
    },
    21363: {
        name: 'Lestnet',
        chain: 'LETH',
        rpc: ['https://service.lestnet.org'],
        faucets: [],
        nativeCurrency: { name: 'Lestnet Ether', symbol: 'LETH', decimals: 18 },
        infoURL: 'https://lestnet.org',
        shortName: 'leth',
        chainId: 21363,
        networkId: 21363,
        icon: 'lestnet',
        explorers: [
            {
                name: 'Lestnet Explorer',
                url: 'https://explore.lestnet.org',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigg4ovuohje6iva42fou7rc7a6fkozvfkg22fhuvhw5oz7vii74ha'
    },
    21816: {
        name: 'omChain Mainnet',
        chain: 'OML',
        icon: 'omlira',
        rpc: ['https://seed.omchain.io'],
        faucets: [],
        nativeCurrency: { name: 'omChain', symbol: 'OMC', decimals: 18 },
        infoURL: 'https://omchain.io',
        shortName: 'omc',
        chainId: 21816,
        networkId: 21816,
        explorers: [
            {
                name: 'omChain Explorer',
                url: 'https://explorer.omchain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQtEHaejiDbmiCvbBYw9jNQv3DLK5XHCQwLRfnLNpdN5j'
    },
    21912: {
        name: 'BSL Mainnet',
        chain: 'BSL',
        rpc: [
            'http://rpc-mainnet.nftruth.io:8545',
            'ws://rpc-mainnet.nftruth.io:8645'
        ],
        faucets: [],
        nativeCurrency: { name: 'Origin NFT', symbol: 'ONF', decimals: 18 },
        infoURL: 'https://bsquarelab.com/',
        shortName: 'onf',
        chainId: 21912,
        networkId: 21912,
        explorers: [
            {
                name: 'BSL Mainnet Explorer',
                url: 'https://scan.nftruth.io',
                standard: 'EIP3091'
            }
        ]
    },
    22023: {
        name: 'Taycan',
        chain: 'Taycan',
        rpc: ['https://taycan-rpc.hupayx.io:8545'],
        faucets: [],
        nativeCurrency: { name: 'shuffle', symbol: 'SFL', decimals: 18 },
        infoURL: 'https://hupayx.io',
        shortName: 'SFL',
        chainId: 22023,
        networkId: 22023,
        icon: 'shuffle',
        explorers: [
            {
                name: 'Taycan Explorer(Blockscout)',
                url: 'https://taycan-evmscan.hupayx.io',
                standard: 'none',
                icon: 'shuffle'
            },
            {
                name: 'Taycan Cosmos Explorer(BigDipper)',
                url: 'https://taycan-cosmoscan.hupayx.io',
                standard: 'none',
                icon: 'shuffle'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidvjcc73v747lqlyrhgbnkvkdepdvepo6baj6hmjsmjtvdyhmzzmq'
    },
    22040: {
        name: 'AirDAO Testnet',
        chain: 'ambnet-test',
        icon: 'airdao',
        rpc: ['https://network.ambrosus-test.io'],
        faucets: [],
        nativeCurrency: { name: 'Amber', symbol: 'AMB', decimals: 18 },
        infoURL: 'https://testnet.airdao.io',
        shortName: 'airdao-test',
        chainId: 22040,
        networkId: 22040,
        slip44: 1,
        explorers: [
            {
                name: 'AirDAO Network Explorer',
                url: 'https://testnet.airdao.io/explorer',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSxXjvWng3Diz4YwXDV2VqSPgMyzLYBNfkjJcr7rzkxom'
    },
    22222: {
        name: 'Nautilus Mainnet',
        chain: 'ETH',
        icon: 'nautilus',
        rpc: ['https://api.nautilus.nautchain.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Zebec', symbol: 'ZBC', decimals: 18 },
        infoURL: 'https://docs.nautchain.xyz',
        shortName: 'NAUTCHAIN',
        chainId: 22222,
        networkId: 22222,
        explorers: [
            {
                name: 'Nautscan',
                url: 'https://nautscan.com',
                standard: 'EIP3091',
                icon: 'nautilus'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNutSgM7n6aJPPDiofe9Dm1epy1RcYTMvugukLUK2vmPM'
    },
    22324: {
        name: 'GoldXChain Testnet',
        chain: 'GoldXTestnet',
        rpc: ['https://testnet-rpc.goldxchain.io'],
        faucets: ['https://faucet.goldxchain.io'],
        nativeCurrency: { name: 'GoldX', symbol: 'GOLDX', decimals: 18 },
        infoURL: 'https://goldxchain.io',
        shortName: 'goldx-testnet',
        chainId: 22324,
        networkId: 22324,
        explorers: [
            {
                name: 'GoldXChain Testnet Explorer',
                url: 'https://testnet-explorer.goldxchain.io',
                standard: 'EIP3091'
            }
        ]
    },
    22776: {
        name: 'MAP Protocol',
        chain: 'MAPO',
        icon: 'map',
        rpc: ['https://rpc.maplabs.io'],
        faucets: [],
        nativeCurrency: { name: 'MAPO', symbol: 'MAPO', decimals: 18 },
        infoURL: 'https://mapprotocol.io/',
        shortName: 'mapo',
        chainId: 22776,
        networkId: 22776,
        slip44: 60,
        explorers: [
            {
                name: 'maposcan',
                url: 'https://maposcan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcLdQ8gM4iHv3CCKA9HuxmzTxY4WhjWtepUVCc3dpzKxD'
    },
    23006: {
        name: 'Antofy Testnet',
        chain: 'ABN',
        icon: 'antofy',
        rpc: ['https://testnet-rpc.antofy.io'],
        faucets: ['https://faucet.antofy.io'],
        nativeCurrency: { name: 'Antofy', symbol: 'ABN', decimals: 18 },
        infoURL: 'https://antofy.io',
        shortName: 'ABNt',
        chainId: 23006,
        networkId: 23006,
        slip44: 1,
        explorers: [
            {
                name: 'Antofy Testnet',
                url: 'https://test.antofyscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdTfku81ohnG9ECU1Xswmeumt678cBhwHWuFYZ7i1Qsto'
    },
    23023: {
        name: 'PremiumBlock',
        chain: 'PBLK',
        rpc: ['https://rpc.premiumblock.org'],
        faucets: [],
        nativeCurrency: { name: 'Premium Block', symbol: 'PBLK', decimals: 18 },
        infoURL: 'https://scan.premiumblock.org',
        shortName: 'pblk',
        chainId: 23023,
        networkId: 23023,
        explorers: [
            {
                name: 'PremiumBlocks Explorer',
                url: 'https://scan.premiumblock.org',
                standard: 'EIP3091'
            }
        ],
        features: [{ name: 'EIP1559' }]
    },
    23118: {
        name: 'Opside Testnet',
        chain: 'Opside',
        rpc: ['https://testrpc.opside.network'],
        faucets: ['https://faucet.opside.network'],
        nativeCurrency: { name: 'IDE', symbol: 'IDE', decimals: 18 },
        infoURL: 'https://opside.network',
        shortName: 'opside',
        chainId: 23118,
        networkId: 23118,
        slip44: 1,
        icon: 'opside',
        explorers: [
            {
                name: 'opsideInfo',
                url: 'https://opside.info',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeCyZeibUoHNoYGzy1GkzH2uhxyRHKvH51PdaUMer4VTo'
    },
    23294: {
        name: 'Oasis Sapphire',
        chain: 'Sapphire',
        icon: 'oasis',
        rpc: ['https://sapphire.oasis.io', 'wss://sapphire.oasis.io/ws'],
        faucets: [],
        nativeCurrency: { name: 'Sapphire Rose', symbol: 'ROSE', decimals: 18 },
        infoURL: 'https://docs.oasis.io/dapp/sapphire',
        shortName: 'sapphire',
        chainId: 23294,
        networkId: 23294,
        explorers: [
            {
                name: 'Oasis Sapphire Explorer',
                url: 'https://explorer.oasis.io/mainnet/sapphire',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiespupb52akiwrexxg7g72mh7m7h7lum5hmqijmpdh3kmuunzclha'
    },
    23295: {
        name: 'Oasis Sapphire Testnet',
        chain: 'Sapphire',
        icon: 'oasis',
        rpc: [
            'https://testnet.sapphire.oasis.io',
            'wss://testnet.sapphire.oasis.io/ws'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'Sapphire Test Rose',
            symbol: 'TEST',
            decimals: 18
        },
        infoURL: 'https://docs.oasis.io/dapp/sapphire',
        shortName: 'sapphire-testnet',
        chainId: 23295,
        networkId: 23295,
        slip44: 1,
        explorers: [
            {
                name: 'Oasis Sapphire Testnet Explorer',
                url: 'https://explorer.oasis.io/testnet/sapphire',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiespupb52akiwrexxg7g72mh7m7h7lum5hmqijmpdh3kmuunzclha'
    },
    23451: {
        name: 'DreyerX Mainnet',
        chain: 'DreyerX',
        rpc: ['https://rpc.dreyerx.com'],
        faucets: [],
        nativeCurrency: { name: 'DreyerX', symbol: 'DRX', decimals: 18 },
        infoURL: 'https://dreyerx.com',
        shortName: 'dreyerx',
        chainId: 23451,
        networkId: 23451,
        icon: 'dreyerx',
        explorers: [
            {
                name: 'drxscan',
                url: 'https://scan.dreyerx.com',
                icon: 'dreyerx',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTGjVbiSdHYhjzpeqzY6fGwGiLQuEa2hW7irD75sUSx9e'
    },
    23452: {
        name: 'DreyerX Testnet',
        chain: 'DreyerX',
        rpc: ['https://testnet-rpc.dreyerx.com'],
        faucets: [],
        nativeCurrency: { name: 'DreyerX', symbol: 'DRX', decimals: 18 },
        infoURL: 'https://dreyerx.com',
        shortName: 'dreyerx-testnet',
        chainId: 23452,
        networkId: 23452,
        icon: 'dreyerx',
        explorers: [
            {
                name: 'drxscan',
                url: 'https://testnet-scan.dreyerx.com',
                icon: 'dreyerx',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTGjVbiSdHYhjzpeqzY6fGwGiLQuEa2hW7irD75sUSx9e'
    },
    23888: {
        name: 'Blast Testnet',
        chain: 'ETH',
        icon: 'blastIcon',
        rpc: ['http://testnet-rpc.blastblockchain.com'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://docs.blastblockchain.com',
        shortName: 'blastT',
        chainId: 23888,
        networkId: 23888,
        explorers: [
            {
                name: 'Blast Testnet',
                url: 'http://testnet-explorer.blastblockchain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdHpjiepU2Q4bt4kR48tKHPgaQW57Sb6UVFgLh4MCyg6U'
    },
    24076: {
        name: 'KYMTC Testnet',
        chain: 'KYMTC',
        icon: 'kymtc',
        rpc: ['https://testnet-rpc.kymaticscan.online'],
        faucets: ['https://faucet.kymaticscan.online'],
        nativeCurrency: { name: 'KYMTC', symbol: 'KYMTC', decimals: 18 },
        infoURL: 'https://testnet-explorer.kymaticscan.online',
        shortName: 'tKYMTC',
        chainId: 24076,
        networkId: 24076,
        explorers: [
            {
                name: 'KYMTC Testnet Explorer',
                url: 'https://testnet-explorer.kymaticscan.online',
                icon: 'kymtc',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmR1AnNYGeXpVmsKyzqktk4K1BtFPiaJpeXuLktb9Kwmer'
    },
    24116: {
        name: 'Amauti',
        title: 'Rails Network Testnet Amauti',
        chain: 'RAILS',
        icon: 'railsTestnet',
        rpc: ['https://testnet.steamexchange.io'],
        faucets: ['https://depot.steamexchange.io/faucet'],
        nativeCurrency: { name: 'SteamX', symbol: 'STEAMX', decimals: 18 },
        infoURL: 'https://steamexchange.io',
        shortName: 'railst',
        chainId: 24116,
        networkId: 24116,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://build.steamexchange.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWsvNvJgnZkiZ1y1VDPfUkSbaWrJVhEMXx7U9vEZx2HZA'
    },
    24125: {
        name: 'Nexurachain',
        chain: 'nexurachain',
        icon: 'xuraIcon',
        rpc: ['https://rpc.nexurachain.io'],
        faucets: [],
        nativeCurrency: { name: 'XURA', symbol: 'XURA', decimals: 18 },
        infoURL: 'https://nexurachain.io',
        shortName: 'XURAm',
        chainId: 24125,
        networkId: 24125,
        explorers: [
            {
                name: 'Nexurachain Explorer',
                url: 'https://explorer.nexurachain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcXFJnDV38rKUmgvM2owwrTRnxWKvEyvmp1QGFKPJ8PJj'
    },
    24484: {
        name: 'Webchain',
        chain: 'WEB',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Webchain Ether', symbol: 'WEB', decimals: 18 },
        infoURL: 'https://webchain.network',
        shortName: 'web',
        chainId: 24484,
        networkId: 37129,
        slip44: 227
    },
    24734: {
        name: 'MintMe.com Coin',
        chain: 'MINTME',
        rpc: ['https://node1.mintme.com'],
        faucets: [],
        nativeCurrency: { name: 'MintMe.com Coin', symbol: 'MINTME', decimals: 18 },
        infoURL: 'https://www.mintme.com',
        shortName: 'mintme',
        chainId: 24734,
        networkId: 37480
    },
    24816: {
        name: 'Recall',
        chain: 'Recall',
        rpc: ['https://evm.node-0.mainnet.recall.network'],
        faucets: [],
        nativeCurrency: { name: 'Recall', symbol: 'RECALL', decimals: 18 },
        infoURL: 'https://recall.network',
        shortName: 'recall',
        chainId: 24816,
        networkId: 24816,
        explorers: []
    },
    25186: {
        name: 'LiquidLayer Mainnet',
        chain: 'LiquidLayer',
        icon: 'lila',
        rpc: ['https://mainnet.liquidlayer.network'],
        faucets: [],
        nativeCurrency: { name: 'LiquidLayer', symbol: 'LILA', decimals: 18 },
        infoURL: 'https://scan.liquidlayer.network',
        shortName: 'LILA',
        chainId: 25186,
        networkId: 25186,
        explorers: [
            {
                name: 'LiquidLayer Mainnet Explorer',
                url: 'https://scan.liquidlayer.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiayuuzfpcgwjll4us4hquvpqa5gwq3lbiedv4qftmlwcxhcyjzzpq'
    },
    25327: {
        name: 'Everclear Mainnet',
        chain: 'Everclear Mainnet',
        rpc: ['https://rpc.everclear.raas.gelato.cloud'],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        faucets: [],
        infoURL: '',
        shortName: 'Everclear',
        chainId: 25327,
        networkId: 25327,
        explorers: [
            {
                name: 'Everclear',
                url: 'https://scan.everclear.org',
                icon: 'everclear',
                standard: 'none'
            }
        ]
    },
    25839: {
        name: 'AlveyChain Testnet',
        chain: 'tALV',
        rpc: ['https://testnet-rpc.alvey.io'],
        faucets: ['https://faucet.alveytestnet.com'],
        nativeCurrency: { name: 'AlveyCoin Testnet', symbol: 'tALV', decimals: 18 },
        infoURL: 'https://alveychain.com/',
        shortName: 'talv',
        chainId: 25839,
        networkId: 25839,
        explorers: [
            {
                name: 'AlveyScan Testnet',
                url: 'https://alveytestnet.com',
                standard: 'EIP3091'
            }
        ]
    },
    25888: {
        name: 'Hammer Chain Mainnet',
        chain: 'HammerChain',
        rpc: ['https://www.hammerchain.io/rpc'],
        faucets: [],
        nativeCurrency: { name: 'GOLDT', symbol: 'GOLDT', decimals: 18 },
        infoURL: 'https://www.hammerchain.io',
        shortName: 'GOLDT',
        chainId: 25888,
        networkId: 25888,
        explorers: [
            {
                name: 'Hammer Chain Explorer',
                url: 'https://www.hammerchain.io',
                standard: 'none'
            }
        ]
    },
    25925: {
        name: 'KUB Testnet',
        chain: 'KUB',
        rpc: [
            'https://rpc-testnet.bitkubchain.io',
            'wss://wss-testnet.bitkubchain.io'
        ],
        faucets: ['https://faucet.kubchain.com'],
        nativeCurrency: { name: 'KUB Coin', symbol: 'tKUB', decimals: 18 },
        infoURL: 'https://www.kubchain.com/',
        shortName: 'kubt',
        chainId: 25925,
        networkId: 25925,
        icon: 'kub',
        slip44: 1,
        explorers: [
            {
                name: 'KUB Testnet Explorer',
                url: 'https://testnet.kubscan.com',
                standard: 'none',
                icon: 'kub'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigwng335wvow35ypah7hpq3m3xga3idods2wqs3cfcncoyzu7vxli'
    },
    26026: {
        name: 'Ferrum Testnet',
        chain: 'tFRM',
        rpc: ['http://testnet.dev.svcs.ferrumnetwork.io:9933'],
        faucets: ['https://testnet.faucet.ferrumnetwork.io'],
        nativeCurrency: { name: 'Ferrum', symbol: 'tFRM', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://ferrum.network',
        shortName: 'frm',
        chainId: 26026,
        networkId: 26026,
        slip44: 1,
        explorers: [
            {
                name: 'polkadotjs',
                url: 'https://polkadot.js.org/apps/?rpc=wss%3A%2F%2Ftestnet.dev.svcs.ferrumnetwork.io#/explorer',
                standard: 'none'
            }
        ]
    },
    26100: {
        name: 'Ferrum Quantum Portal Network',
        chain: 'QPN',
        icon: 'ferrum',
        rpc: ['https://qpn.svcs.ferrumnetwork.io'],
        faucets: [],
        nativeCurrency: { name: 'Ferrum', symbol: 'qpFRM', decimals: 18 },
        infoURL: 'https://ferrum.network',
        shortName: 'qpn',
        chainId: 26100,
        networkId: 26100,
        explorers: [
            {
                name: 'ferrumscout',
                url: 'https://explorer.ferrumnetwork.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme5iDsQTDfLbyXS6iUEmvL4pWTPEiXc5kqFs7jjthqCWP'
    },
    26482: {
        name: 'DucatusX Testnet',
        chain: 'DUCX',
        rpc: [
            'https://ducx-testnet-node1.rocknblock.io',
            'https://ducx-testnet-node2.rocknblock.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'DUCX', symbol: 'DUCX', decimals: 18 },
        infoURL: 'https://www.ducatuscoins.com/ducatusx',
        shortName: 'ducatusx-testnet',
        chainId: 26482,
        networkId: 26482,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer-testnet.ducatusx.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    26483: {
        name: 'DucatusX',
        chain: 'DUCX',
        rpc: [
            'https://ducx-mainnet-node1.rocknblock.io',
            'https://ducx-mainnet-node2.rocknblock.io',
            'https://ducx-mainnet-node3.rocknblock.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'DUCX', symbol: 'DUCX', decimals: 18 },
        infoURL: 'https://www.ducatuscoins.com/ducatusx',
        shortName: 'ducatusx',
        chainId: 26483,
        networkId: 26483,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.ducatusx.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    26600: {
        name: 'Hertz Network Mainnet',
        chain: 'HTZ',
        rpc: ['https://mainnet-rpc.hertzscan.com'],
        faucets: [],
        nativeCurrency: { name: 'Hertz', symbol: 'HTZ', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.hertz-network.com',
        shortName: 'HTZ',
        chainId: 26600,
        networkId: 26600,
        icon: 'hertz-network',
        explorers: [
            {
                name: 'Hertz Scan',
                url: 'https://hertzscan.com',
                icon: 'hertz-network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmf3GYbPXmTDpSP6t7Ug2j5HjEwrY5oGhBDP7d4TQHvGnG'
    },
    26863: {
        name: 'OasisChain Mainnet',
        chain: 'OasisChain',
        rpc: [
            'https://rpc1.oasischain.io',
            'https://rpc2.oasischain.io',
            'https://rpc3.oasischain.io'
        ],
        faucets: ['http://faucet.oasischain.io'],
        nativeCurrency: { name: 'OAC', symbol: 'OAC', decimals: 18 },
        infoURL: 'https://scan.oasischain.io',
        shortName: 'OAC',
        chainId: 26863,
        networkId: 26863,
        explorers: [
            {
                name: 'OasisChain Explorer',
                url: 'https://scan.oasischain.io',
                standard: 'EIP3091'
            }
        ]
    },
    26888: {
        name: 'AB Core Testnet',
        chain: 'ETH',
        rpc: ['https://rpc.core.testnet.ab.org'],
        faucets: [],
        nativeCurrency: { name: 'AB', symbol: 'AB', decimals: 18 },
        infoURL: 'https://ab.org',
        shortName: 'tABCore',
        chainId: 26888,
        networkId: 26888,
        explorers: [
            {
                name: 'AB Core explorer',
                url: 'https://explorer.core.testnet.ab.org',
                standard: 'EIP3091'
            }
        ]
    },
    26988: {
        name: 'Newton Finance Testnet',
        chain: 'ETH',
        rpc: ['https://jp-rpc-testnet-newfi.newpay.io'],
        faucets: [],
        nativeCurrency: { name: 'Newton', symbol: 'NEW', decimals: 18 },
        infoURL: 'https://newtonproject.org',
        shortName: 'tNewFi',
        chainId: 26988,
        networkId: 26988,
        explorers: [
            {
                name: 'NewFi explorer',
                url: 'https://explorer-testnet-newfi.newpay.io',
                standard: 'EIP3091'
            }
        ]
    },
    27125: {
        name: 'XferChain Testnet',
        chain: 'XferChain Testnet',
        icon: 'xferIcon',
        rpc: ['https://testnet-rpc.xferchain.org'],
        faucets: ['https://faucet.xferchain.org'],
        nativeCurrency: { name: 'Dapo', symbol: 'Dapo', decimals: 18 },
        infoURL: 'https://xferchain.org',
        shortName: 'DPt',
        chainId: 27125,
        networkId: 27125,
        explorers: [
            {
                name: 'XferChain Testnet Explorer',
                url: 'https://testnet.xferchain.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmchcfbq1dansGarbpbsgiiYa64HbGYtphe493JASKawxD'
    },
    27181: {
        name: 'KLAOS Nova',
        title: 'KLAOS Nova Test Chain',
        chain: 'KLAOS Nova',
        icon: 'k-laos',
        rpc: [
            'https://rpc.klaosnova.laosfoundation.io',
            'wss://rpc.klaosnova.laosfoundation.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'KLAOS', symbol: 'KLAOS', decimals: 18 },
        infoURL: 'https://www.laosfoundation.io/',
        shortName: 'klaosnova',
        chainId: 27181,
        networkId: 27181,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.klaosnova.laosfoundation.io',
                icon: 'k-laos',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW26eoxJeyUfikZ4DUT1Gfk78sBkvydEo8QzHa1BXjUUL'
    },
    27483: {
        name: 'Nanon Sepolia',
        title: 'Nanon Sepolia Rollup Testnet',
        chain: 'ETH',
        rpc: ['https://sepolia-rpc.nanon.network'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.nanon.network',
        shortName: 'Nanon-Testnet',
        chainId: 27483,
        networkId: 27483,
        slip44: 1,
        icon: 'nanon',
        explorers: [
            {
                name: 'Nanon Sepolia Rollup Testnet Explorer',
                url: 'https://sepolia-explorer.nanon.network',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://sepolia-bridge.nanon.network' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafybeiduib2fygrwziqpy4yuqr6vvnd6elhahpigbcowcipjjhk6c3qiny'
    },
    27827: {
        name: 'zeroone Mainnet Subnet',
        chain: 'ZEROONEMAI',
        rpc: ['https://subnets.avax.network/zeroonemai/mainnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'ZERO', symbol: 'ZERO', decimals: 18 },
        infoURL: 'https://zeroone.art/',
        shortName: 'zeroonemai',
        chainId: 27827,
        networkId: 27827,
        explorers: [
            {
                name: 'ZEROONEMAI Explorer',
                url: 'https://subnets.avax.network/zeroonemai',
                standard: 'EIP3091'
            }
        ]
    },
    28125: {
        name: 'XferChain Mainnet',
        chain: 'XferChain Mainnet',
        icon: 'xferIcon',
        rpc: ['https://rpc.xferchain.org'],
        faucets: [],
        nativeCurrency: { name: 'Dapo', symbol: 'Dapo', decimals: 18 },
        infoURL: 'https://xferchain.org',
        shortName: 'DPm',
        chainId: 28125,
        networkId: 28125,
        explorers: [
            {
                name: 'XferChain Mainnet Explorer',
                url: 'https://network.xferchain.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmchcfbq1dansGarbpbsgiiYa64HbGYtphe493JASKawxD'
    },
    28516: {
        name: 'Vizing Testnet',
        title: 'Vizing Testnet',
        chain: 'Vizing Testnet',
        rpc: ['https://rpc-sepolia.vizing.com'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://vizing.com',
        shortName: 'Vizing-Testnet',
        chainId: 28516,
        networkId: 28516,
        icon: 'vizing',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer-sepolia.vizing.com',
                icon: 'vizing',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPgpWfGsAZ5UHekWFR8rioadVe3Wox8idFyeVxuv9N4Vo'
    },
    28518: {
        name: 'Vizing Mainnet',
        title: 'Vizing Mainnet',
        chain: 'Vizing Mainnet',
        rpc: ['https://rpc.vizing.com'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://vizing.com',
        shortName: 'Vizing',
        chainId: 28518,
        networkId: 28518,
        icon: 'vizing',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.vizing.com',
                icon: 'vizing',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.vizing.com' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmPgpWfGsAZ5UHekWFR8rioadVe3Wox8idFyeVxuv9N4Vo'
    },
    28528: {
        name: 'Optimism Bedrock (Goerli Alpha Testnet)',
        chain: 'ETH',
        rpc: [
            'https://alpha-1-replica-0.bedrock-goerli.optimism.io',
            'https://alpha-1-replica-1.bedrock-goerli.optimism.io',
            'https://alpha-1-replica-2.bedrock-goerli.optimism.io',
            'https://alpha-1-replica-2.bedrock-goerli.optimism.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'Goerli Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://community.optimism.io/docs/developers/bedrock',
        shortName: 'obgor',
        chainId: 28528,
        networkId: 28528,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.com/optimism/bedrock-alpha',
                standard: 'EIP3091'
            }
        ]
    },
    28882: {
        name: 'Boba Sepolia',
        chain: 'ETH',
        rpc: [
            'https://sepolia.boba.network',
            'https://boba-sepolia.gateway.tenderly.co',
            'https://gateway.tenderly.co/public/boba-sepolia',
            'wss://boba-sepolia.gateway.tenderly.co/',
            'wss://gateway.tenderly.co/public/boba-sepolia'
        ],
        faucets: ['https://www.l2faucet.com/boba'],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://boba.network',
        shortName: 'BobaSepolia',
        chainId: 28882,
        networkId: 28882,
        explorers: [
            {
                name: 'Routescan',
                url: 'https://testnet.bobascan.com',
                standard: 'none'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111', bridges: [] }
    },
    29112: {
        name: 'HYCHAIN Testnet',
        chainId: 29112,
        shortName: 'hychain-testnet',
        chain: 'ETH',
        networkId: 29112,
        nativeCurrency: { name: 'TOPIA', symbol: 'TOPIA', decimals: 18 },
        rpc: ['https://testnet-rpc.hychain.com/http'],
        faucets: [],
        infoURL: 'https://www.hychain.com',
        icon: 'hychain',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet.explorer.hychain.com',
                icon: 'hychain',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-58008', bridges: [] },
        iconURL: 'https://ipfs.io/ipfs/QmcSJmAfk3iay6uCGJxgUPd9pTsRxbtF4BrNnC5txE9cg8'
    },
    29223: {
        name: 'Nexa MetaNet',
        chain: 'NEXA',
        rpc: ['https://nexa.sh/metanet'],
        faucets: [],
        nativeCurrency: { name: 'Nexa', symbol: 'NEXA', decimals: 18 },
        infoURL: 'https://nexa.sh/meta',
        shortName: 'nexameta',
        chainId: 29223,
        networkId: 29223,
        slip44: 29223,
        icon: 'nexameta',
        explorers: [
            {
                name: 'NexaShell',
                url: 'https://nexa.sh',
                standard: 'none',
                icon: 'nexashell'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreia42ym3rgzo7w5k445nr4wmji4ucxgw4pdhdo5lacczkk2fiahwni'
    },
    29225: {
        name: 'Nexa MetaTest',
        chain: 'NEXA',
        rpc: ['https://nexa.sh/metatest'],
        faucets: [],
        nativeCurrency: { name: 'Nexa', symbol: 'NEXA', decimals: 18 },
        infoURL: 'https://nexa.sh/meta',
        shortName: 'nexatest',
        chainId: 29225,
        networkId: 29225,
        slip44: 29225,
        icon: 'nexameta',
        explorers: [
            {
                name: 'NexaShell',
                url: 'https://nexa.sh',
                standard: 'none',
                icon: 'nexashell'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreia42ym3rgzo7w5k445nr4wmji4ucxgw4pdhdo5lacczkk2fiahwni'
    },
    29536: {
        name: 'KaiChain Testnet',
        chain: 'KaiChain',
        rpc: ['https://testnet-rpc.kaichain.net'],
        faucets: ['https://faucet.kaichain.net'],
        nativeCurrency: {
            name: 'KaiChain Testnet Native Token',
            symbol: 'KEC',
            decimals: 18
        },
        infoURL: 'https://kaichain.net',
        shortName: 'tkec',
        chainId: 29536,
        networkId: 29536,
        explorers: [
            {
                name: 'KaiChain Explorer',
                url: 'https://testnet-explorer.kaichain.net',
                standard: 'EIP3091'
            }
        ]
    },
    29548: {
        name: 'MCH Verse Mainnet',
        chain: 'MCH Verse',
        icon: 'mch_verse',
        rpc: ['https://rpc.oasys.mycryptoheroes.net'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://www.mycryptoheroes.net/verse',
        shortName: 'MCHV',
        chainId: 29548,
        networkId: 29548,
        explorers: [
            {
                name: 'MCH Verse Explorer',
                url: 'https://explorer.oasys.mycryptoheroes.net',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-248' },
        iconURL: 'https://ipfs.io/ipfs/QmZZnwR1y6cU1sare2TQmwqkNDLXQxD4GdPrmHLmUoPtbU'
    },
    30000: {
        name: 'qChain Mainnet',
        chain: 'qChain',
        rpc: ['https://rpc.qchain.kr'],
        faucets: [],
        features: [{ name: 'EIP155' }],
        nativeCurrency: { name: 'QCO', symbol: 'QCO', decimals: 18 },
        infoURL: 'https://www.qchain.kr',
        shortName: 'qchain',
        chainId: 30000,
        networkId: 30000,
        icon: 'qchain',
        explorers: [
            {
                name: 'qChain explorer',
                url: 'https://scan.qchain.kr',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZESsg3P8cimYjibkD8w1T8DgszAHcKn7UReC8FWbfDGz'
    },
    30067: {
        name: 'Piece testnet',
        chain: 'PieceNetwork',
        icon: 'piecechain',
        rpc: ['https://testnet-rpc0.piecenetwork.com'],
        faucets: ['https://piecenetwork.com/faucet'],
        nativeCurrency: { name: 'ECE', symbol: 'ECE', decimals: 18 },
        infoURL: 'https://piecenetwork.com',
        shortName: 'Piece',
        chainId: 30067,
        networkId: 30067,
        slip44: 1,
        explorers: [
            {
                name: 'Piece Scan',
                url: 'https://testnet-scan.piecenetwork.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWAU39z1kcYshAqkENRH8qUjfR5CJehCxA4GiC33p3HpH'
    },
    30088: {
        name: 'MiYou Mainnet',
        chain: 'MiYou Chain',
        icon: 'miyou',
        faucets: [],
        rpc: ['https://blockchain.miyou.io', 'https://blockchain.miyoulab.com'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'Miyou', symbol: 'MY', decimals: 18 },
        infoURL: 'https://www.miyou.io',
        shortName: 'MiYou',
        chainId: 30088,
        networkId: 30088,
        slip44: 60,
        ens: { registry: '0xFEfa9B3061435977424DD947E756566cFB60473E' },
        explorers: [
            {
                name: 'MiYou block explorer',
                url: 'https://myscan.miyou.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfP1QDK42B7EzYWsYN2PGfjkZUQtSjm1k5gNNT52ixsKL'
    },
    30103: {
        name: 'Cerium Testnet',
        chain: 'CAU',
        icon: 'canxium',
        rpc: ['https://cerium-rpc.canxium.net'],
        faucets: [],
        nativeCurrency: { name: 'Canxium', symbol: 'CAU', decimals: 18 },
        infoURL: 'https://canxium.org',
        shortName: 'ceri',
        chainId: 30103,
        networkId: 30103,
        slip44: 1,
        explorers: [
            {
                name: 'canxium explorer',
                url: 'https://cerium-explorer.canxium.net',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXHSbtVNCJVfe2CvRH7njdyf2SrX5u5bNTfvhqjLeFN2A'
    },
    30730: {
        name: 'Movement EVM Legacy',
        chain: 'MOVE',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Move', symbol: 'MOVE', decimals: 18 },
        infoURL: 'https://movementlabs.xyz',
        shortName: 'moveleg',
        chainId: 30730,
        networkId: 30730,
        icon: 'move',
        explorers: [
            {
                name: 'mevm explorer',
                url: 'https://explorer.movementlabs.xyz',
                standard: 'none'
            }
        ],
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWRAor77N6VyjJiQgtsEE7h9Bd1Q7vtRveTYv2A6wZyAT'
    },
    30731: {
        name: 'Movement EVM Devnet',
        chain: 'MOVE',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Move', symbol: 'MOVE', decimals: 18 },
        infoURL: 'https://movementlabs.xyz',
        shortName: 'movedev',
        chainId: 30731,
        networkId: 30731,
        icon: 'move',
        explorers: [
            {
                name: 'mevm explorer',
                url: 'https://explorer.movementlabs.xyz',
                standard: 'none'
            }
        ],
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWRAor77N6VyjJiQgtsEE7h9Bd1Q7vtRveTYv2A6wZyAT'
    },
    30732: {
        name: 'Movement EVM Testnet',
        chain: 'MOVE',
        rpc: ['https://mevm.testnet.imola.movementlabs.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Move', symbol: 'MOVE', decimals: 18 },
        infoURL: 'https://movementlabs.xyz',
        shortName: 'movetest',
        chainId: 30732,
        networkId: 30732,
        icon: 'move',
        explorers: [
            {
                name: 'mevm explorer',
                url: 'https://explorer.testnet.imola.movementlabs.xyz',
                standard: 'none'
            }
        ],
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWRAor77N6VyjJiQgtsEE7h9Bd1Q7vtRveTYv2A6wZyAT'
    },
    31102: {
        name: 'Ethersocial Network',
        chain: 'ESN',
        rpc: ['https://api.esn.gonspool.com'],
        faucets: [],
        nativeCurrency: {
            name: 'Ethersocial Network Ether',
            symbol: 'ESN',
            decimals: 18
        },
        infoURL: 'https://ethersocial.org',
        shortName: 'esn',
        chainId: 31102,
        networkId: 1,
        slip44: 31102
    },
    31223: {
        name: 'CloudTx Mainnet',
        chain: 'CLD',
        icon: 'cloudtx',
        rpc: ['https://mainnet-rpc.cloudtx.finance'],
        faucets: [],
        nativeCurrency: { name: 'CloudTx', symbol: 'CLD', decimals: 18 },
        infoURL: 'https://cloudtx.finance',
        shortName: 'CLDTX',
        chainId: 31223,
        networkId: 31223,
        explorers: [
            {
                name: 'cloudtxscan',
                url: 'https://scan.cloudtx.finance',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSEsi71AdA5HYH6VNC5QUQezFg1C7BiVQJdx1VVfGz3g3'
    },
    31224: {
        name: 'CloudTx Testnet',
        chain: 'CloudTx',
        icon: 'cloudtx',
        rpc: ['https://testnet-rpc.cloudtx.finance'],
        faucets: ['https://faucet.cloudtx.finance'],
        nativeCurrency: { name: 'CloudTx', symbol: 'CLD', decimals: 18 },
        infoURL: 'https://cloudtx.finance/',
        shortName: 'CLD',
        chainId: 31224,
        networkId: 31224,
        slip44: 1,
        explorers: [
            {
                name: 'cloudtxexplorer',
                url: 'https://explorer.cloudtx.finance',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSEsi71AdA5HYH6VNC5QUQezFg1C7BiVQJdx1VVfGz3g3'
    },
    31337: {
        name: 'GoChain Testnet',
        chain: 'GO',
        rpc: ['https://testnet-rpc.gochain.io'],
        faucets: [],
        nativeCurrency: { name: 'GoChain Coin', symbol: 'GO', decimals: 18 },
        infoURL: 'https://gochain.io',
        shortName: 'got',
        chainId: 31337,
        networkId: 31337,
        slip44: 1,
        explorers: [
            {
                name: 'GoChain Testnet Explorer',
                url: 'https://testnet-explorer.gochain.io',
                standard: 'EIP3091'
            }
        ]
    },
    31414: {
        name: 'Evoke Testnet',
        chain: 'Evoke',
        icon: 'mthn',
        rpc: ['https://testnet-rpc.evokescan.org'],
        faucets: ['https://faucet.evokescan.org'],
        nativeCurrency: { name: 'MTHN Testnet', symbol: 'MTHN', decimals: 18 },
        infoURL: 'https://testnet-explorer.evokescan.org',
        shortName: 'tmthn',
        chainId: 31414,
        networkId: 31414,
        explorers: [
            {
                name: 'Evoke SmartChain Testnet Explorer',
                url: 'https://testnet-explorer.evokescan.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreia5q26knsvxgkwxze7woepvsqat5n2hodokh4ozzphmhexqez5s34'
    },
    31415: {
        name: 'Wirex Pay Mainnet',
        chain: 'WirexPay',
        icon: 'wpay',
        rpc: ['https://rpc.wirexpaychain.com'],
        faucets: [],
        nativeCurrency: { name: 'Ethereum', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://docs.wirexpaychain.com/tech/wirex-pay-chain',
        shortName: 'wpay',
        chainId: 31415,
        networkId: 31415,
        explorers: [
            {
                name: 'Wirex Pay Explorer',
                url: 'https://blockscout.wirexpaychain.com',
                standard: 'EIP3091'
            }
        ],
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/QmRkaZbopr8JTgypSQ3N3VfQumnZEN9bA5Uh3u3mL26dwT'
    },
    31611: {
        name: 'Mezo Testnet',
        chain: 'Mezo Testnet',
        rpc: ['https://rpc.test.mezo.org'],
        faucets: [],
        nativeCurrency: { name: 'Bitcoin', symbol: 'BTC', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://mezo.org/',
        shortName: 'mezo-testnet',
        chainId: 31611,
        networkId: 31611,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.test.mezo.org',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    31612: {
        name: 'Mezo',
        chain: 'Mezo',
        rpc: [
            'https://rpc_evm-mezo.imperator.co',
            'wss://ws_evm-mezo.imperator.co',
            'https://jsonrpc-mezo.boar.network',
            'wss://jsonrpcws-mezo.boar.network',
            'https://mainnet.mezo.public.validationcloud.io',
            'wss://mainnet.mezo.public.validationcloud.io',
            'https://rpc-internal.mezo.org',
            'wss://rpc-ws-internal.mezo.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Bitcoin', symbol: 'BTC', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://mezo.org/',
        shortName: 'mezo',
        chainId: 31612,
        networkId: 31612,
        icon: 'mezo',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.mezo.org',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRwp2AtjoRDWpvQvnZpLXT6aw2S76j5y8gRNXevJY3WEo'
    },
    31753: {
        name: 'Xchain Mainnet (Deprecated)',
        chain: 'XchainDeprecated',
        icon: 'intd',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Intdestcoin', symbol: 'INTD', decimals: 18 },
        infoURL: 'https://chainlist.org/chain/31753',
        shortName: 'INTD_deprecated',
        chainId: 31753,
        networkId: 31753,
        status: 'deprecated',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/bafybeia5n537fj2mkfcwmjfwktkmqrcwef3affdodhxnvmkg2gkvmbv2ke'
    },
    31754: {
        name: 'Xchain Testnet (Deprecated)',
        chain: 'XchainDeprecated',
        icon: 'intd',
        rpc: [],
        faucets: [],
        nativeCurrency: {
            name: 'Intdestcoin Testnet',
            symbol: 'INTD',
            decimals: 18
        },
        infoURL: 'https://chainlist.org/chain/31754',
        shortName: 'tINTD_deprecated',
        chainId: 31754,
        networkId: 31754,
        status: 'deprecated',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/bafybeia5n537fj2mkfcwmjfwktkmqrcwef3affdodhxnvmkg2gkvmbv2ke'
    },
    32001: {
        name: 'W3Gamez Holesky Testnet',
        chain: 'ETH',
        rpc: ['https://rpc-holesky.w3gamez.network'],
        faucets: [],
        nativeCurrency: {
            name: 'W3Gamez Testnet Ether',
            symbol: 'ETH',
            decimals: 18
        },
        infoURL: 'https://web3games.com/',
        shortName: 'w3gamez',
        chainId: 32001,
        networkId: 32001,
        slip44: 1,
        icon: 'w3gamez',
        explorers: [
            {
                name: 'W3Gamez Holesky Explorer',
                url: 'https://w3gamez-holesky.web3games.com',
                icon: 'web3games',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaQdiE7vwxKeuWCjk4nKBikcpg4XCzQkFWGrAZHmMKnrq'
    },
    32323: {
        name: 'BasedAI',
        title: 'BasedAI',
        chain: 'BasedAI',
        rpc: ['https://mainnet.basedaibridge.com/rpc/'],
        faucets: [],
        nativeCurrency: { name: 'BasedAI', symbol: 'BASED', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://getbased.ai',
        shortName: 'basedai',
        chainId: 32323,
        networkId: 32323,
        icon: 'basedai',
        explorers: [
            {
                name: 'BasedAI Explorer',
                url: 'https://explorer.getbased.ai',
                standard: 'none'
            },
            {
                name: 'BF1337 BasedAI Explorer',
                url: 'https://explorer.bf1337.org',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidkgcrgumpvke3rsk3txvy52ovosmyfum3b6vnyv4k4rzzov72zae'
    },
    32382: {
        name: 'Santiment Intelligence Network',
        chain: 'Santiment Intelligence Network',
        rpc: ['https://node.sanr.app'],
        faucets: [],
        nativeCurrency: { name: 'SANR', symbol: 'SANR', decimals: 18 },
        infoURL: 'https://sanr.app',
        shortName: 'SANR',
        chainId: 32382,
        networkId: 32382,
        icon: 'sanrchain',
        parent: {
            chain: 'eip155-1',
            type: 'L2',
            bridges: [{ url: 'https://sanr.app' }]
        },
        explorers: [
            {
                name: 'Santiment Intelligence Explorer',
                url: 'https://app-explorer-pos.sanr.app',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPLMg5mYD8XRknvYbDkD2x7FXxYan7MPTeUWZC2CihwDM'
    },
    32520: {
        name: 'Bitgert Mainnet',
        chain: 'Brise',
        rpc: [
            'https://rpc-bitgert.icecreamswap.com',
            'https://mainnet-rpc.brisescan.com',
            'https://chainrpc.com',
            'https://serverrpc.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Bitrise Token', symbol: 'Brise', decimals: 18 },
        infoURL: 'https://bitgert.com/',
        shortName: 'Brise',
        chainId: 32520,
        networkId: 32520,
        icon: 'brise',
        explorers: [
            {
                name: 'Brise Scan',
                url: 'https://brisescan.com',
                icon: 'brise',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmY3vKe1rG9AyHSGH1ouP3ER3EVUZRtRrFbFZEfEpMSd4V'
    },
    32659: {
        name: 'Fusion Mainnet',
        chain: 'FSN',
        icon: 'fusion',
        rpc: ['https://mainnet.fusionnetwork.io', 'wss://mainnet.fusionnetwork.io'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Fusion', symbol: 'FSN', decimals: 18 },
        infoURL: 'https://fusion.org',
        shortName: 'fsn',
        chainId: 32659,
        networkId: 32659,
        slip44: 288,
        explorers: [
            {
                name: 'fsnscan',
                url: 'https://fsnscan.com',
                icon: 'fsnscan',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmX3tsEoj7SdaBLLV8VyyCUAmymdEGiSGeuTbxMrEMVvth'
    },
    32769: {
        name: 'Zilliqa EVM',
        chain: 'ZIL',
        rpc: ['https://api.zilliqa.com'],
        faucets: [],
        nativeCurrency: { name: 'Zilliqa', symbol: 'ZIL', decimals: 18 },
        infoURL: 'https://www.zilliqa.com/',
        shortName: 'zil',
        chainId: 32769,
        networkId: 32769,
        icon: 'zilliqa',
        explorers: [
            {
                name: 'Zilliqa EVM Explorer',
                url: 'https://evmx.zilliqa.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTREXNgGtUhSoxFsrkhTe5LUnDBTKL5byaX8kpET6UuKp'
    },
    32770: {
        name: 'Zilliqa 2 EVM proto-mainnet',
        chain: 'ZIL',
        rpc: ['https://api.zq2-protomainnet.zilliqa.com'],
        faucets: ['https://faucet.zq2-protomainnet.zilliqa.com'],
        nativeCurrency: { name: 'Zilliqa', symbol: 'ZIL', decimals: 18 },
        infoURL: 'https://www.zilliqa.com/',
        shortName: 'zq2-proto-mainnet',
        chainId: 32770,
        networkId: 32770,
        icon: 'zilliqa',
        explorers: [
            {
                name: 'Zilliqa 2 EVM proto-mainnet explorer',
                url: 'https://explorer.zq2-protomainnet.zilliqa.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTREXNgGtUhSoxFsrkhTe5LUnDBTKL5byaX8kpET6UuKp'
    },
    32990: {
        name: 'Zilliqa EVM Isolated Server',
        chain: 'ZIL',
        rpc: ['https://zilliqa-isolated-server.zilliqa.com/'],
        faucets: ['https://dev-wallet.zilliqa.com/faucet?network=isolated_server'],
        nativeCurrency: { name: 'Zilliqa', symbol: 'ZIL', decimals: 18 },
        infoURL: 'https://www.zilliqa.com/',
        shortName: 'zil-isolated-server',
        chainId: 32990,
        networkId: 32990,
        icon: 'zilliqa',
        explorers: [
            {
                name: 'Zilliqa EVM Isolated Server Explorer',
                url: 'https://devex.zilliqa.com/?network=https://zilliqa-isolated-server.zilliqa.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTREXNgGtUhSoxFsrkhTe5LUnDBTKL5byaX8kpET6UuKp'
    },
    33033: {
        name: 'Entangle Mainnet',
        chain: 'NGL',
        icon: 'ngl',
        rpc: ['https://json-rpc.entangle.fi'],
        faucets: [],
        nativeCurrency: { name: 'Entangle', symbol: 'NGL', decimals: 18 },
        infoURL: 'https://www.entangle.fi',
        shortName: 'ngl',
        chainId: 33033,
        networkId: 33033,
        explorers: [
            {
                name: 'Entangle Mainnet Explorer',
                url: 'https://explorer.entangle.fi',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUQiosuH8ib8aXSpYcJRTje9Lro9VeZyd4cNXrXGY5r8D'
    },
    33101: {
        name: 'Zilliqa EVM Testnet',
        chain: 'ZIL',
        rpc: ['https://dev-api.zilliqa.com'],
        faucets: ['https://dev-wallet.zilliqa.com/faucet?network=testnet'],
        nativeCurrency: { name: 'Zilliqa', symbol: 'ZIL', decimals: 18 },
        infoURL: 'https://www.zilliqa.com/',
        shortName: 'zil-testnet',
        chainId: 33101,
        networkId: 33101,
        slip44: 1,
        explorers: [
            {
                name: 'Zilliqa EVM Explorer',
                url: 'https://evmx.zilliqa.com',
                standard: 'none'
            }
        ]
    },
    33103: {
        name: 'Zilliqa 2 EVM proto-testnet',
        chain: 'ZIL',
        rpc: ['https://api.zq2-prototestnet.zilliqa.com'],
        faucets: ['https://faucet.zq2-prototestnet.zilliqa.com'],
        nativeCurrency: { name: 'Zilliqa', symbol: 'ZIL', decimals: 18 },
        infoURL: 'https://www.zilliqa.com/',
        shortName: 'zq2-proto-testnet',
        chainId: 33103,
        networkId: 33103,
        icon: 'zilliqa',
        explorers: [
            {
                name: 'Zilliqa 2 EVM proto-testnet explorer',
                url: 'https://explorer.zq2-prototestnet.zilliqa.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTREXNgGtUhSoxFsrkhTe5LUnDBTKL5byaX8kpET6UuKp'
    },
    33111: {
        name: 'Curtis',
        chain: 'Curtis',
        rpc: ['https://rpc.curtis.apechain.com'],
        faucets: ['https://curtis.hub.caldera.xyz'],
        nativeCurrency: { name: 'ApeCoin', symbol: 'APE', decimals: 18 },
        infoURL: 'https://curtis.hub.caldera.xyz',
        shortName: 'curtis',
        chainId: 33111,
        networkId: 33111,
        icon: 'curtis',
        explorers: [
            {
                name: 'Curtis Explorer',
                url: 'https://explorer.curtis.apechain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTqiPnYZx6ZyPPbtsuh8VvvoH6DSCJGjTUgtTN9X8NScP'
    },
    33133: {
        name: 'Entangle Testnet',
        chain: 'NGL',
        icon: 'ngl',
        rpc: ['https://evm-testnet.entangle.fi'],
        faucets: [],
        nativeCurrency: { name: 'Entangle', symbol: 'NGL', decimals: 18 },
        infoURL: 'https://www.entangle.fi',
        shortName: 'tngl',
        chainId: 33133,
        networkId: 33133,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmUQiosuH8ib8aXSpYcJRTje9Lro9VeZyd4cNXrXGY5r8D'
    },
    33139: {
        name: 'ApeChain',
        chain: 'apechain',
        rpc: ['https://rpc.apechain.com'],
        faucets: [],
        nativeCurrency: { name: 'ApeCoin', symbol: 'APE', decimals: 18 },
        infoURL: 'https://apechain.com',
        shortName: 'apechain',
        chainId: 33139,
        networkId: 33139,
        explorers: [
            {
                name: 'ApeChain Explorer',
                url: 'https://apescan.io',
                standard: 'EIP3091'
            }
        ]
    },
    33210: {
        name: 'Cloudverse Subnet',
        chain: 'CLOUDVERSE',
        rpc: ['https://subnets.avax.network/cloudverse/mainnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'XCLOUD', symbol: 'XCLOUD', decimals: 18 },
        infoURL: 'https://muadao.build/',
        shortName: 'cloudverse',
        chainId: 33210,
        networkId: 33210,
        explorers: [
            {
                name: 'CLOUDVERSE Explorer',
                url: 'https://subnets.avax.network/cloudverse',
                standard: 'EIP3091'
            }
        ]
    },
    33333: {
        name: 'Aves Mainnet',
        chain: 'AVS',
        rpc: ['https://rpc.avescoin.io'],
        faucets: [],
        nativeCurrency: { name: 'Aves', symbol: 'AVS', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://avescoin.io',
        shortName: 'avs',
        chainId: 33333,
        networkId: 33333,
        icon: 'aves',
        explorers: [
            {
                name: 'avescan',
                url: 'https://avescan.io',
                icon: 'avescan',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeKQVv2QneHaaggw2NfpZ7DGMdjVhPywTdse5RzCs4oGn'
    },
    33385: {
        name: 'Zilliqa EVM Devnet',
        chain: 'ZIL',
        rpc: ['https://api.devnet.zilliqa.com/'],
        faucets: ['https://faucet.devnet.zilliqa.com/'],
        nativeCurrency: { name: 'Zilliqa', symbol: 'ZIL', decimals: 18 },
        infoURL: 'https://www.zilliqa.com/',
        shortName: 'zil-devnet',
        chainId: 33385,
        networkId: 33385,
        icon: 'zilliqa',
        explorers: [
            {
                name: 'Zilliqa EVM Devnet Explorer',
                url: 'https://otterscan.devnet.zilliqa.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTREXNgGtUhSoxFsrkhTe5LUnDBTKL5byaX8kpET6UuKp'
    },
    33401: {
        name: 'SlingShot',
        chain: 'SLING',
        rpc: ['https://rpc.slingshotdao.com'],
        faucets: [],
        nativeCurrency: { name: 'Sling', symbol: 'SLING', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://slingshotdao.com',
        shortName: 'slingshot',
        chainId: 33401,
        networkId: 33401,
        icon: 'slingshot',
        explorers: [
            {
                name: 'SlingShot Explorer',
                url: 'https://explore.slingshotdao.com',
                icon: 'slingshot',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVhM3wHXdXkFEvW4x4vYqT7bx7gb5BQLWcLebHBeAzAXF'
    },
    33469: {
        name: 'Zilliqa 2 EVM devnet',
        chain: 'ZIL',
        rpc: ['https://api.zq2-devnet.zilliqa.com'],
        faucets: ['https://faucet.zq2-devnet.zilliqa.com'],
        nativeCurrency: { name: 'Zilliqa', symbol: 'ZIL', decimals: 18 },
        infoURL: 'https://www.zilliqa.com/',
        shortName: 'zq2-devnet',
        chainId: 33469,
        networkId: 33469,
        icon: 'zilliqa',
        explorers: [
            {
                name: 'Zilliqa-2 EVM Devnet Explorer',
                url: 'https://explorer.zq2-devnet.zilliqa.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTREXNgGtUhSoxFsrkhTe5LUnDBTKL5byaX8kpET6UuKp'
    },
    33710: {
        name: 'R5 Network Testnet',
        chain: 'r5testnet',
        rpc: ['https://rpc-testnet.r5.network'],
        faucets: [],
        nativeCurrency: { name: 'Test R5', symbol: 'TR5', decimals: 18 },
        infoURL: 'https://r5.network',
        shortName: 'tr5',
        chainId: 33710,
        networkId: 33710,
        icon: 'r5',
        explorers: [
            {
                name: 'R5 Explorer',
                url: 'https://explorer-testnet.r5.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihrnrmjndul22scpktxzfvm6lyuxdepjtbfrn7ce4znl2blrqw6te'
    },
    33979: {
        name: 'Funki',
        chain: 'ETH',
        icon: 'funki',
        rpc: [
            'https://rpc-mainnet.funkichain.com',
            'wss://rpc-mainnet.funkichain.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://funkichain.com',
        shortName: 'funki',
        chainId: 33979,
        networkId: 33979,
        explorers: [
            {
                name: 'Funki Mainnet Explorer',
                url: 'https://explorer.funkichain.com',
                standard: 'none'
            },
            {
                name: 'FunkiScan',
                url: 'https://funkiscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQnQZ2YUuJMDYoKWhiA1KqY67VFjvMLSXTww46pnrS8js'
    },
    33999: {
        name: 'Pencils Protocol Sepolia Testnet',
        chain: 'ETH',
        rpc: [],
        faucets: [],
        nativeCurrency: {
            name: 'Pencils Protocol Sepolia Testnet Token',
            symbol: 'DAPPST',
            decimals: 18
        },
        infoURL: 'https://pencilsprotocol.io/',
        shortName: 'dapp-sepolia',
        chainId: 33999,
        networkId: 33999,
        status: 'incubating'
    },
    34443: {
        name: 'Mode',
        chain: 'ETH',
        rpc: [
            'https://mainnet.mode.network',
            'https://mode.drpc.org',
            'wss://mode.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://docs.mode.network/',
        shortName: 'mode',
        chainId: 34443,
        networkId: 34443,
        icon: 'mode',
        explorers: [
            {
                name: 'modescout',
                url: 'https://explorer.mode.network',
                standard: 'none'
            },
            { name: 'Routescan', url: 'https://modescan.io', standard: 'none' }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreidi5y7afj5z4xrz7uz5rkg2mcsv2p2n4ui4g7q4k4ecdz65i2agou'
    },
    34504: {
        name: 'ZEUS Mainnet',
        chain: 'ZEUSX',
        icon: 'zeusicon',
        rpc: ['https://mainnet-rpc.zeuschainscan.io'],
        nativeCurrency: { name: 'The ZEUS Token', symbol: 'ZEUSX', decimals: 18 },
        infoURL: 'https://zeuschainscan.io',
        shortName: 'ZEUSX',
        chainId: 34504,
        networkId: 34504,
        faucets: [],
        explorers: [
            {
                name: 'ZEUS Mainnet Explorer',
                url: 'https://zeuschainscan.io',
                icon: 'zeusicon',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdktFyG3dM6Jk4j7V9xzvWwSpmnLcaNDuWhPwFHJw7K6e'
    },
    35011: {
        name: 'J2O Taro',
        chain: 'TARO',
        rpc: ['https://rpc.j2o.io'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'TARO Coin', symbol: 'taro', decimals: 18 },
        infoURL: 'https://j2o.io',
        shortName: 'j2o',
        chainId: 35011,
        networkId: 35011,
        explorers: [
            {
                name: 'J2O Taro Explorer',
                url: 'https://exp.j2o.io',
                icon: 'j2otaro',
                standard: 'EIP3091'
            }
        ]
    },
    35441: {
        name: 'Q Mainnet',
        chain: 'Q',
        rpc: ['https://rpc.q.org'],
        faucets: [],
        nativeCurrency: { name: 'QGOV', symbol: 'QGOV', decimals: 18 },
        infoURL: 'https://q.org',
        shortName: 'q',
        chainId: 35441,
        networkId: 35441,
        icon: 'q',
        explorers: [
            {
                name: 'Q explorer',
                url: 'https://explorer.q.org',
                icon: 'q',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQUQKe8VEtSthhgXnJ3EmEz94YhpVCpUDZAiU9KYyNLya'
    },
    35443: {
        name: 'Q Testnet',
        chain: 'Q',
        rpc: ['https://rpc.qtestnet.org'],
        faucets: [],
        nativeCurrency: { name: 'Q token', symbol: 'Q', decimals: 18 },
        infoURL: 'https://q.org/',
        shortName: 'q-testnet',
        chainId: 35443,
        networkId: 35443,
        slip44: 1,
        icon: 'q',
        explorers: [
            {
                name: 'Q explorer',
                url: 'https://explorer.qtestnet.org',
                icon: 'q',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQUQKe8VEtSthhgXnJ3EmEz94YhpVCpUDZAiU9KYyNLya'
    },
    37111: {
        name: 'Lens Testnet',
        title: 'Lens Network Sepolia Testnet',
        chain: 'Lens',
        rpc: ['https://rpc.testnet.lens.dev'],
        faucets: ['https://www.alchemy.com/faucets/lens-sepolia'],
        chainId: 37111,
        networkId: 37111,
        nativeCurrency: { name: 'GRASS', symbol: 'GRASS', decimals: 18 },
        icon: 'lens',
        infoURL: 'https://www.lens.xyz',
        shortName: 'lens-sepolia',
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://portal.testnet.lens.dev/bridge' }]
        },
        explorers: [
            {
                name: 'Lens Testnet Block Explorer',
                url: 'https://block-explorer.testnet.lens.dev',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmP9HNKbbWQLEx5H57BSV3VhJNyVpVaC5B3NBCsyoomTMU'
    },
    38400: {
        name: 'ConnectorManager',
        chain: 'Rangers',
        icon: 'rangers',
        rpc: ['https://cm.rangersprotocol.com/api/jsonrpc'],
        faucets: [],
        nativeCurrency: {
            name: 'Rangers Protocol Gas',
            symbol: 'cmRPG',
            decimals: 18
        },
        infoURL: 'https://rangersprotocol.com',
        shortName: 'cmrpg',
        chainId: 38400,
        networkId: 38400,
        explorers: [
            {
                name: 'rangersscan',
                url: 'https://scan.rangersprotocol.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXR5e5SDABWfQn6XT9uMsVYAo5Bv7vUv4jVs8DFqatZWG'
    },
    38401: {
        name: 'ConnectorManager Robin',
        chain: 'Rangers',
        icon: 'rangers',
        rpc: ['https://robin-cm.rangersprotocol.com/api/jsonrpc'],
        faucets: ['https://robin-faucet.rangersprotocol.com'],
        nativeCurrency: {
            name: 'Rangers Protocol Gas',
            symbol: 'ttRPG',
            decimals: 18
        },
        infoURL: 'https://rangersprotocol.com',
        shortName: 'ttrpg',
        chainId: 38401,
        networkId: 38401,
        explorers: [
            {
                name: 'rangersscan-robin',
                url: 'https://robin-rangersscan.rangersprotocol.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXR5e5SDABWfQn6XT9uMsVYAo5Bv7vUv4jVs8DFqatZWG'
    },
    39656: {
        name: 'PRM Mainnet',
        chain: 'prm',
        icon: 'prmIcon',
        rpc: ['https://mainnet-rpc.prmscan.org'],
        faucets: [],
        nativeCurrency: { name: 'Primal Network', symbol: 'PRM', decimals: 18 },
        infoURL: 'https://primalnetwork.org',
        shortName: 'prm',
        chainId: 39656,
        networkId: 39656,
        explorers: [
            {
                name: 'Primal Network',
                url: 'https://prmscan.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmckkDRkuCQWbvhpKGsqa8ajuQvf3W5dekzw5qpiPC6shk'
    },
    39797: {
        name: 'Energi Mainnet',
        chain: 'NRG',
        rpc: ['https://nodeapi.energi.network'],
        faucets: [],
        nativeCurrency: { name: 'Energi', symbol: 'NRG', decimals: 18 },
        infoURL: 'https://www.energi.world/',
        shortName: 'nrg',
        chainId: 39797,
        networkId: 39797,
        slip44: 39797
    },
    39815: {
        name: 'OHO Mainnet',
        chain: 'OHO',
        rpc: ['https://mainnet.oho.ai'],
        faucets: [],
        nativeCurrency: { name: 'OHO', symbol: 'OHO', decimals: 18 },
        infoURL: 'https://oho.ai',
        shortName: 'oho',
        chainId: 39815,
        networkId: 39815,
        icon: 'oho',
        explorers: [
            {
                name: 'ohoscan',
                url: 'https://ohoscan.com',
                icon: 'ohoscan',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZt75xixnEtFzqHTrJa8kJkV4cTXmUZqeMeHM8BcvomQc'
    },
    40000: {
        name: 'DIV Chain',
        chain: 'DIVC',
        rpc: ['https://rpc.divchain.org'],
        faucets: [],
        features: [{ name: 'EIP155' }],
        nativeCurrency: { name: 'DIVC', symbol: 'DIVC', decimals: 18 },
        infoURL: 'https://www.divchain.org',
        shortName: 'divc',
        chainId: 40000,
        networkId: 40000,
        icon: 'divc',
        explorers: [
            {
                name: 'DIV Chain explorer',
                url: 'https://scan.divchain.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmebuyvTmRvM66rXbxSFtZv7VGj1HtvNQ68hvYpLEPe3bA'
    },
    41455: {
        name: 'Aleph Zero EVM',
        chain: 'Aleph Zero EVM',
        icon: 'aleph-zero',
        rpc: [
            'https://rpc.alephzero.raas.gelato.cloud',
            'wss://ws.alephzero.raas.gelato.cloud'
        ],
        faucets: [],
        nativeCurrency: { name: 'Aleph Zero', symbol: 'AZERO', decimals: 18 },
        infoURL: 'https://alephzero.org/',
        shortName: 'aleph-zero',
        chainId: 41455,
        networkId: 41455,
        explorers: [
            {
                name: 'Aleph Zero EVM Mainnet Explorer',
                url: 'https://evm-explorer.alephzero.org',
                icon: 'aleph-zero',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUmw7yJDdkTV6SNp5PDfMLe5LWMfUo6vyQbh7fdhTfGDH'
    },
    41500: {
        name: 'Opulent-X BETA',
        chainId: 41500,
        shortName: 'ox-beta',
        chain: 'Opulent-X',
        networkId: 41500,
        nativeCurrency: { name: 'Oxyn Gas', symbol: 'OXYN', decimals: 18 },
        rpc: ['https://connect.opulent-x.com'],
        faucets: [],
        infoURL: 'https://beta.opulent-x.com',
        explorers: [
            {
                name: 'Opulent-X BETA Explorer',
                url: 'https://explorer.opulent-x.com',
                standard: 'none'
            }
        ]
    },
    41923: {
        name: 'EDU Chain',
        chain: 'EDU Chain',
        icon: 'occ-mainnet',
        rpc: ['https://rpc.edu-chain.raas.gelato.cloud'],
        faucets: ['https://bridge.gelato.network/bridge/edu-chain'],
        nativeCurrency: { name: 'EDU', symbol: 'EDU', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/edu-chain',
        shortName: 'edu-chain',
        chainId: 41923,
        networkId: 41923,
        explorers: [
            {
                name: 'EDU Chain',
                url: 'https://educhain.blockscout.com',
                icon: 'occ-mainnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmAbz7VfGvf6NVHezuBy5HpJTCi1gEshBxxdDdfVXNQ8Bt'
    },
    42000: {
        name: 'Helios Chain Testnet',
        chain: 'Helios Chain',
        rpc: ['https://testnet1.helioschainlabs.org'],
        faucets: ['https://testnet.helioschain.network'],
        nativeCurrency: { name: 'Helios', symbol: 'HLS', decimals: 18 },
        icon: 'helioschain',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://hub.helioschain.network',
        shortName: 'HLS',
        chainId: 42000,
        networkId: 42000,
        explorers: [
            {
                name: 'Helios Chain Explorer',
                url: 'https://explorer.helioschainlabs.org',
                icon: 'helioschain',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/bafkreifrqrkoeenmx6wja2rj5o6sj3mtn5veyvx7dis6mba4bycd7yziba'
    },
    42001: {
        name: 'PMON Chain',
        chain: '42001',
        rpc: ['https://rpc.pmon.xyz'],
        faucets: [],
        nativeCurrency: { name: 'PMON Token', symbol: 'PMON', decimals: 18 },
        infoURL: 'https://protocolmonsterlabs.com/pmon-chain',
        shortName: 'pmon',
        chainId: 42001,
        networkId: 42001,
        icon: 'pmon',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.pmon.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-42161',
            bridges: [{ url: 'https://bridge.arbitrum.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmaEMH8gUpdBuZdMpw2nnZ6tFA8qcRLqVdTtuoTT8U95X6'
    },
    42026: {
        name: 'Donatuz',
        chain: 'ETH',
        rpc: ['https://rpc.donatuz.com'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.donatuz.com',
        shortName: 'donatuz',
        chainId: 42026,
        networkId: 42026,
        explorers: [
            {
                name: 'Donatuz Explorer',
                url: 'https://explorer.donatuz.com',
                standard: 'EIP3091'
            }
        ]
    },
    42069: {
        name: 'pegglecoin',
        chain: '42069',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'pegglecoin', symbol: 'peggle', decimals: 18 },
        infoURL: 'https://teampeggle.com',
        shortName: 'PC',
        chainId: 42069,
        networkId: 42069
    },
    42070: {
        name: 'WMC Testnet',
        chain: 'WMC',
        icon: 'wmc',
        rpc: ['https://rpc-testnet-base.worldmobile.net'],
        faucets: ['https://faucet-testnet-base.worldmobile.net'],
        nativeCurrency: { name: 'WMTx', symbol: 'WMTx', decimals: 18 },
        infoURL: 'https://worldmobiletoken.com',
        shortName: 'wmtx',
        chainId: 42070,
        networkId: 42070,
        explorers: [
            {
                name: 'WMC Explorer',
                url: 'https://explorer-testnet-base.worldmobile.net',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVWrPMhSkocodzjz54R6qdQ1UJx4Y6oUAsvKuqWTi9u2E'
    },
    42072: {
        name: 'AgentLayer Testnet',
        chain: 'AgentLayer',
        icon: 'agentLayerIcon',
        rpc: ['https://testnet-rpc.agentlayer.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Agent', symbol: 'AGENT', decimals: 18 },
        infoURL: 'https://agentlayer.xyz/home',
        shortName: 'agent',
        chainId: 42072,
        networkId: 42072,
        explorers: [
            {
                name: 'AgentLayer Testnet Explorer',
                url: 'https://testnet-explorer.agentlayer.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSj6SSWmBiRjnjZQPb17kvhGDmB9xAGRkG13RwPuXLTCT'
    },
    42096: {
        name: 'Heurist Testnet',
        chain: 'HEU',
        status: 'active',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Heurist', symbol: 'HEU', decimals: 18 },
        infoURL: '',
        shortName: 'HEU',
        chainId: 42096,
        networkId: 42096,
        slip44: 1,
        explorers: [],
        parent: { type: 'L2', chain: 'eip155-4', bridges: [] }
    },
    42161: {
        name: 'Arbitrum One',
        chainId: 42161,
        shortName: 'arb1',
        chain: 'ETH',
        networkId: 42161,
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        rpc: [
            'https://arbitrum-mainnet.infura.io/v3/${INFURA_API_KEY}',
            'https://arb-mainnet.g.alchemy.com/v2/${ALCHEMY_API_KEY}',
            'https://arb1.arbitrum.io/rpc',
            'https://arbitrum-one-rpc.publicnode.com',
            'wss://arbitrum-one-rpc.publicnode.com'
        ],
        faucets: [],
        explorers: [
            {
                name: 'Arbiscan',
                url: 'https://arbiscan.io',
                standard: 'EIP3091'
            },
            {
                name: 'Arbitrum Explorer',
                url: 'https://explorer.arbitrum.io',
                standard: 'EIP3091'
            },
            {
                name: 'dexguru',
                url: 'https://arbitrum.dex.guru',
                icon: 'dexguru',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://arbitrum.io',
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.arbitrum.io' }]
        }
    },
    42170: {
        name: 'Arbitrum Nova',
        chainId: 42170,
        shortName: 'arb-nova',
        chain: 'ETH',
        networkId: 42170,
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        rpc: [
            'https://nova.arbitrum.io/rpc',
            'https://arbitrum-nova-rpc.publicnode.com',
            'wss://arbitrum-nova-rpc.publicnode.com'
        ],
        faucets: [],
        explorers: [
            {
                name: 'Arbitrum Nova Chain Explorer',
                url: 'https://nova-explorer.arbitrum.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://arbitrum.io',
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.arbitrum.io' }]
        }
    },
    42220: {
        name: 'Celo Mainnet',
        chainId: 42220,
        shortName: 'celo',
        chain: 'CELO',
        networkId: 42220,
        nativeCurrency: { name: 'CELO', symbol: 'CELO', decimals: 18 },
        rpc: ['https://forno.celo.org', 'wss://forno.celo.org/ws'],
        faucets: [],
        infoURL: 'https://docs.celo.org/',
        explorers: [
            {
                name: 'Celoscan',
                url: 'https://celoscan.io',
                standard: 'EIP3091'
            },
            {
                name: 'blockscout',
                url: 'https://explorer.celo.org',
                standard: 'none'
            }
        ]
    },
    42261: {
        name: 'Oasis Emerald Testnet',
        chain: 'Emerald',
        icon: 'oasis',
        rpc: [
            'https://testnet.emerald.oasis.io/',
            'wss://testnet.emerald.oasis.io/ws'
        ],
        faucets: ['https://faucet.testnet.oasis.io/'],
        nativeCurrency: { name: 'Emerald Test Rose', symbol: 'TEST', decimals: 18 },
        infoURL: 'https://docs.oasis.io/dapp/emerald',
        shortName: 'emerald-testnet',
        chainId: 42261,
        networkId: 42261,
        slip44: 1,
        explorers: [
            {
                name: 'Oasis Emerald Testnet Explorer',
                url: 'https://explorer.oasis.io/testnet/emerald',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiespupb52akiwrexxg7g72mh7m7h7lum5hmqijmpdh3kmuunzclha'
    },
    42262: {
        name: 'Oasis Emerald',
        chain: 'Emerald',
        icon: 'oasis',
        rpc: ['https://emerald.oasis.io', 'wss://emerald.oasis.io/ws'],
        faucets: [],
        nativeCurrency: { name: 'Emerald Rose', symbol: 'ROSE', decimals: 18 },
        infoURL: 'https://docs.oasis.io/dapp/emerald',
        shortName: 'emerald',
        chainId: 42262,
        networkId: 42262,
        explorers: [
            {
                name: 'Oasis Emerald Explorer',
                url: 'https://explorer.oasis.io/mainnet/emerald',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiespupb52akiwrexxg7g72mh7m7h7lum5hmqijmpdh3kmuunzclha'
    },
    42355: {
        name: 'GoldXChain Mainnet',
        chain: 'GoldX',
        rpc: ['https://mainnet-rpc.goldxchain.io'],
        faucets: [],
        nativeCurrency: { name: 'GoldX', symbol: 'GOLDX', decimals: 18 },
        infoURL: 'https://goldxchain.io',
        shortName: 'goldx',
        chainId: 42355,
        networkId: 42355,
        explorers: [
            {
                name: 'GoldXChain Explorer',
                url: 'https://explorer.goldxchain.io',
                standard: 'EIP3091'
            }
        ]
    },
    42420: {
        name: 'Asset Chain Mainnet',
        chain: 'Asset Chain',
        rpc: ['https://mainnet-rpc.assetchain.org'],
        faucets: ['https://faucet.assetchain.org'],
        nativeCurrency: { name: 'Real World Asset', symbol: 'RWA', decimals: 18 },
        infoURL: 'https://docs.assetchain.org',
        shortName: 'assetchain',
        chainId: 42420,
        networkId: 42420,
        icon: 'assetchain',
        explorers: [
            {
                name: 'Asset Chain Explorer',
                url: 'https://scan.assetchain.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXc4bxuyWvQFqjuunXmvZZs1AwGChyY7sGYK6tgCkp3nJ'
    },
    42421: {
        name: 'Asset Chain Testnet',
        chain: 'Asset Chain',
        rpc: ['https://enugu-rpc.assetchain.org'],
        faucets: ['https://faucet.assetchain.org'],
        nativeCurrency: { name: 'Real World Asset', symbol: 'RWA', decimals: 18 },
        infoURL: 'https://docs.assetchain.org',
        shortName: 'rwa',
        chainId: 42421,
        networkId: 42421,
        icon: 'assetchain',
        explorers: [
            {
                name: 'Asset Chain Testnet Explorer',
                url: 'https://scan-testnet.assetchain.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXc4bxuyWvQFqjuunXmvZZs1AwGChyY7sGYK6tgCkp3nJ'
    },
    42766: {
        name: 'ZKFair Mainnet',
        title: 'ZKFair Mainnet',
        chain: 'ZKFair',
        rpc: ['https://rpc.zkfair.io'],
        faucets: [],
        nativeCurrency: { name: 'USDC Token', symbol: 'USDC', decimals: 18 },
        infoURL: 'https://zkfair.io',
        shortName: 'ZKFair-Mainnet',
        chainId: 42766,
        networkId: 42766,
        icon: 'zkfair',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://scan.zkfair.io',
                icon: 'zkfair',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://wallet.zkfair.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmVb682D4mUXkKNP28xxJDNgSYbDLvEc3kVYx7TQxEa6Cw'
    },
    42793: {
        name: 'Etherlink Mainnet',
        chain: 'Etherlink',
        icon: 'etherlink',
        chainId: 42793,
        networkId: 42793,
        features: [{ name: 'EIP1559' }],
        infoURL: 'https://etherlink.com',
        shortName: 'etlk',
        nativeCurrency: { name: 'tez', symbol: 'XTZ', decimals: 18 },
        rpc: ['https://node.mainnet.etherlink.com'],
        faucets: [],
        explorers: [
            {
                name: 'Etherlink Explorer',
                url: 'https://explorer.etherlink.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVqE4wq3fd3RKZwo7GxmW333ywHgYBZGvqwh3TUBM5DUi'
    },
    42801: {
        name: 'Gesoten Verse Testnet',
        chain: 'Gesoten Verse',
        rpc: ['https://rpc.testnet.verse.gesoten.com/'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://gesoten.com/',
        shortName: 'GST',
        icon: 'gesoten',
        chainId: 42801,
        networkId: 42801,
        slip44: 1,
        explorers: [
            {
                name: 'Gesoten Verse Testnet Explorer',
                url: 'https://explorer.testnet.verse.gesoten.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmb7oJY9zd9sTzxNNQNTVZQz2hkd1aA94mWm4cvXfJ9QxV'
    },
    42888: {
        name: 'Kinto Testnet',
        title: 'Kinto Testnet',
        chain: 'ETH',
        rpc: ['http://35.215.120.180:8545'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://ethereum.org',
        shortName: 'keth',
        chainId: 42888,
        networkId: 42888,
        slip44: 1,
        explorers: [
            {
                name: 'kintoscan',
                url: 'http://35.215.120.180:4000',
                standard: 'EIP3091'
            }
        ]
    },
    43110: {
        name: 'Athereum',
        chain: 'ATH',
        rpc: ['https://ava.network:21015/ext/evm/rpc'],
        faucets: ['http://athfaucet.ava.network//?address=${ADDRESS}'],
        nativeCurrency: { name: 'Athereum Ether', symbol: 'ATH', decimals: 18 },
        infoURL: 'https://athereum.ava.network',
        shortName: 'avaeth',
        chainId: 43110,
        networkId: 43110
    },
    43111: {
        name: 'Hemi',
        chain: 'ETH',
        rpc: ['https://rpc.hemi.network/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://hemi.xyz',
        shortName: 'hemi',
        chainId: 43111,
        networkId: 43111,
        icon: 'hemi',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.hemi.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-1' },
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmfP6GDn5eXFcpWuoiyWn5pjn6PYB7HQhRD8nSko1zR8KD'
    },
    43113: {
        name: 'Avalanche Fuji Testnet',
        chain: 'AVAX',
        icon: 'avax',
        rpc: [
            'https://api.avax-test.network/ext/bc/C/rpc',
            'https://avalanche-fuji-c-chain-rpc.publicnode.com',
            'wss://avalanche-fuji-c-chain-rpc.publicnode.com'
        ],
        faucets: ['https://faucet.avax-test.network/'],
        nativeCurrency: { name: 'Avalanche', symbol: 'AVAX', decimals: 18 },
        infoURL: 'https://cchain.explorer.avax-test.network',
        shortName: 'Fuji',
        chainId: 43113,
        networkId: 1,
        slip44: 1,
        explorers: [
            {
                name: 'Etherscan',
                url: 'https://testnet.snowscan.xyz',
                standard: 'EIP3091'
            },
            {
                name: 'Routescan',
                url: 'https://testnet.snowtrace.io',
                standard: 'EIP3091'
            },
            {
                name: 'Avascan',
                url: 'https://testnet.avascan.info',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRALA5qvQBRwWre8ofuhCbr3wxVmPS3kGetRR9uJqbqqe'
    },
    43114: {
        name: 'Avalanche C-Chain',
        chain: 'AVAX',
        icon: 'avax',
        rpc: [
            'https://api.avax.network/ext/bc/C/rpc',
            'https://avalanche-c-chain-rpc.publicnode.com',
            'wss://avalanche-c-chain-rpc.publicnode.com'
        ],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Avalanche', symbol: 'AVAX', decimals: 18 },
        infoURL: 'https://www.avax.network/',
        shortName: 'avax',
        chainId: 43114,
        networkId: 43114,
        slip44: 9005,
        explorers: [
            {
                name: 'Etherscan',
                url: 'https://snowscan.xyz',
                standard: 'EIP3091'
            },
            {
                name: 'Routescan',
                url: 'https://snowtrace.io',
                standard: 'EIP3091'
            },
            {
                name: 'Avascan',
                url: 'https://avascan.info',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRALA5qvQBRwWre8ofuhCbr3wxVmPS3kGetRR9uJqbqqe'
    },
    43288: {
        name: 'Boba Avax',
        chain: 'Boba Avax',
        status: 'deprecated',
        rpc: [
            'https://avax.boba.network',
            'wss://wss.avax.boba.network',
            'https://replica.avax.boba.network',
            'wss://replica-wss.avax.boba.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Boba Token', symbol: 'BOBA', decimals: 18 },
        infoURL: 'https://docs.boba.network/for-developers/network-avalanche',
        shortName: 'bobaavax',
        chainId: 43288,
        networkId: 43288,
        explorers: [
            {
                name: 'Boba Avax Explorer',
                url: 'https://blockexplorer.avax.boba.network',
                standard: 'none'
            }
        ]
    },
    43419: {
        name: 'GUNZ',
        chain: 'GUNZ',
        rpc: [
            'https://rpc.gunzchain.io/ext/bc/2M47TxWHGnhNtq6pM5zPXdATBtuqubxn5EPFgFmEawCQr9WFML/rpc'
        ],
        faucets: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'GUN', symbol: 'GUN', decimals: 18 },
        icon: 'gunz',
        infoURL: 'https://gunbygunz.com',
        shortName: 'gunz-mainnet',
        chainId: 43419,
        networkId: 43419,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://gunzscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreid7wspejxmvsqkycru3lnfppgqre6zavkyw4vklnzrhoiycqsjzpa'
    },
    43521: {
        name: 'Formicarium',
        title: 'MemeCore Testnet Formicarium',
        chain: 'MemeCore',
        icon: 'memecore',
        rpc: [
            'https://rpc.formicarium.memecore.net',
            'wss://ws.formicarium.memecore.net'
        ],
        faucets: ['https://faucet.memecore.com/formicarium'],
        nativeCurrency: { name: 'Formicarium M', symbol: 'M', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://memecore.com',
        shortName: 'form',
        chainId: 43521,
        networkId: 43521,
        slip44: 1,
        explorers: [
            {
                name: 'OKX-Formicarium',
                url: 'https://www.okx.com/web3/explorer/formicarium-testnet',
                standard: 'EIP3091'
            },
            {
                name: 'MemeCoreScan-Formicarium',
                url: 'https://formicarium.memecorescan.io',
                standard: 'EIP3091'
            },
            {
                name: 'MemeCore Testnet Formicarium Explorer',
                url: 'https://formicarium.blockscout.memecore.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmX2DPJqHjMRUYD4CMpXBDBpqa3p8c4DkE4iiHtcxBJe3i'
    },
    43851: {
        name: 'ZKFair Testnet',
        chain: 'ETH',
        rpc: ['https://testnet-rpc.zkfair.io'],
        faucets: [],
        nativeCurrency: { name: 'USDC Token', symbol: 'USDC', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://zkfair.io',
        shortName: 'ZKFair-Testnet',
        chainId: 43851,
        networkId: 43851,
        slip44: 1,
        icon: 'zkfair',
        explorers: [
            {
                name: 'ZKFair Testnet Info',
                url: 'https://testnet-scan.zkfair.io',
                icon: 'zkfair',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVb682D4mUXkKNP28xxJDNgSYbDLvEc3kVYx7TQxEa6Cw'
    },
    44444: {
        name: 'Frenchain',
        chain: 'fren',
        rpc: ['https://rpc-02.frenscan.io'],
        faucets: [],
        nativeCurrency: { name: 'FREN', symbol: 'FREN', decimals: 18 },
        infoURL: 'https://frenchain.app',
        shortName: 'FREN',
        chainId: 44444,
        networkId: 44444,
        icon: 'fren',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://frenscan.io',
                icon: 'fren',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQk41bYX6WpYyUAdRgomZekxP5mbvZXhfxLEEqtatyJv4'
    },
    44445: {
        name: 'Quantum Network',
        chain: 'Quantum',
        rpc: ['https://rpcqtm.avescoin.io'],
        faucets: [],
        nativeCurrency: { name: 'Quantum', symbol: 'QTM', decimals: 18 },
        infoURL: 'https://avescoin.io/',
        shortName: 'QTM',
        chainId: 44445,
        networkId: 44445,
        icon: 'quantum',
        explorers: [
            {
                name: 'Quantum Explorer',
                url: 'https://qtm.avescoin.io',
                icon: 'quantum',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeKQVv2QneHaaggw2NfpZ7DGMdjVhPywTdse5RzCs4oGn'
    },
    44787: {
        name: 'Celo Alfajores Testnet',
        chainId: 44787,
        shortName: 'ALFA',
        chain: 'CELO',
        networkId: 44787,
        slip44: 1,
        nativeCurrency: { name: 'CELO', symbol: 'CELO', decimals: 18 },
        rpc: [
            'https://alfajores-forno.celo-testnet.org',
            'wss://alfajores-forno.celo-testnet.org/ws'
        ],
        faucets: [
            'https://celo.org/developers/faucet',
            'https://cauldron.pretoriaresearchlab.io/alfajores-faucet'
        ],
        infoURL: 'https://docs.celo.org/',
        explorers: [
            {
                name: 'Alfajoresscan',
                url: 'https://alfajores.celoscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    45000: {
        name: 'Autobahn Network',
        chain: 'TXL',
        rpc: ['https://rpc.autobahn.network'],
        faucets: [],
        nativeCurrency: { name: 'TXL', symbol: 'TXL', decimals: 18 },
        infoURL: 'https://autobahn.network',
        shortName: 'AutobahnNetwork',
        chainId: 45000,
        networkId: 45000,
        icon: 'autobahn',
        explorers: [
            {
                name: 'autobahn explorer',
                url: 'https://explorer.autobahn.network',
                icon: 'autobahn',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZP19pbqTco4vaP9siduLWP8pdYArFK3onfR55tvjr12s'
    },
    45003: {
        name: 'Juneo JUNE-Chain',
        chain: 'Juneo JUNE-Chain',
        rpc: ['https://rpc.juneo-mainnet.network/ext/bc/JUNE/rpc'],
        faucets: [],
        nativeCurrency: { name: 'JUNE', symbol: 'JUNE', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://juneo.com/',
        shortName: 'JUNE',
        chainId: 45003,
        networkId: 45003,
        icon: 'juneomainnet',
        explorers: [
            {
                name: 'Juneo Scan',
                url: 'https://juneoscan.io/chain/2',
                icon: 'juneomainnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUXCyNVe6t9MDdWzW95YCLex6iTwG32NYPfR4ZS9r2JTJ'
    },
    45004: {
        name: 'Juneo DAI1-Chain',
        chain: 'Juneo DAI1-Chain',
        rpc: ['https://rpc.juneo-mainnet.network/ext/bc/DAI1/rpc'],
        faucets: [],
        nativeCurrency: { name: 'DAI1', symbol: 'DAI1', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://juneo.com/',
        shortName: 'DAI1',
        chainId: 45004,
        networkId: 45004,
        icon: 'juneo-dai1',
        explorers: [
            {
                name: 'Juneo Scan',
                url: 'https://juneoscan.io/chain/5',
                icon: 'juneomainnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmegd2hkWhyKjyUuQQ2vMauaj3N5J89kEPqN6YNT6s64zT'
    },
    45005: {
        name: 'Juneo USDT1-Chain',
        chain: 'Juneo USDT1-Chain',
        rpc: ['https://rpc.juneo-mainnet.network/ext/bc/USDT1/rpc'],
        faucets: [],
        nativeCurrency: { name: 'USDT1', symbol: 'USDT1', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://juneo.com/',
        shortName: 'USDT1',
        chainId: 45005,
        networkId: 45005,
        icon: 'juneo-usdt1',
        explorers: [
            {
                name: 'Juneo Scan',
                url: 'https://juneoscan.io/chain/3',
                icon: 'juneomainnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmb7FZMjv6k25vDjNwfpksjsriwrLh7PVsT93eBWzC5pCY'
    },
    45006: {
        name: 'Juneo USD1-Chain',
        chain: 'Juneo USD1-Chain',
        rpc: ['https://rpc.juneo-mainnet.network/ext/bc/USD1/rpc'],
        faucets: [],
        nativeCurrency: { name: 'USD1', symbol: 'USD1', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://juneo.com/',
        shortName: 'USD1',
        chainId: 45006,
        networkId: 45006,
        icon: 'juneo-usd1',
        explorers: [
            {
                name: 'Juneo Scan',
                url: 'https://juneoscan.io/chain/4',
                icon: 'juneomainnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTDaiJnZdwDhxLUjtx1qaNJ5VmKdK9xJoqGr7ubV1EXWW'
    },
    45007: {
        name: 'Juneo mBTC1-Chain',
        chain: 'Juneo mBTC1-Chain',
        rpc: ['https://rpc.juneo-mainnet.network/ext/bc/mBTC1/rpc'],
        faucets: [],
        nativeCurrency: { name: 'mBTC1', symbol: 'mBTC1', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://juneo.com/',
        shortName: 'mBTC1',
        chainId: 45007,
        networkId: 45007,
        icon: 'juneo-mbtc1',
        explorers: [
            {
                name: 'Juneo Scan',
                url: 'https://juneoscan.io/chain/9',
                icon: 'juneomainnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSxps298BQUSGihkHy3sF5k8FRX7DqgfCJfJnZgjQs7bf'
    },
    45008: {
        name: 'Juneo GLD1-Chain',
        chain: 'Juneo GLD1-Chain',
        rpc: ['https://rpc.juneo-mainnet.network/ext/bc/GLD1/rpc'],
        faucets: [],
        nativeCurrency: { name: 'GLD1', symbol: 'GLD1', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://juneo.com/',
        shortName: 'GLD1',
        chainId: 45008,
        networkId: 45008,
        icon: 'juneo-gld1',
        explorers: [
            {
                name: 'Juneo Scan',
                url: 'https://juneoscan.io/chain/8',
                icon: 'juneomainnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQFqkzi97UKJqmC8KRcFieCuC7KXk4G42j7j5PSF4ByWg'
    },
    45009: {
        name: 'Juneo LTC1-Chain',
        chain: 'Juneo LTC1-Chain',
        rpc: ['https://rpc.juneo-mainnet.network/ext/bc/LTC1/rpc'],
        faucets: [],
        nativeCurrency: { name: 'LTC1', symbol: 'LTC1', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://juneo.com/',
        shortName: 'LTC1',
        chainId: 45009,
        networkId: 45009,
        icon: 'juneo-ltc1',
        explorers: [
            {
                name: 'Juneo Scan',
                url: 'https://juneoscan.io/chain/11',
                icon: 'juneomainnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYofWFKyp1ewqn1oZgU9csyfxv1D742kMqNkysx7yRzEm'
    },
    45010: {
        name: 'Juneo DOGE1-Chain',
        chain: 'Juneo DOGE1-Chain',
        rpc: ['https://rpc.juneo-mainnet.network/ext/bc/DOGE1/rpc'],
        faucets: [],
        nativeCurrency: { name: 'DOGE1', symbol: 'DOGE1', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://juneo.com/',
        shortName: 'DOGE1',
        chainId: 45010,
        networkId: 45010,
        icon: 'juneo-doge1',
        explorers: [
            {
                name: 'Juneo Scan',
                url: 'https://juneoscan.io/chain/10',
                icon: 'juneomainnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXTzkZKgRHrkxJyP9FZwHTgmk2ovC9b1vrsfhHc6jvjzF'
    },
    45011: {
        name: 'Juneo EUR1-Chain',
        chain: 'Juneo EUR1-Chain',
        rpc: ['https://rpc.juneo-mainnet.network/ext/bc/EUR1/rpc'],
        faucets: [],
        nativeCurrency: { name: 'EUR1', symbol: 'EUR1', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://juneo.com/',
        shortName: 'EUR1',
        chainId: 45011,
        networkId: 45011,
        icon: 'juneo-eur1',
        explorers: [
            {
                name: 'Juneo Scan',
                url: 'https://juneoscan.io/chain/6',
                icon: 'juneomainnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmexytQkcC8yXzEjv3mbaZyxcy7v8vEEPmii2JZQAyGjqM'
    },
    45012: {
        name: 'Juneo SGD1-Chain',
        chain: 'Juneo SGD1-Chain',
        rpc: ['https://rpc.juneo-mainnet.network/ext/bc/SGD1/rpc'],
        faucets: [],
        nativeCurrency: { name: 'SGD1', symbol: 'SGD1', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://juneo.com/',
        shortName: 'SGD1',
        chainId: 45012,
        networkId: 45012,
        icon: 'juneo-sgd1',
        explorers: [
            {
                name: 'Juneo Scan',
                url: 'https://juneoscan.io/chain/7',
                icon: 'juneomainnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmatZHCTvWWvgLJRphDGuCUv49mWLB3VM5gzGY4uRkzZbe'
    },
    45013: {
        name: 'Juneo BCH1-Chain',
        chain: 'Juneo BCH1-Chain',
        rpc: ['https://rpc.juneo-mainnet.network/ext/bc/BCH1/rpc'],
        faucets: [],
        nativeCurrency: { name: 'BCH1', symbol: 'BCH1', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://juneo.com/',
        shortName: 'BCH1',
        chainId: 45013,
        networkId: 45013,
        icon: 'juneo-bch1',
        explorers: [
            {
                name: 'Juneo Scan',
                url: 'https://juneoscan.io/chain/12',
                icon: 'juneomainnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWCg8qEUtUBWvk7UMJZ7kkqg9SMs63k5Np6hfguZ7btob'
    },
    45014: {
        name: 'Juneo LINK1-Chain',
        chain: 'Juneo LINK1-Chain',
        rpc: ['https://rpc.juneo-mainnet.network/ext/bc/LINK1/rpc'],
        faucets: [],
        nativeCurrency: { name: 'LINK1', symbol: 'LINK1', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://juneo.com/',
        shortName: 'LINK1',
        chainId: 45014,
        networkId: 45014,
        icon: 'juneo-link1',
        explorers: [
            {
                name: 'Juneo Scan',
                url: 'https://juneoscan.io/chain/13',
                icon: 'juneomainnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQqicvzrLaPyDzLCm4mJofTbcdH7xKJrnZYF5ptCyAoTE'
    },
    45454: {
        name: 'Swamps L2',
        chain: 'SWP',
        icon: 'swamps',
        rpc: ['https://swamps.tc.l2aas.com'],
        faucets: [],
        nativeCurrency: { name: 'SWP', symbol: 'SWP', decimals: 18 },
        infoURL: 'https://www.swamps.fi',
        shortName: 'SWP',
        chainId: 45454,
        networkId: 45454,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://swamps-explorer.tc.l2aas.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTEEgWsknzdqjLbaAvLHqCCzCtMJZh2d1SqMscxZCXBwA'
    },
    45510: {
        name: 'Deelance Mainnet',
        title: 'Deelance Network Mainnet',
        chain: 'DEE',
        rpc: ['https://rpc.deelance.com'],
        faucets: ['https://faucet.deelance.com'],
        nativeCurrency: { name: 'Deelance', symbol: 'DEE', decimals: 18 },
        infoURL: 'https://deelance.com',
        shortName: 'dee',
        chainId: 45510,
        networkId: 45510,
        icon: 'deelance',
        explorers: [
            {
                name: 'Deelance Mainnet Explorer',
                url: 'https://deescan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmay2j8biuo5xLJL8NcLtrzubAEHuCWz65cdbKE1pSnGf6'
    },
    45513: {
        name: 'Blessnet',
        chain: 'ETH',
        rpc: [
            'https://blessnet.calderachain.xyz/http',
            'wss://blessnet.calderachain.xyz/ws'
        ],
        faucets: [],
        nativeCurrency: { name: 'Bless', symbol: 'BLESS', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://blessnet.io',
        shortName: 'bless',
        chainId: 45513,
        networkId: 45513,
        icon: 'bless',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blessnet.calderaexplorer.xyz',
                icon: 'bless',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-42161',
            bridges: [{ url: 'https://blessnet.bridge.caldera.xyz' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmUP7NPPrCe6N6k8RQh4KuSBU2xMvbyo6enCtzyE5v4bmQ'
    },
    46688: {
        name: 'Fusion Testnet',
        chain: 'FSN',
        icon: 'fusion',
        rpc: ['https://testnet.fusionnetwork.io', 'wss://testnet.fusionnetwork.io'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Testnet Fusion', symbol: 'T-FSN', decimals: 18 },
        infoURL: 'https://fusion.org',
        shortName: 'tfsn',
        chainId: 46688,
        networkId: 46688,
        slip44: 1,
        explorers: [
            {
                name: 'fsnscan',
                url: 'https://testnet.fsnscan.com',
                icon: 'fsnscan',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmX3tsEoj7SdaBLLV8VyyCUAmymdEGiSGeuTbxMrEMVvth'
    },
    47763: {
        name: 'Neo X Mainnet',
        chain: 'Neo X',
        rpc: [
            'https://mainnet-1.rpc.banelabs.org',
            'https://mainnet-2.rpc.banelabs.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Gas', symbol: 'GAS', decimals: 18 },
        infoURL: 'https://neo.org/',
        shortName: 'neox-mainnet',
        chainId: 47763,
        networkId: 47763,
        icon: 'neox',
        explorers: [
            {
                name: 'Neo X - Explorer',
                url: 'https://xexplorer.neo.org',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmR3iCrjrW814fyv79UeVimDT4fTeBQcpYgMYxv1U6W15u'
    },
    47803: {
        name: 'ReDeFi Layer 1',
        chain: 'ReDeFi',
        icon: 'redefi',
        rpc: ['https://layer1.redefi.world'],
        faucets: [],
        nativeCurrency: { name: 'BAX', symbol: 'BAX', decimals: 18 },
        infoURL: 'https://redefi.world',
        shortName: 'bax',
        chainId: 47803,
        networkId: 47803,
        slip44: 47803,
        explorers: [
            {
                name: 'ReDeFi Scan',
                url: 'https://scanlayer1.redefi.world',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQd2MWwDkGsH6JsHPAKXqy8o2kedYMzbnaEHoRpmvSiLW'
    },
    47805: {
        name: 'REI Network',
        chain: 'REI',
        rpc: ['https://rpc.rei.network', 'wss://rpc.rei.network'],
        faucets: [],
        nativeCurrency: { name: 'REI', symbol: 'REI', decimals: 18 },
        infoURL: 'https://rei.network/',
        shortName: 'REI',
        chainId: 47805,
        networkId: 47805,
        explorers: [
            {
                name: 'rei-scan',
                url: 'https://scan.rei.network',
                standard: 'none'
            }
        ]
    },
    48795: {
        name: 'Space Subnet Testnet',
        chain: 'SPACETESTNET',
        rpc: ['https://subnets.avax.network/space/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'FUEL', symbol: 'FUEL', decimals: 18 },
        infoURL: 'https://otherworld.network',
        shortName: 'spacetestnet',
        chainId: 48795,
        networkId: 48795,
        explorers: [
            {
                name: 'SPACE Explorer',
                url: 'https://subnets-test.avax.network/space',
                standard: 'EIP3091'
            }
        ]
    },
    48898: {
        name: 'Zircuit Garfield Testnet',
        chain: 'Zircuit Garfield Testnet',
        icon: 'zircuit',
        rpc: ['https://garfield-testnet.zircuit.com/'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.zircuit.com/',
        shortName: 'zircuit-garfield-testnet',
        chainId: 48898,
        networkId: 48898,
        explorers: [
            {
                name: 'Zircuit',
                url: 'https://explorer.garfield-testnet.zircuit.com',
                icon: 'zircuit',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmV4nUUiRaTTZSyWubpF98ZL9jNCoXkrgg6AWR6FKqdxMk'
    },
    48899: {
        name: 'Zircuit Testnet',
        chain: 'Zircuit Testnet',
        icon: 'zircuit',
        rpc: ['https://testnet.zircuit.com'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.zircuit.com/',
        shortName: 'zircuit-testnet',
        chainId: 48899,
        networkId: 48899,
        explorers: [
            {
                name: 'Zircuit',
                url: 'https://explorer.testnet.zircuit.com',
                icon: 'zircuit',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmV4nUUiRaTTZSyWubpF98ZL9jNCoXkrgg6AWR6FKqdxMk'
    },
    48900: {
        name: 'Zircuit Mainnet',
        chain: 'Zircuit Mainnet',
        icon: 'zircuit',
        rpc: ['https://mainnet.zircuit.com'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.zircuit.com/',
        shortName: 'zircuit-mainnet',
        chainId: 48900,
        networkId: 48900,
        explorers: [
            {
                name: 'Zircuit',
                url: 'https://explorer.zircuit.com',
                icon: 'zircuit',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmV4nUUiRaTTZSyWubpF98ZL9jNCoXkrgg6AWR6FKqdxMk'
    },
    49049: {
        name: 'Wireshape Floripa Testnet',
        title: 'Wireshape Floripa Testnet',
        chain: 'Wireshape',
        icon: 'wireshape',
        rpc: [
            'https://rpc-floripa.wireshape.org',
            'https://wireshape-floripa-testnet.rpc.thirdweb.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'WIRE', symbol: 'WIRE', decimals: 18 },
        infoURL: 'https://wireshape.org',
        shortName: 'floripa',
        chainId: 49049,
        networkId: 49049,
        slip44: 1,
        explorers: [
            {
                name: 'Wire Explorer',
                url: 'https://floripa-explorer.wireshape.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTAyT3YrW2654CBRqRkec2cCznv6EBsbsRc2y6WQPbvXx'
    },
    49088: {
        name: 'Bifrost Testnet',
        title: 'Bifrost Network Testnet',
        chain: 'BFC',
        rpc: [
            'https://public-01.testnet.bifrostnetwork.com/rpc',
            'https://public-02.testnet.bifrostnetwork.com/rpc'
        ],
        faucets: [],
        nativeCurrency: { name: 'Bifrost', symbol: 'BFC', decimals: 18 },
        infoURL: 'https://bifrostnetwork.com',
        shortName: 'tbfc',
        chainId: 49088,
        networkId: 49088,
        slip44: 1,
        icon: 'bifrost',
        explorers: [
            {
                name: 'explorer-thebifrost',
                url: 'https://explorer.testnet.bifrostnetwork.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYxniqbiFD7nXBNjN8boUhoXYEAW23YquArD2Rnkq8WHS'
    },
    49321: {
        name: 'GUNZ Testnet',
        chain: 'tGUN',
        rpc: [
            'https://rpc.gunz.dev/ext/bc/ryk9vkvNuKtewME2PeCgybo9sdWXGmCkBrrx4VPuZPdVdAak8/rpc'
        ],
        faucets: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'GUN', symbol: 'GUN', decimals: 18 },
        icon: 'guntestnet',
        infoURL: 'https://gunbygunz.com',
        shortName: 'Stork',
        chainId: 49321,
        networkId: 49321,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet.gunzscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmd5R5khFePwY9dYBGhjRA1rGtUAKaHg7Z2B7mBrbA6TiB'
    },
    49797: {
        name: 'Energi Testnet',
        chain: 'NRG',
        rpc: ['https://nodeapi.test.energi.network'],
        faucets: [],
        nativeCurrency: { name: 'Energi', symbol: 'NRG', decimals: 18 },
        infoURL: 'https://www.energi.world/',
        shortName: 'tnrg',
        chainId: 49797,
        networkId: 49797,
        slip44: 1
    },
    50000: {
        name: 'Citronus',
        chain: 'Citronus',
        rpc: ['https://rpc.citronus.com'],
        faucets: [],
        nativeCurrency: { name: 'CITRO', symbol: 'CITRO', decimals: 18 },
        infoURL: 'https://citronus.com',
        shortName: 'citro',
        chainId: 50000,
        networkId: 50000,
        icon: 'citro',
        explorers: [
            {
                name: 'citro',
                url: 'https://explorer.citronus.com',
                icon: 'citro',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.gelato.network/bridge/citronus' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2ws'
    },
    50001: {
        name: 'Liveplex OracleEVM',
        chain: 'Liveplex OracleEVM Network',
        rpc: ['https://rpc.oracle.liveplex.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: '',
        shortName: 'LOE',
        chainId: 50001,
        networkId: 50001,
        explorers: []
    },
    50005: {
        name: 'Yooldo Verse Mainnet',
        chain: 'Yooldo Verse',
        icon: 'yooldo_verse',
        rpc: ['https://rpc.yooldo-verse.xyz/'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://yooldo.gg/',
        shortName: 'YVM',
        chainId: 50005,
        networkId: 50005,
        explorers: [
            {
                name: 'Yooldo Verse Explorer',
                url: 'https://explorer.yooldo-verse.xyz',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-248' },
        iconURL: 'https://ipfs.io/ipfs/QmWvfA2usnYp1ktzLcqFS8eTLgdp4ifrxjiify46KyG9NZ'
    },
    50006: {
        name: 'Yooldo Verse Testnet',
        chain: 'Yooldo Verse',
        icon: 'yooldo_verse',
        rpc: ['https://rpc.testnet.yooldo-verse.xyz/'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://yooldo.gg/',
        shortName: 'YVT',
        chainId: 50006,
        networkId: 50006,
        slip44: 1,
        explorers: [
            {
                name: 'Yooldo Verse Explorer',
                url: 'https://explorer.testnet.yooldo-verse.xyz',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-248' },
        iconURL: 'https://ipfs.io/ipfs/QmWvfA2usnYp1ktzLcqFS8eTLgdp4ifrxjiify46KyG9NZ'
    },
    50021: {
        name: 'GTON Testnet',
        chain: 'GTON Testnet',
        rpc: ['https://testnet.gton.network/'],
        faucets: [],
        nativeCurrency: { name: 'GCD', symbol: 'GCD', decimals: 18 },
        infoURL: 'https://gton.capital',
        shortName: 'tgton',
        chainId: 50021,
        networkId: 50021,
        slip44: 1,
        explorers: [
            {
                name: 'GTON Testnet Network Explorer',
                url: 'https://explorer.testnet.gton.network',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-3' }
    },
    50104: {
        name: 'Sophon',
        chain: 'Sophon',
        rpc: ['https://rpc.sophon.xyz', 'wss://rpc.sophon.xyz/ws'],
        nativeCurrency: { name: 'Sophon', symbol: 'SOPH', decimals: 18 },
        faucets: [],
        infoURL: '',
        shortName: 'sophon',
        chainId: 50104,
        networkId: 50104,
        explorers: [
            {
                name: 'Sophon Block Explorer',
                url: 'https://explorer.sophon.xyz',
                icon: 'sophon-testnet',
                standard: 'none'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://portal.sophon.xyz/bridge' }]
        }
    },
    50312: {
        name: 'Somnia Testnet',
        chain: 'Somnia',
        rpc: ['https://dream-rpc.somnia.network'],
        faucets: [],
        nativeCurrency: { name: 'Somnia Testnet', symbol: 'STT', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://somnia.network',
        shortName: 'SomniaTestnet',
        chainId: 50312,
        networkId: 50312,
        explorers: [
            {
                name: 'Somnia Testnet',
                url: 'https://somnia-testnet.socialscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    50341: {
        name: 'Reddio Testnet',
        title: 'Reddio Sepolia L2 Rollup Testnet',
        chain: 'ETH',
        rpc: ['https://reddio-dev.reddio.com'],
        faucets: [],
        nativeCurrency: { name: 'Reddio', symbol: 'RDO', decimals: 18 },
        infoURL: 'https://www.reddio.com',
        shortName: 'reddio-devnet',
        chainId: 50341,
        networkId: 50341,
        slip44: 1,
        explorers: [
            {
                name: 'L2scan',
                url: 'https://reddio-devnet.l2scan.co',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111' }
    },
    50505: {
        name: 'STB Testnet',
        chain: 'STB Testnet',
        rpc: ['https://rpc.quorum.sps.dev.kode.ru/'],
        faucets: [],
        nativeCurrency: { name: 'STB', symbol: 'STB', decimals: 18 },
        infoURL: '',
        shortName: 'stb-testnet',
        chainId: 50505,
        networkId: 50505,
        explorers: [
            {
                name: 'stb-testnet',
                url: 'https://explorer.quorum.sps.dev.kode.ru',
                standard: 'none'
            }
        ]
    },
    50888: {
        name: 'Erbie Mainnet',
        chain: 'Erbie',
        rpc: ['https://api.erbie.io'],
        faucets: [],
        nativeCurrency: { name: 'ERB', symbol: 'ERB', decimals: 18 },
        infoURL: 'https://www.erbie.io',
        shortName: 'Erbie',
        chainId: 50888,
        networkId: 50888,
        icon: 'erbie',
        explorers: [
            {
                name: 'Erbie Explorer',
                url: 'https://www.erbie.io/explorer',
                standard: 'none',
                icon: 'erbie'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfS33Wd4e5pwq4JpNeK3wV1tbPDTakFA6KLxjewHp553z'
    },
    51178: {
        name: 'Lumoz Testnet Alpha',
        chain: 'ETH',
        rpc: [
            'https://alpha-us-http-geth.lumoz.org',
            'https://alpha-hk-http-geth.lumoz.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Lumoz Test Token', symbol: 'MOZ', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://lumoz.org',
        shortName: 'Lumoz-Testnet',
        chainId: 51178,
        networkId: 51178,
        slip44: 1,
        icon: 'opside-new',
        explorers: [
            {
                name: 'LumozTestnetInfo',
                url: 'https://lumoz.info',
                icon: 'opside-new',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZnE2ygPL2ZGuzHGvFCHmrqxwdurrhz3K1yPnwLzKbgay'
    },
    51712: {
        name: 'Sardis Mainnet',
        chain: 'SRDX',
        icon: 'sardis',
        rpc: ['https://mainnet-rpc.sardisnetwork.com'],
        faucets: ['https://faucet.sardisnetwork.com'],
        nativeCurrency: { name: 'Sardis', symbol: 'SRDX', decimals: 18 },
        infoURL: 'https://mysardis.com',
        shortName: 'SRDXm',
        chainId: 51712,
        networkId: 51712,
        explorers: [
            {
                name: 'Sardis',
                url: 'https://contract-mainnet.sardisnetwork.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdR9QJjQEh1mBnf2WbJfehverxiP5RDPWMtEECbDP2rc3'
    },
    52014: {
        name: 'Electroneum Mainnet',
        chain: 'Electroneum',
        rpc: ['https://rpc.electroneum.com', 'https://rpc.ankr.com/electroneum'],
        faucets: [],
        nativeCurrency: { name: 'Electroneum', symbol: 'ETN', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://electroneum.com',
        shortName: 'etn-mainnet',
        chainId: 52014,
        networkId: 52014,
        icon: 'electroneum',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockexplorer.electroneum.com',
                icon: 'electroneum',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVgFqXA3kkCrVYGcWFF7Mhx8JUSe9vSCauNamuKWSvCym'
    },
    52225: {
        name: 'Cytonic Settlement Layer Testnet',
        chain: 'CytonicSL',
        rpc: ['http://rpc.sl.testnet.cytonic.com'],
        faucets: [],
        nativeCurrency: { name: 'Cytonic', symbol: 'CCC', decimals: 18 },
        infoURL: 'https://cytonic.com',
        shortName: 'CSL',
        chainId: 52225,
        networkId: 52225,
        icon: 'cytonic_l1',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.sl.testnet.cytonic.com',
                icon: 'cytonic_l1',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWASoRS8k7YspDLiwz5xfpusBtqHwy5hR5B9NynGx8HGt'
    },
    52226: {
        name: 'Cytonic Ethereum Testnet',
        chain: 'CytonicEVM',
        rpc: ['http://rpc.evm.testnet.cytonic.com'],
        faucets: [],
        nativeCurrency: { name: 'Cytonic', symbol: 'CCC', decimals: 18 },
        infoURL: 'https://cytonic.com',
        shortName: 'CEVM',
        chainId: 52226,
        networkId: 52226,
        icon: 'cytonic_l2',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.evm.testnet.cytonic.com',
                icon: 'cytonic_l2',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-52225' },
        iconURL: 'https://ipfs.io/ipfs/QmUetrmaY5KwmRzjgcoZCfqqTaEYSc57V2EVBjFQwpZrE1'
    },
    53277: {
        name: 'DOID',
        chain: 'DOID',
        rpc: ['https://rpc.doid.tech'],
        faucets: [],
        nativeCurrency: { name: 'DOID', symbol: 'DOID', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://doid.tech',
        shortName: 'DOID',
        chainId: 53277,
        networkId: 53277,
        icon: 'doid',
        explorers: [
            {
                name: 'DOID Scan',
                url: 'https://scan.doid.tech',
                icon: 'doid',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXYSMyMnMvBf2F1ih6dTcRVUhmMnpzvmuP7vieLjmNQo5'
    },
    53302: {
        name: 'Superseed Sepolia Testnet',
        chain: 'ETH',
        rpc: ['https://sepolia.superseed.xyz', 'wss://sepolia.superseed.xyz'],
        faucets: ['https://sepoliafaucet.com'],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.superseed.xyz',
        shortName: 'seedsep',
        chainId: 53302,
        networkId: 53302,
        slip44: 1,
        icon: 'seedTestnet',
        explorers: [
            {
                name: 'seedscout',
                url: 'https://sepolia-explorer.superseed.xyz',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://sepolia-bridge.superseed.xyz/' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmVa1MhJhixPzFfvhggQWg8hLtS77vg7QFvQtQGrXbVYSg'
    },
    53456: {
        name: 'BirdLayer',
        title: 'BirdLayer',
        chain: 'BirdLayer',
        icon: 'birdlayer',
        rpc: [
            'https://rpc.birdlayer.xyz',
            'https://rpc1.birdlayer.xyz',
            'wss://rpc.birdlayer.xyz/ws'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.dodochain.com',
        shortName: 'birdlayer',
        chainId: 53456,
        networkId: 53456,
        explorers: [
            {
                name: 'BirdLayer Explorer',
                url: 'https://scan.birdlayer.xyz',
                icon: 'birdlayer',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQDdZQjpKhrVM62479RTzppUG8QHhHd8Bq4RFYAjN1yf4'
    },
    53457: {
        name: 'DODOchain testnet',
        title: 'DODOchain testnet',
        chain: 'DODOchain',
        icon: 'dodochain_testnet',
        rpc: [
            'https://dodochain-testnet.alt.technology',
            'wss://dodochain-testnet.alt.technology/ws'
        ],
        faucets: [],
        nativeCurrency: { name: 'DODO', symbol: 'DODO', decimals: 18 },
        infoURL: 'https://www.dodochain.com',
        shortName: 'dodochain',
        chainId: 53457,
        networkId: 53457,
        explorers: [
            {
                name: 'DODOchain Testnet (Sepolia) Explorer',
                url: 'https://testnet-scan.dodochain.com',
                icon: 'dodochain_testnet',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQDdZQjpKhrVM62479RTzppUG8QHhHd8Bq4RFYAjN1yf4'
    },
    53935: {
        name: 'DFK Chain',
        chain: 'DFK',
        icon: 'dfk',
        rpc: ['https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Jewel', symbol: 'JEWEL', decimals: 18 },
        infoURL: 'https://defikingdoms.com',
        shortName: 'DFK',
        chainId: 53935,
        networkId: 53935,
        explorers: [
            {
                name: 'ethernal',
                url: 'https://explorer.dfkchain.com',
                icon: 'ethereum',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQB48m15TzhUFrmu56QCRQjkrkgUaKfgCmKE8o3RzmuPJ'
    },
    54170: {
        name: 'Graphite Testnet',
        chain: 'Graphite',
        rpc: [
            'https://anon-entrypoint-test-1.atgraphite.com',
            'wss://ws-anon-entrypoint-test-1.atgraphite.com'
        ],
        faucets: ['https://faucet.atgraphite.com/'],
        nativeCurrency: { name: 'Graphite', symbol: '@G', decimals: 18 },
        infoURL: 'https://atgraphite.com/',
        shortName: 'graphiteTest',
        chainId: 54170,
        networkId: 54170,
        icon: 'graphite',
        explorers: [
            {
                name: 'Graphite Testnet Explorer',
                url: 'https://test.atgraphite.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigzf3eo43njqreysfsnvot3rzdcvj642o4ekjhjla2efyuiy46vmu'
    },
    54176: {
        name: 'OverProtocol Mainnet',
        chain: 'OverProtocol',
        icon: 'overIcon',
        rpc: ['https://rpc.overprotocol.com'],
        faucets: [],
        nativeCurrency: { name: 'Over', symbol: 'OVER', decimals: 18 },
        infoURL: 'https://docs.over.network',
        shortName: 'overprotocol',
        chainId: 54176,
        networkId: 54176,
        explorers: [
            {
                name: 'OverView',
                url: 'https://scan.over.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcxyEjW9G8K9JP6rZGjRmjJuS9BvgMwzL5dKM1nV2aPLs'
    },
    54211: {
        name: 'Haqq Chain Testnet',
        chain: 'TestEdge2',
        rpc: ['https://rpc.eth.testedge2.haqq.network'],
        faucets: ['https://testedge2.haqq.network'],
        nativeCurrency: { name: 'Islamic Coin', symbol: 'ISLMT', decimals: 18 },
        infoURL: 'https://islamiccoin.net',
        shortName: 'ISLMT',
        chainId: 54211,
        networkId: 54211,
        slip44: 1,
        explorers: [
            {
                name: 'TestEdge HAQQ Explorer',
                url: 'https://explorer.testedge2.haqq.network',
                standard: 'EIP3091'
            }
        ]
    },
    54321: {
        name: 'Toronet Testnet',
        chain: 'Toronet',
        icon: 'toronet',
        rpc: ['https://testnet.toronet.org/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Toroe', symbol: 'TOROE', decimals: 18 },
        infoURL: 'https://toronet.org',
        shortName: 'ToronetTestnet',
        chainId: 54321,
        networkId: 54321,
        slip44: 1,
        ens: { registry: '0x059C474f26D65B0458F9da10A649a7322aB02C09' },
        explorers: [
            {
                name: 'toronet_explorer',
                url: 'https://testnet.toronet.org',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmciSvgLatP6jhgdazuiyD3fSrhipfAN7wC943v1qxcrpv'
    },
    55004: {
        name: 'Titan',
        chain: 'ETH',
        rpc: [
            'https://rpc.titan.tokamak.network',
            'wss://rpc.titan.tokamak.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://tokamak.network',
        shortName: 'teth',
        chainId: 55004,
        networkId: 55004,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.titan.tokamak.network',
                standard: 'EIP3091'
            }
        ]
    },
    55007: {
        name: 'Titan Sepolia',
        chain: 'ETH',
        rpc: [
            'https://rpc.titan-sepolia.tokamak.network',
            'wss://rpc.titan-sepolia.tokamak.network/ws'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://tokamak.network',
        shortName: 'titan-sepolia',
        chainId: 55007,
        networkId: 55007,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.titan-sepolia.tokamak.network',
                standard: 'EIP3091'
            }
        ]
    },
    55244: {
        name: 'Superposition',
        chain: 'Superposition',
        rpc: ['https://rpc.superposition.so'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://superposition.so',
        shortName: 'spn',
        chainId: 55244,
        networkId: 55244,
        explorers: [
            {
                name: 'Superposition Explorer',
                url: 'https://explorer.superposition.so',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-42161', bridges: [] }
    },
    55551: {
        name: 'Photon Aurora Testnet',
        chain: 'Photon',
        rpc: ['https://rpc-test2.photonchain.io'],
        faucets: ['https://photonchain.io/testnet2'],
        nativeCurrency: { name: 'Photon', symbol: 'PTON', decimals: 18 },
        infoURL: 'https://photonchain.io',
        shortName: 'pton',
        chainId: 55551,
        networkId: 55551,
        explorers: [
            {
                name: 'photon_testnet2_explorer',
                url: 'https://testnet2.photonchain.io',
                standard: 'none'
            }
        ]
    },
    55555: {
        name: 'REI Chain Mainnet',
        chain: 'REI',
        icon: 'reichain',
        rpc: ['https://rei-rpc.moonrhythm.io'],
        faucets: ['http://kururu.finance/faucet?chainId=55555'],
        nativeCurrency: { name: 'Rei', symbol: 'REI', decimals: 18 },
        infoURL: 'https://reichain.io',
        shortName: 'reichain',
        chainId: 55555,
        networkId: 55555,
        explorers: [
            {
                name: 'reiscan',
                url: 'https://reiscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNy5d5knHVjJJS9g4kLsh9i73RTjckpKL6KZvRk6ptbhf'
    },
    55556: {
        name: 'REI Chain Testnet',
        chain: 'REI',
        icon: 'reichain',
        rpc: ['https://rei-testnet-rpc.moonrhythm.io'],
        faucets: ['http://kururu.finance/faucet?chainId=55556'],
        nativeCurrency: { name: 'tRei', symbol: 'tREI', decimals: 18 },
        infoURL: 'https://reichain.io',
        shortName: 'trei',
        chainId: 55556,
        networkId: 55556,
        slip44: 1,
        explorers: [
            {
                name: 'reiscan',
                url: 'https://testnet.reiscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNy5d5knHVjJJS9g4kLsh9i73RTjckpKL6KZvRk6ptbhf'
    },
    55614: {
        name: 'Flamma Mainnet',
        chain: 'Flamma',
        rpc: ['https://rpc.flamma.network'],
        faucets: [],
        nativeCurrency: { name: 'Flamma', symbol: 'FLA', decimals: 18 },
        infoURL: 'https://flamma.network',
        shortName: 'FlammaMainnet',
        chainId: 55614,
        networkId: 55614,
        explorers: [
            {
                name: 'flascan',
                url: 'https://flascan.net',
                standard: 'EIP3091'
            }
        ]
    },
    56026: {
        name: 'Lambda Chain Mainnet',
        chain: 'Lambda Chain',
        rpc: ['https://nrpc.lambda.im/'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://lambda.im',
        shortName: 'lambda',
        chainId: 56026,
        networkId: 56026,
        slip44: 1,
        icon: 'lambda-chain',
        explorers: [
            {
                name: 'Lambda Chain Mainnet Explorer',
                url: 'https://scan.lambda.im',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXCWjWSTd6kJZKnH9aQRjgLdWRH9NTxU1wC21iBvoB4Hp'
    },
    56288: {
        name: 'Boba BNB Mainnet',
        chain: 'Boba BNB Mainnet',
        rpc: [
            'https://bnb.boba.network',
            'https://boba-bnb.gateway.tenderly.co/',
            'https://gateway.tenderly.co/public/boba-bnb',
            'https://replica.bnb.boba.network',
            'wss://boba-bnb.gateway.tenderly.co/',
            'wss://gateway.tenderly.co/public/boba-bnb'
        ],
        faucets: [],
        nativeCurrency: { name: 'Boba Token', symbol: 'BOBA', decimals: 18 },
        infoURL: 'https://boba.network',
        shortName: 'BobaBnb',
        chainId: 56288,
        networkId: 56288,
        explorers: [
            {
                name: 'Boba BNB block explorer',
                url: 'https://bobascan.com',
                standard: 'none'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-56',
            bridges: [{ url: 'https://gateway.boba.network' }]
        }
    },
    56400: {
        name: 'Testnet Zeroone Subnet',
        chain: 'TESTNETZER',
        rpc: ['https://subnets.avax.network/testnetzer/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'ZERO', symbol: 'ZERO', decimals: 18 },
        infoURL: 'https://zeroone.art/',
        shortName: 'testnetzer',
        chainId: 56400,
        networkId: 56400,
        explorers: [
            {
                name: 'TESTNETZER Explorer',
                url: 'https://subnets-test.avax.network/testnetzer',
                standard: 'EIP3091'
            }
        ]
    },
    56789: {
        name: 'VELO Labs Mainnet',
        chain: 'NOVA chain',
        rpc: ['https://nova.velo.org'],
        faucets: ['https://nova-faucet.velo.org'],
        nativeCurrency: { name: 'Nova', symbol: 'NOVA', decimals: 18 },
        infoURL: 'https://velo.org',
        shortName: 'VELO',
        chainId: 56789,
        networkId: 56789,
        icon: 'novachain',
        explorers: [
            {
                name: 'novascan',
                url: 'https://novascan.velo.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYqvnW2jwPEKUv8BdaV4sbL8Audcwosat6SPn4GqYtKxc'
    },
    56797: {
        name: 'DOID Testnet',
        chain: 'DOID',
        rpc: ['https://rpc.testnet.doid.tech'],
        faucets: [],
        nativeCurrency: { name: 'DOID', symbol: 'DOID', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://doid.tech',
        shortName: 'doidTestnet',
        chainId: 56797,
        networkId: 56797,
        icon: 'doid',
        explorers: [
            {
                name: 'DOID Testnet Scan',
                url: 'https://scan.testnet.doid.tech',
                icon: 'doid',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXYSMyMnMvBf2F1ih6dTcRVUhmMnpzvmuP7vieLjmNQo5'
    },
    57000: {
        name: 'Rollux Testnet',
        chain: 'SYS',
        rpc: [
            'https://rpc-tanenbaum.rollux.com',
            'https://rpc.ankr.com/rollux_testnet/${ANKR_API_KEY}',
            'wss://rpc-tanenbaum.rollux.com/wss',
            'https://rollux.rpc.tanenbaum.io',
            'wss://rollux.rpc.tanenbaum.io/wss'
        ],
        faucets: ['https://rollux.id/faucetapp'],
        nativeCurrency: { name: 'Testnet Syscoin', symbol: 'TSYS', decimals: 18 },
        infoURL: 'https://rollux.com',
        shortName: 'tsys-rollux',
        chainId: 57000,
        networkId: 57000,
        slip44: 1,
        explorers: [
            {
                name: 'Rollux Testnet Explorer',
                url: 'https://rollux.tanenbaum.io',
                standard: 'EIP3091'
            }
        ]
    },
    57054: {
        name: 'Sonic Blaze Testnet',
        chain: 'blaze-testnet',
        rpc: [
            'https://rpc.blaze.soniclabs.com',
            'https://sonic-blaze-rpc.publicnode.com',
            'wss://sonic-blaze-rpc.publicnode.com'
        ],
        faucets: ['https://blaze.soniclabs.com/account'],
        nativeCurrency: { name: 'Sonic', symbol: 'S', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://blaze.soniclabs.com',
        shortName: 'blaze',
        chainId: 57054,
        networkId: 57054,
        icon: 'sonic',
        iconURL: 'https://ipfs.io/ipfs/QmbFqQ87T3HwjF6KejNYYYMcUtc7t64FDbfkpgWchFgMpC'
    },
    57073: {
        name: 'Ink',
        chain: 'ETH',
        rpc: [
            'https://rpc-gel.inkonchain.com',
            'https://rpc-qnd.inkonchain.com',
            'wss://rpc-gel.inkonchain.com',
            'wss://rpc-qnd.inkonchain.com'
        ],
        faucets: ['https://inkonchain.com/faucet'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://inkonchain.com',
        shortName: 'ink',
        chainId: 57073,
        networkId: 57073,
        explorers: [
            {
                name: 'Ink Explorer',
                url: 'https://explorer.inkonchain.com',
                standard: 'EIP3091'
            }
        ],
        status: 'active'
    },
    57451: {
        name: 'COINSEC Network',
        title: 'COINSEC Network',
        chain: 'coinsecnetwork',
        icon: 'coinsec',
        rpc: ['https://mainnet-rpc.coinsec.network'],
        faucets: [],
        nativeCurrency: { name: 'COINSEC', symbol: 'SEC', decimals: 18 },
        infoURL: 'https://explorer.coinsec.network/',
        shortName: 'coinsecnetwork',
        chainId: 57451,
        networkId: 57451,
        explorers: [
            {
                name: 'coinsecnetwork',
                url: 'https://explorer.coinsec.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeUyBe58BPndt6SpH9Tn1a8AYpNtHbMVhVyZt8Ppc4HTB'
    },
    58008: {
        name: 'Sepolia PGN (Public Goods Network)',
        chain: 'ETH',
        rpc: ['https://sepolia.publicgoods.network'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://publicgoods.network/',
        shortName: 'sepPGN',
        chainId: 58008,
        networkId: 58008,
        icon: 'publicGoodsNetwork',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.sepolia.publicgoods.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://pgn-bridge.vercel.app/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmUVJ7MLCEAfq3pHVPFLscqRMiyAY5biVgTkeDQCmAhHNS'
    },
    58680: {
        name: 'Lumoz Quidditch Testnet',
        chain: 'ETH',
        rpc: ['https://quidditch-rpc.lumoz.org'],
        faucets: [],
        nativeCurrency: {
            name: 'Lumoz Quidditch Testnet Token',
            symbol: 'MOZ',
            decimals: 18
        },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://lumoz.org',
        shortName: 'Lumoz-Quidditch-Testnet',
        chainId: 58680,
        networkId: 58680,
        slip44: 1,
        icon: 'opside-new',
        explorers: [
            {
                name: 'LumozQuidditchTestnetInfo',
                url: 'https://quidditch.lumoz.info',
                icon: 'opside-new',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZnE2ygPL2ZGuzHGvFCHmrqxwdurrhz3K1yPnwLzKbgay'
    },
    59140: {
        name: 'Linea Goerli',
        title: 'Linea Goerli Testnet',
        chain: 'ETH',
        rpc: [
            'https://rpc.goerli.linea.build',
            'wss://rpc.goerli.linea.build',
            'https://linea-goerli.infura.io/v3/${INFURA_API_KEY}',
            'wss://linea-goerli.infura.io/ws/v3/${INFURA_API_KEY}'
        ],
        faucets: ['https://faucetlink.to/goerli'],
        nativeCurrency: { name: 'Linea Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://linea.build',
        shortName: 'linea-goerli',
        chainId: 59140,
        networkId: 59140,
        slip44: 1,
        icon: 'linea',
        parent: {
            type: 'L2',
            chain: 'eip155-5',
            bridges: [
                {
                    url: 'https://goerli.hop.exchange/#/send?token=ETH&sourceNetwork=ethereum&destNetwork=linea'
                }
            ]
        },
        explorers: [
            {
                name: 'Etherscan',
                url: 'https://goerli.lineascan.build',
                standard: 'EIP3091',
                icon: 'linea'
            },
            {
                name: 'Blockscout',
                url: 'https://explorer.goerli.linea.build',
                standard: 'EIP3091',
                icon: 'linea'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH'
    },
    59141: {
        name: 'Linea Sepolia',
        title: 'Linea Sepolia Testnet',
        chain: 'ETH',
        rpc: [
            'https://rpc.sepolia.linea.build',
            'wss://rpc.sepolia.linea.build',
            'https://linea-sepolia.infura.io/v3/${INFURA_API_KEY}',
            'wss://linea-sepolia.infura.io/ws/v3/${INFURA_API_KEY}',
            'https://linea-sepolia-rpc.publicnode.com',
            'wss://linea-sepolia-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Linea Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://linea.build',
        shortName: 'linea-sepolia',
        chainId: 59141,
        networkId: 59141,
        slip44: 1,
        icon: 'linea',
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge.linea.build/' }]
        },
        explorers: [
            {
                name: 'Etherscan',
                url: 'https://sepolia.lineascan.build',
                standard: 'EIP3091',
                icon: 'linea'
            },
            {
                name: 'Blockscout',
                url: 'https://explorer.sepolia.linea.build',
                standard: 'EIP3091',
                icon: 'linea'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH'
    },
    59144: {
        name: 'Linea',
        title: 'Linea Mainnet',
        chain: 'ETH',
        rpc: [
            'https://rpc.linea.build',
            'wss://rpc.linea.build',
            'https://linea-mainnet.infura.io/v3/${INFURA_API_KEY}',
            'wss://linea-mainnet.infura.io/ws/v3/${INFURA_API_KEY}',
            'https://linea-rpc.publicnode.com',
            'wss://linea-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Linea Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://linea.build',
        shortName: 'linea',
        chainId: 59144,
        networkId: 59144,
        icon: 'linea',
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.linea.build' }]
        },
        explorers: [
            {
                name: 'Etherscan',
                url: 'https://lineascan.build',
                standard: 'EIP3091',
                icon: 'linea'
            },
            {
                name: 'Blockscout',
                url: 'https://explorer.linea.build',
                standard: 'EIP3091',
                icon: 'linea'
            },
            {
                name: 'L2scan',
                url: 'https://linea.l2scan.co',
                standard: 'EIP3091',
                icon: 'linea'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmURjritnHL7a8TwZgsFwp3f272DJmG5paaPtWDZ98QZwH'
    },
    59902: {
        name: 'Metis Sepolia Testnet',
        chain: 'ETH',
        rpc: [
            'https://sepolia.metisdevops.link',
            'https://metis-sepolia-rpc.publicnode.com',
            'wss://metis-sepolia-rpc.publicnode.com'
        ],
        faucets: ['https://sepolia.faucet.metisdevops.link'],
        nativeCurrency: { name: 'tMetis', symbol: 'tMETIS', decimals: 18 },
        infoURL: 'https://www.metis.io',
        shortName: 'metis-sepolia',
        chainId: 59902,
        networkId: 59902,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://sepolia-explorer.metisdevops.link',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge.metis.io' }]
        }
    },
    59971: {
        name: 'Genesys Code Mainnet',
        chain: 'GCODE',
        rpc: ['https://mainnet.genesyscode.io/'],
        faucets: [],
        nativeCurrency: { name: 'GenesysCode', symbol: 'GCODE', decimals: 18 },
        infoURL: 'https://genesyscode.io',
        shortName: 'gcode',
        chainId: 59971,
        networkId: 59971,
        icon: 'genesyscode',
        explorers: [
            {
                name: 'Genesys Scan',
                url: 'https://genesysscan.io',
                icon: 'genesyscode',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihgmpaceze7rxpajv7yrlx3cb6daqubippkpvgryzairtaubsjjoe'
    },
    60000: {
        name: 'Thinkium Testnet Chain 0',
        chain: 'Thinkium',
        rpc: ['https://test.thinkiumrpc.net/'],
        faucets: ['https://www.thinkiumdev.net/faucet'],
        nativeCurrency: { name: 'TKM', symbol: 'TKM', decimals: 18 },
        infoURL: 'https://thinkium.net/',
        shortName: 'TKM-test0',
        chainId: 60000,
        networkId: 60000,
        slip44: 1,
        explorers: [
            {
                name: 'thinkiumscan',
                url: 'https://test0.thinkiumscan.net',
                standard: 'EIP3091'
            }
        ]
    },
    60001: {
        name: 'Thinkium Testnet Chain 1',
        chain: 'Thinkium',
        rpc: ['https://test1.thinkiumrpc.net/'],
        faucets: ['https://www.thinkiumdev.net/faucet'],
        nativeCurrency: { name: 'TKM', symbol: 'TKM', decimals: 18 },
        infoURL: 'https://thinkium.net/',
        shortName: 'TKM-test1',
        chainId: 60001,
        networkId: 60001,
        slip44: 1,
        explorers: [
            {
                name: 'thinkiumscan',
                url: 'https://test1.thinkiumscan.net',
                standard: 'EIP3091'
            }
        ]
    },
    60002: {
        name: 'Thinkium Testnet Chain 2',
        chain: 'Thinkium',
        rpc: ['https://test2.thinkiumrpc.net/'],
        faucets: ['https://www.thinkiumdev.net/faucet'],
        nativeCurrency: { name: 'TKM', symbol: 'TKM', decimals: 18 },
        infoURL: 'https://thinkium.net/',
        shortName: 'TKM-test2',
        chainId: 60002,
        networkId: 60002,
        slip44: 1,
        explorers: [
            {
                name: 'thinkiumscan',
                url: 'https://test2.thinkiumscan.net',
                standard: 'EIP3091'
            }
        ]
    },
    60103: {
        name: 'Thinkium Testnet Chain 103',
        chain: 'Thinkium',
        rpc: ['https://test103.thinkiumrpc.net/'],
        faucets: ['https://www.thinkiumdev.net/faucet'],
        nativeCurrency: { name: 'TKM', symbol: 'TKM', decimals: 18 },
        infoURL: 'https://thinkium.net/',
        shortName: 'TKM-test103',
        chainId: 60103,
        networkId: 60103,
        slip44: 1,
        explorers: [
            {
                name: 'thinkiumscan',
                url: 'https://test103.thinkiumscan.net',
                standard: 'EIP3091'
            }
        ]
    },
    60808: {
        name: 'BOB',
        chain: 'ETH',
        rpc: [
            'https://rpc.gobob.xyz',
            'wss://rpc.gobob.xyz',
            'https://bob-mainnet.public.blastapi.io',
            'wss://bob-mainnet.public.blastapi.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://gobob.xyz',
        shortName: 'bob',
        chainId: 60808,
        networkId: 60808,
        icon: 'bob',
        explorers: [
            {
                name: 'bobscout',
                url: 'https://explorer.gobob.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://app.gobob.xyz' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmaX5iqQTrJD8TBuvoT97xPMG6LYamjPCPnZUUMh12jc99'
    },
    60850: {
        name: 'Perennial Sepolia',
        chain: 'perennialSepolia',
        rpc: ['https://rpc-sepolia.perennial.foundation'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://perennial.finance',
        shortName: 'perennial-sepolia',
        chainId: 60850,
        networkId: 60850,
        icon: 'perennial',
        explorers: [
            {
                name: 'Perennial Explorer',
                url: 'https://explorer-sepolia.perennial.foundation',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-84532',
            bridges: [{ url: 'https://bridge-sepolia.perennial.foundation' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreidkqdec42orfj4yiufiqvo3n33yxiw75jybg2lewv36raq7qpijua'
    },
    61022: {
        name: 'Orange Chain Mainnet',
        title: 'Orange Chain Mainnet',
        chain: 'Orange Chain',
        rpc: ['https://rpc.orangechain.xyz', 'https://hk-rpc.orangechain.xyz'],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://orangechain.xyz',
        shortName: 'Orange-Chain-Mainnet',
        chainId: 61022,
        networkId: 61022,
        icon: 'orange',
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://scan.orangechain.xyz',
                icon: 'orange',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWcaVLcPYBxi76HYJc4qudLJwXtfNCDJieLHAs632jMEA'
    },
    61166: {
        name: 'Treasure',
        chain: 'Treasure',
        shortName: 'treasure',
        chainId: 61166,
        networkId: 61166,
        nativeCurrency: { name: 'MAGIC', symbol: 'MAGIC', decimals: 18 },
        slip44: 1,
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://app.treasure.lol',
        icon: 'treasure',
        rpc: ['https://rpc.treasure.lol', 'wss://rpc.treasure.lol/ws'],
        faucets: [
            'https://app.treasure.lol/chain/faucet',
            'https://thirdweb.com/treasure'
        ],
        explorers: [
            {
                name: 'Treasure Block Explorer',
                url: 'https://treasurescan.io',
                icon: 'treasure',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://app.treasure.lol/chain/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmQn3dhxoMDY3R2w9PZtJaVXVh9YtJaozcLesu19B7e1KQ'
    },
    61406: {
        name: 'KaiChain',
        chain: 'KaiChain',
        rpc: ['https://mainnet-rpc.kaichain.net'],
        faucets: [],
        nativeCurrency: {
            name: 'KaiChain Native Token',
            symbol: 'KEC',
            decimals: 18
        },
        infoURL: 'https://kaichain.net',
        shortName: 'kec',
        chainId: 61406,
        networkId: 61406,
        explorers: [
            {
                name: 'KaiChain Explorer',
                url: 'https://explorer.kaichain.net',
                standard: 'EIP3091'
            }
        ]
    },
    61800: {
        name: 'AxelChain Dev-Net',
        chain: 'AXEL',
        rpc: ['https://aium-rpc-dev.viacube.com'],
        faucets: [],
        nativeCurrency: { name: 'Axelium', symbol: 'AIUM', decimals: 18 },
        infoURL: 'https://www.axel.org',
        shortName: 'aium-dev',
        chainId: 61800,
        networkId: 61800,
        icon: 'axelium',
        explorers: [
            {
                name: 'AxelChain Dev-Net Explorer',
                url: 'https://devexplorer2.viacube.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNx8FRacfNeawhkjk5p57EKzDHkLGMaBBmK2VRL5CB2P2'
    },
    61803: {
        name: 'Etica Mainnet',
        chain: 'Etica Protocol (ETI/EGAZ)',
        icon: 'etica',
        rpc: [
            'https://eticamainnet.eticascan.org',
            'https://eticamainnet.eticaprotocol.org'
        ],
        faucets: ['http://faucet.etica-stats.org/'],
        nativeCurrency: { name: 'EGAZ', symbol: 'EGAZ', decimals: 18 },
        infoURL: 'https://eticaprotocol.org',
        shortName: 'Etica',
        chainId: 61803,
        networkId: 61803,
        explorers: [
            {
                name: 'eticascan',
                url: 'https://eticascan.org',
                standard: 'EIP3091'
            },
            {
                name: 'eticastats',
                url: 'http://explorer.etica-stats.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYSyhUqm6ArWyALBe3G64823ZpEUmFdkzKZ93hUUhNKgU'
    },
    61916: {
        name: 'DoKEN Super Chain Mainnet',
        chain: 'DoKEN Super Chain',
        rpc: [
            'https://sgrpc.doken.dev',
            'https://nyrpc.doken.dev',
            'https://ukrpc.doken.dev'
        ],
        faucets: [],
        nativeCurrency: { name: 'DoKEN', symbol: 'DKN', decimals: 18 },
        infoURL: 'https://doken.dev/',
        shortName: 'DoKEN',
        chainId: 61916,
        networkId: 61916,
        icon: 'doken',
        explorers: [
            {
                name: 'DSC Scan',
                url: 'https://explore.doken.dev',
                icon: 'doken',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifms4eio6v56oyeemnnu5luq3sc44hptan225lr45itgzu3u372iu'
    },
    62049: {
        name: 'OPTOPIA Testnet',
        chain: 'ETH',
        rpc: ['https://rpc-testnet.optopia.ai'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP1559' }],
        infoURL: 'https://optopia.ai',
        shortName: 'OPTOPIA-Testnet',
        chainId: 62049,
        networkId: 62049,
        icon: 'optopia',
        explorers: [
            {
                name: 'optopia-testnet-scan',
                url: 'https://scan-testnet.optopia.ai',
                icon: 'optopia',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge-testnet.optopia.ai' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreid3xv3zkuo2cygwt7vwm5c2aqjbyhy5qxn7xkc66ajhu2mjh2ybki'
    },
    62050: {
        name: 'Optopia Mainnet',
        chain: 'ETH',
        rpc: ['https://rpc-mainnet.optopia.ai', 'https://rpc-mainnet-2.optopia.ai'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP1559' }],
        infoURL: 'https://optopia.ai',
        shortName: 'Optopia',
        chainId: 62050,
        networkId: 62050,
        icon: 'optopia',
        explorers: [
            {
                name: 'optopia-scan',
                url: 'https://scan.optopia.ai',
                icon: 'optopia',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.optopia.ai' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreid3xv3zkuo2cygwt7vwm5c2aqjbyhy5qxn7xkc66ajhu2mjh2ybki'
    },
    62092: {
        name: 'TikTrix Testnet',
        chain: 'tTTX',
        icon: 'tiktrix',
        rpc: ['https://tiktrix-rpc.xyz'],
        faucets: [],
        nativeCurrency: { name: 'tTTX', symbol: 'tTTX', decimals: 18 },
        infoURL: 'https://tiktrix.gg',
        shortName: 'tiktrix-testnet',
        chainId: 62092,
        networkId: 62092,
        slip44: 1,
        explorers: [
            {
                name: 'TikTrix Testnet Explorer',
                url: 'https://tiktrix.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQW8DuuyxjdLWAPq3V9zSfdAimaStptZ4gxZ3aEviAafc'
    },
    62298: {
        name: 'Citrea Devnet',
        chain: 'Citrea',
        rpc: ['https://rpc.devnet.citrea.xyz'],
        faucets: ['https://citrea.xyz/bridge'],
        nativeCurrency: { name: 'Citrea BTC', symbol: 'cBTC', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://citrea.xyz',
        shortName: 'citrea-devnet',
        chainId: 62298,
        networkId: 62298,
        icon: 'citrea',
        explorers: [
            {
                name: 'Citrea Devnet Explorer',
                url: 'https://explorer.devnet.citrea.xyz',
                icon: 'citrea',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTfgH4X7ZWkHprKgjUZ7SDcCGtS5f2CBuaTEtQYMsydmJ'
    },
    62320: {
        name: 'Celo Baklava Testnet',
        chainId: 62320,
        shortName: 'BKLV',
        chain: 'CELO',
        networkId: 62320,
        slip44: 1,
        nativeCurrency: { name: 'CELO', symbol: 'CELO', decimals: 18 },
        rpc: ['https://baklava-forno.celo-testnet.org'],
        faucets: [
            'https://docs.google.com/forms/d/e/1FAIpQLSdfr1BwUTYepVmmvfVUDRCwALejZ-TUva2YujNpvrEmPAX2pg/viewform',
            'https://cauldron.pretoriaresearchlab.io/baklava-faucet'
        ],
        infoURL: 'https://docs.celo.org/'
    },
    62621: {
        name: 'MultiVAC Mainnet',
        chain: 'MultiVAC',
        icon: 'multivac',
        rpc: ['https://rpc.mtv.ac', 'https://rpc-eu.mtv.ac'],
        faucets: [],
        nativeCurrency: { name: 'MultiVAC', symbol: 'MTV', decimals: 18 },
        infoURL: 'https://mtv.ac',
        shortName: 'mtv',
        chainId: 62621,
        networkId: 62621,
        explorers: [
            {
                name: 'MultiVAC Explorer',
                url: 'https://e.mtv.ac',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWb1gthhbzkiLdgcP8ccZprGbJVjFcW8Rn4uJjrw4jd3B'
    },
    62831: {
        name: 'PLYR TAU Testnet',
        chain: 'PLYR',
        icon: 'plyr',
        rpc: ['https://subnets.avax.network/plyr/testnet/rpc'],
        faucets: ['https://faucet.avax.network/?subnet=plyr'],
        nativeCurrency: { name: 'PLYR', symbol: 'PLYR', decimals: 18 },
        infoURL: 'https://plyr.network',
        shortName: 'plyr-tau-testnet',
        chainId: 62831,
        networkId: 62831,
        slip44: 1,
        explorers: [
            {
                name: 'PLYR TAU Explorer',
                url: 'https://explorer-testnet.plyr.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVhG7xeTc78ibQunQ5sBJ4533r9FDM2xUCQKV72DPd1ux'
    },
    62850: {
        name: 'LAOS Sigma Testnet',
        title: 'LAOS Sigma Testnet',
        chain: 'LAOS Sigma Testnet',
        rpc: [
            'https://rpc.laossigma.laosfoundation.io',
            'wss://rpc.laossigma.laosfoundation.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'SIGMA', symbol: 'SIGMA', decimals: 18 },
        infoURL: 'https://laosnetwork.io',
        shortName: 'laossigma',
        chainId: 62850,
        networkId: 62850,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://sigma.explorer.laosnetwork.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    63000: {
        name: 'eSync Network Mainnet',
        title: 'eSync Network Mainnet',
        chain: 'ECS',
        rpc: ['https://rpc.esync.network', 'https://rpc.ecredits.com'],
        faucets: [],
        nativeCurrency: { name: 'eCredits', symbol: 'ECS', decimals: 18 },
        infoURL: 'https://esync.network',
        shortName: 'esync-mainnet',
        chainId: 63000,
        networkId: 63000,
        icon: 'esync',
        explorers: [
            {
                name: 'eSync Network Mainnet Explorer',
                url: 'https://explorer.esync.network',
                icon: 'esync',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVo6h7hQcduywA4j5n5vzB75y2PiVaSN4HuNwgB5XiBsj'
    },
    63001: {
        name: 'eCredits Testnet',
        chain: 'ECS',
        rpc: [],
        faucets: ['https://faucet.tst.ecredits.com'],
        nativeCurrency: { name: 'eCredits', symbol: 'ECS', decimals: 18 },
        infoURL: 'https://ecredits.com',
        shortName: 'ecs-testnet-old',
        chainId: 63001,
        networkId: 63001,
        slip44: 1,
        icon: 'ecredits',
        explorers: [
            {
                name: 'eCredits TestNet Explorer',
                url: 'https://explorer.tst.ecredits.com',
                icon: 'ecredits',
                standard: 'EIP3091'
            }
        ],
        status: 'deprecated',
        iconURL: 'https://ipfs.io/ipfs/QmU9H9JE1KtLh2Fxrd8EWTMjKGJBpgRWKUeEx7u6ic4kBY'
    },
    63002: {
        name: 'eSync Network Testnet',
        title: 'eSync Network Testnet',
        chain: 'ECS',
        rpc: ['https://rpc.tst.esync.network'],
        faucets: ['https://faucet.tst.ecredits.com'],
        nativeCurrency: { name: 'eCredits', symbol: 'ECS', decimals: 18 },
        infoURL: 'https://esync.network',
        shortName: 'esync-testnet',
        chainId: 63002,
        networkId: 63002,
        slip44: 1,
        icon: 'esync',
        explorers: [
            {
                name: 'eSync Network Testnet Explorer',
                url: 'https://explorer.tst.esync.network',
                icon: 'esync',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVo6h7hQcduywA4j5n5vzB75y2PiVaSN4HuNwgB5XiBsj'
    },
    63157: {
        name: 'Geist Mainnet',
        chain: 'Geist',
        rpc: ['https://geist-mainnet.g.alchemy.com/public'],
        faucets: [],
        nativeCurrency: {
            name: 'Aavegotchi GHST Token',
            symbol: 'GHST',
            decimals: 18
        },
        features: [],
        infoURL: 'https://playongeist.com',
        shortName: 'geist',
        chainId: 63157,
        networkId: 63157,
        status: 'active',
        icon: 'geist',
        explorers: [
            {
                name: 'Geist Explorer',
                url: 'https://geist-mainnet.explorer.alchemy.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNih9epd2WkWTCWD9nwXyUzpaBcPALJH66Fjq1YywpcA8'
    },
    64002: {
        name: 'XCHAIN Testnet',
        chain: 'XCHAIN',
        rpc: ['https://xchain-testnet-rpc.kuma.bid'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://kuma.bid',
        shortName: 'xct',
        chainId: 64002,
        networkId: 64002,
        explorers: [
            {
                name: 'XCHAIN Testnet Explorer',
                url: 'https://xchain-testnet-explorer.kuma.bid',
                standard: 'EIP3091'
            }
        ]
    },
    65349: {
        name: 'CratD2C Testnet',
        chain: 'CRATD2C',
        rpc: [
            'https://cratd2c-testnet-node1.cratd2csmartchain.io/',
            'https://cratd2c-testnet-node2.cratd2csmartchain.io/'
        ],
        faucets: [],
        nativeCurrency: { name: 'CRATD2C', symbol: 'CRAT', decimals: 18 },
        infoURL: 'https://cratd2csmartchain.io',
        shortName: 'cratd2c-testnet',
        chainId: 65349,
        networkId: 65349,
        icon: 'cratd2c-testnet',
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer-testnet.cratd2csmartchain.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiczmtj47hwgmmtsy3xylhswu4q6rphpt42hznv37shjiaxsx3uqde'
    },
    65357: {
        name: 'Vecno Mainnet',
        chain: 'VE',
        rpc: ['https://rpc.vecno.org'],
        faucets: [],
        nativeCurrency: { name: 'Vecno', symbol: 'VE', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://vecno.org',
        shortName: 've',
        chainId: 65357,
        networkId: 65357,
        icon: 'vecno',
        explorers: [
            {
                name: 'vecno',
                url: 'https://explorer.vecno.org',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXPmM55AvkpEmqCvfP9YNQV1xsRdsPZDzwp6QHVThw6Wv'
    },
    65450: {
        name: 'Scolcoin Mainnet',
        chain: 'SCOLWEI',
        rpc: ['https://mainnet-rpc.scolcoin.com'],
        faucets: [],
        nativeCurrency: { name: 'Scolcoin', symbol: 'SCOL', decimals: 18 },
        infoURL: 'https://scolcoin.com',
        shortName: 'SRC',
        chainId: 65450,
        networkId: 65450,
        icon: 'scolcoin',
        explorers: [
            {
                name: 'Scolscan Explorer',
                url: 'https://explorer.scolcoin.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVES1eqDXhP8SdeCpM85wvjmhrQDXGRquQebDrSdvJqpt'
    },
    65535: {
        name: 'CyberChain Mainnet',
        chain: 'XCC',
        icon: 'cyberchain',
        rpc: ['https://rpc.cyberchain.xyz/'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'XCC', symbol: 'XCC', decimals: 18 },
        infoURL: 'https://cyberchain.xyz',
        shortName: 'xcc',
        chainId: 65535,
        networkId: 65535,
        slip44: 60,
        explorers: [
            {
                name: 'CyberChain explorer',
                url: 'https://scan.cyberchain.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUtbe2mpDGxqvQZxgad9VMMeAS4aSTmqfn7Px5GMJvbpD'
    },
    65536: {
        name: 'Automata Mainnet',
        chain: 'Automata Mainnet',
        rpc: [
            'https://rpc.ata.network',
            'https://automata-mainnet.alt.technology/'
        ],
        faucets: [],
        nativeCurrency: { name: 'ATA', symbol: 'ATA', decimals: 18 },
        infoURL: 'https://ata.network',
        shortName: 'automatamainnet',
        chainId: 65536,
        networkId: 65536,
        icon: 'automata',
        explorers: [
            {
                name: 'Automata Explorer',
                url: 'https://explorer.ata.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW7ugm31MRdhjGtimzWMK5N4g5L84tSyKMpZQYk6N9KvJ'
    },
    66665: {
        name: 'Creator Chain Testnet',
        chain: 'creatorchain',
        icon: 'creatorchain',
        rpc: ['https://rpc.creatorchain.io'],
        faucets: [],
        nativeCurrency: { name: 'CreatorETH', symbol: 'CETH', decimals: 18 },
        infoURL: 'https://docs.creatorchain.io/',
        shortName: 'ceth',
        chainId: 66665,
        networkId: 66665,
        explorers: [
            {
                name: 'creatorchainscan',
                url: 'https://explorer.creatorchain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmarU6J1FyXddaRkrWagEXN39TXUTNdVcuDTfHFKvvs3D4'
    },
    66988: {
        name: 'Janus Testnet',
        chain: 'JanusNetwork',
        icon: 'janusnetwork',
        rpc: ['https://rpc.test.janusnetwork.io'],
        faucets: [],
        nativeCurrency: { name: 'Janus', symbol: 'JNS', decimals: 18 },
        infoURL: 'https://janus-network.gitbook.io/janus',
        shortName: 'janusnetwork-testnet',
        chainId: 66988,
        networkId: 66988,
        slip44: 1,
        status: 'active',
        explorers: [
            {
                name: 'JanusNetwork Testnet Explorer',
                url: 'https://beta.scan.janusnetwork.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifc3vnwf4hj3bo6fg4u5qlqmjgajjgezyeg236qjcihl4ha42siuq'
    },
    67390: {
        name: 'SiriusNet',
        chain: 'SIN',
        status: 'deprecated',
        rpc: [
            'https://u0tnafcv6j:o2T045sxuCNXL878RDQLp5__Zj-es2cvdjtgkl4etn0@u0v7kwtvtg-u0wj114sve-rpc.us0-aws.kaleido.io/'
        ],
        faucets: [],
        nativeCurrency: { name: 'MCD', symbol: 'MCD', decimals: 18 },
        infoURL: 'https://macaucasinolisboa.xyz',
        shortName: 'mcl',
        chainId: 67390,
        networkId: 67390,
        explorers: [
            {
                name: 'siriusnetscan',
                url: 'https://siriusnet.tryethernal.com',
                standard: 'EIP3091'
            }
        ]
    },
    67588: {
        name: 'Cosmic Chain',
        chain: 'COSMIC',
        rpc: ['http://testnet.cosmicchain.site:3344'],
        faucets: [],
        nativeCurrency: { name: 'Cosmic Chain', symbol: 'COSMIC', decimals: 18 },
        infoURL: 'https://cosmicchain.site',
        shortName: 'Cosmic',
        chainId: 67588,
        networkId: 3344
    },
    68770: {
        name: 'DM2 Verse Mainnet',
        chain: 'DM2 Verse',
        icon: 'dm2verse',
        rpc: ['https://rpc.dm2verse.dmm.com'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://seamoon.dmm.com',
        shortName: 'dm2',
        chainId: 68770,
        networkId: 68770,
        explorers: [
            {
                name: 'DM2Verse Explorer',
                url: 'https://explorer.dm2verse.dmm.com',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-248' },
        iconURL: 'https://ipfs.io/ipfs/QmPMqjf5XKZ4Cxa1u8qc8Zj9mmVLBoqK7N5h2zFr3Rsyzw'
    },
    68775: {
        name: 'DM2 Verse Testnet',
        chain: 'DM2 Verse',
        icon: 'dm2verse',
        rpc: ['https://rpc.testnet.dm2verse.dmm.com'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://seamoon.dmm.com',
        shortName: 'dm2t',
        chainId: 68775,
        networkId: 68775,
        explorers: [
            {
                name: 'DM2Verse Testnet Explorer',
                url: 'https://explorer.testnet.dm2verse.dmm.com',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-248' },
        iconURL: 'https://ipfs.io/ipfs/QmPMqjf5XKZ4Cxa1u8qc8Zj9mmVLBoqK7N5h2zFr3Rsyzw'
    },
    69000: {
        name: 'Animechain Mainnet',
        chain: 'ETH',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Animecoin', symbol: 'ANIME', decimals: 18 },
        infoURL: 'https://www.anime.xyz',
        shortName: 'anime',
        chainId: 69000,
        networkId: 69000,
        explorers: [
            {
                name: 'Animechain explorer',
                url: 'https://explorer.anime.xyz',
                standard: 'EIP3091'
            }
        ]
    },
    69420: {
        name: 'Condrieu',
        title: 'Ethereum Verkle Testnet Condrieu',
        chain: 'ETH',
        rpc: ['https://rpc.condrieu.ethdevops.io:8545'],
        faucets: ['https://faucet.condrieu.ethdevops.io'],
        nativeCurrency: {
            name: 'Condrieu Testnet Ether',
            symbol: 'CTE',
            decimals: 18
        },
        infoURL: 'https://condrieu.ethdevops.io',
        shortName: 'cndr',
        chainId: 69420,
        networkId: 69420,
        slip44: 1,
        explorers: [
            {
                name: 'Condrieu explorer',
                url: 'https://explorer.condrieu.ethdevops.io',
                standard: 'none'
            }
        ]
    },
    70000: {
        name: 'Thinkium Mainnet Chain 0',
        chain: 'Thinkium',
        rpc: ['https://proxy.thinkiumrpc.net/'],
        faucets: [],
        nativeCurrency: { name: 'TKM', symbol: 'TKM', decimals: 18 },
        infoURL: 'https://thinkium.net/',
        shortName: 'TKM0',
        chainId: 70000,
        networkId: 70000,
        explorers: [
            {
                name: 'thinkiumscan',
                url: 'https://chain0.thinkiumscan.net',
                standard: 'EIP3091'
            }
        ]
    },
    70001: {
        name: 'Thinkium Mainnet Chain 1',
        chain: 'Thinkium',
        rpc: ['https://proxy1.thinkiumrpc.net/'],
        faucets: [],
        nativeCurrency: { name: 'TKM', symbol: 'TKM', decimals: 18 },
        infoURL: 'https://thinkium.net/',
        shortName: 'TKM1',
        chainId: 70001,
        networkId: 70001,
        explorers: [
            {
                name: 'thinkiumscan',
                url: 'https://chain1.thinkiumscan.net',
                standard: 'EIP3091'
            }
        ]
    },
    70002: {
        name: 'Thinkium Mainnet Chain 2',
        chain: 'Thinkium',
        rpc: ['https://proxy2.thinkiumrpc.net/'],
        faucets: [],
        nativeCurrency: { name: 'TKM', symbol: 'TKM', decimals: 18 },
        infoURL: 'https://thinkium.net/',
        shortName: 'TKM2',
        chainId: 70002,
        networkId: 70002,
        explorers: [
            {
                name: 'thinkiumscan',
                url: 'https://chain2.thinkiumscan.net',
                standard: 'EIP3091'
            }
        ]
    },
    70103: {
        name: 'Thinkium Mainnet Chain 103',
        chain: 'Thinkium',
        rpc: ['https://proxy103.thinkiumrpc.net/'],
        faucets: [],
        nativeCurrency: { name: 'TKM', symbol: 'TKM', decimals: 18 },
        infoURL: 'https://thinkium.net/',
        shortName: 'TKM103',
        chainId: 70103,
        networkId: 70103,
        explorers: [
            {
                name: 'thinkiumscan',
                url: 'https://chain103.thinkiumscan.net',
                standard: 'EIP3091'
            }
        ]
    },
    70700: {
        name: 'Proof of Play - Apex',
        chainId: 70700,
        shortName: 'pop-apex',
        chain: 'ETH',
        networkId: 70700,
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        rpc: ['https://rpc.apex.proofofplay.com'],
        faucets: [],
        explorers: [
            {
                name: 'Proof of Play Apex Explorer',
                url: 'https://explorer.apex.proofofplay.com',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://proofofplay.com',
        parent: {
            type: 'L2',
            chain: 'eip155-42161',
            bridges: [
                { url: 'https://bridge.arbitrum.io' },
                { url: 'https://relay.link/bridge/apex/' }
            ]
        }
    },
    70701: {
        name: 'Proof of Play - Boss',
        chainId: 70701,
        shortName: 'pop-boss',
        chain: 'ETH',
        networkId: 70701,
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        rpc: ['https://rpc.boss.proofofplay.com'],
        faucets: [],
        explorers: [
            {
                name: 'Proof of Play Boss Explorer',
                url: 'https://explorer.boss.proofofplay.com',
                icon: 'pop-boss',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://proofofplay.com',
        icon: 'pop-boss',
        parent: {
            type: 'L2',
            chain: 'eip155-42161',
            bridges: [
                { url: 'https://bridge.arbitrum.io' },
                { url: 'https://relay.link/bridge/boss/' }
            ]
        },
        iconURL: 'https://ipfs.io/ipfs/QmW3NPDe6WRqucrWbe8pg3GqSMPi8V6Qa1fAiaQuqjxSJC'
    },
    71111: {
        name: 'GuapcoinX',
        chain: 'GuapcoinX',
        rpc: [
            'https://rpc-mainnet.guapcoinx.com/',
            'https://rpc-mainnet-1.guapcoinx.com/',
            'https://rpc-mainnet-2.guapcoinx.com/'
        ],
        faucets: [],
        nativeCurrency: { name: 'GuapcoinX', symbol: 'GuapX', decimals: 18 },
        infoURL: 'https://guapcoin.org/',
        shortName: 'GuapX',
        chainId: 71111,
        networkId: 71111,
        icon: 'guapcoinx',
        explorers: [
            {
                name: 'GuapcoinX Explorer',
                url: 'http://explorer.guapcoinx.com',
                standard: 'none',
                icon: 'guapcoinx'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcDTR7982VQKDDz2Mh4fZbnE9hn67MuFPWQv1MimCqPvB'
    },
    71117: {
        name: 'Wadzchain Testnet',
        title: 'Wadzchain Testnet',
        chain: 'Wadzchain-Testnet',
        icon: 'wadz',
        rpc: ['https://rpc-testnet.wadzchain.io'],
        faucets: ['https://faucet-testnet.wadzchain.io'],
        nativeCurrency: { name: 'WadzChain Coin', symbol: 'WCO', decimals: 18 },
        infoURL: 'https://www.wadzchain-network.io',
        shortName: 'wadzchain-testnet',
        chainId: 71117,
        networkId: 71117,
        slip44: 1,
        explorers: [
            {
                name: 'Wadzchain Testnet Explorer',
                url: 'https://scan-testnet.wadzchain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRBVFviqdhyarkTAxrnq2r2em6dJXCzpNxZL4yaXPbLou'
    },
    71393: {
        name: 'Polyjuice Testnet',
        chain: 'CKB',
        icon: 'polyjuice',
        rpc: [
            'https://godwoken-testnet-web3-rpc.ckbapp.dev',
            'ws://godwoken-testnet-web3-rpc.ckbapp.dev/ws'
        ],
        faucets: ['https://faucet.nervos.org/'],
        nativeCurrency: { name: 'CKB', symbol: 'CKB', decimals: 8 },
        infoURL: 'https://github.com/nervosnetwork/godwoken',
        shortName: 'ckb',
        chainId: 71393,
        networkId: 1,
        slip44: 1,
        iconURL: 'https://ipfs.io/ipfs/QmZ5gFWUxLFqqT3DkefYfRsVksMwMTc5VvBjkbHpeFMsNe'
    },
    71401: {
        name: 'Godwoken Testnet v1',
        chain: 'GWT',
        rpc: [
            'https://godwoken-testnet-v1.ckbapp.dev',
            'https://v1.testnet.godwoken.io/rpc'
        ],
        faucets: ['https://testnet.bridge.godwoken.io'],
        nativeCurrency: { name: 'pCKB', symbol: 'pCKB', decimals: 18 },
        infoURL: 'https://www.nervos.org',
        shortName: 'gw-testnet-v1',
        chainId: 71401,
        networkId: 71401,
        slip44: 1,
        explorers: [
            {
                name: 'GWScan Block Explorer',
                url: 'https://v1.testnet.gwscan.com',
                standard: 'none'
            }
        ]
    },
    71402: {
        name: 'Godwoken Mainnet',
        chain: 'GWT',
        rpc: ['https://v1.mainnet.godwoken.io/rpc'],
        faucets: [],
        nativeCurrency: { name: 'pCKB', symbol: 'pCKB', decimals: 18 },
        infoURL: 'https://www.nervos.org',
        shortName: 'gw-mainnet-v1',
        chainId: 71402,
        networkId: 71402,
        explorers: [
            {
                name: 'GWScan Block Explorer',
                url: 'https://v1.gwscan.com',
                standard: 'none'
            }
        ]
    },
    72080: {
        name: 'Nexera Testnet',
        chain: 'Nexera',
        chainId: 72080,
        networkId: 72080,
        infoURL: 'https://testnet.nexera.network',
        shortName: 'nxra-testnet',
        rpc: ['https://rpc.testnet.nexera.network'],
        faucets: ['https://faucet.nexera.network'],
        nativeCurrency: { name: 'tNXRA', symbol: 'tNXRA', decimals: 18 },
        explorers: []
    },
    72778: {
        name: 'CAGA crypto Ankara testnet',
        chain: 'Ankara',
        rpc: [
            'https://www.ankara-cagacrypto.com',
            'wss://wss.ankara-cagacrypto.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Caga', symbol: 'CAGA', decimals: 18 },
        infoURL: 'https://www.cagacrypto.com/',
        shortName: 'caga',
        chainId: 72778,
        networkId: 72778,
        icon: 'ankaracaga',
        explorers: [
            {
                name: 'ankara',
                url: 'https://explorer.ankara-cagacrypto.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmeiop9gSdzU4NNJ6GCuPk6AeYwD9pbhEFVfRdk4dXs3kJ'
    },
    72888: {
        name: 'CAGA mainnet',
        chain: 'CAGA',
        rpc: ['https://cagamainnet.com', 'wss://cagamainnet.com/ws'],
        faucets: [],
        nativeCurrency: { name: 'CAGA', symbol: 'CAGA', decimals: 18 },
        infoURL: 'https://www.cagacrypto.com/',
        shortName: 'caga-mainnet',
        chainId: 72888,
        networkId: 72888,
        icon: 'caga',
        explorers: [
            {
                name: 'caga',
                url: 'https://explorer.cagamainnet.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmeiop9gSdzU4NNJ6GCuPk6AeYwD9pbhEFVfRdk4dXs3kJ'
    },
    72992: {
        name: 'Grok Chain Mainnet',
        chain: 'Grok',
        icon: 'grokicon',
        rpc: ['https://mainnet-rpc.grokchain.dev'],
        faucets: [],
        nativeCurrency: { name: 'Groc', symbol: 'GROC', decimals: 18 },
        infoURL: 'https://grokchain.dev',
        shortName: 'GrokChain',
        chainId: 72992,
        networkId: 72992,
        explorers: [
            {
                name: 'GrokScan',
                url: 'https://mainnet-explorer.grokchain.dev',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreicepw6yqtmubtpcthecjx47ndwgywartfqnkdhf66k3q57h2hlewm'
    },
    73114: {
        name: 'ICB Testnet',
        chain: 'ICBT',
        icon: 'icbnetwork',
        rpc: [
            'https://rpc1-testnet.icbnetwork.info/',
            'https://rpc2-testnet.icbnetwork.info/'
        ],
        faucets: [],
        nativeCurrency: { name: 'ICB Testnet Token', symbol: 'ICBT', decimals: 18 },
        infoURL: 'https://icb.network',
        shortName: 'ICBT',
        chainId: 73114,
        networkId: 73114,
        explorers: [
            {
                name: 'ICB Tesnet Explorer',
                url: 'https://testnet.icbscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifgpv7tnai42hsdegnpwzbvq5iymgub357e553cotitirwy2ir7je'
    },
    73115: {
        name: 'ICB Network',
        chain: 'ICB',
        icon: 'icbnetwork',
        rpc: [
            'https://rpc1-mainnet.icbnetwork.info/',
            'https://rpc2-mainnet.icbnetwork.info/'
        ],
        faucets: [],
        nativeCurrency: { name: 'ICB Native Token', symbol: 'ICBX', decimals: 18 },
        infoURL: 'https://icb.network',
        shortName: 'ICBX',
        chainId: 73115,
        networkId: 73115,
        explorers: [
            {
                name: 'ICB Explorer',
                url: 'https://icbscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifgpv7tnai42hsdegnpwzbvq5iymgub357e553cotitirwy2ir7je'
    },
    73799: {
        name: 'Energy Web Volta Testnet',
        chain: 'Volta',
        rpc: [
            'https://volta-rpc.energyweb.org',
            'wss://volta-rpc.energyweb.org/ws'
        ],
        faucets: ['https://voltafaucet.energyweb.org'],
        nativeCurrency: { name: 'Volta Token', symbol: 'VT', decimals: 18 },
        infoURL: 'https://energyweb.org',
        shortName: 'vt',
        chainId: 73799,
        networkId: 73799,
        slip44: 1
    },
    73927: {
        name: 'Mixin Virtual Machine',
        chain: 'MVM',
        rpc: ['https://geth.mvm.dev'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://mvm.dev',
        shortName: 'mvm',
        chainId: 73927,
        networkId: 73927,
        icon: 'mvm',
        explorers: [
            {
                name: 'mvmscan',
                url: 'https://scan.mvm.dev',
                icon: 'mvm',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeuDgSprukzfV7fi9XYHYcfmT4aZZZU7idgShtRS8Vf6V'
    },
    75000: {
        name: 'ResinCoin Mainnet',
        chain: 'RESIN',
        icon: 'resincoin',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'RESIN', decimals: 18 },
        infoURL: 'https://resincoin.dev',
        shortName: 'resin',
        chainId: 75000,
        networkId: 75000,
        explorers: [
            {
                name: 'ResinScan',
                url: 'https://explorer.resincoin.dev',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTBszPzBeWPhjozf4TxpL2ws1NkG9yJvisx9h6MFii1zb'
    },
    75338: {
        name: 'AppLayer Testnet',
        chain: 'AppLayer',
        rpc: ['https://testnet-api.applayer.com'],
        faucets: ['https://testnet-faucet.applayer.com'],
        nativeCurrency: { name: 'AppLayer', symbol: 'APPL', decimals: 18 },
        features: [{ name: 'EIP55' }, { name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://applayer.com',
        shortName: 'applayer-testnet',
        chainId: 75338,
        networkId: 75338,
        explorers: [
            {
                name: 'Applayer Testnet Explorer',
                url: 'https://testnet-explorer.applayer.com',
                standard: 'EIP3091'
            }
        ]
    },
    75512: {
        name: 'GEEK Verse Mainnet',
        chain: 'GEEK',
        rpc: ['https://rpc.geekout-pte.com'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://www.geekout-pte.com',
        shortName: 'GEEK',
        chainId: 75512,
        networkId: 75512,
        explorers: [
            {
                name: 'Geek Explorer',
                url: 'https://explorer.geekout-pte.com',
                standard: 'EIP3091'
            }
        ]
    },
    75513: {
        name: 'GEEK Verse Testnet',
        chain: 'GEEK Test',
        rpc: ['https://rpc-testnet.geekout-pte.com'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://www.geekout-pte.com',
        shortName: 'GEEK_Test',
        chainId: 75513,
        networkId: 75513,
        explorers: [
            {
                name: 'Geek Testnet Explorer',
                url: 'https://explorer-testnet.geekout-pte.com',
                standard: 'EIP3091'
            }
        ]
    },
    77001: {
        name: 'BORAchain mainnet',
        chain: 'BORA',
        icon: 'bora',
        rpc: [
            'https://public-node.api.boraportal.com/bora/mainnet',
            'https://public-node.api.boraportal.io/bora/mainnet'
        ],
        faucets: [],
        nativeCurrency: { name: 'BORA', symbol: 'BORA', decimals: 18 },
        infoURL: 'https://www.boraportal.com',
        shortName: 'BORAchain',
        chainId: 77001,
        networkId: 77001,
        slip44: 8217,
        explorers: [
            {
                name: 'BORAchainscope',
                url: 'https://scope.boraportal.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmccGWJcCzQh3rP6ZMdRyTc7JjtusKnXkoUtGUANQgjNqR'
    },
    77238: {
        name: 'Foundry Chain Testnet',
        chain: 'tFNC',
        icon: 'fnc',
        rpc: ['https://testnet-rpc.foundryscan.org/'],
        faucets: ['https://faucet.foundryscan.org'],
        nativeCurrency: {
            name: 'Foundry Chain Testnet',
            symbol: 'tFNC',
            decimals: 18
        },
        infoURL: 'https://foundrychain.org',
        shortName: 'fnc',
        chainId: 77238,
        networkId: 77238,
        slip44: 1,
        explorers: [
            {
                name: 'Foundry Scan Testnet',
                url: 'https://testnet-explorer.foundryscan.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifx4vef7ubqz4iiaxckcvkdwjrp2hbliljwjlwu2vytlngg3r4pg4'
    },
    77612: {
        name: 'Vention Smart Chain Mainnet',
        chain: 'VSC',
        icon: 'vention',
        rpc: ['https://mainnet-rpc.vention.network'],
        faucets: ['https://faucet.vention.network'],
        nativeCurrency: { name: 'VNT', symbol: 'VNT', decimals: 18 },
        infoURL: 'https://ventionscan.io',
        shortName: 'vscm',
        chainId: 77612,
        networkId: 77612,
        explorers: [
            {
                name: 'ventionscan',
                url: 'https://ventionscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcNepHmbmHW1BZYM3MFqJW4awwhmDqhUPRXXmRnXwg1U4'
    },
    77652: {
        name: 'Carrchain Testnet',
        chain: 'Carrchain Testnet',
        rpc: ['https://rpc-testnetcarrchain.artiffine.com'],
        faucets: ['https://faucet-testnetcarrchain.artiffine.com'],
        nativeCurrency: { name: 'Carrchain Coin', symbol: 'CARR', decimals: 18 },
        infoURL: 'https://explorer-testnetcarrchain.artiffine.com',
        shortName: 'Carrchain-Testnet',
        chainId: 77652,
        networkId: 77652,
        explorers: [
            {
                name: 'tracehawk',
                url: 'https://explorer-testnetcarrchain.artiffine.com',
                standard: 'none'
            }
        ]
    },
    77677: {
        name: 'Cycle Network Mainnet Sailboat',
        chain: 'ETH',
        rpc: ['https://sailboat-rpc-mainnet.cyclenetwork.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.cyclenetwork.io/',
        shortName: 'cycles',
        chainId: 77677,
        networkId: 77677,
        icon: 'cycle',
        iconURL: 'https://ipfs.io/ipfs/QmeC4mKGbBpwmLfFxUSsareWkSWJomevUmex8ajjxo1zHx'
    },
    77777: {
        name: 'Toronet Mainnet',
        chain: 'Toronet',
        icon: 'toronet',
        rpc: ['https://www.toronet.org/rpc2/'],
        faucets: [],
        nativeCurrency: { name: 'Toroe', symbol: 'TOROE', decimals: 18 },
        infoURL: 'https://toronet.org',
        shortName: 'Toronet',
        chainId: 77777,
        networkId: 77777,
        ens: { registry: '0x1f45a71f4aAD769E27c969c4359E0e250C67165c' },
        explorers: [
            {
                name: 'toronet_explorer',
                url: 'https://toronet.org/explorer',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmciSvgLatP6jhgdazuiyD3fSrhipfAN7wC943v1qxcrpv'
    },
    78110: {
        name: 'Firenze test network',
        chain: 'ETH',
        rpc: ['https://ethnode.primusmoney.com/firenze'],
        faucets: [],
        nativeCurrency: { name: 'Firenze Ether', symbol: 'FIN', decimals: 18 },
        infoURL: 'https://primusmoney.com',
        shortName: 'firenze',
        chainId: 78110,
        networkId: 78110,
        slip44: 1
    },
    78281: {
        name: 'Dragonfly Mainnet (Hexapod)',
        chain: 'Dragonfly',
        icon: 'dragonfly',
        rpc: [
            'https://dragonfly-rpc.switch.ch',
            'https://dragonfly-rpc.kore-technologies.ch',
            'https://dragonfly-rpc.phoenix-systems.io',
            'https://dragonfly-rpc.block-spirit.ch'
        ],
        faucets: [],
        nativeCurrency: { name: 'Dragonfly', symbol: 'DFLY', decimals: 18 },
        infoURL: 'https://hexapod.network',
        shortName: 'dfly',
        chainId: 78281,
        networkId: 78281,
        explorers: [
            {
                name: 'Dragonfly Blockscout',
                url: 'https://blockscout.dragonfly.hexapod.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPXhdPGufjcPzZ9Y6nY6QyW8MgA6793L88iPMRh1Q3gjJ'
    },
    78430: {
        name: 'Amplify Subnet',
        chain: 'AMPLIFY',
        rpc: ['https://subnets.avax.network/amplify/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'AMP', symbol: 'AMP', decimals: 18 },
        infoURL: 'https://www.avax.network',
        shortName: 'amplify',
        chainId: 78430,
        networkId: 78430,
        slip44: 1,
        explorers: [
            {
                name: 'AMPLIFY Explorer',
                url: 'https://subnets-test.avax.network/amplify',
                standard: 'EIP3091'
            }
        ]
    },
    78431: {
        name: 'Bulletin Subnet',
        chain: 'BULLETIN',
        rpc: ['https://subnets.avax.network/bulletin/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'BLT', symbol: 'BLT', decimals: 18 },
        infoURL: 'https://www.avax.network',
        shortName: 'bulletin',
        chainId: 78431,
        networkId: 78431,
        slip44: 1,
        explorers: [
            {
                name: 'BULLETIN Explorer',
                url: 'https://subnets-test.avax.network/bulletin',
                standard: 'EIP3091'
            }
        ]
    },
    78432: {
        name: 'Conduit Subnet',
        chain: 'CONDUIT',
        rpc: ['https://subnets.avax.network/conduit/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'CON', symbol: 'CON', decimals: 18 },
        infoURL: 'https://www.avax.network',
        shortName: 'conduit',
        chainId: 78432,
        networkId: 78432,
        slip44: 1,
        explorers: [
            {
                name: 'CONDUIT Explorer',
                url: 'https://subnets-test.avax.network/conduit',
                standard: 'EIP3091'
            }
        ]
    },
    78600: {
        name: 'Vanguard',
        title: 'Vanar Testnet Vanguard',
        chain: 'VANAR',
        rpc: [
            'https://rpc-vanguard.vanarchain.com',
            'wss://ws-vanguard.vanarchain.com'
        ],
        faucets: ['https://faucet.vanarchain.com'],
        nativeCurrency: { name: 'Vanguard Vanry', symbol: 'VANRY', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://vanarchain.com',
        shortName: 'vanguard',
        chainId: 78600,
        networkId: 78600,
        icon: 'vanguard',
        explorers: [
            {
                name: 'Vanguard Explorer',
                url: 'https://explorer-vanguard.vanarchain.com',
                icon: 'vanguard',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeERjnmdZ6v1tfCyfKfy2Rzh1vPCsU7x2sLJcLqQ6E3Fd'
    },
    79879: {
        name: 'Gold Smart Chain Testnet',
        chain: 'STAND',
        icon: 'standTestnet',
        rpc: ['https://rpc-testnet.goldsmartchain.com'],
        faucets: ['https://faucet.goldsmartchain.com'],
        nativeCurrency: { name: 'Standard in Gold', symbol: 'STAND', decimals: 18 },
        infoURL: 'https://goldsmartchain.com',
        shortName: 'STANDt',
        chainId: 79879,
        networkId: 79879,
        slip44: 1,
        explorers: [
            {
                name: 'Gold Smart Chain',
                url: 'https://testnet.goldsmartchain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPNuymyaKLJhCaXnyrsL8358FeTxabZFsaxMmWNU4Tzt3'
    },
    80001: {
        name: 'Mumbai',
        title: 'Polygon Testnet Mumbai',
        chain: 'Polygon',
        icon: 'polygon',
        rpc: [
            'https://rpc-mumbai.maticvigil.com',
            'https://polygon-mumbai-bor-rpc.publicnode.com',
            'wss://polygon-mumbai-bor-rpc.publicnode.com',
            'https://polygon-mumbai.gateway.tenderly.co',
            'wss://polygon-mumbai.gateway.tenderly.co'
        ],
        faucets: ['https://faucet.polygon.technology/'],
        nativeCurrency: { name: 'MATIC', symbol: 'MATIC', decimals: 18 },
        infoURL: 'https://polygon.technology/',
        shortName: 'maticmum',
        chainId: 80001,
        networkId: 80001,
        slip44: 1,
        explorers: [
            {
                name: 'polygonscan',
                url: 'https://mumbai.polygonscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRNqgazYuxUa5WdddFPftTWiP3KwzBMgV9Z19QWnLMETc'
    },
    80002: {
        name: 'Amoy',
        title: 'Polygon Amoy Testnet',
        chain: 'Polygon',
        icon: 'polygon',
        rpc: [
            'https://rpc-amoy.polygon.technology',
            'https://polygon-amoy-bor-rpc.publicnode.com',
            'wss://polygon-amoy-bor-rpc.publicnode.com'
        ],
        faucets: ['https://faucet.polygon.technology/'],
        nativeCurrency: { name: 'POL', symbol: 'POL', decimals: 18 },
        infoURL: 'https://polygon.technology/',
        shortName: 'polygonamoy',
        chainId: 80002,
        networkId: 80002,
        slip44: 1,
        explorers: [
            {
                name: 'polygonscan-amoy',
                url: 'https://amoy.polygonscan.com',
                standard: 'EIP3091'
            },
            {
                name: 'polygonamoy',
                url: 'https://www.oklink.com/amoy',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRNqgazYuxUa5WdddFPftTWiP3KwzBMgV9Z19QWnLMETc'
    },
    80008: {
        name: 'Polynomia Sepolia',
        chain: 'polynomialSepolia',
        rpc: ['https://rpc.sepolia.polynomial.fi'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://polynomial.fi',
        shortName: 'polynomialSepolia',
        chainId: 80008,
        networkId: 80008,
        icon: 'polynomialSepolia',
        explorers: [
            {
                name: 'Polynomial Sepolia Explorer',
                url: 'https://sepolia.polynomialscan.io',
                standard: 'none',
                icon: 'polynomialSepolia'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeidr3h4onsdhjojrck7tqysrmnduzhgzdhf3l5uqake6w6474vvuha'
    },
    80069: {
        name: 'Berachain Bepolia',
        chain: 'Berachain',
        rpc: ['https://bepolia.rpc.berachain.com'],
        faucets: [],
        nativeCurrency: {
            name: 'Testnet BERA Token',
            symbol: 'BERA',
            decimals: 18
        },
        infoURL: 'https://www.berachain.com',
        shortName: 'berachain-bepolia',
        chainId: 80069,
        networkId: 80069,
        icon: 'berachain',
        explorers: [
            {
                name: 'Beratrail',
                url: 'https://bepolia.beratrail.io',
                icon: 'berachain',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeidicict7kohdlu42btleliya2l4nxknhj45iwdk2pjzamfjwzrhpa'
    },
    80084: {
        name: 'Berachain bArtio',
        chain: 'Berachain bArtio',
        status: 'deprecated',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'BERA Token', symbol: 'BERA', decimals: 18 },
        infoURL: 'https://www.berachain.com',
        shortName: 'berachainbArtio',
        chainId: 80084,
        networkId: 80084,
        icon: 'berachain',
        explorers: [
            {
                name: 'Beratrail',
                url: 'https://bartio.beratrail.io',
                icon: 'berachain',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeidicict7kohdlu42btleliya2l4nxknhj45iwdk2pjzamfjwzrhpa'
    },
    80085: {
        name: 'Berachain Artio',
        chain: 'Berachain Artio',
        status: 'deprecated',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'BERA Token', symbol: 'BERA', decimals: 18 },
        infoURL: 'https://www.berachain.com',
        shortName: 'berachainArtio',
        chainId: 80085,
        networkId: 80085,
        icon: 'berachain',
        explorers: [
            {
                name: 'Beratrail',
                url: 'https://artio.beratrail.io',
                icon: 'berachain',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeidicict7kohdlu42btleliya2l4nxknhj45iwdk2pjzamfjwzrhpa'
    },
    80094: {
        name: 'Berachain',
        chain: 'Berachain',
        rpc: [
            'https://rpc.berachain.com',
            'https://berachain-rpc.publicnode.com',
            'wss://berachain-rpc.publicnode.com',
            'https://rpc.berachain-apis.com',
            'wss://rpc.berachain-apis.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'BERA Token', symbol: 'BERA', decimals: 18 },
        infoURL: 'https://www.berachain.com',
        shortName: 'berachain',
        chainId: 80094,
        networkId: 80094,
        icon: 'berachain',
        explorers: [
            {
                name: 'Berascan',
                url: 'https://berascan.com',
                standard: 'EIP3091'
            },
            {
                name: 'Beratrail',
                url: 'https://beratrail.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeidicict7kohdlu42btleliya2l4nxknhj45iwdk2pjzamfjwzrhpa'
    },
    80096: {
        name: 'Hizoco mainnet',
        chain: 'HZC',
        icon: 'hizoco',
        rpc: ['https://hizoco.net/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Hizoco', symbol: 'HZC', decimals: 18 },
        infoURL: 'http://hizoco.net',
        shortName: 'hzc',
        chainId: 80096,
        networkId: 80096,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://hizoco.net:38443',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNWGj94URMQNyGZbGuAareEL4UpHjTwYWFEFBcX9utBZX'
    },
    80451: {
        name: 'Geo Genesis',
        chain: 'Geo Genesis',
        rpc: ['https://rpc-geo-genesis-h0q2s21xx8.t.conduit.xyz/'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        infoURL: 'https://geobrowser.io',
        nativeCurrency: { name: 'The Graph', symbol: 'GRT', decimals: 18 },
        shortName: 'geo',
        chainId: 80451,
        networkId: 80451,
        explorers: [],
        parent: { type: 'L2', chain: 'eip155-42161' }
    },
    80931: {
        name: 'Forta Chain',
        chain: 'Forta Chain',
        rpc: ['https://rpc-forta-chain-8gj1qndmfc.t.conduit.xyz'],
        faucets: [],
        nativeCurrency: { name: 'FORT', symbol: 'FORT', decimals: 18 },
        infoURL: 'https://www.forta.org/',
        shortName: 'forta',
        chainId: 80931,
        networkId: 80931,
        icon: 'forta-chain',
        explorers: [
            {
                name: 'Forta Chain Explorer',
                url: 'https://explorer.forta.org',
                icon: 'forta-chain',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmd3KFA5oJbPHCe7rdKdzYBiBPoN8QWxCvU9yqteV3fDCQ'
    },
    81041: {
        name: 'Nordek Mainnet',
        chain: 'Nordek',
        icon: 'nordek',
        rpc: ['https://mainnet-rpc.nordekscan.com'],
        faucets: [],
        nativeCurrency: { name: 'NRK', symbol: 'NRK', decimals: 18 },
        infoURL: 'https://nordekscan.com',
        shortName: 'nordek',
        chainId: 81041,
        networkId: 81041,
        explorers: [
            {
                name: 'nordek',
                url: 'https://nordekscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreie45fcr2hllmej2elwqpdxmiaycxmz25tl5ymraduhtefqndhlm4q'
    },
    81341: {
        name: 'Amana Testnet',
        chain: 'MEER',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Amana Testnet', symbol: 'MEER-T', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'amanatest',
        icon: 'meer',
        chainId: 81341,
        networkId: 81341,
        slip44: 1,
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    81342: {
        name: 'Amana Mixnet',
        chain: 'MEER',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Amana Mixnet', symbol: 'MEER-M', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'amanamix',
        icon: 'meer',
        chainId: 81342,
        networkId: 81342,
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    81343: {
        name: 'Amana Privnet',
        chain: 'MEER',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Amana Privnet', symbol: 'MEER-P', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'amanapriv',
        icon: 'meer',
        chainId: 81343,
        networkId: 81343,
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    81351: {
        name: 'Flana Testnet',
        chain: 'MEER',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Flana Testnet', symbol: 'MEER-T', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'flanatest',
        icon: 'meer',
        chainId: 81351,
        networkId: 81351,
        slip44: 1,
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    81352: {
        name: 'Flana Mixnet',
        chain: 'MEER',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Flana Mixnet', symbol: 'MEER-M', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'flanamix',
        icon: 'meer',
        chainId: 81352,
        networkId: 81352,
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    81353: {
        name: 'Flana Privnet',
        chain: 'MEER',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Flana Privnet', symbol: 'MEER-P', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'flanapriv',
        icon: 'meer',
        chainId: 81353,
        networkId: 81353,
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    81361: {
        name: 'Mizana Testnet',
        chain: 'MEER',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Mizana Testnet', symbol: 'MEER-T', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'mizanatest',
        icon: 'meer',
        chainId: 81361,
        networkId: 81361,
        slip44: 1,
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    81362: {
        name: 'Mizana Mixnet',
        chain: 'MEER',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Mizana Mixnet', symbol: 'MEER-M', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'mizanamix',
        icon: 'meer',
        chainId: 81362,
        networkId: 81362,
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    81363: {
        name: 'Mizana Privnet',
        chain: 'MEER',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Mizana Privnet', symbol: 'MEER-P', decimals: 18 },
        infoURL: 'https://github.com/Qitmeer',
        shortName: 'mizanapriv',
        icon: 'meer',
        chainId: 81363,
        networkId: 81363,
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmWSbMuCwQzhBB6GRLYqZ87n5cnpzpYCehCAMMQmUXj4mm'
    },
    81457: {
        name: 'Blast',
        status: 'active',
        chain: 'ETH',
        rpc: [
            'https://rpc.blast.io',
            'https://rpc.ankr.com/blast',
            'https://blast.din.dev/rpc',
            'https://blastl2-mainnet.public.blastapi.io',
            'https://blast.blockpi.network/v1/rpc/public',
            'https://blast-rpc.publicnode.com',
            'wss://blast-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://blast.io/',
        shortName: 'blastmainnet',
        chainId: 81457,
        networkId: 81457,
        icon: 'blast',
        explorers: [
            {
                name: 'Blastscan',
                url: 'https://blastscan.io',
                icon: 'blast',
                standard: 'EIP3091'
            },
            {
                name: 'Blast Explorer',
                url: 'https://blastexplorer.io',
                icon: 'blast',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-1' },
        iconURL: 'https://ipfs.io/ipfs/bafybeifc2h3x7jgy4x4nmg2m54ghbvmkfu6oweujambwefzqzew5vujhsi'
    },
    81720: {
        name: 'Quantum Chain Mainnet',
        chain: 'QNET',
        icon: 'qnet',
        rpc: ['https://rpc.quantumscan.org'],
        faucets: [],
        nativeCurrency: { name: 'Quantum Chain', symbol: 'QNET', decimals: 18 },
        infoURL: 'https://quantumnetwork.gg',
        shortName: 'qnet',
        chainId: 81720,
        networkId: 81720,
        explorers: [
            {
                name: 'Quantum Scan Mainnet',
                url: 'https://quantumscan.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibwywok67uewqbtqdzgr7nlk3lvvg7hxmbgwtn7kdwxe34useucvm'
    },
    82459: {
        name: 'Smart Layer Network Testnet',
        chain: 'SLN',
        rpc: ['https://rpc.test.smartlayer.network'],
        faucets: [],
        nativeCurrency: { name: 'Service Unit Token', symbol: 'SU', decimals: 18 },
        infoURL: 'https://www.smartlayer.network/',
        shortName: 'tSLN',
        chainId: 82459,
        networkId: 82459,
        explorers: [
            {
                name: 'SLN Testnet Explorer',
                url: 'https://explorer.test.smartlayer.network',
                standard: 'EIP3091'
            }
        ]
    },
    82614: {
        name: 'VEMP Horizon',
        chain: 'vemp-horizon',
        rpc: ['https://vemp-horizon.calderachain.xyz/http'],
        faucets: [],
        nativeCurrency: { name: 'VEMP', symbol: 'VEMP', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.vemp.xyz/',
        shortName: 'vemp-horizon',
        chainId: 82614,
        networkId: 82614,
        icon: 'vemp-horizon',
        explorers: [
            {
                name: 'VEMP Horizon Caldera Explorer',
                url: 'https://vemp-horizon.calderaexplorer.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreif4le6thwalvtcpcwav53bwl4c6iltkzem3amf7zd4kogk4mblr4y'
    },
    83144: {
        name: 'Xprotocol Testnet',
        chainId: 83144,
        shortName: 'xprotocoltestnet',
        chain: 'Xprotocol Testnet',
        networkId: 83144,
        nativeCurrency: {
            name: 'KICK Testnet Token',
            symbol: 'KICK',
            decimals: 18
        },
        rpc: ['https://rpc.testnet.xprotocol.org'],
        faucets: ['https://xprotocol.org/faucets'],
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.testnet.xprotocol.org',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-84532' },
        infoURL: 'https://xprotocol.org/'
    },
    83278: {
        name: 'Esa',
        chain: 'Esa',
        rpc: ['http://65.108.151.70:8545'],
        faucets: [],
        nativeCurrency: { name: 'Esa', symbol: 'Esa', decimals: 18 },
        infoURL: 'https://esculap.us',
        shortName: 'Esa',
        chainId: 83278,
        networkId: 83278,
        icon: 'EsaCoins',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmRZ1LHedFNs3pXhxcjhbQtHLmMzDhioKJ6ZsRwHNpbtiF'
    },
    83868: {
        name: 'Xprotocol Sepolia',
        chainId: 83868,
        shortName: 'xprotocolsepolia',
        chain: 'Xprotocol Sepolia',
        networkId: 83868,
        nativeCurrency: {
            name: 'KICK Testnet Token',
            symbol: 'KICK',
            decimals: 18
        },
        rpc: [],
        faucets: [],
        explorers: [],
        status: 'incubating',
        parent: { type: 'L2', chain: 'eip155-84532' },
        infoURL: 'https://xprotocol.org/'
    },
    83872: {
        name: 'ZEDXION',
        chain: 'ZEDXION',
        icon: 'zedx',
        rpc: ['https://mainnet-rpc.zedscan.net'],
        faucets: [],
        nativeCurrency: { name: 'Zedxion', symbol: 'ZEDX', decimals: 9 },
        infoURL: 'https://docs.zedscan.net',
        shortName: 'ZEDX',
        chainId: 83872,
        networkId: 83872,
        explorers: [
            { name: 'Zedscan', url: 'http://zedscan.net', standard: 'EIP3091' }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZ5DXJVxuMRvKzKstFte3TahJ4LSDsGd8DWTrYEPbSjTu'
    },
    84531: {
        name: 'Base Goerli Testnet',
        chain: 'ETH',
        rpc: [
            'https://goerli.base.org',
            'https://base-goerli.gateway.tenderly.co',
            'wss://base-goerli.gateway.tenderly.co',
            'https://base-goerli-rpc.publicnode.com',
            'wss://base-goerli-rpc.publicnode.com'
        ],
        faucets: ['https://www.coinbase.com/faucets/base-ethereum-goerli-faucet'],
        nativeCurrency: { name: 'Goerli Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://base.org',
        shortName: 'basegor',
        chainId: 84531,
        networkId: 84531,
        slip44: 1,
        icon: 'baseTestnet',
        explorers: [
            {
                name: 'basescan',
                url: 'https://goerli.basescan.org',
                standard: 'none'
            },
            {
                name: 'basescout',
                url: 'https://base-goerli.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            },
            {
                name: 'dexguru',
                url: 'https://base-goerli.dex.guru',
                icon: 'dexguru',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaxRoHpxZd8PqccAynherrMznMufG6sdmHZLihkECXmZv'
    },
    84532: {
        name: 'Base Sepolia Testnet',
        chain: 'ETH',
        rpc: [
            'https://sepolia.base.org',
            'https://base-sepolia-rpc.publicnode.com',
            'wss://base-sepolia-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://base.org',
        shortName: 'basesep',
        chainId: 84532,
        networkId: 84532,
        slip44: 1,
        icon: 'baseTestnet',
        explorers: [
            {
                name: 'basescan-sepolia',
                url: 'https://sepolia.basescan.org',
                standard: 'EIP3091'
            },
            {
                name: 'basescout',
                url: 'https://base-sepolia.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaxRoHpxZd8PqccAynherrMznMufG6sdmHZLihkECXmZv'
    },
    84841: {
        name: 'O Chain',
        chain: 'O',
        rpc: [
            'https://rpc.o.xyz',
            'https://84841.rpc.thirdweb.com',
            'wss://rpc.o.xyz'
        ],
        faucets: [],
        nativeCurrency: { name: 'O.XYZ', symbol: 'O', decimals: 18 },
        infoURL: 'https://o.xyz',
        shortName: 'O',
        chainId: 84841,
        networkId: 84841,
        slip44: 1,
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [
                { url: 'https://bridge.o.xyz' },
                { url: 'https://superbridge.o.xyz' }
            ]
        },
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.o.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    84886: {
        name: 'Aerie Network',
        chain: 'Aerie',
        rpc: ['https://mainnet.aerielab.io'],
        faucets: [],
        nativeCurrency: { name: 'Aerie', symbol: 'AER', decimals: 18 },
        infoURL: 'https://aerielab.io/',
        shortName: 'Aerie',
        chainId: 84886,
        networkId: 84886,
        icon: 'aerie',
        explorers: [
            {
                name: 'Aerie Explorer',
                url: 'https://explorer.aerielab.io',
                icon: 'aerie',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreig54jss26xllpjbclmfgwvot72m4ku7qxignhlqei6mijvwi2m4pu'
    },
    85321: {
        name: 'GDPR Testnet',
        chain: 'GDPR',
        rpc: ['https://rpc.testnet.gdprchain.com'],
        faucets: [],
        nativeCurrency: { name: 'GDPR', symbol: 'GDPR', decimals: 18 },
        infoURL: 'https://explorer.testnet.gdprchain.com',
        shortName: 'gdpr-testnet',
        chainId: 85321,
        networkId: 85321,
        explorers: [
            {
                name: 'GDPR Testnet Explorer (Blockscout)',
                url: 'https://explorer.testnet.gdprchain.com',
                standard: 'EIP3091'
            }
        ]
    },
    85449: {
        name: 'CYBERTRUST',
        chain: 'CYBER',
        rpc: ['http://testnet.cybertrust.space:48501'],
        faucets: [],
        nativeCurrency: { name: 'Cyber Trust', symbol: 'CYBER', decimals: 18 },
        infoURL: 'https://cybertrust.space',
        shortName: 'Cyber',
        chainId: 85449,
        networkId: 48501
    },
    88002: {
        name: 'Nautilus Proteus Testnet',
        chain: 'ETH',
        icon: 'nautilus',
        rpc: ['https://api.proteus.nautchain.xyz/solana'],
        faucets: ['https://proteusfaucet.nautchain.xyz'],
        nativeCurrency: { name: 'Zebec Test Token', symbol: 'tZBC', decimals: 18 },
        infoURL: 'https://docs.nautchain.xyz',
        shortName: 'NAUTTest',
        chainId: 88002,
        networkId: 88002,
        slip44: 1,
        explorers: [
            {
                name: 'Nautscan',
                url: 'https://proteus.nautscan.com',
                standard: 'EIP3091',
                icon: 'nautilus'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNutSgM7n6aJPPDiofe9Dm1epy1RcYTMvugukLUK2vmPM'
    },
    88559: {
        name: 'InoAi',
        chain: 'INOAI',
        faucets: [],
        rpc: ['https://inoai-network.com'],
        nativeCurrency: { name: 'InoAi', symbol: 'INO', decimals: 18 },
        infoURL: 'https://docs.inoai.info/',
        shortName: 'INO',
        chainId: 88559,
        networkId: 88559,
        icon: 'inoai',
        explorers: [
            {
                name: 'inoai.live',
                url: 'https://inoai.live',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdiEBREiSP9TBHqxV8Ap3kehvBktBWFCpXs3mkC4e18zM'
    },
    88800: {
        name: 'ZKasino Mainnet',
        chain: 'ZKasino',
        rpc: ['https://rpc.zkas.zeeve.net'],
        faucets: [],
        nativeCurrency: { name: 'ZKAS', symbol: 'ZKAS', decimals: 18 },
        infoURL: '',
        shortName: 'ZKasino',
        chainId: 88800,
        networkId: 88800,
        explorers: [
            {
                name: 'Tracehawk',
                url: 'https://explorer.zkas.zeeve.net',
                standard: 'none'
            }
        ]
    },
    88811: {
        name: 'Unit Zero Mainnet',
        chain: 'Unit Zero',
        icon: 'unitzero',
        rpc: ['https://rpc.unit0.dev'],
        faucets: [],
        nativeCurrency: { name: 'UNIT0', symbol: 'UNIT0', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://units.network',
        shortName: 'unit0-mainnet',
        chainId: 88811,
        networkId: 88811,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmRb2rWanyBTKS5KyrmrbXPNy9zovpxfLRxz9FPPiuRgfg'
    },
    88817: {
        name: 'Unit Zero Testnet',
        chain: 'Unit Zero',
        icon: 'unitzero',
        rpc: ['https://rpc-testnet.unit0.dev'],
        faucets: ['https://faucet-testnet.unit0.dev'],
        nativeCurrency: { name: 'UNIT0', symbol: 'UNIT0', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://units.network',
        shortName: 'unit0-testnet',
        chainId: 88817,
        networkId: 88817,
        explorers: [
            {
                name: 'explorer-testnet',
                url: 'https://explorer-testnet.unit0.dev',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRb2rWanyBTKS5KyrmrbXPNy9zovpxfLRxz9FPPiuRgfg'
    },
    88819: {
        name: 'Unit Zero Stagenet',
        chain: 'Unit Zero',
        icon: 'unitzero',
        rpc: ['https://rpc-stagenet.unit0.dev'],
        faucets: [],
        nativeCurrency: { name: 'UNIT0', symbol: 'UNIT0', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://units.network',
        shortName: 'unit0-stagenet',
        chainId: 88819,
        networkId: 88819,
        explorers: [
            {
                name: 'explorer-stagenet',
                url: 'https://explorer-stagenet.unit0.dev',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRb2rWanyBTKS5KyrmrbXPNy9zovpxfLRxz9FPPiuRgfg'
    },
    88866: {
        name: 'Matr1x Testnet',
        title: 'Matr1x Testnet',
        chain: 'Matr1x',
        rpc: ['https://testnet-rpc.m1chain.io'],
        faucets: [],
        nativeCurrency: { name: 'MAX', symbol: 'MAX', decimals: 18 },
        infoURL: 'https://matr1x.io',
        shortName: 'Matr1x-Testnet',
        chainId: 88866,
        networkId: 88866,
        icon: 'matr1x',
        explorers: [
            {
                name: 'matr1x testnet',
                url: 'https://testnet-scan.m1chain.io',
                icon: 'matr1x',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt'
    },
    88880: {
        name: 'Chiliz Scoville Testnet',
        chain: 'CHZ',
        status: 'deprecated',
        rpc: ['https://scoville-rpc.chiliz.com'],
        faucets: ['https://scoville-faucet.chiliz.com'],
        nativeCurrency: { name: 'Chiliz', symbol: 'CHZ', decimals: 18 },
        icon: 'chiliz',
        infoURL: 'https://www.chiliz.com/en/chain',
        shortName: 'chz',
        chainId: 88880,
        networkId: 88880,
        slip44: 1,
        explorers: [
            {
                name: 'scoville-explorer',
                url: 'https://scoville-explorer.chiliz.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYV5xUVZhHRzLy7ie9D8qZeygJHvNZZAxwnB9GXYy6EED'
    },
    88882: {
        name: 'Chiliz Spicy Testnet',
        chain: 'CHZ',
        rpc: ['https://spicy-rpc.chiliz.com'],
        faucets: [
            'https://spicy-faucet.chiliz.com',
            'https://tatum.io/faucets/chiliz'
        ],
        nativeCurrency: { name: 'Chiliz', symbol: 'CHZ', decimals: 18 },
        icon: 'chilizspicy',
        infoURL: 'https://www.chiliz.com/en/chain',
        shortName: 'chzspicy',
        chainId: 88882,
        networkId: 88882,
        slip44: 1,
        explorers: [
            {
                name: 'spicy-explorer',
                url: 'https://testnet.chiliscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYV5xUVZhHRzLy7ie9D8qZeygJHvNZZAxwnB9GXYy6EED'
    },
    88888: {
        name: 'Chiliz Chain Mainnet',
        chain: 'CHZ',
        icon: 'chilizchain',
        rpc: [
            'https://rpc.chiliz.com',
            'https://rpc.ankr.com/chiliz',
            'https://chiliz.publicnode.com'
        ],
        faucets: [
            'https://spicy-faucet.chiliz.com',
            'https://tatum.io/faucets/chiliz'
        ],
        nativeCurrency: { name: 'Chiliz', symbol: 'CHZ', decimals: 18 },
        infoURL: 'https://chiliz.com',
        shortName: 'chzmainnet',
        chainId: 88888,
        networkId: 88888,
        redFlags: ['reusedChainId'],
        explorers: [
            {
                name: 'chiliscan',
                url: 'https://chiliscan.com',
                standard: 'EIP3091'
            },
            {
                name: 'chilizscan',
                url: 'https://scan.chiliz.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYV5xUVZhHRzLy7ie9D8qZeygJHvNZZAxwnB9GXYy6EED'
    },
    88899: {
        name: 'Unite',
        chain: 'UNITE',
        rpc: ['https://unite-mainnet.g.alchemy.com/public'],
        faucets: [],
        nativeCurrency: { name: 'Unite', symbol: 'UNITE', decimals: 18 },
        infoURL: 'https://unite.io',
        shortName: 'unite',
        chainId: 88899,
        networkId: 88899,
        status: 'active',
        icon: 'unite',
        explorers: [
            {
                name: 'Unite Explorer',
                url: 'https://unite-mainnet.explorer.alchemy.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmajJp6gbZbTMNm5NjGFMv9gYKzDJsW4vVxTECu8NzGXa2'
    },
    90001: {
        name: 'Pundi AIFX Omnilayer Testnet',
        chain: 'PUNDIAI',
        rpc: ['https://testnet-fx-json-web3.functionx.io:8545'],
        faucets: [],
        nativeCurrency: { name: 'Pundi AIFX', symbol: 'PUNDAI', decimals: 18 },
        infoURL: 'https://fx.pundi.ai/',
        shortName: 'dhobyghaut',
        chainId: 90001,
        networkId: 90001,
        icon: 'pundiai',
        explorers: [
            {
                name: 'PundiScan Explorer',
                url: 'https://testnet.pundiscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUve9vX4k6rtTX5dJZhXTGBGUosFccMZL9E349gdTHNkV'
    },
    90002: {
        name: 'UBIT SMARTCHAIN MAINNET',
        chain: 'UBIT SMARTCHAIN',
        rpc: ['https://rpc.ubitscan.io'],
        faucets: [],
        nativeCurrency: { name: 'USC', symbol: 'USC', decimals: 18 },
        infoURL: 'https://ubitscan.io',
        shortName: 'UBITSCAN',
        chainId: 90002,
        networkId: 90002,
        slip44: 108,
        explorers: [
            {
                name: 'UBITSCAN',
                url: 'https://ubitscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    90210: {
        name: 'Beverly Hills',
        title: 'Ethereum multi-client Verkle Testnet Beverly Hills',
        chain: 'ETH',
        rpc: ['https://rpc.beverlyhills.ethdevops.io:8545'],
        faucets: ['https://faucet.beverlyhills.ethdevops.io'],
        nativeCurrency: {
            name: 'Beverly Hills Testnet Ether',
            symbol: 'BVE',
            decimals: 18
        },
        infoURL: 'https://beverlyhills.ethdevops.io',
        shortName: 'bvhl',
        chainId: 90210,
        networkId: 90210,
        status: 'incubating',
        explorers: [
            {
                name: 'Beverly Hills explorer',
                url: 'https://explorer.beverlyhills.ethdevops.io',
                standard: 'none'
            }
        ]
    },
    90354: {
        name: 'Camp Testnet',
        chain: 'ETH',
        icon: 'camp',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        rpc: ['https://rpc-camp-network-4xje7wy105.t.conduit.xyz'],
        faucets: ['https://www.campnetwork.xyz/faucet'],
        nativeCurrency: { name: 'Ethereum', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://campaign-1.gitbook.io/camp-technical-docså',
        shortName: 'camp',
        chainId: 90354,
        networkId: 90354,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorerl2new-camp-network-4xje7wy105.t.conduit.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://camp-testnet-bridge.vercel.app/' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmZN3AzgetKvuTnZvsPPYTvtcsPa73ScGdTguXGHxc2CpN'
    },
    91002: {
        name: 'Nautilus Trition Chain',
        title: 'Nautilus Trition Testnet',
        chain: 'ETH',
        icon: 'nautilus',
        rpc: ['https://triton.api.nautchain.xyz'],
        faucets: ['https://faucet.eclipse.builders'],
        nativeCurrency: {
            name: 'Nautilus Zebec Testnet Tokens',
            symbol: 'tZBC',
            decimals: 18
        },
        infoURL: 'https://docs.nautchain.xyz',
        shortName: 'NAUT',
        chainId: 91002,
        networkId: 91002,
        explorers: [
            {
                name: 'Nautscan',
                url: 'https://triton.nautscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNutSgM7n6aJPPDiofe9Dm1epy1RcYTMvugukLUK2vmPM'
    },
    91111: {
        name: 'Henez Chain Mainnet',
        chain: 'henez',
        rpc: ['https://henez.calderachain.xyz/http'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.henez.fi/',
        shortName: 'henez',
        chainId: 91111,
        networkId: 91111,
        icon: 'henez',
        explorers: [
            {
                name: 'Henez Chain Mainnet Caldera Explorer',
                url: 'https://henez.calderaexplorer.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibgv5ejrws5xpppwgx47nfiajbgskjwjmibl6gjos7kyoxjrnvhi4'
    },
    91120: {
        name: 'MetaDAP Enterprise Mainnet',
        title: 'MetaDAP Enterprise Mainnet',
        chain: 'MetaDAP',
        icon: 'metadap',
        faucets: [],
        rpc: ['https://rpc.chain.metadap.io', 'wss://rpc-ws.chain.metadap.io'],
        nativeCurrency: { name: 'DAP', symbol: 'DAP', decimals: 18 },
        infoURL: 'https://metadap.io/',
        shortName: 'MetaDAP',
        chainId: 91120,
        networkId: 91120,
        explorers: [
            {
                name: 'MetaDAP Enterprise Mainnet explorer',
                url: 'https://explorer.chain.metadap.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcCFUTStKKJKfzTwrjfMFoVaPCMsvAvWXRdDkYMvCkEs3'
    },
    91715: {
        name: 'Combo Testnet',
        chain: 'Combo',
        icon: 'combo',
        rpc: ['https://test-rpc.combonetwork.io'],
        faucets: [],
        nativeCurrency: {
            name: 'BNB Chain Native Token',
            symbol: 'tcBNB',
            decimals: 18
        },
        infoURL: 'https://combonetwork.io',
        shortName: 'combo-testnet',
        chainId: 91715,
        networkId: 91715,
        explorers: [
            {
                name: 'combotrace explorer',
                url: 'https://combotrace-testnet.nodereal.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRR4v6h6z21BpgS9xY3ExLB4Gkmm3i3dJWQx27oTGifq8'
    },
    92001: {
        name: 'Lambda Testnet',
        chain: 'Lambda',
        rpc: ['https://evm.lambda.top/'],
        faucets: ['https://faucet.lambda.top'],
        nativeCurrency: { name: 'test-Lamb', symbol: 'LAMB', decimals: 18 },
        infoURL: 'https://lambda.im',
        shortName: 'lambda-testnet',
        chainId: 92001,
        networkId: 92001,
        slip44: 1,
        icon: 'lambda',
        explorers: [
            {
                name: 'Lambda EVM Explorer',
                url: 'https://explorer.lambda.top',
                standard: 'EIP3091',
                icon: 'lambda'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWsoME6LCghQTpGYf7EnUojaDdYo7kfkWVjE6VvNtkjwy'
    },
    92278: {
        name: 'Miracle Chain',
        chain: 'MIRACLE',
        rpc: ['https://rpc.miracleplay.io'],
        faucets: [],
        nativeCurrency: { name: 'Miracle Play Token', symbol: 'MPT', decimals: 18 },
        infoURL: 'https://miracleplay.gg',
        shortName: 'MIRACLE',
        chainId: 92278,
        networkId: 92278,
        icon: 'miracle',
        explorers: [
            {
                name: 'Miracle Chain Explorer',
                icon: 'miracle',
                url: 'https://explorer.miracleplay.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiakdaiqu4ge773vxf222gxnoonexpomyrn4xns4hl2hm6n6gpg6aa'
    },
    93572: {
        name: 'LiquidLayer Testnet',
        chain: 'LILA',
        icon: 'lila',
        rpc: ['https://testnet.liquidlayer.network'],
        faucets: ['https://claim.liquidlayer.network'],
        nativeCurrency: {
            name: 'LiquidLayer Testnet',
            symbol: 'LILA',
            decimals: 18
        },
        infoURL: 'https://testnet-scan.liquidlayer.network',
        shortName: 'tLILA',
        chainId: 93572,
        networkId: 93572,
        explorers: [
            {
                name: 'LiquidLayer Testnet Explorer',
                url: 'https://testnet-scan.liquidlayer.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiayuuzfpcgwjll4us4hquvpqa5gwq3lbiedv4qftmlwcxhcyjzzpq'
    },
    93747: {
        name: 'StratoVM Testnet',
        chain: 'StratoVM',
        rpc: ['https://rpc.stratovm.io'],
        faucets: [],
        nativeCurrency: { name: 'SVM', symbol: 'SVM', decimals: 18 },
        infoURL: 'https://www.stratovm.io/',
        shortName: 'stratovm',
        chainId: 93747,
        networkId: 93747,
        explorers: [
            {
                name: 'StratoVM Block Explorer',
                url: 'https://explorer.stratovm.io',
                standard: 'none'
            }
        ]
    },
    94524: {
        name: 'XCHAIN',
        chain: 'XCHAIN',
        rpc: ['https://xchain-rpc.kuma.bid'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://kuma.bid',
        shortName: 'xc',
        chainId: 94524,
        networkId: 94524,
        explorers: [
            {
                name: 'XCHAIN Explorer',
                url: 'https://xchain-explorer.kuma.bid',
                standard: 'EIP3091'
            }
        ]
    },
    95432: {
        name: 'SRICHAIN',
        chain: 'SRICHAIN',
        rpc: ['https://rpc.sriscan.com/'],
        faucets: [],
        nativeCurrency: { name: 'SRIX', symbol: 'SRIX', decimals: 18 },
        infoURL: 'https://sriscan.com',
        shortName: 'sriscan',
        chainId: 95432,
        networkId: 95432,
        slip44: 108,
        explorers: [
            {
                name: 'SRICHAIN',
                url: 'https://sriscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    96368: {
        name: 'Lux Testnet',
        chain: 'Lux',
        icon: 'lux',
        rpc: ['https://api.lux-test.network'],
        faucets: ['https://faucet.lux-test.network'],
        nativeCurrency: { name: 'tLux', symbol: 'tLUX', decimals: 18 },
        infoURL: 'https://lux.network',
        shortName: 'tlux',
        chainId: 96368,
        networkId: 96368,
        explorers: [
            {
                name: 'Lux Network Explorer',
                url: 'https://explore.lux.network',
                standard: 'EIP3091'
            },
            {
                name: 'Lux Network Explorer',
                url: 'https://explore.lux-test.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSjXJFpVAEdstq5JiUKciokm9fCwqS7Z9fg6M1XBdpePe'
    },
    96369: {
        name: 'Lux Mainnet',
        chain: 'Lux',
        icon: 'lux',
        rpc: ['https://api.lux.network'],
        faucets: ['https://faucet.lux-test.network'],
        nativeCurrency: { name: 'Lux', symbol: 'LUX', decimals: 18 },
        infoURL: 'https://lux.network',
        shortName: 'lux',
        chainId: 96369,
        networkId: 96369,
        explorers: [
            {
                name: 'Lux Network Explorer',
                url: 'https://explore.lux.network',
                standard: 'EIP3091'
            },
            {
                name: 'Lux Network Explorer',
                url: 'https://explore.lux-test.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSjXJFpVAEdstq5JiUKciokm9fCwqS7Z9fg6M1XBdpePe'
    },
    96370: {
        name: 'Lumoz Chain Mainnet',
        chain: 'ETH',
        rpc: ['https://rpc.lumoz.org', 'https://rpc-hk.lumoz.org'],
        faucets: [],
        nativeCurrency: {
            name: 'Lumoz Mainnet Token',
            symbol: 'MOZ',
            decimals: 18
        },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://lumoz.org',
        shortName: 'Lumoz-Chain-Mainnet',
        chainId: 96370,
        networkId: 96370,
        slip44: 1,
        icon: 'opside-new',
        explorers: [
            {
                name: 'LumozMainnetInfo',
                url: 'https://scan.lumoz.info',
                icon: 'opside-new',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZnE2ygPL2ZGuzHGvFCHmrqxwdurrhz3K1yPnwLzKbgay'
    },
    96371: {
        name: 'Wonder Testnet',
        chain: 'WNDR',
        rpc: ['https://rpc.testnet.wonderchain.org'],
        faucets: ['https://wonderchain.org/faucet'],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://wonderchain.org',
        shortName: 'wndr',
        chainId: 96371,
        networkId: 96371,
        icon: 'wonder',
        explorers: [
            {
                name: 'wonderexplorer',
                url: 'https://explorer.testnet.wonderchain.org',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/bafkreidurmcvrcv5suhpf6wzmdck7nt7ayhpjucpo32xaozxpjltlobyca'
    },
    96970: {
        name: 'Mantis Testnet (Hexapod)',
        chain: 'Mantis',
        icon: 'mantis',
        rpc: [
            'https://mantis-rpc.switch.ch',
            'https://mantis-rpc.kore-technologies.ch',
            'https://mantis-rpc.phoenix-systems.io'
        ],
        faucets: [
            'https://mantis.switch.ch/faucet',
            'https://mantis.kore-technologies.ch/faucet',
            'https://mantis.phoenix-systems.io/faucet',
            'https://mantis.block-spirit.ch/faucet'
        ],
        nativeCurrency: { name: 'Mantis', symbol: 'MANTIS', decimals: 18 },
        infoURL: 'https://hexapod.network',
        shortName: 'mantis',
        chainId: 96970,
        networkId: 96970,
        slip44: 1,
        explorers: [
            {
                name: 'Mantis Blockscout',
                url: 'https://blockscout.mantis.hexapod.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qma8dDhxSSVUyzV8Pu5bo252WaZEEikYFndRh7LVktvQEy'
    },
    97053: {
        name: 'Tetron Testnet Smart Chain',
        chain: 'Tetron Testnet',
        rpc: ['https://test-rpc.tscscan.org'],
        faucets: [],
        features: [{ name: 'EIP155' }],
        nativeCurrency: { name: 'Tetron Testnet', symbol: 'TSC', decimals: 18 },
        infoURL: 'https://tetronchain.com/',
        shortName: 'TetronTestnet',
        chainId: 97053,
        networkId: 97053,
        explorers: [
            {
                name: 'Tetron Explorer',
                url: 'https://testnet.tscscan.org',
                standard: 'EIP3091'
            }
        ]
    },
    97055: {
        name: 'Tetron Smart Chain',
        chain: 'Tetron Mainnet',
        rpc: ['https://rpc.tscscan.org'],
        faucets: [],
        features: [{ name: 'EIP155' }],
        nativeCurrency: { name: 'Tetron Mainnet', symbol: 'TSC', decimals: 18 },
        infoURL: 'https://tetronchain.com/',
        shortName: 'Tetron',
        chainId: 97055,
        networkId: 97055,
        explorers: [
            {
                name: 'Tetron Smart ChainExplorer',
                url: 'https://tscscan.org',
                standard: 'EIP3091'
            }
        ]
    },
    97288: {
        name: 'Boba BNB Mainnet Old',
        chain: 'Boba BNB Mainnet',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Boba Token', symbol: 'BOBA', decimals: 18 },
        infoURL: 'https://boba.network',
        shortName: 'BobaBnbOld',
        chainId: 97288,
        networkId: 97288,
        explorers: [
            {
                name: 'Boba BNB block explorer',
                url: 'https://blockexplorer.bnb.boba.network',
                standard: 'none'
            }
        ],
        status: 'deprecated'
    },
    97435: {
        name: 'SlingShot Testnet',
        chain: 'SLING',
        rpc: ['https://rpc-dependent-emerald-whippet-gh6kch3nen.t.conduit.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Sling Test', symbol: 'SLINGT', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://slingshotdao.com',
        shortName: 'sling',
        chainId: 97435,
        networkId: 97435,
        icon: 'slingshot',
        explorers: [
            {
                name: 'SlingShot Test Explorer',
                url: 'https://explorer-dependent-emerald-whippet-gh6kch3nen.t.conduit.xyz',
                icon: 'slingshot',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVhM3wHXdXkFEvW4x4vYqT7bx7gb5BQLWcLebHBeAzAXF'
    },
    97453: {
        name: 'Sidra Chain',
        chain: 'SIDRA',
        icon: 'sidrachain',
        rpc: ['https://node.sidrachain.com'],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: {
            name: 'Sidra Digital Asset',
            symbol: 'SDA',
            decimals: 18
        },
        infoURL: 'https://www.sidrachain.com',
        shortName: 'sidra',
        chainId: 97453,
        networkId: 97453,
        explorers: [
            {
                name: 'Sidra Chain Explorer',
                url: 'https://ledger.sidrachain.com',
                icon: 'sidrachain',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfVnJSmiB1Ss3Sfhgc9JsZAbQ2RAofsgzYB1VqUNKNgLH'
    },
    97531: {
        name: 'Green Chain Testnet',
        chain: 'Green Chain',
        icon: 'greenchain',
        rpc: ['https://node.greenchain.app/rpc/'],
        faucets: [],
        nativeCurrency: { name: 'GREEN', symbol: 'GREEN', decimals: 18 },
        infoURL: 'https://www.greenchain.app',
        shortName: 'greenchain',
        chainId: 97531,
        networkId: 97531,
        explorers: [
            {
                name: 'Green Chain Explorer',
                url: 'https://explorer.greenchain.app',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNWBcc2AtknphNxt4GtTxbWF6vDkf6sh2nvkPn9wqchW6'
    },
    97766: {
        name: 'MetaBenz CHAIN',
        chain: 'MetaBenz CHAIN',
        rpc: ['https://rpc.metabenzscan.com'],
        faucets: [],
        nativeCurrency: { name: 'MBC', symbol: 'MBC', decimals: 18 },
        infoURL: 'https://metabenzscan.com',
        shortName: 'metabenzscan',
        chainId: 97766,
        networkId: 97766,
        slip44: 108,
        explorers: [
            {
                name: 'MetaBenz CHAIN',
                url: 'https://metabenzscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    97970: {
        name: 'OptimusZ7 Testnet',
        chain: 'OptimusZ7',
        icon: 'OZ7Icon',
        rpc: ['https://testnet-rpc.optimusz7.com'],
        faucets: ['https://faucet.optimusz7.com'],
        nativeCurrency: { name: 'OptimusZ7', symbol: 'OZ7', decimals: 18 },
        infoURL: 'http://optimusz7.com',
        shortName: 'OZ7t',
        chainId: 97970,
        networkId: 97970,
        explorers: [
            {
                name: 'OptimusZ7 Testnet Explorer',
                url: 'https://testnet.optimusz7.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmerd9Q3otjDuQAFbdiQyUnZk7UfPvkCr21E5N4VCNvhbj'
    },
    98864: {
        name: 'Plume Devnet (Legacy)',
        title: 'Plume Sepolia L2 Rollup Devnet (Legacy)',
        chain: 'PLUME Devnet Legacy',
        rpc: [
            'https://test-rpc.plumenetwork.xyz',
            'wss://test-rpc.plumenetwork.xyz'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'Plume Sepolia Ether',
            symbol: 'ETH',
            decimals: 18
        },
        infoURL: 'https://plumenetwork.xyz/',
        shortName: 'plume-devnet',
        chainId: 98864,
        networkId: 98864,
        slip44: 1,
        icon: 'plume',
        status: 'deprecated',
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://test-explorer.plumenetwork.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111' },
        iconURL: 'https://ipfs.io/ipfs/QmT7dJKK2VXMtF9mJ6EfMTJXBntJyVvZcA8beLA2RCFbsW'
    },
    98865: {
        name: 'Plume (Legacy)',
        title: 'Plume Ethereum L2 Rollup Mainnet (Legacy)',
        chain: 'PLUME Legacy',
        rpc: ['https://rpc.plumenetwork.xyz', 'wss://rpc.plumenetwork.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Plume Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://plumenetwork.xyz/',
        shortName: 'plume',
        chainId: 98865,
        networkId: 98865,
        slip44: 1,
        icon: 'plume',
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.plumenetwork.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.plumenetwork.xyz' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmT7dJKK2VXMtF9mJ6EfMTJXBntJyVvZcA8beLA2RCFbsW'
    },
    98866: {
        name: 'Plume Mainnet',
        title: 'Plume Ethereum L2 Rollup Mainnet',
        chain: 'PLUME',
        rpc: [
            'https://phoenix-rpc.plumenetwork.xyz',
            'wss://phoenix-rpc.plumenetwork.xyz'
        ],
        faucets: [],
        nativeCurrency: { name: 'Plume', symbol: 'PLUME', decimals: 18 },
        infoURL: 'https://plumenetwork.xyz/',
        shortName: 'plume-mainnet',
        chainId: 98866,
        networkId: 98866,
        slip44: 1,
        icon: 'plume',
        status: 'incubating',
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://phoenix-explorer.plumenetwork.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.plumenetwork.xyz' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmT7dJKK2VXMtF9mJ6EfMTJXBntJyVvZcA8beLA2RCFbsW'
    },
    98867: {
        name: 'Plume Testnet',
        title: 'Plume Sepolia L2 Rollup Testnet',
        chain: 'PLUME Testnet',
        rpc: [
            'https://testnet-rpc.plumenetwork.xyz',
            'wss://testnet-rpc.plumenetwork.xyz'
        ],
        faucets: ['https://faucet.plumenetwork.xyz'],
        nativeCurrency: { name: 'Plume', symbol: 'PLUME', decimals: 18 },
        infoURL: 'https://plumenetwork.xyz/',
        shortName: 'plume-testnet',
        chainId: 98867,
        networkId: 98867,
        slip44: 1,
        icon: 'plume',
        status: 'incubating',
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://testnet-explorer.plumenetwork.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://testnet-bridge.plumenetwork.xyz' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmT7dJKK2VXMtF9mJ6EfMTJXBntJyVvZcA8beLA2RCFbsW'
    },
    98881: {
        name: 'Ebi Chain',
        title: 'Ebi Chain',
        chain: 'Ebi',
        rpc: ['https://rpc.ebi.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://ebi.xyz',
        shortName: 'ebi',
        chainId: 98881,
        networkId: 98881,
        status: 'incubating'
    },
    98985: {
        name: 'Superposition Testnet',
        title: 'Sperposition Testnet',
        chain: 'SPN',
        rpc: ['https://testnet-rpc.superposition.so'],
        faucets: ['https://faucet.superposition.so'],
        nativeCurrency: { name: 'SPN', symbol: 'SPN', decimals: 18 },
        infoURL: 'https://superposition.so',
        shortName: 'superposition-testnet',
        chainId: 98985,
        networkId: 98985,
        explorers: [
            {
                name: 'Superposition Explorer',
                url: 'https://testnet-explorer.superposition.so',
                standard: 'EIP3091'
            }
        ]
    },
    99099: {
        name: 'eLiberty Testnet',
        chain: '$EL',
        icon: 'eLiberty',
        rpc: ['https://testnet-rpc.eliberty.ngo'],
        faucets: ['https://faucet.eliberty.ngo'],
        nativeCurrency: { name: 'eLiberty', symbol: '$EL', decimals: 18 },
        infoURL: 'https://eliberty.ngo',
        shortName: 'ELt',
        chainId: 99099,
        networkId: 99099,
        slip44: 1,
        explorers: [
            {
                name: 'eLiberty Testnet',
                url: 'https://testnet.eliberty.ngo',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmcr8US1DZcK3ooiMtE8tEQPgep12abXzxPw1jCkgZhji9'
    },
    99876: {
        name: 'Edge Matrix Chain Testnet',
        chain: 'EMC Testnet',
        icon: 'emctest',
        rpc: ['https://rpc1-testnet.emc.network'],
        faucets: [],
        nativeCurrency: {
            name: 'Edge Matrix Chain Token',
            symbol: 'EMC',
            decimals: 18
        },
        infoURL: '',
        shortName: 'EMCTestnet',
        chainId: 99876,
        networkId: 99876,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet.emcscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUDymyXZS9eUn5p3tyDyxhD8GMB91HUBAAvySwENfPevh'
    },
    99879: {
        name: 'Edge Matrix Chain Sepolia',
        chain: 'EMC Sepolia',
        icon: 'emctest',
        rpc: ['https://rpc1-sepolia.emc.network'],
        faucets: [],
        nativeCurrency: {
            name: 'Edge Matrix Chain Token',
            symbol: 'EMC',
            decimals: 18
        },
        infoURL: '',
        shortName: 'EMCSepolia',
        chainId: 99879,
        networkId: 99879,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://sepolia.emcscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUDymyXZS9eUn5p3tyDyxhD8GMB91HUBAAvySwENfPevh'
    },
    99998: {
        name: 'UB Smart Chain(testnet)',
        chain: 'USC',
        rpc: ['https://testnet.rpc.uschain.network'],
        faucets: [],
        nativeCurrency: { name: 'UBC', symbol: 'UBC', decimals: 18 },
        infoURL: 'https://www.ubchain.site',
        shortName: 'usctest',
        chainId: 99998,
        networkId: 99998,
        slip44: 1
    },
    99999: {
        name: 'UB Smart Chain',
        chain: 'USC',
        rpc: ['https://rpc.uschain.network'],
        faucets: [],
        nativeCurrency: { name: 'UBC', symbol: 'UBC', decimals: 18 },
        infoURL: 'https://www.ubchain.site/',
        shortName: 'usc',
        chainId: 99999,
        networkId: 99999
    },
    100000: {
        name: 'QuarkChain Mainnet Root',
        chain: 'QuarkChain',
        rpc: ['http://jrpc.mainnet.quarkchain.io:38391'],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-r',
        chainId: 100000,
        networkId: 100000
    },
    100001: {
        name: 'QuarkChain Mainnet Shard 0',
        chain: 'QuarkChain',
        rpc: [
            'https://mainnet-s0-ethapi.quarkchain.io',
            'http://eth-jrpc.mainnet.quarkchain.io:39000'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-s0',
        chainId: 100001,
        networkId: 100001,
        parent: { chain: 'eip155-100000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-mainnet',
                url: 'https://mainnet.quarkchain.io/0',
                standard: 'EIP3091'
            }
        ]
    },
    100002: {
        name: 'QuarkChain Mainnet Shard 1',
        chain: 'QuarkChain',
        rpc: [
            'https://mainnet-s1-ethapi.quarkchain.io',
            'http://eth-jrpc.mainnet.quarkchain.io:39001'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-s1',
        chainId: 100002,
        networkId: 100002,
        parent: { chain: 'eip155-100000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-mainnet',
                url: 'https://mainnet.quarkchain.io/1',
                standard: 'EIP3091'
            }
        ]
    },
    100003: {
        name: 'QuarkChain Mainnet Shard 2',
        chain: 'QuarkChain',
        rpc: [
            'https://mainnet-s2-ethapi.quarkchain.io',
            'http://eth-jrpc.mainnet.quarkchain.io:39002'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-s2',
        chainId: 100003,
        networkId: 100003,
        parent: { chain: 'eip155-100000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-mainnet',
                url: 'https://mainnet.quarkchain.io/2',
                standard: 'EIP3091'
            }
        ]
    },
    100004: {
        name: 'QuarkChain Mainnet Shard 3',
        chain: 'QuarkChain',
        rpc: [
            'https://mainnet-s3-ethapi.quarkchain.io',
            'http://eth-jrpc.mainnet.quarkchain.io:39003'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-s3',
        chainId: 100004,
        networkId: 100004,
        parent: { chain: 'eip155-100000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-mainnet',
                url: 'https://mainnet.quarkchain.io/3',
                standard: 'EIP3091'
            }
        ]
    },
    100005: {
        name: 'QuarkChain Mainnet Shard 4',
        chain: 'QuarkChain',
        rpc: [
            'https://mainnet-s4-ethapi.quarkchain.io',
            'http://eth-jrpc.mainnet.quarkchain.io:39004'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-s4',
        chainId: 100005,
        networkId: 100005,
        parent: { chain: 'eip155-100000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-mainnet',
                url: 'https://mainnet.quarkchain.io/4',
                standard: 'EIP3091'
            }
        ]
    },
    100006: {
        name: 'QuarkChain Mainnet Shard 5',
        chain: 'QuarkChain',
        rpc: [
            'https://mainnet-s5-ethapi.quarkchain.io',
            'http://eth-jrpc.mainnet.quarkchain.io:39005'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-s5',
        chainId: 100006,
        networkId: 100006,
        parent: { chain: 'eip155-100000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-mainnet',
                url: 'https://mainnet.quarkchain.io/5',
                standard: 'EIP3091'
            }
        ]
    },
    100007: {
        name: 'QuarkChain Mainnet Shard 6',
        chain: 'QuarkChain',
        rpc: [
            'https://mainnet-s6-ethapi.quarkchain.io',
            'http://eth-jrpc.mainnet.quarkchain.io:39006'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-s6',
        chainId: 100007,
        networkId: 100007,
        parent: { chain: 'eip155-100000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-mainnet',
                url: 'https://mainnet.quarkchain.io/6',
                standard: 'EIP3091'
            }
        ]
    },
    100008: {
        name: 'QuarkChain Mainnet Shard 7',
        chain: 'QuarkChain',
        rpc: [
            'https://mainnet-s7-ethapi.quarkchain.io',
            'http://eth-jrpc.mainnet.quarkchain.io:39007'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-s7',
        chainId: 100008,
        networkId: 100008,
        parent: { chain: 'eip155-100000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-mainnet',
                url: 'https://mainnet.quarkchain.io/7',
                standard: 'EIP3091'
            }
        ]
    },
    100009: {
        name: 'VeChain',
        chain: 'VeChain',
        rpc: ['https://rpc-mainnet.vechain.energy'],
        faucets: [],
        nativeCurrency: { name: 'VeChain', symbol: 'VET', decimals: 18 },
        infoURL: 'https://vechain.org',
        shortName: 'vechain',
        chainId: 100009,
        networkId: 100009,
        explorers: [
            {
                name: 'VeChain Stats',
                url: 'https://vechainstats.com',
                standard: 'none'
            },
            {
                name: 'VeChain Explorer',
                url: 'https://explore.vechain.org',
                standard: 'none'
            }
        ]
    },
    100010: {
        name: 'VeChain Testnet',
        chain: 'VeChain',
        rpc: ['https://rpc-testnet.vechain.energy'],
        faucets: ['https://faucet.vecha.in'],
        nativeCurrency: { name: 'VeChain', symbol: 'VET', decimals: 18 },
        infoURL: 'https://vechain.org',
        shortName: 'vechain-testnet',
        chainId: 100010,
        networkId: 100010,
        slip44: 1,
        explorers: [
            {
                name: 'VeChain Explorer',
                url: 'https://explore-testnet.vechain.org',
                standard: 'none'
            }
        ]
    },
    100011: {
        name: 'QuarkChain L2 Mainnet',
        chain: 'QuarkChain',
        rpc: ['https://mainnet-l2-ethapi.quarkchain.io'],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-l2',
        chainId: 100011,
        networkId: 100011,
        parent: { type: 'L2', chain: 'eip155-100000' }
    },
    100100: {
        name: 'Deprecated CHI',
        chain: 'CHI1',
        icon: 'gnosis',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Chiado xDAI', symbol: 'xDAI', decimals: 18 },
        infoURL: 'https://docs.gnosischain.com',
        shortName: 'chi1',
        chainId: 100100,
        networkId: 100100,
        explorers: [],
        status: 'deprecated',
        iconURL: 'https://ipfs.io/ipfs/bafybeidk4swpgdyqmpz6shd5onvpaujvwiwthrhypufnwr6xh3dausz2dm'
    },
    101003: {
        name: 'Socotra JUNE-Chain',
        chain: 'Socotra JUNE-Chain',
        rpc: ['https://rpc.socotra-testnet.network/ext/bc/JUNE/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Socotra JUNE', symbol: 'JUNE', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://juneo.com/',
        shortName: 'Socotra-JUNE',
        chainId: 101003,
        networkId: 101003,
        icon: 'juneoSocotraTestnet',
        explorers: [
            {
                name: 'Juneo Scan',
                url: 'https://socotra.juneoscan.io/chain/2',
                icon: 'juneomainnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVHCbprTiCen4496EnAKedtJPxYLZXBE1gDusVa23y8kg'
    },
    101010: {
        name: 'Global Trust Network',
        chain: 'GTN',
        icon: 'gtn',
        rpc: ['https://gtn.stabilityprotocol.com'],
        faucets: [],
        nativeCurrency: { name: 'FREE', symbol: 'FREE', decimals: 18 },
        infoURL: 'https://stabilityprotocol.com',
        shortName: 'stabilityprotocol',
        chainId: 101010,
        networkId: 101010,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://stability.blockscout.com',
                standard: 'EIP3091'
            }
        ],
        redFlags: ['reusedChainId'],
        iconURL: 'https://ipfs.io/ipfs/bafkreid3wd6ouu53r677q2z24a4eq5un5tlwbc4izfapcvvtrlhkmz43au'
    },
    101088: {
        name: 'Xitcoin',
        chain: 'XITCOIN',
        faucets: [],
        rpc: ['https://network.xitcoin.org'],
        nativeCurrency: { name: 'Xitcoin', symbol: '$XTC', decimals: 8 },
        infoURL: 'https://docs.xitcoin.org/',
        shortName: 'Xitcoin',
        chainId: 101088,
        networkId: 101088,
        icon: 'xitcoin',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/bafkreihijckahzathexwzanldh4u4nm2wwrtus7bmbegmpc7hn4ivo5dn4'
    },
    102030: {
        name: 'Creditcoin',
        chain: 'CTC',
        icon: 'creditcoin',
        rpc: ['https://mainnet3.creditcoin.network'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'CTC', symbol: 'CTC', decimals: 18 },
        infoURL: 'https://creditcoin.org',
        shortName: 'ctc',
        chainId: 102030,
        networkId: 102030,
        faucets: [],
        explorers: [
            {
                name: 'blockscout',
                url: 'https://creditcoin.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbAk3S8XwCRYqKXbXc9rwBNJ9bWTUBgC6HFDE5ayrGfnd'
    },
    102031: {
        name: 'Creditcoin Testnet',
        chain: 'CTC',
        icon: 'creditcoin',
        rpc: ['https://rpc.cc3-testnet.creditcoin.network'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'Testnet CTC', symbol: 'tCTC', decimals: 18 },
        infoURL: 'https://creditcoin.org',
        shortName: 'ctctest',
        chainId: 102031,
        networkId: 102031,
        faucets: [],
        explorers: [
            {
                name: 'blockscout',
                url: 'https://creditcoin-testnet.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbAk3S8XwCRYqKXbXc9rwBNJ9bWTUBgC6HFDE5ayrGfnd'
    },
    102032: {
        name: 'Creditcoin Devnet',
        chain: 'CTC',
        icon: 'creditcoin',
        rpc: ['https://rpc.cc3-devnet.creditcoin.network'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'Devnet CTC', symbol: 'devCTC', decimals: 18 },
        infoURL: 'https://creditcoin.org',
        shortName: 'ctcdev',
        chainId: 102032,
        networkId: 102032,
        faucets: [],
        explorers: [
            {
                name: 'blockscout',
                url: 'https://creditcoin-devnet.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbAk3S8XwCRYqKXbXc9rwBNJ9bWTUBgC6HFDE5ayrGfnd'
    },
    103090: {
        name: 'Crystaleum',
        chain: 'crystal',
        rpc: ['https://evm.cryptocurrencydevs.org', 'https://rpc.crystaleum.org'],
        faucets: [],
        nativeCurrency: { name: 'CRFI', symbol: '◈', decimals: 18 },
        infoURL: 'https://crystaleum.org',
        shortName: 'CRFI',
        chainId: 103090,
        networkId: 1,
        icon: 'crystal',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://scan.crystaleum.org',
                icon: 'crystal',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmbry1Uc6HnXmqFNXW5dFJ7To8EezCCjNr4TqqvAyzXS4h'
    },
    103454: {
        name: 'Masa Testnet',
        chain: 'MASA',
        icon: 'masa',
        rpc: ['https://subnets.avax.network/masatestne/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Masa Token', symbol: 'MASA', decimals: 18 },
        infoURL: 'https://masa.finance',
        shortName: 'masatest',
        chainId: 103454,
        networkId: 103454,
        explorers: [
            {
                name: 'Masa Testnet Explorer',
                url: 'https://subnets-test.avax.network/masatestnet',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmV4f9byENNduHgLi8o1pC1sBNe3QAege2NnFkqGkTKojT'
    },
    104566: {
        name: 'KaspaClassic Mainnet',
        chain: 'KaspaClassic',
        icon: 'kaspaclassic',
        rpc: ['https://api.kaspaclassic.world/', 'http://80.178.101.118:8000/'],
        faucets: [],
        nativeCurrency: { name: 'KaspaClassic', symbol: 'CAS', decimals: 18 },
        infoURL: 'https://kaspaclassic.com/',
        shortName: 'cas',
        chainId: 104566,
        networkId: 104566,
        explorers: [
            {
                name: 'KaspaClassic Explorer',
                url: 'https://explorer.kaspaclassic.world',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNMuNBwg9opKvsnrDaoYBP743LeddeooQupVYjpBXf7d7'
    },
    105105: {
        name: 'Stratis Mainnet',
        chain: 'Stratis',
        rpc: ['https://rpc.stratisevm.com'],
        faucets: [],
        nativeCurrency: { name: 'Stratis', symbol: 'STRAX', decimals: 18 },
        infoURL: 'https://www.stratisplatform.com',
        shortName: 'stratis',
        chainId: 105105,
        networkId: 105105,
        icon: 'stratis',
        explorers: [
            {
                name: 'Stratis Explorer',
                url: 'https://explorer.stratisevm.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWiRBqfzoZ3GC7oCbYFqbwLyF4uDHM4eYdKUUJ7LHf2EA'
    },
    105363: {
        name: 'Lumoz Chain Testnet',
        chain: 'ETH',
        rpc: ['https://testnet-rpc.lumoz.org'],
        faucets: [],
        nativeCurrency: {
            name: 'Lumoz Testnet Token',
            symbol: 'MOZ',
            decimals: 18
        },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://lumoz.org',
        shortName: 'Lumoz-Chain-Testnet',
        chainId: 105363,
        networkId: 105363,
        slip44: 1,
        icon: 'opside-new',
        explorers: [
            {
                name: 'LumozTestInfo',
                url: 'https://testnet-scan.lumoz.info',
                icon: 'opside-new',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZnE2ygPL2ZGuzHGvFCHmrqxwdurrhz3K1yPnwLzKbgay'
    },
    108801: {
        name: 'BROChain Mainnet',
        chain: 'BRO',
        rpc: [
            'https://rpc.brochain.org',
            'http://rpc.brochain.org',
            'https://rpc.brochain.org/mainnet',
            'http://rpc.brochain.org/mainnet'
        ],
        faucets: [],
        nativeCurrency: { name: 'Brother', symbol: 'BRO', decimals: 18 },
        infoURL: 'https://brochain.org',
        shortName: 'bro',
        chainId: 108801,
        networkId: 108801,
        explorers: [
            {
                name: 'BROChain Explorer',
                url: 'https://explorer.brochain.org',
                standard: 'EIP3091'
            }
        ]
    },
    110000: {
        name: 'QuarkChain Devnet Root',
        chain: 'QuarkChain',
        rpc: ['http://jrpc.devnet.quarkchain.io:38391'],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-d-r',
        chainId: 110000,
        networkId: 110000
    },
    110001: {
        name: 'QuarkChain Devnet Shard 0',
        chain: 'QuarkChain',
        rpc: [
            'https://devnet-s0-ethapi.quarkchain.io',
            'http://eth-jrpc.devnet.quarkchain.io:39900'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-d-s0',
        chainId: 110001,
        networkId: 110001,
        parent: { chain: 'eip155-110000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-devnet',
                url: 'https://devnet.quarkchain.io/0',
                standard: 'EIP3091'
            }
        ]
    },
    110002: {
        name: 'QuarkChain Devnet Shard 1',
        chain: 'QuarkChain',
        rpc: [
            'https://devnet-s1-ethapi.quarkchain.io',
            'http://eth-jrpc.devnet.quarkchain.io:39901'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-d-s1',
        chainId: 110002,
        networkId: 110002,
        parent: { chain: 'eip155-110000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-devnet',
                url: 'https://devnet.quarkchain.io/1',
                standard: 'EIP3091'
            }
        ]
    },
    110003: {
        name: 'QuarkChain Devnet Shard 2',
        chain: 'QuarkChain',
        rpc: [
            'https://devnet-s2-ethapi.quarkchain.io',
            'http://eth-jrpc.devnet.quarkchain.io:39902'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-d-s2',
        chainId: 110003,
        networkId: 110003,
        parent: { chain: 'eip155-110000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-devnet',
                url: 'https://devnet.quarkchain.io/2',
                standard: 'EIP3091'
            }
        ]
    },
    110004: {
        name: 'QuarkChain Devnet Shard 3',
        chain: 'QuarkChain',
        rpc: [
            'https://devnet-s3-ethapi.quarkchain.io',
            'http://eth-jrpc.devnet.quarkchain.io:39903'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-d-s3',
        chainId: 110004,
        networkId: 110004,
        parent: { chain: 'eip155-110000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-devnet',
                url: 'https://devnet.quarkchain.io/3',
                standard: 'EIP3091'
            }
        ]
    },
    110005: {
        name: 'QuarkChain Devnet Shard 4',
        chain: 'QuarkChain',
        rpc: [
            'https://devnet-s4-ethapi.quarkchain.io',
            'http://eth-jrpc.devnet.quarkchain.io:39904'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-d-s4',
        chainId: 110005,
        networkId: 110005,
        parent: { chain: 'eip155-110000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-devnet',
                url: 'https://devnet.quarkchain.io/4',
                standard: 'EIP3091'
            }
        ]
    },
    110006: {
        name: 'QuarkChain Devnet Shard 5',
        chain: 'QuarkChain',
        rpc: [
            'https://devnet-s5-ethapi.quarkchain.io',
            'http://eth-jrpc.devnet.quarkchain.io:39905'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-d-s5',
        chainId: 110006,
        networkId: 110006,
        parent: { chain: 'eip155-110000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-devnet',
                url: 'https://devnet.quarkchain.io/5',
                standard: 'EIP3091'
            }
        ]
    },
    110007: {
        name: 'QuarkChain Devnet Shard 6',
        chain: 'QuarkChain',
        rpc: [
            'https://devnet-s6-ethapi.quarkchain.io',
            'http://eth-jrpc.devnet.quarkchain.io:39906'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-d-s6',
        chainId: 110007,
        networkId: 110007,
        parent: { chain: 'eip155-110000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-devnet',
                url: 'https://devnet.quarkchain.io/6',
                standard: 'EIP3091'
            }
        ]
    },
    110008: {
        name: 'QuarkChain Devnet Shard 7',
        chain: 'QuarkChain',
        rpc: [
            'https://devnet-s7-ethapi.quarkchain.io',
            'http://eth-jrpc.devnet.quarkchain.io:39907'
        ],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-d-s7',
        chainId: 110008,
        networkId: 110008,
        parent: { chain: 'eip155-110000', type: 'shard' },
        explorers: [
            {
                name: 'quarkchain-devnet',
                url: 'https://devnet.quarkchain.io/7',
                standard: 'EIP3091'
            }
        ]
    },
    110011: {
        name: 'QuarkChain L2 Testnet',
        chain: 'QuarkChain',
        rpc: ['https://testnet-l2-ethapi.quarkchain.io'],
        faucets: [],
        nativeCurrency: { name: 'QKC', symbol: 'QKC', decimals: 18 },
        infoURL: 'https://www.quarkchain.io',
        shortName: 'qkc-l2-t',
        chainId: 110011,
        networkId: 110011,
        parent: { type: 'L2', chain: 'eip155-110000' }
    },
    110110: {
        name: 'Mars Credit',
        chain: 'MARS',
        rpc: [
            'https://node99-production-dd5f.up.railway.app:443',
            'https://rpc.marscredit.xyz:443'
        ],
        faucets: [],
        nativeCurrency: { name: 'Mars Credit', symbol: 'MARS', decimals: 18 },
        infoURL: 'https://marscredit.xyz/',
        shortName: 'mars',
        chainId: 110110,
        networkId: 110110,
        slip44: 1,
        icon: 'marscredit',
        explorers: [],
        redFlags: [],
        iconURL: 'https://ipfs.io/ipfs/bafybeiaqvko45oh3bppsx57i73ajopgm2nsy4v6a22wwrbhbaoe5olwwlm'
    },
    111000: {
        name: 'Siberium Test Network',
        chain: 'SBR',
        rpc: ['https://rpc.test.siberium.net'],
        faucets: [],
        nativeCurrency: { name: 'TestSIBR', symbol: 'SIBR', decimals: 18 },
        infoURL: 'https://siberium.net',
        shortName: 'testsbr',
        chainId: 111000,
        networkId: 111000,
        slip44: 1,
        icon: 'siberium',
        explorers: [
            {
                name: 'Siberium Testnet Explorer - blockscout',
                url: 'https://explorer.test.siberium.net',
                icon: 'siberium',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYeMdWDZ1iaBFeSPorRyPi7RuSXTdDKTgW3rfnUf3W5ne'
    },
    111111: {
        name: 'Siberium Network',
        chain: 'SBR',
        rpc: ['https://rpc.main.siberium.net', 'https://rpc.main.siberium.net.ru'],
        faucets: [],
        nativeCurrency: { name: 'Siberium', symbol: 'SIBR', decimals: 18 },
        infoURL: 'https://siberium.net',
        shortName: 'sbr',
        chainId: 111111,
        networkId: 111111,
        icon: 'siberium',
        explorers: [
            {
                name: 'Siberium Mainnet Explorer - blockscout - 1',
                url: 'https://explorer.main.siberium.net',
                icon: 'siberium',
                standard: 'EIP3091'
            },
            {
                name: 'Siberium Mainnet Explorer - blockscout - 2',
                url: 'https://explorer.main.siberium.net.ru',
                icon: 'siberium',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYeMdWDZ1iaBFeSPorRyPi7RuSXTdDKTgW3rfnUf3W5ne'
    },
    111188: {
        name: 're.al',
        title: 're.al Real-World Assets network',
        chain: 're.al',
        rpc: [
            'https://rpc.realforreal.gelato.digital',
            'wss://ws.realforreal.gelato.digital',
            'https://tangible-real.gateway.tenderly.co',
            'https://real.drpc.org',
            'wss://real.drpc.org'
        ],
        nativeCurrency: { name: 're.al Ether', symbol: 'reETH', decimals: 18 },
        infoURL: 'https://re.al',
        faucets: [],
        shortName: 're-al',
        chainId: 111188,
        networkId: 111188,
        slip44: 60,
        icon: 'real',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.re.al',
                icon: 'real',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [
                { url: 'https://re.al/bridge' },
                { url: 'https://bridge.gelato.network/bridge/real' }
            ]
        },
        iconURL: 'https://ipfs.io/ipfs/QmNUmWC7jNEBcTs6ZqkrQ5vMAQG8qjq7n3FcZnXvJZLoQ9'
    },
    111451: {
        name: 'eGold Chain Testnet',
        chain: 'EGC',
        icon: 'egoldchain',
        rpc: [
            'https://rpc-testnet.egoldchain.com',
            'wss://rpc-testnet.egoldchain.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Aurum', symbol: 'XAU', decimals: 18 },
        infoURL: 'https://www.egoldchain.com',
        shortName: 'egoldchaint',
        chainId: 111451,
        networkId: 111451,
        explorers: [
            {
                name: 'eGold Chain Block Explorer',
                url: 'http://testnet.egoldscan.io',
                standard: 'none',
                icon: 'egoldchain'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTQh54Rf3DFYxZZoQQ9yCjeAYXwzTaVua4KLmXX8AsFNF'
    },
    112358: {
        name: 'Metachain One Mainnet',
        chain: 'METAO',
        icon: 'metao',
        rpc: ['https://rpc.metachain.one', 'https://rpc2.metachain.one'],
        faucets: [],
        nativeCurrency: { name: 'Metao', symbol: 'METAO', decimals: 18 },
        infoURL: 'https://metachain.one',
        shortName: 'metao',
        chainId: 112358,
        networkId: 112358,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.metachain.one',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTmo2QAtX5PbhX96vewnvH4Vc5H83Ft2DJGi6tAqTcFij'
    },
    119139: {
        name: 'MetaDAP Enterprise Testnet',
        title: 'MetaDAP Enterprise Testnet',
        chain: 'MetaDAP',
        icon: 'metadap',
        faucets: [],
        rpc: [
            'https://rpc.testnet.chain.metadap.io',
            'wss://rpc-ws.testnet.chain.metadap.io'
        ],
        nativeCurrency: { name: 'DAP', symbol: 'DAP', decimals: 18 },
        infoURL: 'https://metadap.io/',
        shortName: 'MetaDAP-T',
        chainId: 119139,
        networkId: 119139,
        explorers: [
            {
                name: 'MetaDAP Enterprise Testnet explorer',
                url: 'https://explorer.testnet.chain.metadap.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcCFUTStKKJKfzTwrjfMFoVaPCMsvAvWXRdDkYMvCkEs3'
    },
    121224: {
        name: 'Fushuma',
        chain: 'Fushuma',
        rpc: ['https://rpc.fushuma.com'],
        faucets: [],
        nativeCurrency: { name: 'FUSHUMA', symbol: 'FUMA', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: '',
        shortName: 'fushuma',
        chainId: 121224,
        networkId: 121224,
        explorers: [
            { name: 'FumaScan', url: 'https://fumascan.com', standard: 'none' }
        ]
    },
    123321: {
        name: 'Gemchain',
        chain: 'Gemchain',
        rpc: ['https://evm-rpc.gemchain.org'],
        faucets: [],
        nativeCurrency: { name: 'GEM', symbol: 'GEM', decimals: 18 },
        infoURL: 'https://gemchain.org',
        shortName: 'gemchain',
        chainId: 123321,
        networkId: 123321,
        slip44: 1,
        explorers: [
            {
                name: 'Gemchain Scan',
                url: 'https://scan.gemchain.org',
                standard: 'EIP3091'
            }
        ]
    },
    123456: {
        name: 'ADIL Devnet',
        chain: 'ADIL',
        icon: 'adil',
        rpc: ['https://devnet.adilchain-rpc.io'],
        faucets: [],
        nativeCurrency: { name: 'Devnet ADIL', symbol: 'ADIL', decimals: 18 },
        infoURL: 'https://adilchain.io',
        shortName: 'dadil',
        chainId: 123456,
        networkId: 123456,
        explorers: [
            {
                name: 'ADIL Devnet Explorer',
                url: 'https://devnet.adilchain-scan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeHNYUx6n8CjUFSLWNT17oAtDYrUq6r8buyvGCUBXCJw6'
    },
    124832: {
        name: 'Mitosis Testnet',
        chain: 'Mitosis Testnet',
        rpc: ['https://rpc.testnet.mitosis.org'],
        faucets: ['https://testnet.mitosis.org/faucet'],
        nativeCurrency: { name: 'MITO', symbol: 'MITO', decimals: 18 },
        infoURL: 'https://mitosis.org',
        shortName: 'mitosis-testnet',
        chainId: 124832,
        networkId: 124832,
        explorers: [
            {
                name: 'mitosis testnet explorer',
                url: 'https://testnet.mitosiscan.xyz',
                standard: 'EIP3091'
            }
        ]
    },
    128123: {
        name: 'Etherlink Testnet',
        chain: 'Etherlink',
        icon: 'etherlink',
        chainId: 128123,
        networkId: 128123,
        features: [{ name: 'EIP1559' }],
        infoURL: 'https://etherlink.com',
        shortName: 'etlt',
        nativeCurrency: { name: 'tez', symbol: 'XTZ', decimals: 18 },
        rpc: ['https://node.ghostnet.etherlink.com'],
        faucets: ['https://faucet.etherlink.com'],
        explorers: [
            {
                name: 'Etherlink Testnet Explorer',
                url: 'https://testnet.explorer.etherlink.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVqE4wq3fd3RKZwo7GxmW333ywHgYBZGvqwh3TUBM5DUi'
    },
    129399: {
        name: 'Tatara Testnet',
        chain: 'Tatara',
        rpc: ['https://rpc.tatara.katanarpc.com/'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: '',
        shortName: 'Tatara',
        chainId: 129399,
        networkId: 129399,
        icon: 'ethereum',
        explorers: [
            {
                name: 'Tatara explorer',
                url: 'https://explorer.tatara.katana.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt'
    },
    131313: {
        name: 'Odyssey Chain (Testnet)',
        chain: 'DIONE',
        rpc: ['https://testnode.dioneprotocol.com/ext/bc/D/rpc'],
        faucets: ['https://faucet.dioneprotocol.com/'],
        features: [{ name: 'EIP155' }],
        infoURL: 'https://www.dioneprotocol.com/',
        shortName: 'DIONE',
        chainId: 131313,
        networkId: 131313,
        icon: 'odyssey',
        nativeCurrency: { name: 'DIONE', symbol: 'DIONE', decimals: 18 },
        iconURL: 'https://ipfs.io/ipfs/bafkreiabuopswwczdqb7kbncgdpqzatpxyyx3qg4oixikalj47oluyrjmu'
    },
    131419: {
        name: 'ETND Chain Mainnets',
        chain: 'ETND',
        rpc: ['https://rpc.node1.etnd.pro/'],
        faucets: [],
        nativeCurrency: { name: 'ETND', symbol: 'ETND', decimals: 18 },
        infoURL: 'https://www.etnd.pro',
        shortName: 'ETND',
        chainId: 131419,
        networkId: 131419,
        icon: 'ETND',
        explorers: [
            {
                name: 'etndscan',
                url: 'https://scan.etnd.pro',
                icon: 'ETND',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmd26eRJxPb1jJg5Q4mC2M4kD9Jrs5vmcnr5LczHFMGwSD'
    },
    132902: {
        name: 'Form Testnet',
        title: 'Form Testnet',
        chain: 'formtestnet',
        rpc: [
            'https://sepolia-rpc.form.network/http',
            'wss://sepolia-rpc.form.network/ws'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://info.form.network/faucet'],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://sepolia-info.form.network',
        shortName: 'formtestnet',
        chainId: 132902,
        networkId: 132902,
        explorers: [
            {
                name: 'Form Testnet explorer',
                url: 'https://sepolia-explorer.form.network',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://sepolia-op-bridge.form.network' }]
        }
    },
    141319: {
        name: 'MagApe Testnet',
        title: 'MagApeChain',
        chain: 'MagApe',
        rpc: ['https://testnet-api.magape.io/chain/'],
        faucets: [],
        nativeCurrency: { name: 'MagApe', symbol: 'MAG', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://magape.io',
        shortName: 'mag',
        chainId: 141319,
        networkId: 141319,
        icon: 'magape',
        explorers: [
            {
                name: 'etherscan',
                url: 'http://testnet-api.magape.io:81',
                icon: 'magape',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPsxWMvnxnZ9dZcRJJMaE24o34dQsnsAMCJh3kVDrE1aB'
    },
    141491: {
        name: 'Bitharvest Chain Testnet',
        chain: 'Bitharvest Chain Testnet',
        rpc: ['https://rpc-testnet.bthscan.io/'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: {
            name: 'Bitharvest Testnet Native Token',
            symbol: 'BTH',
            decimals: 18
        },
        infoURL: '',
        shortName: 'BitharvestTestnet',
        chainId: 141491,
        networkId: 141491,
        explorers: [
            {
                name: 'Bitharvest Testnet Scan',
                url: 'https://testnet.bthscan.io',
                standard: 'EIP3091'
            }
        ],
        icon: 'bth',
        iconURL: 'https://ipfs.io/ipfs/QmPdGw9RLstggj3xcVtAfzmP2rUy6i2FuM4KPLC9wTiQqm'
    },
    142857: {
        name: 'ICPlaza Mainnet',
        chain: 'ICPlaza',
        icon: 'icplaza',
        rpc: ['https://rpcmainnet.ic-plaza.org/'],
        faucets: [],
        nativeCurrency: { name: 'ict', symbol: 'ict', decimals: 18 },
        infoURL: 'https://docs.ic-plaza.org/',
        shortName: 'ICPlaza',
        chainId: 142857,
        networkId: 142857,
        explorers: [
            {
                name: 'ICPlaza',
                url: 'https://browsemainnet.ic-plaza.org/index',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQpKKwpqrx77VA4SJLEWhuv9eLFMcVV9uvxRCLb6gdgCX'
    },
    153153: {
        name: 'Odyssey Chain Mainnet',
        chain: 'DIONE',
        rpc: ['https://node.dioneprotocol.com/ext/bc/D/rpc'],
        faucets: [],
        features: [{ name: 'EIP155' }],
        infoURL: 'https://www.dioneprotocol.com',
        shortName: 'Odyssey',
        chainId: 153153,
        networkId: 153153,
        icon: 'odysseyChain',
        nativeCurrency: { name: 'DIONE', symbol: 'DIONE', decimals: 18 },
        explorers: [
            {
                name: 'Odyssey Scan',
                url: 'https://odysseyscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiabuopswwczdqb7kbncgdpqzatpxyyx3qg4oixikalj47oluyrjmu'
    },
    158245: {
        name: 'CryptoX',
        chain: 'XCOIN',
        rpc: ['https://rpc-xcoin.cryptoxnetwork.io'],
        faucets: [],
        nativeCurrency: { name: 'XCOIN', symbol: 'XCOIN', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://cryptoxnetwork.io',
        shortName: 'cryptox',
        chainId: 158245,
        networkId: 158245,
        explorers: [
            {
                name: 'CryptoX explorer',
                url: 'https://cryptoxscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    158345: {
        name: 'XCOIN',
        chain: 'XCOIN',
        rpc: ['https://rpc-xcoin.cryptoxnetwork.io'],
        faucets: [],
        nativeCurrency: { name: 'XCOIN', symbol: 'XCOIN', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://cryptoxnetwork.io',
        shortName: 'xcoin',
        chainId: 158345,
        networkId: 158345,
        explorers: [
            {
                name: 'CryptoX explorer',
                url: 'https://cryptoxscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    161201: {
        name: 'OpenLedger Testnet',
        chain: 'OpenLedger Testnet',
        rpc: ['https://rpctn.openledger.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Openledger', symbol: 'OPN', decimals: 18 },
        infoURL: 'https://www.openledger.xyz',
        shortName: 'openledgertest',
        chainId: 161201,
        networkId: 161201,
        icon: 'openledger',
        explorers: [
            {
                name: 'OpenLedger Testnet Explorer',
                url: 'https://scantn.openledger.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreia37de5s5jtm5t74jtbx5clas3dnbojnrue7ls7ricbnr4kmgcfca'
    },
    161212: {
        name: 'PlayFi Mainnet',
        chain: 'PLAY',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Play', symbol: 'PLAY', decimals: 18 },
        infoURL: 'https://www.playfi.ai/',
        shortName: 'playfi',
        chainId: 161212,
        networkId: 161212,
        explorers: [],
        status: 'incubating'
    },
    161803: {
        name: 'Eventum Mainnet',
        shortName: 'Eventum',
        chain: 'Eventum',
        icon: 'eventum',
        networkId: 161803,
        chainId: 161803,
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        rpc: ['https://mainnet-rpc.evedex.com'],
        faucets: [],
        explorers: [
            {
                name: 'Eventum Mainnet Explorer',
                url: 'https://explorer.evedex.com',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://evedex.com',
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.arbitrum.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreigor7jjj7q4pczpz5wsj2fhdmkmx7o3r7yp35tcrz2verfkgucymi'
    },
    165279: {
        name: 'Eclat Mainnet',
        chain: 'Eclat',
        icon: 'eclat',
        rpc: ['https://mainnet-rpc.eclatscan.com'],
        faucets: [],
        nativeCurrency: { name: 'Eclat', symbol: 'ECLAT', decimals: 18 },
        infoURL: 'https://eclatscan.com',
        shortName: 'ECLAT',
        chainId: 165279,
        networkId: 165279,
        explorers: [
            {
                name: 'Eclat Mainnet Explorer',
                url: 'https://eclatscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeigpyvnir6awzgeazkk5xdkvexw7w6ww3yxawszue6zms4a5ygdfky'
    },
    167000: {
        name: 'Taiko Alethia',
        chain: 'ETH',
        status: 'active',
        icon: 'taiko',
        rpc: [
            'https://rpc.mainnet.taiko.xyz',
            'https://taiko-rpc.publicnode.com',
            'wss://taiko-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://taiko.xyz',
        shortName: 'tko-mainnet',
        chainId: 167000,
        networkId: 167000,
        explorers: [
            {
                name: 'etherscan',
                url: 'https://taikoscan.io',
                standard: 'EIP3091'
            },
            {
                name: 'Routescan',
                url: 'https://taikoexplorer.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcHdmVr5VRUJq13jnM6tgah5Ge7hn3Dm14eY6vwivJ5ui'
    },
    167004: {
        name: 'Taiko (Alpha-2 Testnet)',
        chain: 'ETH',
        status: 'deprecated',
        icon: 'taiko',
        rpc: ['https://rpc.a2.taiko.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://taiko.xyz',
        shortName: 'taiko-a2',
        chainId: 167004,
        networkId: 167004,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.a2.taiko.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcHdmVr5VRUJq13jnM6tgah5Ge7hn3Dm14eY6vwivJ5ui'
    },
    167005: {
        name: 'Taiko Grimsvotn L2',
        chain: 'ETH',
        status: 'deprecated',
        icon: 'taiko',
        rpc: ['https://rpc.test.taiko.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://taiko.xyz',
        shortName: 'taiko-l2',
        chainId: 167005,
        networkId: 167005,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.test.taiko.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcHdmVr5VRUJq13jnM6tgah5Ge7hn3Dm14eY6vwivJ5ui'
    },
    167006: {
        name: 'Taiko Eldfell L3',
        chain: 'ETH',
        status: 'deprecated',
        icon: 'taiko',
        rpc: ['https://rpc.l3test.taiko.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://taiko.xyz',
        shortName: 'taiko-l3',
        chainId: 167006,
        networkId: 167006,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.l3test.taiko.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcHdmVr5VRUJq13jnM6tgah5Ge7hn3Dm14eY6vwivJ5ui'
    },
    167007: {
        name: 'Taiko Jolnir L2',
        chain: 'ETH',
        status: 'deprecated',
        icon: 'taiko',
        rpc: ['https://rpc.jolnir.taiko.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://taiko.xyz',
        shortName: 'tko-jolnir',
        chainId: 167007,
        networkId: 167007,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.jolnir.taiko.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcHdmVr5VRUJq13jnM6tgah5Ge7hn3Dm14eY6vwivJ5ui'
    },
    167008: {
        name: 'Taiko Katla L2',
        chain: 'ETH',
        status: 'deprecated',
        icon: 'taiko',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://taiko.xyz',
        shortName: 'tko-katla',
        chainId: 167008,
        networkId: 167008,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmcHdmVr5VRUJq13jnM6tgah5Ge7hn3Dm14eY6vwivJ5ui'
    },
    167009: {
        name: 'Taiko Hekla',
        chain: 'ETH',
        status: 'active',
        icon: 'taiko',
        rpc: [
            'https://rpc.hekla.taiko.xyz',
            'wss://ws.hekla.taiko.xyz',
            'https://taiko-hekla-rpc.publicnode.com',
            'wss://taiko-hekla-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://taiko.xyz',
        shortName: 'tko-hekla',
        chainId: 167009,
        networkId: 167009,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscoutapi.hekla.taiko.xyz',
                standard: 'EIP3091'
            },
            {
                name: 'Routescan',
                url: 'https://hekla.taikoexplorer.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcHdmVr5VRUJq13jnM6tgah5Ge7hn3Dm14eY6vwivJ5ui'
    },
    168168: {
        name: 'Zchains',
        chain: 'Zchains',
        rpc: ['https://rpc.zchains.com'],
        faucets: [],
        nativeCurrency: { name: 'ZCD', symbol: 'ZCD', decimals: 18 },
        infoURL: 'https://www.zchains.com/',
        shortName: 'zchains',
        chainId: 168168,
        networkId: 168168,
        icon: 'zchain',
        explorers: [
            {
                name: 'zchains',
                url: 'https://scan.zchains.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWMbLpzmFCSpgWaXKiazwSyaPQ6qKSboHpko4g4HBZbZm'
    },
    168169: {
        name: 'MUD Chain',
        chain: 'MUD',
        rpc: ['https://rpc.mud.network'],
        faucets: ['https://faucet.mud.network'],
        nativeCurrency: { name: 'MUD', symbol: 'MUD', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://mud.network',
        shortName: 'MUD',
        chainId: 168169,
        networkId: 168169,
        icon: 'mud',
        explorers: [
            {
                name: 'MUD Chain Scan',
                url: 'https://scan.mud.network',
                icon: 'mud',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdarywgvFGGBEEH6QAhUbkFhJfKAjFLZxQVEGARTxe1gP'
    },
    171000: {
        name: 'Fair Testnet',
        chain: 'FAIR',
        rpc: ['https://rpc-testnet.xfair.ai', 'wss://rpc-testnet.xfair.ai'],
        faucets: [],
        nativeCurrency: { name: 'FAIR', symbol: 'FAIR', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://xfair.ai',
        shortName: 'fairt',
        chainId: 171000,
        networkId: 171000
    },
    171717: {
        name: 'Wadzchain Mainnet',
        title: 'Wadzchain Mainnet',
        chain: 'Wadzchain-Mainnet',
        icon: 'wadz',
        rpc: ['https://rpc.wadzchain.io'],
        faucets: [],
        nativeCurrency: { name: 'WadzChain Token', symbol: 'WCO', decimals: 18 },
        infoURL: 'https://www.wadzchain-network.io',
        shortName: 'wadzchain-mainnet',
        chainId: 171717,
        networkId: 171717,
        explorers: [
            {
                name: 'Wadzchain Mainnet Explorer',
                url: 'https://scan.wadzchain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRBVFviqdhyarkTAxrnq2r2em6dJXCzpNxZL4yaXPbLou'
    },
    175177: {
        name: 'Chronicle - Lit Protocol Testnet',
        chain: 'LPC',
        icon: 'lit',
        rpc: ['https://chain-rpc.litprotocol.com/http'],
        faucets: ['https://faucet.litprotocol.com'],
        nativeCurrency: { name: 'Test LIT', symbol: 'tstLIT', decimals: 18 },
        infoURL: 'https://developer.litprotocol.com/v3/network/rollup',
        shortName: 'lpc',
        chainId: 175177,
        networkId: 175177,
        explorers: [
            {
                name: 'Lit Chronicle Explorer',
                url: 'https://chain.litprotocol.com',
                icon: 'lit',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXZcwET1LhUxfc2mCdiCJFm61jUHsVVXuZYwx8zhvHQxn'
    },
    175188: {
        name: 'Chronicle Yellowstone - Lit Protocol Testnet',
        chain: 'LPY',
        icon: 'lit',
        rpc: ['https://yellowstone-rpc.litprotocol.com'],
        faucets: ['https://developer.litprotocol.com/support/intro'],
        nativeCurrency: { name: 'Test LPX', symbol: 'tstLPX', decimals: 18 },
        infoURL: 'https://litprotocol.com',
        shortName: 'lpy',
        chainId: 175188,
        networkId: 175188,
        explorers: [
            {
                name: 'Lit Chronicle Yellowstone Explorer',
                url: 'https://yellowstone-explorer.litprotocol.com',
                icon: 'lit',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXZcwET1LhUxfc2mCdiCJFm61jUHsVVXuZYwx8zhvHQxn'
    },
    175190: {
        name: 'Chronicle Loa - Lit Protocol Testnet',
        chain: 'LPL',
        icon: 'lit',
        rpc: ['https://loa-rpc.litprotocol.com'],
        faucets: ['https://developer.litprotocol.com/support/intro'],
        nativeCurrency: { name: 'Test Lit', symbol: 'tLit', decimals: 18 },
        infoURL: 'https://litprotocol.com',
        shortName: 'lpl',
        chainId: 175190,
        networkId: 175190,
        explorers: [
            {
                name: 'Lit Chronicle Loa Explorer',
                url: 'https://loa-explorer.litprotocol.com',
                icon: 'lit',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXZcwET1LhUxfc2mCdiCJFm61jUHsVVXuZYwx8zhvHQxn'
    },
    188710: {
        name: 'Bitica Chain Mainnet',
        chain: 'BDCC',
        rpc: ['https://mainnet-rpc.biticablockchain.com/'],
        faucets: [],
        nativeCurrency: { name: 'Bitica Coin', symbol: 'BDCC', decimals: 18 },
        infoURL: 'https://biticablockchain.com/',
        shortName: 'bdcc',
        chainId: 188710,
        networkId: 188710,
        explorers: [
            {
                name: 'Bitica DPOS Blockchain Explorer',
                url: 'https://biticablockchain.com',
                standard: 'none'
            }
        ]
    },
    188881: {
        name: 'Condor Test Network',
        chain: 'CONDOR',
        icon: 'condor',
        rpc: ['https://testnet.condor.systems/rpc'],
        faucets: ['https://faucet.condor.systems'],
        nativeCurrency: {
            name: 'Condor Native Token',
            symbol: 'CONDOR',
            decimals: 18
        },
        infoURL: 'https://condor.systems',
        shortName: 'condor',
        chainId: 188881,
        networkId: 188881,
        slip44: 1,
        explorers: [
            {
                name: 'CondorScan',
                url: 'https://explorer.condor.systems',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPRDuEJSTqp2cDUvWCp71Wns6XV8nvdeAVKWH6srpk4xM'
    },
    191919: {
        name: 'Altblockscan Mainnet',
        chain: 'ALTB',
        rpc: ['https://rpc.altblockscan.com'],
        faucets: [],
        nativeCurrency: { name: 'Altblockscan', symbol: 'ALTB', decimals: 18 },
        infoURL: 'https://altblockscan.com',
        shortName: 'altb',
        chainId: 191919,
        networkId: 191919,
        icon: 'altb',
        explorers: [
            {
                name: 'altblockscan',
                url: 'https://scan.altblockscan.com',
                icon: 'altb',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreicy275qnnvxzjocl33blzw26orv3rkygqbb4sqwtx5bc2m3hazmre'
    },
    192940: {
        name: 'Mind Network Testnet',
        chain: 'FHET',
        rpc: [
            'https://rpc-testnet.mindnetwork.xyz',
            'wss://rpc-testnet.mindnetwork.xyz'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://mindnetwork.xyz',
        shortName: 'fhet',
        chainId: 192940,
        networkId: 192940
    },
    193939: {
        name: 'R0AR Chain',
        chain: 'R0AR Chain',
        rpc: ['https://rpc-r0ar.io'],
        faucets: [],
        nativeCurrency: { name: 'Ethereum', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://r0arscan.io',
        shortName: 'R0AR-Chain',
        chainId: 193939,
        networkId: 193939,
        explorers: [
            { name: 'tracehawk', url: 'https://r0arscan.io', standard: 'none' }
        ]
    },
    198989: {
        name: 'Lydia Coin Testnet',
        chain: 'LYDIA-TESTNET',
        rpc: ['https://testnet-rpc.lydiacoins.com'],
        faucets: ['https://faucet.lydiacoins.com/'],
        nativeCurrency: { name: 'Lydia Token', symbol: 'BSW', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/lydia-coin-testnet',
        shortName: 'lydia-testnet',
        chainId: 198989,
        networkId: 198989
    },
    199991: {
        name: 'MAZZE Testnet',
        chain: 'MAZZE Testnet',
        icon: 'mazze',
        rpc: ['https://testnet-rpc.mazze.io/'],
        faucets: ['https://faucet.mazze.io/'],
        nativeCurrency: { name: 'MAZZE Testnet', symbol: 'MAZZE', decimals: 18 },
        infoURL: 'https://mazze.io/',
        shortName: 'MAZZE',
        chainId: 199991,
        networkId: 199991,
        explorers: [
            {
                name: 'MAZZE Testnet Explorer',
                url: 'https://mazzescan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmaR9Ud3aD7RaHYdsi3TdC1qx4zVusM76nd91s3Ghaz5fa'
    },
    200000: {
        name: 'xFair.AI Testnet',
        chain: 'FAIT',
        rpc: ['https://rpc_testnet.xfair.ai', 'wss://rpc_testnet.xfair.ai'],
        faucets: [],
        nativeCurrency: { name: 'FAI', symbol: 'FAI', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://xfair.ai',
        shortName: 'fait',
        chainId: 200000,
        networkId: 200000
    },
    200101: {
        name: 'Milkomeda C1 Testnet',
        chain: 'milkTAda',
        icon: 'milkomeda',
        rpc: [
            'https://rpc-devnet-cardano-evm.c1.milkomeda.com',
            'wss://rpc-devnet-cardano-evm.c1.milkomeda.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'milkTAda', symbol: 'mTAda', decimals: 18 },
        infoURL: 'https://milkomeda.com',
        shortName: 'milkTAda',
        chainId: 200101,
        networkId: 200101,
        slip44: 1,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer-devnet-cardano-evm.c1.milkomeda.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdoUtvHDybu5ppYBZT8BMRp6AqByVSoQs8nFwKbaS55jd'
    },
    200200: {
        name: 'Zoo Mainnet',
        chain: 'Zoo',
        icon: 'zoo',
        rpc: ['https://api.zoo.network'],
        faucets: ['https://faucet.zoo-test.network'],
        nativeCurrency: { name: 'Zoo', symbol: 'ZOO', decimals: 18 },
        infoURL: 'https://zoo.network',
        shortName: 'zoo',
        chainId: 200200,
        networkId: 200200,
        explorers: [
            {
                name: 'Zoo Network Explorer',
                url: 'https://explore.zoo.network',
                standard: 'EIP3091'
            },
            {
                name: 'Zoo Network Explorer',
                url: 'https://explore.zoo-test.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUXemD3eYrWLeFNadHtz6WbCMVs5xX5knuu71sEKhPMgA'
    },
    200202: {
        name: 'Milkomeda A1 Testnet',
        chain: 'milkTAlgo',
        icon: 'milkomeda',
        rpc: ['https://rpc-devnet-algorand-rollup.a1.milkomeda.com'],
        faucets: [],
        nativeCurrency: { name: 'milkTAlgo', symbol: 'mTAlgo', decimals: 18 },
        infoURL: 'https://milkomeda.com',
        shortName: 'milkTAlgo',
        chainId: 200202,
        networkId: 200202,
        slip44: 1,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer-devnet-algorand-rollup.a1.milkomeda.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdoUtvHDybu5ppYBZT8BMRp6AqByVSoQs8nFwKbaS55jd'
    },
    200625: {
        name: 'Akroma',
        chain: 'AKA',
        rpc: ['https://remote.akroma.io'],
        faucets: [],
        nativeCurrency: { name: 'Akroma Ether', symbol: 'AKA', decimals: 18 },
        infoURL: 'https://akroma.io',
        shortName: 'aka',
        chainId: 200625,
        networkId: 200625,
        slip44: 200625
    },
    200810: {
        name: 'Bitlayer Testnet',
        chain: 'Bitlayer',
        rpc: [
            'https://testnet-rpc.bitlayer.org',
            'wss://testnet-ws.bitlayer.org',
            'https://testnet-rpc.bitlayer-rpc.com',
            'wss://testnet-ws.bitlayer-rpc.com',
            'https://rpc.ankr.com/bitlayer_testnet'
        ],
        faucets: ['https://www.bitlayer.org/faucet'],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://docs.bitlayer.org/',
        shortName: 'btrt',
        chainId: 200810,
        networkId: 200810,
        slip44: 1,
        icon: 'bitlayer',
        explorers: [
            {
                name: 'bitlayer testnet scan',
                url: 'https://testnet.btrscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdWZ1frB47fr3tw31xE68C2Vocaw5Ef53LQ5WDNdNnNyG'
    },
    200901: {
        name: 'Bitlayer Mainnet',
        chain: 'Bitlayer',
        rpc: [
            'https://rpc.bitlayer.org',
            'https://rpc.bitlayer-rpc.com',
            'https://rpc.ankr.com/bitlayer',
            'https://rpc-bitlayer.rockx.com',
            'wss://ws.bitlayer.org',
            'wss://ws.bitlayer-rpc.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://docs.bitlayer.org/',
        shortName: 'btr',
        chainId: 200901,
        networkId: 200901,
        slip44: 1,
        icon: 'bitlayer',
        explorers: [
            {
                name: 'bitlayer mainnet scan',
                url: 'https://www.btrscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdWZ1frB47fr3tw31xE68C2Vocaw5Ef53LQ5WDNdNnNyG'
    },
    201018: {
        name: 'Alaya Mainnet',
        chain: 'Alaya',
        rpc: [
            'https://openapi.alaya.network/rpc',
            'wss://openapi.alaya.network/ws'
        ],
        faucets: [],
        nativeCurrency: { name: 'ATP', symbol: 'atp', decimals: 18 },
        infoURL: 'https://www.alaya.network/',
        shortName: 'alaya',
        chainId: 201018,
        networkId: 1,
        icon: 'alaya',
        explorers: [
            {
                name: 'alaya explorer',
                url: 'https://scan.alaya.network',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmci6vPcWAwmq19j98yuQxjV6UPzHtThMdCAUDbKeb8oYu'
    },
    201030: {
        name: 'Alaya Dev Testnet',
        chain: 'Alaya',
        rpc: [
            'https://devnetopenapi.alaya.network/rpc',
            'wss://devnetopenapi.alaya.network/ws'
        ],
        faucets: [
            'https://faucet.alaya.network/faucet/?id=f93426c0887f11eb83b900163e06151c'
        ],
        nativeCurrency: { name: 'ATP', symbol: 'atp', decimals: 18 },
        infoURL: 'https://www.alaya.network/',
        shortName: 'alayadev',
        chainId: 201030,
        networkId: 1,
        slip44: 1,
        icon: 'alaya',
        explorers: [
            {
                name: 'alaya explorer',
                url: 'https://devnetscan.alaya.network',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmci6vPcWAwmq19j98yuQxjV6UPzHtThMdCAUDbKeb8oYu'
    },
    201804: {
        name: 'Mythical Chain',
        chain: 'MYTH',
        rpc: ['https://chain-rpc.mythicalgames.com'],
        faucets: [],
        nativeCurrency: { name: 'Mythos', symbol: 'MYTH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://mythicalgames.com/',
        shortName: 'myth',
        chainId: 201804,
        networkId: 201804,
        icon: 'mythical',
        explorers: [
            {
                name: 'Mythical Chain Explorer',
                url: 'https://explorer.mythicalgames.com',
                icon: 'mythical',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihru6cccfblrjz5bv36znq2l3h67u6xj5ivtc4bj5l6gzofbgtnb4'
    },
    202020: {
        name: 'Decimal Smart Chain Testnet',
        chain: 'tDSC',
        rpc: ['https://testnet-val.decimalchain.com/web3/'],
        faucets: [],
        nativeCurrency: { name: 'Decimal', symbol: 'tDEL', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://decimalchain.com',
        shortName: 'tDSC',
        chainId: 202020,
        networkId: 202020,
        slip44: 1,
        icon: 'dsc',
        explorers: [
            {
                name: 'DSC Explorer Testnet',
                url: 'https://testnet.explorer.decimalchain.com',
                icon: 'dsc',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSgzwKnJJjys3Uq2aVVdwJ3NffLj3CXMVCph9uByTBegc'
    },
    202105: {
        name: 'DuckChain Testnet',
        title: 'DuckChain Testnet',
        chain: 'DuckChain',
        icon: 'duckchain',
        rpc: [
            'https://testnet-rpc.duckchain.io',
            'https://testnet-rpc-hk.duckchain.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'TON', symbol: 'TON', decimals: 18 },
        infoURL: 'https://duckchain.io',
        shortName: 'Duck-Chain-Testnet',
        chainId: 202105,
        networkId: 202105,
        explorers: [
            {
                name: 'DuckChain Scan',
                url: 'https://www.okx.com/web3/explorer/duckchain-testnet',
                icon: 'duckchain',
                standard: 'EIP3091'
            },
            {
                name: 'DuckChain Scan',
                url: 'https://www.oklink.com/duckchain-testnet',
                icon: 'duckchain',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTJwaQcF6widssKvbNgdM4AVaddiTqFM2j4n6x17Sp3FL'
    },
    202202: {
        name: 'Bethel Sydney',
        chain: 'Bethel',
        rpc: ['https://rpc-sydney.bethel.network'],
        faucets: ['https://faucet-sydney.bethel.network'],
        nativeCurrency: { name: 'Bethel', symbol: 'BECX', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: '',
        shortName: 'bethel-sydney',
        chainId: 202202,
        networkId: 202202,
        explorers: [
            {
                name: 'Betehl Sydney Explorer',
                url: 'https://sydney.bethel.network',
                standard: 'none'
            }
        ]
    },
    202209: {
        name: 'Alterscope',
        chain: 'Alterscope',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'RISK', symbol: 'RISK', decimals: 18 },
        infoURL: 'https://alterscope.org',
        shortName: 'Alterscope',
        chainId: 202209,
        networkId: 202209,
        status: 'incubating'
    },
    202212: {
        name: 'X1 Devnet',
        chain: 'X1',
        rpc: ['https://x1-devnet.xen.network'],
        faucets: [],
        nativeCurrency: { name: 'XN', symbol: 'XN', decimals: 18 },
        infoURL: 'https://docs.xen.network/x1/',
        shortName: 'x1-devnet',
        chainId: 202212,
        networkId: 202212,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.x1-devnet.xen.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    202401: {
        name: 'YMTECH-BESU Testnet',
        chain: 'YMTECH-BESU',
        rpc: ['http://39.119.118.216:8545'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.ymtech.co.kr',
        shortName: 'YMTECH-BESU',
        chainId: 202401,
        networkId: 202401,
        explorers: [
            {
                name: 'YMTECH-BESU Chainlens',
                url: 'http://39.119.118.198',
                standard: 'none'
            }
        ]
    },
    202424: {
        name: 'Blockfit',
        chain: '202424',
        rpc: ['https://rpc.blockfitscan.io'],
        faucets: [],
        nativeCurrency: { name: 'BFIT', symbol: 'BFIT', decimals: 18 },
        infoURL: 'https://blockfit.io',
        shortName: 'Blockfit',
        chainId: 202424,
        networkId: 202424,
        explorers: [
            {
                name: 'Tracehawk',
                url: 'https://blockfitscan.io',
                standard: 'none'
            }
        ]
    },
    202624: {
        name: 'Jellie',
        title: 'Twala Testnet Jellie',
        shortName: 'twl-jellie',
        chain: 'ETH',
        chainId: 202624,
        networkId: 202624,
        slip44: 1,
        icon: 'twala',
        nativeCurrency: { name: 'Twala Coin', symbol: 'TWL', decimals: 18 },
        rpc: ['https://jellie-rpc.twala.io/', 'wss://jellie-rpc-wss.twala.io/'],
        faucets: [],
        infoURL: 'https://twala.io/',
        explorers: [
            {
                name: 'Jellie Blockchain Explorer',
                url: 'https://jellie.twala.io',
                standard: 'EIP3091',
                icon: 'twala'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTXJVhVKvVC7DQEnGKXvydvwpvVaUEBJrMHvsCr4nr1sK'
    },
    204005: {
        name: 'X1 Network',
        chain: 'X1',
        rpc: ['https://x1-testnet.xen.network'],
        faucets: [],
        nativeCurrency: { name: 'XN', symbol: 'XN', decimals: 18 },
        infoURL: 'https://docs.xen.network/go-x1/',
        shortName: 'x1-testnet',
        chainId: 204005,
        networkId: 204005,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.x1-testnet.xen.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    205205: {
        name: 'Auroria Testnet',
        title: 'Stratis Testnet Auroria',
        chain: 'Auroria',
        rpc: ['https://auroria.rpc.stratisevm.com'],
        faucets: ['https://auroria.faucet.stratisevm.com'],
        nativeCurrency: { name: 'Auroria Stratis', symbol: 'tSTRAX', decimals: 18 },
        infoURL: 'https://www.stratisplatform.com',
        shortName: 'auroria',
        chainId: 205205,
        networkId: 205205,
        icon: 'auroria',
        explorers: [
            {
                name: 'Auroria Testnet Explorer',
                url: 'https://auroria.explorer.stratisevm.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbkTh6qNYUnae5yNjied3qZqVyZcb4x3hfUpJ33bGg9QY'
    },
    210049: {
        name: 'GitAGI Atlas Testnet',
        chain: 'GitAGI',
        rpc: ['https://rpc.gitagi.org'],
        faucets: [],
        nativeCurrency: { name: 'GitAGI', symbol: 'tGAGI', decimals: 18 },
        infoURL: 'https://gitagi.org/',
        shortName: 'atlas',
        chainId: 210049,
        networkId: 210049
    },
    210209: {
        name: 'Sorian',
        chain: 'SOR',
        rpc: ['https://rpc.sorian.io'],
        faucets: [],
        nativeCurrency: { name: 'Sorian', symbol: 'SOR', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://sorian.io',
        shortName: 'sorian',
        chainId: 210209,
        networkId: 210209,
        explorers: []
    },
    210210: {
        name: 'Sorian Testnet',
        chain: 'tSOR',
        rpc: ['https://testnet-rpc.sorian.io', 'https://testnet.rpc.sorian.io'],
        faucets: [],
        icon: 'sorianTestnet',
        nativeCurrency: { name: 'Sorian Testnet', symbol: 'tSOR', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://mint.sorian.io',
        shortName: 'sorianTestnet',
        chainId: 210210,
        networkId: 210210,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmZmrcLYFtPZb36MZ1DyQpR7Lw8CWPP7x3Bx2anCjVWfMR'
    },
    210425: {
        name: 'PlatON Mainnet',
        chain: 'PlatON',
        rpc: [
            'https://openapi2.platon.network/rpc',
            'wss://openapi2.platon.network/ws'
        ],
        faucets: [],
        nativeCurrency: { name: 'LAT', symbol: 'lat', decimals: 18 },
        infoURL: 'https://www.platon.network',
        shortName: 'platon',
        chainId: 210425,
        networkId: 1,
        icon: 'platon',
        explorers: [
            {
                name: 'PlatON explorer',
                url: 'https://scan.platon.network',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmT7PSXBiVBma6E15hNkivmstqLu3JSnG1jXN5pTmcCGRC'
    },
    212013: {
        name: 'Heima',
        chain: 'Heima',
        rpc: [
            'https://rpc.heima-parachain.heima.network',
            'wss://rpc.heima-parachain.heima.network',
            'https://litentry-rpc.dwellir.com',
            'wss://litentry-rpc.dwellir.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Heima', symbol: 'HEI', decimals: 18 },
        infoURL: 'https://heima.network',
        shortName: 'heima',
        chainId: 212013,
        networkId: 212013,
        icon: 'heima',
        explorers: [
            {
                name: 'heima statescan',
                url: 'https://heima.statescan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreib3dv4feoxzpmtjoy54zndilbgkdhs4wxo4sja46u7zkuk36de2pu'
    },
    220315: {
        name: 'Mas Mainnet',
        chain: 'MAS',
        rpc: ['http://node.masnet.ai:8545'],
        faucets: [],
        nativeCurrency: { name: 'Master Bank', symbol: 'MAS', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://masterbank.org',
        shortName: 'mas',
        chainId: 220315,
        networkId: 220315,
        icon: 'mas',
        explorers: [
            {
                name: 'explorer masnet',
                url: 'https://explorer.masnet.ai',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZ9njQhhKkpJKGnoYy6XTuDtk5CYiDFUd8atqWthqUT3Q'
    },
    221230: {
        name: 'Reapchain Mainnet',
        chain: 'REAP',
        rpc: ['https://eth.reapchain.org'],
        faucets: [],
        nativeCurrency: { name: 'Reap', symbol: 'REAP', decimals: 18 },
        features: [],
        infoURL: 'https://reapchain.com',
        shortName: 'reap',
        chainId: 221230,
        networkId: 221230,
        icon: 'reapchain',
        explorers: [
            {
                name: 'Reapchain Dashboard',
                url: 'https://dashboard.reapchain.org',
                icon: 'reapchain',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmevQ8jmDWHmdnUQg6BpoMwVB3NhpzS75adbMnKL78Ls2h'
    },
    221231: {
        name: 'Reapchain Testnet',
        chain: 'REAP',
        rpc: ['https://test-eth.reapchain.org'],
        faucets: ['http://faucet.reapchain.com'],
        nativeCurrency: { name: 'test-Reap', symbol: 'tREAP', decimals: 18 },
        features: [],
        infoURL: 'https://reapchain.com',
        shortName: 'reap-testnet',
        chainId: 221231,
        networkId: 221231,
        slip44: 1,
        icon: 'reapchain',
        explorers: [
            {
                name: 'Reapchain Testnet Dashboard',
                url: 'https://test-dashboard.reapchain.org',
                icon: 'reapchain',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmevQ8jmDWHmdnUQg6BpoMwVB3NhpzS75adbMnKL78Ls2h'
    },
    222222: {
        name: 'Hydration',
        chain: 'HDX',
        rpc: [
            'https://rpc.hydradx.cloud',
            'wss://rpc.hydradx.cloud',
            'https://hydration-rpc.n.dwellir.com',
            'wss://hydration-rpc.n.dwellir.com',
            'https://rpc.helikon.io/hydradx',
            'wss://rpc.helikon.io/hydradx',
            'https://hydration.dotters.network',
            'wss://hydration.dotters.network',
            'https://hydration.ibp.network',
            'wss://hydration.ibp.network',
            'https://rpc.cay.hydration.cloud',
            'wss://rpc.cay.hydration.cloud',
            'https://rpc.parm.hydration.cloud',
            'wss://rpc.parm.hydration.cloud',
            'https://rpc.roach.hydration.cloud',
            'wss://rpc.roach.hydration.cloud',
            'https://rpc.zipp.hydration.cloud',
            'wss://rpc.zipp.hydration.cloud',
            'https://rpc.sin.hydration.cloud',
            'wss://rpc.sin.hydration.cloud',
            'https://rpc.coke.hydration.cloud',
            'wss://rpc.coke.hydration.cloud'
        ],
        faucets: [],
        nativeCurrency: { name: 'Wrapped ETH', symbol: 'WETH', decimals: 18 },
        infoURL: 'https://hydration.net/',
        shortName: 'hdx',
        chainId: 222222,
        networkId: 222222,
        icon: 'hydration',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.evm.hydration.cloud',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibipnyu4vdcvkgkxtgqlf7wdpmntstdy6q52bz5b7xekfaiduylru'
    },
    222555: {
        name: 'DeepL Mainnet',
        chain: 'DEEPL',
        rpc: ['https://rpc.deeplnetwork.org'],
        faucets: [],
        nativeCurrency: { name: 'DeepL', symbol: 'DEEPL', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://deeplnetwork.org',
        shortName: 'deepl',
        chainId: 222555,
        networkId: 222555,
        icon: 'deepl',
        explorers: [
            {
                name: 'DeepL Mainnet Explorer',
                url: 'https://scan.deeplnetwork.org',
                icon: 'deepl',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeihjwgy4qja5cee452malk5hpb25pzpipfaka7hjcyb437ldodxzaq'
    },
    222666: {
        name: 'DeepL Testnet',
        chain: 'DEEPL',
        rpc: ['https://testnet.deeplnetwork.org'],
        faucets: ['https://faucet.deeplnetwork.org'],
        nativeCurrency: { name: 'DeepL', symbol: 'DEEPL', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://deeplnetwork.org',
        shortName: 'tdeepl',
        chainId: 222666,
        networkId: 222666,
        icon: 'deepl',
        explorers: [
            {
                name: 'DeepL Testnet Explorer',
                url: 'https://testnet-scan.deeplnetwork.org',
                icon: 'deepl',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeihjwgy4qja5cee452malk5hpb25pzpipfaka7hjcyb437ldodxzaq'
    },
    223344: {
        name: 'B20 Testnet',
        chain: 'B20',
        rpc: ['https://rpc.beonescan.com'],
        faucets: ['https://faucet.beonechain.com/'],
        nativeCurrency: { name: 'B20', symbol: 'TBOC', decimals: 18 },
        infoURL: 'https://rpc.beonescan.com',
        shortName: 'B20',
        chainId: 223344,
        networkId: 223344,
        icon: 'b20',
        explorers: [
            {
                name: 'beonescan',
                url: 'https://beonescan.com',
                icon: 'b20',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmV14XgxgayF2Chw3HUGPNQ2iLzh9jAUxNL1LAECpZohVp'
    },
    224168: {
        name: 'Taf ECO Chain Mainnet',
        chain: 'Taf ECO Chain',
        icon: 'taf',
        rpc: ['https://mainnet.tafchain.com/v1'],
        faucets: [],
        nativeCurrency: {
            name: 'Taf ECO Chain Mainnet',
            symbol: 'TAFECO',
            decimals: 18
        },
        infoURL: 'https://www.tafchain.com',
        shortName: 'TAFECO',
        chainId: 224168,
        networkId: 224168,
        explorers: [
            {
                name: 'Taf ECO Chain Mainnet',
                url: 'https://ecoscan.tafchain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigpxhu7glccsislhjqpl5fnsfmj2io4cy33blhky642uiuyojossy'
    },
    224400: {
        name: 'CONET Mainnet',
        chain: 'CONET Mainnet',
        rpc: ['https://mainnet-rpc.conet.network'],
        faucets: [],
        nativeCurrency: { name: 'CONET ETH', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://conet.network',
        shortName: 'conet-mainnet',
        chainId: 224400,
        networkId: 224400,
        slip44: 2147708048,
        icon: 'conet',
        explorers: [
            {
                name: 'CONET Mainnet Explorer',
                url: 'https://mainnet.conet.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibjxqd5kqcc2shstjjujvxzg6cwegwr6dgjyyd56v6h7yusgks7sy'
    },
    224422: {
        name: 'CONET Sebolia Testnet',
        chain: 'CONET',
        rpc: ['https://rpc1.conet.network'],
        faucets: [],
        nativeCurrency: { name: 'CONET Sebolia', symbol: 'CONET', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://conet.network',
        shortName: 'conet-sebolia',
        chainId: 224422,
        networkId: 224422,
        slip44: 1,
        icon: 'conet',
        explorers: [
            {
                name: 'CONET Scan',
                url: 'https://scan.conet.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibjxqd5kqcc2shstjjujvxzg6cwegwr6dgjyyd56v6h7yusgks7sy'
    },
    224433: {
        name: 'CONET Cancun',
        chain: 'CONET Cancun',
        rpc: ['https://rpc.conet.network'],
        faucets: [],
        nativeCurrency: { name: 'CONET Cancun', symbol: 'CONET', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://conet.network',
        shortName: 'conet-cancun',
        chainId: 224433,
        networkId: 224433,
        slip44: 2147708081,
        icon: 'conet',
        explorers: [
            {
                name: 'CONET Cancun Scan',
                url: 'https://cancun.conet.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibjxqd5kqcc2shstjjujvxzg6cwegwr6dgjyyd56v6h7yusgks7sy'
    },
    229772: {
        name: 'Abyss Protocol',
        chain: 'Abyss Protocol Testnet',
        rpc: ['https://testnet.rpc.abyssprotocol.ai/'],
        faucets: ['https://faucet.abyssprotocol.ai/'],
        nativeCurrency: { name: 'AbyssETH', symbol: 'aETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://abyssprotocol.ai/',
        shortName: 'abyss',
        chainId: 229772,
        networkId: 229772,
        icon: 'abyss',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet.abyssprotocol.ai',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmeaa9TSsdUuJtRRX9DWX3iuQ4bypTQfctGciuKsFkKL8C'
    },
    230315: {
        name: 'HashKey Chain Testnet(discard)',
        chain: 'HashKey',
        rpc: ['https://testnet.hashkeychain/rpc'],
        faucets: ['https://testnet.hashkeychain/faucet'],
        nativeCurrency: { name: 'HashKey Token', symbol: 'tHSK', decimals: 18 },
        infoURL: 'https://www.hashkey.com',
        shortName: 'hsktest',
        chainId: 230315,
        networkId: 230315,
        slip44: 1,
        icon: 'hsk',
        explorers: [
            {
                name: 'HashKey Chain Testnet Explorer',
                url: 'https://testnet.hashkeyscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNU11AqYB2htrrSyBSP9ct7bPtuZTP7Hrz21PrEcB9nYE'
    },
    234666: {
        name: 'Haymo Testnet',
        chain: 'tHYM',
        rpc: ['https://testnet1.haymo.network'],
        faucets: [],
        nativeCurrency: { name: 'HAYMO', symbol: 'HYM', decimals: 18 },
        infoURL: 'https://haymoswap.web.app/',
        shortName: 'hym',
        chainId: 234666,
        networkId: 234666,
        slip44: 1
    },
    235711: {
        name: 'Universe Testnet',
        chain: 'Universe',
        rpc: ['https://blockchain.dev-universe-bank.com'],
        faucets: [],
        nativeCurrency: { name: 'Universe Token', symbol: 'UNI', decimals: 18 },
        infoURL: 'https://www.universe-bank.com/universal-ledger-system',
        shortName: 'unitestnet',
        chainId: 235711,
        networkId: 235711,
        icon: 'universe',
        explorers: [
            {
                name: 'Universe Testnet Explorer',
                url: 'https://blockchain-explorer.dev-universe-bank.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreif53g2ynhznaqs5y5fxnj5ub3rfrwfsmvsyw23od3clmevnjqw46e'
    },
    240240: {
        name: 'Studio Testnet',
        chain: 'STO',
        icon: 'studio',
        rpc: [
            'https://rpc.studio-blockchain.com',
            'wss://ws.studio-blockchain.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Studio Token', symbol: 'STO', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://studio-blockchain.com',
        shortName: 'sto',
        chainId: 240240,
        networkId: 240240,
        explorers: [
            {
                name: 'Studio Scan',
                url: 'https://studio-scan.com',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmamYSLuQSiAvqfQdejQn2PKXV6ZPQCagpXH5MLRz1GeCf'
    },
    240515: {
        name: 'Orange Chain Testnet',
        title: 'Orange Chain Testnet',
        chain: 'Orange Chain',
        rpc: ['https://testnet-rpc.orangechain.xyz'],
        faucets: [],
        nativeCurrency: { name: 'BTC', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://orangechain.xyz',
        shortName: 'Orange-Chain-Testnet',
        chainId: 240515,
        networkId: 240515,
        icon: 'orange',
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://testnet-scan.orangechain.xyz',
                icon: 'orange',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWcaVLcPYBxi76HYJc4qudLJwXtfNCDJieLHAs632jMEA'
    },
    241120: {
        name: 'Anomaly Andromeda Testnet',
        title: 'Anomaly Andromeda Testnet',
        chain: 'anomaly-andromeda-testnet',
        rpc: [
            'https://rpc.anomaly-andromeda.anomalygames.io',
            'wss://ws.anomaly-andromeda.anomalygames.io'
        ],
        nativeCurrency: { name: 'TestNom', symbol: 'tNOM', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/anomaly-andromeda-testnet',
        faucets: [],
        shortName: 'anomaly-andromeda-testnet',
        chainId: 241120,
        networkId: 241120,
        slip44: 60,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://andromeda.anomalyscan.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-421614',
            bridges: [
                {
                    url: 'https://bridge.gelato.network/bridge/anomaly-andromeda-testnet'
                }
            ]
        }
    },
    246529: {
        name: 'ARTIS sigma1',
        chain: 'ARTIS',
        rpc: ['https://rpc.sigma1.artis.network'],
        faucets: [],
        nativeCurrency: { name: 'ARTIS sigma1 Ether', symbol: 'ATS', decimals: 18 },
        infoURL: 'https://artis.eco',
        shortName: 'ats',
        chainId: 246529,
        networkId: 246529,
        slip44: 246529
    },
    246785: {
        name: 'ARTIS Testnet tau1',
        chain: 'ARTIS',
        rpc: ['https://rpc.tau1.artis.network'],
        faucets: [],
        nativeCurrency: { name: 'ARTIS tau1 Ether', symbol: 'tATS', decimals: 18 },
        infoURL: 'https://artis.network',
        shortName: 'atstau',
        chainId: 246785,
        networkId: 246785,
        slip44: 1
    },
    247253: {
        name: 'Saakuru Testnet',
        chain: 'Saakuru',
        icon: 'saakuru',
        rpc: ['https://rpc-testnet.saakuru.network'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://saakuru.network',
        shortName: 'saakuru-testnet',
        chainId: 247253,
        networkId: 247253,
        slip44: 1,
        explorers: [
            {
                name: 'saakuru-explorer-testnet',
                url: 'https://explorer-testnet.saakuru.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmduEdtFobPpZWSc45MU6RKxZfTEzLux2z8ikHFhT8usqv'
    },
    252525: {
        name: 'CELESTIUM Network Testnet',
        chain: 'CELESTIUM',
        rpc: ['https://rpc-private-testnet.celestium.network'],
        faucets: ['https://faucet.celestium.network'],
        nativeCurrency: { name: 'CLT', symbol: 'tCLT', decimals: 18 },
        infoURL: 'https://celestium.network',
        shortName: 'tclt',
        chainId: 252525,
        networkId: 252525,
        slip44: 1,
        icon: 'celestium',
        explorers: [
            {
                name: 'CELESTIUM Testnet Explorer',
                icon: 'celestium',
                url: 'https://testnet.celestium.network',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdoqEVRnp6Z49VTxEjPMRMAfUv1CbN7wbFw5G1S34SqeA'
    },
    256256: {
        name: 'CMP-Mainnet',
        chain: 'CMP',
        rpc: [
            'https://mainnet.block.caduceus.foundation',
            'wss://mainnet.block.caduceus.foundation'
        ],
        faucets: [],
        nativeCurrency: { name: 'Caduceus Token', symbol: 'CMP', decimals: 18 },
        infoURL: 'https://caduceus.foundation/',
        shortName: 'cmp-mainnet',
        chainId: 256256,
        networkId: 256256,
        explorers: [
            {
                name: 'Mainnet Scan',
                url: 'https://mainnet.scan.caduceus.foundation',
                standard: 'none'
            }
        ]
    },
    262371: {
        name: 'Eclat Testnet',
        chain: 'Eclat',
        icon: 'eclat',
        rpc: ['https://testnet-rpc.eclatscan.com'],
        faucets: ['https://faucet.eclatscan.com'],
        nativeCurrency: { name: 'Eclat Testnet', symbol: 'ECLAT', decimals: 18 },
        infoURL: 'https://testnet-explorer.eclatscan.com',
        shortName: 'tECLAT',
        chainId: 262371,
        networkId: 262371,
        explorers: [
            {
                name: 'Eclat Testnet Explorer',
                url: 'https://testnet-explorer.eclatscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeigpyvnir6awzgeazkk5xdkvexw7w6ww3yxawszue6zms4a5ygdfky'
    },
    266256: {
        name: 'Gear Zero Network Testnet',
        chain: 'GearZero',
        rpc: ['https://gzn-test.linksme.info'],
        faucets: [],
        nativeCurrency: {
            name: 'Gear Zero Network Native Token',
            symbol: 'GZN',
            decimals: 18
        },
        infoURL: 'https://token.gearzero.ca/testnet',
        shortName: 'gz-testnet',
        chainId: 266256,
        networkId: 266256,
        slip44: 1,
        explorers: []
    },
    271271: {
        name: 'EgonCoin Testnet',
        chain: 'EGON',
        icon: 'egonicon',
        rpc: ['https://rpctest.egonscan.com'],
        faucets: ['https://faucet.egonscan.com'],
        nativeCurrency: { name: 'EgonCoin', symbol: 'EGON', decimals: 18 },
        infoURL: 'https://egonscan.com',
        shortName: 'EGONt',
        chainId: 271271,
        networkId: 271271,
        slip44: 1,
        explorers: [
            {
                name: 'EgonCoin Testnet',
                url: 'https://testnet.egonscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNZiMmzMQYjyGtNSghtzLg4UooYhDgMQsa677DAP5KsBg'
    },
    272247: {
        name: 'Nxy Area 51',
        chain: 'NXY',
        rpc: ['https://nxy.social/testnet'],
        faucets: [],
        nativeCurrency: { name: 'Nxy', symbol: 'NXY', decimals: 18 },
        infoURL: 'https://nxy.social/l1',
        shortName: 'nxytest',
        chainId: 272247,
        networkId: 272247,
        slip44: 272247,
        explorers: [
            {
                name: 'Nxy Explorer',
                url: 'https://explorer.nxy.social',
                standard: 'none'
            }
        ]
    },
    272520: {
        name: 'Nxy Oasis',
        chain: 'NXY',
        rpc: ['https://nxy.social/mainnet'],
        faucets: [],
        nativeCurrency: { name: 'Nxy', symbol: 'NXY', decimals: 18 },
        infoURL: 'https://nxy.social/l1',
        shortName: 'nxy',
        chainId: 272520,
        networkId: 272520,
        slip44: 272520,
        explorers: [
            {
                name: 'Nxy Explorer',
                url: 'https://explorer.nxy.social',
                standard: 'none'
            }
        ]
    },
    281121: {
        name: 'Social Smart Chain Mainnet',
        chain: 'SoChain',
        rpc: ['https://socialsmartchain.digitalnext.business'],
        faucets: [],
        nativeCurrency: { name: 'SoChain', symbol: '$OC', decimals: 18 },
        infoURL: 'https://digitalnext.business/SocialSmartChain',
        shortName: 'SoChain',
        chainId: 281121,
        networkId: 281121,
        explorers: []
    },
    281123: {
        name: 'Athene Parthenon',
        chain: 'athene-parthenon',
        rpc: [
            'https://rpc.parthenon.athenescan.io',
            'wss://ws.parthenon.athenescan.io'
        ],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/athene-parthenon',
        faucets: [],
        shortName: 'athene-parthenon',
        chainId: 281123,
        networkId: 281123,
        slip44: 60,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://parthenon.athenescan.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111' },
        status: 'active'
    },
    282828: {
        name: 'Zillion Sepolia Testnet',
        status: 'active',
        chain: 'ETH',
        rpc: ['https://sepolia.zillnet.io/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://zillnet.io',
        shortName: 'zillsep',
        chainId: 282828,
        networkId: 282828,
        slip44: 1,
        icon: 'zillion',
        explorers: [
            {
                name: 'zillscout',
                url: 'https://sepolia.zillnet.io',
                icon: 'zillion',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111' },
        iconURL: 'https://ipfs.io/ipfs/QmfVmjLNiBh8KyCr9mwDZh34aEhhQ2LAjuP87DFxhfd9nn'
    },
    292003: {
        name: 'Cipherem Testnet',
        chain: 'Cipherem',
        rpc: ['https://testnet.cipherem.com'],
        faucets: [],
        nativeCurrency: { name: 'CIP', symbol: 'CIP', decimals: 18 },
        infoURL: 'https://www.cipherem.com',
        shortName: 'CIP',
        chainId: 292003,
        networkId: 292003,
        slip44: 1,
        icon: 'cipherem',
        explorers: [
            {
                name: 'Cipherscan Testnet Explorer',
                icon: 'cipherscan',
                url: 'https://cipherscan.net',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmP8oHKtqUiSxmNcZMFMy5DSFCZQm17uF32FEHojx8HQ5z'
    },
    309075: {
        name: 'One World Chain Mainnet',
        chain: 'One World Chain',
        icon: 'oneWorldChainIcon',
        rpc: ['https://mainnet-rpc.oneworldchain.org'],
        faucets: [],
        nativeCurrency: { name: 'OWCT', symbol: 'OWCT', decimals: 18 },
        infoURL: 'https://oneworldchain.org',
        shortName: 'OWCTm',
        chainId: 309075,
        networkId: 309075,
        explorers: [
            {
                name: 'One World Chain Mainnet Explorer',
                url: 'https://mainnet.oneworldchain.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPmZ6vgtdMG7jttVZQUobF96Sva1noi5Fsi28V1Eck6eC'
    },
    313313: {
        name: 'SaharaAI Testnet',
        chain: 'Sahara',
        rpc: ['https://testnet.saharalabs.ai'],
        faucets: [],
        nativeCurrency: { name: 'Sahara AI', symbol: 'SAHARA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://saharalabs.ai',
        shortName: 'saharatest',
        chainId: 313313,
        networkId: 313313,
        icon: 'sahara',
        explorers: [
            {
                name: 'Testnet Scan',
                url: 'https://testnet-explorer.saharalabs.ai',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibhofpvuswlhmfniolskoguhjr4p7strqgm5uz7tu53s5gv35qwem'
    },
    314159: {
        name: 'Filecoin - Calibration testnet',
        chain: 'FIL',
        icon: 'filecoin',
        rpc: [
            'https://api.calibration.node.glif.io/rpc/v1',
            'https://rpc.ankr.com/filecoin_testnet',
            'https://filecoin-calibration.chainstacklabs.com/rpc/v1',
            'https://filecoin-calibration.chainup.net/rpc/v1',
            'https://calibration.filfox.info/rpc/v1',
            'https://filecoin-calibration.drpc.org',
            'wss://filecoin-calibration.drpc.org'
        ],
        faucets: ['https://faucet.calibration.fildev.network/'],
        nativeCurrency: { name: 'testnet filecoin', symbol: 'tFIL', decimals: 18 },
        infoURL: 'https://filecoin.io',
        shortName: 'filecoin-calibration',
        chainId: 314159,
        networkId: 314159,
        slip44: 1,
        explorers: [
            {
                name: 'Filscan - Calibration',
                url: 'https://calibration.filscan.io',
                standard: 'none'
            },
            {
                name: 'Filscout - Calibration',
                url: 'https://calibration.filscout.com/en',
                standard: 'none'
            },
            {
                name: 'Filfox - Calibration',
                url: 'https://calibration.filfox.info',
                standard: 'none'
            },
            {
                name: 'Glif Explorer - Calibration',
                url: 'https://explorer.glif.io/?network=calibration',
                standard: 'none'
            },
            { name: 'Beryx', url: 'https://beryx.zondax.ch', standard: 'none' }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmS9r9XQkMHVomWcSBNDkKkz9n87h9bH9ssabeiKZtANoU'
    },
    322202: {
        name: 'Parex Mainnet',
        title: 'Parex Mainnet',
        chain: 'Parex',
        rpc: ['https://mainnet-rpc.parex.network'],
        faucets: [],
        nativeCurrency: { name: 'PAREX', symbol: 'PRX', decimals: 18 },
        infoURL: 'https://parex.network',
        shortName: 'parex',
        chainId: 322202,
        networkId: 322202,
        icon: 'parexmain',
        explorers: [
            {
                name: 'Parex Mainnet Explorer',
                url: 'https://scan.parex.network',
                icon: 'parexmain',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSPD3QcjFJL2KpYRnNDxa8Xg5rcSgPugG9kcBBNeavVKi'
    },
    323213: {
        name: 'Bloom Genesis Testnet',
        chain: 'Bloom',
        icon: 'bloom',
        rpc: ['https://testnet-rpc.bloomgenesis.com'],
        faucets: ['https://faucet.bloomgenesis.com'],
        nativeCurrency: { name: 'Bloom', symbol: 'BGBC', decimals: 18 },
        infoURL: 'https://www.bloomgenesis.com',
        shortName: 'BGBC-Testnet',
        chainId: 323213,
        networkId: 323213,
        explorers: [
            {
                name: 'Bloom Genesis Testnet',
                url: 'https://testnet.bloomgenesis.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmetu9hMLvczYo7tDPRyjqjBHwwpHU8mEgW3PEPPre56su'
    },
    325000: {
        name: 'Camp Network Testnet V2',
        chain: 'ETH',
        icon: 'camp',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        rpc: ['https://rpc-campnetwork.xyz'],
        faucets: ['https://www.campnetwork.xyz/faucet'],
        nativeCurrency: { name: 'Ethereum', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://docs.campnetwork.xyz/',
        shortName: 'CampV2',
        chainId: 325000,
        networkId: 325000,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://camp-network-testnet.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [
                {
                    url: 'https://bridge.gelato.network/bridge/camp-network-testnet'
                }
            ]
        },
        iconURL: 'https://ipfs.io/ipfs/QmZN3AzgetKvuTnZvsPPYTvtcsPa73ScGdTguXGHxc2CpN'
    },
    327126: {
        name: 'WABA Chain Testnet',
        chain: 'WABA Mainnet',
        icon: 'waba',
        rpc: ['https://rpc.wabaworld.com'],
        faucets: [],
        nativeCurrency: { name: 'WABA', symbol: 'WABA', decimals: 18 },
        infoURL: 'https://www.wabanetwork.org',
        shortName: 'waba',
        chainId: 327126,
        networkId: 327126,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.wabaworld.com',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmX3NPsVTaBQDBySzMKZLVJhN4kakkAwrfz9mrqmUhNzUU'
    },
    328527: {
        name: 'Nal Mainnet',
        chain: 'ETH',
        icon: 'nal',
        rpc: ['https://rpc.nal.network', 'wss://wss.nal.network'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.nal.network',
        shortName: 'nal',
        chainId: 328527,
        networkId: 328527,
        explorers: [
            {
                name: 'Nal Network Explorer',
                url: 'https://scan.nal.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZLZHX18YUswejxo1JFNPx5EwMsVhUwBeBWEcd1JUHAK5'
    },
    330844: {
        name: 'TTcoin Smart Chain Mainnet',
        chain: 'TSC',
        icon: 'tscscan',
        rpc: ['https://mainnet-rpc.tscscan.com'],
        faucets: ['https://faucet.tscscan.com'],
        nativeCurrency: { name: 'TTcoin', symbol: 'TC', decimals: 18 },
        infoURL: 'https://ttcoin.info/',
        shortName: 'tc',
        chainId: 330844,
        networkId: 330844,
        explorers: [
            {
                name: 'TTcoin Smart Chain Explorer',
                url: 'https://tscscan.com',
                standard: 'EIP3091',
                icon: 'tscscan'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmS7ipvvyZ16weG1DM7AZbi1v9ixYwU2FjP25Jj5jkLiuf'
    },
    333313: {
        name: 'Bloom Genesis Mainnet',
        chain: 'Bloom',
        icon: 'bloom',
        rpc: ['https://mainnet-rpc.bloomgenesis.com'],
        faucets: [],
        nativeCurrency: { name: 'Bloom', symbol: 'BGBC', decimals: 18 },
        infoURL: 'https://www.bloomgenesis.com',
        shortName: 'BGBC',
        chainId: 333313,
        networkId: 333313,
        explorers: [
            {
                name: 'Bloom Genesis Mainnet',
                url: 'https://explorer.bloomgenesis.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmetu9hMLvczYo7tDPRyjqjBHwwpHU8mEgW3PEPPre56su'
    },
    333331: {
        name: 'Aves Testnet',
        chain: 'AVST',
        rpc: ['https://test.rpc.avescoin.io'],
        faucets: [],
        nativeCurrency: { name: 'AvesT', symbol: 'AVST', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://ethereum.org',
        shortName: 'avst',
        chainId: 333331,
        networkId: 333331,
        slip44: 1,
        icon: 'aves',
        explorers: [
            {
                name: 'avescan',
                url: 'https://testnet.avescoin.io',
                icon: 'avescan',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeKQVv2QneHaaggw2NfpZ7DGMdjVhPywTdse5RzCs4oGn'
    },
    333333: {
        name: 'Nativ3 Testnet',
        chainId: 333333,
        shortName: 'N3-Test',
        chain: 'N3-Test',
        icon: 'nativ3',
        networkId: 333333,
        slip44: 1,
        nativeCurrency: { name: 'USNT', symbol: 'USNT', decimals: 18 },
        rpc: ['https://rpctest.nativ3.network', 'wss://wstest.nativ3.network'],
        faucets: [],
        explorers: [
            {
                name: 'Nativ3 Test Explorer',
                url: 'https://scantest.nativ3.network',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://nativ3.network',
        parent: {
            type: 'L2',
            chain: 'eip155-421613',
            bridges: [{ url: 'https://bridgetest.nativ3.network' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmVzJDndPui6qBSeJWe5kMLA56C3KpVhqqqk9xvVKE1DGb'
    },
    333666: {
        name: 'Oone Chain Testnet',
        chain: 'OONE Testnet',
        rpc: ['https://rpc.testnet.oonechain.com'],
        faucets: ['https://apps-test.adigium.com/faucet'],
        nativeCurrency: { name: 'tOONE', symbol: 'tOONE', decimals: 18 },
        infoURL: 'https://oonechain.com',
        shortName: 'oonetest',
        chainId: 333666,
        networkId: 333666,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet.oonescan.com',
                standard: 'none'
            }
        ]
    },
    333777: {
        name: 'Oone Chain Devnet',
        chain: 'OONE Devnet',
        rpc: ['https://rpc.dev.oonechain.com'],
        faucets: ['https://apps-test.adigium.com/faucet'],
        nativeCurrency: { name: 'tOONE', symbol: 'tOONE', decimals: 18 },
        infoURL: 'https://oonechain.com',
        shortName: 'oonedev',
        chainId: 333777,
        networkId: 333777,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://dev.oonescan.com',
                standard: 'none'
            }
        ]
    },
    333888: {
        name: 'Polis Testnet',
        chain: 'Sparta',
        icon: 'polis',
        rpc: ['https://sparta-rpc.polis.tech'],
        faucets: ['https://faucet.polis.tech'],
        nativeCurrency: { name: 'tPolis', symbol: 'tPOLIS', decimals: 18 },
        infoURL: 'https://polis.tech',
        shortName: 'sparta',
        chainId: 333888,
        networkId: 333888,
        slip44: 1,
        iconURL: 'https://ipfs.io/ipfs/QmagWrtyApex28H2QeXcs3jJ2F7p2K7eESz3cDbHdQ3pjG'
    },
    333999: {
        name: 'Polis Mainnet',
        chain: 'Olympus',
        icon: 'polis',
        rpc: ['https://rpc.polis.tech'],
        faucets: ['https://faucet.polis.tech'],
        nativeCurrency: { name: 'Polis', symbol: 'POLIS', decimals: 18 },
        infoURL: 'https://polis.tech',
        shortName: 'olympus',
        chainId: 333999,
        networkId: 333999,
        iconURL: 'https://ipfs.io/ipfs/QmagWrtyApex28H2QeXcs3jJ2F7p2K7eESz3cDbHdQ3pjG'
    },
    336655: {
        name: 'UPchain Testnet',
        chain: 'UPchain',
        rpc: ['https://rpc-testnet.uniport.network'],
        faucets: ['https://faucet-testnet.uniport.network'],
        nativeCurrency: { name: 'UBTC', symbol: 'UBTC', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://uniport.network',
        shortName: 'UPchain-testnet',
        chainId: 336655,
        networkId: 336655,
        icon: 'up',
        explorers: [
            {
                name: 'UPchain Testnet Explorer',
                url: 'https://explorer-testnet.uniport.network',
                icon: 'up',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNMqcPyQnaaFfUDsmsnu2T6agZfoWij3zFYebCNUPkfAH'
    },
    336666: {
        name: 'UPchain Mainnet',
        chain: 'UPchain',
        rpc: ['https://rpc.uniport.network'],
        nativeCurrency: { name: 'UBTC', symbol: 'UBTC', decimals: 18 },
        features: [{ name: 'EIP155' }],
        faucets: [],
        infoURL: 'https://uniport.network',
        shortName: 'UPchain-mainnet',
        chainId: 336666,
        networkId: 336666,
        icon: 'up',
        explorers: [
            {
                name: 'UPchain Mainnet Explorer',
                url: 'https://explorer.uniport.network',
                icon: 'up',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNMqcPyQnaaFfUDsmsnu2T6agZfoWij3zFYebCNUPkfAH'
    },
    355110: {
        name: 'Bitfinity Network Mainnet',
        chain: 'BTF',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        rpc: ['https://mainnet.bitfinity.network'],
        faucets: [],
        nativeCurrency: { name: 'Bitfinity Token', symbol: 'BTF', decimals: 18 },
        infoURL: 'https://bitfinity.network',
        shortName: 'bitfinity-mainnet',
        chainId: 355110,
        networkId: 355110,
        explorers: [
            {
                name: 'Bitfinity Mainnet Block Explorer',
                url: 'https://explorer.mainnet.bitfinity.network',
                icon: 'bitfinity',
                standard: 'EIP3091'
            }
        ]
    },
    355113: {
        name: 'Bitfinity Network Testnet',
        chain: 'BTF',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        rpc: ['https://testnet.bitfinity.network'],
        faucets: ['https://bitfinity.network/faucet'],
        nativeCurrency: { name: 'Bitfinity Token', symbol: 'BTF', decimals: 18 },
        infoURL: 'https://bitfinity.network',
        shortName: 'bitfinity-testnet',
        chainId: 355113,
        networkId: 355113,
        explorers: [
            {
                name: 'Bitfinity Testnet Block Explorer',
                url: 'https://explorer.testnet.bitfinity.network',
                icon: 'bitfinity',
                standard: 'EIP3091'
            },
            {
                name: 'Bitfinity Testnet Block Explorer',
                url: 'https://bitfinity-test.dex.guru',
                icon: 'dexguru',
                standard: 'EIP3091'
            }
        ]
    },
    360890: {
        name: 'LAVITA Mainnet',
        chain: 'LAVITA',
        icon: 'lavita',
        rpc: ['https://tsub360890-eth-rpc.thetatoken.org/rpc'],
        faucets: [],
        nativeCurrency: { name: 'vTFUEL', symbol: 'vTFUEL', decimals: 18 },
        infoURL: 'https://www.lavita.ai',
        shortName: 'lavita-mainnet',
        chainId: 360890,
        networkId: 360890,
        explorers: [
            {
                name: 'LAVITA Mainnet Explorer',
                url: 'https://tsub360890-explorer.thetatoken.org',
                icon: 'lavita',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfHbWCxwSjf8qmg4yw8jySHZijRXTPW8f5xd2T5sjbeCY'
    },
    363636: {
        name: 'Digit Soul Smart Chain 2',
        chain: 'DS2',
        rpc: ['https://dgs-rpc.digitsoul.co.th'],
        faucets: [],
        icon: 'pnet',
        nativeCurrency: { name: 'Digit Coin', symbol: 'DGC', decimals: 18 },
        infoURL: '',
        shortName: 'DS2',
        chainId: 363636,
        networkId: 363636,
        explorers: [
            {
                name: 'Digit Soul Explorer',
                url: 'https://dgs-exp.digitsoul.co.th',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRiAUu3xV5uiX6Nk1iXD5w6qjki5ugGFETRVavzJ2h5QF'
    },
    373737: {
        name: 'HAPchain Testnet',
        chain: 'HAPchain',
        rpc: ['https://jsonrpc-test.hap.land'],
        faucets: [],
        nativeCurrency: { name: 'HAP', symbol: 'HAP', decimals: 18 },
        infoURL: 'https://hap.land',
        shortName: 'hap-testnet',
        chainId: 373737,
        networkId: 373737,
        slip44: 1,
        icon: 'hap',
        explorers: [
            {
                name: 'HAP EVM Explorer (Blockscout)',
                url: 'https://blockscout-test.hap.land',
                standard: 'none',
                icon: 'hap'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQ4V9JC25yUrYk2kFJwmKguSsZBQvtGcg6q9zkDV8mkJW'
    },
    381931: {
        name: 'Metal C-Chain',
        chain: 'Metal',
        rpc: ['https://api.metalblockchain.org/ext/bc/C/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Metal', symbol: 'METAL', decimals: 18 },
        infoURL: 'https://www.metalblockchain.org/',
        shortName: 'metal',
        chainId: 381931,
        networkId: 381931,
        slip44: 9005,
        explorers: [
            {
                name: 'metalscan',
                url: 'https://metalscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    381932: {
        name: 'Metal Tahoe C-Chain',
        chain: 'Metal',
        rpc: ['https://tahoe.metalblockchain.org/ext/bc/C/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Metal', symbol: 'METAL', decimals: 18 },
        infoURL: 'https://www.metalblockchain.org/',
        shortName: 'Tahoe',
        chainId: 381932,
        networkId: 381932,
        slip44: 9005,
        explorers: [
            {
                name: 'metalscan',
                url: 'https://tahoe.metalscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    383353: {
        name: 'CheeseChain',
        title: 'CheeseChain',
        chain: 'CHEESE',
        rpc: ['https://rpc.cheesechain.xyz'],
        faucets: [],
        nativeCurrency: { name: 'CHEESE', symbol: 'CHEESE', decimals: 18 },
        infoURL: 'https://cheesechain.xyz',
        shortName: 'CheeseChain',
        chainId: 383353,
        networkId: 383353,
        icon: 'cheesechain',
        iconURL: 'https://ipfs.io/ipfs/QmNixMsKsnQKM925X3w85TBgFRFRFAe4gGGQw79UnT8BrV'
    },
    404040: {
        name: 'Tipboxcoin Mainnet',
        chain: 'TPBX',
        icon: 'tipboxcoinIcon',
        rpc: ['https://mainnet-rpc.tipboxcoin.net'],
        faucets: ['https://faucet.tipboxcoin.net'],
        nativeCurrency: { name: 'Tipboxcoin', symbol: 'TPBX', decimals: 18 },
        infoURL: 'https://tipboxcoin.net',
        shortName: 'TPBXm',
        chainId: 404040,
        networkId: 404040,
        explorers: [
            {
                name: 'Tipboxcoin',
                url: 'https://tipboxcoin.net',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbiaHnR3fVVofZ7Xq2GYZxwHkLEy3Fh5qDtqnqXD6ACAh'
    },
    413413: {
        name: 'AIE Testnet',
        chain: 'AIE',
        rpc: ['https://rpc1-testnet.aiechain.io'],
        faucets: [],
        nativeCurrency: { name: 'AIE', symbol: 'AIE', decimals: 18 },
        infoURL: 'https://testnet.aiescan.io',
        shortName: 'aie',
        chainId: 413413,
        networkId: 413413,
        icon: 'aie',
        explorers: [
            {
                name: 'aiescan-testnet',
                icon: 'aie',
                url: 'https://testnet.aiescan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihok46mhn5yf7b5jgmq7tiyw2fw76wklvj4frpc3gbswgfxzerhhm'
    },
    420000: {
        name: 'Infinaeon',
        chain: 'Infinaeon',
        rpc: ['https://rpc.infinaeon.com'],
        faucets: [],
        nativeCurrency: { name: 'Ethereum', symbol: 'ETH', decimals: 18 },
        infoURL: 'hhttps://rpc.infinaeon.com',
        shortName: 'Infinaeon',
        chainId: 420000,
        networkId: 420000,
        explorers: [
            {
                name: 'tracehawk',
                url: 'https://explorer.infinaeon.com',
                standard: 'none'
            }
        ]
    },
    420042: {
        name: 'Vector Smart Chain',
        chain: 'VSC',
        icon: 'vectorsmartgas',
        rpc: ['https://rpc.vscblockchain.org'],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: { name: 'Vector Smart Gas', symbol: 'VSG', decimals: 18 },
        infoURL: 'https://vsgofficial.com',
        shortName: 'vsg',
        chainId: 420042,
        networkId: 420042,
        explorers: [
            {
                name: 'vscexplorer',
                url: 'https://explorer.vscblockchain.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRRoNvamJavpaFsxS1PPxyxDZ7q8akcdeNrrQXWmg2fux'
    },
    420420: {
        name: 'Kekchain',
        chain: 'kek',
        rpc: ['https://mainnet.kekchain.com'],
        faucets: [],
        nativeCurrency: { name: 'KEK', symbol: 'KEK', decimals: 18 },
        infoURL: 'https://kekchain.com',
        shortName: 'KEK',
        chainId: 420420,
        networkId: 103090,
        icon: 'kek',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://mainnet-explorer.kekchain.com',
                icon: 'kek',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNzwHAmaaQyuvKudrzGkrTT2GMshcmCmJ9FH8gG2mNJtM'
    },
    420666: {
        name: 'Kekchain (kektest)',
        chain: 'kek',
        rpc: ['https://testnet.kekchain.com'],
        faucets: [],
        nativeCurrency: { name: 'tKEK', symbol: 'tKEK', decimals: 18 },
        infoURL: 'https://kekchain.com',
        shortName: 'tKEK',
        chainId: 420666,
        networkId: 1,
        slip44: 1,
        icon: 'kek',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet-explorer.kekchain.com',
                icon: 'kek',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNzwHAmaaQyuvKudrzGkrTT2GMshcmCmJ9FH8gG2mNJtM'
    },
    420692: {
        name: 'Alterium L2 Testnet',
        chain: 'ALT',
        icon: 'alterium',
        rpc: ['https://l2-testnet-rpc.altscan.org'],
        faucets: [],
        nativeCurrency: { name: 'Alterium ETH', symbol: 'AltETH', decimals: 18 },
        infoURL: 'https://alteriumprotocol.org',
        shortName: 'alterium',
        chainId: 420692,
        networkId: 420692,
        slip44: 1,
        parent: {
            type: 'L2',
            chain: 'eip155-5',
            bridges: [{ url: 'https://testnet-bridge.alteriumprotocol.org' }]
        },
        explorers: [
            {
                name: 'Alterium L2 Testnet Explorer',
                url: 'https://l2-testnet.altscan.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreid3v7ow4c4t3ljya6aouiwvqbtssb2lzmkwt2eghryk234g7yynrq'
    },
    421611: {
        name: 'Arbitrum Rinkeby',
        title: 'Arbitrum Testnet Rinkeby',
        chainId: 421611,
        shortName: 'arb-rinkeby',
        chain: 'ETH',
        networkId: 421611,
        slip44: 1,
        nativeCurrency: {
            name: 'Arbitrum Rinkeby Ether',
            symbol: 'ETH',
            decimals: 18
        },
        rpc: ['https://rinkeby.arbitrum.io/rpc'],
        faucets: ['http://fauceth.komputing.org?chain=421611&address=${ADDRESS}'],
        infoURL: 'https://arbitrum.io',
        explorers: [
            {
                name: 'arbiscan-testnet',
                url: 'https://testnet.arbiscan.io',
                standard: 'EIP3091'
            },
            {
                name: 'arbitrum-rinkeby',
                url: 'https://rinkeby-explorer.arbitrum.io',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-4',
            bridges: [{ url: 'https://bridge.arbitrum.io' }]
        }
    },
    421613: {
        name: 'Arbitrum Goerli',
        title: 'Arbitrum Goerli Rollup Testnet',
        chainId: 421613,
        shortName: 'arb-goerli',
        chain: 'ETH',
        networkId: 421613,
        slip44: 1,
        nativeCurrency: {
            name: 'Arbitrum Goerli Ether',
            symbol: 'AGOR',
            decimals: 18
        },
        rpc: [
            'https://goerli-rollup.arbitrum.io/rpc',
            'https://arbitrum-goerli.publicnode.com',
            'wss://arbitrum-goerli.publicnode.com'
        ],
        faucets: [],
        infoURL: 'https://arbitrum.io/',
        explorers: [
            {
                name: 'Arbitrum Goerli Arbiscan',
                url: 'https://goerli.arbiscan.io',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-5',
            bridges: [{ url: 'https://bridge.arbitrum.io/' }]
        }
    },
    421614: {
        name: 'Arbitrum Sepolia',
        title: 'Arbitrum Sepolia Rollup Testnet',
        chain: 'ETH',
        rpc: [
            'https://sepolia-rollup.arbitrum.io/rpc',
            'https://arbitrum-sepolia.infura.io/v3/${INFURA_API_KEY}',
            'https://arbitrum-sepolia-rpc.publicnode.com',
            'wss://arbitrum-sepolia-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://arbitrum.io',
        shortName: 'arb-sep',
        chainId: 421614,
        networkId: 421614,
        slip44: 1,
        explorers: [
            {
                name: 'arbiscan-sepolia',
                url: 'https://sepolia.arbiscan.io',
                standard: 'EIP3091'
            },
            {
                name: 'Arbitrum Sepolia Rollup Testnet Explorer',
                url: 'https://sepolia-explorer.arbitrum.io',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge.arbitrum.io' }]
        }
    },
    424242: {
        name: 'Fastex Chain testnet',
        chain: 'FTN',
        title: 'Fastex Chain testnet',
        rpc: ['https://rpc.testnet.fastexchain.com'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'FTN', symbol: 'FTN', decimals: 18 },
        infoURL: 'https://fastex.com',
        shortName: 'fastexTestnet',
        chainId: 424242,
        networkId: 424242,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet.ftnscan.com',
                standard: 'none'
            }
        ]
    },
    431140: {
        name: 'Markr Go',
        chain: 'Unified',
        icon: 'markrgo',
        rpc: ['https://rpc.markr.io/ext/'],
        faucets: [],
        nativeCurrency: { name: 'Avalanche', symbol: 'AVAX', decimals: 18 },
        infoURL: 'https://www.markr.io/',
        shortName: 'markr-go',
        chainId: 431140,
        networkId: 431140,
        explorers: [],
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/QmVMBTZVPawyLBD2B5VbG68dfWLfZ1CnB8V59xduBe2kwh'
    },
    432201: {
        name: 'Dexalot Subnet Testnet',
        chain: 'DEXALOT',
        icon: 'dexalot',
        rpc: ['https://subnets.avax.network/dexalot/testnet/rpc'],
        faucets: ['https://faucet.avax.network/?subnet=dexalot'],
        nativeCurrency: { name: 'Dexalot', symbol: 'ALOT', decimals: 18 },
        infoURL: 'https://dexalot.com',
        shortName: 'dexalot-testnet',
        chainId: 432201,
        networkId: 432201,
        slip44: 1,
        explorers: [
            {
                name: 'Avalanche Subnet Testnet Explorer',
                url: 'https://subnets-test.avax.network/dexalot',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfVxdrWjtUKiGzqFDzAxHH2FqwP2aRuZTGcYWdWg519Xy'
    },
    432204: {
        name: 'Dexalot Subnet',
        chain: 'DEXALOT',
        icon: 'dexalot',
        rpc: ['https://subnets.avax.network/dexalot/mainnet/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Dexalot', symbol: 'ALOT', decimals: 18 },
        infoURL: 'https://dexalot.com',
        shortName: 'dexalot',
        chainId: 432204,
        networkId: 432204,
        explorers: [
            {
                name: 'Avalanche Subnet Explorer',
                url: 'https://subnets.avax.network/dexalot',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfVxdrWjtUKiGzqFDzAxHH2FqwP2aRuZTGcYWdWg519Xy'
    },
    440017: {
        name: 'Graphite Mainnet',
        chain: 'Graphite',
        rpc: [
            'https://anon-entrypoint-1.atgraphite.com',
            'wss://ws-anon-entrypoint-1.atgraphite.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Graphite', symbol: '@G', decimals: 18 },
        infoURL: 'https://atgraphite.com/',
        shortName: 'graphite',
        chainId: 440017,
        networkId: 440017,
        slip44: 440017,
        icon: 'graphite',
        explorers: [
            {
                name: 'Graphite Mainnet Explorer',
                url: 'https://main.atgraphite.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigzf3eo43njqreysfsnvot3rzdcvj642o4ekjhjla2efyuiy46vmu'
    },
    444444: {
        name: 'Syndr L3 Sepolia',
        title: 'Syndr L3 Sepolia Rollup Testnet',
        chain: 'SYNDRSEPOLIA',
        rpc: ['https://sepolia.syndr.com/http', 'wss://sepolia.syndr.com/ws'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://syndr.com',
        shortName: 'syndr',
        chainId: 444444,
        networkId: 444444,
        explorers: [
            {
                name: 'Syndr L3 Sepolia Testnet Explorer',
                url: 'https://sepolia-explorer.syndr.com',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-421614',
            bridges: [{ url: 'https://sepolia-bridge.syndr.com' }]
        }
    },
    444900: {
        name: 'Weelink Testnet',
        chain: 'WLK',
        rpc: ['https://weelinknode1c.gw002.oneitfarm.com'],
        faucets: ['https://faucet.weelink.gw002.oneitfarm.com'],
        nativeCurrency: {
            name: 'Weelink Chain Token',
            symbol: 'tWLK',
            decimals: 18
        },
        infoURL: 'https://weelink.cloud',
        shortName: 'wlkt',
        chainId: 444900,
        networkId: 444900,
        slip44: 1,
        explorers: [
            {
                name: 'weelink-testnet',
                url: 'https://weelink.cloud/#/blockView/overview',
                standard: 'none'
            }
        ]
    },
    471100: {
        name: 'Patex Sepolia Testnet',
        chain: 'ETH',
        rpc: ['https://test-rpc.patex.io/'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://patex.io/',
        shortName: 'psep',
        chainId: 471100,
        networkId: 471100,
        slip44: 1
    },
    473861: {
        name: 'Ultra Pro Mainnet',
        chain: 'ultrapro',
        icon: 'ultrapro',
        rpc: ['https://mainnet-rpc.ultraproscan.io'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Ultra Pro', symbol: 'UPRO', decimals: 18 },
        infoURL: 'https://ultrapro.info',
        shortName: 'ultrapro',
        chainId: 473861,
        networkId: 473861,
        explorers: [
            {
                name: 'ultraproscan',
                url: 'https://ultraproscan.io',
                icon: 'ultrapro',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmT11iJMLe9sAk5NiRQbe2wv1jtLFCs2sF2w9vFwDLkkgE'
    },
    474142: {
        name: 'OpenChain Mainnet',
        chain: 'OpenChain',
        rpc: ['https://baas-rpc.luniverse.io:18545?lChainId=1641349324562974539'],
        faucets: [],
        nativeCurrency: { name: 'OpenCoin', symbol: 'OPC', decimals: 10 },
        infoURL: 'https://www.openchain.live',
        shortName: 'oc',
        chainId: 474142,
        networkId: 474142,
        explorers: [
            {
                name: 'SIDE SCAN',
                url: 'https://sidescan.luniverse.io/1641349324562974539',
                standard: 'none'
            }
        ]
    },
    484752: {
        name: 'World Chain Sepolia Testnet Deprecated',
        status: 'deprecated',
        chain: 'ETH',
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://worldcoin.org/',
        shortName: 'wcsep-dep',
        rpc: [],
        faucets: [],
        chainId: 484752,
        networkId: 484752,
        slip44: 1
    },
    486487: {
        name: 'Gobbl Testnet',
        chain: 'Gobbl Testnet',
        rpc: ['https://rpc.gobbl.io'],
        faucets: ['https://faucet.gobbl.io'],
        nativeCurrency: { name: 'Gobbl Token', symbol: 'GOBBL', decimals: 18 },
        infoURL: 'https://www.gobbl.io/',
        shortName: 'gbl-testnet',
        chainId: 486487,
        networkId: 486487,
        icon: 'gobbl',
        explorers: [
            {
                name: 'Gobbl Testnet Explorer',
                url: 'https://explorer.gobbl.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQbJTFnUfWf31d16beZfqM4Fo5NRJjryNrDMyNfj9YQnS'
    },
    490000: {
        name: 'Autonomys Taurus Testnet',
        chain: 'autonomys-taurus-testnet',
        rpc: ['https://auto-evm.taurus.autonomys.xyz/ws'],
        icon: 'autonomys',
        faucets: [],
        nativeCurrency: { name: 'AI3', symbol: 'AI3', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.autonomys.xyz',
        shortName: 'ATN',
        chainId: 490000,
        networkId: 490000,
        explorers: [
            {
                name: 'Autonomys Taurus Testnet Explorer',
                url: 'https://blockscout.taurus.autonomys.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreic62smuudotw6iq724fvysujakoonb3iwtwo6t4hr6ldursz5jyo4'
    },
    490092: {
        name: 'PUMPFI CHAIN TESTNET',
        chain: 'PUMPFI CHAIN TESTNET',
        rpc: ['https://rpc1testnet.pumpfi.me'],
        faucets: ['https://faucet.pumpfi.me'],
        nativeCurrency: { name: 'PMPT', symbol: 'PMPT', decimals: 18 },
        infoURL: 'https://pumpfi.me',
        shortName: 'pumpfi-testnet',
        chainId: 490092,
        networkId: 490092,
        explorers: [
            {
                name: 'Pumpfi Testnet Scan',
                url: 'https://testnetscan.pumpfi.me',
                standard: 'EIP3091'
            }
        ]
    },
    504441: {
        name: 'Playdapp Network',
        chain: 'PDA',
        icon: 'pda',
        rpc: ['https://subnets.avax.network/playdappne/mainnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Playdapp', symbol: 'PDA', decimals: 18 },
        infoURL: 'https://playdapp.io',
        shortName: 'PDA',
        chainId: 504441,
        networkId: 504441,
        explorers: [
            {
                name: 'Playdapp Explorer',
                url: 'https://subnets.avax.network/playdappne',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmY6AkNb5TYrDbM5M7YpSM8X3aYn2LcPXeLXz6F7WoB27r'
    },
    512512: {
        name: 'CMP-Testnet',
        chain: 'CMP',
        rpc: [
            'https://galaxy.block.caduceus.foundation',
            'wss://galaxy.block.caduceus.foundation'
        ],
        faucets: ['https://dev.caduceus.foundation/testNetwork'],
        nativeCurrency: {
            name: 'Caduceus Testnet Token',
            symbol: 'CMP',
            decimals: 18
        },
        infoURL: 'https://caduceus.foundation/',
        shortName: 'cmp',
        chainId: 512512,
        networkId: 512512,
        slip44: 1,
        explorers: [
            {
                name: 'Galaxy Scan',
                url: 'https://galaxy.scan.caduceus.foundation',
                standard: 'none'
            }
        ]
    },
    513100: {
        name: 'EthereumFair',
        chainId: 513100,
        networkId: 513100,
        shortName: 'ethf',
        chain: 'ETHF',
        nativeCurrency: { name: 'EthereumFair', symbol: 'ETHF', decimals: 18 },
        rpc: ['https://rpc.etherfair.org'],
        faucets: [],
        explorers: [
            {
                name: 'EthereumFair',
                url: 'https://www.oklink.com/ethf',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://etherfair.org/'
    },
    526916: {
        name: 'DoCoin Community Chain',
        title: 'DoCoin Community Chain',
        chain: 'DoCoin',
        rpc: ['https://rpc.docoin.shop'],
        faucets: [],
        nativeCurrency: { name: 'DO', symbol: 'DCT', decimals: 18 },
        infoURL: 'https://docoin.network',
        shortName: 'DoCoin',
        chainId: 526916,
        networkId: 526916,
        explorers: [
            {
                name: 'DoCoin Community Chain Explorer',
                url: 'https://explorer.docoin.shop',
                standard: 'EIP3091'
            }
        ]
    },
    534351: {
        name: 'Scroll Sepolia Testnet',
        chain: 'ETH',
        status: 'active',
        rpc: [
            'https://sepolia-rpc.scroll.io',
            'https://rpc.ankr.com/scroll_sepolia_testnet',
            'https://scroll-sepolia.chainstacklabs.com',
            'https://scroll-testnet-public.unifra.io',
            'https://scroll-sepolia-rpc.publicnode.com',
            'wss://scroll-sepolia-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://scroll.io',
        shortName: 'scr-sepolia',
        chainId: 534351,
        networkId: 534351,
        slip44: 1,
        explorers: [
            {
                name: 'Scroll Sepolia Etherscan',
                url: 'https://sepolia.scrollscan.com',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://sepolia.scroll.io/bridge' }]
        }
    },
    534352: {
        name: 'Scroll',
        chain: 'ETH',
        status: 'active',
        rpc: [
            'https://rpc.scroll.io',
            'https://rpc.ankr.com/scroll',
            'https://scroll-mainnet.chainstacklabs.com',
            'https://scroll-rpc.publicnode.com',
            'wss://scroll-rpc.publicnode.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://scroll.io',
        shortName: 'scr',
        chainId: 534352,
        networkId: 534352,
        explorers: [
            {
                name: 'Scrollscan',
                url: 'https://scrollscan.com',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://scroll.io/bridge' }]
        }
    },
    534353: {
        name: 'Scroll Alpha Testnet',
        chain: 'ETH',
        status: 'deprecated',
        rpc: ['https://alpha-rpc.scroll.io/l2'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://scroll.io',
        shortName: 'scr-alpha',
        chainId: 534353,
        networkId: 534353,
        slip44: 1,
        explorers: [
            {
                name: 'Scroll Alpha Testnet Block Explorer',
                url: 'https://alpha-blockscout.scroll.io',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-5', bridges: [] }
    },
    534354: {
        name: 'Scroll Pre-Alpha Testnet',
        chain: 'ETH',
        status: 'deprecated',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'TSETH', decimals: 18 },
        infoURL: 'https://scroll.io',
        shortName: 'scr-prealpha',
        chainId: 534354,
        networkId: 534354,
        slip44: 1,
        explorers: []
    },
    534849: {
        name: 'Shinarium Beta',
        chain: 'Shinarium',
        icon: 'shinarium',
        rpc: ['https://rpc.shinarium.org'],
        faucets: ['https://faucet.shinarium.org'],
        nativeCurrency: { name: 'Shina Inu', symbol: 'SHI', decimals: 18 },
        infoURL: 'https://shinarium.org',
        shortName: 'shi',
        chainId: 534849,
        networkId: 534849,
        explorers: [
            {
                name: 'shinascan',
                url: 'https://shinascan.shinarium.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeiadbavrwcial76vs5ovhyykyaobteltuhliqcthdairbja4klwzhu'
    },
    535037: {
        name: 'BeanEco SmartChain',
        title: 'BESC Mainnet',
        chain: 'BESC',
        rpc: ['https://mainnet-rpc.bescscan.io'],
        faucets: [],
        nativeCurrency: {
            name: 'BeanEco SmartChain',
            symbol: 'BESC',
            decimals: 18
        },
        infoURL: 'besceco.finance',
        shortName: 'BESC',
        chainId: 535037,
        networkId: 535037,
        explorers: [
            {
                name: 'bescscan',
                url: 'https://Bescscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    541764: {
        name: 'OverProtocol Testnet',
        chain: 'OverProtocol',
        icon: 'overIcon',
        rpc: ['https://rpc.dolphin.overprotocol.com'],
        faucets: [],
        nativeCurrency: { name: 'Over', symbol: 'OVER', decimals: 18 },
        infoURL: 'https://docs.over.network',
        shortName: 'overprotocol-testnet',
        chainId: 541764,
        networkId: 541764,
        explorers: [
            {
                name: 'OverView Testnet',
                url: 'https://dolphin-scan.over.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcxyEjW9G8K9JP6rZGjRmjJuS9BvgMwzL5dKM1nV2aPLs'
    },
    543210: {
        name: 'ZERO Network',
        chain: 'ZERONetwork',
        icon: 'zero',
        rpc: ['https://rpc.zerion.io/v1/zero'],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.zero.network' }]
        },
        faucets: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://docs.zero.network',
        shortName: 'zero-network',
        chainId: 543210,
        networkId: 543210,
        explorers: [
            {
                name: 'ZERO Network Explorer',
                url: 'https://explorer.zero.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWpvBtmDhZSAnRww5ZU6BvEbDbxKEzoyjWcanjc1UBD9X'
    },
    552981: {
        name: 'One World Chain Testnet',
        chain: 'One World Chain',
        icon: 'oneWorldChainIcon',
        rpc: ['https://testnet-rpc.oneworldchain.org'],
        faucets: ['https://faucet.oneworldchain.org'],
        nativeCurrency: { name: 'OWCT', symbol: 'OWCT', decimals: 18 },
        infoURL: 'https://oneworldchain.org',
        shortName: 'OWCTt',
        chainId: 552981,
        networkId: 552981,
        explorers: [
            {
                name: 'One World Chain Testnet Explorer',
                url: 'https://testnet.oneworldchain.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPmZ6vgtdMG7jttVZQUobF96Sva1noi5Fsi28V1Eck6eC'
    },
    555555: {
        name: 'Pentagon Testnet',
        chain: 'Pentagon',
        rpc: ['https://rpc-testnet.pentagon.games'],
        faucets: ['https://bridge-testnet.pentagon.games'],
        nativeCurrency: { name: 'Pentagon', symbol: 'PEN', decimals: 18 },
        icon: 'pentagon-testnet',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://pentagon.games',
        shortName: 'pentagon-testnet',
        chainId: 555555,
        networkId: 555555,
        explorers: [
            {
                name: 'Pentagon Testnet Explorer',
                url: 'https://explorer-testnet.pentagon.games',
                icon: 'pentagon',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfU7W3Tm3tGWgnHBTG9vjB4PXGMvcL7Cq8R6MaSaC33DC'
    },
    555666: {
        name: 'Eclipse Testnet',
        chain: 'ECLIPSE',
        rpc: ['https://subnets.avax.network/eclipsecha/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Eclipse', symbol: 'ECLPS', decimals: 18 },
        infoURL: 'http://eclipsenet.io',
        shortName: 'eclipset',
        chainId: 555666,
        networkId: 555666,
        explorers: [
            {
                name: 'ECLIPSE Explorer',
                url: 'https://subnets-test.avax.network/eclipsecha',
                standard: 'EIP3091'
            }
        ]
    },
    555777: {
        name: 'Xsolla ZK Sepolia Testnet',
        chain: 'Xsolla ZK Sepolia',
        rpc: ['https://zkrpc-sepolia.xsollazk.com'],
        faucets: ['https://xsollazk.com/faucet'],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://xsolla.com/zk',
        shortName: 'xsollazk-sepolia',
        chainId: 555777,
        networkId: 555777,
        slip44: 1,
        icon: 'xsollazk',
        explorers: [
            {
                name: 'Xsolla ZK Sepolia Block Explorer',
                url: 'https://x.la/explorer',
                icon: 'xsollazk',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreicoqzosjvdfg2b4ijg5ct5jb5ll6j3xonxlocd7j2yx6dlefuhy6m'
    },
    555888: {
        name: 'DustBoy IoT',
        title: 'DustBoy IoT',
        status: 'active',
        chain: 'DUSTBOY',
        rpc: ['https://dustboy-rpc.jibl2.com/'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'DST', decimals: 18 },
        infoURL: 'https://www.cmuccdc.org/',
        shortName: 'DustBoy_IoT',
        chainId: 555888,
        networkId: 555888,
        slip44: 1,
        icon: 'dustboy',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://dustboy.jibl2.com',
                standard: 'EIP3091',
                icon: 'dustboy'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-1' },
        iconURL: 'https://ipfs.io/ipfs/QmV8Ks2Bikdy3VejY1YRAoucB5nifVocBhG7GJqfGmZuF3'
    },
    560000: {
        name: 'Hetu Testnet',
        chain: 'HETU',
        rpc: ['https://rpc.testchainv1.hetuscan.com'],
        faucets: ['https:/testchainv1.hetuscan.com'],
        nativeCurrency: { name: 'tETH', symbol: 'tETH', decimals: 18 },
        infoURL: 'https://hetu.org',
        shortName: 'HETU',
        chainId: 560000,
        networkId: 560000,
        explorers: [
            {
                name: 'Hetu Testnet Scan',
                url: 'https://testchainv1.hetuscan.com',
                icon: 'hetu',
                standard: 'EIP3091'
            }
        ]
    },
    560048: {
        name: 'Ethereum Hoodi',
        title: 'Ethereum Testnet Hoodi',
        chain: 'ETH',
        icon: 'ethereum',
        rpc: ['https://rpc.hoodi.ethpandaops.io'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [
            'https://faucet.hoodi.ethpandaops.io',
            'https://hoodi-faucet.pk910.de/'
        ],
        nativeCurrency: { name: 'Hoodi Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://hoodi.ethpandaops.io',
        shortName: 'hoe',
        chainId: 560048,
        networkId: 560048,
        slip44: 1,
        explorers: [
            {
                name: 'dora',
                url: 'https://light-hoodi.beaconcha.in',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt'
    },
    621847: {
        name: 'DJT Testnet',
        chain: 'DJT',
        icon: 'djt',
        rpc: ['https://testnet-rpc.trumpchain.io'],
        faucets: [],
        nativeCurrency: { name: 'TrumpChain', symbol: 'DJT', decimals: 18 },
        infoURL: 'https://testnet-explorer.trumpchain.io',
        shortName: 'DJT',
        chainId: 621847,
        networkId: 621847,
        explorers: [
            {
                name: 'DJT Testnet Explorer',
                url: 'https://testnet-explorer.trumpchain.io',
                icon: 'djt',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVCjy8yDeqWHFRNV2CaB82cLheVp37RdVGjwAxxjKqD5L'
    },
    622277: {
        name: 'Hypra Mainnet',
        chain: 'HYP',
        rpc: [
            'https://rpc.hypra.network',
            'https://rpc.rethereum.org',
            'https://rethereum.rpc.restratagem.com',
            'https://rpc.rthcentral.org',
            'https://hypra.rpc.thirdweb.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Hypra', symbol: 'HYP', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.hypra.network',
        shortName: 'hyp',
        chainId: 622277,
        networkId: 622277,
        icon: 'rethereum',
        explorers: [
            {
                name: 'hypra',
                url: 'https://explorer.hypra.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiawlhc2trzyxgnz24vowdymxme2m446uk4vmrplgxsdd74ecpfloq'
    },
    622463: {
        name: 'Atlas',
        title: 'Atlas Testnet',
        chain: 'ATLAS',
        icon: 'atlas',
        rpc: ['https://rpc.testnet.atl.network'],
        faucets: [],
        nativeCurrency: { name: 'TON', symbol: 'TON', decimals: 18 },
        infoURL: 'https://atl.network',
        shortName: 'atlas-testnet',
        chainId: 622463,
        networkId: 622463,
        explorers: [
            {
                name: 'Atlas Testnet Scan',
                url: 'https://explorer.testnet.atl.network',
                icon: 'atlas',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcSWGcoqC3y8VKahRdqPDgD68rr6A1gWVQPRt5FcpgWmG'
    },
    631571: {
        name: 'Polter Testnet',
        chain: 'Geist',
        rpc: ['https://geist-polter.g.alchemy.com/public'],
        faucets: [],
        nativeCurrency: { name: 'Polter GHST', symbol: 'GHST', decimals: 18 },
        features: [],
        infoURL: 'https://playongeist.com',
        shortName: 'poltergeist',
        chainId: 631571,
        networkId: 631571,
        status: 'active',
        icon: 'polterGeist',
        explorers: [
            {
                name: 'Polter Testnet Explorer',
                url: 'https://polter-testnet.explorer.alchemy.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNih9epd2WkWTCWD9nwXyUzpaBcPALJH66Fjq1YywpcA8'
    },
    641230: {
        name: 'Bear Network Chain Mainnet',
        chain: 'BRNKC',
        icon: 'brnkc',
        rpc: [
            'https://brnkc-mainnet.bearnetwork.net',
            'https://brnkc-mainnet1.bearnetwork.net'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'Bear Network Chain Native Token',
            symbol: 'BRNKC',
            decimals: 18
        },
        infoURL: 'https://bearnetwork.net',
        shortName: 'BRNKC',
        chainId: 641230,
        networkId: 641230,
        explorers: [
            {
                name: 'brnkscan',
                url: 'https://brnkscan.bearnetwork.net',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQqhH28QpUrreoRw5Gj8YShzdHxxVGMjfVrx3TqJNLSLv'
    },
    651940: {
        name: 'ALL Mainnet',
        chain: 'ALL',
        icon: 'alltra',
        rpc: ['https://mainnet-rpc.alltra.global'],
        faucets: [],
        nativeCurrency: { name: 'ALL', symbol: 'ALL', decimals: 18 },
        infoURL: 'https://alltra.world',
        shortName: 'ALL',
        chainId: 651940,
        networkId: 651940,
        explorers: [
            {
                name: 'Alltra SmartChain Explorer',
                url: 'https://alltra.global',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibqe2mgiqezi24sx272kunqt6pv7uzxhpkxuobvpbsptce3q6nn5i'
    },
    656476: {
        name: 'EDU Chain Testnet',
        chain: 'EDU Chain Testnet',
        icon: 'open-campus-codex',
        rpc: ['https://rpc.open-campus-codex.gelato.digital'],
        faucets: [],
        nativeCurrency: { name: 'EDU', symbol: 'EDU', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/open-campus-codex',
        shortName: 'open-campus-codex',
        chainId: 656476,
        networkId: 656476,
        explorers: [
            {
                name: 'Open Campus Codex',
                url: 'https://edu-chain-testnet.blockscout.com',
                icon: 'open-campus-codex',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXbz7VEYvf6NVHezuBy5HpJTCiagEThBxxdDdfVXNQ8Bt'
    },
    660279: {
        name: 'Xai Mainnet',
        chainId: 660279,
        shortName: 'xai',
        chain: 'XAI',
        networkId: 660279,
        nativeCurrency: { name: 'Xai', symbol: 'XAI', decimals: 18 },
        rpc: ['https://xai-chain.net/rpc'],
        faucets: [],
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.xai-chain.net',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://xai.games'
    },
    666666: {
        name: 'Vision - Vpioneer Test Chain',
        chain: 'Vision-Vpioneer',
        rpc: ['https://vpioneer.infragrid.v.network/ethereum/compatible'],
        faucets: ['https://vpioneerfaucet.visionscan.org'],
        nativeCurrency: { name: 'VS', symbol: 'VS', decimals: 18 },
        infoURL: 'https://visionscan.org',
        shortName: 'vpioneer',
        chainId: 666666,
        networkId: 666666,
        slip44: 1
    },
    666888: {
        name: 'Hela Official Runtime Testnet',
        chain: 'Hela',
        icon: 'hela',
        rpc: ['https://testnet-rpc.helachain.com'],
        faucets: ['https://testnet-faucet.helachain.com'],
        nativeCurrency: { name: 'Hela HLUSD', symbol: 'HLUSD', decimals: 18 },
        infoURL: 'https://helalabs.com',
        shortName: 'hela-testnet',
        chainId: 666888,
        networkId: 666888,
        slip44: 1,
        explorers: [
            {
                name: 'Hela Official Runtime Testnet Explorer',
                url: 'https://testnet-blockexplorer.helachain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQbUVcaxFwY8gqMq1Jeup4NEyivo12QYhbLvVRvgXRBFb'
    },
    668668: {
        name: 'Conwai Mainnet',
        chain: 'CNW',
        rpc: ['https://conwai.calderachain.xyz/http'],
        faucets: [],
        nativeCurrency: { name: 'Conwai', symbol: 'CNW', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://conwai.net',
        shortName: 'cnw',
        chainId: 668668,
        networkId: 668668,
        icon: 'conwai',
        explorers: [
            {
                name: 'conwaiscan',
                icon: 'conwaiscan',
                url: 'https://conwai.calderaexplorer.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbCavc5ge8bp2neLuUzDbbZd737kHTN59dFgGDNsZezSD'
    },
    685685: {
        name: 'Gensyn Testnet',
        chain: 'Gensyn',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.gensyn.ai/',
        shortName: 'gensyn-test',
        chainId: 685685,
        networkId: 685685,
        status: 'incubating'
    },
    686868: {
        name: 'Won Network',
        chainId: 686868,
        shortName: 'WonChain',
        chain: 'WON',
        icon: 'won',
        networkId: 686868,
        nativeCurrency: { name: 'Won', symbol: 'WON', decimals: 18 },
        rpc: ['https://rpc.wonnetwork.org'],
        faucets: ['https://faucet.wondollars.org'],
        explorers: [
            {
                name: 'Won Explorer',
                url: 'https://scan.wonnetwork.org',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://wonnetwork.org',
        iconURL: 'https://ipfs.io/ipfs/QmQ6mjKWJQ5WmFiJzcqJnuHWZK53nQYJB1SnMQZEqgr74h'
    },
    695569: {
        name: 'Pyrope Testnet',
        chain: 'ETH',
        rpc: ['https://rpc.pyropechain.com', 'wss://rpc.pyropechain.com'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://pyropechain.com',
        shortName: 'pyrope',
        chainId: 695569,
        networkId: 695569,
        icon: 'pyrope',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://pyrope.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://pyropechain.com/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmWhHvjbjTiNNsHKpbEz9rxSt4CCL2Q5xVZjk8eQkp82B9'
    },
    696969: {
        name: 'Galadriel Devnet',
        chain: 'Galadriel',
        rpc: ['https://devnet.galadriel.com'],
        faucets: ['https://docs.galadriel.com/faucet'],
        nativeCurrency: {
            name: 'Galadriel Devnet token',
            symbol: 'GAL',
            decimals: 18
        },
        infoURL: 'https://galadriel.com',
        shortName: 'galadriel-devnet',
        chainId: 696969,
        networkId: 696969,
        explorers: [
            {
                name: 'Galadriel Explorer',
                url: 'https://explorer.galadriel.com',
                standard: 'none'
            }
        ]
    },
    698369: {
        name: 'Primea Network Mainnet',
        chain: 'Primea Network Mainnet',
        rpc: [
            'http://rpc.primeanetwork.com/rpc-http',
            'https://rpc.primeanetwork.com/rpc-https',
            'ws://rpc.primeanetwork.com/rpc-ws',
            'wss://rpc.primeanetwork.com/rpc-wss'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'GoldPrimeaNetwork',
            symbol: 'GOLDPN',
            decimals: 18
        },
        infoURL: 'https://primeanetwork.com',
        shortName: 'goldpn',
        chainId: 698369,
        networkId: 698369,
        icon: 'prim',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/bafkreidaurpqgf3mmudm2foh5a45xyughike2y2pltb323ad5ywo4gtc3q'
    },
    706883: {
        name: 'Fidesinnova',
        chain: 'Fidesinnova',
        rpc: ['https://rpc1.fidesinnova.io'],
        faucets: [],
        nativeCurrency: { name: 'Fidesinnova', symbol: 'FDS', decimals: 18 },
        infoURL: 'https://fidesinnova.gitbook.io/docs',
        shortName: 'Fidesinnova',
        chainId: 706883,
        networkId: 706883,
        explorers: [
            {
                name: 'Fidesinnova Blockchain Explorer',
                url: 'https://explorer.fidesinnova.io',
                standard: 'none'
            }
        ]
    },
    710420: {
        name: 'Tiltyard Mainnet Subnet',
        chain: 'TILTYARD',
        rpc: ['https://subnets.avax.network/tiltyard/mainnet/rpc'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'TILT', symbol: 'TILT', decimals: 18 },
        infoURL: 'https://play.tiltyard.gg/',
        shortName: 'tiltyardmainnet',
        chainId: 710420,
        networkId: 710420,
        explorers: [
            {
                name: 'TILTYARD Explorer',
                url: 'https://subnets.avax.network/tiltyard',
                standard: 'EIP3091'
            }
        ]
    },
    713715: {
        name: 'Sei Devnet',
        chain: 'Sei',
        rpc: [
            'https://evm-rpc-arctic-1.sei-apis.com',
            'https://evm-rpc.arctic-1.seinetwork.io'
        ],
        faucets: [
            'https://sei-faucet.nima.enterprises',
            'https://sei-evm.faucetme.pro'
        ],
        nativeCurrency: { name: 'Sei', symbol: 'SEI', decimals: 18 },
        infoURL: 'https://www.sei.io',
        shortName: 'sei-devnet',
        chainId: 713715,
        networkId: 713715,
        icon: 'sei',
        explorers: [
            {
                name: 'Seistream',
                url: 'https://seistream.app',
                standard: 'none'
            },
            {
                name: 'Seitrace',
                url: 'https://seitrace.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreih3l3iisplmikofkbfyimqlox7nmixzlkzhjoewmpi4jbqitwryoa'
    },
    715131: {
        name: 'Zether Mainnet',
        chain: 'Zether',
        rpc: ['https://rpc.zether.org', 'https://rpc.zthscan.com'],
        faucets: [],
        nativeCurrency: { name: 'Zether', symbol: 'ZTH', decimals: 18 },
        infoURL: 'https://zether.org',
        shortName: 'zth',
        chainId: 715131,
        networkId: 715131,
        icon: 'zether',
        explorers: [
            {
                name: 'zthscan',
                url: 'https://zthscan.com',
                icon: 'zether',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZwdhRze34c3synJSp6QNv5zSpMiQf7DZS3N16HxGuzGh'
    },
    721529: {
        name: 'ERAM Mainnet',
        chain: 'ERAM',
        icon: 'eram',
        rpc: ['https://mainnet-rpc.eramscan.com'],
        faucets: [],
        nativeCurrency: { name: 'ERAM', symbol: 'ERAM', decimals: 18 },
        infoURL: 'http://doc.eramscan.com/',
        shortName: 'ERAM',
        chainId: 721529,
        networkId: 721529,
        explorers: [
            {
                name: 'Eramscan',
                url: 'https://eramscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQyu82MtGVLYMwCc5rseNXDV12V3UUX7iNq8q86SyeaPh'
    },
    723107: {
        name: 'TixChain Testnet',
        chain: 'TIXCHAIN',
        rpc: ['https://subnets.avax.network/tixchain/testnet/rpc'],
        faucets: [],
        nativeCurrency: { name: 'TIX Token', symbol: 'TIX', decimals: 18 },
        infoURL: 'https://subnets-test.avax.network/tixchain/details',
        shortName: 'tixchain',
        chainId: 723107,
        networkId: 723107,
        explorers: [
            {
                name: 'TixChain Testnet Subnet Explorer',
                url: 'https://subnets-test.avax.network/tixchain',
                standard: 'EIP3091'
            }
        ]
    },
    743111: {
        name: 'Hemi Sepolia',
        chain: 'ETH',
        rpc: ['https://testnet.rpc.hemi.network/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://hemi.xyz',
        shortName: 'hemi-sep',
        chainId: 743111,
        networkId: 743111,
        icon: 'hemi',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet.explorer.hemi.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111' },
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmfP6GDn5eXFcpWuoiyWn5pjn6PYB7HQhRD8nSko1zR8KD'
    },
    751230: {
        name: 'Bear Network Chain Testnet',
        chain: 'BRNKCTEST',
        icon: 'brnkc',
        rpc: ['https://brnkc-test.bearnetwork.net'],
        faucets: ['https://faucet.bearnetwork.net'],
        nativeCurrency: {
            name: 'Bear Network Chain Testnet Token',
            symbol: 'tBRNKC',
            decimals: 18
        },
        infoURL: 'https://bearnetwork.net',
        shortName: 'BRNKCTEST',
        chainId: 751230,
        networkId: 751230,
        slip44: 1,
        explorers: [
            {
                name: 'brnktestscan',
                url: 'https://brnktest-scan.bearnetwork.net',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQqhH28QpUrreoRw5Gj8YShzdHxxVGMjfVrx3TqJNLSLv'
    },
    752024: {
        name: 'Ternoa Testnet',
        chain: 'Ternoa',
        rpc: ['https://rpc.zkevm.ternoa.network'],
        faucets: ['https://faucet.zkevm.ternoa.network'],
        nativeCurrency: { name: 'Capsule Coin', symbol: 'CAPS', decimals: 18 },
        infoURL: '',
        shortName: 'ternoa',
        chainId: 752024,
        networkId: 7502024,
        explorers: [
            {
                name: 'Tracehawk',
                url: 'https://explorer.zkevm.ternoa.network',
                standard: 'none'
            }
        ]
    },
    752025: {
        name: 'Ternoa',
        chain: 'Ternoa',
        rpc: ['https://rpc-mainnet.zkevm.ternoa.network'],
        faucets: [],
        nativeCurrency: { name: 'Capsule Coin', symbol: 'CAPS', decimals: 18 },
        infoURL: '',
        shortName: 'ternoa-mainnet',
        chainId: 752025,
        networkId: 7502025,
        explorers: [
            {
                name: 'Tracehawk',
                url: 'https://explorer-mainnet.zkevm.ternoa.network',
                standard: 'none'
            }
        ]
    },
    756689: {
        name: 'PAYSCAN CHAIN',
        chain: 'PAYSCAN CHAIN',
        rpc: ['https://rpc.payscan.live'],
        faucets: [],
        nativeCurrency: { name: 'PYZ', symbol: 'PYZ', decimals: 18 },
        infoURL: 'https://payscan.live',
        shortName: 'payscan',
        chainId: 756689,
        networkId: 756689,
        slip44: 108,
        explorers: [
            {
                name: 'PAYSCAN CHAIN',
                url: 'https://payscan.live',
                standard: 'EIP3091'
            }
        ]
    },
    761412: {
        name: 'Miexs Smartchain',
        chain: 'MiexsSmartchain',
        icon: 'miexs',
        rpc: ['https://mainnet-rpc.miexs.com'],
        faucets: [],
        nativeCurrency: { name: 'Miexs Coin', symbol: 'MIX', decimals: 18 },
        infoURL: 'https://miexs.com',
        shortName: 'Miexs',
        chainId: 761412,
        networkId: 761412,
        explorers: [
            {
                name: 'Miexs Smartchain Explorer',
                url: 'https://miexs.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreic6tcc6swh5kzljwqnswj6rlemcm7n6ra7xkgttwv5v3fv7ozj5zu'
    },
    763373: {
        name: 'Ink Sepolia',
        chain: 'ETH',
        rpc: [
            'https://rpc-gel-sepolia.inkonchain.com',
            'wss://ws-gel-sepolia.inkonchain.com'
        ],
        faucets: [],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://inkonchain.com/',
        shortName: 'inksepolia',
        chainId: 763373,
        networkId: 763373,
        explorers: [
            {
                name: 'Ink Sepolia Explorer',
                url: 'https://explorer-sepolia.inkonchain.com',
                standard: 'EIP3091'
            }
        ]
    },
    763374: {
        name: 'Surge Testnet',
        chain: 'Surge Testnet',
        rpc: [
            'https://l2-rpc.surge.staging-nethermind.xyz',
            'wss://l2-rpc.surge.staging-nethermind.xyz'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://surge.wtf',
        shortName: 'surge-testnet',
        chainId: 763374,
        networkId: 763374,
        icon: 'surge-testnet',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.holesky.surge.wtf',
                standard: 'EIP3091',
                icon: 'surge-testnet'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreianxdx5j3ybmryz7n7fngycnmyihoi3jjerby2xtahahsw5kgz3qa'
    },
    764984: {
        name: 'Lamina1 Testnet',
        chain: 'Lamina1 Testnet',
        rpc: ['https://subnets.avax.network/lamina1tes/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Lamina1 Test', symbol: 'L1T', decimals: 18 },
        infoURL: 'https://fuji.lamina1.com/',
        shortName: 'lamina1test',
        chainId: 764984,
        networkId: 764984,
        slip44: 1,
        explorers: [
            {
                name: 'Lamina1 Test Explorer',
                url: 'https://subnets-test.avax.network/lamina1tes',
                standard: 'EIP3091'
            }
        ]
    },
    767368: {
        name: 'Lamina1 Identity Testnet',
        chain: 'Lamina1 Identity Testnet',
        rpc: ['https://subnets.avax.network/lamina1id/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'L1ID Test', symbol: 'L1IDT', decimals: 18 },
        infoURL: 'https://fuji.lamina1.com/',
        shortName: 'lamina1idtest',
        chainId: 767368,
        networkId: 767368,
        slip44: 1,
        explorers: [
            {
                name: 'Lamina1 Identity Testnet Explorer',
                url: 'https://subnets-test.avax.network/lamina1id',
                standard: 'EIP3091'
            }
        ]
    },
    776877: {
        name: 'Modularium',
        chain: 'EVMCC',
        rpc: ['https://fraa-dancebox-3035-rpc.a.dancebox.tanssi.network'],
        faucets: [],
        nativeCurrency: { name: 'Modularium', symbol: 'MDM', decimals: 18 },
        infoURL: 'https://www.rmrk.app/',
        shortName: 'mdlrm',
        chainId: 776877,
        networkId: 776877,
        explorers: [
            {
                name: 'Tanssi Explorer',
                url: 'https://tanssi-evmexplorer.netlify.app/?rpcUrl=https://fraa-dancebox-3035-rpc.a.dancebox.tanssi.network',
                standard: 'none'
            }
        ]
    },
    777777: {
        name: 'Winr Protocol Mainnet',
        chain: 'WINR',
        rpc: ['https://rpc.winr.games'],
        faucets: [],
        nativeCurrency: { name: 'Winr', symbol: 'WINR', decimals: 18 },
        features: [],
        infoURL: 'https://winr.games',
        shortName: 'winr',
        chainId: 777777,
        networkId: 777777,
        icon: 'winr',
        explorers: [
            {
                name: 'Winr Protocol Explorer',
                url: 'https://explorer.winr.games',
                icon: 'winr',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPL68edFCf9taAKQQu7rt11LrmWh7f7aBQ7ZkuhBKmrUv'
    },
    777888: {
        name: 'Oone Chain Mainnet',
        chain: 'OONE',
        rpc: ['https://rpc.oonechain.com'],
        faucets: [],
        nativeCurrency: { name: 'OONE', symbol: 'OONE', decimals: 18 },
        infoURL: 'https://oonechain.com',
        shortName: 'oone',
        chainId: 777888,
        networkId: 777888,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://oonescan.com',
                standard: 'none'
            }
        ]
    },
    786786: {
        name: 'Zebro Smart Chain',
        chain: 'ZEBRO',
        rpc: ['https://rpc.zebrocoin.app', 'https://rpc1.zebrocoin.app'],
        faucets: [],
        nativeCurrency: { name: 'Zebrocoin', symbol: 'ZEBRO', decimals: 18 },
        infoURL: 'https://zebrocoin.app',
        shortName: 'zebro',
        chainId: 786786,
        networkId: 786786,
        icon: 'zebrocoin',
        explorers: [
            {
                name: 'Zebrocoin Explorer',
                url: 'https://explorer.zebrocoin.app',
                standard: 'EIP3091'
            },
            {
                name: 'Zebrocoin Explorer1',
                url: 'https://explorer1.zebrocoin.app',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreig42tcn5hfgtzszmwvmodsxvtu5frfkgreb23dndle2mywns3xxse'
    },
    789789: {
        name: 'Emeraldz',
        chain: 'EMED',
        rpc: ['https://public.0xrpc.com/789789'],
        faucets: [],
        nativeCurrency: { name: 'EMERALDZ', symbol: 'EMED', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://emeraldzscan.com',
        shortName: 'emed',
        chainId: 789789,
        networkId: 789789,
        explorers: [
            {
                name: 'Emeraldz Explorer',
                url: 'https://emeraldzscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    800001: {
        name: 'OctaSpace',
        chain: 'OCTA',
        rpc: ['https://rpc.octa.space', 'wss://rpc.octa.space'],
        faucets: [],
        nativeCurrency: { name: 'OctaSpace', symbol: 'OCTA', decimals: 18 },
        infoURL: 'https://octa.space',
        shortName: 'octa',
        chainId: 800001,
        networkId: 800001,
        icon: 'octaspace',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.octa.space',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVhezQHkqSZ5Tvtsw18giA1yBjV1URSsBQ7HenUh6p6oC'
    },
    806582: {
        name: 'Ethpar Testnet',
        chain: 'ETP',
        rpc: ['https://rpc82.testnet.ethpar.net/'],
        faucets: [],
        nativeCurrency: { name: 'Ethpar', symbol: 'ETP', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://ethpar.com',
        shortName: 'ethpar-tesnet',
        chainId: 806582,
        networkId: 806582,
        icon: 'ethpar',
        explorers: [
            {
                name: 'Ethpar Testnet Explorer',
                url: 'https://dora.testnet.ethpar.net',
                icon: 'ethpar',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiezag3ijij32zbo3ko7xes2hafsqjhru22ab6ia35ygafc66kjb6u'
    },
    808080: {
        name: 'BIZ Smart Chain Testnet',
        chain: 'BIZT Testnet',
        rpc: ['https://rpc-testnet.bizex.io/'],
        faucets: [],
        nativeCurrency: { name: 'tBIZT', symbol: 'tBIZT', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.biztoken.io/',
        shortName: 'bizt-testnet',
        chainId: 808080,
        networkId: 808080,
        slip44: 1,
        icon: 'biz',
        explorers: [
            {
                name: 'BIZ Smart Chain Testnet Explorer',
                url: 'https://testnet.btscan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNnaDZRoMz9aoho35TGHBY5zD16P39cgPpw3z3jnkDHHB'
    },
    808813: {
        name: 'BOB Sepolia',
        chain: 'ETH',
        rpc: [
            'https://bob-sepolia.rpc.gobob.xyz',
            'wss://bob-sepolia.rpc.gobob.xyz'
        ],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://gobob.xyz',
        shortName: 'bob-sepolia',
        chainId: 808813,
        networkId: 808813,
        icon: 'bob',
        explorers: [
            {
                name: 'bobscout',
                url: 'https://bob-sepolia.explorer.gobob.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bob-sepolia.gobob.xyz/' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmaX5iqQTrJD8TBuvoT97xPMG6LYamjPCPnZUUMh12jc99'
    },
    810180: {
        name: 'zkLink Nova Mainnet',
        chain: 'ETH',
        rpc: ['https://rpc.zklink.io', 'wss://rpc.zklink.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://zklink.io',
        shortName: 'zklink-nova',
        chainId: 810180,
        networkId: 810180,
        slip44: 1,
        icon: 'zklink-nova',
        explorers: [
            {
                name: 'zkLink Nova Block Explorer',
                url: 'https://explorer.zklink.io',
                icon: 'zklink-nova',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-59144',
            bridges: [{ url: 'https://portal.zklink.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreiaj7b6pdekv3rjuta5wsdvmfdcsat2jftjgozape7wvmyj6d3vjcm'
    },
    810181: {
        name: 'zkLink Nova Sepolia Testnet',
        chain: 'ETH',
        rpc: ['https://sepolia.rpc.zklink.io', 'wss://sepolia.rpc.zklink.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://zklink.io',
        shortName: 'zklink-nova-sepolia',
        chainId: 810181,
        networkId: 810181,
        slip44: 1,
        icon: 'zklink-nova',
        explorers: [
            {
                name: 'zkLink Nova Block Explorer',
                url: 'https://sepolia.explorer.zklink.io',
                icon: 'zklink-nova',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-59141',
            bridges: [{ url: 'https://sepolia.portal.zklink.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreiaj7b6pdekv3rjuta5wsdvmfdcsat2jftjgozape7wvmyj6d3vjcm'
    },
    810182: {
        name: 'zkLink Nova Goerli Testnet',
        chain: 'ETH',
        rpc: ['https://goerli.rpc.zklink.io', 'wss://goerli.rpc.zklink.io'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://zklink.io',
        shortName: 'zklink-nova-goerli',
        chainId: 810182,
        networkId: 810182,
        slip44: 1,
        icon: 'zklink-nova',
        explorers: [
            {
                name: 'zkLink Nova Block Explorer',
                url: 'https://goerli.explorer.zklink.io',
                icon: 'zklink-nova',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-59140',
            bridges: [{ url: 'https://goerli.portal.zklink.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreiaj7b6pdekv3rjuta5wsdvmfdcsat2jftjgozape7wvmyj6d3vjcm'
    },
    812397: {
        name: 'SG Verse Mainnet',
        chain: 'SG Verse',
        icon: 'sg_verse',
        rpc: ['https://rpc.sgverse.net/'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: '',
        shortName: 'SGV',
        chainId: 812397,
        networkId: 812397,
        explorers: [
            {
                name: 'SG Verse Explorer',
                url: 'https://explorer.sgverse.net',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-248' },
        iconURL: 'https://ipfs.io/ipfs/QmXBm2hTGzFeYT5YYixzRnTdPNWnkNUaT1bBL3LYD4QvUk'
    },
    820522: {
        name: 'TSC Testnet',
        chain: 'Trust Smart Chain Testnet',
        rpc: ['https://testnet.tscscan.io/testrpc'],
        faucets: [],
        nativeCurrency: { name: 'TAS', symbol: 'tTAS', decimals: 18 },
        infoURL: 'https://www.trias.one',
        shortName: 'tTSC',
        icon: 'netx',
        chainId: 820522,
        networkId: 820025,
        explorers: [
            {
                name: 'tscscan',
                url: 'https://testnet.tscscan.io',
                icon: 'netxscan',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYmQAo5hSr16LDeSbWbXfKdF6qa2zCoK7e88r2f7RiFdt'
    },
    827431: {
        name: 'CURVE Mainnet',
        chain: 'CURVE',
        icon: 'curveIcon',
        rpc: ['https://mainnet-rpc.curvescan.io'],
        faucets: [],
        nativeCurrency: { name: 'Curve', symbol: 'CURVE', decimals: 18 },
        infoURL: 'https://curvescan.io',
        shortName: 'CURVEm',
        chainId: 827431,
        networkId: 827431,
        explorers: [
            {
                name: 'CURVE Mainnet',
                url: 'https://curvescan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTjV3TTR5aLb7fi7tjx8gcDvYtqBpusqhCSaznVxJ7NJg'
    },
    839320: {
        name: 'PRM Testnet',
        chain: 'prm',
        icon: 'prmIcon',
        rpc: ['https://testnet-rpc.prmscan.org'],
        faucets: ['https://faucet.prmscan.org'],
        nativeCurrency: { name: 'Primal Network', symbol: 'PRM', decimals: 18 },
        infoURL: 'https://primalnetwork.org',
        shortName: 'prmtest',
        chainId: 839320,
        networkId: 839320,
        explorers: [
            {
                name: 'Primal Network Testnet',
                url: 'https://testnet-explorer.prmscan.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmckkDRkuCQWbvhpKGsqa8ajuQvf3W5dekzw5qpiPC6shk'
    },
    839999: {
        name: 'exSat Testnet',
        chain: 'exSat',
        icon: 'exsat',
        rpc: ['https://evm-tst3.exsat.network'],
        faucets: [],
        nativeCurrency: { name: 'Bitcoin', symbol: 'BTC', decimals: 18 },
        infoURL: 'https://exsat.network/',
        shortName: 'txsat',
        chainId: 839999,
        networkId: 839999,
        explorers: [
            {
                name: 'exSat Testnet Explorer',
                url: 'https://scan-testnet.exsat.network',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-1', bridges: [{ url: '' }] },
        iconURL: 'https://ipfs.io/ipfs/QmYZ1FjYCByj89pNiZfae2a9uTm7pJMKrzdQ1V1UKwhwNs'
    },
    840000: {
        name: 'RUNEVM Testnet',
        chain: 'RuneVM',
        rpc: ['https://rpc.runevm.io/'],
        faucets: ['https://faucet.runevm.io/'],
        nativeCurrency: { name: 'Test Bitcoin', symbol: 'tBTC', decimals: 8 },
        infoURL: '',
        shortName: 'runevm-test',
        chainId: 840000,
        networkId: 840000,
        explorers: [
            {
                name: 'Tracehawk',
                url: 'https://explorer.runevm.io',
                standard: 'none'
            }
        ]
    },
    846000: {
        name: '4GoodNetwork',
        chain: '4GN',
        rpc: ['https://chain.deptofgood.com'],
        faucets: [],
        nativeCurrency: { name: 'APTA', symbol: 'APTA', decimals: 18 },
        infoURL: 'https://bloqs4good.com',
        shortName: 'bloqs4good',
        chainId: 846000,
        networkId: 846000
    },
    855456: {
        name: 'Dodao',
        chain: 'EVMCC',
        rpc: [
            'https://fraa-flashbox-4643-rpc.a.stagenet.tanssi.network',
            'wss://fraa-flashbox-4643-rpc.a.stagenet.tanssi.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Dodao', symbol: 'DODAO', decimals: 18 },
        infoURL: 'https://dodao.dev/',
        shortName: 'dodao',
        chainId: 855456,
        networkId: 855456,
        icon: 'dodao',
        explorers: [
            {
                name: 'Dodao EVM Explorer',
                url: 'https://evmexplorer.tanssi-chains.network/?rpcUrl=https://fraa-flashbox-4643-rpc.a.stagenet.tanssi.network',
                icon: 'dodao',
                standard: 'none'
            },
            {
                name: 'Dodao Polkadot Explorer',
                url: 'https://polkadot.js.org/apps/?rpc=wss://fraa-flashbox-4643-rpc.a.stagenet.tanssi.network#/explorer',
                icon: 'dodao',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdWsi6mhs6Agb3LF4uycUwx2fgNmwkuAGb7JmsLPkwd3j'
    },
    879151: {
        name: 'BlocX Mainnet',
        chain: 'BLX',
        rpc: ['https://mainnet-rpc.blxscan.com/'],
        faucets: [],
        nativeCurrency: { name: 'BlocX', symbol: 'BLX', decimals: 18 },
        infoURL: 'https://www.blocxchain.org/',
        shortName: 'blx',
        chainId: 879151,
        networkId: 879151,
        icon: 'blx',
        explorers: [
            {
                name: 'BlocX Mainnet Explorer',
                url: 'https://explorer.blxscan.com',
                icon: 'blx',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXM7XiLdSxhCub8MLSSo2J9V2qAkTcwdAGxcT57kurUzg'
    },
    888882: {
        name: 'REXX Mainnet',
        title: 'REXX Mainnet',
        chain: 'REXX',
        rpc: ['https://rpc.rexxnetwork.com'],
        faucets: [],
        nativeCurrency: { name: 'REXX', symbol: 'REXX', decimals: 18 },
        infoURL: 'https://rexxnetwork.com',
        shortName: 'REXX',
        chainId: 888882,
        networkId: 888882,
        explorers: [
            {
                name: 'REXX Mainnet Explorer',
                url: 'https://rexxnetwork.com',
                standard: 'EIP3091'
            }
        ]
    },
    888888: {
        name: 'Vision - Mainnet',
        chain: 'Vision',
        rpc: ['https://infragrid.v.network/ethereum/compatible'],
        faucets: [],
        nativeCurrency: { name: 'VS', symbol: 'VS', decimals: 18 },
        infoURL: 'https://www.v.network',
        explorers: [
            {
                name: 'Visionscan',
                url: 'https://www.visionscan.org',
                standard: 'EIP3091'
            }
        ],
        shortName: 'vision',
        chainId: 888888,
        networkId: 888888,
        slip44: 60
    },
    888991: {
        name: 'Unite Testnet',
        chain: 'UNITE',
        rpc: ['https://unite-testnet.g.alchemy.com/public'],
        faucets: [],
        nativeCurrency: { name: 'Testnet Unite', symbol: 'UNITE', decimals: 18 },
        infoURL: 'https://unite.io',
        shortName: 'unitetestnet',
        chainId: 888991,
        networkId: 888991,
        status: 'active',
        explorers: [
            {
                name: 'Unite Testnet Explorer',
                url: 'https://unite-testnet.explorer.alchemy.com',
                standard: 'EIP3091'
            }
        ]
    },
    900000: {
        name: 'Posichain Mainnet Shard 0',
        chain: 'PSC',
        rpc: ['https://api.posichain.org', 'https://api.s0.posichain.org'],
        faucets: [],
        nativeCurrency: {
            name: 'Posichain Native Token',
            symbol: 'POSI',
            decimals: 18
        },
        infoURL: 'https://posichain.org',
        shortName: 'psc-s0',
        chainId: 900000,
        networkId: 900000,
        explorers: [
            {
                name: 'Posichain Explorer',
                url: 'https://explorer.posichain.org',
                standard: 'EIP3091'
            }
        ]
    },
    910000: {
        name: 'Posichain Testnet Shard 0',
        chain: 'PSC',
        rpc: ['https://api.s0.t.posichain.org'],
        faucets: ['https://faucet.posichain.org/'],
        nativeCurrency: {
            name: 'Posichain Native Token',
            symbol: 'POSI',
            decimals: 18
        },
        infoURL: 'https://posichain.org',
        shortName: 'psc-t-s0',
        chainId: 910000,
        networkId: 910000,
        explorers: [
            {
                name: 'Posichain Explorer Testnet',
                url: 'https://explorer-testnet.posichain.org',
                standard: 'EIP3091'
            }
        ]
    },
    911867: {
        name: 'Odyssey Testnet',
        chain: 'ETH',
        rpc: ['https://odyssey.ithaca.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://ithaca.xyz',
        shortName: 'odyssey-testnet',
        chainId: 911867,
        networkId: 911867,
        explorers: [
            {
                name: 'odyssey explorer',
                url: 'https://odyssey-explorer.ithaca.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    912559: {
        name: 'Astria EVM Dusknet',
        chain: 'RIA',
        icon: 'astria',
        chainId: 912559,
        networkId: 912559,
        infoURL: 'https://docs.astria.org',
        shortName: 'ria-dev',
        nativeCurrency: { name: 'RIA', symbol: 'RIA', decimals: 18 },
        rpc: ['https://rpc.evm.dusk-3.devnet.astria.org'],
        faucets: ['https://faucet.evm.dusk-3.devnet.astria.org/'],
        explorers: [
            {
                name: 'Astria EVM Dusknet Explorer',
                url: 'https://explorer.evm.dusk-3.devnet.astria.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVbzZYXdVFY3uFaWQd7iSRtdM2UKWohj9fVqqEwxcw2RV'
    },
    918273: {
        name: 'Owshen Mainnet',
        chain: 'ETH',
        status: 'active',
        icon: 'owshen',
        rpc: ['https://rpc.owshen.io'],
        faucets: [],
        nativeCurrency: { name: 'DIVE', symbol: 'DIVE', decimals: 18 },
        infoURL: 'https://owshen.io',
        shortName: 'owshen-mainnet',
        chainId: 918273,
        networkId: 918273,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmPraJeGkPBaJqSrFc5yfcazpK1TN5Nz8t56tYWMhXycbz'
    },
    920000: {
        name: 'Posichain Devnet Shard 0',
        chain: 'PSC',
        rpc: ['https://api.s0.d.posichain.org'],
        faucets: ['https://faucet.posichain.org/'],
        nativeCurrency: {
            name: 'Posichain Native Token',
            symbol: 'POSI',
            decimals: 18
        },
        infoURL: 'https://posichain.org',
        shortName: 'psc-d-s0',
        chainId: 920000,
        networkId: 920000,
        explorers: [
            {
                name: 'Posichain Explorer Devnet',
                url: 'https://explorer-devnet.posichain.org',
                standard: 'EIP3091'
            }
        ]
    },
    920001: {
        name: 'Posichain Devnet Shard 1',
        chain: 'PSC',
        rpc: ['https://api.s1.d.posichain.org'],
        faucets: ['https://faucet.posichain.org/'],
        nativeCurrency: {
            name: 'Posichain Native Token',
            symbol: 'POSI',
            decimals: 18
        },
        infoURL: 'https://posichain.org',
        shortName: 'psc-d-s1',
        chainId: 920001,
        networkId: 920001,
        explorers: [
            {
                name: 'Posichain Explorer Devnet',
                url: 'https://explorer-devnet.posichain.org',
                standard: 'EIP3091'
            }
        ]
    },
    923018: {
        name: 'FNCY Testnet',
        chain: 'FNCY',
        rpc: ['https://fncy-testnet-seed.fncy.world'],
        faucets: ['https://faucet-testnet.fncy.world'],
        nativeCurrency: { name: 'FNCY', symbol: 'FNCY', decimals: 18 },
        infoURL: 'https://fncyscan-testnet.fncy.world',
        shortName: 'tFNCY',
        chainId: 923018,
        networkId: 923018,
        slip44: 1,
        icon: 'fncy',
        explorers: [
            {
                name: 'fncy scan testnet',
                url: 'https://fncyscan-testnet.fncy.world',
                icon: 'fncy',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfXCh6UnaEHn3Evz7RFJ3p2ggJBRm9hunDHegeoquGuhD'
    },
    955081: {
        name: 'Jono12 Subnet',
        chain: 'JONO12',
        icon: 'jono12',
        rpc: ['https://subnets.avax.network/jono12/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Jono12 Token', symbol: 'JONO', decimals: 18 },
        infoURL: '',
        shortName: 'jono12',
        chainId: 955081,
        networkId: 955081,
        explorers: [
            {
                name: 'JONO12 Explorer',
                url: 'https://subnets-test.avax.network/jono12',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreievzx4ke62dtc77o47x7vs7nn67ghzrwku6h5dxo3hwcsqfeblke4'
    },
    955305: {
        name: 'Eluvio Content Fabric',
        chain: 'Eluvio',
        rpc: [
            'https://host-76-74-28-226.contentfabric.io/eth/',
            'https://host-76-74-28-232.contentfabric.io/eth/',
            'https://host-76-74-29-2.contentfabric.io/eth/',
            'https://host-76-74-29-8.contentfabric.io/eth/',
            'https://host-76-74-29-34.contentfabric.io/eth/',
            'https://host-76-74-29-35.contentfabric.io/eth/',
            'https://host-154-14-211-98.contentfabric.io/eth/',
            'https://host-154-14-192-66.contentfabric.io/eth/',
            'https://host-60-240-133-202.contentfabric.io/eth/',
            'https://host-64-235-250-98.contentfabric.io/eth/'
        ],
        faucets: [],
        nativeCurrency: { name: 'ELV', symbol: 'ELV', decimals: 18 },
        infoURL: 'https://eluv.io',
        shortName: 'elv',
        chainId: 955305,
        networkId: 955305,
        slip44: 1011,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.eluv.io',
                standard: 'EIP3091'
            }
        ]
    },
    978657: {
        name: 'Treasure Ruby',
        chainId: 978657,
        shortName: 'treasure-ruby',
        chain: 'TRS',
        networkId: 978657,
        nativeCurrency: { name: 'Testnet MAGIC', symbol: 'MAGIC', decimals: 18 },
        slip44: 1,
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://app.treasure.lol',
        icon: 'treasureruby',
        rpc: [],
        faucets: [],
        status: 'deprecated',
        explorers: [],
        parent: { type: 'L2', chain: 'eip155-1', bridges: [] },
        iconURL: 'https://ipfs.io/ipfs/QmbALStb7WtVPHMdwp5DBhE1pUs9QdTgYU1XqRnyJKobE4'
    },
    978658: {
        name: 'Treasure Topaz',
        chain: 'Treasure Topaz',
        shortName: 'treasure-topaz',
        chainId: 978658,
        networkId: 978658,
        nativeCurrency: { name: 'Testnet MAGIC', symbol: 'MAGIC', decimals: 18 },
        slip44: 1,
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://app.treasure.lol',
        icon: 'treasuretopaz',
        rpc: ['https://rpc.topaz.treasure.lol', 'wss://rpc.topaz.treasure.lol/ws'],
        faucets: [
            'https://app.treasure.lol/chain/faucet',
            'https://thirdweb.com/treasure-topaz'
        ],
        explorers: [
            {
                name: 'Treasure Topaz Block Explorer',
                url: 'https://topaz.treasurescan.io',
                icon: 'treasure',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://app.treasure.lol/chain/bridge' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmT9TS1vsxxq4pToEXPouuYtDcpQZWZfh91NZdNXVQGPrY'
    },
    984122: {
        name: 'Forma',
        chain: 'Forma',
        rpc: ['https://rpc.forma.art'],
        faucets: [],
        nativeCurrency: { name: 'TIA', symbol: 'TIA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://forma.art',
        shortName: 'forma',
        chainId: 984122,
        networkId: 984122,
        icon: 'forma',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.forma.art',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQkjcadjAEefa4HLG26pKFvCaNZeZ7wWNxMkCVarW9tiU'
    },
    984123: {
        name: 'Forma Sketchpad',
        chain: 'Forma',
        rpc: ['https://rpc.sketchpad-1.forma.art'],
        faucets: [],
        nativeCurrency: { name: 'TIA', symbol: 'TIA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://forma.art',
        shortName: 'sketchpad',
        chainId: 984123,
        networkId: 984123,
        icon: 'forma',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.sketchpad-1.forma.art',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQkjcadjAEefa4HLG26pKFvCaNZeZ7wWNxMkCVarW9tiU'
    },
    988207: {
        name: 'Ecrox Chain Mainnet',
        chain: 'Ecrox Chain',
        rpc: ['https://mainnet-rpc.ecroxscan.com/'],
        faucets: [],
        nativeCurrency: { name: 'ECROX COIN', symbol: 'ECROX', decimals: 18 },
        infoURL: 'https://ecroxcoin.io/',
        shortName: 'ecrox',
        icon: 'ecrox',
        chainId: 988207,
        networkId: 988207,
        explorers: [
            {
                name: 'Ecrox Chain Explorer',
                url: 'https://ecroxscan.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreibnqdlwgotu4hwx6oeu4ye3huobr3eaiuvv55n5tolyxya2q7edmq'
    },
    998899: {
        name: 'Supernet Testnet',
        title: 'Supernet Testnet',
        chain: 'Supernet Testnet',
        rpc: ['https://testnet-rpc.supernet.chaingames.io/'],
        faucets: ['https://faucet.chaingames.io'],
        nativeCurrency: { name: 'CHAIN', symbol: 'CHAIN', decimals: 18 },
        infoURL: '',
        shortName: 'supernetchain',
        chainId: 998899,
        networkId: 998899,
        slip44: 1,
        explorers: [
            {
                name: 'supernet-testnet-explorer',
                url: 'https://testnet-explorer.supernet.chaingames.io',
                standard: 'EIP3091'
            }
        ]
    },
    999999: {
        name: 'AmChain',
        title: 'AMC',
        chain: 'AmChain',
        icon: 'amc',
        rpc: ['https://node1.amchain.net'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'AMC', symbol: 'AMC', decimals: 18 },
        infoURL: 'https://hewe.io/',
        shortName: 'AMC',
        chainId: 999999,
        networkId: 999999,
        explorers: [
            {
                name: 'AMCAmChain explorer',
                url: 'https://explorer.amchain.net',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmb6VAhhtaJmdaW1j7PAjxaLju1V24PPDFBdXtebyTSfsZ'
    },
    1008686: {
        name: 'Naga Testnet',
        chain: 'Naga',
        rpc: ['https://rpc.nagafintech.com', 'wss://rpc.nagafintech.com'],
        faucets: [],
        nativeCurrency: { name: 'Naga', symbol: 'Naga', decimals: 18 },
        infoURL: 'https://stablecoin.nagafintech.com/#/app/home',
        shortName: 'Naga',
        chainId: 1008686,
        networkId: 1008686,
        icon: 'naga',
        explorers: [
            {
                name: 'Naga Explorer Testnet',
                url: 'https://explorer.nagafintech.com',
                icon: 'naga',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWrjS43miGAKEzKyNn1YajFn4zG7cDiPiaNHF1gTqKR91'
    },
    1100789: {
        name: 'Netmind Chain Testnet',
        title: 'NetMind Chain Testnet',
        chain: 'NetMind',
        rpc: ['https://testblock.protago-dev.com'],
        faucets: [],
        nativeCurrency: { name: 'NMT', symbol: 'NMT', decimals: 18 },
        infoURL: 'https://netmind.ai',
        shortName: 'nmtTest',
        chainId: 1100789,
        networkId: 1100789,
        icon: 'netmind',
        explorers: [
            {
                name: 'NetMind Testnet Explorer',
                url: 'https://testbrower.protago-dev.com',
                icon: 'netmind',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQNipd6uen7sm7HZXGbqhcSVkUXxu3Tp6c3BoeFpvmywp'
    },
    1127469: {
        name: 'Tiltyard Subnet',
        chain: 'TILTYARD',
        rpc: ['https://subnets.avax.network/tiltyard/testnet/rpc'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Tiltyard Token', symbol: 'TILTG', decimals: 18 },
        infoURL: '',
        shortName: 'tiltyard',
        chainId: 1127469,
        networkId: 1127469,
        explorers: [
            {
                name: 'TILTYARD Explorer',
                url: 'http://testnet-explorer.tiltyard.gg',
                standard: 'EIP3091'
            }
        ]
    },
    1212101: {
        name: '1Money Network Testnet',
        chain: '1Money Testnet',
        rpc: ['https://testnet.1money.network'],
        faucets: [],
        nativeCurrency: { name: 'USD1', symbol: 'USD1', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://1money.com',
        shortName: '1money-testnet',
        chainId: 1212101,
        networkId: 1212101,
        explorers: []
    },
    1234567: {
        name: 'Sharecle Mainnet',
        chain: 'SHARECLE',
        icon: 'sharecle',
        rpc: ['https://mainnet.sharecle.com'],
        faucets: [],
        nativeCurrency: { name: 'SHARECLE COIN', symbol: 'SHR', decimals: 18 },
        infoURL: 'https://sharecle.com/',
        shortName: 'shr',
        chainId: 1234567,
        networkId: 1234567,
        slip44: 1,
        explorers: [
            {
                name: 'Etherscan',
                url: 'https://etherscan.io',
                standard: 'none',
                icon: 'sharecle'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeiaqaphacy5swvtyxw56ma5f5iewjcqspbgxr5l6ln2433liyw2djy'
    },
    1261120: {
        name: 'zKatana',
        shortName: 'azktn',
        title: 'Astar zkEVM Testnet zKatana',
        chain: 'ETH',
        icon: 'astarzk',
        rpc: [
            'https://rpc.zkatana.gelato.digital',
            'https://rpc.startale.com/zkatana',
            'https://astar-zkatana.drpc.org',
            'wss://astar-zkatana.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://astar.network',
        chainId: 1261120,
        networkId: 1261120,
        explorers: [
            {
                name: 'Blockscout zKatana chain explorer',
                url: 'https://zkatana.blockscout.com',
                standard: 'EIP3091'
            },
            {
                name: 'Startale zKatana chain explorer',
                url: 'https://zkatana.explorer.startale.com',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [
                { url: 'https://portal.astar.network' },
                { url: 'https://bridge.zkatana.gelato.digital' }
            ]
        },
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmRySLe3su59dE5x5JPm2b1GeZfz6DR9qUzcbp3rt4SD3A'
    },
    1313114: {
        name: 'Etho Protocol',
        chain: 'ETHO',
        rpc: ['https://rpc.ethoprotocol.com'],
        faucets: [],
        nativeCurrency: { name: 'Etho Protocol', symbol: 'ETHO', decimals: 18 },
        infoURL: 'https://ethoprotocol.com',
        shortName: 'etho',
        chainId: 1313114,
        networkId: 1313114,
        slip44: 1313114,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.ethoprotocol.com',
                standard: 'none'
            }
        ]
    },
    1313500: {
        name: 'Xerom',
        chain: 'XERO',
        rpc: ['https://rpc.xerom.org'],
        faucets: [],
        nativeCurrency: { name: 'Xerom Ether', symbol: 'XERO', decimals: 18 },
        infoURL: 'https://xerom.org',
        shortName: 'xero',
        chainId: 1313500,
        networkId: 1313500
    },
    1337702: {
        name: 'Kintsugi',
        title: 'Kintsugi merge testnet',
        chain: 'ETH',
        rpc: ['https://rpc.kintsugi.themerge.dev'],
        faucets: [
            'http://fauceth.komputing.org?chain=1337702&address=${ADDRESS}',
            'https://faucet.kintsugi.themerge.dev'
        ],
        nativeCurrency: { name: 'kintsugi Ethere', symbol: 'kiETH', decimals: 18 },
        infoURL: 'https://kintsugi.themerge.dev/',
        shortName: 'kintsugi',
        chainId: 1337702,
        networkId: 1337702,
        explorers: [
            {
                name: 'kintsugi explorer',
                url: 'https://explorer.kintsugi.themerge.dev',
                standard: 'EIP3091'
            }
        ]
    },
    1337802: {
        name: 'Kiln',
        chain: 'ETH',
        rpc: ['https://rpc.kiln.themerge.dev'],
        faucets: [
            'https://faucet.kiln.themerge.dev',
            'https://kiln-faucet.pk910.de',
            'https://kilnfaucet.com'
        ],
        nativeCurrency: { name: 'Testnet ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://kiln.themerge.dev/',
        shortName: 'kiln',
        chainId: 1337802,
        networkId: 1337802,
        icon: 'ethereum',
        explorers: [
            {
                name: 'Kiln Explorer',
                url: 'https://explorer.kiln.themerge.dev',
                icon: 'ethereum',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt'
    },
    1337803: {
        name: 'Zhejiang',
        chain: 'ETH',
        rpc: ['https://rpc.zhejiang.ethpandaops.io'],
        faucets: [
            'https://faucet.zhejiang.ethpandaops.io',
            'https://zhejiang-faucet.pk910.de'
        ],
        nativeCurrency: { name: 'Testnet ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://zhejiang.ethpandaops.io',
        shortName: 'zhejiang',
        chainId: 1337803,
        networkId: 1337803,
        icon: 'ethereum',
        explorers: [
            {
                name: 'Zhejiang Explorer',
                url: 'https://zhejiang.beaconcha.in',
                icon: 'ethereum',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt'
    },
    1398243: {
        name: 'Automata Testnet',
        chain: 'Automata Testnet',
        rpc: [
            'https://rpc-testnet.ata.network',
            'https://automata-testnet.alt.technology'
        ],
        faucets: [],
        nativeCurrency: { name: 'ATA', symbol: 'ATA', decimals: 18 },
        infoURL: 'https://ata.network',
        shortName: 'automatatest',
        chainId: 1398243,
        networkId: 1398243,
        icon: 'automata',
        explorers: [
            {
                name: 'Automata Testnet Explorer',
                url: 'https://explorer-testnet.ata.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW7ugm31MRdhjGtimzWMK5N4g5L84tSyKMpZQYk6N9KvJ'
    },
    1398244: {
        name: 'Automata Orbit Testnet',
        chain: 'Automata Orbit Testnet',
        rpc: ['https://rpc-orbit-testnet.ata.network'],
        faucets: [],
        nativeCurrency: { name: 'ATA', symbol: 'ATA', decimals: 18 },
        infoURL: 'https://ata.network',
        shortName: 'automataorbittestnet',
        chainId: 1398244,
        networkId: 1398244,
        icon: 'automata',
        explorers: [
            {
                name: 'Automata Orbit Testnet Explorer',
                url: 'https://automata-orbit-testnet-explorer.alt.technology',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW7ugm31MRdhjGtimzWMK5N4g5L84tSyKMpZQYk6N9KvJ'
    },
    1440002: {
        name: 'XRPL EVM Sidechain Devnet',
        chain: 'XRPLEVM Devnet',
        icon: 'xrplevm',
        rpc: ['https://rpc.xrplevm.org', 'https://ws.xrplevm.org'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://faucet.xrplevm.org'],
        nativeCurrency: { name: 'XRP', symbol: 'XRP', decimals: 18 },
        infoURL: 'https://xrplevm.org',
        shortName: 'xrplevmdevnet',
        chainId: 1440002,
        networkId: 1440002,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.xrplevm.org',
                icon: 'xrplevm',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXP4M9LvEfLotu5HfpMBcuxJEqpefaxhRxFPToBGfhNSo'
    },
    1449000: {
        name: 'XRPL EVM Sidechain Testnet',
        chain: 'XRPLEVM Testnet',
        icon: 'xrplevm',
        rpc: ['https://rpc.testnet.xrplevm.org', 'https://ws.testnet.xrplevm.org'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://faucet.xrplevm.org'],
        nativeCurrency: { name: 'XRP', symbol: 'XRP', decimals: 18 },
        infoURL: 'https://xrplevm.org',
        shortName: 'xrplevmtestnet',
        chainId: 1449000,
        networkId: 1449000,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.testnet.xrplevm.org',
                icon: 'xrplevm',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXP4M9LvEfLotu5HfpMBcuxJEqpefaxhRxFPToBGfhNSo'
    },
    1501869: {
        name: 'Waterfall 9 Test Network',
        chain: 'Waterfall TestNet9',
        rpc: ['https://rpc.testnet9.waterfall.network'],
        faucets: ['https://faucet.testnet9.waterfall.network'],
        nativeCurrency: { name: 'WATER', symbol: 'WATER', decimals: 18 },
        features: [{ name: 'EIP1559' }],
        infoURL: 'https://waterfall.network',
        shortName: 'water9',
        chainId: 1501869,
        networkId: 1501869,
        icon: 'waterfall',
        explorers: [
            {
                name: 'Waterfall Explorer Testnet9',
                url: 'https://explorer.testnet9.waterfall.network',
                icon: 'waterfall',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmSDJPBKh9cLVL8UZ5KYwdwPyhD8bRWNb33jjt48wtu5Uc'
    },
    1612127: {
        name: 'PlayFi Albireo Testnet',
        chain: 'ETH',
        rpc: ['https://albireo-rpc.playfi.ai'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.playfi.ai/',
        shortName: 'alberio',
        chainId: 1612127,
        networkId: 1612127,
        slip44: 1,
        explorers: [
            {
                name: 'PlayFi Block Explorer',
                url: 'https://albireo-explorer.playfi.ai',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://portal.playfi.ai/bridge' }]
        }
    },
    1637450: {
        name: 'Xterio Testnet',
        chain: 'Xterio Testnet',
        rpc: ['https://xterio-testnet.alt.technology'],
        faucets: [],
        nativeCurrency: { name: 'tBNB', symbol: 'tBNB', decimals: 18 },
        infoURL: 'https://xter.io',
        shortName: 'xteriotest',
        chainId: 1637450,
        networkId: 1637450,
        explorers: [
            {
                name: 'Xterio Testnet Explorer',
                url: 'https://testnet.xterscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    1698369: {
        name: 'Primea Network Testnet',
        chain: 'Primea Network Testnet',
        rpc: [
            'http://test-rpc.primeanetwork.com/rpc-http',
            'https://test-rpc.primeanetwork.com/rpc-https',
            'ws://test-rpc.primeanetwork.com/rpc-ws',
            'wss://test-rpc.primeanetwork.com/rpc-wss'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'GoldPrimeaNetwork Test',
            symbol: 'GOLDPN',
            decimals: 18
        },
        infoURL: 'https://primeanetwork.com',
        shortName: 'test-goldpn',
        chainId: 1698369,
        networkId: 1698369,
        icon: 'prim',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/bafkreidaurpqgf3mmudm2foh5a45xyughike2y2pltb323ad5ywo4gtc3q'
    },
    1731313: {
        name: 'Turkey Demo Dev',
        chain: 'ETH',
        rpc: ['https://devchain-poa.huabeizhenxuan.com'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: '',
        shortName: 'TDD',
        chainId: 1731313,
        networkId: 1731313
    },
    1998991: {
        name: 'Xphere Testnet',
        chain: 'Xphere Testnet',
        icon: 'xphere',
        rpc: ['http://testnet.x-phere.com'],
        features: [{ name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Xphere Testnet', symbol: 'XPT', decimals: 18 },
        infoURL: 'https://x-phere.com/',
        shortName: 'xp-test',
        chainId: 1998991,
        networkId: 1998991,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmfUV9PqF7JxuUAYaBHh6YJ2ChCdDVobTwDibxQuPMUmPq'
    },
    2021398: {
        name: 'DeBank Testnet',
        chain: 'DeBank',
        rpc: ['http://rpc.testnet.debank.com'],
        faucets: [],
        icon: 'debank',
        nativeCurrency: { name: 'DeBank USD', symbol: 'USD', decimals: 18 },
        infoURL: 'https://debank.com',
        shortName: 'dbk',
        chainId: 2021398,
        networkId: 2021398,
        slip44: 1,
        explorers: [
            {
                name: 'DeBank Chain Explorer',
                url: 'https://explorer.testnet.debank.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW9pBps8WHRRWmyXhjLZrjZJUe8F48hUu7z98bu2RVsjN'
    },
    2022091: {
        name: 'Alterscope Testnet',
        chain: 'AlterscopeTest',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'RISK Test Token', symbol: 'RISKT', decimals: 18 },
        infoURL: 'https://alterscope.org',
        shortName: 'AlterscopeTest',
        chainId: 2022091,
        networkId: 2022091,
        status: 'incubating'
    },
    2099156: {
        name: 'Plian Mainnet Main',
        chain: 'Plian',
        rpc: ['https://mainnet.plian.io/pchain'],
        faucets: [],
        nativeCurrency: { name: 'Plian Token', symbol: 'PI', decimals: 18 },
        infoURL: 'https://plian.org/',
        shortName: 'plian-mainnet',
        chainId: 2099156,
        networkId: 2099156,
        explorers: [
            {
                name: 'piscan',
                url: 'https://piscan.plian.org/pchain',
                standard: 'EIP3091'
            }
        ]
    },
    2203181: {
        name: 'PlatON Dev Testnet Deprecated',
        chain: 'PlatON',
        rpc: [
            'https://devnetopenapi2.platon.network/rpc',
            'wss://devnetopenapi2.platon.network/ws'
        ],
        faucets: ['https://devnet2faucet.platon.network/faucet'],
        nativeCurrency: { name: 'LAT', symbol: 'lat', decimals: 18 },
        infoURL: 'https://www.platon.network',
        shortName: 'platondev',
        chainId: 2203181,
        networkId: 1,
        slip44: 1,
        icon: 'platon',
        status: 'deprecated',
        explorers: [
            {
                name: 'PlatON explorer',
                url: 'https://devnetscan.platon.network',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmT7PSXBiVBma6E15hNkivmstqLu3JSnG1jXN5pTmcCGRC'
    },
    2206132: {
        name: 'PlatON Dev Testnet2',
        chain: 'PlatON',
        rpc: [
            'https://devnet2openapi.platon.network/rpc',
            'wss://devnet2openapi.platon.network/ws'
        ],
        faucets: ['https://devnet2faucet.platon.network/faucet'],
        nativeCurrency: { name: 'LAT', symbol: 'lat', decimals: 18 },
        infoURL: 'https://www.platon.network',
        shortName: 'platondev2',
        chainId: 2206132,
        networkId: 1,
        slip44: 1,
        icon: 'platon',
        explorers: [
            {
                name: 'PlatON explorer',
                url: 'https://devnet2scan.platon.network',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmT7PSXBiVBma6E15hNkivmstqLu3JSnG1jXN5pTmcCGRC'
    },
    2222222: {
        name: 'Coinweb BNB shard',
        title: 'Coinweb BNB shard',
        chain: 'CWEB BNB',
        rpc: ['https://api-cloud.coinweb.io/eth-rpc-service/bnb'],
        faucets: [],
        nativeCurrency: { name: 'CWEB', symbol: 'CWEB', decimals: 18 },
        infoURL: 'https://coinweb.io',
        shortName: 'cweb-bnb',
        chainId: 2222222,
        networkId: 2222222,
        slip44: 1,
        explorers: [
            {
                name: 'Coinweb block explorer',
                url: 'https://explorer.coinweb.io',
                standard: 'none'
            }
        ]
    },
    2481632: {
        name: 'Recall Testnet',
        chain: 'Recall Testnet',
        rpc: ['https://evm.v013.node-0.testnet.recall.network'],
        faucets: ['faucet.recall.network'],
        nativeCurrency: { name: 'Recall', symbol: 'RECALL', decimals: 18 },
        infoURL: 'https://recall.network',
        shortName: 'trecall',
        chainId: 2481632,
        networkId: 2481632,
        explorers: [
            {
                name: 'Recall testnet explorer',
                url: 'https://explorer.testnet.recall.network',
                standard: 'EIP3091'
            }
        ]
    },
    2611555: {
        name: 'DPU Chain',
        chain: 'DPU',
        rpc: ['https://sc-rpc.dpu.ac.th'],
        faucets: [],
        nativeCurrency: { name: 'DGC', symbol: 'DGC', decimals: 18 },
        infoURL: '',
        shortName: 'DPU',
        chainId: 2611555,
        networkId: 2611555
    },
    2632500: {
        name: 'COTI',
        chainId: 2632500,
        shortName: 'coti',
        chain: 'COTI',
        networkId: 2632500,
        nativeCurrency: { name: 'COTI', symbol: 'COTI', decimals: 18 },
        rpc: ['https://mainnet.coti.io/rpc'],
        faucets: [],
        explorers: [
            {
                name: 'COTI Mainnet Explorer',
                url: 'https://mainnet.cotiscan.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://coti.io/',
        icon: 'coti',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        iconURL: 'https://ipfs.io/ipfs/QmR58SroHx7ovpqEB5iRkw4PufEXmcCBAJ8AZ7mChDgTfV'
    },
    2702128: {
        name: 'Xterio Chain (ETH)',
        chain: 'Xterio',
        rpc: ['https://xterio-eth.alt.technology'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://xter.io',
        shortName: 'xterio',
        chainId: 2702128,
        networkId: 2702128,
        explorers: [
            {
                name: 'Xterio Chain (ETH) Explorer',
                url: 'https://eth.xterscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    3132023: {
        name: 'Sahara AI',
        chain: 'Sahara',
        rpc: ['https://mainnet.saharalabs.ai'],
        faucets: [],
        nativeCurrency: { name: 'Sahara AI', symbol: 'SAHARA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://saharalabs.ai',
        shortName: 'sahara',
        chainId: 3132023,
        networkId: 3132023,
        icon: 'sahara',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/bafkreibhofpvuswlhmfniolskoguhjr4p7strqgm5uz7tu53s5gv35qwem'
    },
    3141592: {
        name: 'Filecoin - Butterfly testnet',
        chain: 'FIL',
        status: 'incubating',
        rpc: [],
        faucets: ['https://faucet.butterfly.fildev.network'],
        nativeCurrency: { name: 'testnet filecoin', symbol: 'tFIL', decimals: 18 },
        infoURL: 'https://filecoin.io',
        shortName: 'filecoin-butterfly',
        icon: 'filecoin',
        chainId: 3141592,
        networkId: 3141592,
        slip44: 1,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmS9r9XQkMHVomWcSBNDkKkz9n87h9bH9ssabeiKZtANoU'
    },
    3397901: {
        name: 'Funki Sepolia Testnet',
        chain: 'ETH',
        icon: 'funki',
        rpc: ['https://funki-testnet.alt.technology'],
        faucets: ['https://funkichain.com/portfolio'],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://funkichain.com',
        shortName: 'funkisepolia',
        chainId: 3397901,
        networkId: 3397901,
        explorers: [
            {
                name: 'Funki Sepolia Testnet Explorer',
                url: 'https://testnet.funkiscan.io',
                standard: 'none'
            },
            {
                name: 'Funki Sepolia Sandbox Explorer',
                url: 'https://testnet-explorer.funkichain.com',
                standard: 'none'
            },
            {
                name: 'Funki Sepolia Testnet Explorer',
                url: 'https://testnet.funkiscan.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQnQZ2YUuJMDYoKWhiA1KqY67VFjvMLSXTww46pnrS8js'
    },
    3441005: {
        name: 'Manta Pacific Testnet',
        chain: 'Manta Pacific',
        rpc: [
            'https://manta-testnet.calderachain.xyz/http',
            'https://manta-pacific-testnet.drpc.org',
            'wss://manta-pacific-testnet.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Manta', symbol: 'MANTA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://manta-testnet.caldera.dev/',
        shortName: 'mantaTestnet',
        chainId: 3441005,
        networkId: 3441005,
        slip44: 1,
        icon: 'manta',
        explorers: [
            {
                name: 'manta-testnet Explorer',
                url: 'https://manta-testnet.calderaexplorer.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTckcVTViRZ3NqT36MTt8AvgBSmudrbgU3pi8AaNtthoV'
    },
    3441006: {
        name: 'Manta Pacific Sepolia Testnet',
        chain: 'Manta Pacific',
        rpc: ['https://pacific-rpc.sepolia-testnet.manta.network/http'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://manta-testnet.caldera.dev/',
        shortName: 'mantaSepoliaTestnet',
        chainId: 3441006,
        networkId: 3441006,
        slip44: 1,
        icon: 'manta',
        explorers: [
            {
                name: 'manta-testnet Explorer',
                url: 'https://pacific-explorer.sepolia-testnet.manta.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTckcVTViRZ3NqT36MTt8AvgBSmudrbgU3pi8AaNtthoV'
    },
    4000003: {
        name: 'AltLayer Zero Gas Network',
        chain: 'ETH',
        rpc: ['https://zero.alt.technology'],
        faucets: [],
        nativeCurrency: { name: 'ZERO', symbol: 'ZERO', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://altlayer.io',
        shortName: 'alt-zerogas',
        chainId: 4000003,
        networkId: 4000003,
        icon: 'altlayer',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://zero-explorer.alt.technology',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcEfZJU7NMn9ycTAcEooQgGNfa2nYBToSUZHdFCFadcjb'
    },
    4278608: {
        name: 'Arcadia Mainnet',
        chain: 'Arcadia',
        rpc: ['https://arcadia.khalani.network'],
        faucets: [],
        nativeCurrency: { name: 'AIP', symbol: 'AIP', decimals: 18 },
        infoURL: 'https://khalani.network',
        shortName: 'aip',
        chainId: 4278608,
        networkId: 4278608,
        explorers: [
            {
                name: 'Arcadia Mainnet Explorer',
                url: 'https://explorer.arcadia.khalani.network',
                standard: 'EIP3091'
            }
        ]
    },
    4281033: {
        name: 'Worlds Caldera',
        chain: 'WCal',
        rpc: ['https://worlds-test.calderachain.xyz/http'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://caldera.xyz/',
        shortName: 'worldscal',
        chainId: 4281033,
        networkId: 4281033,
        icon: 'ethereum',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt'
    },
    4284265: {
        name: 'Zuux chain testnet',
        title: 'Zuux chain testnet',
        chain: 'zuuxchain',
        icon: 'zuuxchain',
        rpc: ['https://rpc.zuux.network'],
        features: [{ name: 'none' }],
        faucets: ['https://www.zuuxlend.xyz/faucet'],
        nativeCurrency: { name: 'ZUUX', symbol: 'ZUUX', decimals: 18 },
        infoURL: 'https://www.zuux.network',
        shortName: 'zuuxchain',
        chainId: 4284265,
        networkId: 4284265,
        explorers: [
            {
                name: 'Zuux chain explorer',
                url: 'https://blockscout.zuux.network',
                standard: 'EIP3091'
            },
            {
                name: 'Zuux chain explorer',
                url: 'https://explorer.zuux.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUbpXxB8ZkowBKRN4g7QrezZvVHWEcTwBjx4Pkgx3uJXX'
    },
    4444444: {
        name: 'Altar Testnet',
        chain: 'Altar',
        rpc: ['https://altar-rpc.ceremonies.ai/'],
        faucets: ['https://sepoliafaucet.com/'],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://ceremonies.gitbook.io',
        shortName: 'altarTestnet',
        chainId: 4444444,
        networkId: 4444444,
        slip44: 1,
        icon: 'altarTestnet',
        explorers: [
            {
                name: 'altar testnet explorer',
                url: 'https://altar-explorer.ceremonies.ai',
                standard: 'none'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [
                {
                    url: 'https://altar-testnet-yzxhzk61ck-b7590e4db247a680.testnets.rollbridge.app/'
                }
            ]
        },
        iconURL: 'https://ipfs.io/ipfs/QmZiJLjciV6KiuxwDebi7CwRhDzei6KKDuStppzsUGtNfN'
    },
    4457845: {
        name: 'ZERO Testnet (Sepolia)',
        chain: 'ETH',
        icon: 'zero-sepolia',
        rpc: ['https://rpc.zerion.io/v1/zero-sepolia'],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge.zero.network' }]
        },
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://docs.zero.network',
        shortName: 'zero-sepolia',
        chainId: 4457845,
        networkId: 4457845,
        slip44: 1,
        explorers: [
            {
                name: 'ZERO Testnet Explorer',
                url: 'https://explorer.zero.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWpvBtmDhZSAnRww5ZU6BvEbDbxKEzoyjWcanjc1UBD9X'
    },
    5112023: {
        name: 'NumBlock Chain',
        chain: 'NumBlock',
        rpc: ['https://rpc-mainnet.numblock.org'],
        faucets: [],
        nativeCurrency: { name: 'NUMB Token', symbol: 'NUMB', decimals: 18 },
        infoURL: 'https://numblock.org',
        shortName: 'NUMB',
        chainId: 5112023,
        networkId: 5112023,
        icon: 'NumBlock',
        explorers: [
            {
                name: 'NumBlock Explorer',
                url: 'https://mainnet.numblock.org',
                standard: 'none',
                icon: 'NumBlock'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRY72AKDaUwxgPukdfSBj19NfMrmsSm48mdBe9zJcW3jB'
    },
    5167003: {
        name: 'MXC Wannsee zkEVM Testnet',
        chain: 'MXC zkEVM',
        icon: 'mxc',
        rpc: ['https://wannsee-rpc.mxc.com'],
        faucets: [],
        nativeCurrency: {
            name: 'MXC Wannsee zkEVM Testnet',
            symbol: 'MXC',
            decimals: 18
        },
        infoURL: 'https://wannsee.mxc.com/docs/intro',
        shortName: 'MXCdiscontinued',
        chainId: 5167003,
        networkId: 5167003,
        slip44: 1,
        explorers: [
            {
                name: 'MXC Wannsee zkEVM Testnet',
                url: 'https://wannsee-explorer.mxc.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdGCthKA11K9kCZJdbTP5WPAyq1wiRZ3REn6KG58MrWaE'
    },
    5167004: {
        name: 'Moonchain Geneva Testnet',
        chain: 'MXC zkEVM',
        icon: 'mxc',
        rpc: ['https://geneva-rpc.moonchain.com'],
        faucets: [],
        nativeCurrency: {
            name: 'Moonchain Geneva Testnet',
            symbol: 'MXC',
            decimals: 18
        },
        infoURL: 'https://doc.mxc.com/docs/intro',
        shortName: 'MXC',
        chainId: 5167004,
        networkId: 5167004,
        slip44: 1,
        explorers: [
            {
                name: 'Moonchain Geneva Testnet',
                url: 'https://geneva-explorer.moonchain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdGCthKA11K9kCZJdbTP5WPAyq1wiRZ3REn6KG58MrWaE'
    },
    5201420: {
        name: 'Electroneum Testnet',
        chain: 'Electroneum',
        rpc: ['https://rpc.ankr.com/electroneum_testnet'],
        faucets: ['https://faucet.electroneum.com'],
        nativeCurrency: { name: 'Electroneum', symbol: 'ETN', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://electroneum.com',
        shortName: 'etn-testnet',
        chainId: 5201420,
        networkId: 5201420,
        slip44: 1,
        icon: 'electroneum',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet-blockexplorer.electroneum.com',
                icon: 'electroneum',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVgFqXA3kkCrVYGcWFF7Mhx8JUSe9vSCauNamuKWSvCym'
    },
    5318008: {
        name: 'Reactive Kopli',
        title: 'Reactive Network Testnet Kopli',
        chain: 'REACT',
        rpc: ['https://kopli-rpc.rnk.dev'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://dev.reactive.network/docs/kopli-testnet#faucet'],
        nativeCurrency: { name: 'Kopli React', symbol: 'REACT', decimals: 18 },
        infoURL: 'https://reactive.network',
        shortName: 'kreact',
        icon: 'reactive',
        chainId: 5318008,
        networkId: 5318008,
        explorers: [
            {
                name: 'Reactscan',
                url: 'https://kopli.reactscan.net',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreih2sitkbspgnboiwga7k4zwz22h4u3qqpswxdr3miqtdwuovw2cte'
    },
    5511555: {
        name: 'PointPay Testnet',
        chain: 'pointpay',
        rpc: ['https://rpc-testnet.pointpay.io'],
        faucets: [],
        nativeCurrency: { name: 'PointPay', symbol: 'PXP', decimals: 18 },
        infoURL: 'https://pointpay.io',
        shortName: 'PPTEST',
        chainId: 5511555,
        networkId: 5511555,
        icon: 'pointpay',
        explorers: [
            {
                name: 'PointPay Testnet Explorer',
                url: 'https://testnet.pointpay.io',
                icon: 'pointpay',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPVsJrzshxQMVDSqn45aiaNJcFY8zWU27fg8vq5Mht4z7'
    },
    5555555: {
        name: 'Imversed Mainnet',
        chain: 'Imversed',
        rpc: [
            'https://jsonrpc.imversed.network',
            'https://ws-jsonrpc.imversed.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Imversed Token', symbol: 'IMV', decimals: 18 },
        infoURL: 'https://imversed.com',
        shortName: 'imversed',
        chainId: 5555555,
        networkId: 5555555,
        icon: 'imversed',
        explorers: [
            {
                name: 'Imversed EVM explorer (Blockscout)',
                url: 'https://txe.imversed.network',
                icon: 'imversed',
                standard: 'EIP3091'
            },
            {
                name: 'Imversed Cosmos Explorer (Big Dipper)',
                url: 'https://tex-c.imversed.com',
                icon: 'imversed',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYwvmJZ1bgTdiZUKXk4SifTpTj286CkZjMCshUyJuBFH1'
    },
    5555558: {
        name: 'Imversed Testnet',
        chain: 'Imversed',
        rpc: [
            'https://jsonrpc-test.imversed.network',
            'https://ws-jsonrpc-test.imversed.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Imversed Token', symbol: 'IMV', decimals: 18 },
        infoURL: 'https://imversed.com',
        shortName: 'imversed-testnet',
        chainId: 5555558,
        networkId: 5555558,
        slip44: 1,
        icon: 'imversed',
        explorers: [
            {
                name: 'Imversed EVM Explorer (Blockscout)',
                url: 'https://txe-test.imversed.network',
                icon: 'imversed',
                standard: 'EIP3091'
            },
            {
                name: 'Imversed Cosmos Explorer (Big Dipper)',
                url: 'https://tex-t.imversed.com',
                icon: 'imversed',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYwvmJZ1bgTdiZUKXk4SifTpTj286CkZjMCshUyJuBFH1'
    },
    6038361: {
        name: 'Astar zKyoto',
        shortName: 'azkyt',
        title: 'Astar zkEVM Testnet zKyoto',
        chain: 'ETH',
        icon: 'astarzk',
        rpc: [
            'https://rpc.startale.com/zkyoto',
            'https://rpc.zkyoto.gelato.digital'
        ],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://astar.network',
        chainId: 6038361,
        networkId: 6038361,
        explorers: [
            {
                name: 'Blockscout zKyoto explorer',
                url: 'https://astar-zkyoto.blockscout.com',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [
                { url: 'https://portal.astar.network' },
                { url: 'https://bridge.gelato.network/bridge/astar-zkyoto' }
            ]
        },
        iconURL: 'https://ipfs.io/ipfs/QmRySLe3su59dE5x5JPm2b1GeZfz6DR9qUzcbp3rt4SD3A'
    },
    6231991: {
        name: 'Block Chain LOL Berachain Testnet',
        chain: 'Block Chain LOL Berachain',
        rpc: ['https://block-chain.alt.technology'],
        faucets: ['https://faucet.block-chain.lol/'],
        nativeCurrency: {
            name: 'HarryPotterObamaSonic10Inu',
            symbol: 'HARRY',
            decimals: 18
        },
        infoURL: 'https://block-chain.lol/',
        shortName: 'block-chain-lol-testnet',
        chainId: 6231991,
        networkId: 6231991,
        explorers: [
            {
                name: 'Block Chain LOL Berachain Testnet Blockscout Explorer',
                url: 'https://explorer.block-chain.lol',
                standard: 'EIP3091'
            }
        ]
    },
    6666665: {
        name: 'Safe(AnWang) Mainnet',
        chain: 'Safe(AnWang)',
        icon: 'safe-anwang',
        rpc: ['https://rpc.anwang.com'],
        faucets: [],
        nativeCurrency: { name: 'SAFE(AnWang)', symbol: 'SAFE', decimals: 18 },
        infoURL: 'https://www.anwang.com',
        shortName: 'SafeMainnet',
        chainId: 6666665,
        networkId: 6666665,
        explorers: [
            {
                name: 'Safe(AnWang) Explorer',
                url: 'http://safe4.anwang.com',
                icon: 'safe-anwang',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmahJhdaLfGwBStQ9q9K4Mc73vLNqFV1otWCsT2ZKsMavv'
    },
    6666666: {
        name: 'Safe(AnWang) Testnet',
        chain: 'Safe(AnWang)',
        icon: 'safe-anwang',
        rpc: ['https://rpc-testnet.anwang.com'],
        faucets: [],
        nativeCurrency: { name: 'SAFE(AnWang)', symbol: 'SAFE', decimals: 18 },
        infoURL: 'https://www.anwang.com',
        shortName: 'SafeTestnet',
        chainId: 6666666,
        networkId: 6666666,
        explorers: [
            {
                name: 'Safe(AnWang) Testnet Explorer',
                url: 'http://safe4-testnet.anwang.com',
                icon: 'safe-anwang',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmahJhdaLfGwBStQ9q9K4Mc73vLNqFV1otWCsT2ZKsMavv'
    },
    6666689: {
        name: 'The Ting Blockchain Testnet Explorer',
        chain: 'Ting',
        rpc: ['https://testnet.tingchain.org', 'https://public.0xrpc.com/6666689'],
        faucets: [],
        nativeCurrency: { name: 'Ton', symbol: 'Ton', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://tingscan.com',
        shortName: 'ting-testnet',
        chainId: 6666689,
        networkId: 6666689,
        explorers: [
            {
                name: 'TingScan',
                url: 'https://tingscan.com',
                standard: 'EIP3091'
            }
        ]
    },
    7082400: {
        name: 'COTI Testnet',
        title: 'COTI Testnet',
        chain: 'COTI',
        icon: 'coti',
        rpc: [
            'https://testnet.coti.io/rpc',
            'https://testnet-magnus-validator.coti.io/rpc',
            'https://testnet-minor-validator.coti.io/rpc'
        ],
        faucets: ['https://faucet.coti.io'],
        nativeCurrency: { name: 'COTI', symbol: 'COTI', decimals: 18 },
        infoURL: 'https://coti.io/',
        shortName: 'coti-testnet',
        chainId: 7082400,
        networkId: 7082400,
        explorers: [
            {
                name: 'COTI Testnet Explorer',
                url: 'https://testnet.cotiscan.io',
                icon: 'ethernal',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmR58SroHx7ovpqEB5iRkw4PufEXmcCBAJ8AZ7mChDgTfV'
    },
    7225878: {
        name: 'Saakuru Mainnet',
        chain: 'Saakuru',
        icon: 'saakuru',
        rpc: ['https://rpc.saakuru.network'],
        faucets: [],
        nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
        infoURL: 'https://saakuru.network',
        shortName: 'saakuru',
        chainId: 7225878,
        networkId: 7225878,
        explorers: [
            {
                name: 'saakuru-explorer',
                url: 'https://explorer.saakuru.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmduEdtFobPpZWSc45MU6RKxZfTEzLux2z8ikHFhT8usqv'
    },
    7355310: {
        name: 'OpenVessel',
        chain: 'VSL',
        icon: 'vsl',
        rpc: ['https://mainnet-external.openvessel.io'],
        faucets: [],
        nativeCurrency: { name: 'Vessel ETH', symbol: 'VETH', decimals: 18 },
        infoURL: 'https://www.openvessel.io',
        shortName: 'vsl',
        chainId: 7355310,
        networkId: 7355310,
        explorers: [
            {
                name: 'openvessel-mainnet',
                url: 'https://mainnet-explorer.openvessel.io',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeknNzGCZXQK7egwfwyxQan7Lw8bLnqYsyoEgEbDNCzJX'
    },
    7668378: {
        name: 'QL1 Testnet',
        chain: 'QOM',
        status: 'incubating',
        rpc: ['https://rpc.testnet.qom.one'],
        faucets: ['https://faucet.qom.one'],
        nativeCurrency: { name: 'Shiba Predator', symbol: 'QOM', decimals: 18 },
        infoURL: 'https://qom.one',
        shortName: 'tqom',
        chainId: 7668378,
        networkId: 7668378,
        slip44: 1,
        icon: 'qom',
        explorers: [
            {
                name: 'QL1 Testnet Explorer',
                url: 'https://testnet.qom.one',
                icon: 'qom',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRc1kJ7AgcDL1BSoMYudatWHTrz27K6WNTwGifQb5V17D'
    },
    7762959: {
        name: 'Musicoin',
        chain: 'MUSIC',
        rpc: ['https://mewapi.musicoin.tw'],
        faucets: [],
        nativeCurrency: { name: 'Musicoin', symbol: 'MUSIC', decimals: 18 },
        infoURL: 'https://musicoin.tw',
        shortName: 'music',
        chainId: 7762959,
        networkId: 7762959,
        slip44: 184
    },
    7777777: {
        name: 'Zora',
        chain: 'ETH',
        rpc: ['https://rpc.zora.energy/'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        icon: 'zora',
        infoURL: 'https://zora.energy',
        shortName: 'zora',
        chainId: 7777777,
        networkId: 7777777,
        explorers: [
            {
                name: 'Zora Network Explorer',
                url: 'https://explorer.zora.energy',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmYQf9VKTzPwQiU5xQMNbJKKGasLDVoXs2S86Ay77MStp7'
    },
    7849306: {
        name: 'Ozean Poseidon Testnet',
        chain: 'Ozean Poseidon',
        rpc: [
            'https://ozean-testnet.rpc.caldera.xyz/http',
            'wss://ozean-testnet.rpc.caldera.xyz/ws'
        ],
        faucets: ['https://ozean-testnet.hub.caldera.xyz'],
        nativeCurrency: { name: 'USDX', symbol: 'USDX', decimals: 18 },
        infoURL: 'https://docs.ozean.finance',
        shortName: 'ozean-poseidon',
        chainId: 7849306,
        networkId: 7849306,
        icon: 'ozean',
        status: 'active',
        explorers: [
            {
                name: 'Ozean Testnet Explorer',
                url: 'https://ozean-testnet.explorer.caldera.xyz',
                icon: 'ozean',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111' },
        iconURL: 'https://ipfs.io/ipfs/bafkreiapf66dn4de4dz2oyn63y3bpafm5f6pne4gxtufapd452c4ruzj5a'
    },
    8007736: {
        name: 'Plian Mainnet Subchain 1',
        chain: 'Plian',
        rpc: ['https://mainnet.plian.io/child_0'],
        faucets: [],
        nativeCurrency: { name: 'Plian Token', symbol: 'PI', decimals: 18 },
        infoURL: 'https://plian.org',
        shortName: 'plian-mainnet-l2',
        chainId: 8007736,
        networkId: 8007736,
        explorers: [
            {
                name: 'piscan',
                url: 'https://piscan.plian.org/child_0',
                standard: 'EIP3091'
            }
        ],
        parent: { chain: 'eip155-2099156', type: 'L2' }
    },
    8008135: {
        name: 'Fhenix Helium',
        chain: 'tFHE',
        rpc: ['https://api.helium.fhenix.zone'],
        faucets: ['https://get-helium.fhenix.zone'],
        nativeCurrency: { name: 'tFHE', symbol: 'tFHE', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.fhenix.io',
        shortName: 'fhe-helium',
        chainId: 8008135,
        networkId: 8008135,
        explorers: [
            {
                name: 'Fhenix Helium Explorer (Blockscout)',
                url: 'https://explorer.helium.fhenix.zone',
                standard: 'EIP3091'
            }
        ]
    },
    8080808: {
        name: 'Hokum',
        chain: 'Hokum',
        icon: 'hokum',
        rpc: ['https://mainnet.hokum.gg'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://hokum.gg',
        shortName: 'hokum',
        chainId: 8080808,
        networkId: 8080808,
        explorers: [
            {
                name: 'Hokum Explorer',
                url: 'https://explorer.hokum.gg',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmafrUmh1FD48WWQwk6pfW1Y7eA9VQTdpeL387Wt2JFrAd'
    },
    8601152: {
        name: 'Waterfall 8 Test Network',
        chain: 'Waterfall Testnet8',
        rpc: ['https://rpc.testnet8.waterfall.network/'],
        faucets: ['https://faucet.testnet8.waterfall.network'],
        nativeCurrency: { name: 'WATER', symbol: 'WATER', decimals: 18 },
        features: [{ name: 'EIP1559' }],
        infoURL: 'https://waterfall.network',
        shortName: 'waterfall',
        chainId: 8601152,
        networkId: 8601152,
        icon: 'waterfall',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmSDJPBKh9cLVL8UZ5KYwdwPyhD8bRWNb33jjt48wtu5Uc'
    },
    8794598: {
        name: 'HAPchain',
        chain: 'HAPchain',
        rpc: ['https://jsonrpc.hap.land'],
        faucets: [],
        nativeCurrency: { name: 'HAP', symbol: 'HAP', decimals: 18 },
        infoURL: 'https://hap.land',
        shortName: 'hap',
        chainId: 8794598,
        networkId: 8794598,
        icon: 'hap',
        explorers: [
            {
                name: 'HAP EVM Explorer (Blockscout)',
                url: 'https://blockscout.hap.land',
                standard: 'none',
                icon: 'hap'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQ4V9JC25yUrYk2kFJwmKguSsZBQvtGcg6q9zkDV8mkJW'
    },
    8888881: {
        name: 'Quarix Testnet',
        chain: 'Quarix',
        status: 'incubating',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'QARE', symbol: 'QARE', decimals: 18 },
        infoURL: '',
        shortName: 'quarix-testnet',
        chainId: 8888881,
        networkId: 8888881,
        slip44: 1,
        icon: 'quarix',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmTw8TyeeNhUFWrck2WCiN17MaHRt5qzRBtaAvmz6L7qq7'
    },
    8888888: {
        name: 'Quarix',
        chain: 'Quarix',
        status: 'incubating',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'QARE', symbol: 'QARE', decimals: 18 },
        infoURL: '',
        shortName: 'quarix',
        chainId: 8888888,
        networkId: 8888888,
        icon: 'quarix',
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmTw8TyeeNhUFWrck2WCiN17MaHRt5qzRBtaAvmz6L7qq7'
    },
    9322252: {
        name: 'XCAP',
        title: 'XCAP Mainnet',
        chain: 'XCAP',
        rpc: [
            'https://xcap-mainnet.relay.xcap.network/znzvh2ueyvm2yts5fv5gnul395jbkfb2/rpc1'
        ],
        faucets: [],
        nativeCurrency: { name: 'Gas', symbol: 'GAS', decimals: 18 },
        infoURL: 'https://xcap.network/',
        shortName: 'xcap',
        chainId: 9322252,
        networkId: 9322252,
        icon: 'xcap',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://xcap-mainnet.explorer.xcap.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeTj6tfaw9qf9wnEUQh7PnCpNWyvm56e7kY35kANRWNxj'
    },
    9322253: {
        name: 'Milvine',
        title: 'XCAP Testnet Milvine',
        chain: 'XCAP',
        rpc: [
            'https://xcap-milvine.relay.xcap.network/zj5l55ftsgi027kz4nf14vs8d89inego/rpc1'
        ],
        faucets: [],
        nativeCurrency: { name: 'Gas', symbol: 'GAS', decimals: 18 },
        infoURL: 'https://xcap.network/',
        shortName: 'milv',
        chainId: 9322253,
        networkId: 9322253,
        icon: 'xcap',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://xcap-milvine.explorer.xcap.network',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeTj6tfaw9qf9wnEUQh7PnCpNWyvm56e7kY35kANRWNxj'
    },
    9999999: {
        name: 'Fluence',
        chain: 'Fluence',
        rpc: ['https://rpc.mainnet.fluence.dev/', 'wss://ws.mainnet.fluence.dev/'],
        faucets: [],
        nativeCurrency: { name: 'FLT', symbol: 'FLT', decimals: 18 },
        infoURL: 'https://fluence.network/',
        shortName: 'fluence',
        chainId: 9999999,
        networkId: 9999999,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.mainnet.fluence.dev',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-1' }
    },
    10058111: {
        name: 'Spotlight',
        chain: 'ETH',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://spotlightchain.com/',
        shortName: 'spotlight',
        chainId: 10058111,
        networkId: 10058111,
        status: 'incubating'
    },
    10058112: {
        name: 'Spotlight Sepolia Testnet',
        chain: 'ETH',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://spotlightchain.com/',
        shortName: 'spotlightsep',
        chainId: 10058112,
        networkId: 10058112,
        status: 'incubating'
    },
    10067275: {
        name: 'Plian Testnet Subchain 1',
        chain: 'Plian',
        rpc: ['https://testnet.plian.io/child_test'],
        faucets: [],
        nativeCurrency: { name: 'Plian Token', symbol: 'TPI', decimals: 18 },
        infoURL: 'https://plian.org/',
        shortName: 'plian-testnet-l2',
        chainId: 10067275,
        networkId: 10067275,
        slip44: 1,
        explorers: [
            {
                name: 'piscan',
                url: 'https://testnet.plian.org/child_test',
                standard: 'EIP3091'
            }
        ],
        parent: { chain: 'eip155-16658437', type: 'L2' }
    },
    10101010: {
        name: 'Soverun Mainnet',
        chain: 'SVRN',
        icon: 'soverun',
        rpc: ['https://mainnet-rpc.soverun.com'],
        faucets: ['https://faucet.soverun.com'],
        nativeCurrency: { name: 'Soverun', symbol: 'SVRN', decimals: 18 },
        infoURL: 'https://soverun.com',
        shortName: 'SVRNm',
        chainId: 10101010,
        networkId: 10101010,
        explorers: [
            {
                name: 'Soverun',
                url: 'https://explorer.soverun.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTYazUzgY9Nn2mCjWwFUSLy3dG6i2PvALpwCNQvx1zXyi'
    },
    10241024: {
        name: 'AlienX Mainnet',
        chain: 'AlienX Mainnet',
        rpc: ['https://rpc.alienxchain.io/http'],
        faucets: [],
        nativeCurrency: { name: 'Ethereum', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://alienxchain.io/home',
        shortName: 'AlienX',
        chainId: 10241024,
        networkId: 10241024,
        icon: 'alienx',
        explorers: [
            {
                name: 'AlienXChain Explorer',
                url: 'https://explorer.alienxchain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWAa7JayD8HCtAMXezzUNcUoi2Rikqpu2WmrHpFBmDEez'
    },
    10241025: {
        name: 'ALIENX Hal Testnet',
        chain: 'ALIENX Hal',
        rpc: [
            'https://hal-rpc.alienxchain.io/http',
            'https://hal.rpc.caldera.xyz/http'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ethereum', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://alienxchain.io/home',
        shortName: 'ALIENXHal',
        chainId: 10241025,
        networkId: 10241025,
        icon: 'hal',
        explorers: [
            {
                name: 'Hal Explorer',
                url: 'https://hal-explorer.alienxchain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWAa7JayD8HCtAMXezzUNcUoi2Rikqpu2WmrHpFBmDEez'
    },
    11145513: {
        name: 'Blessnet Sepolia',
        chain: 'ETH',
        rpc: [
            'https://blessnet-sepolia-testnet.rpc.caldera.xyz/http',
            'wss://blessnet-sepolia-testnet.rpc.caldera.xyz/ws'
        ],
        faucets: ['https://blessnet-sepolia-testnet.hub.caldera.xyz'],
        nativeCurrency: { name: 'Bless', symbol: 'BLESS', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://blessnet.io',
        shortName: 'bless-sepolia',
        chainId: 11145513,
        networkId: 11145513,
        icon: 'bless',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blessnet-sepolia-testnet.explorer.caldera.xyz',
                icon: 'bless',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-421614',
            bridges: [{ url: 'https://blessnet-sepolia-testnet.bridge.caldera.xyz' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmUP7NPPrCe6N6k8RQh4KuSBU2xMvbyo6enCtzyE5v4bmQ'
    },
    11155111: {
        name: 'Ethereum Sepolia',
        title: 'Ethereum Testnet Sepolia',
        chain: 'ETH',
        rpc: [
            'https://rpc.sepolia.org',
            'https://rpc2.sepolia.org',
            'https://rpc.sepolia.ethpandaops.io',
            'https://sepolia.infura.io/v3/${INFURA_API_KEY}',
            'wss://sepolia.infura.io/v3/${INFURA_API_KEY}',
            'https://sepolia.gateway.tenderly.co',
            'wss://sepolia.gateway.tenderly.co',
            'https://ethereum-sepolia-rpc.publicnode.com',
            'wss://ethereum-sepolia-rpc.publicnode.com',
            'https://sepolia.drpc.org',
            'wss://sepolia.drpc.org',
            'https://eth-sepolia.g.alchemy.com/v2/WddzdzI2o9S3COdT73d5w6AIogbKq4X-'
        ],
        faucets: ['http://fauceth.komputing.org?chain=11155111&address=${ADDRESS}'],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://sepolia.otterscan.io',
        shortName: 'sep',
        chainId: 11155111,
        networkId: 11155111,
        slip44: 1,
        explorers: [
            {
                name: 'etherscan-sepolia',
                url: 'https://sepolia.etherscan.io',
                standard: 'EIP3091'
            },
            {
                name: 'otterscan-sepolia',
                url: 'https://sepolia.otterscan.io',
                standard: 'EIP3091'
            },
            {
                name: 'Routescan',
                url: 'https://11155111.testnet.routescan.io',
                standard: 'EIP3091'
            }
        ]
    },
    11155420: {
        name: 'OP Sepolia Testnet',
        chain: 'ETH',
        rpc: [
            'https://sepolia.optimism.io',
            'https://optimism-sepolia.drpc.org',
            'wss://optimism-sepolia.drpc.org'
        ],
        faucets: ['https://app.optimism.io/faucet'],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://optimism.io',
        shortName: 'opsep',
        chainId: 11155420,
        networkId: 11155420,
        slip44: 1,
        explorers: [
            {
                name: 'etherscan-sepolia-optimism',
                url: 'https://sepolia-optimism.etherscan.io',
                standard: 'EIP3091'
            },
            {
                name: 'opscout',
                url: 'https://optimism-sepolia.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    11155931: {
        name: 'RISE Testnet',
        chain: 'ETH',
        rpc: ['https://testnet.riselabs.xyz', 'wss://testnet.riselabs.xyz/ws'],
        faucets: ['https://faucet.testnet.riselabs.xyz'],
        nativeCurrency: { name: 'RISE Testnet Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://www.riselabs.xyz/',
        shortName: 'rise-testnet',
        chainId: 11155931,
        networkId: 11155931,
        icon: 'rise',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.testnet.riselabs.xyz',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge-ui.testnet.riselabs.xyz' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafybeigpqflfjdeovryzeqcw42chsqtoed6ommcilepi7hnarqf34rat7i'
    },
    11166111: {
        name: 'R0AR Testnet',
        chain: 'R0AR Testnet',
        rpc: ['https://testnet.rpc-r0ar.io'],
        faucets: ['https://testnet.r0arfaucet.io'],
        nativeCurrency: { name: 'Ethereum', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://testnet.r0arscan.io',
        shortName: 'R0AR-Test-Chain',
        chainId: 11166111,
        networkId: 11166111,
        explorers: [
            {
                name: 'tracehawk',
                url: 'https://testnet.r0arscan.io',
                standard: 'none'
            }
        ]
    },
    12020498: {
        name: 'Lummio Network',
        chain: 'Lummio Network',
        rpc: ['https://rpc.lummio.net'],
        faucets: [],
        nativeCurrency: {
            name: 'Lummio Reward Points',
            symbol: 'LRPO',
            decimals: 18
        },
        infoURL: 'https://lummio.net',
        shortName: 'lummio',
        chainId: 12020498,
        networkId: 12020498,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.lummio.net',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ]
    },
    12052024: {
        name: 'Memento Testnet',
        chain: 'Memento',
        rpc: ['https://test-rpc.mementoblockchain.com/IRkghvI3FfEArEJMr4zC/rpc'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: '',
        shortName: 'memento-test',
        chainId: 12052024,
        networkId: 12052024,
        explorers: [
            {
                name: 'Tracehawk',
                url: 'https://test-explorer.mementoblockchain.com',
                standard: 'none'
            }
        ]
    },
    12227331: {
        name: 'NeoX Testnet T3',
        chain: 'NeoX',
        rpc: ['https://neoxseed1.ngd.network/'],
        faucets: [],
        nativeCurrency: { name: 'Gas', symbol: 'GAS', decimals: 18 },
        infoURL: 'https://neo.org/',
        shortName: 'neox',
        chainId: 12227331,
        networkId: 12227331,
        icon: 'neox',
        explorers: [
            {
                name: 'neox-scan',
                url: 'https://testnet.scan.banelabs.org',
                standard: 'EIP3091'
            }
        ],
        status: 'deprecated',
        iconURL: 'https://ipfs.io/ipfs/QmR3iCrjrW814fyv79UeVimDT4fTeBQcpYgMYxv1U6W15u'
    },
    12227332: {
        name: 'Neo X Testnet T4',
        chain: 'Neo X',
        rpc: ['https://testnet.rpc.banelabs.org/'],
        faucets: [],
        nativeCurrency: { name: 'Gas', symbol: 'GAS', decimals: 18 },
        infoURL: 'https://neo.org/',
        shortName: 'neox-t4',
        chainId: 12227332,
        networkId: 12227332,
        icon: 'neox',
        explorers: [
            {
                name: 'neox-scan',
                url: 'https://xt4scan.ngd.network',
                standard: 'EIP3091'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmR3iCrjrW814fyv79UeVimDT4fTeBQcpYgMYxv1U6W15u'
    },
    13068200: {
        name: 'COTI Devnet',
        title: 'COTI Devnet',
        chain: 'COTI',
        icon: 'coti',
        rpc: ['https://devnet.coti.io/rpc'],
        faucets: ['https://faucet.coti.io'],
        nativeCurrency: { name: 'COTI2', symbol: 'COTI2', decimals: 18 },
        infoURL: 'https://coti.io/',
        shortName: 'coti-devnet',
        chainId: 13068200,
        networkId: 13068200,
        explorers: [
            {
                name: 'coti devnet explorer',
                url: 'https://explorer-devnet.coti.io',
                icon: 'ethernal',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmR58SroHx7ovpqEB5iRkw4PufEXmcCBAJ8AZ7mChDgTfV'
    },
    13371337: {
        name: 'PepChain Churchill',
        chain: 'PEP',
        rpc: ['https://churchill-rpc.pepchain.io'],
        faucets: [],
        nativeCurrency: {
            name: 'PepChain Churchill Ether',
            symbol: 'TPEP',
            decimals: 18
        },
        infoURL: 'https://pepchain.io',
        shortName: 'tpep',
        chainId: 13371337,
        networkId: 13371337
    },
    14288640: {
        name: 'Anduschain Mainnet',
        chain: 'anduschain',
        rpc: ['https://rpc.anduschain.io/rpc', 'wss://rpc.anduschain.io/ws'],
        faucets: [],
        nativeCurrency: { name: 'DAON', symbol: 'DEB', decimals: 18 },
        infoURL: 'https://anduschain.io/',
        shortName: 'anduschain-mainnet',
        chainId: 14288640,
        networkId: 14288640,
        explorers: [
            {
                name: 'anduschain explorer',
                url: 'https://explorer.anduschain.io',
                icon: 'daon',
                standard: 'none'
            }
        ]
    },
    16658437: {
        name: 'Plian Testnet Main',
        chain: 'Plian',
        rpc: ['https://testnet.plian.io/testnet'],
        faucets: [],
        nativeCurrency: {
            name: 'Plian Testnet Token',
            symbol: 'TPI',
            decimals: 18
        },
        infoURL: 'https://plian.org',
        shortName: 'plian-testnet',
        chainId: 16658437,
        networkId: 16658437,
        slip44: 1,
        explorers: [
            {
                name: 'piscan',
                url: 'https://testnet.plian.org/testnet',
                standard: 'EIP3091'
            }
        ]
    },
    16969696: {
        name: 'Privix Chain Mainnet',
        chain: 'PRIVIX',
        rpc: [
            'https://mainnet-rpc.privixchain.xyz/',
            'wss://mainnet-rpc.privixchain.xyz/ws'
        ],
        faucets: [],
        nativeCurrency: { name: 'Privix Coin', symbol: 'PRIVIX', decimals: 18 },
        infoURL: 'https://privix.co/',
        shortName: 'mpsc',
        chainId: 16969696,
        networkId: 16969696,
        icon: 'privix',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://privixscan.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigodpsoidrdcnck4gemprf6zh6qptx72t2iit3hq7rhtk5qbr6vri'
    },
    17000920: {
        name: 'Lambda Chain Testnet',
        chain: 'Lambda Chain',
        rpc: ['https://testnrpc.lambda.im/'],
        faucets: [],
        nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://lambda.im',
        shortName: 'tlambda',
        chainId: 17000920,
        networkId: 17000920,
        slip44: 1,
        icon: 'lambda-chain',
        explorers: [
            {
                name: 'Lambda Chain Testnet Explorer',
                url: 'https://testscan.lambda.im',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXCWjWSTd6kJZKnH9aQRjgLdWRH9NTxU1wC21iBvoB4Hp'
    },
    18071918: {
        name: 'Mande Network Mainnet',
        chain: 'Mande',
        rpc: ['https://mande-mainnet.public.blastapi.io'],
        faucets: [],
        nativeCurrency: { name: 'Mand', symbol: 'MAND', decimals: 18 },
        infoURL: 'https://mande.network/',
        shortName: 'Mande',
        chainId: 18071918,
        networkId: 18071918,
        icon: 'mande',
        explorers: [
            {
                name: 'FYI',
                url: 'https://dym.fyi/r/mande',
                icon: 'fyi',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmbySJWaSQxzL3F4zvpKYaNvMjHsX2qUyWTv2kpitq9dW8'
    },
    18289463: {
        name: 'IOLite',
        chain: 'ILT',
        rpc: ['https://net.iolite.io'],
        faucets: [],
        nativeCurrency: { name: 'IOLite Ether', symbol: 'ILT', decimals: 18 },
        infoURL: 'https://iolite.io',
        shortName: 'ilt',
        chainId: 18289463,
        networkId: 18289463
    },
    19850818: {
        name: 'DeepBrainChain Testnet',
        chain: 'DeepBrainChain',
        rpc: ['https://rpc-testnet.dbcwallet.io'],
        faucets: [],
        nativeCurrency: { name: 'DeepBrainChain', symbol: 'tDBC', decimals: 18 },
        infoURL: 'https://www.deepbrainchain.org',
        shortName: 'tDBC',
        chainId: 19850818,
        icon: 'dbc',
        networkId: 19850818,
        slip44: 1,
        explorers: [
            {
                name: 'DeepBrainChain Testnet',
                url: 'https://testnet.dbcscan.io',
                icon: 'dbc',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXxRtZnrvzckKVwbRLpKpP9E9vGgQCUPkLroQDCYTmQdG'
    },
    19880818: {
        name: 'DeepBrainChain Mainnet',
        chain: 'DeepBrainChain',
        rpc: ['https://rpc.dbcwallet.io'],
        faucets: [],
        nativeCurrency: { name: 'DeepBrainChain', symbol: 'DBC', decimals: 18 },
        infoURL: 'https://www.deepbrainchain.org',
        shortName: 'DBC',
        chainId: 19880818,
        networkId: 19880818,
        icon: 'dbc',
        slip44: 1,
        explorers: [
            {
                name: 'DeepBrainChain Mainnet',
                url: 'https://www.dbcscan.io',
                icon: 'dbc',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXxRtZnrvzckKVwbRLpKpP9E9vGgQCUPkLroQDCYTmQdG'
    },
    20180427: {
        name: 'Stability Testnet',
        chain: 'stabilityTestnet',
        icon: 'stabilitytestnet',
        rpc: ['https://free.testnet.stabilityprotocol.com'],
        faucets: [],
        nativeCurrency: { name: 'FREE', symbol: 'FREE', decimals: 18 },
        infoURL: 'https://stabilityprotocol.com',
        shortName: 'stabilitytestnet',
        chainId: 20180427,
        networkId: 20180427,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://stability-testnet.blockscout.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreid3wd6ouu53r677q2z24a4eq5un5tlwbc4izfapcvvtrlhkmz43au'
    },
    20180430: {
        name: 'SmartMesh Mainnet',
        chain: 'Spectrum',
        rpc: ['https://jsonapi1.smartmesh.cn'],
        faucets: [],
        nativeCurrency: {
            name: 'SmartMesh Native Token',
            symbol: 'SMT',
            decimals: 18
        },
        infoURL: 'https://smartmesh.io',
        shortName: 'spectrum',
        chainId: 20180430,
        networkId: 1,
        explorers: [
            { name: 'spectrum', url: 'https://spectrum.pub', standard: 'none' }
        ]
    },
    20181205: {
        name: 'quarkblockchain',
        chain: 'QKI',
        rpc: [
            'https://hz.rpc.qkiscan.cn',
            'https://jp.rpc.qkiscan.io',
            'https://rpc1.qkiscan.io',
            'https://rpc2.qkiscan.io',
            'https://rpc3.qkiscan.io'
        ],
        faucets: [],
        nativeCurrency: {
            name: 'quarkblockchain Native Token',
            symbol: 'QKI',
            decimals: 18
        },
        infoURL: 'https://quarkblockchain.org/',
        shortName: 'qki',
        chainId: 20181205,
        networkId: 20181205,
        explorers: [
            { name: 'qkiscan', url: 'https://qkiscan.io', standard: 'EIP3091' }
        ]
    },
    20201022: {
        name: 'Pego Network',
        chain: 'PEGO',
        rpc: [
            'https://pegorpc.com',
            'https://node1.pegorpc.com',
            'https://node2.pegorpc.com',
            'https://node3.pegorpc.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Pego Native Token', symbol: 'PG', decimals: 18 },
        infoURL: 'https://pego.network',
        shortName: 'pg',
        chainId: 20201022,
        networkId: 20201022,
        icon: 'pego',
        explorers: [
            {
                name: 'Pego Network Explorer',
                url: 'https://scan.pego.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVf1afskRHuZjFSLCZH8397KrVNAoYgyAePX9VMBrPVtx'
    },
    20221001: {
        name: 'SoonChain Sepolia Devnet',
        chain: 'SoonChain Devnet Sepolia',
        rpc: ['https://sepolia.rpc.soonchain.ai'],
        faucets: ['https://console.optimism.io/faucet'],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://soonchain.ai',
        shortName: 'Soon-Devnet',
        chainId: 20221001,
        networkId: 20221001,
        icon: 'soonchain',
        explorers: [
            {
                name: 'Soon Scan',
                url: 'https://sepolia.explorer.soonchain.ai',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreia4zzsj2wxfrincui3hk664sspjfapd744eybh6th566ncj5js7aa'
    },
    20230825: {
        name: 'Vcity Testnet',
        chain: 'VCITY',
        rpc: ['http://testnet-rpc.vcity.app'],
        faucets: [],
        nativeCurrency: {
            name: 'Testnet Vcity Token',
            symbol: 'VCT',
            decimals: 18
        },
        features: [],
        infoURL: 'https://vcity.app',
        shortName: 'Vcitytestnet',
        chainId: 20230825,
        networkId: 20230825,
        icon: 'vcity',
        explorers: [
            {
                name: 'Vcity Explorer',
                url: 'https://scan.vcity.app',
                icon: 'vcity',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXBNp75r6DUCB99vknr5B1hHQFMCc1c2wE3qNbYkuss9C'
    },
    20240324: {
        name: 'DeBank Sepolia Testnet',
        chain: 'DeBank',
        rpc: ['https://sepolia-rpc.testnet.debank.com'],
        faucets: [],
        icon: 'debank',
        nativeCurrency: { name: 'DeBank USD', symbol: 'USD', decimals: 18 },
        infoURL: 'https://debank.com',
        shortName: 'dbkse',
        chainId: 20240324,
        networkId: 20240324,
        slip44: 1,
        explorers: [
            {
                name: 'DeBank Chain Explorer',
                url: 'https://sepolia-explorer.testnet.debank.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmW9pBps8WHRRWmyXhjLZrjZJUe8F48hUu7z98bu2RVsjN'
    },
    20240603: {
        name: 'DBK Chain',
        chain: 'DBK Chain',
        rpc: ['https://rpc.mainnet.dbkchain.io'],
        icon: 'dbkchain',
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://docs.dbkchain.io',
        shortName: 'dbkchain',
        chainId: 20240603,
        networkId: 20240603,
        explorers: [
            {
                name: 'DBK Chain Explorer',
                url: 'https://scan.dbkchain.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeib7ovny3xkl4nr4a5oqvoqwf7dcjtqavydysclfmbavbl2oekhxty'
    },
    20241133: {
        name: 'Swan Proxima Testnet',
        chain: 'SWAN',
        rpc: ['https://rpc-proxima.swanchain.io'],
        faucets: [],
        nativeCurrency: { name: 'SWANETH', symbol: 'sETH', decimals: 18 },
        infoURL: 'https://swanchain.io/',
        shortName: 'Proxima',
        chainId: 20241133,
        networkId: 20241133,
        explorers: [
            {
                name: 'Swan Proxima Chain explorer',
                url: 'https://proxima-explorer.swanchain.io',
                standard: 'EIP3091'
            }
        ]
    },
    20250217: {
        name: 'Xphere Mainnet',
        chain: 'Xphere',
        icon: 'xphere',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        rpc: ['https://en-bkk.x-phere.com'],
        faucets: [],
        nativeCurrency: { name: 'Xphere', symbol: 'XP', decimals: 18 },
        infoURL: 'https://x-phere.com/',
        shortName: 'xp',
        chainId: 20250217,
        networkId: 20250217,
        explorers: [
            { name: 'Tamsa', url: 'https://xp.tamsa.io', standard: 'EIP3091' }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfUV9PqF7JxuUAYaBHh6YJ2ChCdDVobTwDibxQuPMUmPq'
    },
    20250825: {
        name: 'Vcitychain Mainnet',
        chain: 'Vcitychain',
        rpc: ['https://mainnet-rpc.vcity.app'],
        faucets: [],
        nativeCurrency: { name: 'Vcity Coin', symbol: 'VCITY', decimals: 18 },
        features: [],
        infoURL: 'https://vcity.app',
        shortName: 'vcity',
        chainId: 20250825,
        networkId: 20250825,
        icon: 'vcitychain',
        explorers: [
            {
                name: 'Vcitychain Explorer',
                url: 'https://blockchain.vcity.app',
                icon: 'vcitychain',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiawfldsm6h56ug2md3hp6xeos3xoyqt6gnw4mepz2f6lzi6xcygli'
    },
    20256789: {
        name: 'ETP Mainnet',
        chain: 'ETP',
        rpc: ['https://rpc.etpscan.xyz'],
        faucets: [],
        nativeCurrency: {
            name: 'ETP Chain Native Token',
            symbol: 'ETP',
            decimals: 18
        },
        infoURL: 'https://www.etposchain.com',
        shortName: 'ETP',
        chainId: 20256789,
        networkId: 20256789,
        icon: 'etpchain',
        explorers: [
            {
                name: 'ETPScan',
                url: 'https://etpscan.xyz',
                icon: 'etpchain',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreid4pi4wvhivaydzlflqqgdbddrmmc2szqtgsuhrp4hgfplg2z7ffe'
    },
    20482050: {
        name: 'Hokum Testnet',
        chain: 'HokumTestnet',
        icon: 'hokum',
        rpc: ['https://testnet.hokum.gg'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://hokum.gg',
        shortName: 'hokum-testnet',
        chainId: 20482050,
        networkId: 20482050,
        explorers: [
            {
                name: 'Hokum Explorer',
                url: 'https://testnet-explorer.hokum.gg',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmafrUmh1FD48WWQwk6pfW1Y7eA9VQTdpeL387Wt2JFrAd'
    },
    21000000: {
        name: 'Corn',
        chain: 'BTCN',
        rpc: [
            'https://mainnet.corn-rpc.com',
            'https://rpc.ankr.com/corn_maizenet',
            'https://maizenet-rpc.usecorn.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Bitcorn', symbol: 'BTCN', decimals: 18 },
        infoURL: 'https://usecorn.com',
        shortName: 'corn',
        chainId: 21000000,
        networkId: 21000000,
        icon: 'corn',
        explorers: [
            {
                name: 'Corn Explorer',
                url: 'https://cornscan.io',
                standard: 'EIP3091'
            },
            {
                name: 'Corn Blockscout',
                url: 'https://maizenet-explorer.usecorn.com',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-1' },
        iconURL: 'https://ipfs.io/ipfs/bafkreiho2xcmjcg6tv7dbns5jl7zsp7f5rpymjuv3c2h2trvmfwm3hmwce'
    },
    21000001: {
        name: 'Corn Testnet',
        chain: 'BTCN',
        rpc: [
            'https://testnet.corn-rpc.com',
            'https://rpc.ankr.com/corn_testnet',
            'https://testnet-rpc.usecorn.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Bitcorn', symbol: 'BTCN', decimals: 18 },
        infoURL: 'https://usecorn.com',
        shortName: 'corn-testnet',
        chainId: 21000001,
        networkId: 21000001,
        explorers: [
            {
                name: 'Corn Testnet Explorer',
                url: 'https://testnet.cornscan.io',
                standard: 'EIP3091'
            },
            {
                name: 'Corn Testnet Blockscout',
                url: 'https://testnet-explorer.usecorn.com',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111' }
    },
    22052002: {
        name: 'Excelon Mainnet',
        chain: 'XLON',
        icon: 'xlon',
        rpc: ['https://edgewallet1.xlon.org/'],
        faucets: [],
        nativeCurrency: { name: 'Excelon', symbol: 'xlon', decimals: 18 },
        infoURL: 'https://xlon.org',
        shortName: 'xlon',
        chainId: 22052002,
        networkId: 22052002,
        explorers: [
            {
                name: 'Excelon explorer',
                url: 'https://explorer.excelon.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTV45o4jTe6ayscF1XWh1WXk5DPck4QohR5kQocSWjvQP'
    },
    24132016: {
        name: 'XMTP',
        chain: 'ETH',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'USDC', symbol: 'USDC', decimals: 18 },
        infoURL: 'https://xmtp.org',
        shortName: 'xmtp',
        chainId: 24132016,
        networkId: 24132016,
        status: 'incubating'
    },
    24772477: {
        name: '6Degree of Outreach - Testnet',
        chain: '6DO',
        rpc: ['https://rpc-testnet.6dochain.com'],
        faucets: [],
        nativeCurrency: {
            name: '6Degree-Testnet Coin',
            symbol: '6DO-T',
            decimals: 18
        },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://6do.world',
        shortName: '6dotest',
        chainId: 24772477,
        networkId: 24772477,
        icon: '6do',
        explorers: [
            {
                name: '6Degree Testnet Chain Explorer',
                url: 'https://explorer-testnet.6dochain.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWyyraWiYNJRAb4AEEkozjh8u5TAnFNG7YnFd7A54AjPi'
    },
    27082017: {
        name: 'Excoincial Chain Volta-Testnet',
        chain: 'TEXL',
        icon: 'exl',
        rpc: ['https://testnet-rpc.exlscan.com'],
        faucets: ['https://faucet.exlscan.com'],
        nativeCurrency: { name: 'TExlcoin', symbol: 'TEXL', decimals: 18 },
        infoURL: '',
        shortName: 'exlvolta',
        chainId: 27082017,
        networkId: 27082017,
        slip44: 1,
        explorers: [
            {
                name: 'exlscan',
                url: 'https://testnet-explorer.exlscan.com',
                icon: 'exl',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeooM7QicT1YbgY93XPd5p7JsCjYhN3qjWt68X57g6bVC'
    },
    27082022: {
        name: 'Excoincial Chain Mainnet',
        chain: 'EXL',
        icon: 'exl',
        rpc: ['https://rpc.exlscan.com'],
        faucets: [],
        nativeCurrency: { name: 'Exlcoin', symbol: 'EXL', decimals: 18 },
        infoURL: '',
        shortName: 'exl',
        chainId: 27082022,
        networkId: 27082022,
        explorers: [
            {
                name: 'exlscan',
                url: 'https://exlscan.com',
                icon: 'exl',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmeooM7QicT1YbgY93XPd5p7JsCjYhN3qjWt68X57g6bVC'
    },
    28122024: {
        name: 'Ancient8 Testnet',
        chain: 'Ancient8',
        icon: 'ancient8',
        rpc: ['https://rpcv2-testnet.ancient8.gg'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://ancient8.gg/',
        shortName: 'a8',
        chainId: 28122024,
        networkId: 28122024,
        slip44: 1,
        explorers: [
            {
                name: 'scan-testnet',
                url: 'https://scanv2-testnet.ancient8.gg',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreievnqg3xjokaty4kfbxxbrzm5v5y7exbaaia2txrh4sfgrqsalfym'
    },
    28945486: {
        name: 'Auxilium Network Mainnet',
        chain: 'AUX',
        rpc: ['https://rpc.auxilium.global'],
        faucets: [],
        nativeCurrency: { name: 'Auxilium coin', symbol: 'AUX', decimals: 18 },
        infoURL: 'https://auxilium.global',
        shortName: 'auxi',
        chainId: 28945486,
        networkId: 28945486,
        slip44: 344
    },
    29032022: {
        name: 'Flachain Mainnet',
        chain: 'FLX',
        icon: 'flacoin',
        rpc: ['https://flachain.flaexchange.top/'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Flacoin', symbol: 'FLA', decimals: 18 },
        infoURL: 'https://www.flaexchange.top',
        shortName: 'fla',
        chainId: 29032022,
        networkId: 29032022,
        explorers: [
            {
                name: 'FLXExplorer',
                url: 'https://explorer.flaexchange.top',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeiadlvc4pfiykehyt2z67nvgt5w4vlov27olu5obvmryv4xzua4tae'
    },
    31415926: {
        name: 'Filecoin - Local testnet',
        chain: 'FIL',
        status: 'incubating',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'testnet filecoin', symbol: 'tFIL', decimals: 18 },
        infoURL: 'https://filecoin.io',
        shortName: 'filecoin-local',
        icon: 'filecoin',
        chainId: 31415926,
        networkId: 31415926,
        slip44: 1,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmS9r9XQkMHVomWcSBNDkKkz9n87h9bH9ssabeiKZtANoU'
    },
    33626250: {
        name: 'Toliman Suave Testnet',
        chain: 'ETH',
        rpc: ['https://rpc.toliman.suave.flashbots.net'],
        faucets: ['https://faucet.toliman.suave.flashbots.net'],
        nativeCurrency: {
            name: 'SUAVE Toliman Eth',
            symbol: 'TEEth',
            decimals: 18
        },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://suave-alpha.flashbots.net/toliman',
        shortName: 'suave-toliman',
        chainId: 33626250,
        networkId: 33626250,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.toliman.suave.flashbots.net',
                standard: 'EIP3091'
            }
        ]
    },
    33772211: {
        name: 'Xone Testnet',
        chain: 'XOC',
        icon: 'xone-test',
        rpc: [
            'https://rpc-testnet.xone.plus',
            'https://rpc-testnet.xone.org',
            'https://rpc-testnet.knight.center',
            'wss://wss-rpc-testnet.xone.org'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: ['https://faucet.xone.org/'],
        nativeCurrency: { name: 'Xone Coin', symbol: 'XOC', decimals: 18 },
        infoURL: 'https://xone.org',
        shortName: 'txoc',
        chainId: 33772211,
        networkId: 33772211,
        explorers: [
            {
                name: 'testnet-xscscan',
                url: 'https://testnet.xscscan.com',
                icon: 'testnet-xscscan',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmR3twvfhDES34nLhcVmUbAZpW4eynZoSfA2XpWUBnH7gB'
    },
    34949059: {
        name: 'citronus-citro',
        title: 'Citronus-Citro',
        chain: 'citronus-citro',
        rpc: [
            'https://rpc.citro-testnet.t.raas.gelato.cloud',
            'wss://testnet-ws.eh-dev.app'
        ],
        nativeCurrency: { name: 'Citronus', symbol: 'CITRO', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/citronus-citro',
        faucets: [],
        shortName: 'citronus-citro',
        chainId: 34949059,
        networkId: 34949059,
        slip44: 60,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://test.citronus.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [
                {
                    url: 'https://testnet-bridge.gelato.network/bridge/citronus-citro'
                }
            ]
        },
        status: 'active'
    },
    35855456: {
        name: 'Joys Digital Mainnet',
        chain: 'JOYS',
        rpc: ['https://node.joys.digital'],
        faucets: [],
        nativeCurrency: { name: 'JOYS', symbol: 'JOYS', decimals: 18 },
        infoURL: 'https://joys.digital',
        shortName: 'JOYS',
        chainId: 35855456,
        networkId: 35855456
    },
    37084624: {
        name: 'SKALE Nebula Hub Testnet',
        title: 'SKALE Nebula Hub Testnet',
        chain: 'lanky-ill-funny-testnet',
        icon: 'nebula',
        rpc: [
            'https://testnet.skalenodes.com/v1/lanky-ill-funny-testnet',
            'wss://testnet.skalenodes.com/v1/ws/lanky-ill-funny-testnet'
        ],
        faucets: ['https://www.sfuelstation.com/'],
        nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
        infoURL: 'https://nebulachain.io/',
        shortName: 'nebula-testnet',
        chainId: 37084624,
        networkId: 37084624,
        slip44: 1,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://lanky-ill-funny-testnet.explorer.testnet.skalenodes.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeic5eexvd34wfy4kuebcyu73qpkv3x57s54ebzjyhyjsmeuni5jwcm'
    },
    39916801: {
        name: 'Kingdom Chain',
        chain: 'KingdomChain',
        rpc: ['https://kingdomchain.observer/rpc'],
        features: [{ name: 'EIP155' }],
        faucets: [],
        nativeCurrency: { name: 'Kozi', symbol: 'KOZI', decimals: 18 },
        infoURL: 'https://www.beastkingdom.io/',
        shortName: 'kchain',
        chainId: 39916801,
        networkId: 39916801,
        explorers: [
            {
                name: 'TravelSong',
                url: 'https://www.beastkingdom.io/travelsong',
                standard: 'EIP3091'
            }
        ]
    },
    43214913: {
        name: 'maistestsubnet',
        chain: 'MAI',
        rpc: [
            'http://174.138.9.169:9650/ext/bc/VUKSzFZKckx4PoZF9gX5QAqLPxbLzvu1vcssPG5QuodaJtdHT/rpc'
        ],
        faucets: [],
        nativeCurrency: { name: 'maistestsubnet', symbol: 'MAI', decimals: 18 },
        infoURL: '',
        shortName: 'mais',
        chainId: 43214913,
        networkId: 43214913,
        slip44: 1,
        explorers: [
            {
                name: 'maistesntet',
                url: 'http://174.138.9.169:3006/?network=maistesntet',
                standard: 'none'
            }
        ]
    },
    50591822: {
        name: 'Stavanger Public Testnet',
        chain: 'stavanger',
        rpc: ['https://rpc.stavanger.gateway.fm'],
        faucets: ['https://faucet.stavanger.gateway.fm'],
        nativeCurrency: { name: 'Polygon', symbol: 'POL', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://gateway.fm',
        shortName: 'stavanger',
        chainId: 50591822,
        networkId: 50591822,
        icon: 'stavanger',
        explorers: [
            {
                name: 'BlockScout',
                url: 'https://explorer.stavanger.gateway.fm',
                icon: 'stavanger',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge.stavanger.gateway.fm' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafybeighctebzusfrmvuahcswjrseyno3eaetu4oskwcu6ubivd7c7elqa'
    },
    52027071: {
        name: 'Deviant Token Blockchain',
        chain: 'DTBC',
        status: 'incubating',
        rpc: ['https://rpc.devianttoken.net'],
        faucets: [],
        nativeCurrency: { name: 'Deviant Token', symbol: 'DTBC', decimals: 18 },
        infoURL: 'https://devianttoken.net',
        shortName: 'dtbc',
        chainId: 52027071,
        networkId: 52027071,
        explorers: []
    },
    52027080: {
        name: 'Deviant Token Blockchain Testnet',
        chain: 'tDTBC',
        status: 'incubating',
        rpc: ['https://trpc.devianttoken.net'],
        faucets: [],
        nativeCurrency: {
            name: 'Deviant Token Testnet',
            symbol: 'tDTBC',
            decimals: 18
        },
        infoURL: 'https://devianttoken.net',
        shortName: 'tdtbc',
        chainId: 52027080,
        networkId: 52027080,
        explorers: []
    },
    52164803: {
        name: 'Fluence Testnet',
        chain: 'Fluence Testnet',
        rpc: ['https://rpc.testnet.fluence.dev/', 'wss://ws.testnet.fluence.dev/'],
        faucets: [],
        nativeCurrency: { name: 'tFLT', symbol: 'tFLT', decimals: 18 },
        infoURL: 'https://fluence.network/',
        shortName: 'fluence-testnet',
        chainId: 52164803,
        networkId: 52164803,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.testnet.fluence.dev',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111' }
    },
    61022448: {
        name: 'dKargo Warehouse Testnet',
        chain: 'dKargo Warehouse',
        rpc: ['https://warehouse-full01.dkargo.io'],
        faucets: [],
        nativeCurrency: { name: 'dKargo', symbol: 'DKA', decimals: 18 },
        infoURL: 'https://dkargo.io',
        shortName: 'dkargowarehouse',
        chainId: 61022448,
        networkId: 61022448
    },
    61717561: {
        name: 'Aquachain',
        chain: 'AQUA',
        rpc: ['https://c.onical.org', 'https://tx.aquacha.in/api'],
        faucets: ['https://aquacha.in/faucet'],
        nativeCurrency: { name: 'Aquachain Ether', symbol: 'AQUA', decimals: 18 },
        infoURL: 'https://aquachain.github.io',
        shortName: 'aqua',
        chainId: 61717561,
        networkId: 61717561,
        slip44: 61717561
    },
    65010000: {
        name: 'Autonity Bakerloo (Thames) Testnet',
        status: 'deprecated',
        chain: 'AUT',
        rpc: [],
        faucets: ['https://faucet.autonity.org/'],
        nativeCurrency: { name: 'Bakerloo Auton', symbol: 'ATN', decimals: 18 },
        infoURL: 'https://autonity.org/',
        shortName: 'bakerloo-0',
        chainId: 65010000,
        networkId: 65010000,
        slip44: 1,
        icon: 'autonity',
        explorers: [
            {
                name: 'autonity-blockscout',
                url: 'https://bakerloo.autonity.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme5nxFZZoNNpiT8u9WwcBot4HyLTg2jxMxRnsbc5voQwB'
    },
    65010001: {
        name: 'Autonity Bakerloo (Barada) Testnet',
        status: 'deprecated',
        chain: 'AUT',
        rpc: [],
        faucets: ['https://faucet.autonity.org/'],
        nativeCurrency: { name: 'Bakerloo Auton', symbol: 'ATN', decimals: 18 },
        infoURL: 'https://autonity.org/',
        shortName: 'bakerloo-01',
        chainId: 65010001,
        networkId: 65010001,
        slip44: 1,
        icon: 'autonity',
        explorers: [
            {
                name: 'autonity-blockscout',
                url: 'https://bakerloo.autonity.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme5nxFZZoNNpiT8u9WwcBot4HyLTg2jxMxRnsbc5voQwB'
    },
    65010002: {
        name: 'Autonity Bakerloo (Sumida) Testnet',
        status: 'deprecated',
        chain: 'AUT',
        rpc: [],
        faucets: ['https://faucet.autonity.org/'],
        nativeCurrency: { name: 'Bakerloo Auton', symbol: 'ATN', decimals: 18 },
        infoURL: 'https://autonity.org/',
        shortName: 'bakerloo-02',
        chainId: 65010002,
        networkId: 65010002,
        slip44: 1,
        icon: 'autonity',
        explorers: [
            {
                name: 'autonity-blockscout',
                url: 'https://bakerloo.autonity.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme5nxFZZoNNpiT8u9WwcBot4HyLTg2jxMxRnsbc5voQwB'
    },
    65010003: {
        name: 'Autonity Bakerloo (Yamuna) Testnet',
        status: 'deprecated',
        chain: 'AUT',
        rpc: [],
        faucets: ['https://faucet.autonity.org/'],
        nativeCurrency: { name: 'Bakerloo Auton', symbol: 'ATN', decimals: 18 },
        infoURL: 'https://autonity.org/',
        shortName: 'bakerloo-03',
        chainId: 65010003,
        networkId: 65010003,
        slip44: 1,
        icon: 'autonity',
        explorers: [
            {
                name: 'autonity-blockscout',
                url: 'https://bakerloo.autonity.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme5nxFZZoNNpiT8u9WwcBot4HyLTg2jxMxRnsbc5voQwB'
    },
    65100000: {
        name: 'Autonity Piccadilly (Thames) Testnet',
        status: 'deprecated',
        chain: 'AUT',
        rpc: [],
        faucets: ['https://faucet.autonity.org/'],
        nativeCurrency: { name: 'Piccadilly Auton', symbol: 'ATN', decimals: 18 },
        infoURL: 'https://autonity.org/',
        shortName: 'piccadilly-0',
        chainId: 65100000,
        networkId: 65100000,
        slip44: 1,
        icon: 'autonity',
        explorers: [
            {
                name: 'autonity-blockscout',
                url: 'https://piccadilly.autonity.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme5nxFZZoNNpiT8u9WwcBot4HyLTg2jxMxRnsbc5voQwB'
    },
    65100001: {
        name: 'Autonity Piccadilly (Barada) Testnet',
        status: 'deprecated',
        chain: 'AUT',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Piccadilly Auton', symbol: 'ATN', decimals: 18 },
        infoURL: 'https://autonity.org/',
        shortName: 'piccadilly-01',
        chainId: 65100001,
        networkId: 65100001,
        slip44: 1,
        icon: 'autonity',
        explorers: [
            {
                name: 'autonity-blockscout',
                url: 'https://piccadilly.autonity.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme5nxFZZoNNpiT8u9WwcBot4HyLTg2jxMxRnsbc5voQwB'
    },
    65100002: {
        name: 'Autonity Piccadilly (Sumida) Testnet',
        status: 'deprecated',
        chain: 'AUT',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Piccadilly Auton', symbol: 'ATN', decimals: 18 },
        infoURL: 'https://autonity.org/',
        shortName: 'piccadilly-02',
        chainId: 65100002,
        networkId: 65100002,
        slip44: 1,
        icon: 'autonity',
        explorers: [
            {
                name: 'autonity-blockscout',
                url: 'https://piccadilly.autonity.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme5nxFZZoNNpiT8u9WwcBot4HyLTg2jxMxRnsbc5voQwB'
    },
    65100003: {
        name: 'Autonity Piccadilly (Yamuna) Testnet',
        status: 'deprecated',
        chain: 'AUT',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Piccadilly Auton', symbol: 'ATN', decimals: 18 },
        infoURL: 'https://autonity.org/',
        shortName: 'piccadilly-03',
        chainId: 65100003,
        networkId: 65100003,
        slip44: 1,
        icon: 'autonity',
        explorers: [
            {
                name: 'autonity-blockscout',
                url: 'https://piccadilly.autonity.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme5nxFZZoNNpiT8u9WwcBot4HyLTg2jxMxRnsbc5voQwB'
    },
    65100004: {
        name: 'Autonity Piccadilly (Tiber) Testnet',
        chain: 'AUT',
        rpc: [
            'https://autonity.rpc.web3cdn.network/testnet',
            'wss://autonity.rpc.web3cdn.network/testnet/ws',
            'https://autonity-piccadilly.rpc.subquery.network/public',
            'https://piccadilly.autonity-apis.com',
            'wss://piccadilly-ws.autonity-apis.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Piccadilly Auton', symbol: 'ATN', decimals: 18 },
        infoURL: 'https://autonity.org/',
        shortName: 'piccadilly-04',
        chainId: 65100004,
        networkId: 65100004,
        slip44: 1,
        icon: 'autonity',
        explorers: [
            {
                name: 'autonity-blockscout',
                url: 'https://piccadilly.autonity.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qme5nxFZZoNNpiT8u9WwcBot4HyLTg2jxMxRnsbc5voQwB'
    },
    66666666: {
        name: 'Winr Protocol Testnet',
        chain: 'WINR',
        rpc: ['https://rpc-devnet.winr.games'],
        faucets: [],
        nativeCurrency: { name: 'Winr', symbol: 'WINR', decimals: 18 },
        features: [],
        infoURL: 'https://winr.games',
        shortName: 'winrtestnet',
        chainId: 66666666,
        networkId: 66666666,
        icon: 'winr',
        explorers: [
            {
                name: 'Winr Protocol Testnet Explorer',
                url: 'https://explorer-winrprotocoltestnet-wmwv59m23g.t.conduit.xyz',
                icon: 'winr',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmPL68edFCf9taAKQQu7rt11LrmWh7f7aBQ7ZkuhBKmrUv'
    },
    68840142: {
        name: 'Frame Testnet',
        chain: 'ETH',
        rpc: ['https://rpc.testnet.frame.xyz/http'],
        faucets: ['https://faucet.triangleplatform.com/frame/testnet'],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        icon: 'frameTestnet',
        infoURL: 'https://www.frame.xyz/',
        shortName: 'frametest',
        chainId: 68840142,
        networkId: 68840142,
        slip44: 1,
        explorers: [
            {
                name: 'Frame Testnet Explorer',
                url: 'https://explorer.testnet.frame.xyz',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRxeKFwBwrXyDksoN4NzNRp3R35s8pVnTBfBj4AJSCq5g'
    },
    77787778: {
        name: '0xHash Testnet',
        chain: 'HETH',
        icon: 'ethereum',
        rpc: ['https://rpc-test.0xhash.io'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: '0xHash', symbol: 'HETH', decimals: 18 },
        infoURL: 'https://0xhash.io',
        shortName: 'HETH',
        chainId: 77787778,
        networkId: 77787778,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://test.0xhashscan.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://app.optimism.io/bridge/deposit' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt'
    },
    79479957: {
        name: 'SX Toronto Rollup',
        chain: 'SX',
        icon: 'SX',
        rpc: ['https://rpc.sx-rollup-testnet.t.raas.gelato.cloud'],
        faucets: ['https://faucet.toronto.sx.technology'],
        nativeCurrency: { name: 'SX Network', symbol: 'SX', decimals: 18 },
        infoURL: 'https://www.sx.technology',
        shortName: 'SXR-Testnet',
        chainId: 79479957,
        networkId: 79479957,
        explorers: [
            {
                name: 'SX Toronto L2 Explorer',
                url: 'https://explorerl2.toronto.sx.technology',
                standard: 'EIP3091',
                icon: 'SX'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111' },
        iconURL: 'https://ipfs.io/ipfs/QmSXLXqyr2H6Ja5XrmznXbWTEvF2gFaL8RXNXgyLmDHjAF'
    },
    88558801: {
        name: 'Backstop Testnet',
        chain: 'backstopTestnet',
        icon: 'backstop',
        rpc: ['https://testnet.rpc.backstop.technology'],
        faucets: [],
        nativeCurrency: { name: 'Backstop Testnet 1', symbol: 'ZBS', decimals: 18 },
        infoURL: 'https://backstop.technology/testnet',
        shortName: 'backstop-testnet',
        chainId: 88558801,
        networkId: 88558801,
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://testnet.bridge.backstop.technology' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmaWH5iWif22gtYVizWvuPoEHZ3qZjYc8nXnEgPh9rLMiY'
    },
    88888888: {
        name: 'T.E.A.M Blockchain',
        chain: 'TEAM',
        icon: 'team',
        rpc: ['https://rpc.teamblockchain.team'],
        faucets: [],
        nativeCurrency: { name: 'TEAM', symbol: '$TEAM', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://teamblockchain.team',
        shortName: 'team',
        chainId: 88888888,
        networkId: 88888888,
        explorers: [
            {
                name: 'teamscan',
                url: 'https://teamblockchain.team',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcnA15BLE9uvznbugXKjqquizZs1eLPeEEkc92DSmvhmt'
    },
    89346162: {
        name: 'Reya Cronos',
        title: 'Reya Cronos',
        chain: 'reya-cronos',
        rpc: [
            'https://rpc.reya-cronos.gelato.digital',
            'wss://ws.reya-cronos.gelato.digital'
        ],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/reya-cronos',
        faucets: [],
        shortName: 'reya-cronos',
        chainId: 89346162,
        networkId: 89346162,
        slip44: 60,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://reya-cronos.blockscout.com',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge.gelato.network/bridge/reya-cronos' }]
        }
    },
    94204209: {
        name: 'Polygon Blackberry',
        title: 'Polygon Blackberry Testnet',
        chain: 'ETH',
        rpc: [
            'https://rpc.polygon-blackberry.gelato.digital',
            'wss://ws.polygon-blackberry.gelato.digital'
        ],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/polygon-blackberry',
        shortName: 'polygon-blackberry',
        chainId: 94204209,
        networkId: 94204209,
        slip44: 60,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://polygon-blackberry.gelatoscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [
                {
                    url: 'https://bridge.gelato.network/bridge/polygon-blackberry'
                }
            ]
        },
        status: 'active'
    },
    96969696: {
        name: ' Privix Chain Testnet',
        chain: 'PRIVIX',
        rpc: [
            'https://testnet-rpc.privixchain.xyz/',
            'wss://testnet-rpc.privixchain.xyz/ws'
        ],
        faucets: ['https://faucet.privixchain.xyz'],
        nativeCurrency: { name: 'Privix Coin', symbol: 'PRIVIX', decimals: 18 },
        infoURL: 'https://privix.co/',
        shortName: 'tpsc',
        chainId: 96969696,
        networkId: 96969696,
        icon: 'privix',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet.privixscan.io',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreigodpsoidrdcnck4gemprf6zh6qptx72t2iit3hq7rhtk5qbr6vri'
    },
    97912060: {
        name: 'ChadChain',
        chain: 'CHAD',
        status: 'incubating',
        rpc: ['https://rpc.chadchain.org'],
        faucets: [],
        nativeCurrency: { name: 'ChadChain', symbol: 'CHAD', decimals: 18 },
        infoURL: 'https://chadchain.org',
        shortName: 'chad',
        chainId: 97912060,
        networkId: 97912060,
        explorers: []
    },
    99415706: {
        name: 'Joys Digital TestNet',
        chain: 'TOYS',
        rpc: ['https://toys.joys.cash/'],
        faucets: ['https://faucet.joys.digital/'],
        nativeCurrency: { name: 'TOYS', symbol: 'TOYS', decimals: 18 },
        infoURL: 'https://joys.digital',
        shortName: 'TOYS',
        chainId: 99415706,
        networkId: 99415706,
        slip44: 1
    },
    100000000: {
        name: 'Ethos',
        chain: 'ETHOS',
        rpc: ['https://rpc.ethos.cool'],
        faucets: ['https://faucet.ethos.cool'],
        nativeCurrency: { name: 'ETHOS', symbol: 'ETHOS', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://ethos.cool',
        shortName: 'ETHOS',
        chainId: 100000000,
        networkId: 100000000,
        icon: 'ethos',
        explorers: [
            {
                name: 'ethos scan',
                url: 'https://scan.ethos.cool',
                icon: 'ethos',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTHkNAvYzYnHoKm5ht7RKXqChFeBndptunhMDfcCict2J'
    },
    108160679: {
        name: 'Oraichain Mainnet',
        title: 'Oraichain Mainnet',
        chain: 'Oraichain',
        rpc: ['https://evm.orai.io'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Oraichain Token', symbol: 'ORAI', decimals: 18 },
        infoURL: 'https://orai.io',
        shortName: 'Oraichain',
        chainId: 108160679,
        networkId: 108160679
    },
    111557560: {
        name: 'Cyber Testnet',
        chain: 'Cyber',
        rpc: [
            'https://cyber-testnet.alt.technology/',
            'wss://cyber-testnet.alt.technology/ws',
            'https://rpc.testnet.cyber.co/',
            'wss://rpc.testnet.cyber.co/'
        ],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        icon: 'cyber',
        infoURL: 'https://cyber.co/',
        shortName: 'cysep',
        chainId: 111557560,
        networkId: 111557560,
        explorers: [
            {
                name: 'Cyber Testnet Explorer',
                url: 'https://testnet.cyberscan.co',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://cyber-testnet.testnets.rollbridge.app/' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmR8NuaSqALStb95YsMsJRG2BoYkibjS1XE1pZFtvEkAXY'
    },
    123420111: {
        name: 'OP Celestia Raspberry',
        title: 'OP Celestia Raspberry Testnet',
        chain: 'ETH',
        rpc: [
            'https://rpc.opcelestia-raspberry.gelato.digital',
            'wss://ws.opcelestia-raspberry.gelato.digital'
        ],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/opcelestia-raspberry',
        shortName: 'opcelestia-raspberry',
        chainId: 123420111,
        networkId: 123420111,
        slip44: 60,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://opcelestia-raspberry.gelatoscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [
                {
                    url: 'https://bridge.gelato.network/bridge/opcelestia-raspberry'
                }
            ]
        },
        status: 'active'
    },
    161221135: {
        name: 'Plume Testnet (Legacy)',
        title: 'Plume Sepolia L2 Rollup Testnet (Legacy)',
        chain: 'PLUME Testnet Legacy',
        rpc: [],
        faucets: [],
        nativeCurrency: {
            name: 'Plume Sepolia Ether',
            symbol: 'ETH',
            decimals: 18
        },
        infoURL: 'https://plumenetwork.xyz/',
        shortName: 'plume-testnet-legacy',
        chainId: 161221135,
        networkId: 161221135,
        slip44: 1,
        icon: 'plume',
        status: 'deprecated',
        explorers: [],
        parent: { type: 'L2', chain: 'eip155-11155111' },
        iconURL: 'https://ipfs.io/ipfs/QmT7dJKK2VXMtF9mJ6EfMTJXBntJyVvZcA8beLA2RCFbsW'
    },
    168587773: {
        name: 'Blast Sepolia Testnet',
        chain: 'ETH',
        rpc: [
            'https://sepolia.blast.io',
            'https://blast-sepolia.drpc.org',
            'wss://blast-sepolia.drpc.org'
        ],
        faucets: ['https://faucet.quicknode.com/blast/sepolia'],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://blast.io/',
        shortName: 'blastsepolia',
        chainId: 168587773,
        networkId: 168587773,
        icon: 'blast',
        explorers: [
            {
                name: 'Blast Sepolia Explorer',
                url: 'https://testnet.blastscan.io',
                icon: 'blast',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111' },
        iconURL: 'https://ipfs.io/ipfs/bafybeifc2h3x7jgy4x4nmg2m54ghbvmkfu6oweujambwefzqzew5vujhsi'
    },
    192837465: {
        name: 'Gather Mainnet Network',
        chain: 'GTH',
        rpc: ['https://mainnet.gather.network'],
        faucets: [],
        nativeCurrency: { name: 'Gather', symbol: 'GTH', decimals: 18 },
        infoURL: 'https://gather.network',
        shortName: 'GTH',
        chainId: 192837465,
        networkId: 192837465,
        icon: 'gather',
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://explorer.gather.network',
                icon: 'gather',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTYR8CeFiNbJ1zJHnE3DK2wEN18r2y2vqSKUcLweUT2Gz'
    },
    222000222: {
        name: 'Kanazawa',
        title: 'Meld Testnet Kanazawa',
        chain: 'Kanazawa',
        rpc: ['https://testnet-rpc.meld.com'],
        faucets: [],
        features: [],
        nativeCurrency: { name: 'gMeld', symbol: 'gMELD', decimals: 18 },
        icon: 'meld',
        infoURL: 'https://meld.com',
        shortName: 'kanazawa',
        chainId: 222000222,
        networkId: 222000222,
        slip44: 1,
        explorers: [
            {
                name: 'explorer',
                url: 'https://testnet.meldscan.io',
                icon: 'meld',
                standard: 'EIP3091'
            },
            {
                name: 'explorer',
                url: 'https://subnets-test.avax.network/meld',
                icon: 'meld',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRhB4AbjDrhvwfSAQi2JvKirFiDWxzJvKEvG8S8AdDdED'
    },
    241320161: {
        name: 'XMTP Sepolia',
        chain: 'ETH',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'USDC', symbol: 'USDC', decimals: 18 },
        infoURL: 'https://xmtp.org',
        shortName: 'xmtp-sepolia',
        chainId: 241320161,
        networkId: 241320161,
        status: 'incubating'
    },
    245022926: {
        name: 'Neon EVM Devnet',
        chain: 'Solana',
        rpc: [
            'https://devnet.neonevm.org',
            'https://neon-evm-devnet.drpc.org',
            'wss://neon-evm-devnet.drpc.org'
        ],
        faucets: ['https://neonfaucet.org'],
        icon: 'neon',
        nativeCurrency: { name: 'Neon', symbol: 'NEON', decimals: 18 },
        infoURL: 'https://neon-labs.org',
        shortName: 'neonevm-devnet',
        chainId: 245022926,
        networkId: 245022926,
        explorers: [
            {
                name: 'neonscan',
                url: 'https://devnet.neonscan.org',
                standard: 'EIP3091'
            },
            {
                name: 'blockscout',
                url: 'https://neon-devnet.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmcxevb3v8PEvnvfYgcG3bCBuPhe5YAdsHeaufDChSSR3Q'
    },
    245022929: {
        name: 'Neon EVM Devnet Rollup',
        chain: 'Solana',
        rpc: ['https://devnet.rollup.neonevm.org/'],
        faucets: [],
        icon: 'neon',
        nativeCurrency: { name: 'Neon', symbol: 'NEON', decimals: 18 },
        infoURL: 'https://neonevm.org/',
        shortName: 'neonevm-devnet-rollup',
        chainId: 245022929,
        networkId: 245022929,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/Qmcxevb3v8PEvnvfYgcG3bCBuPhe5YAdsHeaufDChSSR3Q'
    },
    245022934: {
        name: 'Neon EVM Mainnet',
        chain: 'Solana',
        rpc: [
            'https://neon-proxy-mainnet.solana.p2p.org',
            'https://neon-evm.drpc.org',
            'wss://neon-evm.drpc.org'
        ],
        faucets: [],
        icon: 'neon',
        nativeCurrency: { name: 'Neon', symbol: 'NEON', decimals: 18 },
        infoURL: 'https://neonevm.org',
        shortName: 'neonevm-mainnet',
        chainId: 245022934,
        networkId: 245022934,
        explorers: [
            {
                name: 'neonscan',
                url: 'https://neonscan.org',
                standard: 'EIP3091'
            },
            {
                name: 'native',
                url: 'https://neon.blockscout.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmcxevb3v8PEvnvfYgcG3bCBuPhe5YAdsHeaufDChSSR3Q'
    },
    245022940: {
        name: 'Neon EVM TestNet',
        status: 'deprecated',
        chain: 'Solana',
        rpc: ['https://testnet.neonevm.org'],
        faucets: [],
        icon: 'neon',
        nativeCurrency: { name: 'Neon', symbol: 'NEON', decimals: 18 },
        infoURL: 'https://neon-labs.org',
        shortName: 'neonevm-testnet',
        chainId: 245022940,
        networkId: 245022940,
        slip44: 1,
        explorers: [
            {
                name: 'native',
                url: 'https://testnet.explorer.neon-labs.org',
                standard: 'EIP3091'
            },
            {
                name: 'neonscan',
                url: 'https://testnet.neonscan.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmcxevb3v8PEvnvfYgcG3bCBuPhe5YAdsHeaufDChSSR3Q'
    },
    253368190: {
        name: 'Flame',
        chain: 'Flame',
        rpc: ['https://rpc.flame.astria.org'],
        faucets: [],
        nativeCurrency: { name: 'TIA', symbol: 'TIA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://astria.org',
        shortName: 'flame',
        chainId: 253368190,
        networkId: 253368190,
        icon: 'flame',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.flame.astria.org',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmf6P4yzrcavKhrxmQaqErLxa4TBnUVUMX4wyVRNhJMDuw'
    },
    278611351: {
        name: 'Razor Skale Chain',
        chain: 'Razor Schain',
        icon: 'razornetwork',
        rpc: ['https://mainnet.skalenodes.com/v1/turbulent-unique-scheat'],
        faucets: ['https://faucet.razorscan.io/'],
        nativeCurrency: { name: 'sFuel', symbol: 'SFUEL', decimals: 18 },
        infoURL: 'https://razor.network',
        shortName: 'razor',
        chainId: 278611351,
        networkId: 278611351,
        explorers: [
            {
                name: 'turbulent-unique-scheat',
                url: 'https://turbulent-unique-scheat.explorer.mainnet.skalenodes.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUdwAZJfyKGZnfPGDsCnNvGu123mdd57kTGj1Y3EWVuWK'
    },
    311752642: {
        name: 'OneLedger Mainnet',
        chain: 'OLT',
        icon: 'oneledger',
        rpc: ['https://mainnet-rpc.oneledger.network'],
        faucets: [],
        nativeCurrency: { name: 'OLT', symbol: 'OLT', decimals: 18 },
        infoURL: 'https://oneledger.io',
        shortName: 'oneledger',
        chainId: 311752642,
        networkId: 311752642,
        explorers: [
            {
                name: 'OneLedger Block Explorer',
                url: 'https://mainnet-explorer.oneledger.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRhqq4Gp8G9w27ND3LeFW49o5PxcxrbJsqHbpBFtzEMfC'
    },
    328527624: {
        name: 'Nal Sepolia Testnet',
        chain: 'ETH',
        rpc: ['https://testnet-rpc.nal.network'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        icon: 'nal',
        infoURL: 'https://www.nal.network',
        shortName: 'nalsep',
        chainId: 328527624,
        networkId: 328527624,
        explorers: [
            {
                name: 'Nal Sepolia Testnet Network Explorer',
                url: 'https://testnet-scan.nal.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZLZHX18YUswejxo1JFNPx5EwMsVhUwBeBWEcd1JUHAK5'
    },
    333000333: {
        name: 'Meld',
        title: 'Meld Mainnet',
        chain: 'MELD',
        rpc: ['https://rpc-1.meld.com'],
        faucets: [],
        features: [],
        nativeCurrency: { name: 'gMeld', symbol: 'gMELD', decimals: 18 },
        icon: 'meld',
        infoURL: 'https://meld.com',
        shortName: 'meld',
        chainId: 333000333,
        networkId: 333000333,
        explorers: [
            {
                name: 'explorer',
                url: 'https://meldscan.io',
                icon: 'meld',
                standard: 'EIP3091'
            },
            {
                name: 'explorer',
                url: 'https://subnets.avax.network/meld',
                icon: 'meld',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRhB4AbjDrhvwfSAQi2JvKirFiDWxzJvKEvG8S8AdDdED'
    },
    344106930: {
        name: 'Deprecated SKALE Calypso Hub Testnet',
        title: 'Deprecated Calypso NFT Hub Testnet',
        status: 'deprecated',
        chain: 'staging-utter-unripe-menkar',
        icon: 'calypso',
        rpc: ['https://staging-v3.skalenodes.com/v1/staging-utter-unripe-menkar'],
        faucets: ['https://sfuel.dirtroad.dev/staging'],
        nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
        infoURL: 'https://calypsohub.network/',
        shortName: 'deprected-calypso-testnet',
        chainId: 344106930,
        networkId: 344106930,
        slip44: 1,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://staging-utter-unripe-menkar.explorer.staging-v3.skalenodes.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeigyayzxvt7vosat4rtrbmhhnldgx57w2pfbutuniax7h6kswzi42m'
    },
    356256156: {
        name: 'Gather Testnet Network',
        chain: 'GTH',
        rpc: ['https://testnet.gather.network'],
        faucets: [],
        nativeCurrency: { name: 'Gather', symbol: 'GTH', decimals: 18 },
        infoURL: 'https://gather.network',
        shortName: 'tGTH',
        chainId: 356256156,
        networkId: 356256156,
        slip44: 1,
        icon: 'gather',
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://testnet-explorer.gather.network',
                icon: 'gather',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTYR8CeFiNbJ1zJHnE3DK2wEN18r2y2vqSKUcLweUT2Gz'
    },
    420420419: {
        name: 'Asset Hub',
        chain: 'DOT',
        rpc: ['https://asset-hub-eth-rpc.polkadot.io'],
        faucets: [],
        nativeCurrency: { name: 'DOT', symbol: 'DOT', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://polkadot.network',
        shortName: 'AH',
        chainId: 420420419,
        networkId: 420420419,
        explorers: []
    },
    420420421: {
        name: 'Westend Asset Hub',
        chain: 'WST',
        rpc: ['https://westend-asset-hub-eth-rpc.polkadot.io'],
        faucets: ['https://faucet.polkadot.io/westend'],
        nativeCurrency: { name: 'Westies', symbol: 'WND', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://polkadot.network',
        shortName: 'wst',
        chainId: 420420421,
        networkId: 420420421,
        explorers: [
            {
                name: 'subscan',
                icon: 'subscan',
                url: 'https://westend-asset-hub-eth-explorer.parity.io',
                standard: 'EIP3091'
            }
        ]
    },
    476158412: {
        name: 'Deprecated SKALE Europa Hub Testnet',
        title: 'Deprecated Europa Hub Testnet',
        status: 'deprecated',
        chain: 'staging-legal-crazy-castor',
        icon: 'europa',
        rpc: ['https://staging-v3.skalenodes.com/v1/staging-legal-crazy-castor'],
        faucets: ['https://sfuel.dirtroad.dev/staging'],
        nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
        infoURL: 'https://europahub.network/',
        shortName: 'deprecated-europa-testnet',
        chainId: 476158412,
        networkId: 476158412,
        slip44: 1,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://staging-legal-crazy-castor.explorer.staging-v3.skalenodes.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiezcwowhm6xjrkt44cmiu6ml36rhrxx3amcg3cfkcntv2vgcvgbre'
    },
    476462898: {
        name: 'GPT Testnet',
        chain: 'Skopje Testnet',
        icon: 'skopje-gpt',
        rpc: ['https://testnet-rpc.gptprotocol.io'],
        faucets: ['https://testnet-faucet.gptprotocol.io'],
        chainId: 476462898,
        networkId: 476462898,
        nativeCurrency: { name: 'SkpGPT', symbol: 'SkpGPT', decimals: 18 },
        infoURL: 'https://gptprotocol.com',
        shortName: 'Skopje',
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://testnet-bridge.gptprotocol.io' }]
        },
        explorers: [
            {
                name: 'blockscout',
                url: 'https://testnet-explorer.gptprotocol.io',
                standard: 'EIP3091',
                icon: 'blockscout'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmf75UpPd7PA3tV6iPxWXGmHq4azyP3CrBYStdSSjQ2Wrx'
    },
    486217935: {
        name: 'Gather Devnet Network',
        chain: 'GTH',
        rpc: ['https://devnet.gather.network'],
        faucets: [],
        nativeCurrency: { name: 'Gather', symbol: 'GTH', decimals: 18 },
        infoURL: 'https://gather.network',
        shortName: 'dGTH',
        chainId: 486217935,
        networkId: 486217935,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://devnet-explorer.gather.network',
                standard: 'none'
            }
        ]
    },
    503129905: {
        name: 'Deprecated SKALE Nebula Hub Testnet',
        chain: 'staging-faint-slimy-achird',
        status: 'deprecated',
        icon: 'nebula',
        rpc: [
            'https://staging-v3.skalenodes.com/v1/staging-faint-slimy-achird',
            'wss://staging-v3.skalenodes.com/v1/ws/staging-faint-slimy-achird'
        ],
        faucets: ['https://sfuel.dirtroad.dev/staging'],
        nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
        infoURL: 'https://nebulachain.io/',
        shortName: 'deprecated-nebula-testnet',
        chainId: 503129905,
        networkId: 503129905,
        slip44: 1,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://staging-faint-slimy-achird.explorer.staging-v3.skalenodes.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeic5eexvd34wfy4kuebcyu73qpkv3x57s54ebzjyhyjsmeuni5jwcm'
    },
    531050104: {
        name: 'Sophon Testnet',
        chain: 'Sophon Testnet',
        rpc: ['https://rpc.testnet.sophon.xyz', 'wss://rpc.testnet.sophon.xyz/ws'],
        nativeCurrency: { name: 'Sophon', symbol: 'SOPH', decimals: 18 },
        faucets: [],
        infoURL: '',
        shortName: 'sophon-testnet',
        chainId: 531050104,
        networkId: 531050104,
        explorers: [
            {
                name: 'Sophon Block Explorer',
                url: 'https://explorer.testnet.sophon.xyz',
                icon: 'sophon-testnet',
                standard: 'none'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://portal.testnet.sophon.xyz/bridge' }]
        }
    },
    661898459: {
        name: 'Smart Mainnet',
        chain: 'SMART',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Smart', symbol: 'SMART', decimals: 6 },
        infoURL: 'https://smartblockchain.com',
        shortName: 'smart',
        chainId: 661898459,
        networkId: 661898459,
        slip44: 783,
        icon: 'smart',
        explorers: [
            {
                name: 'smartexplorer',
                url: 'https://smartexplorer.com',
                icon: 'smart',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmWXs2ZzdbSTEL4uf5vsa7gRvC7AnVk5TDjaP4W6f9KALg'
    },
    666666666: {
        name: 'Degen Chain',
        title: 'Degen Chain',
        chain: 'Degen',
        rpc: ['https://rpc.degen.tips'],
        faucets: [],
        nativeCurrency: { name: 'DEGEN', symbol: 'DEGEN', decimals: 18 },
        infoURL: 'https://degen.tips',
        shortName: 'degen-chain',
        chainId: 666666666,
        networkId: 666666666,
        status: 'incubating',
        icon: 'degen',
        iconURL: 'https://ipfs.io/ipfs/Qmb6yAe4wXeBkxjfhxzoUT9TzETcmE7Vne59etm9GJaQf7'
    },
    728126428: {
        name: 'Tron Mainnet',
        chain: 'TRON',
        rpc: [
            'https://rpc.ankr.com/tron_jsonrpc',
            'https://api.trongrid.io/jsonrpc'
        ],
        faucets: [],
        nativeCurrency: { name: 'Tron', symbol: 'TRX', decimals: 6 },
        infoURL: 'https://tron.network',
        shortName: 'tron',
        chainId: 728126428,
        networkId: 728126428,
        icon: 'tron',
        slip44: 195,
        explorers: [
            {
                name: 'tronscan',
                url: 'https://tronscan.org',
                icon: 'tron',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZCR3JnesjwLKRXtW8Vm9sJ4geEnXcAfQsARcv2NVpHSU'
    },
    888888888: {
        name: 'Ancient8',
        chain: 'Ancient8',
        icon: 'ancient8',
        rpc: ['https://rpc.ancient8.gg'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://ancient8.gg/',
        shortName: 'ancient8',
        chainId: 888888888,
        networkId: 888888888,
        explorers: [
            {
                name: 'Ancient8 Explorer',
                url: 'https://scan.ancient8.gg',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreievnqg3xjokaty4kfbxxbrzm5v5y7exbaaia2txrh4sfgrqsalfym'
    },
    889910245: {
        name: 'PTCESCAN Testnet',
        title: 'PTCESCAN Testnet',
        chain: 'PTCE',
        rpc: ['https://rpc-testnet.ptcscan.io'],
        faucets: ['https://faucet.ptcscan.io/'],
        nativeCurrency: { name: 'PTCE', symbol: 'PTCE', decimals: 18 },
        infoURL: 'https://ptcscan.io',
        shortName: 'PTCE',
        chainId: 889910245,
        networkId: 889910245,
        explorers: [
            {
                name: 'PTCESCAN Testnet Explorer',
                url: 'https://explorer-testnet.ptcscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    889910246: {
        name: 'PTCESCAN Mainnet',
        title: 'PTCESCAN Mainnet',
        chain: 'PTCE',
        rpc: ['https://rpc.ptcscan.io'],
        faucets: [],
        nativeCurrency: { name: 'PTCE', symbol: 'PTCE', decimals: 18 },
        infoURL: 'https://ptcscan.io',
        shortName: 'POLYTECH',
        chainId: 889910246,
        networkId: 889910246,
        explorers: [
            {
                name: 'PTCESCAN Explorer',
                url: 'https://ptcscan.io',
                standard: 'EIP3091'
            }
        ]
    },
    974399131: {
        name: 'SKALE Calypso Hub Testnet',
        title: 'SKALE Calypso Hub Testnet',
        chain: 'giant-half-dual-testnet',
        icon: 'calypso',
        rpc: ['https://testnet.skalenodes.com/v1/giant-half-dual-testnet'],
        faucets: ['https://www.sfuelstation.com/'],
        nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
        infoURL: 'https://calypsohub.network/',
        shortName: 'calypso-testnet',
        chainId: 974399131,
        networkId: 974399131,
        slip44: 1,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://giant-half-dual-testnet.explorer.testnet.skalenodes.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeigyayzxvt7vosat4rtrbmhhnldgx57w2pfbutuniax7h6kswzi42m'
    },
    994873017: {
        name: 'Lumia Mainnet',
        shortName: 'lumia-mainnet',
        title: 'Lumia Mainnet',
        chain: 'ETH',
        icon: 'lumia',
        rpc: ['https://mainnet-rpc.lumia.org'],
        faucets: [],
        nativeCurrency: { name: 'Lumia', symbol: 'LUMIA', decimals: 18 },
        infoURL: 'https://lumia.org',
        chainId: 994873017,
        networkId: 994873017,
        explorers: [
            {
                name: 'Lumia Mainnet Explorer',
                url: 'https://explorer.lumia.org',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.lumia.org' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmV3V19LTs7RobiBo4pgwvNGY7AXEXDTVbRPuB8pPvmxi4'
    },
    999999999: {
        name: 'Zora Sepolia Testnet',
        chain: 'ETH',
        rpc: ['https://sepolia.rpc.zora.energy'],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        icon: 'zoraSepoliaTestnet',
        infoURL: 'https://zora.energy',
        shortName: 'zsep',
        chainId: 999999999,
        networkId: 999999999,
        slip44: 1,
        explorers: [
            {
                name: 'Zora Sepolia Testnet Network Explorer',
                url: 'https://sepolia.explorer.zora.energy',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifvrly5tgd34xqeo67s4etmiu52bkroml7uy7eosizf57htf5nrzq'
    },
    1020352220: {
        name: 'SKALE Titan Hub Testnet',
        title: 'SKALE Titan Hub Testnet',
        chain: 'aware-fake-trim-testnet',
        icon: 'titan',
        rpc: [
            'https://testnet.skalenodes.com/v1/aware-fake-trim-testnet',
            'wss://testnet.skalenodes.com/v1/ws/aware-fake-trim-testnet'
        ],
        faucets: ['https://www.sfuelstation.com/'],
        nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
        infoURL: '',
        shortName: 'titan-testnet',
        chainId: 1020352220,
        networkId: 1020352220,
        slip44: 1,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://aware-fake-trim-testnet.explorer.testnet.skalenodes.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiagrt5dhgltg2kmw7hf24kslstr5h42e745luuxwp2wbg24gm6zza'
    },
    1122334455: {
        name: 'IPOS Network',
        chain: 'IPOS',
        rpc: ['https://rpc.iposlab.com', 'https://rpc2.iposlab.com'],
        faucets: [],
        nativeCurrency: {
            name: 'IPOS Network Ether',
            symbol: 'IPOS',
            decimals: 18
        },
        infoURL: 'https://iposlab.com',
        shortName: 'ipos',
        chainId: 1122334455,
        networkId: 1122334455
    },
    1146703430: {
        name: 'CyberdeckNet',
        chain: 'cyberdeck',
        rpc: ['http://cybeth1.cyberdeck.eu:8545'],
        faucets: [],
        nativeCurrency: { name: 'Cyb', symbol: 'CYB', decimals: 18 },
        infoURL: 'https://cyberdeck.eu',
        shortName: 'cyb',
        chainId: 1146703430,
        networkId: 1146703430,
        icon: 'cyberdeck',
        status: 'active',
        explorers: [
            {
                name: 'CybEthExplorer',
                url: 'http://cybeth1.cyberdeck.eu:8000',
                icon: 'cyberdeck',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmTvYMJXeZeWxYPuoQ15mHCS8K5EQzkMMCHQVs3GshooyR'
    },
    1273227453: {
        name: 'HUMAN Protocol',
        title: 'HUMAN Protocol',
        chain: 'wan-red-ain',
        rpc: ['https://mainnet.skalenodes.com/v1/wan-red-ain'],
        faucets: ['https://dashboard.humanprotocol.org/faucet'],
        nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
        infoURL: 'https://www.humanprotocol.org',
        shortName: 'human-mainnet',
        chainId: 1273227453,
        networkId: 1273227453,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://wan-red-ain.explorer.mainnet.skalenodes.com',
                icon: 'human',
                standard: 'EIP3091'
            }
        ]
    },
    1278060416: {
        name: 'OFFICIAL VASYL',
        title: 'OFFICIAL VASYL',
        chain: 'Official-Vasyl',
        rpc: ['https://rpc.official-vasyl.network'],
        faucets: ['https://faucet.official-vasyl.network'],
        nativeCurrency: { name: 'OFFICIAL VASYL', symbol: 'VASYL', decimals: 18 },
        infoURL: 'official-vasyl.network',
        shortName: 'Vasyl',
        chainId: 1278060416,
        networkId: 1278060416,
        icon: 'vasyl',
        explorers: [
            {
                name: 'Official Vasyl Explorer',
                url: 'https://explorer.official-vasyl.network',
                icon: 'vasyl',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge.official-vasyl.network' }]
        },
        features: [{ name: 'EIP155' }],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/bafkreib454hflqzfcvpsmk43mkgwsj3ds36olbf2nidtr4kppfk2ghpu2q'
    },
    1313161554: {
        name: 'Aurora Mainnet',
        chain: 'NEAR',
        rpc: [
            'https://mainnet.aurora.dev',
            'https://aurora.drpc.org',
            'wss://aurora.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://aurora.dev',
        shortName: 'aurora',
        chainId: 1313161554,
        networkId: 1313161554,
        explorers: [
            {
                name: 'Aurora Explorer',
                url: 'https://explorer.aurora.dev',
                standard: 'EIP3091'
            }
        ]
    },
    1313161555: {
        name: 'Aurora Testnet',
        chain: 'NEAR',
        rpc: [
            'https://testnet.aurora.dev/',
            'https://aurora-testnet.drpc.org',
            'wss://aurora-testnet.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://aurora.dev',
        shortName: 'aurora-testnet',
        chainId: 1313161555,
        networkId: 1313161555,
        slip44: 1,
        explorers: [
            {
                name: 'Aurora Explorer',
                url: 'https://explorer.testnet.aurora.dev',
                standard: 'EIP3091'
            }
        ]
    },
    1313161556: {
        name: 'Aurora Betanet',
        chain: 'NEAR',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://aurora.dev',
        shortName: 'aurora-betanet',
        chainId: 1313161556,
        networkId: 1313161556
    },
    1313161560: {
        name: 'PowerGold',
        chain: 'NEAR',
        rpc: ['https://powergold.aurora.dev'],
        icon: 'powergold',
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.powergold.tech',
        shortName: 'powergold',
        chainId: 1313161560,
        networkId: 1313161560,
        explorers: [
            {
                name: 'PowerGold explorer',
                url: 'https://explorer.powergold.aurora.dev',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreib2sabb6vgfoskobp2wdr6if7v6s34f2xwjecfceui6qhjudmu4u4'
    },
    1313161567: {
        name: 'Turbo',
        chain: 'NEAR',
        rpc: ['https://rpc-0x4e45415f.aurora-cloud.dev'],
        icon: 'turbo',
        faucets: [],
        nativeCurrency: { name: 'Turbo', symbol: 'TURBO', decimals: 18 },
        infoURL: 'https://turbotoken.io',
        shortName: 'turbo',
        chainId: 1313161567,
        networkId: 1313161567,
        explorers: [
            {
                name: 'Turbo explorer',
                url: 'https://explorer.turbo.aurora.dev',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmXUP4JFNX2ET2vZHh9p4a6wEVC5os13evrWtF65EUfNkn'
    },
    1313161573: {
        name: 'Tuxappcoin',
        chain: 'NEAR',
        rpc: ['https://rpc-0x4e454165.aurora-cloud.dev'],
        icon: 'tuxa',
        faucets: [],
        nativeCurrency: { name: 'TUXA', symbol: 'TUXA', decimals: 18 },
        infoURL: 'https://x.com/tuxapp_coin',
        shortName: 'tuxa',
        chainId: 1313161573,
        networkId: 1313161573,
        explorers: [
            {
                name: 'TUXA explorer',
                url: 'https://explorer.tuxa.aurora.dev',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmNeWsKujSToh78mFWDqaFjjbqW6trtSTf9zHFXer1GfWT'
    },
    1350216234: {
        name: 'SKALE Titan Hub',
        chain: 'parallel-stormy-spica',
        icon: 'titan',
        rpc: [
            'https://mainnet.skalenodes.com/v1/parallel-stormy-spica',
            'wss://mainnet.skalenodes.com/v1/ws/parallel-stormy-spica'
        ],
        faucets: ['https://sfuel.skale.network/'],
        nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
        infoURL: '',
        shortName: 'titan-mainnet',
        chainId: 1350216234,
        networkId: 1350216234,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://parallel-stormy-spica.explorer.mainnet.skalenodes.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiagrt5dhgltg2kmw7hf24kslstr5h42e745luuxwp2wbg24gm6zza'
    },
    1351057110: {
        name: 'Chaos (SKALE Testnet)',
        title: 'Chaos Testnet',
        chain: 'staging-fast-active-bellatrix',
        rpc: ['https://staging-v3.skalenodes.com/v1/staging-fast-active-bellatrix'],
        faucets: ['https://sfuel.skale.network/staging/chaos'],
        nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
        infoURL: 'https://docs.skale.network/develop/',
        shortName: 'chaos-tenet',
        chainId: 1351057110,
        networkId: 1351057110,
        slip44: 1,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://staging-fast-active-bellatrix.explorer.staging-v3.skalenodes.com',
                icon: 'chaos',
                standard: 'EIP3091'
            }
        ]
    },
    1380012617: {
        name: 'RARI Chain Mainnet',
        chain: 'RARI',
        rpc: ['https://rari.calderachain.xyz/http'],
        faucets: [],
        nativeCurrency: { name: 'Ethereum', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://rarichain.org/',
        shortName: 'rari-mainnet',
        chainId: 1380012617,
        networkId: 1380012617,
        explorers: [
            {
                name: 'rarichain-explorer',
                url: 'https://mainnet.explorer.rarichain.org',
                standard: 'EIP3091'
            }
        ]
    },
    1380996178: {
        name: 'RaptorChain',
        chain: 'RPTR',
        rpc: ['https://rpc.raptorchain.io/web3'],
        faucets: [],
        nativeCurrency: { name: 'Raptor', symbol: 'RPTR', decimals: 18 },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://raptorchain.io',
        shortName: 'rptr',
        chainId: 1380996178,
        networkId: 1380996178,
        icon: 'raptorchain',
        explorers: [
            {
                name: 'RaptorChain Explorer',
                url: 'https://explorer.raptorchain.io',
                icon: 'raptorchain_explorer',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmQuvmiN6vM6Rqzqe1pMzDf8iZXqTtSeqCgGe5k5AyksDU'
    },
    1417429182: {
        name: 'Zephyr Testnet',
        title: 'Zephyr Testnet',
        chain: 'Zephyr-testnet',
        rpc: ['https://zephyr-rpc.eu-north-2.gateway.fm'],
        faucets: ['https://zephyr-faucet.eu-north-2.gateway.fm'],
        nativeCurrency: { name: 'ZERO', symbol: 'Z', decimals: 18 },
        infoURL: 'https://zero.tech',
        shortName: 'zephyr',
        chainId: 1417429182,
        networkId: 1417429182,
        icon: 'zephyr',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://zephyr-blockscout.eu-north-2.gateway.fm',
                icon: 'zephyr',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://zephyr-bridge.eu-north-2.gateway.fm' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafybeiech76mp6ro4lo7pyferpovrnvghwb745upatj5h6be4cnav52zwu'
    },
    1444673419: {
        name: 'SKALE Europa Hub Testnet',
        title: 'SKALE Europa Hub Testnet',
        chain: 'juicy-low-small-testnet',
        icon: 'europa',
        rpc: ['https://testnet.skalenodes.com/v1/juicy-low-small-testnet'],
        faucets: ['https://www.sfuelstation.com/'],
        nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
        infoURL: 'https://europahub.network/',
        shortName: 'europa-testnet',
        chainId: 1444673419,
        networkId: 1444673419,
        slip44: 1,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://juicy-low-small-testnet.explorer.testnet.skalenodes.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiezcwowhm6xjrkt44cmiu6ml36rhrxx3amcg3cfkcntv2vgcvgbre'
    },
    1482601649: {
        name: 'SKALE Nebula Hub',
        chain: 'green-giddy-denebola',
        icon: 'nebula',
        rpc: [
            'https://mainnet.skalenodes.com/v1/green-giddy-denebola',
            'wss://mainnet-proxy.skalenodes.com/v1/ws/green-giddy-denebola'
        ],
        faucets: ['https://sfuel.skale.network/'],
        nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
        infoURL: 'https://nebulachain.io/',
        shortName: 'nebula-mainnet',
        chainId: 1482601649,
        networkId: 1482601649,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://green-giddy-denebola.explorer.mainnet.skalenodes.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeic5eexvd34wfy4kuebcyu73qpkv3x57s54ebzjyhyjsmeuni5jwcm'
    },
    1511670449: {
        name: 'GPT Mainnet',
        chain: 'GPT Protocol',
        icon: 'gpt',
        rpc: ['https://rpc.gptprotocol.io'],
        faucets: [],
        chainId: 1511670449,
        networkId: 1511670449,
        nativeCurrency: { name: 'GPT', symbol: 'GPT', decimals: 18 },
        infoURL: 'https://gptprotocol.com',
        shortName: 'GPT',
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.gptprotocol.io' }]
        },
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.gptprotocol.io',
                standard: 'EIP3091',
                icon: 'blockscout'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmdh4Lzamv34Ae2bhA9M6GLCjXxPAtHC5zdG5ZNidrdenA'
    },
    1517929550: {
        name: 'Deprecated SKALE Titan Hub Testnet',
        chain: 'staging-aware-chief-gianfar',
        status: 'deprecated',
        icon: 'titan',
        rpc: [
            'https://staging-v3.skalenodes.com/v1/staging-aware-chief-gianfar',
            'wss://staging-v3.skalenodes.com/v1/ws/staging-aware-chief-gianfar'
        ],
        faucets: ['https://sfuel.dirtroad.dev/staging'],
        nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
        infoURL: '',
        shortName: 'deprecated-titan-testnet',
        chainId: 1517929550,
        networkId: 1517929550,
        slip44: 1,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://staging-aware-chief-gianfar.explorer.staging-v3.skalenodes.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreiagrt5dhgltg2kmw7hf24kslstr5h42e745luuxwp2wbg24gm6zza'
    },
    1523903251: {
        name: 'Haust Network Testnet',
        title: 'Haust Network Testnet',
        chain: 'haust-network-testnet',
        rpc: ['https://rpc-testnet.haust.app'],
        features: [{ name: 'EIP155' }],
        faucets: ['https://faucet.haust.app'],
        status: 'active',
        nativeCurrency: { name: 'HAUST', symbol: 'HAUST', decimals: 18 },
        infoURL: 'https://haust.network/',
        shortName: 'HaustTestnet',
        chainId: 1523903251,
        networkId: 1523903251,
        icon: 'haust',
        explorers: [
            {
                name: 'Haust Network Testnet Explorer',
                url: 'https://explorer-testnet.haust.app',
                icon: 'haust',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge-testnet.haust.app' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmRAjG8kc6PJr3xFGYhq1pWiiDoERD3Wj8wR7Cu59HoFnm'
    },
    1564830818: {
        name: 'SKALE Calypso Hub',
        chain: 'honorable-steel-rasalhague',
        icon: 'calypso',
        rpc: ['https://mainnet.skalenodes.com/v1/honorable-steel-rasalhague'],
        faucets: ['https://sfuel.dirtroad.dev'],
        nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
        infoURL: 'https://calypsohub.network/',
        shortName: 'calypso-mainnet',
        chainId: 1564830818,
        networkId: 1564830818,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://honorable-steel-rasalhague.explorer.mainnet.skalenodes.com',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafybeigyayzxvt7vosat4rtrbmhhnldgx57w2pfbutuniax7h6kswzi42m'
    },
    1570754601: {
        name: 'Haust Testnet',
        title: 'Haust Testnet',
        chain: 'Haust-testnet',
        rpc: ['https://rpc-test.haust.network'],
        faucets: ['https://haust-testnet-faucet.eu-north-2.gateway.fm'],
        nativeCurrency: { name: 'HAUST', symbol: 'HAUST', decimals: 18 },
        infoURL: 'https://haust.network/',
        shortName: 'hst-test',
        chainId: 1570754601,
        networkId: 1570754601,
        icon: 'haust',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://haust-testnet-blockscout.eu-north-2.gateway.fm',
                icon: 'haust',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://haust-testnet-bridge.eu-north-2.gateway.fm' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmRAjG8kc6PJr3xFGYhq1pWiiDoERD3Wj8wR7Cu59HoFnm'
    },
    1660990954: {
        name: 'Status Network Sepolia',
        title: 'Status Network Sepolia',
        chain: 'ETH',
        rpc: [
            'https://public.sepolia.rpc.status.network',
            'wss://status-sepolia-rpc.eu-north-2.gateway.fm/ws'
        ],
        faucets: ['https://faucet.status.network/'],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://status.network',
        shortName: 'sn-sepolia',
        chainId: 1660990954,
        networkId: 1660990954,
        icon: 'sn',
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge.status.network' }]
        },
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://sepoliascan.status.network',
                standard: 'EIP3091',
                icon: 'sn'
            }
        ],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/bafkreici5icyyijhmonrnkxar2tj5426xcywqjnzcl7ovhk6d43z66pd64'
    },
    1666600000: {
        name: 'Harmony Mainnet Shard 0',
        chain: 'Harmony',
        rpc: [
            'https://api.harmony.one',
            'https://a.api.s0.t.hmny.io',
            'https://api.s0.t.hmny.io',
            'https://rpc.ankr.com/harmony',
            'https://1rpc.io/one',
            'https://harmony-0.drpc.org',
            'wss://harmony-0.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'ONE', symbol: 'ONE', decimals: 18 },
        infoURL: 'https://www.harmony.one/',
        slip44: 1023,
        ens: { registry: '0x4cd2563118e57b19179d8dc033f2b0c5b5d69ff5' },
        shortName: 'hmy-s0',
        chainId: 1666600000,
        networkId: 1666600000,
        explorers: [
            {
                name: 'Harmony Block Explorer',
                url: 'https://explorer.harmony.one',
                standard: 'EIP3091'
            }
        ]
    },
    1666600001: {
        name: 'Harmony Mainnet Shard 1',
        chain: 'Harmony',
        rpc: [
            'https://api.s1.t.hmny.io',
            'https://harmony-1.drpc.org',
            'wss://harmony-1.drpc.org'
        ],
        faucets: [],
        nativeCurrency: { name: 'ONE', symbol: 'ONE', decimals: 18 },
        infoURL: 'https://www.harmony.one/',
        slip44: 1023,
        shortName: 'hmy-s1',
        chainId: 1666600001,
        networkId: 1666600001,
        explorers: [
            {
                name: 'Harmony Block Explorer',
                url: 'https://explorer.harmony.one/blocks/shard/1',
                standard: 'none'
            }
        ]
    },
    1666600002: {
        name: 'Harmony Mainnet Shard 2',
        chain: 'Harmony',
        rpc: ['https://api.s2.t.hmny.io'],
        faucets: [],
        nativeCurrency: { name: 'ONE', symbol: 'ONE', decimals: 18 },
        infoURL: 'https://www.harmony.one/',
        slip44: 1023,
        shortName: 'hmy-s2',
        chainId: 1666600002,
        networkId: 1666600002,
        status: 'deprecated',
        explorers: [
            {
                name: 'Harmony Block Explorer',
                url: 'https://explorer.harmony.one/blocks/shard/2',
                standard: 'none'
            }
        ]
    },
    1666600003: {
        name: 'Harmony Mainnet Shard 3',
        chain: 'Harmony',
        rpc: ['https://api.s3.t.hmny.io'],
        faucets: [],
        nativeCurrency: { name: 'ONE', symbol: 'ONE', decimals: 18 },
        infoURL: 'https://www.harmony.one/',
        slip44: 1023,
        shortName: 'hmy-s3',
        chainId: 1666600003,
        networkId: 1666600003,
        status: 'deprecated',
        explorers: [
            {
                name: 'Harmony Block Explorer',
                url: 'https://explorer.harmony.one/blocks/shard/3',
                standard: 'none'
            }
        ]
    },
    1666700000: {
        name: 'Harmony Testnet Shard 0',
        chain: 'Harmony',
        rpc: ['https://api.s0.b.hmny.io'],
        faucets: ['https://faucet.pops.one'],
        nativeCurrency: { name: 'ONE', symbol: 'ONE', decimals: 18 },
        infoURL: 'https://www.harmony.one/',
        shortName: 'hmy-b-s0',
        chainId: 1666700000,
        networkId: 1666700000,
        explorers: [
            {
                name: 'Harmony Testnet Block Explorer',
                url: 'https://explorer.testnet.harmony.one',
                standard: 'EIP3091'
            }
        ]
    },
    1666700001: {
        name: 'Harmony Testnet Shard 1',
        chain: 'Harmony',
        rpc: ['https://api.s1.b.hmny.io'],
        faucets: ['https://faucet.pops.one'],
        nativeCurrency: { name: 'ONE', symbol: 'ONE', decimals: 18 },
        infoURL: 'https://www.harmony.one/',
        shortName: 'hmy-b-s1',
        chainId: 1666700001,
        networkId: 1666700001,
        explorers: [
            {
                name: 'Harmony Block Explorer',
                url: 'https://explorer.testnet.harmony.one',
                standard: 'none'
            }
        ]
    },
    1666900000: {
        name: 'Harmony Devnet Shard 0',
        chain: 'Harmony',
        rpc: ['https://api.s0.ps.hmny.io'],
        faucets: [],
        nativeCurrency: { name: 'ONE', symbol: 'ONE', decimals: 18 },
        infoURL: 'https://www.harmony.one/',
        shortName: 'hmy-ps-s0',
        chainId: 1666900000,
        networkId: 1666900000,
        explorers: []
    },
    1666900001: {
        name: 'Harmony Devnet Shard 1',
        chain: 'Harmony',
        rpc: ['https://api.s1.ps.hmny.io'],
        faucets: [],
        nativeCurrency: { name: 'ONE', symbol: 'ONE', decimals: 18 },
        infoURL: 'https://www.harmony.one/',
        shortName: 'hmy-ps-s1',
        chainId: 1666900001,
        networkId: 1666900001,
        explorers: []
    },
    1702448187: {
        name: 'WITNESS CHAIN',
        title: 'WITNESS CHAIN',
        chain: 'Witness-Chain',
        rpc: ['https://sequencer.witnesschain.com'],
        nativeCurrency: { name: 'ETHER', symbol: 'ETH', decimals: 18 },
        faucets: [],
        infoURL: 'https://www.witnesschain.com',
        shortName: 'Witness',
        chainId: 1702448187,
        networkId: 1702448187,
        icon: 'witness',
        explorers: [
            {
                name: 'Witness Chain Explorer',
                url: 'https://explorer.witnesschain.com',
                icon: 'witness',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://bridge.witnesschain.com' }]
        },
        features: [{ name: 'EIP155' }],
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/bafkreif7kqdtkwsemjxpfiarn5db3zhe7xtqi2z3hmzls3ehygfk2dsfhe'
    },
    1722641160: {
        name: 'Silicon zkEVM Sepolia Testnet',
        title: 'Silicon zkEVM Sepolia Testnet',
        chain: 'Silicon',
        rpc: [
            'https://rpc-sepolia.silicon.network',
            'https://silicon-testnet.nodeinfra.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://docs.silicon.network',
        shortName: 'silicon-sepolia-testnet',
        chainId: 1722641160,
        networkId: 1722641160,
        icon: 'silicon',
        explorers: [
            {
                name: 'siliconscope-sepolia',
                url: 'https://scope-sepolia.silicon.network',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [{ url: 'https://bridge-sepolia.silicon.network' }]
        },
        status: 'active',
        iconURL: 'https://ipfs.io/ipfs/QmTEnk2fosqbY6HQW5vySrLGbopJfeni9ThZ6R9sVefbnq'
    },
    1802203764: {
        name: 'Kakarot Sepolia (Deprecated)',
        chain: 'ETH',
        icon: 'kakarot',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://kakarot.org',
        shortName: 'kkrt-sepolia',
        chainId: 1802203764,
        networkId: 1802203764,
        explorers: [
            {
                name: 'Kakarot Scan',
                url: 'https://sepolia.kakarotscan.org',
                standard: 'EIP3091'
            },
            {
                name: 'Kakarot Explorer',
                url: 'https://sepolia-explorer.kakarot.org',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111', bridges: [] },
        iconURL: 'https://ipfs.io/ipfs/QmQcB7Q2kqVWhJxXmtN9Ri37rcLH9g6z4UCCYqEzgM3XmW'
    },
    1903648807: {
        name: 'Gemuchain Testnet',
        chain: 'Gemuchain',
        rpc: ['https://gemutest-rpc.gemuchain.io'],
        faucets: ['https://faucet.gemuchain.io/'],
        nativeCurrency: { name: 'Gemuchain', symbol: 'GEMU', decimals: 18 },
        infoURL: 'https://gemuchain.io/',
        shortName: 'Gemuchain',
        chainId: 1903648807,
        networkId: 1903648807,
        explorers: [
            {
                name: 'Gemuchain Explorer (Blockscout)',
                url: 'https://gemutest-explorer.gemuchain.io',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://gemutest-bridge.gemuchain.io/login' }]
        }
    },
    1918988905: {
        name: 'RARI Chain Testnet',
        chain: 'RARI',
        rpc: ['https://testnet.rpc.rarichain.org/http'],
        faucets: [],
        nativeCurrency: { name: 'Ethereum', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://rarichain.org/',
        shortName: 'rari-testnet',
        chainId: 1918988905,
        networkId: 1918988905,
        explorers: [
            {
                name: 'rarichain-testnet-explorer',
                url: 'https://explorer.rarichain.org',
                standard: 'EIP3091'
            }
        ]
    },
    1952959480: {
        name: 'Lumia Testnet',
        shortName: 'lumiatestnet',
        title: 'Lumia Testnet',
        chain: 'ETH',
        icon: 'lumia',
        rpc: ['https://testnet-rpc.lumia.org'],
        faucets: ['https://testnet-faucet.lumia.org'],
        nativeCurrency: { name: 'Lumia', symbol: 'LUMIA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://lumia.org',
        chainId: 1952959480,
        networkId: 1952959480,
        explorers: [
            {
                name: 'Lumia Testnet Explorer',
                url: 'https://testnet-explorer.lumia.org',
                icon: 'lumia',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://testnet-bridge.lumia.org' }]
        },
        iconURL: 'https://ipfs.io/ipfs/QmV3V19LTs7RobiBo4pgwvNGY7AXEXDTVbRPuB8pPvmxi4'
    },
    2021121117: {
        name: 'DataHopper',
        chain: 'HOP',
        rpc: ['https://23.92.21.121:8545'],
        faucets: [],
        nativeCurrency: { name: 'DataHoppers', symbol: 'HOP', decimals: 18 },
        infoURL: 'https://www.DataHopper.com',
        shortName: 'hop',
        chainId: 2021121117,
        networkId: 2021121117
    },
    2046399126: {
        name: 'SKALE Europa Hub',
        chain: 'europa',
        icon: 'europa',
        rpc: [
            'https://mainnet.skalenodes.com/v1/elated-tan-skat',
            'wss://mainnet.skalenodes.com/v1/elated-tan-skat'
        ],
        faucets: [
            'https://ruby.exchange/faucet.html',
            'https://sfuel.mylilius.com/'
        ],
        nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
        infoURL: 'https://europahub.network/',
        shortName: 'europa',
        chainId: 2046399126,
        networkId: 2046399126,
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://elated-tan-skat.explorer.mainnet.skalenodes.com',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-1',
            bridges: [{ url: 'https://ruby.exchange/bridge.html' }]
        },
        iconURL: 'https://ipfs.io/ipfs/bafkreiezcwowhm6xjrkt44cmiu6ml36rhrxx3amcg3cfkcntv2vgcvgbre'
    },
    2478899481: {
        name: 'Accumulate Kermit',
        shortName: 'Kermit',
        title: 'Accumulate Kermit Testnet',
        chain: 'Accumulate',
        chainId: 2478899481,
        networkId: 2478899481,
        infoURL: 'https://accumulate.org',
        slip44: 2147483929,
        rpc: ['https://kermit.accumulatenetwork.io/eth'],
        nativeCurrency: { name: 'ACME', symbol: 'ACME', decimals: 18 },
        faucets: ['https://kermit.explorer.accumulatenetwork.io/faucet'],
        explorers: [
            {
                name: 'accumulate-explorer-kermit',
                url: 'https://kermit.explorer.accumulatenetwork.io',
                standard: 'EIP3091'
            }
        ]
    },
    2494104990: {
        name: 'Tron Shasta',
        chain: 'TRON',
        rpc: ['https://api.shasta.trongrid.io/jsonrpc'],
        faucets: [],
        nativeCurrency: { name: 'Tron', symbol: 'TRX', decimals: 6 },
        infoURL: 'https://tron.network',
        shortName: 'tron-shasta',
        chainId: 2494104990,
        networkId: 2494104990,
        icon: 'tron',
        explorers: [
            {
                name: 'shasta tronscan',
                url: 'https://shasta.tronscan.org',
                icon: 'tron',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZCR3JnesjwLKRXtW8Vm9sJ4geEnXcAfQsARcv2NVpHSU'
    },
    2863311531: {
        name: 'Ancient8 Testnet (deprecated)',
        status: 'deprecated',
        chain: 'Ancient8',
        icon: 'ancient8',
        rpc: ['https://rpc-testnet.ancient8.gg'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://ancient8.gg/',
        shortName: 'a8old',
        chainId: 2863311531,
        networkId: 2863311531,
        slip44: 1,
        explorers: [
            {
                name: 'a8scan-testnet',
                url: 'https://testnet.a8scan.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreievnqg3xjokaty4kfbxxbrzm5v5y7exbaaia2txrh4sfgrqsalfym'
    },
    3125659152: {
        name: 'Pirl',
        chain: 'PIRL',
        rpc: ['https://wallrpc.pirl.io'],
        faucets: [],
        nativeCurrency: { name: 'Pirl Ether', symbol: 'PIRL', decimals: 18 },
        infoURL: 'https://pirl.io',
        shortName: 'pirl',
        chainId: 3125659152,
        networkId: 3125659152,
        slip44: 164
    },
    3416255149: {
        name: 'Ultima Mainnet',
        chain: 'ULTIMA',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Ultima', symbol: 'ULTIMA', decimals: 6 },
        infoURL: 'https://ultima.io',
        shortName: 'ultima',
        chainId: 3416255149,
        networkId: 3416255149,
        slip44: 785,
        icon: 'ultima',
        explorers: [
            {
                name: 'ultimachain',
                url: 'https://ultimachain.info',
                icon: 'ultima',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmUbWVHDrD4TUj6pCwPt9eXJ1GK8nomHMDMq8DJ2KNeV7Y'
    },
    4216137055: {
        name: 'OneLedger Testnet Frankenstein',
        chain: 'OLT',
        icon: 'oneledger',
        rpc: ['https://frankenstein-rpc.oneledger.network'],
        faucets: ['https://frankenstein-faucet.oneledger.network'],
        nativeCurrency: { name: 'OLT', symbol: 'OLT', decimals: 18 },
        infoURL: 'https://oneledger.io',
        shortName: 'frankenstein',
        chainId: 4216137055,
        networkId: 4216137055,
        slip44: 1,
        explorers: [
            {
                name: 'OneLedger Block Explorer',
                url: 'https://frankenstein-explorer.oneledger.network',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmRhqq4Gp8G9w27ND3LeFW49o5PxcxrbJsqHbpBFtzEMfC'
    },
    7078815900: {
        name: 'Mekong',
        chain: 'ETH',
        rpc: ['https://rpc.mekong.ethpandaops.io'],
        faucets: ['https://faucet.mekong.ethpandaops.io'],
        nativeCurrency: { name: 'Testnet ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://mekong.ethpandaops.io',
        shortName: 'mekong',
        chainId: 7078815900,
        networkId: 7078815900,
        icon: 'ethereum',
        status: 'incubating',
        explorers: [
            {
                name: 'Holesky Dora Explorer',
                url: 'https://explorer.mekong.ethpandaops.io',
                icon: 'ethereum',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt'
    },
    7088110746: {
        name: 'pectra-devnet-5',
        chain: 'ETH',
        rpc: ['https://rpc.pectra-devnet-5.ethpandaops.io'],
        faucets: ['https://faucet.pectra-devnet-5.ethpandaops.io'],
        nativeCurrency: { name: 'Testnet ETH', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://pectra-devnet-5.ethpandaops.io',
        shortName: 'pectra5',
        chainId: 7088110746,
        networkId: 7088110746,
        icon: 'ethereum',
        status: 'incubating',
        explorers: [
            {
                name: 'Explorer',
                url: 'https://explorer.pectra-devnet-5.ethpandaops.io',
                icon: 'ethereum',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmdwQDr6vmBtXmK2TmknkEuZNoaDqTasFdZdu3DRw8b2wt'
    },
    8691942025: {
        name: 'ONFA Chain',
        title: 'ONFA Chain',
        chain: 'onfa',
        rpc: [
            'https://rpc.onfa.io',
            'https://rpc.onfachain.com',
            'wss://ws.onfa.io',
            'wss://ws.onfachain.com'
        ],
        faucets: [],
        nativeCurrency: { name: 'Onfa Coin', symbol: 'OFC', decimals: 18 },
        infoURL: 'https://onfa.io',
        shortName: 'onfa',
        chainId: 8691942025,
        networkId: 8691942025,
        icon: 'onfachain',
        explorers: [
            {
                name: 'ONFA Scan',
                url: 'https://onfascan.com',
                icon: 'onfachain',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreifsbv53qf674fmv2yhn7c426yv3dsge37hhhzvtcrrbx56ya762dy'
    },
    11297108099: {
        name: 'Palm Testnet',
        chain: 'Palm',
        icon: 'palm',
        rpc: [
            'https://palm-testnet.infura.io/v3/${INFURA_API_KEY}',
            'https://palm-testnet.public.blastapi.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'PALM', symbol: 'PALM', decimals: 18 },
        infoURL: 'https://palm.network',
        shortName: 'tpalm',
        chainId: 11297108099,
        networkId: 11297108099,
        slip44: 1,
        explorers: [
            {
                name: 'Chainlens',
                url: 'https://testnet.palm.chainlens.com',
                standard: 'EIP3091'
            },
            {
                name: 'Dora',
                url: 'https://www.ondora.xyz/network/palm-testnet',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihifvvbq6xzviygveivayogqiotdtpjvilu27bgqobduqemzeq7o4'
    },
    11297108109: {
        name: 'Palm',
        chain: 'Palm',
        icon: 'palm',
        rpc: [
            'https://palm-mainnet.infura.io/v3/${INFURA_API_KEY}',
            'https://palm-mainnet.public.blastapi.io'
        ],
        faucets: [],
        nativeCurrency: { name: 'PALM', symbol: 'PALM', decimals: 18 },
        infoURL: 'https://palm.network',
        shortName: 'palm',
        chainId: 11297108109,
        networkId: 11297108109,
        explorers: [
            {
                name: 'Chainlens',
                url: 'https://palm.chainlens.com',
                standard: 'EIP3091'
            },
            {
                name: 'Dora',
                url: 'https://www.ondora.xyz/network/palm',
                standard: 'none'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihifvvbq6xzviygveivayogqiotdtpjvilu27bgqobduqemzeq7o4'
    },
    28872323069: {
        name: 'GitSwarm Test Network',
        title: 'GitSwarm Test Network',
        chain: 'ETH',
        icon: 'gitswarm',
        rpc: ['https://testnet.gitswarm.com:2096'],
        faucets: [],
        nativeCurrency: { name: 'GitSwarm Ether', symbol: 'GS-ETH', decimals: 18 },
        infoURL: 'https://gitswarm.com/',
        shortName: 'GS-ETH',
        chainId: 28872323069,
        networkId: 28872323069,
        slip44: 1,
        explorers: [],
        status: 'incubating',
        iconURL: 'https://ipfs.io/ipfs/bafkreihdfuzytq2og65n3d3b2kzfvk6yywvqdlorrt6h76q4baz5phcvju'
    },
    37714555429: {
        name: 'Xai Testnet v2',
        chainId: 37714555429,
        shortName: 'xaitestnet',
        chain: 'XAI Testnet',
        networkId: 37714555429,
        nativeCurrency: { name: 'sXai', symbol: 'sXAI', decimals: 18 },
        rpc: ['https://testnet-v2.xai-chain.net/rpc'],
        faucets: [],
        explorers: [
            {
                name: 'Blockscout',
                url: 'https://testnet-explorer-v2.xai-chain.net',
                standard: 'EIP3091'
            }
        ],
        infoURL: 'https://xai.games'
    },
    44474237230: {
        name: 'Deriw Devnet',
        chainId: 44474237230,
        shortName: 'deriw-dev',
        title: 'Deriw Devnet',
        chain: 'Deriw Devnet',
        networkId: 44474237230,
        icon: 'deriw',
        rpc: ['https://rpc.dev.deriw.com'],
        faucets: [],
        nativeCurrency: { name: 'Deriw', symbol: 'Der', decimals: 18 },
        infoURL: 'https://deriw.com',
        explorers: [
            {
                name: 'Deriw Explorer',
                url: 'https://explorer.dev.deriw.com',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-421614',
            bridges: [{ url: 'https://bridge.arbitrum.io' }]
        },
        iconURL: 'https://ipfs.io/ipfs/Qmf3bGpAoPV6K4JLpmzDW748Toqb9WArGzYP5rMUY5P9ED'
    },
    88153591557: {
        name: 'Arbitrum Blueberry',
        title: 'Arbitrum Blueberry Testnet',
        chain: 'ETH',
        rpc: [
            'https://rpc.arb-blueberry.gelato.digital',
            'wss://ws.arb-blueberry.gelato.digital'
        ],
        faucets: [],
        nativeCurrency: { name: 'GelatoCGT', symbol: 'CGT', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/arb-blueberry',
        shortName: 'arb-blueberry',
        chainId: 88153591557,
        networkId: 88153591557,
        slip44: 60,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://arb-blueberry.gelatoscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-421614',
            bridges: [{ url: 'https://bridge.gelato.network/bridge/arb-blueberry' }]
        },
        status: 'active'
    },
    96737205180: {
        name: 'ALDChain Testnet',
        chain: 'ALD',
        rpc: ['https://testnet-rpc.aldrickb.xyz'],
        faucets: ['https://faucet.aldrickb.xyz'],
        nativeCurrency: { name: 'ALD Token', symbol: 'ALD', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://aldrickb.com/projects',
        shortName: 'ald',
        chainId: 96737205180,
        networkId: 96737205180,
        icon: 'aldrickb',
        explorers: [
            {
                name: 'ALDChain Testnet Explorer',
                url: 'https://testnet-explorer.aldrickb.xyz',
                icon: 'aldrickb',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmcR85gVf9bok2Q6Jan7n335wF5t3KrJJQ2WCbRv8Lwwma'
    },
    107107114116: {
        name: 'Kakarot Sepolia Deprecated',
        chain: 'ETH',
        icon: 'kakarot',
        rpc: [],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://kakarot.org',
        shortName: 'kkrt-sepolia-deprecated',
        chainId: 107107114116,
        networkId: 107107114116,
        explorers: [],
        parent: { type: 'L2', chain: 'eip155-11155111', bridges: [] },
        iconURL: 'https://ipfs.io/ipfs/QmQcB7Q2kqVWhJxXmtN9Ri37rcLH9g6z4UCCYqEzgM3XmW'
    },
    111222333444: {
        name: 'Alphabet Mainnet',
        chain: 'Alphabet Network',
        icon: 'alphabetnetwork',
        rpc: [
            'https://londonpublic.alphabetnetwork.org',
            'wss://londonpublic.alphabetnetwork.org/ws/',
            'https://main-rpc.com',
            'wss://main-rpc.com/ws/'
        ],
        faucets: [],
        nativeCurrency: { name: 'ALT', symbol: 'ALT', decimals: 18 },
        infoURL: 'https://alphabetnetwork.org',
        shortName: 'alphabet',
        chainId: 111222333444,
        networkId: 111222333444,
        explorers: [
            {
                name: 'Alphabet Explorer',
                url: 'https://scan.alphabetnetwork.org',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmfTeudwVJcu7jzySBcpD9H5ZVK66nPJKRnicxend1bxfq'
    },
    111551119090: {
        name: 'Thanos Sepolia',
        chain: 'ETH',
        rpc: [
            'https://rpc.thanos-sepolia.tokamak.network',
            'wss://rpc.thanos-sepolia.tokamak.network'
        ],
        faucets: [],
        nativeCurrency: { name: 'Tokamak Network', symbol: 'TON', decimals: 18 },
        infoURL: 'https://tokamak.network',
        shortName: 'thanos-sepolia',
        chainId: 111551119090,
        networkId: 111551119090,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.thanos-sepolia.tokamak.network',
                standard: 'EIP3091'
            }
        ]
    },
    123420000220: {
        name: 'Fluence Stage',
        chain: 'Fluence Stage (Testnet)',
        rpc: ['https://rpc.stage.fluence.dev', 'wss://ws.stage.fluence.dev'],
        faucets: [],
        nativeCurrency: { name: 'tFLT', symbol: 'tFLT', decimals: 18 },
        infoURL: 'https://fluence.network/',
        shortName: 'fluence-stage',
        chainId: 123420000220,
        networkId: 123420000220,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://blockscout.stage.fluence.dev',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111' }
    },
    123420000558: {
        name: 'PIN',
        title: 'PIN',
        chain: 'PIN',
        rpc: [
            'https://rpc.pin.t.raas.gelato.cloud',
            'wss://ws.pin.t.raas.gelato.cloud'
        ],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/pin',
        faucets: [],
        shortName: 'PIN',
        chainId: 123420000558,
        networkId: 123420000558,
        slip44: 60,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.pin.t.raas.gelato.cloud',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [
                {
                    url: 'https://testnet-bridge.gelato.network/bridge/pin/bridge/pin'
                }
            ]
        }
    },
    123420000586: {
        name: 'sivo-defi-testnet',
        title: 'Sivo Defi Testnet',
        chain: 'sivo-defi-testnet',
        rpc: [
            'https://rpc.sivo-defi-testnet.t.raas.gelato.cloud',
            'wss://ws.sivo-defi-testnet.t.raas.gelato.cloud'
        ],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/sivo-defi-testnet',
        faucets: [],
        shortName: 'sivo-defi-testnet',
        chainId: 123420000586,
        networkId: 123420000586,
        slip44: 60,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://sivo-defi-testnet.cloud.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-11155111',
            bridges: [
                {
                    url: 'https://testnet-bridge.gelato.network/bridge/sivo-defi-testnet'
                }
            ]
        }
    },
    123420000588: {
        name: 'volmex',
        title: 'Volmex',
        chain: 'volmex',
        rpc: [
            'https://rpc.volmex.t.raas.gelato.cloud',
            'wss://ws.volmex.t.raas.gelato.cloud'
        ],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://raas.gelato.network/rollups/details/public/volmex',
        faucets: [],
        shortName: 'volmex',
        chainId: 123420000588,
        networkId: 123420000588,
        slip44: 60,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://volmex.cloud.blockscout.com',
                standard: 'EIP3091'
            }
        ],
        parent: {
            type: 'L2',
            chain: 'eip155-84532',
            bridges: [{ url: 'https://testnet-bridge.gelato.network/bridge/volmex' }]
        }
    },
    123420001114: {
        name: 'Basecamp',
        chain: 'CAMP',
        icon: 'camp',
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        rpc: ['https://rpc.basecamp.t.raas.gelato.cloud'],
        faucets: ['https://www.campnetwork.xyz/faucet_l1'],
        nativeCurrency: { name: 'Camp', symbol: 'CAMP', decimals: 18 },
        infoURL: 'https://docs.campnetwork.xyz/',
        shortName: 'Basecamp',
        chainId: 123420001114,
        networkId: 123420001114,
        slip44: 1,
        explorers: [
            {
                name: 'blockscout',
                url: 'https://basecamp.cloud.blockscout.com',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmZN3AzgetKvuTnZvsPPYTvtcsPa73ScGdTguXGHxc2CpN'
    },
    197710212030: {
        name: 'Ntity Mainnet',
        chain: 'Ntity',
        rpc: ['https://rpc.ntity.io'],
        faucets: [],
        nativeCurrency: { name: 'Ntity', symbol: 'NTT', decimals: 18 },
        infoURL: 'https://ntity.io',
        shortName: 'ntt',
        chainId: 197710212030,
        networkId: 197710212030,
        icon: 'ntity',
        explorers: [
            {
                name: 'Ntity Explorer',
                url: 'https://explorer.ntity.io',
                icon: 'ntity',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreicdp3rj3zxltqurayvc7d7z2fkdg3bq357vfbi4ck4nhuveg6sela'
    },
    197710212031: {
        name: 'Haradev Testnet',
        chain: 'Ntity',
        rpc: ['https://blockchain.haradev.com'],
        faucets: [],
        nativeCurrency: { name: 'Ntity Haradev', symbol: 'NTTH', decimals: 18 },
        infoURL: 'https://ntity.io',
        shortName: 'haradev',
        chainId: 197710212031,
        networkId: 197710212031,
        slip44: 1,
        icon: 'haradev',
        explorers: [
            {
                name: 'Haradev Explorer',
                url: 'https://explorer.haradev.com',
                icon: 'haradev',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/bafkreihcwkjjx7twil7phw75d4rcnjzb3jxxammyocvbn6rsujwk23tgrq'
    },
    202402181627: {
        name: 'GM Network Testnet',
        chain: 'GM Network Testnet',
        rpc: ['https://gmnetwork-testnet.alt.technology/'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://gmnetwork.ai',
        shortName: 'gmnetwork-testnet',
        chainId: 202402181627,
        networkId: 202402181627,
        explorers: [
            {
                name: 'gmnetwork-testnet',
                url: 'https://gmnetwork-testnet-explorer.alt.technology',
                standard: 'EIP3091'
            }
        ]
    },
    383414847825: {
        name: 'Zeniq',
        chain: 'ZENIQ',
        icon: 'zeniq',
        rpc: ['https://api.zeniq.network'],
        features: [{ name: 'EIP155' }],
        faucets: ['https://faucet.nomo.zone/', 'https://faucet.zeniq.net/'],
        nativeCurrency: { name: 'Zeniq', symbol: 'ZENIQ', decimals: 18 },
        infoURL: 'https://www.zeniq.dev/',
        shortName: 'zeniq',
        chainId: 383414847825,
        networkId: 383414847825,
        ens: { registry: '0xa0446c88240bCA2A8E0f68C93aa365d25B198aA4' },
        explorers: [
            {
                name: 'zeniqscan',
                url: 'https://zeniqscan.com',
                icon: 'zeniq',
                standard: 'EIP3091'
            },
            {
                name: 'zeniq-smart-chain-explorer',
                url: 'https://smart.zeniq.net',
                icon: 'zeniq',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmVUVUBuN7ZeSty2PZ2sS41752b4ez4pDGbLjjY8PSrmVu'
    },
    666301171999: {
        name: 'PDC Mainnet',
        chain: 'IPDC',
        rpc: ['https://mainnet.ipdc.io/'],
        faucets: [],
        nativeCurrency: { name: 'PDC', symbol: 'PDC', decimals: 18 },
        infoURL: 'https://ipdc.io',
        shortName: 'ipdc',
        chainId: 666301171999,
        networkId: 666301171999,
        explorers: [
            {
                name: 'ipdcscan',
                url: 'https://scan.ipdc.io',
                standard: 'EIP3091'
            }
        ]
    },
    666301179999: {
        name: 'SmartPay Mobile Money',
        chain: 'Mobile Money',
        rpc: ['https://network.uat.smartmoneyewallet.com/'],
        faucets: [],
        nativeCurrency: {
            name: 'SmartPay Mobile Money',
            symbol: 'SMM',
            decimals: 18
        },
        features: [{ name: 'EIP155' }],
        infoURL: 'https://network.uat.smartmoneyewallet.com/',
        shortName: 'SmartPay',
        chainId: 666301179999,
        networkId: 666301179999,
        icon: 'smartpay',
        iconURL: 'https://ipfs.io/ipfs/bafkreign3xx2pllwlykay6euiq2dv766cgt5zgycgpf4mkirulf7ufo5um'
    },
    6022140761023: {
        name: 'Molereum Network',
        chain: 'ETH',
        rpc: ['https://molereum.jdubedition.com'],
        faucets: [],
        nativeCurrency: { name: 'Molereum Ether', symbol: 'MOLE', decimals: 18 },
        infoURL: 'https://github.com/Jdubedition/molereum',
        shortName: 'mole',
        chainId: 6022140761023,
        networkId: 6022140761023
    },
    16604737732183: {
        name: 'Flame Testnet',
        chain: 'Flame',
        rpc: ['https://rpc.flame.dawn-1.astria.org'],
        faucets: [],
        nativeCurrency: { name: 'TIA', symbol: 'TIA', decimals: 18 },
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        infoURL: 'https://astria.org',
        shortName: 'flame-testnet',
        chainId: 16604737732183,
        networkId: 16604737732183,
        icon: 'flame',
        explorers: [
            {
                name: 'blockscout',
                url: 'https://explorer.flame.dawn-1.astria.org',
                icon: 'blockscout',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/Qmf6P4yzrcavKhrxmQaqErLxa4TBnUVUMX4wyVRNhJMDuw'
    },
    428962654539583: {
        name: 'Yominet',
        chain: 'YOMINET',
        icon: 'yominet',
        rpc: ['https://jsonrpc-yominet-1.anvil.asia-southeast.initia.xyz'],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        shortName: 'yomi',
        infoURL: 'https://www.kamigotchi.io/',
        chainId: 428962654539583,
        networkId: 428962654539583,
        explorers: [],
        iconURL: 'https://ipfs.io/ipfs/QmceqNgqPdKXQqGBs8JGLUNUTeKEi69jmQNjXjTd6zfjHP'
    },
    868455272153094: {
        name: 'Godwoken Testnet (V1)',
        chain: 'GWT',
        rpc: ['https://godwoken-testnet-web3-v1-rpc.ckbapp.dev'],
        faucets: ['https://homura.github.io/light-godwoken'],
        nativeCurrency: { name: 'CKB', symbol: 'CKB', decimals: 8 },
        infoURL: 'https://www.nervos.org',
        shortName: 'gw-testnet-v1-deprecated',
        chainId: 868455272153094,
        networkId: 868455272153094,
        slip44: 1,
        status: 'deprecated',
        explorers: [
            {
                name: 'GWScan Block Explorer',
                url: 'https://v1.aggron.gwscan.com',
                standard: 'none'
            }
        ]
    },
    920637907288165: {
        name: 'Kakarot Starknet Sepolia',
        chain: 'ETH',
        icon: 'kakarot',
        rpc: ['https://sepolia-rpc.kakarot.org'],
        faucets: ['https://sepolia-faucet.kakarot.org/'],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://kakarot.org',
        shortName: 'kkrt-starknet-sepolia',
        chainId: 920637907288165,
        networkId: 920637907288165,
        explorers: [
            {
                name: 'Kakarot Scan',
                url: 'https://sepolia.kakarotscan.org',
                standard: 'EIP3091'
            },
            {
                name: 'Kakarot Explorer',
                url: 'https://sepolia-explorer.kakarot.org',
                standard: 'EIP3091'
            }
        ],
        parent: { type: 'L2', chain: 'eip155-11155111', bridges: [] },
        iconURL: 'https://ipfs.io/ipfs/QmQcB7Q2kqVWhJxXmtN9Ri37rcLH9g6z4UCCYqEzgM3XmW'
    },
    2713017997578000: {
        name: 'DCHAIN Testnet',
        title: 'DCHAIN Testnet',
        chain: 'dchaint',
        icon: 'dchaint',
        rpc: [
            'https://dchaintestnet-2713017997578000-1.jsonrpc.testnet.sagarpc.io'
        ],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.dchain.foundation/',
        shortName: 'dchaint',
        chainId: 2713017997578000,
        networkId: 2713017997578000,
        explorers: [
            {
                name: 'dchaint scan',
                url: 'https://dchaintestnet-2713017997578000-1.testnet.sagaexplorer.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmP2cDWvgMuPgwAAEX9KexowUEjw6q7zCUSsWcb8HdudUH'
    },
    2716446429837000: {
        name: 'DCHAIN',
        title: 'DCHAIN Mainnet',
        chain: 'dchainmainnet',
        icon: 'dchainmainnet',
        rpc: ['https://dchain-2716446429837000-1.jsonrpc.sagarpc.io'],
        features: [{ name: 'EIP155' }, { name: 'EIP1559' }],
        faucets: [],
        nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
        infoURL: 'https://www.dchain.foundation/',
        shortName: 'dchainmainnet',
        chainId: 2716446429837000,
        networkId: 2716446429837000,
        explorers: [
            {
                name: 'dchain scan',
                url: 'https://dchain-2716446429837000-1.sagaexplorer.io',
                standard: 'EIP3091'
            }
        ],
        iconURL: 'https://ipfs.io/ipfs/QmamkxtxT1uFWQGxswmzBRkoTcZuU5biM1QvdsU6SD36K6'
    }
};
